
// ============================================================
// © 2026 港興業株式会社（Minato Kogyo Co., Ltd.） All rights reserved.
// 【警告】コピー禁止：このページのプログラム・デザイン・柄（SVG）・文章・画像は、港興業株式会社の著作物です。
// 港興業株式会社の書面による許可なく、複製・コピー・改変・転載・再配布・ほかのサイトやアプリでの利用をすることを、かたく禁じます。
// ============================================================
// 楽天GOLD — バースブック手帳B5（手帳の線はこのページのプログラムで描く）
//   画面・注文の流れは バースブックルーズリーフ B5 v0.1.66 を写したもの
//   手帳の形は FORMATS に1行足して、描く関数を1つ書くとふえる
//   計画：クロードコード/tkdeko_gold_b5_techou_plan.md
// ============================================================
const APP_VERSION = 'nv0.2.200';   // ★バースブックノート（手帳 v0.2.181 を 下じきに した 1代目）

// ===== どの店で ひらいているか（楽天／Shopify）=====
//   ファイルは1つ。楽天GOLD にも Shopify（本店）にも 同じものを入れて、いる場所で 自分できめる
//   ・*.rakuten.ne.jp → 楽天（オーダーメイドは かくす・楽天のカゴ）
//   ・tkdeko.com／*.myshopify.com → Shopify（オーダーメイドあり・Shopify のカゴ）
//   ・パソコンの中（file:）・localhost → 楽天の見た目。?shop=shopify で Shopify の見た目（ためす用）
//   ・それ以外 → 楽天の見た目（どちらのカゴも 動かない）
//   marker＝Shopify のテーマの部品が入れる しるし（window.TK_SHOP）。カゴを動かすときに つかう
function shopOf(host, protocol, search) {
  host = String(host || '').toLowerCase();
  if (/(^|\.)rakuten\.ne\.jp$/.test(host)) return 'rakuten';
  if (/(^|\.)tkdeko\.com$/.test(host) || /^[a-z0-9-]+\.myshopify\.com$/.test(host)) return 'shopify';
  if (protocol === 'file:' || host === 'localhost' || host === '127.0.0.1' || host === '') {
    return /(^|[?&])shop=shopify(&|$)/.test(String(search || '')) ? 'shopify' : 'rakuten';
  }
  return 'rakuten';
}
// Shopify の 商品（window.TK_PRODUCT＝テーマの部品が バリアントだけ わたす）から、バインダーごとの バリアントを 取りだす
//   ★バリアントの 名前の ことばで 見分ける（中身のみ／紙黒 クラフト／本革黒 レザー／クロッキーマルマン）。商品の 名前を かえたら ここも 直す
//   ★Shopify の 値段は「円×100」の数（¥1,980 → 198000）。100 で わって 円にする
//   ★PDFデータのみ は 廃止（2026-09-18 みなとさん）→ どれにも あてはめない
//   ★「本革黒 レザー」を「紙黒」より 先に しらべる（どちらも「黒」が 入るので、ことばの じゅんばんが 大事）
function shopifyVariants(product) {
  const out = {};
  const list = product && Array.isArray(product.variants) ? product.variants : [];
  const rules = [['maruman', /マルマン/], ['leather', /本革|レザー/], ['bb', /紙黒|クラフト/], ['none', /中身のみ/]];
  for (const v of list) {
    if (!v || !Number.isSafeInteger(v.id) || v.id <= 0 || !Number.isInteger(v.price) || v.price <= 0) continue;
    const name = [v.title, v.option1, v.public_title].filter(s => typeof s === 'string').join(' ');
    if (/PDF/i.test(name)) continue;
    const hit = rules.find(([, re]) => re.test(name));
    if (hit && !out[hit[0]]) out[hit[0]] = { id: v.id, yen: Math.round(v.price / 100), available: v.available !== false };
  }
  return out;
}
/* ★nv0.2.57 トップページに お店の ページを 取りこんで srcdoc の 枠で 動かす（手帳 v0.2.244 と 同じ）。
   その 枠の 中では location が からっぽ なので、住所の 代わりを window.TK_LOC で もらう */
const TK_LOC = (typeof window !== 'undefined' && window.TK_LOC) || (() => {
  let search = location.search;
  /* ★nv0.2.152 トップの 印刷メニューの［購入］から とんで きた とき：デザインの コードを sessionStorage で うけとる
     （名入れの 名前が URL・履歴に のこらない ように。同じ お店の 中だけ・5分より 古いのは 使わない・1回 読んだら けす） */
  try {
    const h = JSON.parse(sessionStorage.getItem('tk_handoff') || 'null');
    if (h && h.k === 'note' && typeof h.d === 'string' && /^[A-Za-z0-9_-]{1,1200}$/.test(h.d) && Date.now() - (+h.t || 0) < 5 * 60 * 1000) {
      sessionStorage.removeItem('tk_handoff');
      const u = new URLSearchParams(search); u.set('d', h.d); search = '?' + u.toString();
      window.__tkGo = { go: 'order' };
    }
  } catch (e) {}
  return { hostname: location.hostname, protocol: location.protocol, search };
})();
const TK_HOME = new URLSearchParams(TK_LOC.search).get('tkhome') === '1';
const SHOP = shopOf(TK_LOC.hostname, TK_LOC.protocol, TK_LOC.search);
const CUSTOM_ON = true;   // ★2026-10-03 みなとさん「まったく同じにして」→ 楽天でも 形を変える・マスの中の 時計を 出す
//   （2026-09-18 は「オーダーメイドは Shopify だけ」でした。楽天の 注文は オーダー／オーダー2 の 欄で 記号を わたせます）
// ★nv0.2.31 みなとさん：楽天GOLD も お店と 同じ 見た目（NIKE風の 手順の 画面）にする。カゴは それぞれの お店の まま
const NIKE_ON = true;
// Shopify の カゴに つかう バリアント（Shopify のときだけ。楽天では 空っぽ＝楽天の うごきは かわらない）
const SHOPIFY_VARIANTS = SHOP === 'shopify' ? shopifyVariants(window.TK_PRODUCT) : {};

// ★v0.2.110 お店の ヘッダー（header-group）の 高さを はかって、手帳を のこりの 高さに する
if (document.documentElement.classList.contains('tk-shop')) {
  const fitShop = () => {
    // お店の ヘッダーには「画面に はりつく（fixed）もの」と「ふつうに ならぶ もの」が ある。
    //   はりつく ぶんだけ 下げてから、手帳が はじまる ところを はかって のこりの 高さに する
    let stick = 0;
    document.querySelectorAll('.shopify-section-group-header-group *').forEach(el => {
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none') return;
      const r = el.getBoundingClientRect();
      if (r.height && r.top < 200) stick = Math.max(stick, r.bottom);   // 上に はりついて いるものだけ
    });
    const st = document.documentElement.style;
    const app = document.querySelector('.app');
    /* ★v0.2.125 みなとさん「スマホで 名入れから 下が 切れる」「上が 大きく あく」
       前は「はりつく ヘッダーの 高さ」を そのまま 下げていた。でも テーマの ほうでも すでに
       ヘッダーの ぶんが あいている ことが あり、2回 あけて（105＋115px）手帳が 低く なっていた。
       → まず 下げを 0 に して「手帳が もともと はじまる 高さ」を はかり、
         はりつく ヘッダーに かくれる ぶんだけ 下げる（かくれて いなければ 0） */
    st.setProperty('--tk-top', '0px');
    // ★v0.2.143 お店の NIKE 風では 窓（#nkWin）が .app の 前に ある → 下げるのは 窓の ほう（v0.2.142 まで 紙の 上が ヘッダーに かくれていた。前は 題名の 文が たまたま すき間を 作っていた）
    const first = document.getElementById('nkWin') || app;
    const natural = first ? Math.round(first.getBoundingClientRect().top + window.scrollY) : 0;
    const top = Math.max(0, Math.round(stick - natural));
    st.setProperty('--tk-top', top + 'px');
    st.setProperty('--tk-hdr', (natural + top) + 'px');
  };
  addEventListener('resize', fitShop);
  addEventListener('load', fitShop);
  [0, 400, 1200, 3000, 6000].forEach(t => setTimeout(fitShop, t));   // ★v0.2.173 帯（subtabs）が おそく 出た ときの ため 6秒まで
}

/* ★v0.2.130 NIKE 風の 画面（お店だけ）
   ・紙を 描く 部分・state・注文コードは さわらない。DOM の 置き場所と CSS だけ
   ・#pop の カード（year/view/custom/color/name/paper/binder）を そのまま 窓の 手順に つかう（openPop が 動く）
   ・なかま＋タイル（.topbar）は 窓の ②③ に 移す。えにっき（#enikkiBox）は 紙の すぐ 下に 移す */
const NK = { on: false, ready: false, step: 0, done: new Set(), country: 0 };
// ★v0.2.149 手順を えらぶと 紙が 移る 説明ページ（INFO_PAGES の id）。色＝やわらかい線（POINT 4）・紙＝紙は 3つ（POINT 5）
const NK_PAGE = { start: 's0', view: 's0', custom: 's0', color: 'ink', name: 'name', enikki: 'enikki', paper: 'paper', binder: 'bb', check: 'changes' };   // ★v0.2.153 はじまり月・表示・形を変える は 手帳の 1まいめ／★v0.2.154 名入れ・えにっき は その POINT の ページへ
function nkInit() {
  if (TK_HOME) return;   // ★nv0.2.57 トップページ（ホーム表示）では いつもの NIKE 画面は 作らない
  if (!NIKE_ON || NK.on) return;   // ★nv0.2.31 楽天も お店と同じ 画面（NIKE風）／★v0.2.155 2回 動かさない（はじめの 1回＋load の ほけん）
  const app = document.querySelector('.app'), main = app && app.querySelector('.main'), stage = app && app.querySelector('.stage');
  const topbar = app && app.querySelector('.topbar'), pop = $('pop');
  if (!app || !main || !stage || !topbar || !pop) return;
  NK.on = true;
  document.body.classList.add('nike');
  // ★nv0.2.31 楽天（お店の ヘッダーが ない ところ）では ページ ぜんたいを 動かせるように する
  if (!document.documentElement.classList.contains('tk-shop')) document.documentElement.classList.add('nk-page');
  //   ★v0.2.133 整理：［国］［カスタマイズ］［印刷］の 段と、上の 段（商品名・共有・印刷）は 作らない（ぜんぶ ☰ メニューの 中）
  //   ★v0.2.142 「サイズは この 商品で 決まっています」の ひとことも 出さない（みなとさん）
  // ★v0.2.135 みなとさん：「えにっきbook の 絵」（LINE で 見る・絵の えらびかた・スタンプ）は 手順 ⑨ えにっきの 中へ
  const eb = $('enikkiBox'), ec = pop.querySelector('.pop-card[data-card="enikki"]'); if (eb && ec) ec.append(eb);
  // ★v0.2.139 みなとさん：赤い「内容確定に進む」（.cartbar）は 手順 12 注文確定の ページへ（メニューからは 外した）
  const cb = document.querySelector('.cartbar'), oc = pop.querySelector('.pop-card[data-card="order"]'); if (cb && oc) oc.append(cb);
  // 窓
  const win = mk('div', 'nk-win'); win.id = 'nkWin';
  const view = mk('div', 'nk-view');
  // 下の 帯：⌄ ／ ← 手順名 n/N → ／ ☰ メニュー
  const bar = mk('div', 'nk-bar');
  // ★v0.2.145 みなとさん：左の ⌄（印刷・共有・おきにいりの 一覧）は 廃止 → ☰ メニューの いちばん下へ
  const prev = mk('button', 'nk-arrow', '←'); prev.type = 'button'; prev.onclick = () => nkGo(NK.step > 0 ? NK.step - 1 : TEXTS.nkSteps.length - 1);   // ★手帳と おなじ（先頭の ← は さいごへ）
  const mid = mk('div', 'nk-mid'); const now = mk('span', ''); now.id = 'nkNow';
  const next = mk('button', 'nk-arrow next', '→'); next.type = 'button'; next.id = 'nkNext';
  next.onclick = () => { NK.done.add(NK.step); if (NK.step < TEXTS.nkSteps.length - 1) nkGo(NK.step + 1); else nkGo(0); };   // ★v0.2.149 12 の つぎは 1 に もどる（みなとさん）
  mid.append(prev, now, next);
  const menu = mk('button', 'nk-menu', '☰ メニュー'); menu.type = 'button'; menu.id = 'nkMenuBtn';
  const list = mk('div', 'nk-list'); list.id = 'nkList';
  menu.onclick = e => { e.stopPropagation(); list.classList.toggle('open'); };
  document.addEventListener('click', () => list.classList.remove('open'));
  // ★2026-10-15 みなとさん「手帳と おなじ。印刷ボタンが ある」：メニューの すぐ 左（メニューは かくす）
  const pbtn = mk('button', 'nk-menu nk-print'); pbtn.innerHTML = picto('print').replace('<svg', '<svg class="nk-print-ico"') + '<span class="nk-print-t">' + tr('印刷') + '</span>'; pbtn.type = 'button'; pbtn.id = 'nkPrintBtn';
  pbtn.onclick = e => { e.stopPropagation(); nkGo('print'); };
  // ★2026-10-15 みなとさん「印刷の 横に［メイン］ボタン」：いまの 状態を トップページに 保存（ログインして いる ときだけ）
  const mbtn = mk('button', 'nk-menu nk-main'); mbtn.innerHTML = picto('pin').replace('<svg', '<svg class="nk-print-ico"') + '<span class="nk-main-t">' + tr(TEXTS.mainBtn) + '</span>'; mbtn.type = 'button'; mbtn.id = 'nkMainBtn';
  mbtn.onclick = e => { e.stopPropagation(); nkSaveMain(mbtn); };
  if (SHOP !== 'shopify') mbtn.hidden = true;   // 楽天には ない（トップページが ない）
  bar.append(mk('span', 'sp'), mid, mk('span', 'sp'), pbtn, mbtn, menu);
  const body = mk('div', 'nk-body'); body.id = 'nkBody';
  // ① 国（新しい カード）
  const cc = mk('div', 'pop-card'); cc.dataset.card = 'country'; cc.hidden = true;
  const cl = mk('div', 'nk-country');
  // ★v0.2.138 まだ えらべない 国は 暗くして 押せなく。★v0.2.159 日本と アメリカが えらべる
  NK.country = COUNTRIES.findIndex(c => c.id === state.country); LANG = langOf(); if (LANG !== 'ja') applyTexts();   // ★v0.2.165 共有アドレス・お店の 言葉
  TEXTS.nkCountries.forEach((n, i) => { const b = mk('button', i === NK.country ? 'on' : '', n); b.type = 'button';
    if (!COUNTRIES[i].ready) { b.disabled = true; b.title = TEXTS.nkCountrySoon; }
    b.onclick = () => { setCountry(i); cl.querySelectorAll('button').forEach((q, k) => q.classList.toggle('on', k === i)); }; cl.append(b); });
  cc.append(cl);
  // ★v0.2.171 みなとさん「サイズは 国の 部分だけに」→ サイズの ボタン（B5・A5・A4）は 手順 ① 国の カードの 中（国の 下）
  const sz = mk('div', 'nk-sizes'); sz.id = 'sizes';
  // ★nv0.2.94 みなとさん「サイズと 国を わけて」→ ② サイズの カード（手帳と おなじ）
  const scd = mk('div', 'pop-card'); scd.dataset.card = 'size'; scd.hidden = true; scd.append(sz);
  pop.append(cc, scd);
  body.append(pop);                      // #pop ごと 窓へ（カードは openPop が 出し分ける）
  pop.querySelector('.pop-card[data-card="year"]').before(topbar);   // なかま＋タイルは 窓へ（②③で 見せる）
  win.append(view, bar, body, list);   // 上：紙／帯／えらぶ 欄／☰ メニュー（v0.2.132 から 上の 段は なし）
  // ★v0.2.131 窓は ページの いちばん上（.app の 前）。紙は 窓の 中に 置きっぱなし
  app.before(win);
  view.append(stage);
  buildSizes();   // ★v0.2.170 サイズの ボタン（窓が できてから）
  nkGo(TEXTS.nkSteps.findIndex(st => st[0] === 'sheet'));   // はじめから 柄を えらぶ（① 国・② サイズは そのまま。メニューか ← で もどれる）
  NK.ready = true;
}
/* ★2026-10-15 みなとさん「印刷の 横に［メイン］ボタン。ログインして いれば いまの 状態を トップの ノート に 保存。次回から その 状態で ひらく」 */
async function nkSaveMain(btn) {
  const lbl = btn.querySelector('.nk-main-t') || btn, orig = tr(TEXTS.mainBtn);
  const back = () => setTimeout(() => { lbl.textContent = orig; }, 3000);
  if (!SHOP_LOGGED_IN || typeof window.TK_KARTE !== 'string') {
    lbl.textContent = TEXTS.mainLogin; back();
    try { const u = new URL(shareUrl()); setTimeout(() => { location.href = '/account/login?return_to=' + encodeURIComponent(u.pathname + u.search); }, 600); } catch (e) {}
    return;
  }
  btn.disabled = true; lbl.textContent = TEXTS.mainSaving;
  try {
    const n = state.notes[state.idx];
    const name = ((n ? n.fmt.name : '') + ' ノート').trim().slice(0, 40);
    const r = await fetch(window.TK_KARTE + '/save_top_page', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind: 'note', d: shareCode(), name, thumb: designThumbSvg() }) });
    const j = await r.json().catch(() => null);
    lbl.textContent = j && j.ok ? TEXTS.mainDone : TEXTS.mainErr;
    if (j && j.ok) { try { localStorage.setItem('tk_home_kind', 'note'); localStorage.removeItem('tk_print_sel'); } catch (e) {} }   // ★ 印刷に登録 → トップは この 種類（手帳／ノート）で ひらく
    if (j && j.ok && j.limited && j.message) alert(j.message);   // ★プラス：保存の かずが いっぱい（トップには なる）
  } catch (e) { lbl.textContent = TEXTS.mainErr; }
  btn.disabled = false; back();
}
// ★nv0.2.173 三人の佐藤さん案：15の 手順を 3つの 章（えらぶ／かざる／うけとる）に。手順名の 前の 小さな 札。日本語いがいで 訳が ない ときは 出さない
const NK_CHAPTER = { country: 'えらぶ', size: 'えらぶ', year: 'えらぶ', sheet: 'えらぶ', start: 'えらぶ', view: 'えらぶ', custom: 'えらぶ', color: 'かざる', name: 'かざる', enikki: 'かざる', stars: 'かざる', todo: 'かざる', paper: 'うけとる', binder: 'うけとる', option: 'うけとる', check: 'うけとる', order: 'うけとる', print: 'うけとる' };
function nkChapterCss() { if (document.getElementById('nkChCss')) return; const st = document.createElement('style'); st.id = 'nkChCss'; st.textContent = '.nk-win .nk-mid .nk-ch{font-size:10.5px;color:#707072;border:1px solid #d8d8d8;border-radius:999px;padding:1px 7px;margin-right:2px;white-space:nowrap;line-height:1.5;font-weight:400}.nk-win .nk-mid .nk-ch.c3{color:#185fa5;border-color:#b5d4f4;background:#e6f1fb}@media (max-width:360px){.nk-win .nk-mid .nk-ch{display:none}}.nk-mile{font-size:12px;color:#1a1a1a;background:#f3f4f6;border-radius:8px;padding:6px 10px;margin:0 0 8px;line-height:1.5}body.nike .pop-card[data-card="paper"] > .nk-mile{display:block!important}'; document.head.appendChild(st); }
function nkChapter(key) { const ja = NK_CHAPTER[key]; if (!ja) return ''; const t = tr(ja); if (LANG !== 'ja' && t === ja) return ''; nkChapterCss(); return t; }
// ★nv0.2.173 かざる まで おわった しるし：紙の 種類の 手順の いちばん上に 1行（買わない 人は 印刷へ）
function nkMile(key) { try { const pc = document.querySelector('#pop .pop-card[data-card="paper"]'); if (!pc) return; let m = pc.querySelector('.nk-mile'); if (key !== 'paper') { if (m) m.hidden = true; return; } if (!m) { nkChapterCss(); m = mk('div', 'nk-mile', tr('ここまでで できあがり。買う ときは → へ、刷るだけなら 印刷へ')); pc.prepend(m); } m.hidden = false; } catch (e) {} }
// 狭い 画面（スマホ）で 長い 名前の サイズは みじかく（くわしい 名前は 長押しの title）
const NK_SIZE_SHORT = { dk: 'デスクF', hp: 'HP', hm: 'HPミニ', dj: 'ディスクJr', fp: 'Franklin', fm: 'Filofax', hl: 'ハーフ', tr: 'トラベラ' };
// ★みなとさん「2段に ならないように・帯の 高さに 収めて」：1行のまま、長い 名前は 字を 小さく（はばの 上限に 合わせる）。それでも 小さすぎる（8px 未満）ときは 短い 名前（HP など）
function nkSizeFit(id, nm) {
  // 字の 大きさは そろえる（--nkfs）。はばに 入らない ときだけ 短い 名前（スマホ 5.4字・広い 画面 12.6字まで）
  const narrow = window.matchMedia('(max-width:480px)').matches, cap = narrow ? 5.4 : 12.6;
  const units = t => [...t].reduce((n, c) => n + (c.charCodeAt(0) < 256 ? 0.55 : 1), 0);
  let txt = nm;
  if (units(txt) > cap && NK_SIZE_SHORT[id]) txt = tr(NK_SIZE_SHORT[id]);
  return { txt };
}
// ★みなとさん 2026-11-03「選ぶの 文字は 廃止。その 部分に サイズを 入れて」：えらぶ の 章の 札は サイズに
function nkSizeBadge() { const nm = tr(PSEL.name), f = nkSizeFit(PSEL.id, nm); nkChapterCss(); const b = mk('span', 'nk-ch nk-sz', f.txt); b.title = nm; return b; }
function nkStrip() {
  // まん中：手順名 n/N（印刷の ときは「印刷」だけ）
  const mb = $('nkMenuBtn'); if (mb) mb.textContent = tr('☰ メニュー');   // ★v0.2.165 言葉は TEXTS（Proxy）と tr() で そろえる
  const pb = $('nkPrintBtn'); if (pb) { const tt = pb.querySelector('.nk-print-t'); if (tt) tt.textContent = tr('印刷'); }
  const n = $('nkNow'); if (n) { const k0 = TEXTS.nkSteps[NK.step][0], ch = nkChapter(k0), kids = []; if (NK_CHAPTER[k0] === 'えらぶ') kids.push(nkSizeBadge()); else if (ch) kids.push(mk('span', 'nk-ch' + (NK_CHAPTER[k0] === 'うけとる' ? ' c3' : ''), ch)); kids.push(mk('b', '', TEXTS.nkSteps[NK.step][1]), mk('small', '', (NK.step + 1) + '/' + TEXTS.nkSteps.length)); n.replaceChildren(...kids); }   // ★nv0.2.173 章の 札   // ★印刷も 13番めの 手順（手帳と おなじ）
  document.querySelectorAll('.nk-win .nk-arrow').forEach(a => { a.style.visibility = ''; });   // ★印刷でも ← → で もどれる（手帳と おなじ）
  // ☰ メニュー：10の 手順の 一覧
  const list = $('nkList');
  if (list) {
    // ★v0.2.133 みなとさん：右上に 閉じる（✕）
    const head = mk('div', 'nk-head'); const x = mk('button', 'nk-x', '✕'); x.type = 'button'; x.setAttribute('aria-label', 'とじる');
    x.onclick = e => { e.stopPropagation(); list.classList.remove('open'); };
    head.append(mk('b', '', TEXTS.nkMenuTitle), x);
    list.replaceChildren(head, ...TEXTS.nkSteps.map(([key, label], i) => {
      const b = mk('button', (i === NK.step ? 'on' : '') + (NK.done.has(i) ? ' done' : ''));
      b.type = 'button'; b.append(mk('span', '', (i + 1) + ' ' + label), mk('small', '', nkValue(key)));
      b.onclick = e => { e.stopPropagation(); list.classList.remove('open'); nkGo(i); };
      return b;
    }));
    // ★v0.2.145 いちばん下：印刷・共有・おきにいりに 入れる（おきにいりは 結果を 見せるので メニューは とじない）
    const tb = (label, fn, close = true) => { const b = mk('button', 'jump', label); b.type = 'button'; b.onclick = e => { e.stopPropagation(); if (close) list.classList.remove('open'); fn(b); }; return b; };
    const favNote = mk('div', 'nk-cap');   // favSaveOrder は ボタンの つぎの 要素に 結果を 書く
    list.append(mk('div', 'nk-hr'), tb(TEXTS.nkPrint, () => nkGo('print')), tb(TEXTS.nkShare, nkShare), tb(TEXTS.favSave, b => favSaveOrder(b), false), favNote);
  }
}
// ★v0.2.133 手順「えにっき」：いれる（新しい絵）／いれない。こまかい えらびかたは 紙の 下の #enikkiBox の まま
function syncNkEnikki() {
  const sg = $('nkEnikkiSeg'); if (!sg) return;
  seg(sg, TEXTS.nkEnikkiModes, state.enikki.mode > 0 ? 0 : 1, i => {
    state.enikki.mode = i === 0 ? 1 : 0; state.enikki.pick = {};
    syncNkEnikki(); syncEnikki(); enikkiRepaint(); nkStrip();
  });
  try { syncEnikkiPix(); } catch (e) {}
}
// ★v0.2.159 国を かえる（お店）：紙の 言葉・祝日が かわる。アメリカ＝日曜はじまり（v0.2.161 から こよみ・ぎょうじは 英語で そのまま つかえる）
function setCountry(i) {
  const c = COUNTRIES[i]; if (!c || !c.ready) return;
  NK.country = i;
  changePlanner(() => {
    state.country = c.id;
    LANG = langOf();           // 画面の 言葉
    state.weekStart = c.ws;    // 週の はじまり（アメリカ・韓国＝日曜）
  });
  /* ★nv0.2.14 みなとさん「ここが ピクトグラムの 図が 全て 消えて いる」（2026-10-03）
     ------------------------------------------------------------
     ★わたしの つなぎまちがいでした。形を変える の パネルを 中身で うめるのは
       **ノートの nbSyncCustom**なのに、手帳の syncCustom を 呼んで いました。
       手帳の ほうは もう 無い cmBox を さがすので、何も 入らず 空っぽに なって いた。 */
  applyTexts(); buildCats(); buildTiles(); syncChoices(); syncEnikki(); try { nbSyncCustom(); } catch (e) {}
  nkStrip();
}
// ⇪ 共有：この形の アドレス（共有の しくみが ない ときは コピー）
function nkShare() {
  try { if (navigator.share) navigator.share({ url: shareUrl(true) }); else { navigator.clipboard.writeText(shareUrl(true)); alert(TEXTS.nkCopied); } } catch (err) {}   // ★2026-10-15 共有アドレスには 名前を 入れない
}
// いまの えらびを 帯の 下に 小さく
function nkValue(key) {
  if (key === 'check') return changesList().length + tr('か所');   // ★2026-10-15
  try {
    const n = state.notes[state.idx];
    if (key === 'country') return TEXTS.nkCountries[COUNTRIES.findIndex(c => c.id === state.country)];
    if (key === 'size') return tr(PSEL.name) + (PSEL.holes ? ' ' + PSEL.holes + tr('穴') : '');
    if (key === 'year') return '';                       // ★nv0.2.8 ノートに 年間は ない
    if (key === 'sheet') return n ? fmtName(n.fmt) : '';
    if (key === 'stars') return state.stars + TEXTS.starsUnit;   // ★nv0.2.8
    if (key === 'todo') return (state.todo || []).filter(Boolean).join('・');
    if (key === 'option') return (OPTIONS.find(o => o.id === state.option) || {}).name || '';
    if (key === 'start') return LANG === 'ja' ? state.year + '年' + state.month + '月' : MONTH_EN[state.month - 1].slice(0, 3) + ' ' + state.year;
    if (key === 'color') return state.color;
    if (key === 'view') return viewCode() === VIEW_DEFAULT ? '' : TEXTS.nkChanged;   // ★v0.2.139 はじめから 変えていたら「変えている」
    if (key === 'custom') return (n && n.fmt.custom) ? customCode() : '';   // ★nv0.2.19 ノートは 注文コードを 出す
    if (key === 'name') return state.name || tr('なし');
    if (key === 'enikki') return TEXTS.nkEnikkiModes[state.enikki.mode > 0 ? 0 : 1];
    if (key === 'paper') return tr((PAPERS.find(p => p.id === state.paper) || {}).name || '');
    if (key === 'binder') return tr((BINDER_LIST.find(b => b.id === state.binder) || {}).name || '');
    if (key === 'order') return ($('cartPrice') || {}).textContent || '';
  } catch (e) {}
  return '';
}
function nkGo(i) {
  const pop = $('pop');
  // 印刷（13番めの 手順＝手帳と おなじ）：印刷の カードだけ 見せる
  if (i === 'print' || (typeof i === 'number' && TEXTS.nkSteps[i] && TEXTS.nkSteps[i][0] === 'print')) {
    i = TEXTS.nkSteps.findIndex(st => st[0] === 'print');
    NK.step = i;
    NK.print = true;
    const topbar = document.querySelector('.topbar'); if (topbar) topbar.style.display = 'none';
    pop.hidden = false; pop.dataset.key = 'print';
    pop.querySelectorAll('.pop-card').forEach(c => { c.hidden = c.dataset.card !== 'print'; });
    syncPrintApp();
    { const po = $('prOnlyNote'); if (po) po.hidden = !PRINT_ONLY; } try { prChoose('home'); prRefreshQuota(); prCooldownSync(); } catch (e) {}   // ★手帳と おなじ：家／コンビニ／保存の えらびと のこり回数
    document.body.classList.remove('cm-open');
    $('nkBody').scrollTop = 0; nkStrip(); return;
  }
  NK.print = false;
  NK.step = i;
  const [key] = TEXTS.nkSteps[i];
  // ②年間・③月間か週間 は なかま＋タイル（cat を 切りかえる）。それ以外は #pop の カード
  const topbar = document.querySelector('.topbar');
  pop.hidden = false;
  if (key === 'year' || key === 'sheet') {
    if (topbar) topbar.style.display = 'block';
    pop.dataset.key = '';
    pop.querySelectorAll('.pop-card').forEach(c => { c.hidden = true; });
    /* ★nv0.2.8 ノートには「年間」の なかまが ない。
       いま えらんで いる 柄の なかま（なければ いちばん はじめの なかま）に する。 */
    const now = state.notes[state.idx];
    const want = (now && now.fmt.cat) || (CATS[0] && CATS[0].id) || 'lines';
    if (want !== state.cat) { state.cat = want; buildCats(); buildTiles(); }
    // ★v0.2.146 みなとさん：年間 → 年間の 紙、月間か 週間 → 手帳の 1まいめ に 紙も 移る（はじめの 1回は 動かさない）
    if (NK.ready) { try { if (key === 'year') { if (yNote()) turnPage('y0'); } else turnPage('s0'); } catch (err) {} }
  } else {
    if (topbar) topbar.style.display = 'none';
    /* ★nv0.2.15 みなとさん「ここも 消えて いる」（2026-10-03）
       ★わたしの 足しわすれでした。この 表に **stars・todo・option が 無かった**ので、
         「星」「チェック」「大容量」の 手順で どの カードも 出ず、下が 空っぽに なって いた。 */
    const map = { check: 'check', country: 'country', size: 'size', start: 'year', view: 'view', custom: 'custom', color: 'color', name: 'name', enikki: 'enikki', stars: 'stars', todo: 'todo', paper: 'paper', binder: 'binder', option: 'option', order: 'order' };
    pop.hidden = false; pop.dataset.key = map[key];
    pop.querySelectorAll('.pop-card').forEach(c => { c.hidden = c.dataset.card !== map[key]; });
    if (map[key] === 'check') { try { syncCheck(); } catch (e) {} }   // ★2026-10-15 内容の確認
    if (map[key] === 'color') { showPalette(); try { syncColorPix(); } catch (e) {} }   // ★2026-10-15 絵の パネル
    if (map[key] === 'year' || map[key] === 'view') syncYear();
    if (map[key] === 'year') syncBg();
    if (map[key] === 'view') syncSize();
    if (map[key] === 'enikki') { syncNkEnikki(); try { syncEnikkiPix(); } catch (e) {} }
    if (map[key] === 'name') { try { syncNamePix(); } catch (e) {} }
    if (map[key] === 'paper' || map[key] === 'binder' || map[key] === 'option') { try { syncChoicePix(); } catch (e) {} }
    if (map[key] === 'stars') { syncStars(); try { syncStarsPix(); } catch (e) {} }                       // ★nv0.2.15 星の 数を 出す
    if (map[key] === 'todo') { try { syncBoxBtns(); syncTodoPix(); } catch (e) {} }   // ★nv0.2.15 □の 光り
    if (map[key] === 'order') { try { turnPage('order'); } catch (err) {} }   // ★v0.2.139 12 注文確定：紙も ご注文内容の ページに
    if (NK.ready) { try { if (NK_PAGE[key]) turnPage(NK_PAGE[key]); else if (key !== 'order' && !/^[sy]\d+$/.test(curPage().id)) turnPage(sheetPage()); } catch (err) {} }   // ★nv0.2.173 手順に 合わない POINT が のこらない（星・チェック・大容量・国・サイズ では 紙に もどる）   // ★v0.2.149 色 → POINT 4（やわらかい線）・紙 → POINT 5（紙は 3つ）の 説明ページへ
    if (map[key] === 'custom') {
      /* ★nv0.2.23 みなとさん「形を変えるの 部分を **現在 選んで いる もの**を
         カスタムできるように 変更して」（2026-10-03）
         → いま えらんで いる 柄を 下じきに して オーダーメイドに 切りかえる。 */
      try { nbCustomFromNow(); } catch (e) {}
      document.body.classList.add('cm-open'); nbSyncCustom();
    } else document.body.classList.remove('cm-open');
  }
  nkMile(key);
  $('nkBody').scrollTop = 0;
  nkStrip();
}
// ★v0.2.155 ほけん：はじめの 呼び出しが うまく いかなかった ときだけ 動く（ふつうは 下の「はじめ」で もう 動いている）
// ★nv0.2.32 ほけんの nkInit は、下の「はじめ」が おわってから だけ 動かす。
//   ノートは 柄の 読みこみを 待つ（await）ので、先に load が きて 紙が まだ ない ことが ある。
//   その ときに 動くと「柄を えらぶ 2/12」の 字が 出ないまま 止まっていた（楽天で 見つかった）
let NK_BOOTED = false;
addEventListener('load', () => { if (!NK_BOOTED) return; try { nkInit(); } catch (e) { console.warn('nike', e); } });

// 開発者用の画面（コンソール）を開いた人への警告
(() => {
  try {
    console.log('%c© 2026 港興業株式会社 — コピー禁止', 'color:#c14a30;font-size:18px;font-weight:bold');
    console.log('このページのプログラム・デザイン・手帳の線・文章・画像は、港興業株式会社の著作物です。\n港興業株式会社の書面による許可なく、複製・コピー・改変・転載・再配布・ほかのサイトやアプリでの利用をすることを、かたく禁じます。\nThis page is the copyrighted work of Minato Kogyo Co., Ltd. Copying or reusing it without written permission is prohibited.');
  } catch (e) {}
})();

// ===== 画面の文章（ここを直せば変わる）=====
// ★v0.2.164 みなとさん「基本 全て 英語」：アメリカの とき 画面の 文字を 英語に する 辞書（日本語 → 英語）。
//   紙の 中は KOYO_EN／L()／FMT_EN、形の 名前は FMT_EN・CAT_EN。ここは 画面（えらぶ 欄・説明・ご注文内容）の ぶん。無い 文字は 日本語の まま
// ★v0.2.165 整理：国の 表（COUNTRIES）と 言葉の 辞書（I18N）。国を 足すときは COUNTRIES に 1行 ＋ I18N.<言葉> の 辞書 ＋ HOLIDAYS.<国> の 祝日
//   ・LANG＝画面の 言葉（'ja' か I18N に ある 言葉）。国で 決まる。お店（Shopify）の 言葉が 日本語 いがいなら それにも 合わせる
//   ・PLANG＝紙の 言葉（描いている あいだ。plannerSvg が opt.country から 入れる）
//   ・辞書は「日本語 → その 言葉」。無い 文字は 日本語の まま 出る（まちがいより まし）
// ★COUNTRIES・countryOf・I18N は 紙を 描く ところ（テストが 切り出す 範囲）に ある。ここは 画面の 言葉だけ
let LANG = 'ja';          // 画面の 言葉
const shopLang = () => { try { const l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'ja'; return l.slice(0, 2).toLowerCase(); } catch (e) { return 'ja'; } };
// 画面の 言葉を 決める：国が 日本 いがい → その 国の 言葉。国が 日本でも お店の 言葉が 日本語 いがい（Shopify Markets）なら その 言葉
function langOf() { const c = countryOf(state.country); if (c.lang !== 'ja' && I18N[c.lang]) return c.lang; const sl = shopLang(); return sl !== 'ja' && I18N[sl] ? sl : 'ja'; }
const tr = str => (LANG !== 'ja' && typeof str === 'string' ? (I18N[LANG].ui[str] ?? str) : str);
const trDeep = v => (typeof v === 'string' ? tr(v) : Array.isArray(v) ? v.map(trDeep) : v);
/* ★nv0.2.145 英語（など）の とき：画面に 出た 日本語を 辞書で 置きかえる（見える 文字と title・aria-label・placeholder・alt）
   ・日本語の 文字列は 1字も 変えない。ここで 変えるのは「画面に 出た 文字」だけ。日本語の 画面では 何も しない
   ・紙の 絵（svg）・script・style・textarea は さわらない
   ・もとの 日本語を おぼえて いて、国を 日本に もどしたら もとに もどす
   ・辞書に ない 文字は そのまま（柄の 名前など）。足す ときは UI_EN に 1行 足すだけ */
const TRDOM = { rec: new WeakMap(), live: new Set(), mo: null };
const TRDOM_JP = /[぀-ヿ㐀-鿿ｦ-ﾟ]/;
const TRDOM_ATTR = ['title', 'aria-label', 'placeholder', 'alt'];
const TRDOM_FW = /[（）＋：、。]/;
// 英語に なった 文の 中の 全角の かっこ・＋・：を 半角に（日本語が のこって いる 文は そのまま）
function trFw(s) {
  if (!TRDOM_FW.test(s) || TRDOM_JP.test(s) || !/[A-Za-z0-9]/.test(s)) return s;
  return s.replace(/\s*（/g, ' (').replace(/）/g, ')').replace(/＋/g, '+').replace(/：/g, ': ').replace(/、/g, ', ').replace(/。/g, '. ').replace(/\( /g, '(').replace(/ {2,}/g, ' ').replace(/ +$/, '');
}
// 数字・色コード・かっこが くっついた 文字を ほどいて 辞書で 引く（1文字ずつ 辞書に 入れずに すむ）
function trLoose(s) {
  const d = tr(s); if (d !== s) return d;
  let m;
  if ((m = /^(.+?)\s*(#[0-9a-fA-F]{3,8})$/.exec(s))) return trLoose(m[1]) + ' ' + m[2];                      // 色 #edb6b6／白藍（しらあい）#c1e4e9
  if ((m = /^(.+?)（(.+?)）$/.exec(s)) && (tr(m[1]) !== m[1] || tr(m[2]) !== m[2])) return trLoose(m[1]) + ' (' + trLoose(m[2]) + ')';   // 白藍（しらあい）
  if ((m = /^(\d+)\s+(.+)$/.exec(s)) && tr(m[2]) !== m[2]) return m[1] + ' ' + tr(m[2]);                  // 3 柄を えらぶ
  if ((m = /^(.+?)\s+(\d+)$/.exec(s)) && tr(m[1]) !== m[1]) return tr(m[1]) + ' ' + m[2];                  // 罫線 30
  if ((m = /^(\d+)\s*個$/.exec(s))) return m[1];                                                          // 5個
  if ((m = /^(.+?)\s+(\d+)個$/.exec(s)) && tr(m[1]) !== m[1]) return tr(m[1]) + ' ' + m[2];                  // 星 5個
  if ((m = /^(☆*)（(\d+)個）$/.exec(s))) return m[1] + ' (' + m[2] + ')';                                   // ☆☆☆☆☆（5個）
  if ((m = /^(\d+) ページめ$/.exec(s))) return 'Page ' + m[1];                                          // 2 ページめ
  if ((m = /^書けるのは (\d+)ページまで(?:（プラス会員は (\d+)ページ）)?$/.exec(s))) return 'You can write up to ' + m[1] + ' pages' + (m[2] ? ' (Plus members: ' + m[2] + ' pages)' : '');   // 書けるのは 2ページまで（プラス会員は 52ページ）
  if ((m = /^(\d{1,2})月$/.exec(s)) && typeof MONTH_EN !== 'undefined' && MONTH_EN[m[1] - 1]) return MONTH_EN[m[1] - 1].charAt(0) + MONTH_EN[m[1] - 1].slice(1, 3).toLowerCase();   // 1月（はじまり月の ボタン）
  if ((m = /^(\d+)か所$/.exec(s))) return m[1] + (m[1] === '1' ? ' change' : ' changes');                   // 2か所
  if ((m = /^コンビニで 暗証番号（(.+)）も 入れます。$/.exec(s))) return 'You will also enter the PIN (' + m[1] + ') at the store.';   // 暗証番号の 数字が 入る 文
  return s;
}
function trDomText(n) {
  const rec = TRDOM.rec.get(n);
  let ja = n.data;
  if (rec && ja === rec.en) ja = rec.ja;   // 自分が 置きかえた まま
  if (LANG === 'ja') { if (rec) { if (n.data !== ja) n.data = ja; TRDOM.rec.delete(n); TRDOM.live.delete(n); } return; }
  if (!TRDOM_JP.test(ja) && !TRDOM_FW.test(ja)) { if (rec) { TRDOM.rec.delete(n); TRDOM.live.delete(n); } return; }
  const m = /^(\s*)([\s\S]*?)(\s*)$/.exec(ja), en = m[1] + trFw(TRDOM_JP.test(m[2]) ? trLoose(m[2]) : m[2]) + m[3];
  if (en !== ja) { n.data = en; TRDOM.rec.set(n, { ja, en }); TRDOM.live.add(n); }
  else if (rec) { TRDOM.rec.delete(n); TRDOM.live.delete(n); }
}
function trDomAttrs(el) {
  let r = TRDOM.rec.get(el);
  for (const a of TRDOM_ATTR) {
    const v = el.getAttribute(a); if (v == null) continue;
    const rc = r && r[a]; let ja = v;
    if (rc && v === rc.en) ja = rc.ja;
    if (LANG === 'ja') { if (rc) { if (v !== ja) el.setAttribute(a, ja); delete r[a]; } continue; }
    if (!TRDOM_JP.test(ja)) { if (rc) delete r[a]; continue; }
    const en = trLoose(ja.trim());
    if (en !== ja.trim()) { el.setAttribute(a, en); if (!r) { r = {}; TRDOM.rec.set(el, r); } r[a] = { ja, en }; TRDOM.live.add(el); }
    else if (rc) delete r[a];
  }
}
function trDomWalk(root) {
  if (!root || (root.nodeType !== 1 && root.nodeType !== 3)) return;
  if (root.nodeType === 3) { if (root.parentElement && !root.parentElement.closest('svg,script,style,textarea')) trDomText(root); return; }
  if (root.closest && root.closest('svg,script,style,textarea')) return;
  const w = document.createTreeWalker(root, 5, { acceptNode: n => (n.nodeType === 1 && /^(svg|script|style|textarea|noscript)$/i.test(n.tagName) ? 2 : 1) });   // 2＝その中は とばす
  trDomAttrs(root);
  for (let n = w.nextNode(); n; n = w.nextNode()) { if (n.nodeType === 3) trDomText(n); else trDomAttrs(n); }
}
function trDomAll() {
  if (typeof document === 'undefined' || !document.body) return;
  trDomStart();
  const busy = TRDOM.mo; if (busy) busy.disconnect();
  try {
    if (LANG === 'ja') {
      for (const n of [...TRDOM.live]) { if (n.nodeType === 3) trDomText(n); else trDomAttrs(n); TRDOM.live.delete(n); }
    } else {
      for (const n of [...TRDOM.live]) if (!n.isConnected) TRDOM.live.delete(n);   // 消えた ものは わすれる
      trDomWalk(document.body);
    }
  } finally { if (busy) busy.observe(document.body, TRDOM_OPT); }
}
const TRDOM_OPT = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: TRDOM_ATTR };
function trDomStart() {
  if (TRDOM.mo || typeof MutationObserver === 'undefined' || !document.body) return;
  TRDOM.mo = new MutationObserver(list => {
    if (LANG === 'ja' && !TRDOM.live.size) return;
    if (LANG === 'ja') return;   // 日本語の あいだは 何も しない（もどすのは trDomAll）
    TRDOM.mo.disconnect();
    try {
      const seen = new Set();
      for (const r of list) {
        if (r.type === 'childList') r.addedNodes.forEach(n => { if (!seen.has(n)) { seen.add(n); trDomWalk(n); } });
        else if (r.type === 'characterData') { if (!seen.has(r.target)) { seen.add(r.target); trDomWalk(r.target); } }
        else if (r.target.nodeType === 1 && !r.target.closest('svg,script,style,textarea')) trDomAttrs(r.target);
      }
    } finally { TRDOM.mo.observe(document.body, TRDOM_OPT); }
  });
  TRDOM.mo.observe(document.body, TRDOM_OPT);
}
// 英語の 画面の 辞書（アメリカ・ヨーロッパの 英語）
const UI_EN = {
  '購入に進む': 'Proceed to purchase',
  'ご注文内容': 'Order summary', '色': 'Color', '名入れ': 'Name', 'すべて': 'All', '色をえらぶ': 'Choose colors', '線': 'Lines', '文字': 'Text', '土曜日': 'Saturday', '日曜日': 'Sunday',
  '線の色': 'Line color', '文字の色': 'Text color', '土曜日の色': 'Saturday color', '日曜日の色': 'Sunday color', '線と同じにする': 'Same as lines', '線と同じ': 'Same as lines', '定番の色': 'Classic colors', 'いろいろな色': 'More colors', '細かく決める': 'Fine-tune', '色あい': 'Hue', 'あざやかさ': 'Saturation', '明るさ': 'Brightness', 'パソコンの色えらび': 'System color picker',
  '名入れをする': 'Add a name', 'お名前': 'Name', '20文字まで・絵文字は使えないよ': 'Up to 20 characters, no emoji', '入る場所': 'Position', '紙の右下に入るよ': 'Printed at the bottom right', '印刷して確認する': 'Print to check', '線をつくる（オーダーメイド）': 'Custom lines', 'オーダーメイド': 'Custom',
  'ボタンを押すと、紙がすぐにかわるよ。上の「オーダーメイド」を押すと、このパネルがまたひらくよ': 'Tap a button and the paper changes right away. Tap "Custom" above to reopen this panel',
  'B5の紙・倍率100%（実際のサイズ）で印刷してね': 'Print on B5 paper at 100% (actual size)',
  'B5の紙・倍率100%で印刷してね': 'Print on B5 paper at 100%', '色は、おうちのプリンターで少しちがうよ': 'Colors differ a little on your printer', '紙の左下に、印刷のマークが入るよ': 'A printout mark goes at the bottom left',
  '線の色をたしかめられるよ。ただし、おうちのプリンターとお店のプリンターはちがうので、とどく手帳とは色が少しちがいます。ひとつの目安としてお使いください': 'You can check the line color. Home printers differ from ours, so the delivered planner may look a little different. Use it as a guide',
  '紙の左下に、下のQRコードが入るよ': 'The QR code below is printed at the bottom left', '紙に入るQRコード': 'QR code on the paper', 'スマホで読みとると、いまの内容でこのページがひらくよ。印刷の前にためせます': 'Scan it with your phone to reopen this page with the current settings. Try it before printing',
  '印刷する': 'Print', '楽天市場アプリの中では印刷できません': 'Printing is not available in the Rakuten app', 'Safari や Chrome などのブラウザで、このページを開いてから印刷してね。下のボタンでURLをコピーして、ブラウザのアドレス欄に貼りつけると、いまえらんでいる内容のままひらくよ。': 'Open this page in a browser such as Safari or Chrome, then print. Copy the URL below and paste it into the address bar to open it with the current settings.',
  'URLをコピーする': 'Copy URL', 'コピーしました。ブラウザのアドレス欄に貼りつけてね': 'Copied. Paste it into the browser address bar', 'コピーできませんでした。上のURLを長押ししてコピーしてね': 'Could not copy. Long-press the URL above to copy', 'ダブルタップで 小さく／もとの大きさ': 'Double-tap to shrink / actual size',
  '印刷すると色をたしかめられるよ。プリンターがちがうので、とどく手帳とは色が少しちがいます。ひとつの目安としてお使いください': 'Printing lets you check the colors. Printers differ, so the delivered planner may look a little different. Use it as a guide', '印刷の準備ができませんでした。もう一度おためしください。': 'Could not prepare printing. Please try again.',
  'B5ルーズリーフ 内容確定に進む': 'B5 loose-leaf — review order', '書籍用紙': 'Book paper', '万年筆専用用紙': 'Fountain-pen paper', 'シャープペン専用用紙': 'Pencil paper', 'バインダーなし': 'No binder', 'バースブックバインダー': 'BirthBook binder', 'レザーバインダー': 'Leather binder', 'マルマン バインダー': 'Maruman binder',
  'カゴに入れる': 'Add to cart', 'バースブック手帳B5': 'BirthBook Planner B5', '準備中': 'Coming soon', 'ただいま準備中です。もうしばらくお待ちください。': 'Coming soon. Please wait a little longer.', 'カゴに入れられませんでした。少し時間をおいて、もう一度おためしください。': 'Could not add to cart. Please try again later.',
  '送料無料・B5・26穴｜レビューを書くとペン1本プレゼント': 'Free shipping · B5 · 26 holes | Write a review and get a free pen', '仮の写真': 'Sample photo', '紙': 'Paper', '紙をえらぶ': 'Choose paper', 'どの紙も B5・26穴。書きごこちだけがちがうよ': 'All papers are B5, 26 holes. Only the writing feel differs',
  'バインダー': 'Binder', 'バインダーをえらぶ': 'Choose a binder', 'どれも、えらんだ手帳のリフィルつき': 'Each comes with the planner refills you chose', '仮': 'Tentative', 'はじまり月': 'Start month', 'はじまり月・背景': 'Start month & background', '表示': 'Display', '形を変える': 'Adjust shape', 'もとの形に もどす': 'Reset to original',
  '日本の行事': 'Japanese events', '日にちが決まる行事を、その日に小さく入れるよ。七草・節分・ひなまつり・花まつり・八十八夜・母の日・父の日・入梅・半夏生・七夕・土用の入り・お盆・二百十日・十五夜・十三夜・ハロウィン・七五三・クリスマス・大晦日 など（節分・彼岸入り・八十八夜・入梅・半夏生・土用の入り・二百十日 は国立天文台と同じ計算）。年間の形・ガントチャートには入らない': "Adds dated events in small type: Nanakusa, Setsubun, Hinamatsuri, 88th Night, Mother's Day, Father's Day, Tanabata, Obon, Harvest Moon, Halloween, Shichi-go-san, Christmas, New Year's Eve and more (seasonal days follow the National Astronomical Observatory of Japan). Not on yearly formats or the Gantt chart",
  'ぎょうじ': 'Events', '先生行事': 'School events', '保育園行事': 'Preschool events', '先生行事・保育園行事は、学校や園ごとに日がちがうので、日付には入れないよ。その月の「おもな行事」の一覧と、日にちを書く（ / ）を、月間式は表の下、週の形は右下のカレンダーのとなりに入れる（週の形は右下のカレンダーが1つになる）。年間の形には入らない': "School and preschool events differ by school, so they are not placed on dates. A list of the month's main events with ( / ) blanks goes below the monthly grid, or next to the bottom-right calendar on weekly formats (which then have one calendar). Not on yearly formats",
  '文字の大きさ': 'Text size', '文字の位置（上下）': 'Text position (up / down)', '文字の位置（左右）': 'Text position (left / right)', '上へ1': 'Up 1', '上へ.5': 'Up .5', '下へ.5': 'Down .5', '下へ1': 'Down 1', '左へ1': 'Left 1', '左へ.5': 'Left .5', '右へ.5': 'Right .5', '右へ1': 'Right 1',
  '手帳の中の文字が ぜんぶ いっしょに かわるよ（位置の数は mm）。上の月の数字など 大きな見出しの大きさは かわらない。大きくすると となりの文字と かさなることがあるので、紙の見本で たしかめてね': 'All text on the paper changes together (position in mm). Large headings such as the month number stay the same. Larger text may overlap its neighbors, so check the preview',
  'サイズ': 'Size', '背景（線の下にしく柄）': 'Background (pattern under the lines)', '柄': 'Pattern', '無地': 'Plain', 'ドット': 'Dots', '方眼': 'Grid', '罫線': 'Ruled', '十字': 'Crosses', '間隔': 'Spacing', 'こさ（線の色をうすくする）': 'Density (lighter than the lines)', '同じ': 'Same',
  '手帳のわくの中の、線の下にしくよ。見出しや紙のまわりにはしかない。印刷にも出る。無地のときは なにもしかない': 'Laid under the lines inside the planner frame, not on headings or margins. It prints too. Plain adds nothing', '背景': 'Background', '表示（こよみ・ぎょうじ・文字）': 'Display (calendar marks, events, text)', '文字の大きさと位置': 'Text size & position', 'こよみ': 'Calendar marks', 'ぎょうじ（行事を入れる）': 'Events',
  'はじまりの年と月をえらぶ': 'Choose the start year and month', 'えらんだ月の1日から2年分（24か月）。年間の表は1年で1まい、2まい': 'Two years (24 months) from the 1st of the chosen month. Yearly charts: one sheet per year, 2 sheets', '週のはじまり': 'Week starts on', '月曜': 'Monday', '日曜': 'Sunday', '祝日': 'Holidays', '入れる': 'On', '入れない': 'Off',
  '六曜': 'Rokuyo', '月齢': 'Moon phases', '二十四節気': 'Solar terms', '旧暦': 'Lunar calendar', 'カレンダー': 'Mini calendar', '日付の丸': 'Date circles', '土曜の丸': 'Saturday circle', '日曜の丸': 'Sunday circle', '祝日の丸': 'Holiday circle', 'つける': 'On', 'つけない': 'Off',
  'マスの中の 時計': 'Clock in each cell', 'マスの すみに 12時間の 文字ばんが 入るよ。ねた時間や はたらいた時間を 色で ぬれる。月間式のときだけ えらべる': 'A 12-hour dial in the corner of each cell. Color in your sleep or work hours. Monthly formats only', '土曜': 'Saturday', '出す': 'Show', '出さない': 'Hide',
  'えにっきbook の 絵': 'Diary book pictures', 'えにっきbook（LINE）で 入れた 絵を、月間式の 日の マスに 出します。LINE で ログインすると 見られます（印刷にも 出ます）': 'Pictures drawn in the Diary book (LINE) appear in the day cells of monthly formats. Log in with LINE to see them (they print too)',
  'LINE で 見る': 'View with LINE', 'えにっきbook の 絵を 読みこんでいます…': 'Loading Diary book pictures…', 'えにっきbook の 絵を 読みこめませんでした': 'Could not load Diary book pictures', 'もう一度 読みこむ': 'Reload', '絵': 'Pictures', '新しい絵': 'Newest', '古い絵': 'Oldest',
  'この 期間に えにっきbook の 絵が ありません（動画は 出しません）': 'No Diary book pictures in this period (videos are not shown)', '1日に 絵が 2まい 以上 ある日は、マスの 絵を おすと つぎの 絵に かわります': 'On days with 2 or more pictures, tap the cell to switch pictures', 'LINE から はずす': 'Unlink LINE',
  'お店の アカウントで 見ています（LINE の ログインは いりません）': 'Viewing with your store account (no LINE login needed)', 'このアカウントは えにっきbook と つながっています。つぎからも ログインするだけで 絵が 出ます': 'This account is linked to the Diary book. Just log in next time to see your pictures',
  '「LINE で 見る」で 一度 入ると、このアカウントと つながります。つぎからは ログインするだけで 絵が 出ます': 'Sign in once with "View with LINE" to link this account. After that, just log in',
  '⭐ この形を おきにいりに 入れる': '⭐ Add this design to favorites', 'おきにいりに 入れています…': 'Adding to favorites…', 'おきにいりに 入れました。マイページの「おきにいり → オーダー」から、この形の まま ひらけます': 'Added to favorites. Open it anytime from My page → Favorites → Orders', 'おきにいりから はずしました': 'Removed from favorites', 'おきにいりに 入れられませんでした（ログインを たしかめてください）': 'Could not add to favorites (please check that you are logged in)',
  'スタンプを 貼る': 'Place stamps', 'えらんでから 紙を 押すと そこに 貼れます。貼った ものを 押すと 大きく なり、さいごに 消えます': 'Pick a stamp, then tap the paper to place it. Tap a stamp to enlarge it; the last tap removes it', 'マイスタンプが ありません（えにっきの 絵を「🔖 マイスタンプに 入れる」で ふやせます）': 'No stamps in My Stamps yet (add Diary pictures with "🔖 Add to My Stamps")',
  '貼るのを やめる': 'Stop placing', 'スタンプを さがしています…': 'Looking for stamps…', 'じぶんの': 'Mine', 'みんなの': "Everyone's", '公開する': 'Make public', '公開を やめる': 'Make private', 'この 絵を 公開すると、世界中の 人が 見られて、自分の 手帳に 貼れるように なります。名前や 日づけは 出ません。公開しますか？': 'If you make this picture public, people around the world can see it and place it in their planners. Your name and dates are not shown. Make it public?',
  '公開しました（やめたいときは いつでも やめられます）': 'Now public (you can make it private anytime)', '公開を やめました': 'Now private', 'もらう': 'Get', 'マイスタンプに 入りました': 'Added to My Stamps', 'もらえませんでした': 'Could not get it', '通報': 'Report', 'この スタンプを 通報しますか？（3人から 通報されると 一覧から 消えます）': 'Report this stamp? (It is hidden after 3 reports)', '通報しました': 'Reported', 'まだ 公開されている スタンプが ありません': 'No public stamps yet',
  'カスタマイズ': 'Customize', 'いま 直している ところ': 'Editing now', '確定して つぎへ': 'Confirm & next', '完了': 'Done', 'もどる': 'Back', '🖨 印刷（見ている 1まい）': '🖨 Print (this sheet)', '⇪ 共有（この形の アドレス）': '⇪ Share (link)', 'アドレスを コピーしました': 'Link copied', 'メニュー': 'Menu',
  '紙は ご注文内容の ページです。赤い ボタンで カゴへ 進みます': 'The paper shows your order summary. Tap the red button to go to the cart', '変えている': 'Changed', 'いれる': 'On', 'いれない': 'Off', 'いれる：えにっきbook（LINE）で 入れた 絵を 月間式の 日の マスに 出します。絵の えらびかたや スタンプは 下の「えにっきbook の 絵」で': 'On: pictures from the Diary book (LINE) appear in monthly day cells. Choose pictures and stamps in "Diary book pictures" below',
  '国': 'Country', '年間': 'Yearly', '月間か 週間': 'Monthly / Weekly', 'えにっき': 'Diary', '注文確定': 'Checkout', '日本': 'Japan', 'アメリカ': 'USA', '中国': 'China', '韓国': 'Korea', 'ヨーロッパ': 'Europe', '日本 いがいは じゅんび中です（紙の 言葉・祝日が 国ごとに かわります）': 'Other countries are coming soon (paper language and holidays change by country)',
  'お店の アカウントには えにっきの 絵が ありませんでした。えにっきbook で 描いた 絵を 出すなら「LINE で 見る」をおしてね': 'No Diary pictures on your store account. Tap "View with LINE" to show pictures drawn in the Diary book',
  '日付の丸を「つけない」にすると、丸はなくなって 色のちがう数字だけになるよ（土曜は土曜の色、日曜と祝日は日曜日の色）': 'With circles off, dates show only in their colors (Saturday in the Saturday color, Sunday and holidays in the Sunday color)',
  '祝日は日曜と同じ ぬった丸。六曜は「大安」など、月齢は 新月●・満月○、二十四節気は「立春」など、旧暦は「8/15」（閏月は「閏11/3」）が、日付のそばに小さく入るよ。旧暦は、マスの小さい 年間スケジュール・ガントチャートには入らない。カレンダーは、紙の右下の小さなカレンダー': 'Holidays get a filled circle like Sundays. Rokuyo (e.g. Taian), moon phases (new ●, full ○), solar terms and the lunar date (8/15, leap L11/3) appear in small type by the date. The lunar date is not shown on the yearly schedule or Gantt chart. "Mini calendar" is the small calendar at the bottom right',
  '暦': 'Calendar marks', '手帳の紙': 'Planner sheets', '年間トップ': 'Yearly top', '年間 ': 'Yearly ', '手帳トップ': 'Planner top', '注文方法': 'How to order', '手帳の紙をえらぶ': 'Choose planner sheets', '手帳の形': 'Format', '期間': 'Period', '（なし）': '(none)', '注文コード': 'Order code',
  '手帳のみ': 'Refill only', '黒・手帳のリフィルつき': 'Black, with planner refills', 'クロッキー・手帳のリフィルつき': 'Croquis, with planner refills', '日本書籍用紙': 'Japanese book paper', 'ボールペン専用': 'For ballpoint pens', '裏移りしにくい': 'Little bleed-through', '品切れ': 'Sold out', 'お値段': 'Price', '税込': 'Tax included', '表紙': 'Cover', 'はじまり': ' start',
  'ご注文の方法': 'How to order', 'ご注文の方法 1/2': 'How to order 1/2', '国を えらぶ': 'Choose a country', 'いまは 日本だけ': 'Japan or USA', '年間の 形を えらぶ': 'Choose a yearly format', '1冊の はじめに つく 2まい': '2 sheets at the front of the book', '月間か 週間を えらぶ': 'Choose monthly or weekly', '7つの なかまから': 'From 7 families', 'はじまり月を きめる': 'Set the start month', '2年ぶんの はじめの 月。背景も ここで': 'First month of the 2 years. Background too',
  '表示を ととのえる': 'Adjust the display', '週の はじまり・日付の 丸・六曜など': 'Week start, date circles, rokuyo…', '形を 変える': 'Adjust the shape', 'マスの 数や 線を 自分に ぴったりに': 'Rows, lines and more, your way', 'ご注文の方法 2': 'How to order 2', 'ご注文の方法 2/2': 'How to order 2/2', '色を えらぶ': 'Choose colors', '線・文字・土曜・日曜の 4つ': 'Lines, text, Saturday, Sunday', '名前を 入れる': 'Add your name', 'はじめは BirthBookNote。いらなければ 消してね': 'Default is BirthBookNote. Delete it if you like',
  'えにっきを いれる': 'Add diary pictures', 'LINE の えにっきbook の 絵を マスに': 'Diary book pictures in the day cells', '紙を えらぶ': 'Choose paper', 'ボールペン・万年筆・シャープペンの 3つから': 'Ballpoint, fountain pen or pencil', 'バインダーを えらぶ': 'Choose a binder', 'いらないときは そのままで OK': "Skip it if you don't need one", '注文を 確定する': 'Check out', 'ご注文内容を たしかめて カゴへ': 'Review your order and add to cart',
  '1ページ完結': 'One page', 'ページを またがない': 'No page turns', 'どの形も、B5の1まいに1年・1か月・1週間・2週間がまるごと入ります。見開きをまたがないので、ひと目で見わたせて、1まいずつ入れかえ・並べかえもできます。': 'Every format fits a whole year, month, week or two weeks on one B5 sheet. Nothing crosses a spread, so you see it all at a glance, and sheets can be swapped or reordered one by one.',
  '手作り': 'Handmade', 'ひとつずつ手作り': 'Made one by one', 'ひとつずつ、手作りでお作りしています。四国・徳島県の国府町（こくふちょう）からお送りします。': 'Each planner is handmade and shipped from Kokufu, Tokushima, on Shikoku island, Japan.', '片面印刷': 'Single-sided', 'おもてだけに線を印刷しています。うらは、すけて見える線をたよりに書けます。': 'Lines are printed on the front only. On the back, write along the lines showing through.',
  'やわらかい線': 'Soft lines', 'えほんのような、やわらかい線': 'Soft lines like a picture book', '線は水性インクで印刷しています。やわらかさを再現した、えほんのような風合いです。水にはよわいので、ぬらさないように気をつけてください。': 'Lines are printed with water-based ink for a soft, picture-book feel. They are not waterproof, so keep the paper dry.',
  '紙は3つからえらべます': 'Three papers to choose from', '書くものに合わせてえらんでください。①日本書籍用紙（ボールペン専用）＝本に使われるクリーム色の紙。②万年筆専用用紙＝裏移りしにくい紙。③シャープペン専用用紙。どれもB5・26穴です。': 'Choose by pen: ① Japanese book paper (ballpoint) — the cream paper used in books. ② Fountain-pen paper — little bleed-through. ③ Pencil paper. All B5, 26 holes.',
  'ジェットストリーム': 'Jetstream', 'ジュースアップ 0.4': 'Juice Up 0.4', 'サラサ': 'Sarasa', 'ブレン': 'bLen', 'に ぴったりの 日本書籍用紙': '— Japanese book paper suits these pens', '名前を 入れられます': 'Add your name', '紙の 右下に 好きな 文字を 入れられます（20文字まで）。はじめは BirthBookNote。いらないときは 文字を けせば 何も 出ません。ぜんぶの 紙に 同じ 文字が 入ります。': 'Any text (up to 20 characters) is printed at the bottom right. Default is BirthBookNote; delete it for none. The same text goes on every sheet.',
  'えにっきの 絵が 入ります': 'Diary pictures on your planner', 'LINE の「えにっきbook」で かいた 絵を、月間式の 日の マスに そのまま 出せます。LINE で ログインすると 見られて、印刷にも 出ます。マイスタンプも マスに はれます。': 'Pictures drawn in the "Diary book" on LINE appear in the day cells of monthly formats. Log in with LINE to see them; they print too. My Stamps can be placed in cells as well.',
  'バースブックバインダー（黒）': 'BirthBook binder (black)', '軽くてじょうぶな、黒い紙のバインダーです。B5・26穴。手帳のリフィルつき。': 'A light, sturdy black paper binder. B5, 26 holes. Planner refills included.', 'レザーバインダー（黒）': 'Leather binder (black)', '本革の黒いバインダーです。使うほど手になじみます。B5・26穴。手帳のリフィルつき。': 'A black genuine-leather binder that softens with use. B5, 26 holes. Planner refills included.',
  'おまけ': 'Bonus', 'レビューでペン1本': 'A pen for your review', 'レビューを書いてくださった方全員に、おまけでペンを1本おとどけします。': 'Everyone who writes a review receives a free pen.',
  '白藍': 'Pale indigo', 'しらあい': 'shiraai', '珊瑚色': 'Coral', 'さんごいろ': 'sangoiro', '浅黄': 'Light yellow', 'うすき': 'usuki', '錆青磁': 'Rusty celadon', 'さびせいじ': 'sabiseiji', '白藤色': 'Pale wisteria', 'しらふじいろ': 'shirafujiiro', '白橡': 'Pale oak', 'しろつるばみ': 'shirotsurubami', '灰青': 'Gray blue', 'はいあお': 'haiao', '薄花色': 'Pale flower blue', 'うすはないろ': 'usuhanairo',
  '目標': 'Goals', 'ふりかえり': 'Review', '横罫': 'Ruled', '5本罫': '5-line', 'チェック': 'Checklist', 'マス目': 'Grid', '英語罫': 'English ruled', 'ほそい': 'Thin', 'ふつう': 'Normal', 'ふとい': 'Thick', '実線': 'Solid', '点線': 'Dotted', '破線': 'Dashed', '5本ごと': 'Every 5', '10本ごと': 'Every 10', 'もとの形': 'Base format', '年間スケジュール（たて）': 'Yearly schedule (vertical)',
  '月のわけ方': 'Month split', '12か月で1まい': '12 months per sheet', '6か月で1まい': '6 months per sheet', '日の欄の線': 'Day row lines', '下のメモ': 'Bottom memo', 'あり': 'Yes', 'メモの線': 'Memo lines', 'メモの間隔': 'Memo spacing', 'メモの線の太さ': 'Memo line weight', 'メモの線の引き方': 'Memo line style', 'メモの強調': 'Memo accent', '段の数': 'Rows', '5段': '5 rows', '6段': '6 rows',
  'よこのメモ': 'Side memo', '右 1/3': 'Right 1/3', '右 1/2': 'Right 1/2', '左 1/3': 'Left 1/3', '左 1/2': 'Left 1/2', 'たてのメモ': 'Vertical memo', '下': 'Bottom', '上': 'Top', 'インデックス': 'Index', 'マスの中の線': 'Lines in cells', '1本': '1 line', '2本': '2 lines', '3本': '3 lines', '4本': '4 lines', '5本': '5 lines',
  '表の 上': 'Top of grid', 'すこし上': 'A bit up', 'すこし下': 'A bit down', '表の 下': 'Bottom of grid', 'すこし短く': 'A bit shorter', '短く': 'Shorter', '表の はば': 'Grid width', 'ひろい': 'Wide', 'せまい': 'Narrow', '曜日の 帯': 'Weekday band', 'ふつう 6mm': 'Normal 6mm', 'ひくい 4mm': 'Low 4mm', '高い 8mm': 'Tall 8mm', '曜日の 名前': 'Weekday names', '英語 MON': 'English MON', '日本語 月': 'Japanese 月',
  '日付の 丸': 'Date circle', '小さい': 'Small', '大きい': 'Large', '週の 番号': 'Week number', '左の 列': 'Left column', 'メモ': 'Memo', 'やること □': 'To-do □', '右の 列（NOTES）': 'Right column (NOTES)', '日付の となりの 数字': 'Number by the date', 'その年の 何日め': 'Day of year', '列の はば': 'Column width', '均等': 'Equal', '週末を 大きく': 'Bigger weekend', '平日を 大きく': 'Bigger weekdays',
  '日付': 'Dates', '入れない（フリー）': 'None (free)', 'マスの 上の メモ線': 'Memo line above cells', 'マスの すみの □': '□ in cell corner', '2つ': '2', '土日の マスの 色': 'Weekend cell color', 'うすく ぬる': 'Light fill', '下の 月間プランの 表': 'Monthly plan table below', '潮の らん': 'Tide row', 'マスの中の 線の 間隔': 'Cell line spacing', 'カレンダーの 場所': 'Calendar position', '右下': 'Bottom right', '左下': 'Bottom left', '右上': 'Top right', '下のまんなか': 'Bottom center', 'メモの わく': 'Memo frame',
  '朝がた': 'Early bird', '目もり': 'Scale', '時刻': 'Hours', '校時': 'Periods', 'はじめの時間': 'Start hour', '0時': '0:00', '1時': '1:00', '2時': '2:00', '3時': '3:00', '4時': '4:00', '5時': '5:00', '6時': '6:00', '7時': '7:00', '8時': '8:00', '9時': '9:00', 'おわりの時間': 'End hour', '18時': '18:00', '19時': '19:00', '20時': '20:00', '21時': '21:00', '22時': '22:00', '23時': '23:00', '24時': '24:00',
  '日数': 'Days', '7日': '7 days', '月〜金': 'Mon–Fri', '1日の分割': 'Day split', '30分の点線': '30-min dotted', '夜をうすく': 'Dim night', '子どもの記録': 'Kids notes', 'お昼の 帯': 'Noon band', '12時・18時の 線': '12:00 & 18:00 lines', '太く': 'Bold', '上の メモ欄': 'Top memo', '下の メモ欄': 'Bottom memo', 'チェックの □': 'Check boxes', '4つ': '4', '時間の 分け方': 'Time division', '1時間ごと': 'Hourly', '方眼を しく': 'Grid background', '土日の 大きさ': 'Weekend size', '平日と 同じ': 'Same as weekdays', '小さく': 'Smaller',
  '左右のわりあい': 'Left / right ratio', '右なし（7日いっぱい）': 'No right (7 days full)', 'もうひとつの欄': 'Second column', '横の時間': 'Horizontal time', 'その欄の場所': 'Column position', '右': 'Right', '左': 'Left', '行の線': 'Row lines', '0本': 'None', '時間の 目やすの 点': 'Time guide dots', '行の 分け方': 'Row split', '上下2段': '2 rows', '左右3分割': '3 columns', '逆N字（3本）': 'Reverse N (3 lines)', 'もうひとつの欄を 7段に': 'Second column in 7 rows', '7段に 分ける': 'Split in 7', '右はしに 当月の 日づけ': 'Month dates at right edge',
  '日曜の 場所': 'Sunday position', '左に ならべる': 'In the left list', '右がわの 下（変則レフト）': 'Bottom right (variant)', '小さく（平日 重視）': 'Smaller (weekday focus)', '曜日の 書き方': 'Weekday style', '英語だけ': 'English only', '英語＋漢字': 'English + kanji', '土日・祝日の 色': 'Weekend / holiday color', 'わけ方': 'Split', '4日＋3日': '4 + 3 days', '3日＋4日': '3 + 4 days', 'メモ欄': 'Memo', 'おわり（下）': 'End (bottom)', 'はじめ（上）': 'Start (top)',
  '日付の となりの 十字': 'Cross by the date', '横の 時間めもり': 'Horizontal time scale', '8〜22時': '8–22', '右はしの たてメモ': 'Vertical memo at right', '2列': '2 columns', '下の メモ': 'Bottom memo', 'トピックつき': 'With topics', '方眼メモ 大': 'Large grid memo', '予定と実際': 'Plan & actual', 'やること□': 'To-do □', '3か月カレンダー': '3-month calendar', 'メモの場所': 'Memo position', '右 1/4': 'Right 1/4', '左 1/4': 'Left 1/4',
  'その日の トピック': 'Day topic', '上に 入れる': 'At top', 'やったことの らん': 'Done row', '下に 入れる': 'At bottom', 'やることの □': 'To-do boxes', '5つ': '5', 'カレンダーの 数': 'Calendars', '当月だけ': 'This month only', '当月＋翌月': 'This + next month', '3か月': '3 months', '時間めもり': 'Time scale', '上下に時間': 'Time top & bottom', '時間の点': 'Time dots', 'まん中に線': 'Center line', '今週の目標': 'Weekly goals', 'シンプル': 'Simple', '下にメモ': 'Bottom memo', '日づけが外': 'Dates outside', '右にメモ': 'Right memo',
  'メモの列': 'Memo column', '上下のあいだ': 'Gap between', '横の 時間': 'Horizontal time', 'ぜんぶの行（8〜20時）': 'All rows (8–20)', '上と下の行（9〜18時）': 'Top & bottom rows (9–18)', 'まん中の たて線': 'Center vertical line', '今週の目標の らん': 'Weekly goals row', '暦（六曜など）': 'Calendar marks (rokuyo etc.)', '日付と曜日だけ': 'Date & weekday only', '2週めの 日づけ': '2nd-week dates', '左に そろえる': 'Align left', '右はしに（外がわ）': 'Right edge (outside)',
  '穴': ' holes', 'L判たて': 'L portrait', 'L判よこ': 'L landscape', 'レターたて': 'Letter portrait', 'レターよこ': 'Letter landscape',   // ★v0.2.169〜174 サイズの ボタン（'サイズ': 'Size' は 前から 辞書に ある）
  '週間バーティカル': 'Weekly Vertical', '週間セパレート': 'Weekly Separate', '月間式': 'Monthly', 'なし': 'None', '☰ メニュー': '☰ Menu', '印刷': 'Print',
};
Object.assign(UI_EN, { 'A4の紙のまん中に刷られるので、切ってつかってね。': 'It is printed centered on A4 paper, so trim it to size.', '{paper}の紙に原寸で刷れます。{days}日間（{date}まで）。': 'Prints at actual size on {paper} paper for {days} days (until {date}).', 'あと {m}分で 印刷できます': 'Available again in {m} min', 'おきにいりに 保存': 'Save to favorites', 'お店にログインするとつかえます。ログインのページへうつります': 'Sign in to use this. Taking you to the sign-in page', 'お店にログインすると刷れます（1日3回・サブスク会員は100回）': 'Sign in to print (3 a day, 100 for subscribers)', 'きょう あと：{h}回（1日 {l}回まで）': 'Left today: {h} (up to {l} a day)', 'きょう あと：家 {h}回・コンビニ {n}回（1日 {l}回まで）': 'Left today: home {h}, store {n} (up to {l} a day)', 'きょうの分はおわりました。あしたまた刷れます': 'That is all for today. You can print again tomorrow', 'このサイズは 印刷・ダウンロード専用です。家で 印刷するか、会員は PDF を ダウンロードできます（買うことは できません）': 'This size is print / download only. Print at home, or download a PDF if you are a member (it cannot be purchased).', 'この大きさの紙は、コンビニ印刷（ねっぷり）に対応していません（B5・A4だけ）。家で印刷してね': 'This paper size is not supported by convenience-store printing (B5 and A4 only). Please print at home', 'この紙は{base}の紙のまん中に原寸で刷られます。切ってつかってね': 'This sheet prints at actual size centered on {base} paper. Trim it to size', 'たしかめています…': 'Checking…', 'ねっぷりで変換できませんでした。もう一度送ってみてね': 'Network Print could not convert the file. Please send it again', 'ねっぷりに送っています…': 'Sending to Network Print…', 'まだ用意中です（{s}）。少し待ってもう一度おしてね': 'Still preparing ({s}). Wait a little and try again', 'コンビニで刷る（ネットワークプリント）': 'Print at a convenience store (Network Print, Japan)', 'コンビニで印刷': 'Print at a store', 'コンビニで暗証番号も入れます。': 'You will also enter the PIN at the store.', 'コンビニのマルチコピー機で「ネットワークプリント」をえらび、ユーザー番号を入れてね（QRでも入れられます）。送ったあと数分で刷れるようになります': 'On the multicopy machine choose "Network Print" and enter the user number (or scan the QR). It becomes printable a few minutes after sending', 'コンビニ用の番号をもらう': 'Get a user number', 'サブスク会員は1日100回': 'Subscribers get 100 a day', 'ユーザー番号': 'User number', 'ログインする': 'Sign in', 'ログインすると 保存できます': 'Sign in to save', '保存': 'Save', '刷れます。コンビニへどうぞ': 'Ready. Go to the store', '刷れるようになったか たしかめる': 'Check if it is ready', '印刷の窓を出した時点で1回に数えます': 'Opening the print dialog counts as one', '家で印刷': 'Print at home', '暗証番号（なくてもよい・半角）': 'PIN (optional, ASCII)', '番号をもらえませんでした。もう一度おためしください': 'Could not get a number. Please try again', '（ためし用のねっぷりです。ファミリーマート・ローソンで刷れます）': '(Test Network Print: prints at FamilyMart and Lawson)' });   // ★2026-10-15 ねっぷり・印刷の えらびの 英語（手帳と おなじ）
Object.assign(UI_EN, {   // ★nv0.2.145 ノートの 画面の 英語（辞書に なかった もの）。日本語の 文字列は 1字も かえず、ここに 足しただけ
  "ノートトップ": "Notebook top",
  "柄を えらぶ": "Choose a design",
  "星": "Stars",
  "大容量": "Large capacity",
  "内容の確認": "Review your order",
  "内容を": "Review",
  "確認する": "your order",
  "星（左上）": "Stars (top left)",
  "チェック（右上）": "Checklist (top right)",
  "印刷に\n登録": "Save to\nPrint",
  "保存中…": "Saving…",
  "✓ 登録\nしました": "✓ Saved",
  "登録\nできません": "Could not\nsave",
  "ログイン\nして ね": "Log in\nfirst",
  "えにっきbook（LINE）の 絵を 入れます": "Add pictures from Enikki Book (LINE)",
  "紙の左上に入るよ": "Printed at the top left",
  "紙の右上に入るよ": "Printed at the top right",
  "0〜5個。手でぬって使ってね": "0 to 5. Color them in by hand",
  "1行め": "Line 1",
  "2行め": "Line 2",
  "3行め": "Line 3",
  "□もふくめて1行6文字まで。□を消せば、チェック以外にも使えるよ": "Up to 6 characters per line, including the □. Delete the □ and you can use it for more than checklists",
  "1行は □もふくめて 6文字までです": "Each line can have up to 6 characters, including the □",
  "右上の1行め": "Top right, line 1",
  "右上の2行め": "Top right, line 2",
  "右上の3行め": "Top right, line 3",
  "先頭の□をつける・はずす": "Add or remove the leading □",
  "星をへらす": "Fewer stars",
  "星をふやす": "More stars",
  "ルーズリーフ70枚": "70 loose-leaf sheets",
  "＋マルマンのバインダー1つ＋ルーズリーフ150枚": "+ 1 Maruman binder + 150 loose-leaf sheets",
  "大容量は マルマンの バインダー1つ＋ルーズリーフ150枚が つきます": "Large capacity comes with 1 Maruman binder and 150 loose-leaf sheets",
  "ノートのみ": "Notebook refill only",
  "黒・ノートのリフィルつき": "Black, notebook refills included",
  "クロッキー・ノートのリフィルつき": "Croquis paper and notebook refills included",
  "紙の 上の 赤い 丸が 変えた ところです。うすい 字が まえの えらび、赤い 字が いまの えらびです": "Red circles on the paper mark what you changed. Light text is your earlier choice; red text is your current choice",
  "変えた ところ": "Changes",
  "なかま": "Category",
  "オーダー": "Custom",
  "□たいせつ・□みかえす・□おしまい": "□Important · □Recheck · □Done",
  "□たいせつ/□みかえす/□おしまい": "□Important / □Recheck / □Done",
  "ボタンを押すと、紙がすぐにかわるよ。上の「形を変える」を押すと、このパネルがまたひらくよ": "Tap a button and the paper changes right away. Tap \"Adjust shape\" above to reopen this panel",
  "紙のわけ方": "Divide the paper",
  "分ける位置": "Divider position",
  "線の種類": "Line type",
  "線の間隔": "Line spacing",
  "線の 間隔": "Line spacing",
  "線の太さ": "Line weight",
  "線の形": "Line style",
  "太くする線": "Bold lines",
  "直す 面": "Area to edit",
  "1面": "Whole page",
  "上下": "Top / bottom",
  "左右": "Left / right",
  "上＋下2列": "Top + 2 below",
  "上2列＋下": "2 above + bottom",
  "3段": "3 rows",
  "3列": "3 columns",
  "左メモ＋右2段": "Left memo + 2 rows right",
  "ぜんぶ": "Whole page",
  "左上": "Top left",
  "まん中": "Middle",
  "タイトル": "Title",
  "いまの柄": "Current design",
  "10本": "Every 10th",
  "前のページ": "Previous page",
  "つぎのページ": "Next page",
  "ページ": "Page",
  "とじる": "Close",
  "色コード": "Color code",
  "大きく": "Larger",
  "せまく": "Narrower",
  "ひろく": "Wider",
  "左へ": "Left",
  "右へ": "Right",
  "このページのURL": "URL of this page",
  "いま 見ている 1まいだけ 刷ります": "Prints only the sheet you are viewing",
  "ファミマ・ローソンなどの マルチコピー機で 刷れます。番号を もらって コンビニで 入れるだけ（印刷代は コンビニで）": "Print at the multicopy machines in FamilyMart, Lawson and other Japanese convenience stores. Just get a number and enter it at the store (pay for printing there)",
  "暗証番号（かえる ときだけ・半角。ふつうは 作った 日の 月日 4けた）": "PIN (only if you want to change it; digits only. Normally the month and day you made it, 4 digits)",
  "プラス会員（月380円）は印刷し放題": "Plus members (¥380/month) can print as much as they like",
  "いまの 形を お店の おきにいりに 入れます（マイページ → おきにいり → 手帳デザイン から いつでも ひらけます）": "Adds this design to your favorites. Open it anytime from My account → Favorites → Planner designs",
  "紙の左下に、印刷とわかる小さなマークが入るよ": "A small mark showing it is a printout goes at the bottom left",
  "PDFでダウンロード（会員）": "Download as PDF (members)",
  "ぜんぶの紙を、1つのPDFにするよ。印刷（この1枚）は今までどおり無料です": "Puts every sheet into one PDF. Printing this one sheet stays free",
  "えらんだ形のぜんぶの紙を、1つのPDFにします。拡大してもきれいな線なので、おうちやコンビニで原寸に刷れます。印刷（この1枚だけ）は今までどおり無料です": "Puts every sheet of your chosen design into one PDF. The lines stay sharp when zoomed, so you can print at actual size at home or at a store. Printing just this one sheet stays free",
  "PDFをつくる": "Make PDF",
  "用意しています…": "Getting ready…",
  "つくっています… {n} / {all} まい": "Making… {n} / {all} sheets",
  "できました。ダウンロードを見てね": "Done! Check your downloads",
  "PDFをつくれませんでした。もう一度おためしください": "Could not make the PDF. Please try again",
  "PDFは「プラス会員」（月380円）になるとつかえます（準備中）": "PDF is for Plus members (¥380/month) (coming soon)",
  "まとめて 印刷は プラス会員（月380円）の 特典です": "Printing many sheets at once is a Plus membership perk (¥380/month)",
  "ページを えらんで 印刷するには ログインが いります": "Log in to choose pages to print",
  "この アプリの 画面では 印刷できません。Safari か Chrome で ひらいて ください。": "You cannot print inside this app. Please open the page in Safari or Chrome.",
  "きょうの ログインなしの 印刷は 3回まで です。ログインすると 1日 3回・保存・マイ手帳に のこせます。": "Without logging in you can print up to 3 times today. Log in to print 3 times a day and save your designs.",
  "きょうの 分は おわりました": "That is all for today",
  "印刷できませんでした": "Could not print",
  "印刷できませんでした（つながりません）": "Could not print (no connection)",
  "ねっぷり印刷は ログインが いります": "Log in to use Network Print",
  "この 紙は ねっぷりで 刷れません（B5・A4 だけ）": "This paper cannot be printed with Network Print (B5 and A4 only)",
  "まとめての ねっぷりは プラス会員（月380円）の 特典です": "Printing many sheets with Network Print is a Plus membership perk (¥380/month)",
  "ページが おおくて 大きすぎます（10MBまで）。ページの はんいを 分けて ください": "Too many pages (10 MB limit). Please split the page range",
  "QRに入りきりません": "Does not fit in the QR code",
  "消しゴム": "Eraser",
  "戻る": "Undo",
  "画像消し": "Erase image",
  "全消し": "Clear all",
  "ペン": "Pen",
  "スタンプ": "Stamp",
  "写真": "Photo",
  "スクロール": "Scroll",
  "書": "Calligraphy",
  "筆": "Brush",
  "掠れ": "Dry brush",
  "マイスタンプ": "My Stamps",
  "スタンプを": "Make a",
  "作成する": "stamp",
  "スタンプを 作成する": "Make a stamp",
  "マイスタンプが まだ ありません": "No stamps yet",
  "（えにっきで「スタンプに保存」すると ここに 出ます）": "(Save a stamp in Enikki and it will show up here)",
  "えらぶ": "Choose",
  "白ぬき": "Remove white",
  "消す": "Remove",
  "指で 上下に スクロールできます（もう一度 おすと 書けます）": "Scroll up and down with your finger (tap again to write)",
  "保存しました（この ブラウザの 中だけ。ログインすると どこでも 見られます）": "Saved (in this browser only. Log in to see it anywhere)",
  "保存できませんでした": "Could not save",
  "保存できませんでした（あとで もう一度）": "Could not save (please try again later)",
  "保存できませんでした（つながりません）": "Could not save (no connection)",
  "保存しました": "Saved",
  "読みこめませんでした。ページを 読みこみなおして ください": "Could not load. Please reload the page",
  "おきました。つぎも おく ときは「アイコン」から もう一度 えらんで ください（おいた ものは ドラッグで うごかせます）": "Placed. To place another, choose from \"Icon\" again (drag to move what you placed)",
  "おく アイコンを えらんで ください（「アイコン」ボタン）": "Choose an icon to place (the \"Icon\" button)",
  "おきました。つぎも おく ときは「スタンプ」から もう一度 えらんで ください（おいた 絵は ドラッグで うごかせます）": "Placed. To place another, choose from \"Stamp\" again (drag to move what you placed)",
  "おく スタンプを えらんで ください（「スタンプ」ボタン）": "Choose a stamp to place (the \"Stamp\" button)",
  "このページは いっぱいです": "This page is full",
  "🎲 なぞると 回る／🎈 紐を 持つと 動かせる／ダブルタップで 正面": "🎲 Drag to rotate / 🎈 Hold the string to move / Double-tap to face front",
  "ログインすると 写真を おけます": "Log in to place photos",
  "写真を よみこんで います…": "Loading photo…",
  "保存して います…": "Saving…",
  "写真を 保存できませんでした": "Could not save the photo",
  "おきました（ドラッグで 動かす・ホイール／2本指で 大きさ）": "Placed (drag to move; wheel or two fingers to resize)",
  "写真を よみこめませんでした": "Could not load the photo",
  "🎲 ボールを なぞると 紙が 回ります（このあいだは 書けません）／もう一度 まわす で もどります": "🎲 Drag the ball to spin the paper (you cannot write meanwhile) / tap Rotate again to go back",
  "このページの 書きこみを ぜんぶ 消しますか？": "Erase everything written on this page?",
  "写真・絵の 消したい ところを なぞると 透明に なります（線は そのまま）": "Trace the parts of the photo or picture you want to erase to make them transparent (your lines stay)",
  "紙を タップすると おけます": "Tap the paper to place it",
  "紙を タップすると おけます（おいた 絵は ドラッグで 動かせます）": "Tap the paper to place it (drag to move what you placed)",
  "白ぬき：つぎに えらぶ 写真の 白い ところが 透明に なります": "Remove white: white areas of the next photo you choose become transparent",
  "白ぬき：なし": "Remove white: off",
  "はじめの ままです": "Still the default",
  "前": "Front",
  "後": "Back",
  "病院": "Hospital",
  "美容院": "Salon",
  "食事": "Meal",
  "学校": "School",
  "歯": "Teeth",
  "お財布": "Wallet",
  "家": "Home",
  "手紙": "Letter",
  "時間": "Time",
  "予定": "Plan",
  "吹き出し": "Speech bubble",
  "カフェ": "Café",
});

const TEXTS_JA = {
  /* ★2026-10-15 ねっぷり・印刷の えらび（手帳 v0.2.202〜241 の 言葉） */
  npTitle: 'コンビニで刷る（ネットワークプリント）',
  npNote: 'ファミマ・ローソンなどの マルチコピー機で 刷れます。番号を もらって コンビニで 入れるだけ（印刷代は コンビニで）',   // ★v0.2.225 短く
  npPw: '暗証番号（かえる ときだけ・半角。ふつうは 作った 日の 月日 4けた）',
  npGo: 'コンビニ用の番号をもらう',
  npSending: 'ねっぷりに送っています…',
  npError: '番号をもらえませんでした。もう一度おためしください',
  npLogin: 'お店にログインするとつかえます。ログインのページへうつります',
  npResultTitle: 'ユーザー番号',
  npInfo: '{paper}の紙に原寸で刷れます。{days}日間（{date}まで）。',
  npCentered: 'A4の紙のまん中に刷られるので、切ってつかってね。',
  npPwNote: 'コンビニで暗証番号も入れます。',
  npTest: '（ためし用のねっぷりです。ファミリーマート・ローソンで刷れます）',
  npHow: 'コンビニのマルチコピー機で「ネットワークプリント」をえらび、ユーザー番号を入れてね（QRでも入れられます）。送ったあと数分で刷れるようになります',
  npCheck: '刷れるようになったか たしかめる',
  npChecking: 'たしかめています…',
  npReady: '刷れます。コンビニへどうぞ',
  npNotYet: 'まだ用意中です（{s}）。少し待ってもう一度おしてね',
  npFailed: 'ねっぷりで変換できませんでした。もう一度送ってみてね',
  prOne: 'いま 見ている 1まいだけ 刷ります',   // ★v0.2.225 短く
  prBuy: '購入に進む',   // ★nv0.2.147
  prHome: '家で印刷',
  prNp: 'コンビニで印刷',
  prOnlyNote: 'このサイズは 印刷・ダウンロード専用です。家で 印刷するか、会員は PDF を ダウンロードできます（買うことは できません）',   // ★v0.2.214
  prNpNo: 'この大きさの紙は、コンビニ印刷（ねっぷり）に対応していません（B5・A4だけ）。家で印刷してね',   // ★v0.2.210
  prCentered: 'この紙は{base}の紙のまん中に原寸で刷られます。切ってつかってね',
  prQuota: 'きょう あと：家 {h}回・コンビニ {n}回（1日 {l}回まで）',
  prQuotaHome: 'きょう あと：{h}回（1日 {l}回まで）',   // ★v0.2.210 ねっぷりに 対応しない 紙
  prQuotaMember: 'プラス会員（月380円）は印刷し放題',
  prQuotaOff: 'きょうの分はおわりました。あしたまた刷れます',
  prLogin: 'お店にログインすると刷れます（1日3回・サブスク会員は100回）',
  prCounted: '印刷の窓を出した時点で1回に数えます',
  prSave: '保存', prSaveGo: 'おきにいりに 保存', prSaveNote: 'いまの 形を お店の おきにいりに 入れます（マイページ → おきにいり → 手帳デザイン から いつでも ひらけます）', prSaveLogin: 'ログインすると 保存できます', prSaveLoginBtn: 'ログインする',   // ★v0.2.233／★v0.2.242「オーダー」→「手帳デザイン」
  prCool: 'あと {m}分で 印刷できます',
  summaryTitle: 'ご注文内容',
  toolColor: '色',
  toolName: '名入れ',
  toolPrint: '印刷',
  all: 'すべて',
  cardColor: '色をえらぶ',
  inkNames: ['線', '文字'],   // ★nv0.2.17 土日は 廃止
  inkRows: ['線の色', '文字の色'],   // ★nv0.2.17 土日は 廃止
  inkSame: '線と同じにする',
  inkSameNow: '線と同じ',
  palBase: '定番の色',
  palMore: 'いろいろな色',
  palFine: '細かく決める',
  palHue: '色あい',
  palSat: 'あざやかさ',
  palLight: '明るさ',
  palNative: 'パソコンの色えらび',
  palClose: 'とじる',
  cardName: '名入れをする',
  nameLabel: 'お名前',
  nameNote: '20文字まで・絵文字は使えないよ',
  enikkiOrder: ['いれる', 'いれない'],   // ★nv0.2.35 注文に のこす えにっきの ことば
  whereTitle: '入る場所',
  where_br: '紙の右下に入るよ',
  cardPrint: '印刷して確認する',
  cardCustom: '線をつくる（オーダーメイド）',
  customName: 'オーダーメイド',
  cmNote: 'ボタンを押すと、紙がすぐにかわるよ。上の「オーダーメイド」を押すと、このパネルがまたひらくよ',
  customRow: 'オーダーメイド',
  prSheetLabel: '刷る紙',   // ★nv0.2.171
  prSheetOwn: 'このサイズ',
  prSheetA4: 'A4（切って使う）',
  prSheetLetter: 'レター（切って使う）',
  prSheetHint: '{p}を まん中に 原寸で 刷るよ。かどの 印で 切ってね',   // ★nv0.2.180 みなとさん「文章も短く」
  printLine1: 'B5の紙・倍率100%で印刷してね',
  printLine2: '色は、おうちのプリンターで少しちがうよ',
  printLine3: '紙の左下に、印刷のマークが入るよ',   // ★2026-10-15 QR は やめた（手帳と おなじ）
  printQrTitle: '紙に入るQRコード',
  printQrNote: 'スマホで読みとると、いまの内容でこのページがひらくよ。印刷の前にためせます',
  printGo: '印刷する',
  printAppTitle: '楽天市場アプリの中では印刷できません',
  printAppText: 'Safari や Chrome などのブラウザで、このページを開いてから印刷してね。下のボタンでURLをコピーして、ブラウザのアドレス欄に貼りつけると、いまえらんでいる内容のままひらくよ。',
  printCopy: 'URLをコピーする',
  printCopied: 'コピーしました。ブラウザのアドレス欄に貼りつけてね',
  printCopyFail: 'コピーできませんでした。上のURLを長押ししてコピーしてね',
  zoomHint: 'ダブルタップで 小さく／もとの大きさ',
  /* ★nv0.2.2 ノートの 言葉（古い ノート v0.1.71 から そのまま） */
  toolStars: '星', toolTodo: 'チェック', toolOption: '大容量',
  /* ★nv0.2.25 入る場所の 言葉 */
  whereTitle: '入る場所', where_tl: '紙の左上に入るよ', where_tr: '紙の右上に入るよ', where_br: '紙の右下に入るよ',
  /* ★nv0.2.10 形を変える（オーダーメイド）の 言葉。古い ノート v0.1.71 から */
  customName: 'オーダーメイド',
  cmLayout: '紙のわけ方', cmRatio: '分ける位置', cmType: '線の種類', cmSpace: '線の間隔',
  cmWeight: '線の太さ', cmStyle: '線の形', cmEmph: '太くする線',
  cmNote: 'ボタンを押すと、紙がすぐにかわるよ。上の「形を変える」を押すと、このパネルがまたひらくよ',
  starsNote: '0〜5個。手でぬって使ってね', starsUnit: '個',
  todoNote: '1行 6文字まで。空に すると その 行は 出ません',   // ★nv0.2.174 □ は やめた
  optionNote: '大容量は マルマンの バインダー1つ＋ルーズリーフ150枚が つきます',
  boxFull: '1行は □もふくめて 6文字までです',
  colorPrintNote: '印刷すると色をたしかめられるよ。プリンターがちがうので、とどく手帳とは色が少しちがいます。ひとつの目安としてお使いください',
  printError: '印刷の準備ができませんでした。もう一度おためしください。',
  /* ★v0.2.180 PDF（会員・月480円）。文は ここだけで 直す（画面に 直書きしない） */
  pdfTitle: 'PDFでダウンロード（会員）',
  pdfNote: 'ぜんぶの紙を、1つのPDFにするよ。印刷（この1枚）は今までどおり無料です',
  pdfGo: 'PDFをつくる',
  pdfLoading: '用意しています…',
  pdfMaking: 'つくっています… {n} / {all} まい',
  pdfDone: 'できました。ダウンロードを見てね',
  pdfError: 'PDFをつくれませんでした。もう一度おためしください',
  pdfMember: 'PDFは「プラス会員」（月380円）になるとつかえます（準備中）',
  cartWhat: (name, n) => `${name} B5ルーズリーフ ${n}枚`,   // ★ノートも 同じ 言い方
  goConfirm: 'B5ルーズリーフ 内容確定に進む',
  // 下の ボタンの 小さな文字（v0.2.78）：年間カレンダー2年：月間式2年：書籍用紙：レザーバインダー
  paperShort: { book: '書籍用紙', fp: '万年筆専用用紙', mp: 'シャープペン専用用紙' },
  binderShort: { none: 'バインダーなし', bb: 'バースブックバインダー', leather: 'レザーバインダー', maruman: 'マルマン バインダー' },
  cart: 'カゴに入れる',
  cartWaitName: 'バースブック手帳B5',
  cartWait: '準備中',
  cartNotReady: 'ただいま準備中です。もうしばらくお待ちください。',
  cartFail: 'カゴに入れられませんでした。少し時間をおいて、もう一度おためしください。',
  photoKari: '仮の写真',
  coverTitle: 'BirthBookNote',
  toolPaper: '紙',
  cardPaper: '紙をえらぶ',
  paperNote: 'どの紙も B5・26穴。書きごこちだけがちがうよ',
  paperRow: '紙',
  summaryRow: 'ご注文内容',
  toolBinder: 'バインダー',
  cardBinder: 'バインダーをえらぶ',
  binderNote: 'どれも、えらんだ手帳のリフィルつき',
  priceKari: '仮',
  soon: '準備中',
  toolYear: 'はじまり月',
  cardYear: 'はじまり月・背景',
  toolView: '表示',
  toolTune: '形を変える',
  cmBack: 'もとの形に もどす',
  evJpTitle: '日本の行事',
  evJpNote: '日にちが決まる行事を、その日に小さく入れるよ。七草・節分・ひなまつり・花まつり・八十八夜・母の日・父の日・入梅・半夏生・七夕・土用の入り・お盆・二百十日・十五夜・十三夜・ハロウィン・七五三・クリスマス・大晦日 など（節分・彼岸入り・八十八夜・入梅・半夏生・土用の入り・二百十日 は国立天文台と同じ計算）。年間の形・ガントチャートには入らない',
  eventRow: 'ぎょうじ',
  eventNames: ['日本の行事', '先生行事', '保育園行事'],
  evSchoolTitle: '先生行事',
  evNurseryTitle: '保育園行事',
  evPlanNote: '先生行事・保育園行事は、学校や園ごとに日がちがうので、日付には入れないよ。その月の「おもな行事」の一覧と、日にちを書く（ / ）を、月間式は表の下、週の形は右下のカレンダーのとなりに入れる（週の形は右下のカレンダーが1つになる）。年間の形には入らない',
  sizeTitle: '文字の大きさ',
  posYTitle: '文字の位置（上下）',
  posXTitle: '文字の位置（左右）',
  posY: ['上へ1', '上へ.5', '±0', '下へ.5', '下へ1'],
  posX: ['左へ1', '左へ.5', '±0', '右へ.5', '右へ1'],
  sizeNote: '手帳の中の文字が ぜんぶ いっしょに かわるよ（位置の数は mm）。上の月の数字など 大きな見出しの大きさは かわらない。大きくすると となりの文字と かさなることがあるので、紙の見本で たしかめてね',
  sizeRow: 'サイズ',
  bgSecTitle: '背景（線の下にしく柄）',
  bgTypeTitle: '柄',
  bgTypes: ['無地', 'ドット', '方眼', '罫線', '十字'],
  bgGapTitle: '間隔',
  bgDensTitle: 'こさ（線の色をうすくする）',
  bgDensNames: ['1/10', '1/5', '1/3', '1/2', '同じ'],
  bgNote: '手帳のわくの中の、線の下にしくよ。見出しや紙のまわりにはしかない。印刷にも出る。無地のときは なにもしかない',
  bgRow: '背景',
  cardView: '表示（こよみ・ぎょうじ・文字）',
  sizeSecTitle: '文字の大きさと位置',
  koyoSecTitle: 'こよみ',
  evSecTitle: 'ぎょうじ（行事を入れる）',
  yearTitle: 'はじまりの年と月をえらぶ',
  monthUnit: '月',
  yearNote: 'えらんだ月の1日から2年分（24か月）。年間の表は1年で1まい、2まい',
  weekStartTitle: '週のはじまり',
  weekStarts: ['月曜', '日曜'],
  holidayTitle: '祝日',
  holidayOpts: ['入れる', '入れない'],
  rokuyoTitle: '六曜',
  moonTitle: '月齢',
  sekkiTitle: '二十四節気',
  kyurekiTitle: '旧暦',
  calTitle: 'カレンダー',
  markTitle: '日付の丸',
  markSatTitle: '土曜の丸',
  markSunTitle: '日曜の丸',
  markHolTitle: '祝日の丸',
  markOpts: ['つける', 'つけない'],
  clockTitle: 'マスの中の 時計',
  clockNote: 'マスの すみに 12時間の 文字ばんが 入るよ。ねた時間や はたらいた時間を 色で ぬれる。月間式のときだけ えらべる',
  markRow: '日付の丸',
  markNames: ['土曜', '日曜', '祝日'],
  calOpts: ['出す', '出さない'],
  // えにっきbook の 絵（本店だけ）
  enikkiTitle: 'えにっきbook の 絵',
  enikkiAbout: 'えにっきbook（LINE）で 入れた 絵を、月間式の 日の マスに 出します。LINE で ログインすると 見られます（印刷にも 出ます）',
  enikkiLogin: 'LINE で 見る',
  enikkiLoading: 'えにっきbook の 絵を 読みこんでいます…',
  enikkiErr: 'えにっきbook の 絵を 読みこめませんでした',
  enikkiRetry: 'もう一度 読みこむ',
  enikkiShowTitle: '絵',
  enikkiModes: ['出さない', '新しい絵', '古い絵'],   // 新しい絵＝その日 いちばん あとに 入れた 1まい
  enikkiNone: 'この 期間に えにっきbook の 絵が ありません（動画は 出しません）',
  enikkiCount: n => `${n}日ぶんの 絵が あります（月間式の 紙に 出ます）`,
  enikkiTapNote: '1日に 絵が 2まい 以上 ある日は、マスの 絵を おすと つぎの 絵に かわります',
  enikkiLogout: 'LINE から はずす',
  // ★v0.2.118 お店に ログインしている人は LINE なしでも 見られる
  enikkiViaShop: 'お店の アカウントで 見ています（LINE の ログインは いりません）',
  // ★v0.2.119 一度 つないだ人は、つぎから ログインだけで 見られる
  enikkiLinked: 'このアカウントは えにっきbook と つながっています。つぎからも ログインするだけで 絵が 出ます',
  enikkiLinkHint: '「LINE で 見る」で 一度 入ると、このアカウントと つながります。つぎからは ログインするだけで 絵が 出ます',
  // ★v0.2.123 いまの 形を おきにいりに（お店に ログインしている ときだけ）
  favSave: '⭐ この形を おきにいりに 入れる',
  favSaving: 'おきにいりに 入れています…',
  favDone: 'おきにいりに 入れました。マイページの「おきにいり → オーダー」から、この形の まま ひらけます',
  favOff: 'おきにいりから はずしました',
  favErr: 'おきにいりに 入れられませんでした（ログインを たしかめてください）',
  // ★v0.2.124 スタンプ
  stampTitle: 'スタンプを 貼る',
  stampHint: 'えらんでから 紙を 押すと そこに 貼れます。貼った ものを 押すと 大きく なり、さいごに 消えます',
  /* ★v0.2.181 みなとさん「お気に入りスタンプ の 言い方を **マイスタンプ** に 全て 変更です」 */
  stampNone: 'マイスタンプが ありません（えにっきの 絵を「🔖 マイスタンプに 入れる」で ふやせます）',
  stampOff: '貼るのを やめる',
  stampLoading: 'スタンプを さがしています…',
  // ★v0.2.127 公開・みんなの スタンプ
  stampMine: 'じぶんの', stampAll: 'みんなの',
  stampPub: '公開する', stampUnpub: '公開を やめる',
  stampPubAsk: 'この 絵を 公開すると、世界中の 人が 見られて、自分の 手帳に 貼れるように なります。名前や 日づけは 出ません。公開しますか？',
  stampPubOn: '公開しました（やめたいときは いつでも やめられます）',
  stampPubOff: '公開を やめました',
  stampCopy: 'もらう', stampCopied: 'マイスタンプに 入りました',   // ★v0.2.181
  stampCopyErr: 'もらえませんでした',
  stampReport: '通報', stampReportAsk: 'この スタンプを 通報しますか？（3人から 通報されると 一覧から 消えます）', stampReported: '通報しました',
  stampAllNone: 'まだ 公開されている スタンプが ありません',
  // ★v0.2.130 NIKE 風の 画面
  nkTitle: 'カスタマイズ', nkNow: 'いま 直している ところ', nkNext: '確定して つぎへ', nkFin: '完了', nkBack: 'もどる',
  nkPrint: '🖨 印刷（見ている 1まい）',
  checkNote: '紙の 上の 赤い 丸が 変えた ところです。うすい 字が まえの えらび、赤い 字が いまの えらびです',   // ★2026-10-15
  mainBtn: '印刷に\n登録',   // ★2026-10-18 みなとさん「メインに登録→印刷に登録」（手帳・ノート とも）
   mainSaving: '保存中…', mainDone: '✓ 登録\nしました', mainErr: '登録\nできません', mainLogin: 'ログイン\nして ね',   // ★2026-10-15 みなとさん「メイン／に登録」（2行）   // ★2026-10-15 ［メイン］＝いまの 状態を トップページに 保存
  nkShare: '⇪ 共有（この形の アドレス）', nkCopied: 'アドレスを コピーしました', nkMenuTitle: 'メニュー',
  nkOrderNote: '紙は ご注文内容の ページです。赤い ボタンで カゴへ 進みます', nkChanged: '変えている',
  nkEnikkiModes: ['あり', 'なし'], nkEnikkiNote: 'えにっきbook（LINE）の 絵を 入れます',   // ★nv0.2.96 短く（手帳と そろえる）
  /* ★nv0.2.8 お店（Shopify）の 手順を **ノートの もの**に（みなとさん 2026-10-03）
     ------------------------------------------------------------
     手帳は 12の 手順（国・年間・月間か週間・はじまり月・表示・形を変える…）でした。
     ノートには 暦が ない ので「年間」「はじまり月」「表示」「えにっき」は いりません。
     かわりに ノートの 売りの「星」「チェック」「大容量」を 入れます。
     ★'sheet' は「柄を えらぶ」に なります（なかま＋見本が 出る 手順）。 */
  /* ★nv0.2.9 みなとさん（2026-10-03）の 指示どおり：
       月間 → なし／はじまり月 → なし／表示 → なし（ノートなので）
       **形を変える → のこす**（同じように 形を 変えられる ように）
       色・名入れ・**えにっき** → のこす／紙・バインダー → のこす
     ＋ノートの 売り（星・チェック・大容量）を 足して 12の 手順。 */
  nkSteps: [['country', '使う 国'], ['size', '紙の 大きさ'], ['sheet', '柄'], ['custom', '線の ならび'], ['color', '線の 色'], ['name', '名前（右下）'], ['enikki', 'えにっきの 絵'], ['stars', '☆ 左上'], ['todo', '右上の ことば'], ['paper', '紙の 種類'], ['binder', 'バインダー'], ['option', '150枚セット'], ['check', '確認'], ['order', '注文'], ['print', '印刷']].filter(([k]) => SHOP === 'shopify' || k !== 'enikki'),   // ★2026-10-15 13 印刷（手帳と おなじ。← → で 行き来）★nv0.2.189 楽天には えにっき（LINE）が ない ので 出さない（手帳と おなじ）
     // ★v0.2.139 12 注文確定（赤い ボタンの ページ）   // ★v0.2.133 名入れの あとに えにっき（いれる／いれない）
  nkCountries: ['日本', 'アメリカ', '中国', '韓国', 'ヨーロッパ'],
  nkCountrySoon: '日本 いがいは じゅんび中です（紙の 言葉・祝日が 国ごとに かわります）',
  enikkiNoneShop: 'お店の アカウントには えにっきの 絵が ありませんでした。えにっきbook で 描いた 絵を 出すなら「LINE で 見る」をおしてね',
  enikkiLoginAlso: 'LINE で 見る',
  markNote: '日付の丸を「つけない」にすると、丸はなくなって 色のちがう数字だけになるよ（土曜は土曜の色、日曜と祝日は日曜日の色）',
  holidayNote: '祝日は日曜と同じ ぬった丸。六曜は「大安」など、月齢は 新月●・満月○、二十四節気は「立春」など、旧暦は「8/15」（閏月は「閏11/3」）が、日付のそばに小さく入るよ。旧暦は、マスの小さい 年間スケジュール・ガントチャートには入らない。カレンダーは、紙の右下の小さなカレンダー',
  koyoRow: '暦',
  koyoNames: ['六曜', '月齢', '二十四節気', '旧暦'],
  calRow: 'カレンダー',
  weekStartRow: '週のはじまり',
  holidayRow: '祝日',
  sheetLabel: '手帳の紙',
  yearRow: '年間',
  navYear: '年間トップ',
  navYearShort: '年間 ',
  navSheet: 'ノートトップ',   // ★nv0.2.3
  navInfo: '注文方法',
  sheetRange: '手帳の紙をえらぶ',
  sheetOf: (i, n) => `${i}まいめ・${n}まい中`,
  fmtRow: '柄',   // ★nv0.2.13 ノートは「柄」（手帳は「手帳の形」）
  termRow: '期間', countryRow: '国',
  none: '（なし）',
};
// ★v0.2.164 TEXTS は 見る たびに 国で 切りかえる（英語の とき 辞書を 引く。関数の ものは 英語版を 別に）
const TEXTS = new Proxy(TEXTS_JA, { get(t, k) { const v = t[k]; if (LANG === 'ja') return v; if (typeof v === 'function') return (I18N[LANG].fn || {})[k] || v; return trDeep(v); } });

// ===== バインダー・値段 =====
//   ★値段は仮（2026-09-17）。決まったら PRICES の数字だけ直す
//   ★楽天で実際にはらう値段は、楽天に登録した商品の値段で決まる（ページからは変えられない）
/* ★nv0.2.13 ノートの 言い方に（手帳のみ → ノートのみ／手帳のリフィル → ノートのリフィル） */
const BINDERS = [
  { id: 'none', name: 'ノートのみ', sub: 'バインダーなし', pi: 'sheets' },
  { id: 'bb', name: 'バースブックバインダー', sub: '黒・ノートのリフィルつき', pi: 'binder' },
  { id: 'leather', name: 'レザーバインダー', sub: '黒・ノートのリフィルつき', pi: 'binder' },
  // ★マルマンは Shopify だけ（only）。楽天には 商品が ないので 出さない
  { id: 'maruman', name: 'マルマン バインダー', sub: 'クロッキー・ノートのリフィルつき', pi: 'binder', only: 'shopify' },
];
// いまの お店で えらべる バインダー（楽天では いままでどおり 3つ）
const BINDER_LIST = BINDERS.filter(b => !b.only || b.only === SHOP);
// 紙の種類（書きごこち。大きさ・穴は どれも同じ B5・26穴）
//   ★2026-09-18 みなとさんから3つ。3つめの ひとこと は まだ決まっていない
const PAPERS = [
  { id: 'book', name: '日本書籍用紙', sub: 'ボールペン専用', pi: 'penBall' },
  { id: 'fp', name: '万年筆専用用紙', sub: '裏移りしにくい', pi: 'penFp' },
  { id: 'mp', name: 'シャープペン専用用紙', sub: '', pi: 'penMp' },
];
// ★楽天の 値段（バインダー × 紙）。楽天の バリエーション（SKU）9つに 登録した 値段と そろえる（v0.2.69 みなとさん「この金額でいきます」）
//   ★楽天で ほんとうにはらう金額は、楽天に登録した SKU の値段で決まる。ここは 見せるための 数字。RMS で かえたら ここも 直す
//   ★Shopify は まだ 紙で 値段を かえていない（商品の バリエーションが 紙で 分かれていないため）→ PRICES の まま
const PRICE_TABLE = {
  none:    { book: 1580,  fp: 1980,  mp: 1580 },
  bb:      { book: 1980,  fp: 2380,  mp: 1980 },
  leather: { book: 12000, fp: 12000, mp: 12000 },
};
// ★楽天で 品切れの 紙（RMS の 在庫が 0）。えらべないように する。在庫が もどったら ここから けす（v0.2.69：シャープペンは いま 在庫なし）
const PAPER_OUT = SHOP === 'shopify' ? {} : { mp: true };
const paperOf = (id = state.paper) => PAPERS.find(x => x.id === id) || PAPERS[0];
const PRICES = {                       // バインダー → 円（税込）
  // ★手帳もルーズリーフと同じ値段（2026-09-17 きまり。形・まい数で変えない）
  // ★本店「すきないろのB5」の値段：中身のみ ¥1,980 ／ 紙黒クラフト ¥3,600 ／ 本革黒レザー ¥12,000
  // ★大容量は 2026-09-18 になくした
  none: 1980,
  bb: 3600,
  leather: 12000,
  maruman: 3980,   // Shopify だけ（クロッキーマルマン バインダー）
};
// ★Shopify では 商品に 登録した 値段を つかう（ページの 数字より 商品の ほうが 正しい）。楽天では 何もしない
Object.entries(SHOPIFY_VARIANTS).forEach(([k, v]) => { if (k in PRICES) PRICES[k] = v.yen; });
const PRICE_IS_KARI = false;   // 2026-09-17 値段が全部決まった

// ===== 紙を横にめくると出る説明のページ =====
//   ★楽天の規約：楽天の外（自社サイトをふくむ）の アドレスを ページに入れない（2026-09-18 たしかめた）
//     → このファイルには Shopify・本店の アドレスを 書かない
//   ・楽天：GOLD の img/ に置いた写真（この index.html と 同じ場所の img/ フォルダ）
//   ・Shopify：テーマの部品（layout/techou.liquid）が window.TK_PHOTOS で わたす
//   ・写真が まだないときは 絵（ピクトグラム）を出す（こわれた画像は 出さない）
const PHOTO_GOLD = { bb: 'img/b5-bb.jpg', leather: 'img/b5-leather.jpg', paper: 'img/b5-paper.jpg', pen: 'img/b5-pen.png' };
const PHOTO = (() => {
  if (SHOP !== 'shopify') return PHOTO_GOLD;
  const given = (typeof window.TK_PHOTOS === 'object' && window.TK_PHOTOS) || {};
  const ok = u => typeof u === 'string' && /^https:\/\/(cdn\.shopify\.com\/s\/files\/1\/0741\/1518\/7005|(?:tkdeko\.com|timekeeperdeko\.myshopify\.com)\/cdn\/shop)\//.test(u);   // Shopify の 画像の置き場だけ
  return Object.fromEntries(Object.keys(PHOTO_GOLD).map(k => [k, ok(given[k]) ? given[k] : '']));
})();
const INFO_PAGES = [
  // ★v0.2.150 みなとさん：ご注文の方法は 2ページ・12項目（お店の メニューの 手順 ①〜⑫ と 同じ ならび）。start＝番号の つづき
  { id: 'howto', label: 'ご注文の方法', title: 'ご注文の方法 1/2',
    steps: [
      { pi: ['koyo'], text: '国を えらぶ', sub: 'いまは 日本だけ' },
      { pi: ['year'], text: '年間の 形を えらぶ', sub: '1冊の はじめに つく 2まい' },
      { pi: ['sheets'], text: '月間か 週間を えらぶ', sub: '7つの なかまから' },
      { pi: ['event'], text: 'はじまり月を きめる', sub: '2年ぶんの はじめの 月。背景も ここで' },
      { pi: ['view'], text: '表示を ととのえる', sub: '週の はじまり・日付の 丸・六曜など' },
      { pi: ['custom'], text: '形を 変える', sub: 'マスの 数や 線を 自分に ぴったりに' },
    ] },
  { id: 'howto2', label: 'ご注文の方法 2', title: 'ご注文の方法 2/2', start: 6,
    steps: [
      { pi: ['color'], text: '色を えらぶ', sub: '線・文字・土曜・日曜の 4つ' },
      { pi: ['name'], text: '名前を 入れる', sub: 'はじめは BirthBookNote。いらなければ 消してね' },
      { pi: ['bg'], text: 'えにっきを いれる', sub: 'LINE の えにっきbook の 絵を マスに' },
      { pi: ['paper'], text: '紙を えらぶ', sub: 'ボールペン・万年筆・シャープペンの 3つから' },
      { pi: ['binder'], text: 'バインダーを えらぶ', sub: 'いらないときは そのままで OK' },
      { pi: ['cart'], text: '注文を 確定する', sub: SHOP === 'shopify' ? 'ご注文内容を たしかめて カゴへ' : 'ご注文内容を たしかめて 楽天の カゴへ' },
    ] },
  { id: 'onepage', label: '1ページ完結', kind: 'oneside',
    title: 'ページを またがない', text: 'どの形も、B5の1まいに1年・1か月・1週間・2週間がまるごと入ります。見開きをまたがないので、ひと目で見わたせて、1まいずつ入れかえ・並べかえもできます。' },
  { id: 'handmade', label: '手作り', icon: 'pin',
    title: 'ひとつずつ手作り', text: 'ひとつずつ、手作りでお作りしています。四国・徳島県の国府町（こくふちょう）からお送りします。' },
  { id: 'oneside', label: '片面印刷', kind: 'oneside',
    title: '片面印刷', text: 'おもてだけに線を印刷しています。うらは、すけて見える線をたよりに書けます。' },
  { id: 'ink', label: 'やわらかい線', kind: 'oneside',
    title: 'えほんのような、やわらかい線', text: '線は水性インクで印刷しています。やわらかさを再現した、えほんのような風合いです。水にはよわいので、ぬらさないように気をつけてください。' },
  { id: 'paper', label: '紙', photo: 'paper',
    title: '紙は3つからえらべます', text: '書くものに合わせてえらんでください。①日本書籍用紙（ボールペン専用）＝本に使われるクリーム色の紙。②万年筆専用用紙＝裏移りしにくい紙。③シャープペン専用用紙。どれもB5・26穴です。',
    tags: ['ジェットストリーム', 'ジュースアップ 0.4', 'サラサ', 'ブレン'], tagsNote: 'に ぴったりの 日本書籍用紙' },
  // ★v0.2.154 みなとさん：POINT に 名入れ と えにっき を 足した（メニューの ⑧名入れ・⑨えにっき から ここへ 移る）
  { id: 'name', label: '名入れ', icon: 'name',
    title: '名前を 入れられます', text: '紙の 右下に 好きな 文字を 入れられます（20文字まで）。はじめは BirthBookNote。いらないときは 文字を けせば 何も 出ません。ぜんぶの 紙に 同じ 文字が 入ります。' },
  { id: 'enikki', label: 'えにっき', icon: 'bg',
    title: 'えにっきの 絵が 入ります', text: 'LINE の「えにっきbook」で かいた 絵を、月間式の 日の マスに そのまま 出せます。LINE で ログインすると 見られて、印刷にも 出ます。マイスタンプも マスに はれます。' },   // ★v0.2.181
  { id: 'bb', label: 'バースブックバインダー', photo: 'bb',
    title: 'バースブックバインダー（黒）', text: '軽くてじょうぶな、黒い紙のバインダーです。B5・26穴。手帳のリフィルつき。',
    price: () => priceFrom('bb') },
  { id: 'leather', label: 'レザーバインダー', photo: 'leather',
    title: 'レザーバインダー（黒）', text: '本革の黒いバインダーです。使うほど手になじみます。B5・26穴。手帳のリフィルつき。',
    price: () => priceFrom('leather') },
  /* ★2026-10-15 ご注文内容の 前に 1ページ：変えた ところを 丸で かこんで わかりやすく（画面だけ・印刷には 出ない） */
  { id: 'changes', label: '変えた ところ', kind: 'oneside', changes: true, title: '変えた ところ', text: '' },
];
const yen = n => '¥' + n.toLocaleString('ja-JP');
/* ★nv0.2.5 ノートは **大容量**で 値段が 足されます（手帳には ない）。
   たし算の 金額 BIG_PLUS は 楽天の 値段から きめた もの（古い ノート v0.1.71 と 同じ）。 */
const priceOf = (b = state.binder, pp = state.paper, op = state.option) =>
  (SHOP !== 'shopify' && PRICE_TABLE[b] && PRICE_TABLE[b][pp] ? PRICE_TABLE[b][pp] : PRICES[b])
  + (op === 'big' ? BIG_PLUS : 0);
// 説明のページの 値段：紙で ちがうときは いちばん安い 値段＋「〜」
const priceFrom = b => { const ps = PAPERS.filter(x => !PAPER_OUT[x.id]).map(x => priceOf(b, x.id)); const lo = Math.min(...ps); return yen(lo) + (ps.some(p => p !== lo) ? '〜' : ''); };

// ===== 楽天のかご（2026-09-11 の実験で決めた形。今のGOLDページと同じ）=====
//   ★GOLD（rakuten.ne.jp）から送ったときだけ受けつけられる
//   ★項目名が1文字でもちがうと「未選択」エラー。値は20文字まで・絵文字不可
const CART_READY = true;    // 2026-09-17 GOLDでためすため ON。楽天の商品番号（item）が 空のあいだは、自動で「準備中」のまま
/* ★nv0.2.5 大容量の たし算（楽天の「マルマン26穴黒＋追加150枚」から きめた・2026-09-17）
   ★priceOf より 先に 書く（const は あとから だと「まだ ない」と 言われる） */
const BIG_PLUS = 4378;
const OPTIONS = [
  { id: 'normal', name: 'なし', sub: 'ルーズリーフ70枚', pi: 'sheets' },
  { id: 'big', name: '大容量', sub: '＋マルマンのバインダー1つ＋ルーズリーフ150枚', pi: 'option' },
];
const RAKUTEN = {
  shopId: '248096',
  // ★v0.2.68：楽天は 1つの商品に バリエーション（SKU）9つ（紙3 × バインダー3）。みなとさん「B」できめた
  //   ・item＝その商品の 商品ID（数字）。空＝まだ ない →「準備中」
  //   ・どの バリエーションかは variant_id で 送る＝ RMS の「SKU管理番号」
  //     （2026-09-18 テスト商品 techou-test で ためした：variant_id で 送ると えらんだ 紙で カゴに入る。variantId では 入らない）
  //   ・SKU管理番号は techou-<紙>-<バインダー>（例 techou-fp-none・techou-book-bb）。RMS の 番号と 1文字でも ちがうと 入らない
  //   ★10065343 はルーズリーフ、10065401 は 1つめに作った 手帳（バリエーションなし）なので、ここには入れない
  /* ★nv0.2.5 ここが 手帳と ノートの わかれ目
     ------------------------------------------------------------
     手帳＝10065401（timekeeper-b5-techou-001・バリエーション 9つ）
     ノート＝**10065343**（timekeeper-b5-note-001・バリエーション **18こ**
             ＝紙3 × バインダー3 × 大容量2。2026-09-18 に みなとさんが RMS で 作った）
     SKU管理番号は note-<紙>-<バインダー>、大容量は うしろに -big
     （例 note-book-none ／ note-fp-bb-big）。1文字でも ちがうと カゴに 入りません。 */
  item: '10065343',
  sku: (paper = state.paper, binder = state.binder, option = state.option) =>
    `note-${paper}-${binder}` + (option === 'big' ? '-big' : ''),
  basket: 'https://t.basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set',
  //   ★1つの項目は20文字まで。色は 線・文字・土曜・日曜 で 項目を分ける（1つにまとめると こえる）
  /* ★nv0.2.5 ノートの 項目（古い ノート v0.1.71 と 同じ）。
     ToDo と 星は ノートに あるので のこす。暦の 色（文字・土曜・日曜）は ノートに ない。 */
  opt: { code: '注文コード', color: '線の色', inkText: '文字の色', name: '名入れ', todo: 'チェック', order: 'オーダー', order2: 'オーダー2' },   // ★nv0.2.35 星は 注文コードの 中／チェックは 20文字ちょうど／えにっきは いれる・いれない   // ★v0.2.89 えらびが ふえて 20文字を こえるので オーダーは 2つに 分ける   // ★「色」＝文字・土曜日・日曜日の色（線と同じなら入れない）   // ★ToDo は 2026-09-18 になくした
  MAX: 20,
};
const NO_EMOJI = /[\u{1F000}-\u{1FFFF}\u{FE0F}\u{200D}]/u;

// 線の色のパレット（お手本 timekeeper-b5.html と同じ）
// 定番の色（日本の伝統色。名前は小さく出す）
//   ★2026-09-17：#92b5a9 → 錆青磁 #a6c8b2、#6b8cae → 薄花色 #698aab に合わせた（伝統色の値にそろえるため）
const PAL_BASE = [
  { c: '#c1e4e9', name: '白藍', yomi: 'しらあい' },
  { c: '#f5b1aa', name: '珊瑚色', yomi: 'さんごいろ' },
  { c: '#edd3a1', name: '浅黄', yomi: 'うすき' },
  { c: '#a6c8b2', name: '錆青磁', yomi: 'さびせいじ' },
  { c: '#dbd0e6', name: '白藤色', yomi: 'しらふじいろ' },
  { c: '#cbb994', name: '白橡', yomi: 'しろつるばみ' },
  { c: '#c0c6c9', name: '灰青', yomi: 'はいあお' },
  { c: '#698aab', name: '薄花色', yomi: 'うすはないろ' },
  /* ★2026-11-03 みなとさん「下の 小さな 色を 廃止。押しボタンの 色だけ・種類は ふやして」＝日本の伝統色 35いろ（名前と 値は サイト NIPPON COLORS の もの） */
  { c: '#f596aa', name: '桃', yomi: 'もも' },
  { c: '#eea9a9', name: '鴇', yomi: 'とき' },
  { c: '#e87a90', name: '薄紅', yomi: 'うすべに' },
  { c: '#dc9fb4', name: '撫子', yomi: 'なでしこ' },
  { c: '#d05a6e', name: '今様', yomi: 'いまよう' },
  { c: '#cb1b45', name: '紅', yomi: 'くれない' },
  { c: '#c1328e', name: '牡丹', yomi: 'ぼたん' },
  { c: '#ffb11b', name: '山吹', yomi: 'やまぶき' },
  { c: '#ca7a2c', name: '琥珀', yomi: 'こはく' },
  { c: '#563f2e', name: '焦茶', yomi: 'こげちゃ' },
  { c: '#7ba23f', name: '萌黄', yomi: 'もえぎ' },
  { c: '#838a2d', name: '苔', yomi: 'こけ' },
  { c: '#6c6a2d', name: '鶯', yomi: 'うぐいす' },
  { c: '#42602d', name: '松葉', yomi: 'まつば' },
  { c: '#1b813e', name: '常磐', yomi: 'ときわ' },
  { c: '#5dac81', name: '若竹', yomi: 'わかたけ' },
  { c: '#69b0ac', name: '青磁', yomi: 'せいじ' },
  { c: '#00aa90', name: '青緑', yomi: 'あおみどり' },
  { c: '#36563c', name: '千歳緑', yomi: 'ちとせみどり' },
  { c: '#78c2c4', name: '白群', yomi: 'びゃくぐん' },
  { c: '#33a6b8', name: '浅葱', yomi: 'あさぎ' },
  { c: '#58b2dc', name: '空', yomi: 'そら' },
  { c: '#2ea9df', name: '露草', yomi: 'つゆくさ' },
  { c: '#005caf', name: '瑠璃', yomi: 'るり' },
  { c: '#006284', name: '縹', yomi: 'はなだ' },
  { c: '#113285', name: '紺青', yomi: 'こんじょう' },
  { c: '#0d5661', name: '藍', yomi: 'あい' },
  { c: '#566c73', name: '藍鼠', yomi: 'あいねず' },
  { c: '#0f2540', name: '紺', yomi: 'こん' },
  { c: '#261e47', name: '鉄紺', yomi: 'てつこん' },
  { c: '#8b81c3', name: '藤', yomi: 'ふじ' },
  { c: '#8f77b5', name: '紫苑', yomi: 'しおん' },
  { c: '#6a4c9c', name: '桔梗', yomi: 'ききょう' },
  { c: '#66327c', name: '菫', yomi: 'すみれ' },
  { c: '#1c1c1c', name: '墨', yomi: 'すみ' },
];
const colorName = c => PAL_BASE.find(p => p.c === c);
const PAL_HUES = [0,25,45,60,90,130,165,190,210,235,270,320];
const PAL_TONES = [[60,82],[50,68],[45,52],[40,38]];      // [あざやかさ%, 明るさ%]。★明るさ90%以上は紙の上でほぼ見えない
const PAL_GRAYS = ['#e0e0e0','#bdbdbd','#9e9e9e','#7a7a7a','#555555','#333333','#1a1a1a','#000000','#a89f91','#7d6e5d','#5b4a3a','#3b2f25'];
const START_COLOR = '#698aab';   // 薄花色
const DEFAULT_NAME = 'BirthBookNote';   // 名入れのはじめの文字（消せば名入れなし）
const SHEET_COLOR = '#FDF8D8';    // 画面の紙の色（リーガルパッドの色。印刷は白のまま）

// B5・26穴（9.525mmピッチ）
// ★v0.2.168 紙の サイズの 表。A5・A4 は B5 の 絵（182×257）を 紙に ぴったり 縮尺して 描く（横縦 べつべつ・差は 0.5%ほど）。
//   穴は 画面の かざり（holesSvg）で 本物の 数・位置。B5 は 今までと 1文字も 変わらない（golden で 証明）。
const SIZES = {
  b5: { id: 'b5', name: 'B5', w: 182, h: 257, holes: 26, pitch: 9.525 },
  a5: { id: 'a5', name: 'A5', w: 148, h: 210, holes: 20, pitch: 9.5 },
  b6: { id: 'b6', name: 'B6', w: 128, h: 182, holes: 21, pitch: 8.47 },
  /* ★nv0.2.54 L判の 大きさを **127 × 89mm** に 直した（2026-10-03）
     ------------------------------------------------------------
     ★それまで 86 × 128mm（マルマン ルーズリーフミニ）に して いました。
       みなとさんが 上げた 本物の 柄の SVG を はかったら **127.0 × 89.0mm**（L判）でした。
       480 × 336.37732 px（96dpi）＝127.0 × 89.0mm。
     ★穴も ぴったり 合います：9つ × 9.5mm ＝ 76mm、89 − 76 ＝ 13 → 上下 6.5mm ずつ。 */
  l: { id: 'l', name: 'L判たて', w: 89, h: 127, holes: 9, pitch: 9.5, side: 'top' },
  ly: { id: 'ly', name: 'L判よこ', w: 127, h: 89, holes: 9, pitch: 9.5 },
  // ★nv0.2.169 レター（B5 の 柄から）は 印刷・ダウンロード専用で 出す（手帳 v0.2.317 と おなじ 数字）。レターよこは 出さない（hidden）
  letter: { id: 'letter', name: 'レター', w: 216, h: 279, holes: 3, pitch: 108, r: 4, x: 12.7, printOnly: true },
  'letter-yoko': { id: 'letter-yoko', name: 'レターよこ', w: 279, h: 216, holes: 3, pitch: 108, r: 4, side: 'top', hidden: true },
  a4: { id: 'a4', name: 'A4', w: 210, h: 297, holes: 30, pitch: 9.5 },   // ★印刷用（家の プリンターで 切らずに つかえる）
  /* ★nv0.2.162 バイブル・ミニ6（手帳 v0.2.214 と おなじ 数字。穴の 並び gaps・x・r は 手帳の SIZES から。実物で たしかめる 前の 仮）
     ・printOnly＝印刷・ダウンロードだけ（手帳と おなじ あつかい）。柄は B6 から 作った（make_size_from_b6.py） */
  bible: { id: 'bible', name: 'バイブル', w: 95, h: 170, holes: 6, gaps: [19, 19, 51, 19, 19], r: 1.9, printOnly: true },
  mini6: { id: 'mini6', name: 'ミニ6', w: 76, h: 126, holes: 6, pitch: 19, r: 1.9, printOnly: true },
  // ★nv0.2.168 ポケット・M5・Filofaxミニ・Franklinポケット（B6 から）・ハーフレター（A5 から）。手帳 v0.2.317 と おなじ 数字（make_size2.py）
  pk: { id: 'pk', name: 'ポケット', w: 81, h: 120, holes: 6, pitch: 19, r: 1.9, printOnly: true },
  m5: { id: 'm5', name: 'M5', w: 62, h: 105, holes: 5, pitch: 19, r: 1.9, printOnly: true },
  fm: { id: 'fm', name: 'Filofaxミニ', w: 67, h: 105, holes: 5, pitch: 19, r: 1.9, printOnly: true },
  fp: { id: 'fp', name: 'Franklinポケット', w: 89, h: 153, holes: 6, gaps: [19, 19, 38, 19, 19], r: 1.9, printOnly: true },
  hl: { id: 'hl', name: 'ハーフレター', w: 140, h: 216, holes: 3, pitch: 70, r: 4, x: 12.7, printOnly: true },
  // ★nv0.2.169 デスクファックス（9穴・19-19-51-19-19-51-19-19＝Filofax 公式）・トラベラーズ／パスポート（穴なし）。穴の 絵の 大きさ r は 仮
  dk: { id: 'dk', name: 'デスクファックス', w: 176, h: 250, holes: 9, gaps: [19, 19, 51, 19, 19, 51, 19, 19], r: 1.9, printOnly: true },
  tr: { id: 'tr', name: 'トラベラーズ', w: 110, h: 210, holes: 0, printOnly: true },
  tp: { id: 'tp', name: 'パスポート', w: 89, h: 124, holes: 0, printOnly: true },
  // ディスク式（ハッピープランナー・ディスクジュニア）：穴（キノコ形の 切り欠き）の 寸法が わからない ので 絵は 出さない（holes 0）。左の 余白は 19mm
  hp: { id: 'hp', name: 'ハッピープランナー', w: 178, h: 235, holes: 0, printOnly: true },
  hm: { id: 'hm', name: 'ハッピープランナー ミニ', w: 118, h: 178, holes: 0, printOnly: true },
  dj: { id: 'dj', name: 'ディスクジュニア', w: 140, h: 216, holes: 0, printOnly: true },
  // ★nv0.2.170 HB×WA5（マークス・6穴）。穴の 位置は 見つからず バイブルと おなじ 並びに 仮に した（絵だけ・印刷には 出ない）
  hb: { id: 'hb', name: 'HB×WA5', w: 148, h: 170, holes: 6, gaps: [19, 19, 51, 19, 19], r: 1.9, printOnly: true },
};
// どの サイズか：商品が わたす TK_PAPER か、ためし用の ?paper=（知らない 名前は b5）
const PSIZE = (() => { try { let t = new URLSearchParams(location.search).get('paper') || (typeof window !== 'undefined' && window.TK_PAPER); if (t === 'letter-tate') t = 'letter'; return SIZES[t] ? t : 'b5'; } catch (e) { return 'b5'; } })();   // ★v0.2.177 ?paper= が 商品の サイズ（TK_PAPER）より 強い（ためし・共有用）／v0.2.174 letter-tate は letter の 別名
const PSEL = SIZES[PSIZE];
const psizeOf = id => SIZES[id] || SIZES.b5;
// ★nv0.2.163 印刷・ダウンロード専用の サイズ（バイブル・ミニ6）：カゴ・注文確定を 出さない（手帳 v0.2.214 と おなじ）
const PRINT_ONLY = !!PSEL.printOnly;
if (PRINT_ONLY) {
  document.documentElement.classList.add('po');
  TEXTS_JA.nkSteps = TEXTS_JA.nkSteps.filter(st => !['paper', 'binder', 'option', 'check', 'order'].includes(st[0]));
}
// ★テストは この SIZES の かたまりを 切り出して いっしょに Node へ わたす（下の 描く 範囲より 前に あるため）

const state = { enikki: { mode: 1, pick: {} },   // えにっきの 絵（本店だけ・v0.2.84）：mode 0 出さない・1 新しい1まい・2 古い1まい、pick＝マスを おして えらんだ 絵
  country: 'jp',   // ★v0.2.159 国（jp＝日本／us＝アメリカ）。紙の 言葉・祝日が かわる（お店だけ えらべる）
  /* ★nv0.2.2 ノートだけの もの：星（0〜5）・右上の 3行・大容量 */
  stars: 5,   // ★nv0.2.25 みなとさん「星は デフォルトで 5つに して おいて」
  todo: ['□たいせつ', '□みかえす', '□おしまい'],   // ★2026-11-03 みなとさん「B5 が 一番 正確」＝□ を もどす（紙の 上は todoShow で B5 の 柄と 同じ すきまに）
  option: 'normal',   // ★nv0.2.5 大容量（normal／big）
  notes: [], cat: 'month', idx: 0,   // ★v0.2.79「すべて」を なくした。はじめは 月間式の なかま
 color: START_COLOR, name: DEFAULT_NAME, paper: 'book', binder: 'none', page: '' };
// ★年間の紙（v0.2.74 みなとさん「買うのは 年間＋月間 か 年間＋週間」）
//   ・yIdx＝えらんだ 年間の形（state.notes の 何番め）。1冊の 前に 2まい つく（ページの名前は y0・y1）
//   ・idx（手帳の形）は 年間の形には しない（月間・週間だけ）
//   ・ySheet＝いま（さいごに）見ている 年間の紙（0 か 1）
state.yIdx = -1;
state.ySheet = 0;
const yNote = () => state.notes[state.yIdx];
const isYearNote = n => !!n && n.fmt.cat === 'year';
/* ★nv0.2.17 みなとさん「色の 土日 廃止して」（2026-10-03）
   ------------------------------------------------------------
   ノートに 曜日は ない ので、土曜日・日曜日の 色は いりません。
   のこすのは **線**と **文字**（名入れ・右上の3行に きく）の 2つ。
   ★`state.inks` の しくみ自体は のこす（消すと 色の 計算が くるう）。
     土曜・日曜は いつも null（＝線と 同じ）に なります。 */
// ★nv0.2.34 本店の 柄の もとの 色（import_honten.py の BASE_COLOR と 同じ）。
//   柄の SVG は 線も 文字も この 色で 描いて ある。えらんだ 色に そめるのは tintedUrl
const NOTE_INK_BASE = '#c1e4e9';
const INK_KEYS = ['line', 'text'];
state.inks = { text: null, sat: null, sun: null };
state.inkTarget = 'line';
const inkOf = k => (k === 'line' ? state.color : state.inks[k] || state.color);
const inks = () => Object.fromEntries(INK_KEYS.map(k => [k, inkOf(k)]));
const inkKey = () => INK_KEYS.map(inkOf).join('');
const $ = id => document.getElementById(id);
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

function applyTexts() { document.querySelectorAll('[data-t]').forEach(el => { el.textContent = TEXTS[el.dataset.t] || ''; if (PSIZE !== 'b5') { if (el.textContent.includes('B5の紙')) el.textContent = el.textContent.replace('B5の紙', PSEL.name + 'の紙'); if (el.textContent.includes('B5 paper')) el.textContent = el.textContent.replace('B5 paper', tr(PSEL.name) + ' paper'); } }); try { trDomAll(); } catch (e) {} }   // ★nv0.2.145 画面に 出た 日本語を 辞書で 置きかえる（日本語の ときは 何も しない）／★v0.2.168〜173 印刷の 案内は その 紙の 名前に（英語も）   // ★v0.2.164 国を かえた ときも 入れなおす
applyTexts();

// ===== ピクトグラム（絵文字は使わない。線で描いた24×24の絵）=====
const PICTO = {
  /* ★nv0.2.2 ノートの 丸（古い ノート v0.1.71 から そのまま 持ってきた） */
  todo: '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8 12.3l2.8 2.8L16 9.5"/>',
  stars: '<path d="M12 3.6l2.6 5.2 5.7.8-4.1 4 1 5.7L12 16.6l-5.2 2.7 1-5.7-4.1-4 5.7-.8z"/>',
  option: '<path d="M4 8l8-4 8 4-8 4z"/><path d="M4 12l8 4 8-4"/><path d="M4 16l8 4 8-4"/>',
  box: '<rect x="5" y="5" width="14" height="14" rx="2"/>',
  minus: '<path d="M5 12h14"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  koyo: '<path d="M5.5 3.5h8l5 5v12a1.5 1.5 0 0 1-1.5 1.5h-11.5A1.5 1.5 0 0 1 4 20.5v-15.5A1.5 1.5 0 0 1 5.5 3.5z"/><path d="M13.5 3.5v5h5"/><path d="M7.5 13h8M7.5 17h5"/>',
  custom: '<path d="M3.5 17.5L17.5 3.5l3 3-14 14h-3z"/><path d="M14.5 6.5l3 3"/><path d="M4 21h16" stroke-dasharray="2 2"/>',
  event: '<path d="M5.5 21V3.5"/><path d="M5.5 4.5h12l-3 4 3 4h-12"/><circle class="fill" cx="10" cy="8.5" r="1.2"/>',
  // 背景の柄（背景のパネルのボタン）
  bg0: '<rect x="4" y="4" width="16" height="16" rx="1.5"/>',
  bg1: '<rect x="4" y="4" width="16" height="16" rx="1.5"/><circle class="fill" cx="8" cy="8" r=".95"/><circle class="fill" cx="12" cy="8" r=".95"/><circle class="fill" cx="16" cy="8" r=".95"/><circle class="fill" cx="8" cy="12" r=".95"/><circle class="fill" cx="12" cy="12" r=".95"/><circle class="fill" cx="16" cy="12" r=".95"/><circle class="fill" cx="8" cy="16" r=".95"/><circle class="fill" cx="12" cy="16" r=".95"/><circle class="fill" cx="16" cy="16" r=".95"/>',
  bg2: '<rect x="4" y="4" width="16" height="16" rx="1.5"/><path stroke-width="1" d="M8 4v16M12 4v16M16 4v16M4 8h16M4 12h16M4 16h16"/>',
  bg3: '<rect x="4" y="4" width="16" height="16" rx="1.5"/><path stroke-width="1" d="M4 8h16M4 12h16M4 16h16"/>',
  bg4: '<rect x="4" y="4" width="16" height="16" rx="1.5"/><path stroke-width="1.2" d="M6.7 8.5h3.6M8.5 6.7v3.6M13.7 8.5h3.6M15.5 6.7v3.6M6.7 15.5h3.6M8.5 13.7v3.6M13.7 15.5h3.6M15.5 13.7v3.6"/>',
  bg: '<rect x="3.5" y="3.5" width="17" height="17" rx="2"/><circle class="fill" cx="8" cy="8" r="1"/><circle class="fill" cx="12" cy="8" r="1"/><circle class="fill" cx="16" cy="8" r="1"/><circle class="fill" cx="8" cy="12" r="1"/><circle class="fill" cx="12" cy="12" r="1"/><circle class="fill" cx="16" cy="12" r="1"/><circle class="fill" cx="8" cy="16" r="1"/><circle class="fill" cx="12" cy="16" r="1"/><circle class="fill" cx="16" cy="16" r="1"/>',
  view: '<path d="M3.5 8.5h17M3.5 15.5h17"/><circle class="fill" cx="8.5" cy="8.5" r="2.6"/><circle class="fill" cx="15.5" cy="15.5" r="2.6"/>',   // スライダー（つまみ）2026-09-18
  color: '<path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.7-.8 1.7-1.7 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-.9.8-1.7 1.7-1.7H16a5 5 0 0 0 5-5c0-4-4-7.2-9-7.2z"/><circle class="fill" cx="7.5" cy="11.5" r="1.3"/><circle class="fill" cx="10" cy="7.3" r="1.3"/><circle class="fill" cx="14.6" cy="7.3" r="1.3"/><circle class="fill" cx="17.2" cy="11" r="1.3"/>',
  name: '<path d="M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 7.5l3 3"/>',
  print: '<path d="M7 9V4h10v5"/><rect x="3.5" y="9" width="17" height="8" rx="2"/><path d="M7 14h10v6H7z"/><circle class="fill" cx="17" cy="12" r=".9"/>',
  cart: '<path d="M3 4h2.2l2.1 10.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2"/><circle cx="9.5" cy="19.5" r="1.4"/><circle cx="17" cy="19.5" r="1.4"/>',
  close: '<path d="M6 6l12 12M18 6L6 18"/>',
  reset: '<path d="M4.5 12a7.5 7.5 0 1 0 2.4-5.5"/><path d="M4 4v4.2h4.2"/>',
  paper: '<path d="M6 3.5h7.5l4.5 4.5v12.5H6z"/><path d="M13.5 3.5v4.5h4.5"/><path d="M9 12.5h6M9 16h4"/>',
  penBall: '<path d="M9 3.5h6v11.5l-3 3-3-3z"/><path d="M9 7.5h6" stroke-width="1"/><circle class="fill" cx="12" cy="19.6" r="1.1"/>',
  penFp: '<path d="M8.5 4.5h7v9l-3.5 7-3.5-7z"/><path d="M12 14.5v4" stroke-width="1"/><circle class="fill" cx="12" cy="11.8" r="1"/>',
  penMp: '<path d="M10.5 2.2h3v1.6h-3z"/><path d="M9 3.8h6v11.2H9z"/><path d="M9 12h6" stroke-width="1"/><path d="M9 15h6l-2 2.6h-2z"/><path d="M12 17.6v3.2" stroke-width="1"/>',
  binder: '<rect x="6" y="3.5" width="13" height="17" rx="1.5"/><path d="M9.5 3.5v17"/><path d="M4 7.5h3.5M4 12h3.5M4 16.5h3.5"/>',
  pin: '<path d="M12 21s-6.5-6.2-6.5-11.2a6.5 6.5 0 0 1 13 0C18.5 14.8 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.4"/>',
  sheets: '<path d="M7 3.5h8l3 3v14H7z"/><path d="M15 3.5v3h3"/><path d="M9.5 11h6M9.5 14h6M9.5 17h4"/>',
  year: '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/><circle class="fill" cx="8" cy="13.5" r="1.1"/><circle class="fill" cx="12" cy="13.5" r="1.1"/><circle class="fill" cx="16" cy="13.5" r="1.1"/><circle class="fill" cx="8" cy="17" r="1.1"/>',
};
const picto = key => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${PICTO[key]}</svg>`;
document.querySelectorAll('.pi[data-pi]').forEach(el => { el.innerHTML = picto(el.dataset.pi); });

/* パネルの「入る場所」：小さな紙の絵で、入る角だけ朱色にする
   ★nv0.2.25 みなとさん「星は 左上」「チェックは 左上（右上）」「もともと
     ピクトグラムが あったと 思います」→ そのとおりでした。
     手帳では 名入れ（右下）だけ だったので、**左上・右上を 足しました**。 */
const WHERE_BOX = { tl: [4, 3], tr: [15, 3], br: [15, 30] };
document.querySelectorAll('.where[data-where]').forEach(el => {
  const w = el.dataset.where;
  if (!WHERE_BOX[w]) return;
  const [x, y] = WHERE_BOX[w];
  el.innerHTML = `<svg viewBox="0 0 30 42" aria-hidden="true">
    <rect x=".75" y=".75" width="28.5" height="40.5" rx="1.5" fill="${SHEET_COLOR}" stroke="#d9d3c4" stroke-width="1.5"/>
    <g fill="#ebe6d8">${[...Array(9)].map((_, i) => `<circle cx="2.6" cy="${5 + i * 4}" r=".8"/>`).join('')}</g>
    <rect x="${x}" y="${y}" width="11" height="9" rx="1.5" fill="#c14a30"/>
  </svg><span><small></small><b></b></span>`;
  el.querySelector('small').textContent = TEXTS.whereTitle;
  el.querySelector('b').textContent = TEXTS['where_' + w] || '';
});
$('ver').textContent = APP_VERSION;

// ===== SVG を読む（色を変えて、画像として出す）=====
//   img で出すので、SVG の中のスクリプトは動かない・id もぶつからない
const tinted = new Map();
/* ★ノートの 柄の SVG を 読む（1回 読んだら おぼえる）
   ・GOLD では notes/ の ファイルを fetch
   ・ファイルを ダブルクリックで ひらいた ときは notes.js（window.NOTES_LOCAL）から */
/* ★nv0.2.7 柄の SVG の ありか
   ------------------------------------------------------------
   楽天GOLD＝notes/lines/001_xxx.svg（フォルダの まま）
   Shopify ＝テーマの assets は **フォルダが 作れない** ので、
            ファイル名だけに して 前に bbn- を つける（bbn-001_xxx.svg）。
            ありかは head.liquid から window.TK_NOTE_BASE で わたす。
   ★index.html に Shopify の アドレスは 1行も 書きません（きまり）。 */
function noteFileUrl(file) {
  const base = (typeof window !== 'undefined' && window.TK_NOTE_BASE) || '';
  if (!base) return file;                       // 楽天GOLD・ためし台は そのまま
  const name = String(file).split('/').pop();   // 001_3237101009611.svg
  return base.replace('bbn-.svg', 'bbn-' + name).replace(/\?.*$/, '')
       + (base.includes('?') ? base.slice(base.indexOf('?')) : '');
}
const noteSvgCache = new Map();
async function noteSvgText(fmt) {
  if (noteSvgCache.has(fmt.id)) return noteSvgCache.get(fmt.id);
  let t = null;
  try { if (window.NOTES_LOCAL && window.NOTES_LOCAL.svgs) t = window.NOTES_LOCAL.svgs[fmt.id] || null; } catch (e) {}
  if (!t) { const r = await fetch(noteFileUrl(fmt.file), { cache: 'no-cache' }); t = await r.text(); }
  noteSvgCache.set(fmt.id, t);
  return t;
}

async function getSvg(note, today) {
  // ★ノートの 柄は 描かずに「ファイルを 読む」。ここが 手帳との ゆいいつの ちがい
  // ★nv0.2.16 オーダーメイドは ファイルが ない。その場で 線を 描く
  if (note && note.fmt && note.fmt.custom && typeof customSvg === 'function') {
    let out = customSvg(state.custom, state.color);
    /* ★nv0.2.27「いまの 柄」の 区画に、えらんで いる 柄を 切り取って 入れる。
       ・もとの 柄は 182×257mm の 1まい。その **同じ ところ**を 切り取るので、
         線の 間隔も 向きも **もとの まま**（のばしたり 縮めたり しません）。
       ・切り取りは clipPath。柄の 中身は そのまま 入れるので 色も いつもの 色が きく。 */
    if (state.cmBaseFmt) {
      try { out = nbInjectOrig(out, await noteSvgText(state.cmBaseFmt)); }
      catch (e) { console.warn('[note] いまの柄を 入れられません', e); }
    }
    return out;
  }
  if (note && note.fmt && note.fmt.note) return await noteSvgText(note.fmt);
  // ★年間の紙（1冊の前に つく 2まい）は state.ySheet まいめ（v0.2.74）
  const at = note === yNote() ? sheetAt(note, state.ySheet) : note === state.notes[state.idx] ? state.at : sheetAt(note, sheetNear(note, curDate()));
  // ★v0.2.79 みなとさん：今日の 枠は 出さない（today は いつも false。描く しくみは のこしてある）
  return plannerSvg(note, at, { ...drawOpt(note), today: false && today, enikki: enikkiWants(note) });
}
// 手帳の線は START_COLOR で描き、ここで えらんだ色（線・文字・土曜・日曜）・紙の色にかえる
async function tintedUrl(note, sheet = SHEET_COLOR) {
  // ★年間の紙は 何まいめかも 名前に 入れる（入れないと 1まいめと 2まいめが 同じ絵に なる）
  /* ★nv0.2.18 みなとさん「形を変えるが 動きません」（2026-10-03）
     ------------------------------------------------------------
     ★わたしの つなぎまちがいでした。この 名前（key）は「もう 作った 絵を つかいまわす」
       ための 合いことばです。オーダーメイドの ときに **手帳の cmCode** を 呼んで いて、
       手帳の 表（CUSTOM）が ノートには 無い ので エラーに なり、
       **紙が 1まいも 出なく なって いました**。
     → ノートの customCode（36進数14文字）を つかいます。 */
  const key = (note.fmt.custom ? 'CM' + customCode() + (state.cmBaseFmt ? 'B' + state.cmBaseFmt.id : '') : note.id + (tuneOf(note) ? tuneCode(note) : '')) + plannerKey() + inkKey() + sheet + decoKey();
  if (tinted.has(key)) return tinted.get(key);
  // 今日のしるしは画面だけ（印刷＝白い紙のときは入れない）
  const doc = new DOMParser().parseFromString(await getSvg(note, sheet !== '#ffffff'), 'image/svg+xml');
  const svg = doc.documentElement;
  if (svg.nodeName !== 'svg') throw new Error('not svg');
  fillDeco(svg);
  const cells = fillEnikki(svg);
  fillStamps(svg, note);   // ★v0.2.124
  const st = doc.createElementNS('http://www.w3.org/2000/svg', 'style');
  const c = inks();
  /* ★nv0.2.34 みなとさん「楽天の ノートで **文字と 線の 色が 合いません**」（2026-10-03）
     ------------------------------------------------------------
     ★わたしの 見のこしでした。本店の 柄は 線も 文字も **#c1e4e9（白藍）**で 描いて あります。
       線は `stroke="#c1e4e9"` なので 上の きまりで そまって いましたが、
       **文字は `fill="#c1e4e9"` の まま**で、どの きまりにも あたらず
       **うすい 水色の まま のこって いました**（235の 柄の うち 234に 文字が あります）。
     → 本店の 色（NOTE_INK_BASE）で 塗られて いる ものを そめます。
       ・文字（text / tspan / use）… 文字の 色
       ・そのほか（path・丸・四角 など）… 線の 色
     ★土曜・日曜の 色は ノートには ありません（INK_KEYS は line と text だけ）。
       前は `fill:undefined` と 書いて いたので その 行は なくしました。 */
  const B = NOTE_INK_BASE;
  st.textContent = `[stroke]:not([stroke="none"]){stroke:${c.line}!important}.ink{fill:${c.text}!important}.line{fill:${c.line}!important}`
    + `[fill="${B}" i]{fill:${c.line}!important}`
    + `text[fill="${B}" i],tspan[fill="${B}" i],use[fill="${B}" i]{fill:${c.text}!important}`
    + `rect.today[stroke]{stroke:#c14a30!important}`
    + `rect[fill="#ffffff"],rect[fill="#fff"],rect[fill="white"],.paper{fill:${sheet}!important}`
    /* ★nv0.2.24 みなとさん「ノートの 中の マークが 白ぬきに なって います。
       透明に して 背景の 色を 同じに して ください」（2026-10-03）
       → 丸・路（四角 いがい）の 白も 紙の 色に する。前は **四角だけ**だった。 */
    + `circle[fill="#ffffff"],circle[fill="#fff"],circle[fill="white"],`
    + `path[fill="#ffffff"],path[fill="#fff"],path[fill="white"],`
    + `ellipse[fill="#ffffff"],ellipse[fill="#fff"],ellipse[fill="white"],`
    + `polygon[fill="#ffffff"],polygon[fill="#fff"],polygon[fill="white"]{fill:${sheet}!important}`;
  svg.appendChild(st);
  /* ★nv0.2.24 マークの 白い 丸は **うめこまれた 画像（PNG）**です。
     CSS では そめられない ので、色の フィルターを かけます（古い ノート v0.1.54 と 同じ やり方）。
     印刷（紙が 白）の ときは かけません。 */
  const imgs = svg.querySelectorAll('image');
  if (imgs.length && !/^#?f{3}(f{3})?$/i.test(sheet)) {
    const NS = 'http://www.w3.org/2000/svg';
    const n = parseInt(String(sheet).replace('#', ''), 16);
    const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(v => (v / 255).toFixed(4));
    const flt = doc.createElementNS(NS, 'filter');
    flt.setAttribute('id', 'bbnSheet');
    flt.setAttribute('color-interpolation-filters', 'sRGB');
    const fm = doc.createElementNS(NS, 'feColorMatrix');
    fm.setAttribute('type', 'matrix');
    fm.setAttribute('values', `${r} 0 0 0 0  0 ${g} 0 0 0  0 0 ${b} 0 0  0 0 0 1 0`);
    flt.append(fm);
    let defs = svg.querySelector('defs');
    if (!defs) { defs = doc.createElementNS(NS, 'defs'); svg.prepend(defs); }
    defs.append(flt);
    imgs.forEach(im => im.setAttribute('filter', 'url(#bbnSheet)'));
  }
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(doc)], { type: 'image/svg+xml' }));
  tinted.set(key, url);
  if (cells.length) ENIKKI.cells.set(url, cells);   // マスを おしたとき どの日か わかるように
  return url;
}
// ☆・3行・名前（お客さまが入れた文字）は、SVG の文字として組み立てず、できた絵の目印に textContent で入れる
const decoKey = () => '\u0001' + state.name;
function fillDeco(svg) {
  /* ★nv0.2.2 ノートの 柄には data-bbn の しるしが ある（本店の 柄から）。
     手帳は 名前だけ だったが、ノートは **星・右上の3行・色コード**も 入れる。
     ★名前の 右そろえは 古い ノート v0.1.71 と まったく 同じ やり方（右はしを
       もとの「BirthBookNote」の 右はしに そろえる）。 */
  const text = {
    name: state.name,
    stars: '☆'.repeat(Math.max(0, Math.min(5, state.stars | 0))),
    color: String(state.color || '').toUpperCase(),
    todo0: todoShow(state.todo && state.todo[0]),
    todo1: todoShow(state.todo && state.todo[1]),
    todo2: todoShow(state.todo && state.todo[2]),
  };
  svg.querySelectorAll('[data-bbn]').forEach(el => {
    const k = el.getAttribute('data-bbn');
    if (!Object.hasOwn(text, k)) return;
    el.textContent = text[k];
    if (k === 'name') {
      // 名前は 右そろえ。右はしを もとの「BirthBookNote」の 右はしに そろえる（ノートの 柄）
      const x0 = parseFloat((el.getAttribute('x') || '0').split(/[\s,]+/)[0]) || 0;
      const size = parseFloat((el.closest('text') || el).getAttribute('font-size')) || 9;
      const est = t => [...t].reduce((w, ch) => w + (ch.charCodeAt(0) < 0x2e80 ? .56 : 1), 0) * size;
      el.setAttribute('x', (x0 + est('BirthBookNote')).toFixed(2));
      el.setAttribute('text-anchor', 'end');
      const MAX = size * 15;
      if (est(text.name) > MAX) { el.setAttribute('textLength', MAX); el.setAttribute('lengthAdjust', 'spacingAndGlyphs'); }
    }
  });
}
/* ★nv0.2.42 「いまの柄」の 区画に、えらんだ 柄を 切り取って 入れる。
   ------------------------------------------------------------
   ★**画面（index.html）と お店用ページ（shop.html）で 同じ ものを つかいます。**
     前は お店用ページが 写しを 持って いて、**書きこみを 外す 直しが 入って いません**でした。
   ・もとの 柄は 182×257mm の 1まい。その **同じ ところ**を 切り取るので、
     線の 間隔も 向きも もとの まま（のばしたり 縮めたり しません）。
   ・もとの 柄が もって いる 書きこみ（☆☆☆☆☆・BirthBookNote・□たいせつ…）は 外します。
     のこすと オーダーメイドの 紙の 書きこみと 二重に なります。 */
function nbInjectOrig(out, src) {
  if (!out.includes('data-orig="1"') || !src) return out;
  const inner = (src.match(/<svg[^>]*>([\s\S]*)<\/svg>/) || [, ''])[1]
    .replace(/<\?xml[\s\S]*?\?>/g, '')
    .replace(/<!DOCTYPE[\s\S]*?>/g, '')
    .replace(/<tspan[^>]*data-bbn="\w+"[^>]*>[\s\S]*?<\/tspan>/g, '')
    .replace(/\sdata-bbn="\w+"/g, '');
  /* ★nv0.2.101 みなとさん「まだ 拡大されて 表示される 時が ある。原因を しらべて」
     ★原因：柄の ファイルは pt（515.906×728.504）で 描いて あるのに、オーダーメイドの 紙は mm（182×257）。
       そのまま 入れると **約2.8倍に 大きく**（線の 間隔も 位置も）なって いた。
     ★直し：柄の viewBox を 読んで、182×257 に ぴったり なる ように scale して 入れる。 */
  let sc = '';
  try {
    const vb = ((src.match(/<svg[^>]*\sviewBox="([^"]+)"/) || [])[1] || '').trim().split(/[\s,]+/).map(Number);
    if (vb.length === 4 && vb[2] > 0 && vb[3] > 0 && (Math.abs(vb[2] - 182) > 0.5 || Math.abs(vb[3] - 257) > 0.5 || vb[0] || vb[1])) {
      sc = `transform="scale(${(182 / vb[2]).toFixed(6)} ${(257 / vb[3]).toFixed(6)}) translate(${-vb[0]} ${-vb[1]})"`;
    }
  } catch (e) {}
  /* ★nv0.2.167 みなとさん「作るで 色の 変更が できません（バイブル）」（2026-10-27）
     ★原因：B5 以外（A5・B6・A4・L判・バイブル・ミニ6）の 柄は ルートに Inkscape の 名前空間
       （xmlns:ns1 / xmlns:ns2）が あり、中の 要素（<ns2:namedview> など）が その 接頭辞を 使う。
       ここで ルートを はずして 中身だけ 入れると 接頭辞が 宣言されず XML が こわれ、
       「形を変える」の 紙（オーダーメイド）が 描けない → ふだんの 手順で 形を変える の 手順を 通ると
       そのあとの 色・星・名入れが 紙に ぜんぶ 出なく なって いた。
     ★直し：ルートの 名前空間の 宣言（xlink いがい）を 入れる <g> に そのまま うつす。 */
  const nsDecl = ((src.match(/<svg\b[^>]*>/) || [''])[0].match(/\sxmlns:(?!xlink\b)[\w-]+="[^"]*"/g) || []).join('');
  let n = 0;
  return out.replace(/<g data-orig="1" data-x="([-\d.]+)" data-y="([-\d.]+)" data-w="([-\d.]+)" data-h="([-\d.]+)"><\/g>/g,
    (m, x, y, w, h) => {
      const id = 'bbnClip' + (++n);
      return `<clipPath id="${id}"><rect x="${x}" y="${y}" width="${w}" height="${h}"/></clipPath>`
           + `<g clip-path="url(#${id})"><g${nsDecl} ${sc}>${inner}</g></g>`;
    });
}
function clearTinted(keepUrls) {
  for (const [k, u] of tinted) if (!keepUrls.includes(u)) { URL.revokeObjectURL(u); tinted.delete(k); ENIKKI.cells.delete(u); }
}

// ===== えにっきbook の 絵を 月間式の マスに（本店 Shopify だけ・v0.2.84）=====
//   ・「LINE で見る」→ LINE ログイン（/apps/techou/line/login）→ もどると sessionStorage に しるし（2時間）
//   ・しるしで /apps/techou/photos から 日付と 絵の URL（cdn.shopify.com だけ）を もらう
//   ・絵は 小さくして data: に してから 紙の SVG の 目じるし（rect[data-enikki]）に 入れる → 画面にも 印刷にも 出る
//   ・出し方：出さない／いちばん新しい1まい（はじめ）／いちばん古い1まい。マスを おすと その日の 絵を じゅんばんに かえる
//   ★楽天では 何も しない（楽天の 外の アドレスも 書かない。/apps/… は 本店の 中の 道）
//   ★絵の URL は ここでも もう一度 たしかめる。文字として HTML に 入れない（SVG の href に data: だけ）
//   ★えにっきbook の データには 書きこまない（読むだけ）
const ENIKKI = {
  on: SHOP === 'shopify',
  status: 'off',            // off＝LINE で見る まえ／loading／ok／none＝絵が ない／err
  photos: {},               // '2026-09-19' → [URL…]（あとに 入れたものが うしろ）
  range: '',                // 読みこんだ 期間（はじまり月が かわったら 読みなおす）
  imgs: new Map(),          // URL → data:（null＝よめなかった・'wait'＝読みこみ中）
  ver: 0,                   // 絵が ふえたら ふやす（絵の 作りおきの 名前に 入る）
  cells: new Map(),         // 紙の 絵の URL → [{date,x,y,w,h}]（mm）
  /* ★v0.2.124 スタンプ（おきにいりの 絵を 紙に 貼る）
     stamps … '2026-09' → [{ id, url, x, y, s, r }]（x,y,s は 紙に 対する わりあい 0〜1）
     sver   … 貼りかえたら ふやす（絵の 作りおきの 名前に 入る）
     pick   … いま えらんでいる スタンプの URL（null＝貼るモードでは ない）
     list   … マイスタンプの 一覧 [{url,name}] */
  stamps: {}, sver: 0, pick: null, list: null, saveTimer: 0,
};
const STAMP_SIZES = [0.16, 0.26, 0.38];   // 押すたびに 大きく → さいごに 消える（紙の はばに 対する わりあい）
const ENIKKI_KEY = 'tk_enikki';
const ENIKKI_URL_RE = /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0741\/1518\/7005\/[^\s"'<>\\]+$/;   // ★安全の 係 L6 このお店の 画像置き場だけ
const ENIKKI_PX = 420;      // 小さくした 絵の いちばん長い辺（印刷でも 約500dpi）
function enikkiToken() {
  try { const t = sessionStorage.getItem(ENIKKI_KEY); return t && /^tk1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/.test(t) ? t : ''; } catch (e) { return ''; }
}
// ★v0.2.115 みなとさん：絵は 月間式の 形 ぜんぶで 出す（マスの ある 形だけ 実際に 出る）
// ★v0.2.118 お店（Shopify）に ログインしているか。テーマの head.liquid が わたす
const SHOP_LOGGED_IN = window.TK_LOGGED_IN === true;
const enikkiWants = note => ENIKKI.on && ENIKKI.status === 'ok' && state.enikki.mode > 0 && !!note && note.fmt.cat === 'month';
const enikkiKey = note => (enikkiWants(note) ? '\u0002' + state.enikki.mode + ENIKKI.ver + JSON.stringify(state.enikki.pick) : '') + (ENIKKI.on ? '\u0003' + ENIKKI.sver : '');
// その日に 出す 絵の URL
function enikkiUrl(date) {
  const list = ENIKKI.photos[date];
  if (!Array.isArray(list) || !list.length || state.enikki.mode === 0) return '';
  const p = state.enikki.pick[date];
  if (Number.isInteger(p)) return list[((p % list.length) + list.length) % list.length];
  return state.enikki.mode === 2 ? list[0] : list[list.length - 1];
}
// 紙の SVG の 目じるしに 絵を 入れる（まだ 読みこんでいない 絵は 読みはじめて、できたら ぬりなおす）
function fillEnikki(svg) {
  const cells = [];
  svg.querySelectorAll('rect[data-enikki]').forEach(r => {
    const date = r.getAttribute('data-enikki');
    const c = { date, x: +r.getAttribute('x'), y: +r.getAttribute('y'), w: +r.getAttribute('width'), h: +r.getAttribute('height') };
    cells.push(c);
    const u = enikkiUrl(date);
    const data = u && ENIKKI.imgs.get(u);
    if (!u) return;
    if (data === undefined) { enikkiLoadImg(u); return; }
    if (typeof data !== 'string' || !/^data:image\/(jpeg|png);base64,/.test(data)) return;   // ★v0.2.126 PNG も
    const im = svg.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'image');
    ['x', 'y', 'width', 'height'].forEach(a => im.setAttribute(a, r.getAttribute(a)));
    // ★v0.2.122 マスを ぜんぶ うめる（はみ出す ぶんは 切る）。絵は もともと 正方形で 描く
    im.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    im.setAttribute('href', data);
    r.replaceWith(im);
  });
  return cells;
}
/* ★v0.2.124 貼った スタンプを 紙に 入れる（えにっきの 絵と 同じく data: に した 絵を <image> で）
   ・その紙の 年月（月間なら その月・週間なら その週の 月）の ぶんだけ
   ・まだ 読みこんでいない 絵は 読みはじめて、できたら ぬりなおす（enikkiLoadImg と 同じ） */
function stampYm(note) {
  const at = note === yNote() ? sheetAt(note, state.ySheet) : note === state.notes[state.idx] ? state.at : sheetAt(note, sheetNear(note, curDate()));
  return at ? at.y + '-' + String(at.m).padStart(2, '0') : '';
}
function fillStamps(svg, note) {
  if (!ENIKKI.on || note === yNote()) return;
  const list = ENIKKI.stamps[stampYm(note)];
  if (!Array.isArray(list) || !list.length) return;
  const doc = svg.ownerDocument;
  for (const st of list) {
    const data = ENIKKI.imgs.get(st.url);
    if (data === undefined) { enikkiLoadImg(st.url); continue; }
    if (typeof data !== 'string' || !/^data:image\/(jpeg|png);base64,/.test(data)) continue;   // ★v0.2.126 PNG も
    const w = st.s * 182, cx = st.x * 182, cy = st.y * 257;
    const im = doc.createElementNS('http://www.w3.org/2000/svg', 'image');
    im.setAttribute('x', nf(cx - w / 2)); im.setAttribute('y', nf(cy - w / 2));
    im.setAttribute('width', nf(w)); im.setAttribute('height', nf(w));
    im.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    if (st.r) im.setAttribute('transform', `rotate(${nf(st.r)} ${nf(cx)} ${nf(cy)})`);
    im.setAttribute('data-stamp', st.id || '');
    im.setAttribute('href', data);
    svg.appendChild(im);
  }
}
// 貼った 場所を Worker に 保存（少し まとめてから）
function stampSave() {
  clearTimeout(ENIKKI.saveTimer);
  ENIKKI.saveTimer = setTimeout(async () => {
    try {
      const body = { data: ENIKKI.stamps };
      const t = enikkiToken(); if (t) body.t = t;
      await fetch('/apps/techou/stamps', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    } catch (e) { /* 保存できなくても 画面は そのまま */ }
  }, 800);
}
// 紙を 押した：貼るモードなら 置く／もう 貼って ある ものを 押したら 大きく → さいごは 消す
function stampTap(clientX, clientY) {
  if (!ENIKKI.on || curPage().sheet == null) return false;
  const note = state.notes[state.idx];
  if (note === yNote()) return false;
  const img = base.querySelector(':scope > img');
  const r = img && img.getBoundingClientRect();
  if (!r || !r.width) return false;
  const fx = (clientX - r.left) / r.width, fy = (clientY - r.top) / r.height;
  if (fx < 0 || fx > 1 || fy < 0 || fy > 1) return false;
  const ym = stampYm(note);
  const list = ENIKKI.stamps[ym] || (ENIKKI.stamps[ym] = []);
  // 貼って ある ものの 上か（近い 順）
  const hit = list.map(st => ({ st, d: Math.hypot((st.x - fx) * 182, (st.y - fy) * 257) })).filter(o => o.d <= o.st.s * 182 / 2).sort((a, b) => a.d - b.d)[0];
  if (hit) {
    const i = STAMP_SIZES.findIndex(v => Math.abs(v - hit.st.s) < 0.01);
    if (i >= 0 && i < STAMP_SIZES.length - 1) hit.st.s = STAMP_SIZES[i + 1];
    else list.splice(list.indexOf(hit.st), 1);
  } else {
    if (!ENIKKI.pick) return false;
    if (list.length >= 300) return false;
    list.push({ id: 'st' + Date.now().toString(36), url: ENIKKI.pick, x: Math.round(fx * 1000) / 1000, y: Math.round(fy * 1000) / 1000, s: STAMP_SIZES[0], r: 0 });
  }
  if (!list.length) delete ENIKKI.stamps[ym];
  ENIKKI.sver++;
  enikkiRepaint();
  stampSave();
  return true;
}
// マイスタンプの 一覧を もらう（tkdeko-proxy。合言葉は テーマの 部品が 自動で つける）
async function stampList() {
  if (ENIKKI.list) return ENIKKI.list;
  if (!SHOP_LOGGED_IN || typeof window.TK_KARTE !== 'string') return (ENIKKI.list = []);
  try {
    const j = await (await fetch(window.TK_KARTE + '/get_library')).json();
    const out = [];
    for (const items of Object.values((j && j.ok && j.data && j.data.lists) || {})) for (const it of items || []) {
      if (it && it.type === 'stamp' && typeof it.url === 'string' && ENIKKI_URL_RE.test(it.url)) out.push({ url: it.url, name: it.name || '', id: it.item_id || '', pub: it.pub === true });
    }
    ENIKKI.list = out;
  } catch (e) { ENIKKI.list = []; }
  return ENIKKI.list;
}
// ★v0.2.127 みんなの 公開スタンプ（名前・日づけは 来ない）
async function stampAllList() {
  if (typeof window.TK_KARTE !== 'string') return [];
  try {
    const j = await (await fetch(window.TK_KARTE + '/get_public_stamps?mode=latest')).json();
    return ((j && j.ok && j.stamps) || []).filter(st => st && typeof st.url === 'string' && ENIKKI_URL_RE.test(st.url) && st.item_id && st.owner);
  } catch (e) { return []; }
}
async function stampPost(path, body) {
  try { return await (await fetch(window.TK_KARTE + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })).json(); }
  catch (e) { return null; }
}
let stampTab = 'mine';
let enikkiRedrawTimer = 0;
async function enikkiLoadImg(u) {
  if (!ENIKKI_URL_RE.test(u) || ENIKKI.imgs.has(u)) return;
  ENIKKI.imgs.set(u, 'wait');
  let data = null;
  try {
    const res = await fetch(u + (u.includes('?') ? '&' : '?') + 'width=' + ENIKKI_PX, { mode: 'cors', credentials: 'omit' });
    if (!res.ok) throw new Error('img ' + res.status);
    const blob = await res.blob();
    const bmp = await createImageBitmap(blob);
    const k = Math.min(1, ENIKKI_PX / Math.max(bmp.width, bmp.height));
    const cv = document.createElement('canvas');
    cv.width = Math.max(1, Math.round(bmp.width * k)); cv.height = Math.max(1, Math.round(bmp.height * k));
    const g = cv.getContext('2d');
    /* ★v0.2.126 みなとさん：えにっきbook v4.90.0 から 絵は「透明の PNG」で 保存される。
       前は どの絵も 白の 上に のせて JPEG に していたので、紙に 白い 四角が 出ていた。
       PNG の ときは 白を しかず PNG の まま → 紙の 色の 上に 線だけ 透ける。写真（JPEG）は これまで どおり */
    const png = /image\/png/i.test(blob.type) || /\.png(\?|$)/i.test(u.split('?')[0] + (u.includes('?') ? '?' : ''));
    if (!png) { g.fillStyle = '#ffffff'; g.fillRect(0, 0, cv.width, cv.height); }   // JPEG は 白の 上に
    g.drawImage(bmp, 0, 0, cv.width, cv.height);
    data = png ? cv.toDataURL('image/png') : cv.toDataURL('image/jpeg', .86);
  } catch (e) { data = null; }
  ENIKKI.imgs.set(u, data);
  ENIKKI.ver++;
  clearTimeout(enikkiRedrawTimer);
  enikkiRedrawTimer = setTimeout(enikkiRepaint, 120);   // いくつか まとめて ぬりなおす
}
function enikkiRepaint() {
  const my = ++colorTurn;
  repaint().then(() => { if (my === colorTurn) clearTinted([base.querySelector(':scope > img').src]); });
}
// 1冊の 期間（はじまり月から 24か月）の 絵を もらう
function enikkiRange() {
  const ym = i => { const d = new Date(state.year, state.month - 1 + i, 1); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'); };
  return { from: ym(0), to: ym(23) };
}
async function enikkiLoad() {
  if (!ENIKKI.on) return;
  const t = enikkiToken();
  // ★v0.2.118 LINE の しるしが なくても、お店に ログインしていれば 聞いてみる
  //   （Shopify が 署名つきで お客さま番号を Worker に わたしてくれる）
  if (!t && !SHOP_LOGGED_IN) { ENIKKI.status = 'off'; syncEnikki(); return; }
  const rg = enikkiRange();
  ENIKKI.status = 'loading'; ENIKKI.range = rg.from + '/' + rg.to; syncEnikki();
  let j = null, code = 0;
  try {
    const res = await fetch('/apps/techou/photos', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ t, from: rg.from, to: rg.to }) });
    code = res.status;
    j = res.ok ? await res.json() : null;
  } catch (e) { j = null; }
  if (code === 401) {                              // しるしの 期限ぎれ → もう一度 LINE で
    if (t) { enikkiLogout(); return; }
    ENIKKI.status = 'off'; ENIKKI.via = ''; syncEnikki(); return;
  }
  if (!j || !j.ok || typeof j.photos !== 'object' || !j.photos) { ENIKKI.status = 'err'; syncEnikki(); return; }
  const photos = {};
  for (const [d, list] of Object.entries(j.photos)) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || !Array.isArray(list)) continue;
    const ok = list.filter(u => typeof u === 'string' && ENIKKI_URL_RE.test(u));
    if (ok.length) photos[d] = ok;
  }
  ENIKKI.photos = photos;
  // ★v0.2.124 貼った スタンプ（Worker が 形を たしかめてから 返す）
  const stamps = {};
  for (const [ym, list] of Object.entries(j.stamps && typeof j.stamps === 'object' ? j.stamps : {})) {
    if (!/^\d{4}-\d{2}$/.test(ym) || !Array.isArray(list)) continue;
    const ok = list.filter(st => st && typeof st.url === 'string' && ENIKKI_URL_RE.test(st.url) && st.x >= 0 && st.x <= 1 && st.y >= 0 && st.y <= 1 && st.s > 0 && st.s <= 1)
      .map(st => ({ id: String(st.id || ''), url: st.url, x: +st.x, y: +st.y, s: +st.s, r: +st.r || 0 }));
    if (ok.length) stamps[ym] = ok;
  }
  ENIKKI.stamps = stamps; ENIKKI.sver++;
  ENIKKI.via = j.via === 'shop' ? 'shop' : 'line';   // ★v0.2.118 どちらで 見ているか
  ENIKKI.linked = !!j.linked;                        // ★v0.2.119 お店の アカウントと LINE が つながっているか
  ENIKKI.status = Object.keys(photos).length ? 'ok' : 'none';
  ENIKKI.ver++;
  syncEnikki();
  enikkiRepaint();
}
// ★v0.2.110 本店の 商品ページでは、この ページは iframe（お店の ヘッダーの 中）に 入っている。
//   カゴや LINE の ログインは、いちばん外の 窓を うごかす（同じ お店の 中なので できる）
function topWin() {
  try { if (window.top && window.top !== window && window.top.location.hostname) return window.top; } catch (e) {}
  return window;
}
function goTop(url) { topWin().location.href = url; }
function enikkiLogin() {
  const t = topWin().location;
  const q = new URLSearchParams({ h: t.hostname, r: t.pathname + t.search });
  goTop('/apps/techou/line/login?' + q);
}
function enikkiLogout() {
  try { sessionStorage.removeItem(ENIKKI_KEY); } catch (e) {}
  ENIKKI.status = 'off'; ENIKKI.photos = {}; ENIKKI.ver++;
  syncEnikki();
  enikkiRepaint();
}
// マスを おしたら その日の つぎの 絵に（紙の 上の 場所 → mm）
function enikkiTap(clientX, clientY) {
  if (!enikkiWants(state.notes[state.idx]) || curPage().sheet == null) return false;
  const img = base.querySelector(':scope > img');
  const cells = ENIKKI.cells.get(img.src);
  if (!cells) return false;
  const r = img.getBoundingClientRect();
  if (!r.width) return false;
  const mx = (clientX - r.left) / r.width * 182, my = (clientY - r.top) / r.height * 257;
  const c = cells.find(c => mx >= c.x && mx <= c.x + c.w && my >= c.y - 1 && my <= c.y + c.h);
  const list = c && ENIKKI.photos[c.date];
  if (!list || list.length < 2) return false;
  const now = list.indexOf(enikkiUrl(c.date));
  state.enikki.pick[c.date] = (now + 1) % list.length;
  enikkiRepaint();
  return true;
}
// 表示パネルの「えにっき」
function syncEnikki() {
  const box = $('enikkiBox');
  if (!box) return;
  box.hidden = !ENIKKI.on;
  if (!ENIKKI.on) return;
  const st = ENIKKI.status;
  const kids = [];
  const note = (t) => { const n = mk('div', 'cap-hint', t); return n; };
  const btn = (t, fn, cls = 'print-go') => { const b = mk('button', cls, t); b.type = 'button'; b.onclick = fn; return b; };
  if (st === 'off') {
    kids.push(note(TEXTS.enikkiAbout), btn(TEXTS.enikkiLogin, enikkiLogin, 'print-go line-go'));   // ★v0.2.117 LINE の 緑
  } else if (st === 'loading') {
    kids.push(note(TEXTS.enikkiLoading));
  } else if (st === 'err') {
    kids.push(note(TEXTS.enikkiErr), btn(TEXTS.enikkiRetry, enikkiLoad));
  } else {
    const line = mk('div', 'cm-line');
    line.append(mk('div', 'cm-sec', TEXTS.enikkiShowTitle));
    const sg = mk('div', 'cm-seg');
    seg(sg, TEXTS.enikkiModes, state.enikki.mode, i => { state.enikki.mode = i; state.enikki.pick = {}; syncEnikki(); enikkiRepaint(); });
    line.append(sg);
    kids.push(line);
    const shopWay = ENIKKI.via === 'shop';
    kids.push(note(st === 'none' ? (shopWay ? TEXTS.enikkiNoneShop : TEXTS.enikkiNone) : TEXTS.enikkiCount(Object.keys(ENIKKI.photos).length)));
    if (st === 'ok') kids.push(note(TEXTS.enikkiTapNote));
    // ★v0.2.118 お店の アカウントで 見ているとき：そのことを 出し、LINE でも 見られるように
    if (shopWay) {
      kids.push(note(ENIKKI.linked ? TEXTS.enikkiLinked : TEXTS.enikkiViaShop));
      // ★v0.2.119 まだ つながっていない人には、つなぎ方を おしえる
      if (!ENIKKI.linked) kids.push(note(TEXTS.enikkiLinkHint));
      kids.push(btn(TEXTS.enikkiLoginAlso, enikkiLogin, 'print-go line-go'));
    }
  }
  // 「LINE から はずす」は LINE で 見ているときだけ
  if (st !== 'off' && ENIKKI.via !== 'shop') kids.push(btn(TEXTS.enikkiLogout, enikkiLogout, 'enikki-out'));
  /* ★v0.2.123 いまの 形（?d= の 中身）を おきにいりに 入れる
     ・お店（Shopify）で ログインしている ときだけ 出す。楽天では 出ない
     ・送る 先は head.liquid が わたす TK_KARTE。合言葉は テーマの 部品が 自動で つける */
  if (SHOP_LOGGED_IN && typeof window.TK_KARTE === 'string') {
    const fb = btn(TEXTS.favSave, () => favSaveOrder(fb), 'print-go');
    kids.push(fb, note(''));
    // ★v0.2.124 スタンプの 一覧（おきにいり → スタンプ）。えらぶと 貼るモード
    const sec = mk('div', 'cm-sec', TEXTS.stampTitle);
    // ★v0.2.127 じぶんの／みんなの
    const tabs = mk('div', 'cm-seg');
    seg(tabs, [TEXTS.stampMine, TEXTS.stampAll], stampTab === 'mine' ? 0 : 1, i => { stampTab = i ? 'all' : 'mine'; syncEnikki(); });
    const box = mk('div', 'stamp-list');
    kids.push(sec, tabs, box, note(stampTab === 'mine' ? TEXTS.stampHint : ''));
    const thumb = (it, cls) => { const b = mk('button', cls); b.type = 'button'; b.title = it.name || '';
      const im = new Image(); im.src = it.url + (it.url.includes('?') ? '&' : '?') + 'width=120'; im.alt = it.name || ''; b.append(im); return b; };
    if (stampTab === 'mine') {
      stampList().then(list => {
        box.replaceChildren();
        if (!list.length) { box.append(note(TEXTS.stampNone)); return; }
        for (const it of list) {
          const wrap = mk('div', 'stamp-cell');
          const b = thumb(it, 'stamp-pick' + (ENIKKI.pick === it.url ? ' on' : ''));
          b.onclick = () => { ENIKKI.pick = ENIKKI.pick === it.url ? null : it.url; syncEnikki(); };
          wrap.append(b);
          // 公開の スイッチ（1まいずつ・はじめは 非公開）
          if (it.id) {
            const p = mk('button', 'stamp-mini' + (it.pub ? ' on' : ''), it.pub ? TEXTS.stampUnpub : TEXTS.stampPub);
            p.type = 'button';
            p.onclick = async () => {
              if (!it.pub && !confirm(TEXTS.stampPubAsk)) return;
              p.disabled = true;
              const r = await stampPost('/toggle_stamp_public', { item_id: it.id });
              if (r && r.ok) { it.pub = !!r.pub; ENIKKI.list = null; alert(r.pub ? TEXTS.stampPubOn : TEXTS.stampPubOff); syncEnikki(); }
              else p.disabled = false;
            };
            wrap.append(p);
          }
          box.append(wrap);
        }
        if (ENIKKI.pick) box.append(btn(TEXTS.stampOff, () => { ENIKKI.pick = null; syncEnikki(); }, 'enikki-out'));
      });
    } else {
      stampAllList().then(list => {
        box.replaceChildren();
        if (!list.length) { box.append(note(TEXTS.stampAllNone)); return; }
        for (const it of list) {
          const wrap = mk('div', 'stamp-cell');
          const b = thumb(it, 'stamp-pick');
          // 押すと 自分の スタンプに 写す（そのあと じぶんの から 貼れる）
          b.onclick = async () => {
            b.disabled = true;
            const r = await stampPost('/copy_stamp', { item_id: it.item_id, owner: it.owner });
            if (r && r.ok) { ENIKKI.list = null; alert(TEXTS.stampCopied); }
            else alert((r && r.error) || TEXTS.stampCopyErr);
            b.disabled = false;
          };
          const rp = mk('button', 'stamp-mini', TEXTS.stampReport); rp.type = 'button';
          rp.onclick = async () => { if (!confirm(TEXTS.stampReportAsk)) return; const r = await stampPost('/report_stamp', { item_id: it.item_id, owner: it.owner }); if (r && r.ok) { alert(TEXTS.stampReported); syncEnikki(); } };
          wrap.append(b, rp);
          box.append(wrap);
        }
      });
    }
    box.append(note(TEXTS.stampLoading));
  }
  $('enikkiBody').replaceChildren(...kids);
}
// ★nv0.2.93 マイノートの カードに 出す 小さな 見本（表紙の 色・紙の 色・線の 色）
function designThumbSvg() {
  const hasBinder = state.binder !== 'none';
  const cover = hasBinder ? state.color : '#ffffff';
  const paper = SHEET_COLOR;
  const ink = state.color;
  const W = 120, H = 160;
  let s = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}">`;
  s += `<rect x="1" y="1" width="${W - 2}" height="${H - 2}" rx="6" fill="${paper}" stroke="#d9d3c4" stroke-width="2"/>`;
  if (hasBinder) s += `<rect x="1" y="1" width="${Math.round(W * 0.3)}" height="${H - 2}" rx="6" fill="${cover}"/>`;
  const x0 = Math.round(W * 0.3) + 14, x1 = W - 12;
  for (let i = 0; i < 6; i++) { const y = 26 + i * 20; s += `<line x1="${x0}" y1="${y}" x2="${x1}" y2="${y}" stroke="${ink}" stroke-width="1.6" opacity=".55"/>`; }
  // リング（穴）を 表紙と 紙の さかいめに
  const ringX = Math.round(W * 0.3) + 1;
  for (let i = 0; i < 5; i++) s += `<circle cx="${ringX}" cy="${20 + i * 28}" r="3" fill="none" stroke="#c9c4bc" stroke-width="1.6"/>`;
  s += `</svg>`;
  return s;
}
// ★v0.2.123 おきにいり（オーダー）に 入れる／もう一度 押すと はずれる
async function favSaveOrder(b, msgEl) {
  const note = msgEl || b.nextSibling;   // ★手帳と おなじ（2つめ＝結果を 書く 場所）
  b.disabled = true; if (note) note.textContent = TEXTS.favSaving;
  try {
    const n = state.notes[state.idx];
    const name = (n ? n.fmt.name : '') + ' ' + state.year + '年' + state.month + '月';
    const r = await fetch(window.TK_KARTE + '/save_item', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'order', okind: 'note', d: shareCode(), name: name.trim().slice(0, 40), thumb: designThumbSvg() }) });   // ★2026-10-15 ノートの デザインは マイノートの フォルダへ
    const j = await r.json();
    if (note) note.textContent = j && j.ok ? (j.toggled ? TEXTS.favDone : TEXTS.favOff) : (j && j.error === 'limit' && j.message ? j.message : TEXTS.favErr);
  } catch (e) { if (note) note.textContent = TEXTS.favErr; }
  b.disabled = false;
}

// ===== 紙（1枚ぶん）=====
let _holesSvg = '';
function holesSvg() {
  if (!_holesSvg) {
    let c = '';
    // ★nv0.2.162 穴の あいだが ふぞろいな サイズ（バイブル）：gaps（穴の あいだ）か pitch（等間隔）を 辺の まん中に そろえる。x＝はしから 穴の 中心まで（無ければ 6.5）
    const topSide = PSEL.side === 'top', along = topSide ? PSEL.w : PSEL.h, xe = PSEL.x || 6.5, rr = PSEL.r || 2.6;
    const gaps = PSEL.gaps || Array.from({ length: Math.max(PSEL.holes - 1, 0) }, () => PSEL.pitch);
    let a = (along - gaps.reduce((t, g) => t + g, 0)) / 2;
    const at = PSEL.holes ? [a] : []; if (PSEL.holes) gaps.forEach(g => { a += g; at.push(a); });
    c = at.map(v => topSide ? `<circle cx="${v.toFixed(2)}" cy="${xe}" r="${rr}"/>` : `<circle cx="${xe}" cy="${v.toFixed(2)}" r="${rr}"/>`).join('');
    _holesSvg = `<svg class="holes" viewBox="0 0 ${PSEL.w} ${PSEL.h}" aria-hidden="true"><g style="fill:var(--hole-fill,#faf7f0)" stroke="#d9d3c4" stroke-width=".3">${c}</g></svg>`;
  }
  return _holesSvg;
}
/* ★ノートの ホスト部品（ペンの 本体は 手帳と 共有。_shared_ink/tk_ink.js → sync_ink.py で ここに 入る） */
const noteInkPaperMm = () => (typeof PSEL !== 'undefined' && PSEL.w) || 182;
function noteInkPageNo() { const p = curPage(); return (p && p.sheet != null ? p.sheet : 0) + 1; }
/* ★2026-10-19 みなとさん「ノートは ふつう 2ページまで・プラス会員は 52ページまで」「ノートの 種類と ページごとに 保存」「表示されて いる ノートごと」
   ・ページの 名前＝ n:<紙の 大きさ>:<柄の ID>:<ページ>（紙の 大きさ × 柄 ＝ いま 表示して いる ノート。前の n1〜n3 は つかわない）
   ・上限＝ふつう 2 ／ 会員 52（会員かどうかは 印刷の のこりを 聞く とき 一緒に わかる＝ noteQuotaLoad）。Worker も おなじ きまりで ことわる */
const NOTE_PAGES_FREE = 2, NOTE_PAGES_MEMBER = 52;
const noteWriteMax = () => (+window.TK_NOTE_PAGES >= NOTE_PAGES_FREE ? +window.TK_NOTE_PAGES : NOTE_PAGES_FREE);
function noteInkPrefix() { const n = state.notes && state.notes[state.idx]; const id = n && n.id != null ? String(n.id).replace(/[^A-Za-z0-9-]/g, '').slice(0, 16) : ''; return 'n:' + String(PSIZE).replace(/[^a-z0-9]/g, '').slice(0, 8) + ':' + (id || 'x') + ':'; }
const noteInkKey = () => noteInkPageNo() <= noteWriteMax() ? noteInkPrefix() + noteInkPageNo() : null;   // ノートの ページの 名前（ノートごと）
const noteInkLabel = () => noteInkPageNo() <= noteWriteMax() ? noteInkPageNo() + ' ページめ' : '書けるのは ' + noteWriteMax() + 'ページまで' + (window.TK_PLUS ? '' : '（プラス会員は ' + NOTE_PAGES_MEMBER + 'ページ）');
function noteInkVisit(key) { const m = /^(.*?)(\d+)$/.exec(String(key || '')); if (!m) return; const n = +m[2]; if (NOTEINK.visitedFor !== m[1]) { NOTEINK.visitedFor = m[1]; NOTEINK.visited = 1; } if (n > NOTEINK.visited) NOTEINK.visited = n; }
function noteInkLast() { const pre = noteInkPrefix(); let m = 0; for (const k of Object.keys(NOTEINK.pages)) { if (k.indexOf(pre) !== 0) continue; const n = +k.slice(pre.length); if (n > m && Array.isArray(NOTEINK.pages[k]) && NOTEINK.pages[k].length) m = n; } return m; }
function noteHomeCount() { const vis = NOTEINK.visitedFor === noteInkPrefix() ? NOTEINK.visited : 1; return Math.min(noteWriteMax(), Math.max(1, noteInkLast() + 1, vis + 1)); }   // ★ふつう 2ページ・会員 52ページまで
/* ★2026-10-19 会員かどうか（印刷の のこりと いっしょに わかる）→ ノートの ページ上限（ふつう 2・会員 52）。読めなければ ふつう あつかい */
async function noteQuotaLoad() {
  if (typeof SHOP === 'undefined' || SHOP !== 'shopify' || !SHOP_LOGGED_IN) return;
  try {
    const r = await fetch('/apps/techou/print-quota', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => null);
    if (r.ok && j && j.ok) { window.TK_PLUS = !!j.member; window.TK_NOTE_PAGES = +j.notePages >= NOTE_PAGES_FREE ? +j.notePages : NOTE_PAGES_FREE; NOTEINK.rev++; if (typeof noteInkRender === 'function') noteInkRender(); }
  } catch (e) { /* 読めなくても ふつうの 2ページで 書ける */ }
}
/* INK-BEGIN ★手帳と ノートで 同じ ペン（_shared_ink/tk_ink.js が 本体。直す ときは ここを 直して `python3 _shared_ink/sync_ink.py`） */
/* ★2026-10-15 みなとさん「ペンを えにっきと 同じに。表示（下の バー）も 同じに」「手帳でも 書ける ように」「スタンプ・アイコン・写真・まわす も」
   ------------------------------------------------------------
   ・トップページ（?tkhome=1）の 手帳・ノートに、紙の 上へ canvas を かさねて 書く
   ・ペンの 描きかたは えにっきbook（space-drawing.js）の 筆エンジンを 写した もの
       ①手ぶれを ならす（行きと 帰りの 2回）②速さから 筆圧 ③点ごとの 太さ ④左右に 輪郭を 作って 塗る（掠れは 毛の 束）
   ・太さ・筆圧・手ぶれ補正・色・道具の 出し入れは **えにっきで 保存した 設定**（共通設定）を 読んで つかう（/apps/techou/pen-settings・読むだけ）
   ・下の バーは えにっきの #sd-colors と 同じ：消しゴム・まわす・ペン・スタンプ・アイコン・写真 ＋ 色の 丸
       ペン＝ペン／筆／掠れ（「書」は まだ）／消しゴム＝消しゴム・戻る・全消し／スタンプ＝マイスタンプ（おきにいりの 絵）／アイコン＝線の スタンプ 12こ／写真＝えらぶ・白ぬき・大小・消す／まわす＝紙を 立体で かたむける
   ・線は 0〜10000 の 整数の 点列（p）＋ 点ごとの 筆圧（q）。画像は {o:'img',u,x,y,w,a}。ページごとに /apps/techou/note-pages へ 保存（ログイン前は この ブラウザ）
   ・ホスト（手帳／ノート）が 用意する もの：noteInkKey()＝いまの ページの 名前（なければ null）／noteInkLabel()／noteInkTapThrough?(x,y)／noteInkPaperMm() */
const NOTEINK = { pages: {}, loaded: false, color: '#1e88e5', tool: 'pen', mode: 'pen', scroll: false, sq: null, visited: 1, undo: {}, dirty: new Set(), cv: null, live: null, bar: null, sqEl: null, msg: null, fileEl: null, W: 462, Hpx: 652, H: 14121, dpr: 1, msgT: 0, idleT: 0,
  cfg: {}, visible: null, sqHtml: '', rev: 0, pcache: null, psig: '', imgs: new Map(), sel: null, selG: null, stampUrl: null, iconId: null, whiteout: false, tilt: { a: 0, b: 0 }, rot: { x: 0.2, y: 0 }, ball: { x: 14, y: 70, el: null, cv: null }, colorTouched: false, busy: false };
/* ★2026-10-16 みなとさん「まだ 途切れます」＝原因を 当てずに 数字で たしかめる ための 診断（?inkdebug=1 を トップの アドレスに つけると ONに なる。?inkdebug=0 で OFF）。
   線を 1本 書く たびに「イベントの 数・いちばん あいた 間（ms）・ほぞんした 点・まびいた 点・点の 上限に あたったか・中断（pointercancel）の 回数」を 左上に 出す */
const NOTE_DBG = (() => { try { return localStorage.getItem('tk_ink_debug') === '1'; } catch (e) { return false; } })();
const noteDbg = { ev: 0, kept: 0, skip: 0, cap: 0, gap: 0, last: 0, coal: 0, cancel: 0, type: '', n: 0, el: null, t0: 0 };
function noteDbgShow() {
  if (!NOTE_DBG) return;
  if (!noteDbg.el) { const el = document.createElement('pre'); el.style.cssText = 'position:fixed;left:4px;top:4px;z-index:99999;margin:0;padding:4px 6px;background:rgba(0,0,0,.78);color:#9f9;font:10px/1.3 monospace;border-radius:4px;pointer-events:none;white-space:pre'; document.body.appendChild(el); noteDbg.el = el; }
  noteDbg.el.textContent = '線#' + noteDbg.n + ' ' + noteDbg.type + '  ' + Math.round(performance.now() - noteDbg.t0) + 'ms\nイベント ' + noteDbg.ev + '（まとめ ' + noteDbg.coal + '）\n点 ' + noteDbg.kept + ' まびき ' + noteDbg.skip + ' 上限 ' + noteDbg.cap + '\nいちばん あいた間 ' + Math.round(noteDbg.gap) + 'ms\nキャンセル ' + noteDbg.cancel + '\ngetCoalesced ' + (typeof PointerEvent !== 'undefined' && 'getCoalescedEvents' in PointerEvent.prototype ? 'あり' : 'なし') + '\nzoom ' + (typeof zoom !== 'undefined' ? zoom.s.toFixed(2) : '-');
}
const NOTE_LS = 'tk_note_pages_v3', NOTE_STROKES_MAX = 1000, NOTE_POINTS_MAX = 3000;
const NOTE_PENS = { pen: { thinning: 0.15, streamline: 0.45, taper: 0 }, sho: { thinning: 0.55, streamline: 0.3, taper: 0 }, fude: { thinning: 0.75, streamline: 0.55, taper: 0.55 }, kasure: { thinning: 0.5, streamline: 0.35, taper: 0.25 } };
const NOTE_PEN_NAME = { pen: 'ペン', sho: '書', fude: '筆', kasure: '掠れ' };
const NOTE_MM_PER_PX = 0.1;      // えにっきの 1px が 紙の 何mmに あたるか（太さ 16 ＝ 1.6mm）
const NOTE_ICON_BASE = 0.108;    // アイコンの 大きさ（えにっきの 0.44 が 紙の はばの 10.8%）
const NOTE_LINE_RATIO = 1.7 / 24;   // アイコンの 線の 太さ（えにっきと 同じ）
const NOTE_STAMPS = [{"id":"byoin","name":"病院","size":0.44,"g":"basic","lines":[[[0.167,0.854],[0.167,0.392],[0.5,0.158],[0.833,0.392],[0.833,0.854]],[[0.1,0.854],[0.9,0.854]],[[0.5,0.442],[0.5,0.658]],[[0.392,0.55],[0.608,0.55]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4 20.5V9.4L12 3.8l8 5.6v11.1\"/><path d=\"M2.4 20.5h19.2\"/><path d=\"M12 10.6v5.2M9.4 13.2h5.2\"/></svg>"},{"id":"biyoin","name":"美容院","size":0.44,"g":"basic","lines":[[[0.363,0.633],[0.775,0.142]],[[0.638,0.633],[0.225,0.142]],[[0.4,0.725],[0.399,0.743],[0.395,0.76],[0.389,0.777],[0.38,0.793],[0.37,0.807],[0.357,0.82],[0.343,0.83],[0.327,0.839],[0.31,0.845],[0.293,0.849],[0.275,0.85],[0.257,0.849],[0.24,0.845],[0.223,0.839],[0.207,0.83],[0.193,0.82],[0.181,0.807],[0.17,0.793],[0.161,0.777],[0.155,0.76],[0.151,0.743],[0.15,0.725],[0.151,0.707],[0.155,0.69],[0.161,0.673],[0.17,0.657],[0.181,0.643],[0.193,0.631],[0.207,0.62],[0.223,0.611],[0.24,0.605],[0.257,0.601],[0.275,0.6],[0.293,0.601],[0.31,0.605],[0.327,0.611],[0.343,0.62],[0.357,0.631],[0.37,0.643],[0.38,0.657],[0.389,0.673],[0.395,0.69],[0.399,0.707],[0.4,0.725]],[[0.85,0.725],[0.849,0.743],[0.845,0.76],[0.839,0.777],[0.83,0.793],[0.82,0.807],[0.807,0.82],[0.793,0.83],[0.777,0.839],[0.76,0.845],[0.743,0.849],[0.725,0.85],[0.707,0.849],[0.69,0.845],[0.673,0.839],[0.657,0.83],[0.643,0.82],[0.631,0.807],[0.62,0.793],[0.611,0.777],[0.605,0.76],[0.601,0.743],[0.6,0.725],[0.601,0.707],[0.605,0.69],[0.611,0.673],[0.62,0.657],[0.631,0.643],[0.643,0.631],[0.657,0.62],[0.673,0.611],[0.69,0.605],[0.707,0.601],[0.725,0.6],[0.743,0.601],[0.76,0.605],[0.777,0.611],[0.793,0.62],[0.807,0.631],[0.82,0.643],[0.83,0.657],[0.839,0.673],[0.845,0.69],[0.849,0.707],[0.85,0.725]],[[0.546,0.471],[0.545,0.477],[0.544,0.484],[0.542,0.49],[0.539,0.496],[0.535,0.501],[0.53,0.505],[0.525,0.509],[0.519,0.513],[0.513,0.515],[0.506,0.516],[0.5,0.517],[0.494,0.516],[0.487,0.515],[0.481,0.513],[0.475,0.509],[0.47,0.505],[0.465,0.501],[0.461,0.496],[0.458,0.49],[0.456,0.484],[0.455,0.477],[0.454,0.471],[0.455,0.464],[0.456,0.458],[0.458,0.452],[0.461,0.446],[0.465,0.441],[0.47,0.436],[0.475,0.432],[0.481,0.429],[0.487,0.427],[0.494,0.426],[0.5,0.425],[0.506,0.426],[0.513,0.427],[0.519,0.429],[0.525,0.432],[0.53,0.436],[0.535,0.441],[0.539,0.446],[0.542,0.452],[0.544,0.458],[0.545,0.464],[0.546,0.471]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"6.6\" cy=\"17.4\" r=\"3\"/><circle cx=\"17.4\" cy=\"17.4\" r=\"3\"/><path d=\"M8.7 15.2L18.6 3.4\"/><path d=\"M15.3 15.2L5.4 3.4\"/><circle cx=\"12\" cy=\"11.3\" r=\"1.1\"/></svg>"},{"id":"shokuji","name":"食事","size":0.44,"g":"basic","lines":[[[0.233,0.142],[0.233,0.375],[0.235,0.396],[0.242,0.417],[0.252,0.435],[0.265,0.452],[0.282,0.465],[0.3,0.475],[0.321,0.481],[0.342,0.483],[0.363,0.481],[0.383,0.475],[0.402,0.465],[0.418,0.452],[0.432,0.435],[0.442,0.417],[0.448,0.396],[0.45,0.375],[0.45,0.142]],[[0.342,0.142],[0.342,0.375]],[[0.342,0.483],[0.342,0.858]],[[0.725,0.142],[0.742,0.163],[0.756,0.188],[0.767,0.215],[0.776,0.245],[0.782,0.276],[0.786,0.308],[0.788,0.341],[0.786,0.373],[0.782,0.405],[0.776,0.435],[0.767,0.464],[0.756,0.49],[0.742,0.514],[0.725,0.533],[0.617,0.533],[0.617,0.142],[0.725,0.142]],[[0.671,0.533],[0.671,0.858]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5.6 3.4v5.6a2.6 2.6 0 0 0 5.2 0V3.4\"/><path d=\"M8.2 3.4v5.6\"/><path d=\"M8.2 11.6v9\"/><path d=\"M17.4 3.4c2 2.2 2 7.4 0 9.4h-2.6V3.4z\"/><path d=\"M16.1 12.8v7.8\"/></svg>"},{"id":"gakko","name":"学校","size":0.48,"g":"basic","lines":[[[0.142,0.854],[0.142,0.417],[0.858,0.417],[0.858,0.854]],[[0.083,0.854],[0.917,0.854]],[[0.5,0.417],[0.5,0.142]],[[0.5,0.158],[0.692,0.158],[0.642,0.221],[0.692,0.283],[0.5,0.283],[0.5,0.158]],[[0.275,0.542],[0.367,0.542]],[[0.633,0.542],[0.725,0.542]],[[0.433,0.854],[0.433,0.679],[0.567,0.679],[0.567,0.854]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3.4 20.5V10h17.2v10.5\"/><path d=\"M2 20.5h20\"/><path d=\"M12 10V3.4\"/><path d=\"M12 3.8h4.6l-1.2 1.5 1.2 1.5H12z\"/><path d=\"M6.6 13h2.2M15.2 13h2.2\"/><path d=\"M10.4 20.5v-4.2h3.2v4.2\"/></svg>"},{"id":"ha","name":"歯","size":0.4,"g":"basic","lines":[[[0.275,0.167],[0.261,0.176],[0.247,0.187],[0.236,0.199],[0.225,0.212],[0.217,0.226],[0.209,0.241],[0.203,0.257],[0.198,0.274],[0.194,0.292],[0.192,0.311],[0.191,0.33],[0.191,0.35],[0.193,0.371],[0.196,0.392],[0.2,0.418],[0.205,0.444],[0.21,0.469],[0.215,0.493],[0.221,0.517],[0.226,0.541],[0.231,0.565],[0.237,0.588],[0.242,0.612],[0.247,0.636],[0.252,0.661],[0.257,0.686],[0.262,0.711],[0.267,0.738],[0.27,0.752],[0.276,0.764],[0.282,0.775],[0.29,0.783],[0.299,0.79],[0.308,0.795],[0.318,0.797],[0.328,0.797],[0.337,0.795],[0.347,0.791],[0.355,0.784],[0.363,0.775],[0.37,0.764],[0.375,0.75],[0.417,0.604],[0.419,0.598],[0.423,0.594],[0.427,0.589],[0.432,0.586],[0.438,0.584],[0.444,0.583],[0.45,0.582],[0.456,0.583],[0.462,0.584],[0.468,0.586],[0.473,0.589],[0.478,0.594],[0.481,0.598],[0.483,0.604],[0.525,0.75],[0.53,0.764],[0.537,0.775],[0.545,0.784],[0.553,0.791],[0.563,0.795],[0.572,0.797],[0.582,0.797],[0.592,0.795],[0.601,0.79],[0.61,0.783],[0.618,0.775],[0.625,0.764],[0.63,0.752],[0.633,0.738],[0.638,0.711],[0.643,0.686],[0.648,0.661],[0.653,0.636],[0.658,0.612],[0.663,0.588],[0.669,0.565],[0.674,0.541],[0.679,0.517],[0.685,0.493],[0.69,0.469],[0.695,0.444],[0.7,0.418],[0.704,0.392],[0.707,0.371],[0.709,0.35],[0.709,0.33],[0.708,0.311],[0.706,0.292],[0.702,0.274],[0.697,0.257],[0.691,0.241],[0.684,0.226],[0.675,0.212],[0.664,0.199],[0.653,0.187],[0.64,0.176],[0.625,0.167],[0.611,0.16],[0.597,0.156],[0.582,0.154],[0.568,0.154],[0.555,0.155],[0.541,0.158],[0.528,0.161],[0.515,0.165],[0.503,0.169],[0.491,0.174],[0.48,0.177],[0.469,0.18],[0.459,0.183],[0.45,0.183],[0.441,0.183],[0.431,0.18],[0.42,0.177],[0.409,0.174],[0.397,0.169],[0.385,0.165],[0.372,0.161],[0.359,0.158],[0.345,0.155],[0.332,0.154],[0.318,0.154],[0.304,0.156],[0.289,0.16],[0.275,0.167],[0.275,0.167]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M6.6 4c-1.7 1-2.3 3-1.9 5.4.5 3 1.2 5.3 1.7 8.3.3 1.7 2.1 2 2.6.3l1-3.5c.2-.7 1.4-.7 1.6 0l1 3.5c.5 1.7 2.3 1.4 2.6-.3.5-3 1.2-5.3 1.7-8.3.4-2.4-.2-4.4-1.9-5.4-1.6-.9-3.2.4-4.2.4S8.2 3.1 6.6 4z\"/></svg>"},{"id":"saifu","name":"お財布","size":0.44,"g":"basic","lines":[[[0.183,0.45],[0.817,0.45],[0.858,0.667],[0.861,0.685],[0.861,0.703],[0.859,0.721],[0.855,0.738],[0.85,0.756],[0.842,0.772],[0.833,0.788],[0.823,0.802],[0.81,0.816],[0.797,0.827],[0.782,0.838],[0.766,0.846],[0.749,0.853],[0.732,0.858],[0.714,0.861],[0.696,0.863],[0.304,0.863],[0.286,0.861],[0.268,0.858],[0.251,0.853],[0.234,0.846],[0.218,0.838],[0.203,0.827],[0.19,0.816],[0.178,0.802],[0.167,0.788],[0.158,0.772],[0.15,0.756],[0.145,0.738],[0.141,0.721],[0.139,0.703],[0.14,0.685],[0.142,0.667],[0.183,0.45]],[[0.142,0.358],[0.858,0.358],[0.858,0.45],[0.142,0.45],[0.142,0.358]],[[0.317,0.358],[0.318,0.337],[0.322,0.317],[0.328,0.298],[0.336,0.28],[0.346,0.263],[0.357,0.248],[0.371,0.233],[0.386,0.221],[0.402,0.21],[0.42,0.201],[0.439,0.193],[0.458,0.188],[0.479,0.185],[0.5,0.183],[0.521,0.185],[0.542,0.188],[0.561,0.193],[0.58,0.201],[0.598,0.21],[0.614,0.221],[0.629,0.233],[0.643,0.248],[0.655,0.263],[0.665,0.28],[0.673,0.298],[0.678,0.317],[0.682,0.337],[0.683,0.358]],[[0.55,0.142],[0.55,0.149],[0.548,0.156],[0.546,0.162],[0.542,0.169],[0.538,0.174],[0.533,0.18],[0.527,0.184],[0.521,0.187],[0.514,0.19],[0.507,0.191],[0.5,0.192],[0.493,0.191],[0.486,0.19],[0.479,0.187],[0.473,0.184],[0.467,0.18],[0.462,0.174],[0.458,0.169],[0.455,0.162],[0.452,0.156],[0.451,0.149],[0.45,0.142],[0.451,0.135],[0.452,0.128],[0.455,0.121],[0.458,0.115],[0.462,0.109],[0.467,0.104],[0.473,0.1],[0.479,0.096],[0.486,0.094],[0.493,0.092],[0.5,0.092],[0.507,0.092],[0.514,0.094],[0.521,0.096],[0.527,0.1],[0.533,0.104],[0.538,0.109],[0.542,0.115],[0.546,0.121],[0.548,0.128],[0.55,0.135],[0.55,0.142]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4.4 10.8h15.2l1 5.2a4 4 0 0 1-3.9 4.7H7.3a4 4 0 0 1-3.9-4.7z\"/><path d=\"M3.4 8.6h17.2v2.2H3.4z\"/><path d=\"M7.6 8.6c0-2.4 2-4.2 4.4-4.2s4.4 1.8 4.4 4.2\"/><circle cx=\"12\" cy=\"3.4\" r=\"1.2\"/></svg>"},{"id":"ie","name":"家","size":0.44,"g":"basic","lines":[[[0.125,0.475],[0.5,0.158],[0.875,0.475]],[[0.225,0.4],[0.225,0.854],[0.775,0.854],[0.775,0.4]],[[0.4,0.854],[0.4,0.613],[0.6,0.613],[0.6,0.854]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 11.4L12 3.8l9 7.6\"/><path d=\"M5.4 9.6v10.9h13.2V9.6\"/><path d=\"M9.6 20.5v-5.8h4.8v5.8\"/></svg>"},{"id":"tegami","name":"手紙","size":0.44,"g":"basic","lines":[[[0.142,0.275],[0.5,0.542],[0.858,0.275]],[[0.192,0.225],[0.808,0.225],[0.808,0.225],[0.825,0.227],[0.841,0.232],[0.855,0.241],[0.867,0.253],[0.876,0.268],[0.882,0.283],[0.883,0.3],[0.883,0.7],[0.883,0.7],[0.882,0.717],[0.876,0.733],[0.867,0.747],[0.855,0.759],[0.841,0.768],[0.825,0.773],[0.808,0.775],[0.192,0.775],[0.192,0.775],[0.175,0.773],[0.159,0.768],[0.145,0.759],[0.133,0.747],[0.124,0.733],[0.119,0.717],[0.117,0.7],[0.117,0.3],[0.117,0.3],[0.119,0.283],[0.124,0.268],[0.133,0.253],[0.145,0.241],[0.159,0.232],[0.175,0.227],[0.192,0.225]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"2.8\" y=\"5.4\" width=\"18.4\" height=\"13.2\" rx=\"1.8\"/><path d=\"M3.4 6.6L12 13l8.6-6.4\"/></svg>"},{"id":"clock","name":"時間","size":0.75,"g":"tpl","lines":[[[0.5,0.117],[0.5,0.208]],[[0.5,0.792],[0.5,0.883]],[[0.883,0.5],[0.792,0.5]],[[0.208,0.5],[0.117,0.5]],[[0.692,0.163],[0.658,0.225]],[[0.342,0.775],[0.308,0.838]],[[0.838,0.692],[0.775,0.658]],[[0.225,0.342],[0.163,0.308]],[[0.838,0.308],[0.775,0.342]],[[0.225,0.658],[0.163,0.692]],[[0.692,0.838],[0.658,0.775]],[[0.342,0.225],[0.308,0.163]],[[0.883,0.5],[0.879,0.555],[0.868,0.608],[0.849,0.659],[0.823,0.707],[0.79,0.751],[0.751,0.79],[0.707,0.823],[0.659,0.849],[0.608,0.868],[0.555,0.879],[0.5,0.883],[0.445,0.879],[0.392,0.868],[0.341,0.849],[0.293,0.823],[0.249,0.79],[0.21,0.751],[0.178,0.707],[0.151,0.659],[0.132,0.608],[0.121,0.555],[0.117,0.5],[0.121,0.445],[0.132,0.392],[0.151,0.341],[0.178,0.293],[0.21,0.249],[0.249,0.21],[0.293,0.178],[0.341,0.151],[0.392,0.132],[0.445,0.121],[0.5,0.117],[0.555,0.121],[0.608,0.132],[0.659,0.151],[0.707,0.178],[0.751,0.21],[0.79,0.249],[0.823,0.293],[0.849,0.341],[0.868,0.392],[0.879,0.445],[0.883,0.5]],[[0.542,0.5],[0.541,0.506],[0.54,0.512],[0.538,0.517],[0.535,0.523],[0.532,0.527],[0.527,0.532],[0.523,0.535],[0.517,0.538],[0.512,0.54],[0.506,0.541],[0.5,0.542],[0.494,0.541],[0.488,0.54],[0.483,0.538],[0.478,0.535],[0.473,0.532],[0.469,0.527],[0.465,0.523],[0.462,0.517],[0.46,0.512],[0.459,0.506],[0.458,0.5],[0.459,0.494],[0.46,0.488],[0.462,0.483],[0.465,0.478],[0.469,0.473],[0.473,0.469],[0.478,0.465],[0.483,0.462],[0.488,0.46],[0.494,0.459],[0.5,0.458],[0.506,0.459],[0.512,0.46],[0.517,0.462],[0.523,0.465],[0.527,0.469],[0.532,0.473],[0.535,0.478],[0.538,0.483],[0.54,0.488],[0.541,0.494],[0.542,0.5]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"12\" cy=\"12\" r=\"9.2\"/><path d=\"M12 2.8v2.2M12 19v2.2M21.2 12H19M5 12H2.8\"/><path d=\"M16.6 3.9l-.8 1.5M8.2 18.6l-.8 1.5M20.1 16.6l-1.5-.8M5.4 8.2l-1.5-.8M20.1 7.4l-1.5.8M5.4 15.8l-1.5.8M16.6 20.1l-.8-1.5M8.2 5.4l-.8-1.5\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/></svg>"},{"id":"tpl_yotei","name":"予定","size":0.75,"g":"tpl","lines":[[[0.125,0.392],[0.875,0.392]],[[0.275,0.542],[0.725,0.542]],[[0.275,0.683],[0.725,0.683]],[[0.275,0.792],[0.575,0.792]],[[0.325,0.108],[0.325,0.25]],[[0.675,0.108],[0.675,0.25]],[[0.208,0.192],[0.792,0.192],[0.792,0.192],[0.81,0.194],[0.828,0.2],[0.844,0.21],[0.857,0.223],[0.867,0.239],[0.873,0.257],[0.875,0.275],[0.875,0.792],[0.875,0.792],[0.873,0.81],[0.867,0.828],[0.857,0.844],[0.844,0.857],[0.828,0.867],[0.81,0.873],[0.792,0.875],[0.208,0.875],[0.208,0.875],[0.19,0.873],[0.172,0.867],[0.156,0.857],[0.143,0.844],[0.133,0.828],[0.127,0.81],[0.125,0.792],[0.125,0.275],[0.125,0.275],[0.127,0.257],[0.133,0.239],[0.143,0.223],[0.156,0.21],[0.172,0.2],[0.19,0.194],[0.208,0.192]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"3\" y=\"4.6\" width=\"18\" height=\"16.4\" rx=\"2\"/><path d=\"M3 9.4h18\"/><path d=\"M6.6 13h10.8M6.6 16.4h10.8M6.6 19h7.2\"/><path d=\"M7.8 2.6v3.4M16.2 2.6v3.4\"/></svg>"},{"id":"tpl_fukidashi","name":"吹き出し","size":1.5,"g":"tpl","lines":[[[0.317,0.217],[0.294,0.218],[0.272,0.221],[0.251,0.226],[0.231,0.233],[0.213,0.242],[0.196,0.252],[0.18,0.264],[0.166,0.278],[0.154,0.292],[0.144,0.308],[0.136,0.326],[0.13,0.344],[0.126,0.363],[0.125,0.383],[0.126,0.403],[0.129,0.422],[0.133,0.439],[0.139,0.455],[0.146,0.47],[0.155,0.484],[0.165,0.496],[0.176,0.508],[0.188,0.518],[0.201,0.526],[0.215,0.534],[0.229,0.541],[0.243,0.546],[0.258,0.55],[0.256,0.562],[0.254,0.574],[0.25,0.585],[0.246,0.596],[0.242,0.607],[0.237,0.617],[0.231,0.627],[0.224,0.636],[0.218,0.645],[0.21,0.654],[0.202,0.663],[0.194,0.671],[0.185,0.679],[0.175,0.688],[0.193,0.688],[0.21,0.688],[0.227,0.686],[0.243,0.684],[0.259,0.681],[0.275,0.677],[0.29,0.673],[0.305,0.668],[0.319,0.662],[0.333,0.655],[0.346,0.647],[0.359,0.639],[0.372,0.63],[0.383,0.621],[0.391,0.623],[0.4,0.626],[0.408,0.628],[0.416,0.63],[0.425,0.631],[0.434,0.633],[0.442,0.634],[0.451,0.635],[0.46,0.636],[0.469,0.636],[0.477,0.637],[0.486,0.637],[0.495,0.637],[0.504,0.638],[0.545,0.636],[0.584,0.631],[0.621,0.623],[0.656,0.613],[0.688,0.6],[0.718,0.584],[0.744,0.566],[0.768,0.546],[0.789,0.524],[0.806,0.5],[0.819,0.475],[0.829,0.449],[0.835,0.421],[0.838,0.392],[0.835,0.363],[0.829,0.335],[0.819,0.308],[0.806,0.283],[0.789,0.259],[0.768,0.237],[0.744,0.217],[0.718,0.199],[0.688,0.184],[0.656,0.171],[0.621,0.16],[0.584,0.152],[0.545,0.148],[0.504,0.146],[0.49,0.146],[0.476,0.147],[0.462,0.148],[0.448,0.15],[0.434,0.152],[0.421,0.155],[0.407,0.159],[0.394,0.164],[0.381,0.17],[0.368,0.177],[0.355,0.185],[0.342,0.194],[0.329,0.205],[0.317,0.217],[0.317,0.217]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M7.6 5.2c-2.6 0-4.6 1.7-4.6 4s1.5 3.6 3.2 4c-.2 1.4-.9 2.4-2 3.3 2 .1 3.7-.5 5-1.6.9.3 1.9.4 2.9.4 4.7 0 8-2.6 8-5.9s-3.3-5.9-8-5.9c-1.6 0-3.1.3-4.5 1.7z\"/></svg>"},{"id":"tpl_cafe","name":"カフェ","size":0.75,"g":"tpl","lines":[[[0.267,0.392],[0.733,0.392],[0.688,0.821],[0.687,0.827],[0.685,0.833],[0.683,0.838],[0.68,0.844],[0.677,0.849],[0.674,0.854],[0.67,0.859],[0.665,0.863],[0.661,0.866],[0.656,0.87],[0.65,0.873],[0.645,0.875],[0.639,0.877],[0.633,0.878],[0.627,0.879],[0.621,0.879],[0.379,0.879],[0.373,0.879],[0.367,0.878],[0.361,0.877],[0.355,0.875],[0.35,0.873],[0.345,0.87],[0.34,0.866],[0.335,0.863],[0.33,0.859],[0.326,0.854],[0.323,0.849],[0.32,0.844],[0.317,0.838],[0.315,0.833],[0.314,0.827],[0.313,0.821],[0.267,0.392]],[[0.333,0.567],[0.667,0.567]],[[0.346,0.7],[0.654,0.7]],[[0.4,0.2],[0.408,0.195],[0.414,0.189],[0.419,0.183],[0.423,0.176],[0.426,0.17],[0.428,0.163],[0.428,0.156],[0.428,0.15],[0.426,0.143],[0.423,0.136],[0.419,0.13],[0.414,0.124],[0.408,0.118],[0.4,0.113]],[[0.6,0.2],[0.608,0.195],[0.614,0.189],[0.619,0.183],[0.623,0.176],[0.626,0.17],[0.628,0.163],[0.628,0.156],[0.628,0.15],[0.626,0.143],[0.623,0.136],[0.619,0.13],[0.614,0.124],[0.608,0.118],[0.6,0.113]],[[0.275,0.292],[0.725,0.292],[0.725,0.292],[0.736,0.293],[0.747,0.297],[0.756,0.303],[0.764,0.311],[0.77,0.32],[0.774,0.331],[0.775,0.342],[0.775,0.342],[0.775,0.342],[0.774,0.353],[0.77,0.363],[0.764,0.373],[0.756,0.381],[0.747,0.387],[0.736,0.39],[0.725,0.392],[0.275,0.392],[0.275,0.392],[0.264,0.39],[0.253,0.387],[0.244,0.381],[0.236,0.373],[0.23,0.363],[0.226,0.353],[0.225,0.342],[0.225,0.342],[0.225,0.342],[0.226,0.331],[0.23,0.32],[0.236,0.311],[0.244,0.303],[0.253,0.297],[0.264,0.293],[0.275,0.292]]],"thumb":"<svg class=\"sd-ico\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M6.4 9.4h11.2l-1.1 10.3a1.6 1.6 0 0 1-1.6 1.4H9.1a1.6 1.6 0 0 1-1.6-1.4z\"/><rect x=\"5.4\" y=\"7\" width=\"13.2\" height=\"2.4\" rx=\"1.2\"/><path d=\"M8 13.6h8M8.3 16.8h7.4\"/><path d=\"M9.6 4.8c.9-.6.9-1.5 0-2.1M14.4 4.8c.9-.6.9-1.5 0-2.1\"/></svg>"}];
const NOTE_ICONS = {   // えにっきbook の sd-icons.js と 同じ 絵（24×24・線 1.7）
  pen: '<path d="M4 20l3.2-.8L19 7.4a2 2 0 0 0 0-2.8l-.6-.6a2 2 0 0 0-2.8 0L4 15.8 3.2 19z"/><path d="M14.5 5.5l4 4"/>',
  sho: '<path d="M12 3.2c-1.5 0-2.6 1.2-2.6 2.7 0 1.6.7 2.6.7 4.1h3.8c0-1.5.7-2.5.7-4.1 0-1.5-1.1-2.7-2.6-2.7z"/><path d="M10.1 10h3.8l-.6 5.4c-.1 1-.6 1.7-1.3 1.7s-1.2-.7-1.3-1.7z"/><path d="M12 17.1V21"/><path d="M10.6 16.6l-.9 3.6M13.4 16.6l.9 3.6"/>',
  fude: '<path d="M5 19c2.2.6 4-.4 5.2-2.2"/><path d="M9.4 15.2c-1.6-1-2-2.6-1.2-4L16 3.6a1.8 1.8 0 0 1 2.6 0l1.8 1.8a1.8 1.8 0 0 1 0 2.6l-7.6 7.8c-1.4.8-2.6.4-3.4-.6z"/><path d="M5 19c-.6-1.6-.2-2.8 1-3.6"/>',
  kasure: '<path d="M4 7c4 1.5 9 2 16 1.5"/><path d="M4 10.5c5 1 10 1 16 .5"/><path d="M4 14c3.5 1.2 8 1.4 12 .6"/><path d="M4 17.5c3 .8 6 1 9 .4"/>',
  scroll: '<path d="M12 4v16"/><path d="M8 8l4-4 4 4"/><path d="M8 16l4 4 4-4"/>',   // ★2026-10-16 スクロール
  eraser: '<path d="M8.6 20.4h11"/><path d="M14.8 4.6l4.6 4.6a1.5 1.5 0 0 1 0 2.2l-7.6 7.6a1.5 1.5 0 0 1-2.2 0L5 14.4a1.5 1.5 0 0 1 0-2.2l7.6-7.6a1.5 1.5 0 0 1 2.2 0z"/><path d="M8.8 8.4l6.8 6.8"/>',
  cubeRotate: '<path d="M12 4.6l6.4 3.6v7.6L12 19.4l-6.4-3.6V8.2z"/><path d="M5.6 8.2L12 11.8l6.4-3.6M12 11.8v7.6"/><path d="M4.2 5.4A8.4 8.4 0 0 1 9 2.6"/><path d="M3.2 2.6l1 2.8 2.8-.6"/>',
  stampTool: '<path d="M9 3.6h6a1.6 1.6 0 0 1 1.6 1.8l-.5 3.4h-8.2l-.5-3.4A1.6 1.6 0 0 1 9 3.6z"/><path d="M5.4 11.4a2.6 2.6 0 0 1 2.6-2.6h8a2.6 2.6 0 0 1 2.6 2.6v1.8H5.4z"/><path d="M3.6 20.4h16.8"/>',
  tplTool: '<rect x="7.4" y="2.8" width="13.8" height="13.8" rx="2.2"/><path d="M16.6 19.4a1.8 1.8 0 0 1-1.8 1.8H4.6a1.8 1.8 0 0 1-1.8-1.8V9.2a1.8 1.8 0 0 1 1.8-1.8"/><path d="M7 11.6h6.4M7 15h4.2"/>',
  photo: '<path d="M2.8 9a2 2 0 0 1 2-2H7l1.3-2h7.4L17 7h2.2a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H4.8a2 2 0 0 1-2-2z"/><circle cx="12" cy="13.2" r="3.2"/>',
  undo: '<path d="M4 10h9.5a5.5 5.5 0 0 1 0 11H8"/><path d="M8 5.5L3.5 10 8 14.5"/>',
  clear: '<path d="M4 7h16"/><path d="M9 7V4.5h6V7"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v5M14 11v5"/>',
  phPick: '<path d="M2.8 9a2 2 0 0 1 2-2H7l1.3-2h7.4L17 7h2.2a2 2 0 0 1 2 2v8.4a2 2 0 0 1-2 2H4.8a2 2 0 0 1-2-2z"/><circle cx="12" cy="13.2" r="3.2"/>',
  bgerase: '<path d="M3.4 5.4h17.2v13.2H3.4z"/><path d="M3.4 12h8.6v6.6"/><path d="M12 5.4v3.6h3.6M15.6 12v3.6h5"/>',
  phCut: '<rect x="3.4" y="3.4" width="17.2" height="17.2" rx="2.4"/><path d="M3.4 12h8.6v8.6"/><path d="M12 3.4v4.3h4.3M16.3 12v4.3h4.3"/>',
  plus: '<path d="M12 5v14M5 12h14"/>', minus: '<path d="M5 12h14"/>'
};
const noteIco = (name, size) => '<svg class="sd-ico" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (NOTE_ICONS[name] || '') + '</svg>';
// ══════════════════════════════════════════════════════════════
// 🖌 えにっきbook - 毛1本ずつの物理エンジン v0.2.0
// ------------------------------------------------------------
//  【v0.2.0 で直したこと】
//   ① 広がりが毎コマ足し算されて穂が爆発しとった
//      → バネで「目標の広がり」に引っぱる方式に変更
//   ② 毛が輪っか状に並んで中が空っぽやった（＝はけ）
//      → 円盤状にびっしり並べる（ひまわりの種の並び方）
//   ③ 毛が細すぎて重ならず、すじすじに見えとった
//      → 毛1本ずつに「速さ→太さ」の式を入れた
//         （seal-kobo の sign.js と同じ考え方）
//
//  ⭐ ③のおかげで、真ん中の毛どうしが重なって黒くなり、
//     外の毛だけがほつれる＝ちゃんと筆に見えます。
// ══════════════════════════════════════════════════════════════

// 📔 えにっきbookに組み込んだ版
const NOTE_FUDE_VERSION = 'v0.7.0';

const NOTE_FUDE = {

  DEFAULTS: {
    // 筆
    bristles: 44,     // 毛の本数
    segments: 4,      // 1本あたりの節の数
    length:   32,     // 穂の長さ(px)
    root:     3.4,    // 束の太さ(px) ＝ 口金
    splay:    10,      // 圧で広がる量(px)
    stiff:    0.50,   // 腰（大きいほど硬い）
    hair:     1.10,    // 毛の太さの下限(px)

    // ⭐ v0.2.0 インクの出方（seal-kobo方式）
    thinning: 0.55,   // 速いほど細くなる度合い 0〜1
    cover:    1.50,    // 毛どうしの重なり（下げるとすじすじ）
    core:     0.56,   // ⭐ 芯の太さ（束の幅に対する割合）0で毛だけ
    coreInk:  0.45,    // 墨の濃さ（芯もほつれも、これでまとめて決まる）
    hairInk:  0.75,    // ⭐ ほつれの濃さ（芯に対する割合／1.0で同じ色）
    speedW:   1.00,   // ⭐ 速さで太さがどれだけ変わるか 0〜1
    speedRev: false,  // true なら「早い＝細い」（ふつうの筆）
    speedRef: 7,      // ⭐ どれくらいで「速い」とみなすか(px/コマ)
    speedResp: 0.55,  // ⭐ 太さが変わる反応の速さ 0.05〜1

    // ⭐ v0.5.0 起筆・収筆
    taperIn:  0.35,   // 入り（トンと置く）0〜1
    taperOut: 0.60,   // 払い（スーッと抜く）0〜1
    pool:     0.60,   // ⭐ 止め（急に止まると墨がたまる）0〜1

    // 動き
    damp:     0.86,
    friction: 0.50,
    repel:    0.36,

    // 墨
    ink:      0.40,
    drain:    2.20,
    bleed:    0.05,

    // 圧
    press:    1.0,

    seed:     20260730,
  },

  _rnd(a, b) {
    const n = Math.sin(a * 127.1 + b * 311.7) * 43758.5453;
    return n - Math.floor(n);
  },

  /* ============================================================
   * 🖌 筆をつくる
   * ------------------------------------------------------------
   *  ⭐ 毛を「円盤」にびっしり並べます。
   *     ひまわりの種と同じ並べ方（黄金角）にすると、
   *     すき間なく・かたよりなく散らばります。
   * ============================================================ */
  create(opts) {
    const cfg = Object.assign({}, this.DEFAULTS, opts || {});
    const nB = Math.max(2, Math.round(cfg.bristles));
    const nS = Math.max(2, Math.round(cfg.segments));
    const seed = cfg.seed;
    const GOLD = 2.399963229728653;   // 黄金角

    const bristles = [];
    for (let i = 0; i < nB; i++) {
      // 円盤に均等にばらまく（中心から外まで満遍なく）
      const far = Math.sqrt((i + 0.5) / nB);
      const ang = i * GOLD + this._rnd(i, seed) * 0.20;

      bristles.push({
        ang, far,
        // 外の毛ほど短い＝穂が円すいになって先が尖る
        len:   cfg.length * (1 - far * 0.40),
        thick: 0.75 + this._rnd(i, seed + 2) * 0.6,              // 毛ごとの個性
        dry:   0.6 + far * 0.7 + this._rnd(i, seed + 3) * 0.25,  // 外ほど先に乾く
        wob:  (this._rnd(i, seed + 4) - 0.5) * 0.30,
        ink: 0, tipX: 0, tipY: 0, live: false,
        nodes: new Array(nS),
      });
      for (let s = 0; s < nS; s++) bristles[i].nodes[s] = { x: 0, y: 0, px: 0, py: 0 };
    }

    return { cfg, nB, nS, bristles, hx: 0, hy: 0, cx: 0, cy: 0, wmul: 1, vx: 0, vy: 0, lastSpeed: 0, lastP: 0.6, warm: 0,
      peak: 0, still: 0, pooling: false, lastCw: 3, lastInk: 1,
      down: false, dist: 0 };
  },

  /* ============================================================
   * ✏️ 描きはじめ
   * ============================================================ */
  begin(b, x, y) {
    const cfg = b.cfg;
    b.hx = x; b.hy = y; b.cx = x; b.cy = y; b.wmul = 1; b.vx = 0; b.vy = 0;
    b.lastSpeed = 0; b.lastP = 0.6; b.warm = 0;
    b.peak = 0; b.still = 0; b.pooling = false; b.lastCw = 3; b.lastInk = 1;
    b.down = true; b.dist = 0;

    for (let i = 0; i < b.nB; i++) {
      const br = b.bristles[i];
      br.ink = cfg.ink * (0.85 + this._rnd(i, cfg.seed + 5) * 0.15);
      br.live = true;
      const ox = Math.cos(br.ang) * cfg.root * br.far;
      const oy = Math.sin(br.ang) * cfg.root * br.far;
      for (let s = 0; s < b.nS; s++) {
        const n = br.nodes[s];
        n.x = n.px = x + ox;
        n.y = n.py = y + oy;
      }
      br.tipX = x + ox; br.tipY = y + oy;
    }
  },

  /* ============================================================
   * 🖌 1コマ進める
   * ============================================================ */
  /**
   * 1コマ進める
   * @param inSpeed 本当の指の速さ(px/コマ)。
   *   ⚠️ 呼ぶ側が点と点の間を細かく分けている場合、
   *      ここに「分ける前の速さ」を渡さないと、
   *      物理から見た速さがいつも同じになってしまいます。
   */
  step(b, x, y, press, inSpeed) {
    if (!b.down) return [];
    const cfg = b.cfg;
    const nS = b.nS;
    let P = Math.max(0, Math.min(1, press)) * cfg.press + (1 - cfg.press) * 0.5;

    // ⭐ v0.5.0 入り（起筆）：書きはじめは穂先だけが触れて、すぐ寝る
    if (cfg.taperIn > 0 && b.warm < 1) {
      b.warm = Math.min(1, b.warm + 0.16 / Math.max(0.05, cfg.taperIn));
      P *= (1 - cfg.taperIn) + cfg.taperIn * b.warm;
    } else {
      b.warm = 1;
    }
    b.lastP = P;

    const dx = x - b.hx, dy = y - b.hy;
    const move = Math.sqrt(dx * dx + dy * dy);
    b.hx = x; b.hy = y;
    b.dist += move;
    b.vx = dx; b.vy = dy;

    // ⭐ v0.4.2 速さで太さを「0.5倍〜2倍」にする
    //  ・遅い   → ふつうの太さの半分
    //  ・ふつう → そのまま
    //  ・速い   → ふつうの2倍
    //  「速さで太さ」スライダーが 0 なら、まったく変わりません。
    //  ⚠️ ガクッと変わらんように、バネでゆるやかに近づけます
    {
      const raw = (inSpeed !== undefined && inSpeed !== null) ? inSpeed : move;
      b.lastSpeed = raw;
      const v = Math.min(1, raw / Math.max(0.5, cfg.speedRef));   // 速さ 0〜1
      const g = cfg.speedW;                        // 効き 0〜1
      // v=0 → 0.5倍 ／ v=1/3 → 1倍 ／ v=1 → 2倍
      const curve = cfg.speedRev
        ? (2.0 - v * 1.5)                          // 早い＝細い（逆）
        : (0.5 + v * 1.5);                         // 早い＝太い
      const target = 1 + g * (curve - 1);          // g=0 なら常に1倍
      b.wmul += (Math.max(0.35, Math.min(2.4, target)) - b.wmul) * cfg.speedResp;
    }

    const dabs = [];

    for (let i = 0; i < b.nB; i++) {
      const br = b.bristles[i];
      if (!br.live) continue;
      const ox = Math.cos(br.ang), oy = Math.sin(br.ang);

      // ① 根元は軸にくっつく
      const n0 = br.nodes[0];
      n0.px = n0.x; n0.py = n0.y;
      n0.x = x + ox * cfg.root * br.far;
      n0.y = y + oy * cfg.root * br.far;

      // ② ベルレ法で進む（慣性・遅れ）
      for (let s = 1; s < nS; s++) {
        const n = br.nodes[s];
        const vx = (n.x - n.px) * cfg.damp;
        const vy = (n.y - n.py) * cfg.damp;
        n.px = n.x; n.py = n.y;
        n.x += vx + (-oy) * br.wob * P;
        n.y += vy + ( ox) * br.wob * P;
      }

      // ③ 長さを保つ＋腰（まっすぐ戻る）
      for (let it = 0; it < 2; it++) {
        for (let s = 1; s < nS; s++) {
          const p = br.nodes[s - 1], n = br.nodes[s];
          // ⭐ v0.2.2 紙に寝とるのは穂の「先っぽだけ」
          //  前は穂の全長(40px)を紙の上で引きずっとったので、
          //  ほうき／はけみたいになっとった。
          //  ・軽く置く → ほぼ点（先端だけ）
          //  ・強く押す → 寝て長くなる
          const L = (br.len * (0.16 + P * 0.40)) / (nS - 1);

          const ax = n.x - p.x, ay = n.y - p.y;
          const d = Math.sqrt(ax * ax + ay * ay) || 1;
          const k = (d - L) / d;
          n.x -= ax * k; n.y -= ay * k;

          if (s >= 2) {
            const pp = br.nodes[s - 2];
            const bx = p.x - pp.x, by = p.y - pp.y;
            const bl = Math.sqrt(bx * bx + by * by) || 1;
            n.x += (p.x + (bx / bl) * L - n.x) * cfg.stiff * 0.5;
            n.y += (p.y + (by / bl) * L - n.y) * cfg.stiff * 0.5;
          }
        }
      }

      // ④ 🆕 広がりは「目標にバネで近づける」（爆発しない）
      const want = (cfg.root + cfg.splay * P) * br.far;
      for (let s = 1; s < nS; s++) {
        const n = br.nodes[s];
        const t = s / (nS - 1);
        const proj = (n.x - x) * ox + (n.y - y) * oy;   // いまの広がり
        const gap = (want * t) - proj;
        n.x += ox * gap * 0.28;
        n.y += oy * gap * 0.28;
      }

      // ⑤ 紙の摩擦（穂先が引っかかる）
      const tip = br.nodes[nS - 1];
      const fr = cfg.friction * (0.35 + P * 0.65);
      tip.px += (tip.x - tip.px) * fr;
      tip.py += (tip.y - tip.py) * fr;

      if (move < 0.8) br.ink = Math.min(cfg.ink, br.ink + cfg.bleed * 0.004);

      br.tipX = tip.x; br.tipY = tip.y;
    }

    // ── 押し合い（近い毛どうし） ──────────────
    const gapWant = ((cfg.root + cfg.splay * P) * 2 / b.nB) * cfg.cover;
    if (cfg.repel > 0) this._repel(b, P, gapWant);

    // ── ⭐ v0.2.1 本当の束の幅を測ってから太さを決める ──
    //  前は「計算上の幅」で決めとったけど、実際は摩擦や遅れで
    //  倍くらい広がっとった。だから毛が届かずスカスカやった。
    let pmin = 1e9, pmax = -1e9;
    const ux = move > 0.01 ? -dy / move : 0;    // 進む向きと直角
    const uy = move > 0.01 ?  dx / move : 1;
    for (let i = 0; i < b.nB; i++) {
      const t = b.bristles[i].nodes[nS - 1];
      const o = (t.x - x) * ux + (t.y - y) * uy;
      if (o < pmin) pmin = o;
      if (o > pmax) pmax = o;
    }
    const spread = Math.max(cfg.root * 2, pmax - pmin);
    const need = (spread / b.nB) * cfg.cover;

    // ── ⭐ v0.3.0 芯（束の本体）を描く ────────────
    //  本物の筆は、真ん中はべったり黒くて、フチだけ毛が見える。
    //  毛だけで描くと点々になってしまうので、
    //  「束のまん中」を1本の線としてしっかり塗る。
    if (cfg.core > 0) {
      let sx = 0, sy = 0, si = 0, n = 0;
      let rms = 0;
      for (let i = 0; i < b.nB; i++) {
        const br = b.bristles[i];
        if (!br.live || br.ink <= 0.002) continue;
        const t = br.nodes[nS - 1];
        sx += t.x; sy += t.y; si += br.ink; n++;
        const o = (t.x - x) * ux + (t.y - y) * uy;
        rms += o * o;
      }
      if (n > 0) {
        const cx = sx / n, cy = sy / n;          // 束のまん中
        const avgInk = si / n;
        rms = Math.sqrt(rms / n);                 // 広がりの代表値

        const cmove = Math.sqrt((cx - b.cx) * (cx - b.cx) + (cy - b.cy) * (cy - b.cy));

        // ⭐ 速さのばいすうをかける（ここが一番効く）
        //  ⚠️ 穂の広がり(rms)だけで決めると、速く動いた時に
        //     穂がすぼまって逆に細くなってしまう。
        //     「実測の広がり」と「筆そのものの太さ」を半々で使う。
        const baseW = (cfg.root + cfg.splay * P) * 2;
        const mixW = rms * 2 * 0.5 + baseW * 0.5;
        // 圧が抜けると細くなる（払いの先が点になる）
        const cw = Math.max(0.6, mixW * cfg.core * b.wmul * (0.28 + P * 0.72))
                 * Math.min(1, 0.35 + avgInk * 1.3);
        const ca = Math.min(1, avgInk * 2.0) * cfg.coreInk * (0.45 + P * 0.55);

        if (ca > 0.02 && cmove > 0.004) {
          dabs.push({ x0: b.cx, y0: b.cy, x1: cx, y1: cy, w: cw, a: ca, core: true });
        }
        b.cx = cx; b.cy = cy;
        b.lastCw = cw; b.lastInk = avgInk;
      }
    }

    // ── 墨を置く（毛はフチのほつれ担当） ──────
    for (let i = 0; i < b.nB; i++) {
      const br = b.bristles[i];
      if (!br.live) continue;
      const tip = br.nodes[nS - 1];

      // ⑥ 🆕 インクの出方（seal-kobo の式を毛1本ずつに）
      const tdx = tip.x - br.tipX, tdy = tip.y - br.tipY;
      const tlen = Math.sqrt(tdx * tdx + tdy * tdy);   // ← その毛じしんの速さ

      // ⭐ v0.2.3 軽く置いても真ん中の毛はちゃんと紙に触れる
      //  前は「圧 ≧ 遠さ×0.62」やったので、
      //  圧0.5だと外の毛がほぼ全部浮いて真っ白になっとった。
      const touching = br.far <= 0.30 + P * 0.85;
      if (touching && br.ink > 0.002 && tlen > 0.004) {
        const use = tlen * 0.0013 * cfg.drain * br.dry * (0.45 + P * 0.55);
        br.ink = Math.max(0, br.ink - use);

        // ⭐ 速いほど細い（毛ごとに速さが違うので太さもバラける）
        // 毛ごとのゆらぎ（速さのばいすうは束ぜんぶ共通でかける）
        const jitter = Math.max(1 - cfg.thinning * 0.5, 1 - (tlen / 9) * cfg.thinning * 0.5);
        const w = Math.max(cfg.hair, need) * br.thick * jitter * b.wmul * (0.55 + P * 0.60);

        // ⭐ v0.7.0 ほつれも芯と同じ濃さにする
        //  前は「芯の濃さ」が毛に掛かっておらず、
        //  芯を薄くしても毛だけ真っ黒のままやった。
        let a = Math.min(1, br.ink * 2.2) * (0.35 + P * 0.65)
              * cfg.coreInk * cfg.hairInk;

        const dryOut = 1 - Math.min(1, br.ink * 3.2);
        if (dryOut > 0 && this._rnd(Math.floor(b.dist * 1.7) + i * 37, i) < dryOut * 0.8) a = 0;

        if (a > 0.01) {
          dabs.push({ x0: br.tipX, y0: br.tipY, x1: tip.x, y1: tip.y, w: Math.max(0.4, w), a });
        }
      }
      br.tipX = tip.x; br.tipY = tip.y;
    }

    // ── ⭐ v0.6.0 止め（急に止まると墨がたまる） ──────
    //  ・勢いよく来て、ピタッと止まった → 墨がじわっと広がる
    //  ・もともとゆっくり → たまらない（払いになる）
    if (cfg.pool > 0) {
      const sp = b.lastSpeed;
      if (sp >= 1.4) {
        // 動いとる間だけ、勢いの記憶がゆっくり薄れる
        b.peak = Math.max(sp, b.peak * 0.94);
        b.still = 0;
        b.pooling = false;
      } else {
        // 止まっとる間は勢いの記憶をそのまま保つ
        //  （前は消えるのが早すぎて、たまりがすぐ終わっとった）
        b.still++;
        if (b.still >= 2 && b.peak > 3.5) b.pooling = true;
      }

      if (b.pooling && b.lastInk > 0.02) {
        const grow = Math.min(1, b.still / 22);            // じわじわ広がる
        const r = b.lastCw * (0.50 + grow * 0.60) * cfg.pool;
        const a = Math.min(1, b.lastInk * 2.2) * (0.09 + grow * 0.16) * cfg.pool * cfg.coreInk;
        if (a > 0.01) {
          dabs.push({ x0: b.cx, y0: b.cy, x1: b.cx, y1: b.cy, w: Math.max(1, r * 2), a, pool: true });
        }
      }
    }

    return dabs;
  },

  /* ── 毛どうしの押し合い（穂割れ） ──────────
   *  ⚠️ v0.2.1 ここが「はけ」の原因やった。
   *     前は「番号がとなりの毛」を押し合っとったけど、
   *     円盤に並べたので番号のとなり＝場所は正反対。
   *     見当ちがいの方へ押して、束がふくらんどった。
   *     → ちゃんと「近くにおる毛」だけ押し合うようにした。
   */
  _repel(b, P, gapWant) {
    const nS = b.nS;
    const k = b.cfg.repel * 0.35;
    for (let i = 0; i < b.nB; i++) {
      const a = b.bristles[i].nodes[nS - 1];
      for (let j = i + 1; j < b.nB; j++) {
        const c = b.bristles[j].nodes[nS - 1];
        const dx = c.x - a.x, dy = c.y - a.y;
        const d2 = dx * dx + dy * dy;
        if (d2 > gapWant * gapWant || d2 < 1e-8) continue;
        const d = Math.sqrt(d2);
        const push = (gapWant - d) / d * k * 0.5;
        a.x -= dx * push; a.y -= dy * push;
        c.x += dx * push; c.y += dy * push;
      }
    }
  },

  /**
   * ✋ 描きおわり ＝ 払い（収筆）
   * ------------------------------------------------------------
   *  筆を上げる瞬間、穂先は
   *   ① まだ少し前へ進みながら
   *   ② だんだん紙から離れて
   *   ③ 最後は点になって消える
   *  これを何コマかぶん続けて描くと、あの「スーッ」が出ます。
   *  @return 払いのぶんの線（呼んだ側で描いてください）
   */
  end(b) {
    const cfg = b.cfg;
    const dabs = [];

    // ⭐ v0.6.0 どう止まったかで分ける
    //  勢いよく来てピタッと止まった → 止め（たまり）
    //  ゆっくり止まった／動いたまま離した → 払い
    const abrupt = !!b.pooling || (b.peak > 3.5 && b.lastSpeed < 1.6);

    if (b.down && abrupt && cfg.pool > 0) {
      const n = Math.round(6 + cfg.pool * 10);
      for (let k = 1; k <= n; k++) {
        const t = k / n;
        const r = b.lastCw * (0.55 + t * 0.55) * cfg.pool;
        const a = Math.min(1, b.lastInk * 2.2) * (0.16 * (1 - t * 0.5)) * cfg.pool * cfg.coreInk;
        if (a > 0.01) {
          dabs.push({ x0: b.cx, y0: b.cy, x1: b.cx, y1: b.cy, w: Math.max(1, r * 2), a, pool: true });
        }
      }
    } else if (b.down && cfg.taperOut > 0) {
      const n = Math.max(2, Math.round(cfg.taperOut * 16));
      let vx = b.vx, vy = b.vy;
      let x = b.hx, y = b.hy;
      const P0 = b.lastP;
      const sp0 = b.lastSpeed;

      for (let k = 1; k <= n; k++) {
        const t = k / n;
        const decay = (1 - t) * (1 - t);        // ぐっと減速
        x += vx * decay;
        y += vy * decay;
        // 圧が抜けていく（最後は0）
        const p = P0 * Math.pow(1 - t, 1.7);
        const out = this.step(b, x, y, p, sp0 * (1 - t * 0.5));
        for (const d of out) dabs.push(d);
      }
    }

    b.down = false;
    for (const br of b.bristles) br.live = false;
    return dabs;
  },

  paint(ctx, dabs, color) {
    ctx.save();
    ctx.lineCap = 'round';
    ctx.strokeStyle = color || '#111';
    for (const d of dabs) {
      ctx.globalAlpha = d.a;
      ctx.lineWidth = d.w;
      ctx.beginPath();
      ctx.moveTo(d.x0, d.y0);
      ctx.lineTo(d.x1, d.y1);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;
    ctx.restore();
  },

  PRESETS: {
    // 🌸 だん設定（みなとさんが実験室で決めた数字）
    minato: {
      bristles: 44, segments: 4, length: 32, root: 3.4, splay: 10,
      stiff: 0.50, hair: 1.10, thinning: 0.55, cover: 1.50,
      core: 0.56, coreInk: 0.55,
      speedW: 0.70, speedRev: false, speedRef: 20, speedResp: 0.85,
      damp: 0.86, friction: 0.50, repel: 0.36,
      ink: 0.40, drain: 2.20, bleed: 0.05, press: 1.0,
      taperIn: 0.35, taperOut: 0.60, pool: 0.60, hairInk: 1.0,
    },

    // ✒️ 速筆サイン：細筆・腰が強い・すぐカスレる
    sign: {
      bristles: 40, segments: 4, length: 18, root: 1.5, splay: 3.4,
      stiff: 0.80, hair: 0.9, thinning: 0.65, cover: 2.0, core: 0.85, coreInk: 1.0, speedW: 0.85, speedRev: false, speedRef: 6, speedResp: 0.60,
      damp: 0.84, friction: 0.22, repel: 0.20,
      ink: 0.60, drain: 1.7, bleed: 0.10, press: 1.0,
    },
    // 🖌 太墨：大筆・柔らかい・たっぷり
    sumi: {
      bristles: 56, segments: 5, length: 40, root: 5.0, splay: 16,
      stiff: 0.35, hair: 1.4, thinning: 0.40, cover: 2.2, core: 0.78, coreInk: 1.0, speedW: 0.75, speedRev: false, speedRef: 8, speedResp: 0.50,
      damp: 0.90, friction: 0.42, repel: 0.30,
      ink: 1.0, drain: 0.8, bleed: 0.45, press: 0.85,
    },
    // 🖋 かすれ：乾いた筆
    kasure: {
      bristles: 44, segments: 4, length: 32, root: 3.4, splay: 10,
      stiff: 0.50, hair: 1.1, thinning: 0.55, cover: 1.5, core: 0.55, coreInk: 0.9, speedW: 0.70, speedRev: false, speedRef: 7, speedResp: 0.55,
      damp: 0.86, friction: 0.50, repel: 0.35,
      ink: 0.38, drain: 2.2, bleed: 0.05, press: 1.0,
    },
  },
};
const noteCfg = tool => Object.assign({}, NOTE_PENS[tool] || NOTE_PENS.pen, (NOTEINK.cfg[tool] || {}));
/* ★2026-10-16 みなとさん「紙を 拡大しても ペンの 太さを かえない ように」＝拡大して いる あいだは、紙に のこす 太さを 拡大の ぶんだけ 細く（画面で 見える 太さは そのまま）。最小は 2（保存の きまり） */
const noteInkDrawSize = tool => { const s = noteInkSize(tool), z = (typeof zoom !== 'undefined' && zoom.s > 1.05) ? zoom.s : 1; return z === 1 ? s : Math.max(2, Math.round(s / z)); };
const noteInkSize = tool => { const v = (NOTEINK.cfg[tool] || {}).size; return Number.isInteger(v) ? v : (typeof v === 'number' ? Math.round(v) : 16); };
function noteInkMsg(text, ms = 1800) {
  const el = NOTEINK.msg; if (!el) return;
  el.textContent = text; el.classList.toggle('show', !!text); clearTimeout(NOTEINK.msgT);
  if (text) NOTEINK.msgT = setTimeout(() => { el.textContent = ''; el.classList.remove('show'); }, ms);
}
// ── 筆エンジン（えにっきbook の space-drawing.js から そのまま 写した） ──
function noteStreamline(pts, amount) {
  if (pts.length < 2 || amount <= 0) return pts;
  const k = 1 - amount, n = pts.length, fwd = new Array(n);
  let px = pts[0].sx, py = pts[0].sy;
  fwd[0] = { sx: px, sy: py };
  for (let i = 1; i < n; i++) { px += (pts[i].sx - px) * k; py += (pts[i].sy - py) * k; fwd[i] = { sx: px, sy: py }; }
  const out = new Array(n);
  px = fwd[n - 1].sx; py = fwd[n - 1].sy; out[n - 1] = { sx: px, sy: py };
  for (let i = n - 2; i >= 0; i--) { px += (fwd[i].sx - px) * k; py += (fwd[i].sy - py) * k; out[i] = { sx: px, sy: py }; }
  out[0] = pts[0]; out[n - 1] = pts[n - 1];
  return out;
}
function notePressures(pts, size, thinning) {
  const out = new Array(pts.length); let prev = 0.5;
  for (let i = 0; i < pts.length; i++) {
    let target = 0.5;
    if (i > 0) { const dx = pts[i].sx - pts[i - 1].sx, dy = pts[i].sy - pts[i - 1].sy, dist = Math.sqrt(dx * dx + dy * dy); target = Math.min(1, Math.max(0, 1 - dist / Math.max(4, size))); }
    prev += (target - prev) * 0.275;
    out[i] = 1 - thinning + prev * thinning;
  }
  return out;
}
function noteOutline(pts, radii, taper) {
  const n = pts.length; if (n < 2) return null;
  const left = [], right = [];
  for (let i = 0; i < n; i++) {
    const prev = pts[Math.max(0, i - 1)], next = pts[Math.min(n - 1, i + 1)];
    let vx = next.sx - prev.sx, vy = next.sy - prev.sy; const len = Math.sqrt(vx * vx + vy * vy) || 1; vx /= len; vy /= len;
    const nx = -vy, ny = vx; let r = radii[i];
    if (taper > 0) { const head = Math.min(1, i / Math.max(1, n * taper * 0.5)), tail = Math.min(1, (n - 1 - i) / Math.max(1, n * taper * 0.5)); r *= Math.min(head, tail) * 0.85 + 0.15; }
    r = Math.max(0.35, r);
    left.push([pts[i].sx + nx * r, pts[i].sy + ny * r]); right.push([pts[i].sx - nx * r, pts[i].sy - ny * r]);
  }
  right.reverse(); return left.concat(right);
}
function noteFillOutline(ctx, poly, color, sharp) {
  ctx.beginPath(); ctx.moveTo(poly[0][0], poly[0][1]);
  if (sharp) { for (let i = 1; i < poly.length; i++) ctx.lineTo(poly[i][0], poly[i][1]); }
  else for (let i = 1; i < poly.length; i++) { const a = poly[i], b = poly[(i + 1) % poly.length]; ctx.quadraticCurveTo(a[0], a[1], (a[0] + b[0]) / 2, (a[1] + b[1]) / 2); }
  ctx.closePath(); ctx.fillStyle = color; ctx.fill();
}
const noteSeed = (a, b) => { const n = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return n - Math.floor(n); };
function noteKasure(ctx, pts, radii, color, kc) {
  const nB = Math.max(2, Math.round(kc.bristles || 12)), dryness = kc.dryness != null ? kc.dryness : 0.5, scatter = kc.scatter != null ? kc.scatter : 0.4, blotAmt = kc.blot != null ? kc.blot : 0.6, boost = kc.speedBoost != null ? kc.speedBoost : 0.8, rev = !!kc.reverse;
  const speed = new Array(pts.length).fill(0);
  for (let i = 1; i < pts.length; i++) { const dx = pts[i].sx - pts[i - 1].sx, dy = pts[i].sy - pts[i - 1].sy; speed[i] = Math.sqrt(dx * dx + dy * dy); }
  speed[0] = speed[1] || 0;
  const grow = new Array(pts.length).fill(1); let g = 1;
  if (boost > 0) for (let i = 0; i < pts.length; i++) { const v = Math.min(1, speed[i] / 18); g += ((rev ? (1 - v * 0.65 * boost) : (1 + v * 0.9 * boost)) - g) * 0.22; grow[i] = Math.max(0.25, g); }
  const pool = new Array(pts.length).fill(0); let acc = 0;
  for (let i = 0; i < pts.length; i++) { acc = speed[i] < 2.2 ? Math.min(1, acc + 0.045) : Math.max(0, acc - 0.18); pool[i] = acc; }
  ctx.save(); ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = color;
  for (let b = 0; b < nB; b++) {
    const t = nB === 1 ? 0 : (b / (nB - 1)) * 2 - 1, jitter = (noteSeed(b, 7) - 0.5) * scatter;
    ctx.beginPath(); let drawing = false;
    for (let i = 0; i < pts.length; i++) {
      const prev = pts[Math.max(0, i - 1)], next = pts[Math.min(pts.length - 1, i + 1)];
      let vx = next.sx - prev.sx, vy = next.sy - prev.sy; const len = Math.sqrt(vx * vx + vy * vy) || 1;
      const nx = -vy / len, ny = vx / len, r = radii[i] * grow[i], spreadNow = 1 + Math.min(1.4, speed[i] / 14) * scatter * 2, off = (t + jitter) * r * spreadNow;
      const dry = Math.min(1, speed[i] / 16) * dryness;
      if (noteSeed(i * 3 + b * 31, b) < dry * 0.85) { if (drawing) { ctx.stroke(); ctx.beginPath(); drawing = false; } continue; }
      const x = pts[i].sx + nx * off, y = pts[i].sy + ny * off;
      ctx.globalAlpha = Math.max(0.12, 1 - Math.min(0.8, speed[i] / 20));
      ctx.lineWidth = Math.max(0.4, (r * 2 / nB) * (0.7 + noteSeed(b, 3) * 0.8) * grow[i]);
      if (!drawing) { ctx.moveTo(x, y); drawing = true; } else ctx.lineTo(x, y);
    }
    if (drawing) ctx.stroke();
  }
  ctx.globalAlpha = 1; ctx.fillStyle = color;
  if (blotAmt > 0) for (let i = 2; i < pts.length; i += 2) {
    if (pool[i] < 0.55 || pool[i] < (pool[i + 2] || 0) || noteSeed(i, 91) > blotAmt * 0.5) continue;
    const r = radii[i] * (0.9 + noteSeed(i, 5) * 0.7) * (0.6 + blotAmt * 0.8);
    ctx.beginPath(); ctx.arc(pts[i].sx + (noteSeed(i, 11) - 0.5) * r * 0.5, pts[i].sy + (noteSeed(i, 13) - 0.5) * r * 0.5, Math.max(1, r), 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}
// ===== ✒️ 書（毛を 1本ずつ 物理で うごかす 筆）：えにっきの sd-fude.js を そのまま つかう =====
// ★「えにっきの 1px」を 1の 世界（仮想の 紙：はば 1820）で 動かして、紙の 大きさに あわせて 縮めて 描く（どの 大きさでも 同じ 形）
const NOTE_SHO_CACHE = new WeakMap();
const noteVirtW = () => noteInkPaperMm() / NOTE_MM_PER_PX;
function noteShoStore(a, dabs) {
  if (!dabs || !dabs.length) return;
  if (a.hair.length > 40000) return;
  for (const d of dabs) {
    if (d.core) { if (a.core.length === 0) a.core.push({ x: d.x0, y: d.y0, w: d.w, a: d.a }); a.core.push({ x: d.x1, y: d.y1, w: d.w, a: d.a }); }
    else if (d.pool) a.pool.push({ x: d.x0, y: d.y0, w: d.w, a: d.a });
    else a.hair.push({ ax: d.x0, ay: d.y0, bx: d.x1, by: d.y1, w: d.w, a: d.a });
  }
}
const noteShoPress = sp => 0.55 + Math.min(1, sp / 14) * 0.45;
function noteShoSim(p, v) {   // 保存した 点と 速さから 線を うごかして 作る（いつ やっても 同じ）
  const k = noteVirtW() / 10000, vh = k * (NOTEINK.Hpx / NOTEINK.W) * 10000, a = { core: [], pool: [], hair: [] };
  const b = NOTE_FUDE.create(Object.assign({}, NOTE_FUDE.DEFAULTS));
  const X = i => p[2 * i] * k, Y = i => p[2 * i + 1] / 10000 * vh;
  NOTE_FUDE.begin(b, X(0), Y(0));
  for (let i = 1; i < p.length / 2; i++) {
    const x0 = X(i - 1), y0 = Y(i - 1), dx = X(i) - x0, dy = Y(i) - y0, dist = Math.sqrt(dx * dx + dy * dy), sp = (v && v[i] != null ? v[i] : 40) / 10;
    const steps = Math.max(1, Math.min(24, Math.ceil(dist / 2)));
    for (let j = 1; j <= steps; j++) noteShoStore(a, NOTE_FUDE.step(b, x0 + dx * (j / steps), y0 + dy * (j / steps), noteShoPress(sp), sp));
  }
  noteShoStore(a, NOTE_FUDE.end(b));
  for (const d of a.hair) d.k = Math.round(d.w * 4) * 64 + Math.round(d.a * 24);
  a.hair.sort((q, r) => q.k - r.k);
  return a;
}
function noteShoRibbon(ctx, P, from, to, alpha) {
  if (to - from < 1) return;
  const L = [], R = [];
  for (let i = from; i <= to; i++) {
    const p = P[i], a = P[Math.max(from, i - 1)], b = P[Math.min(to, i + 1)];
    const vx = b.sx - a.sx, vy = b.sy - a.sy, len = Math.sqrt(vx * vx + vy * vy) || 1, nx = -vy / len, ny = vx / len;
    L.push({ x: p.sx + nx * p.r, y: p.sy + ny * p.r }); R.push({ x: p.sx - nx * p.r, y: p.sy - ny * p.r });
  }
  ctx.globalAlpha = alpha; ctx.beginPath(); ctx.moveTo(L[0].x, L[0].y);
  for (let i = 1; i < L.length; i++) ctx.lineTo(L[i].x, L[i].y);
  const e = P[to]; ctx.arc(e.sx, e.sy, e.r, Math.atan2(L[L.length - 1].y - e.sy, L[L.length - 1].x - e.sx), Math.atan2(R[R.length - 1].y - e.sy, R[R.length - 1].x - e.sx));
  for (let i = R.length - 1; i >= 0; i--) ctx.lineTo(R[i].x, R[i].y);
  const st = P[from]; ctx.arc(st.sx, st.sy, st.r, Math.atan2(R[0].y - st.sy, R[0].x - st.sx), Math.atan2(L[0].y - st.sy, L[0].x - st.sx));
  ctx.closePath(); ctx.fill();
}
function noteShoDraw(ctx, a, color) {
  const u = notePxUnit();
  ctx.save(); ctx.scale(u, u); ctx.lineCap = ctx.lineJoin = 'round';
  if (a.core.length > 1) {   // ① 芯：濃さが ちかい ところを ひとまとめの 面で ぬる
    ctx.fillStyle = color;
    const P = a.core.map(c => ({ sx: c.x, sy: c.y, r: Math.max(0.25, c.w * 0.5), a: c.a })); let from = 0;
    for (let i = 1; i < P.length; i++) if (Math.abs(P[i].a - P[from].a) > 0.06) { noteShoRibbon(ctx, P, from, i, P[from].a); from = i; }
    if (from < P.length - 1) noteShoRibbon(ctx, P, from, P.length - 1, P[from].a);
  }
  ctx.fillStyle = color;
  for (const c of a.pool) { ctx.globalAlpha = c.a; ctx.beginPath(); ctx.arc(c.x, c.y, Math.max(0.5, c.w * 0.5), 0, Math.PI * 2); ctx.fill(); }   // ② たまり
  ctx.strokeStyle = color; let lw = -1, la = -1, open = false;   // ③ 毛（ほつれ）
  for (const d of a.hair) {
    const w = Math.max(0.3, d.w);
    if (!open || Math.abs(w - lw) > 0.12 || Math.abs(d.a - la) > 0.03) { if (open) ctx.stroke(); ctx.beginPath(); ctx.lineWidth = w; ctx.globalAlpha = d.a; lw = w; la = d.a; open = true; }
    ctx.moveTo(d.ax, d.ay); ctx.lineTo(d.bx, d.by);
  }
  if (open) ctx.stroke();
  ctx.restore();
}
// 紙の 大きさに あわせた「えにっきの 1px」の 長さ（px）
function notePxUnit() { return (NOTEINK.W / noteInkPaperMm()) * NOTE_MM_PER_PX; }
// 画像（マイスタンプ・写真）
function noteImgEntry(url) {
  let e = NOTEINK.imgs.get(url);
  if (!e) { const im = new Image(); e = { im, ok: false, bad: false }; im.onload = () => { e.ok = true; NOTEINK.rev++; noteInkRender(); }; im.onerror = () => { e.bad = true; }; im.src = url; NOTEINK.imgs.set(url, e); }
  return e;
}
function noteImgBox(it) {
  const e = NOTEINK.imgs.get(it.u), ratio = e && e.ok && e.im.naturalWidth ? e.im.naturalHeight / e.im.naturalWidth : 1, w = it.w / 10000 * NOTEINK.W;
  return { cx: it.x / 10000 * NOTEINK.W, cy: it.y / 10000 * NOTEINK.Hpx, w, h: w * ratio };
}
function noteDrawImg(ctx, it) {
  const e = noteImgEntry(it.u); if (!e.ok) return;
  const b = noteImgBox(it);
  ctx.save(); ctx.translate(b.cx, b.cy); ctx.rotate((it.a || 0) * Math.PI / 180);
  ctx.drawImage(e.im, -b.w / 2, -b.h / 2, b.w, b.h);
  ctx.restore();
}
// ページの ぜんぶを 描く：①画像（そこへ「背景消し」を かける）→ ②線（ペン・スタンプ）。背景消しは 画像だけを 消す（線は さわらない）
function noteDrawItems(ctx, items) {
  const hasCut = items.some(it => it.o === 'cut');
  if (hasCut) {
    const off = NOTEINK.off || (NOTEINK.off = document.createElement('canvas'));
    if (off.width !== ctx.canvas.width || off.height !== ctx.canvas.height) { off.width = ctx.canvas.width; off.height = ctx.canvas.height; }
    const oc = off.getContext('2d'); oc.setTransform(1, 0, 0, 1, 0, 0); oc.clearRect(0, 0, off.width, off.height); oc.setTransform(NOTEINK.dpr, 0, 0, NOTEINK.dpr, 0, 0);
    for (const it of items) {
      if (it.o === 'img') noteDrawImg(oc, it, true);
      else if (it.o === 'cut') { oc.save(); oc.globalCompositeOperation = 'destination-out'; oc.lineCap = oc.lineJoin = 'round'; oc.lineWidth = (it.s || 24) * notePxUnit(); oc.beginPath(); for (let i = 0; i + 1 < it.p.length; i += 2) { const x = it.p[i] / 10000 * NOTEINK.W, y = it.p[i + 1] / 10000 * NOTEINK.Hpx; if (i === 0) { oc.moveTo(x, y); oc.lineTo(x + 0.01, y); } else oc.lineTo(x, y); } oc.stroke(); oc.restore(); }
    }
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(off, 0, 0); ctx.restore();
  } else for (const it of items) if (it.o === 'img') noteDrawImg(ctx, it, true);
  if (NOTEINK.sel && (NOTEINK.mode === 'stamp' || NOTEINK.mode === 'photo' || NOTEINK.mode === 'icon')) noteDrawSelFrame(ctx);
  for (const it of items) if (it.o !== 'img' && it.o !== 'cut') noteDrawStroke(ctx, it);
  if (NOTEINK.selG && NOTEINK.mode === 'icon') noteDrawSelFrame(ctx);
}
// えらんで いる 画像・アイコンの 点線の わく
function noteDrawSelFrame(ctx) {
  const key = noteInkKey(), items = (key && NOTEINK.pages[key]) || []; let b = null;
  if (NOTEINK.sel && items.includes(NOTEINK.sel)) { const bx = noteImgBox(NOTEINK.sel); ctx.save(); ctx.translate(bx.cx, bx.cy); ctx.rotate((NOTEINK.sel.a || 0) * Math.PI / 180); ctx.strokeStyle = '#5b8fd6'; ctx.lineWidth = 1.5; ctx.setLineDash([5, 4]); ctx.strokeRect(-bx.w / 2, -bx.h / 2, bx.w, bx.h); ctx.restore(); return; }
  if (NOTEINK.selG) { b = noteGroupBox(items, NOTEINK.selG); if (b) { ctx.save(); ctx.strokeStyle = '#5b8fd6'; ctx.lineWidth = 1.5; ctx.setLineDash([5, 4]); ctx.strokeRect(b.x0, b.y0, b.x1 - b.x0, b.y1 - b.y0); ctx.restore(); } }
}
// アイコン（同じ g の 線の かたまり）の 四角（紙の px）
function noteGroupBox(items, g) {
  let x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, n = 0;
  for (const it of items) if (it.g === g && it.p) { n++; for (let i = 0; i + 1 < it.p.length; i += 2) { const x = it.p[i] / 10000 * NOTEINK.W, y = it.p[i + 1] / 10000 * NOTEINK.Hpx; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
  if (!n) return null;
  const pad = 6; return { x0: x0 - pad, y0: y0 - pad, x1: x1 + pad, y1: y1 + pad };
}
// 1本の 線を ctx に 描く（st.p は 0〜10000・st.q は 点ごとの 筆圧 0〜100・st.r は くっきり）
function noteDrawStroke(ctx, st, pq) {
  const W = NOTEINK.W, Hh = NOTEINK.Hpx, p = st.p, n = p.length / 2; if (n < 1) return;
  const tool = NOTE_PENS[st.t] ? st.t : 'pen', cfg = noteCfg(tool), size = (st.s || 16) * notePxUnit();
  if (tool === 'sho' && !st.r && n >= 2) { let a = NOTE_SHO_CACHE.get(st); if (!a) { a = noteShoSim(p, st.v); NOTE_SHO_CACHE.set(st, a); } noteShoDraw(ctx, a, st.c); return; }
  const pts = []; for (let i = 0; i < n; i++) pts.push({ sx: p[2 * i] / 10000 * W, sy: p[2 * i + 1] / 10000 * Hh });
  if (n === 1) { ctx.fillStyle = st.c; ctx.beginPath(); ctx.arc(pts[0].sx, pts[0].sy, Math.max(0.6, size / 2 * 0.85), 0, Math.PI * 2); ctx.fill(); return; }
  ctx.save();
  if (st.r === 1) { const poly = noteOutline(pts, pts.map(() => size / 2), 0); if (poly) noteFillOutline(ctx, poly, st.c, true); ctx.restore(); return; }
  const sm = noteStreamline(pts, cfg.streamline);
  const pr = pq || (Array.isArray(st.q) && st.q.length === n ? st.q.map(v => v / 100) : null) || sm.map(() => 1);
  const radii = sm.map((q, i) => size / 2 * pr[i]);
  if (tool === 'kasure') noteKasure(ctx, sm, radii, st.c, cfg);
  else { const poly = noteOutline(sm, radii, cfg.taper); if (poly) noteFillOutline(ctx, poly, st.c, false); }
  ctx.restore();
}
// ★2026-10-15 みなとさん「携帯で 見ると 上が かなり あいて います。紙の ぶんが ぴったりに」
// 紙の 入れものの 高さを、紙の たて横比（PSEL）と いまの はばから 出す（上限 660px＝パソコンは いままでどおり）
function noteInkFitArea() {
  const area = document.querySelector('.paper-area'); if (!area) return;
  const ps = typeof PSEL !== 'undefined' ? PSEL : { w: 182, h: 257 };
  const w = area.clientWidth; if (!w) return;
  // 紙の はば＝入れものの はば − 8px（上下 左右 4pxずつ）。たて＝はば × たて横比。上限 660px（パソコンは いままでどおり）
  const vh = (window.parent && window.parent !== window ? window.parent.innerHeight : window.innerHeight) || 900;
  const cap = Math.max(480, Math.min(900, vh - 190));   // ★2026-10-15「背景の 枠を 廃止して その ぶん 紙を 大きく」：画面の 高さに あわせて（ヘッダー・ボタン・バーの ぶんを 引く）
  const h = Math.max(240, Math.min(cap, Math.round((w - 8) * ps.h / ps.w) + 8));
  area.style.setProperty('height', h + 'px', 'important');
}
// ★2026-10-15 みなとさん「印刷」：いまの ページに 書いた ものを、印刷用の canvas に 描いて わたす（紙の 絵は ふくまない・画像が あっても 書き出さない＝canvas のまま 印刷に 入れる）
function noteInkPrintCanvas(pxW) {
  const key = noteInkKey(); if (!key) return null;
  const items = NOTEINK.pages[key] || []; if (!items.length) return null;
  const ps = typeof PSEL !== 'undefined' ? PSEL : { w: 182, h: 257 };
  const W = Math.max(600, pxW || 1800), H = Math.round(W * ps.h / ps.w);
  const keep = { W: NOTEINK.W, Hpx: NOTEINK.Hpx, H: NOTEINK.H, dpr: NOTEINK.dpr, sel: NOTEINK.sel, selG: NOTEINK.selG };
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  try {
    NOTEINK.W = W; NOTEINK.Hpx = H; NOTEINK.H = 10000 * H / W; NOTEINK.dpr = 1; NOTEINK.sel = null; NOTEINK.selG = null;
    const ctx = c.getContext('2d'); ctx.setTransform(1, 0, 0, 1, 0, 0);
    noteDrawItems(ctx, items);
  } finally { Object.assign(NOTEINK, keep); }
  return c;
}
function noteInkLayout() {
  const area = document.querySelector('.paper-area'), img = base.querySelector('img'), cv = NOTEINK.cv;
  if (!area || !img || !cv) return false;
  const a = area.getBoundingClientRect(), r = img.getBoundingClientRect();
  if (!r.width || !r.height) return false;
  // まわす で かたむいて いる ときは、かたむき を ふくむ 見かけの 位置では なく 本来の 位置・大きさ（offset）を つかう
  const tilted = false;   // ★紙は かたむけない（書いた ものの 層だけ かたむく）ので、いつも 見かけの 位置を つかう
  let w = r.width, h = r.height, left = r.left - a.left, top = r.top - a.top;
  if (tilted) { w = img.offsetWidth; h = img.offsetHeight; left = 0; top = 0; for (let el = img; el && el !== area; el = el.offsetParent) { left += el.offsetLeft; top += el.offsetTop; } }
  let dpr = Math.min(3, window.devicePixelRatio || 1);
  while (w * dpr * h * dpr > 5e6 && dpr > 0.6) dpr *= 0.85;   // 拡大 しても 絵の 大きさが 500万画素を こえない ように（重く ならない）
  NOTEINK.W = w; NOTEINK.Hpx = h; NOTEINK.H = 10000 * h / w;
  for (const c of [cv, NOTEINK.live]) {
    c.style.left = left + 'px'; c.style.top = top + 'px'; c.style.width = w + 'px'; c.style.height = h + 'px';
    if (c.width !== Math.round(w * dpr) || c.height !== Math.round(h * dpr)) { c.width = Math.round(w * dpr); c.height = Math.round(h * dpr); }
  }
  NOTEINK.dpr = dpr;
  if (typeof sampleLayout === 'function') sampleLayout();   // ★nv0.2.139 拡大・縮小で 紙の 大きさ・場所が かわったら 見本も いっしょに 合わせる（見本の しくみは ホスト側）
  return true;
}
function noteInkHide() { for (const c of [NOTEINK.cv, NOTEINK.live]) if (c) c.style.visibility = 'hidden'; }
function noteInkRender() {
  const cv = NOTEINK.cv; if (!cv) return;
  noteInkFitArea();
  if (!noteInkLayout()) return;
  const key = noteInkKey();
  if (typeof noteInkVisit === 'function') noteInkVisit(key);
  const ctx = cv.getContext('2d'); ctx.setTransform(NOTEINK.dpr, 0, 0, NOTEINK.dpr, 0, 0); ctx.clearRect(0, 0, NOTEINK.W, NOTEINK.Hpx);
  const sig = key + '|' + NOTEINK.rev + '|' + NOTEINK.W + 'x' + NOTEINK.Hpx + '|' + NOTEINK.dpr + '|' + (NOTEINK.sel ? 1 : 0) + (NOTEINK.selG || '') + '|' + NOTEINK.mode;
  const C = NOTEINK.pcache || (NOTEINK.pcache = document.createElement('canvas'));
  if (NOTEINK.psig !== sig || C.width !== cv.width || C.height !== cv.height) {   // 変わった ときだけ 描きなおす。ふだんは 前の 絵を そのまま はる
    C.width = cv.width; C.height = cv.height;
    const cc = C.getContext('2d'); cc.setTransform(NOTEINK.dpr, 0, 0, NOTEINK.dpr, 0, 0);
    noteDrawItems(cc, key ? NOTEINK.pages[key] || [] : []);
    NOTEINK.psig = sig;
  }
  ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(C, 0, 0); ctx.restore();
  const lc = NOTEINK.live.getContext('2d'); lc.setTransform(1, 0, 0, 1, 0, 0); lc.clearRect(0, 0, NOTEINK.live.width, NOTEINK.live.height);
  cv.style.visibility = NOTEINK.live.style.visibility = 'visible';
  cv.style.pointerEvents = key && NOTEINK.mode !== 'rotate' && !NOTEINK.loadFailed ? 'auto' : 'none';   // まわす の ときは ボールだけが うごく
  if (typeof syncFlip === 'function') syncFlip();
  noteInkBarSync();
  noteInkPlaceFlips();
}
/* ★2026-10-16 みなとさん「IPAD で ページを めくる 矢じるしが 紙に かぶる。ギリギリ 外に」
   ＝トップの 紙の すぐ 外がわ（よこに 余白が ある とき）に ‹ › を おく。せまい 画面（スマホ）は これまで どおり 紙の はし */
function noteInkPlaceFlips() {
  try {
    if (!document.body.classList.contains('tk-home')) return;
    const area = document.querySelector('.paper-area'), img = typeof base !== 'undefined' && base.querySelector('img');
    if (!area || !img) return;
    const a = area.getBoundingClientRect(), r = img.getBoundingClientRect(); if (!r.width) return;
    /* ★2026-11-03 みなとさん「＜＞ が 紙に かぶらない ように」＝拡大・縮小の あいだも 見かけの 紙で はかる。
       となりに 場所が なければ（スマホ・拡大中）紙の 上には おかず、下の 欄の ページ名の 両どなりへ（欄の 高さは かえない） */
    const bw = window.innerWidth <= 640 ? 32 : 42, roomL = r.left - a.left, roomR = a.right - r.right;
    const bar = NOTEINK.bar, pg = bar && bar.querySelector('.note-pg');
    const side = !pg || ((typeof zoom === 'undefined' || zoom.s <= 1.01) && roomL >= bw + 8 && roomR >= bw + 8);
    document.querySelectorAll('.flip-btn').forEach(b => {
      const isL = b.classList.contains('l');
      if (side) {
        if (b.parentElement !== area) area.appendChild(b);
        if (isL) { b.style.left = Math.round(roomL - bw - 4) + 'px'; b.style.right = 'auto'; }
        else { b.style.right = Math.round(roomR - bw - 4) + 'px'; b.style.left = 'auto'; }
      } else {
        if (b.parentElement !== bar) { if (isL) bar.insertBefore(b, pg); else pg.after(b); }
        b.style.left = ''; b.style.right = '';
      }
    });
    if (bar) bar.classList.toggle('flip-in', !side);
  } catch (e) {}
}
function noteVisibleTools() {
  const all = ['pen', 'sho', 'fude', 'kasure'], v = NOTEINK.visible;
  const list = v ? all.filter(k => v[k] !== false) : all;   // えにっきで 外した 道具は ここでも 出さない（ぜんぶ 外して いたら ぜんぶ 出す）
  return list.length ? list : all;
}
function noteInkBarSync() {
  const bar = NOTEINK.bar; if (!bar) return;
  const pen = bar.querySelector('[data-sw="pen"]');
  pen.innerHTML = noteIco(NOTEINK.tool, 18) + '<span class="sd-ico-label">ペン</span>';
  for (const [sw, md] of [['edit', NOTEINK.mode === 'cut' ? 'cut' : 'erase'], ['cube', 'rotate'], ['pen', 'pen'], ['stamp', 'stamp'], ['tpl', 'icon'], ['photo', 'photo']]) { const el = bar.querySelector('[data-sw="' + sw + '"]'); if (el) el.classList.toggle('on', NOTEINK.mode === md || NOTEINK.sq === sw); }
  { const sc = bar.querySelector('[data-sw="scroll"]'); if (sc) { if (NOTEINK.scroll) bar.querySelectorAll('.sd-ball-sw').forEach(el => el.classList.remove('on')); sc.classList.toggle('on', !!NOTEINK.scroll); } }   // ★スクロール中は それだけ 光る
  const col = bar.querySelector('#note-col-now'); if (col && col.value !== NOTEINK.color) col.value = NOTEINK.color;
  const sq = NOTEINK.sqEl;
  if (sq) {
    const q = NOTEINK.sq;
    sq.classList.toggle('show', !!q && q !== 'cube');
    sq.classList.toggle('wide', q === 'tpl' || q === 'photo');
    sq.classList.toggle('mine', q === 'stamp');
    const btn = (kind, ico, label, extra) => '<button class="sd-sq' + (extra || '') + '" data-sq="' + q + '" data-kind="' + kind + '">' + ico + '<span class="sd-ico-label">' + label + '</span></button>';
    let html = '';
    if (q === 'pen') html = noteVisibleTools().map(k => btn(k, noteIco(k, 18), NOTE_PEN_NAME[k], k === NOTEINK.tool ? ' active' : '')).join('');
    else if (q === 'edit') {
      const u = NOTEINK.undo[noteInkKey()];
      html = btn('erase', noteIco('eraser', 18), '消しゴム', NOTEINK.mode === 'erase' ? ' active' : '') + btn('undo', noteIco('undo', 18), '戻る', u && u.length ? '' : '" disabled="') + btn('cut', noteIco('bgerase', 18), '画像消し', NOTEINK.mode === 'cut' ? ' active' : '') + btn('clear', noteIco('clear', 18), '全消し');
    } else if (q === 'tpl') html = NOTE_STAMPS.map(d => btn(d.id, d.thumb, d.name, NOTEINK.mode === 'icon' && NOTEINK.iconId === d.id ? ' active' : '')).join('');
    else if (q === 'stamp') {
      const list = NOTEINK.stampList || [];
      html = list.length ? list.map(s => '<button class="sd-sq sd-sq-my' + (NOTEINK.stampUrl === s.url ? ' active' : '') + '" data-sq="stamp" data-kind="' + String(s.url).replace(/"/g, '&quot;') + '" title="マイスタンプ"><img class="sd-sq-img" alt="" src="' + String(s.url).replace(/"/g, '&quot;') + '"></button>').join('') : '<div class="sd-sq-none">マイスタンプが まだ ありません<br>（えにっきで「スタンプに保存」すると ここに 出ます）</div>';
      /* ★2026-10-17 みなとさん「下の バーの スタンプで、登録が あっても 一番 上に『スタンプを作成する』。押すと えにっきの トップへ」 */
      html = '<a class="sd-sq sd-sq-my sd-sq-make" href="/pages/enikki" target="_top" title="スタンプを 作成する"><b>＋</b><span>スタンプを<br>作成する</span></a>' + html;
    } else if (q === 'photo') {
      const has = !!NOTEINK.sel;
      html = btn('pick', noteIco('phPick', 18), 'えらぶ') + btn('cut', noteIco('phCut', 18), '白ぬき', NOTEINK.whiteout ? ' active' : '') + btn('big', noteIco('plus', 18), '大きく', has ? '' : '" disabled="') + btn('small', noteIco('minus', 18), '小さく', has ? '' : '" disabled="') + btn('del', noteIco('clear', 18), '消す', has ? '' : '" disabled="');
    } else html = '';
    if (NOTEINK.sqHtml !== html) { sq.innerHTML = html; NOTEINK.sqHtml = html; }   // 中身が かわった ときだけ 作りなおす
    const b = q ? bar.querySelector('[data-sw="' + q + '"]') : null;
    if (b) { const br = b.getBoundingClientRect(), pr = bar.parentElement.getBoundingClientRect(); sq.style.left = Math.max(2, Math.min(pr.width - (sq.offsetWidth || 46) - 2, br.left - pr.left + br.width / 2 - (sq.offsetWidth || 40) / 2)) + 'px'; }
  }
  const pg = bar.querySelector('.note-pg'); if (pg) pg.textContent = noteInkLabel() || '';
}
// ★2026-10-15 みなとさん「保存が おそい」：書きおわって 2びょうで 保存（前は 15びょう）。書きつづけて いても 8びょうに 1回は 保存する
const NOTE_SAVE_IDLE_MS = 2000, NOTE_SAVE_MAX_MS = 8000;
// ★nv0.2.146 トップ：［保存］ボタン（外側）に「まだ 保存して いない」かを 知らせる（色が かわる だけ・うごかない）
function noteInkTell(state) {
  try { if (window.parent && window.parent !== window && typeof window.parent.tkSaveState === 'function') window.parent.tkSaveState(state || (NOTEINK.dirty.size ? 'dirty' : 'clean')); } catch (e) {}
}
window.noteInkUnsaved = () => NOTEINK.dirty.size > 0;
function noteInkDirty(key) {
  NOTEINK.rev++;
  if (!key) return;
  NOTEINK.dirty.add(key);
  if (TK_HOME) { noteInkTell(); return; }   // ★nv0.2.146 みなとさん「ページを めくると 保存される のを やめて 印刷の よこの［保存］に」＝トップでは 自動で 保存しない（［保存］を おした ときだけ）
  if (!NOTEINK.firstT) NOTEINK.firstT = Date.now();
  clearTimeout(NOTEINK.idleT);
  const wait = Math.max(0, Math.min(NOTE_SAVE_IDLE_MS, NOTEINK.firstT + NOTE_SAVE_MAX_MS - Date.now()));
  NOTEINK.idleT = setTimeout(() => { noteInkFlush(); }, wait);
}
// 保存は 1つずつ 順番に（ページを つづけて めくっても、同時に 2つ 送らない＝サーバーで 書きこみが ぶつかって 字が 消えるのを ふせぐ）。閉じる ときだけは 待たずに 送る
function noteInkFlush(opt) {
  clearTimeout(NOTEINK.idleT); NOTEINK.firstT = 0;
  if (opt && opt.keepalive) return noteInkFlushRun(opt);
  const run = () => noteInkFlushRun(opt);
  NOTEINK.flushP = (NOTEINK.flushP || Promise.resolve()).then(run, run);
  return NOTEINK.flushP;
}
// ★2026-10-16 みなとさん「保存している 時は ページを めくる ボタンの 色を かえて。おわったら もどして」
function noteInkSaving(on) {
  // ★みなとさん「時々 ページの 矢印が 点滅して います」＝書く たびに ほぞんが 走って 色が ちかちか していた → 0.5びょうより 長い ほぞんだけ 色を かえ、かえたら 0.8びょうは そのまま
  clearTimeout(NOTEINK.savT);
  const set = v => { try { document.querySelectorAll('.flip-btn').forEach(b => b.classList.toggle('saving', v)); } catch (e) {} NOTEINK.savShown = v ? Date.now() : 0; };
  if (on) NOTEINK.savT = setTimeout(() => set(true), 500);
  else if (NOTEINK.savShown) NOTEINK.savT = setTimeout(() => set(false), Math.max(0, 800 - (Date.now() - NOTEINK.savShown)));
  else set(false);
}
async function noteInkFlushRun(opt) {
  const keys = [...NOTEINK.dirty]; if (!keys.length) { if (TK_HOME) noteInkTell('clean'); return true; }
  NOTEINK.dirty.clear();
  if (TK_HOME) noteInkTell('saving');
  if (!SHOP_LOGGED_IN) {
    try { localStorage.setItem(NOTE_LS, JSON.stringify(NOTEINK.pages)); noteInkMsg('保存しました（この ブラウザの 中だけ。ログインすると どこでも 見られます）', 2600); if (TK_HOME) noteInkTell('saved'); return true; }
    catch (e) { noteInkMsg('保存できませんでした'); if (TK_HOME) { keys.forEach(k => NOTEINK.dirty.add(k)); noteInkTell('dirty'); } return false; }
  }
  let all = true;
  if (!(opt && opt.keepalive)) noteInkMsg('保存中…', 10000);
  noteInkSaving(true);
  try { for (const key of keys) {
    const body = JSON.stringify({ action: 'save', page: key, strokes: NOTEINK.pages[key] || [] }, (k, v) => (k === '_live' || k === 'brush' ? undefined : v));
    try {
      const res = await fetch('/apps/techou/note-pages', { method: 'POST', credentials: 'same-origin', keepalive: !!(opt && opt.keepalive) && body.length < 60000, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
      const j = await res.json().catch(() => null);
      if (!res.ok || !j || !j.ok) { all = false; NOTEINK.dirty.add(key); noteInkMsg((j && typeof j.error === 'string' && /[぀-ヿ一-鿿]/.test(j.error)) ? j.error : '保存できませんでした（あとで もう一度）', 3000); }
    } catch (e) { all = false; NOTEINK.dirty.add(key); noteInkMsg('保存できませんでした（つながりません）', 3000); }
  } } finally { noteInkSaving(false); }
  if (all) noteInkMsg('保存しました');
  if (TK_HOME) noteInkTell(all ? 'saved' : 'dirty');
  return all;
}
const NOTE_IMG_RE = /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0741\/1518\/7005\/[^\s"'<>\\]+$/;   // ★安全の 係 L6
const noteCleanItem = st => {
  if (!st || typeof st !== 'object') return null;
  const inR = (v, lo, hi) => Number.isInteger(v) && v >= lo && v <= hi;
  if (st.o === 'img') { return typeof st.u === 'string' && NOTE_IMG_RE.test(st.u) && inR(st.x, 0, 10000) && inR(st.y, 0, 10000) && inR(st.w, 100, 10000) ? { o: 'img', u: st.u, x: st.x, y: st.y, w: st.w, a: inR(st.a, -180, 180) ? st.a : 0 } : null; }
  if (!Array.isArray(st.p) || st.p.length < 2 || st.p.length % 2 || !st.p.every(v => inR(v, 0, 10000))) return null;
  if (st.o === 'cut') return { o: 'cut', s: inR(st.s, 2, 40) ? st.s : 24, p: st.p };   // 背景消し
  if (!/^#[0-9a-f]{6}$/i.test(st.c)) return null;
  const o = { c: st.c.toLowerCase(), t: NOTE_PENS[st.t] ? st.t : 'pen', s: inR(st.s, 2, 40) ? st.s : 16, p: st.p };
  if (Array.isArray(st.q) && st.q.length === st.p.length / 2) o.q = st.q;
  if (Array.isArray(st.v) && st.v.length === st.p.length / 2 && st.v.every(v => inR(v, 0, 999))) o.v = st.v;
  if (st.r === 1) o.r = 1;
  if (typeof st.g === 'string' && /^[A-Za-z0-9]{1,12}$/.test(st.g)) o.g = st.g;
  return o;
};
async function noteInkLoad(tries = 0) {
  let pages = {}, failed = false;
  try {
    if (!SHOP_LOGGED_IN) { const raw = localStorage.getItem(NOTE_LS); if (raw) pages = JSON.parse(raw) || {}; }
    else {
      const res = await fetch('/apps/techou/note-pages', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ action: 'list' }) });
      const j = res.ok ? await res.json() : null;
      if (j && j.ok && j.pages && typeof j.pages === 'object') pages = j.pages; else failed = true;
    }
  } catch (e) { pages = {}; failed = true; }
  // ★2026-10-15 安全の 点検：読めなかった ときに「空っぽ」と 思って 書きはじめると、あとで 保存した とき ほかの ページを 消す おそれ → やりなおして、だめなら 書けなく する
  if (failed && SHOP_LOGGED_IN) {
    if (tries < 3) { setTimeout(() => noteInkLoad(tries + 1), 1500 * (tries + 1)); return; }
    NOTEINK.loadFailed = true; noteInkMsg('読みこめませんでした。ページを 読みこみなおして ください', 9000); noteInkRender(); return;
  }
  NOTEINK.loadFailed = false;
  for (const [k, v] of Object.entries(pages)) {
    if (!/^[nt][A-Za-z0-9_:.\-]{1,60}$/.test(k) || !Array.isArray(v) || NOTEINK.dirty.has(k)) continue;
    NOTEINK.pages[k] = v.map(noteCleanItem).filter(Boolean);
  }
  NOTEINK.loaded = true; NOTEINK.rev++;
  noteInkRender();
}
// えにっきで 保存した ペンの 設定（共通設定）を 読む。読むだけ・ログイン中だけ
async function noteInkLoadSettings() {
  if (!SHOP_LOGGED_IN) return;
  try {
    const res = await fetch('/apps/techou/pen-settings', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}' });
    const j = res.ok ? await res.json() : null; const st = j && j.ok && j.settings;
    if (!st) return;
    if (st.tools) NOTEINK.cfg = st.tools;
    if (st.toolShow) NOTEINK.visible = st.toolShow;
    if (Array.isArray(st.colors) && st.colors.length && !NOTEINK.colorTouched) {   // えにっきの initColorFromList と 同じ：白っぽい 色は 青に・いまの 青が 一覧に なければ 1つめ
      const BLUE = '#1e88e5', nearWhite = c => { const m = /^#?([0-9a-f]{6})$/i.exec(c); if (!m) return false; const v = parseInt(m[1], 16); return ((v >> 16) & 255) >= 236 && ((v >> 8) & 255) >= 236 && (v & 255) >= 236; };
      const list = []; for (const c of st.colors) { const k = nearWhite(c) ? BLUE : c; if (!list.includes(k)) list.push(k); }
      if (!list.includes(NOTEINK.color)) NOTEINK.color = list[0];
    }
    const vis = noteVisibleTools(); if (!vis.includes(NOTEINK.tool)) NOTEINK.tool = vis[0];
    noteInkRender();
  } catch (e) { /* 読めなくても 初期値で 書ける */ }
}
function noteInkNear(p, x, y) {
  const H = NOTEINK.H; let best = 1e9;
  for (let i = 0; i + 1 < p.length; i += 2) {
    const ax = p[i], ay = p[i + 1] * H / 10000, bx = i + 3 < p.length ? p[i + 2] : ax, by = i + 3 < p.length ? p[i + 3] * H / 10000 : ay;
    const dx = bx - ax, dy = by - ay, l2 = dx * dx + dy * dy, t = l2 ? Math.max(0, Math.min(1, ((x - ax) * dx + (y - ay) * dy) / l2)) : 0;
    best = Math.min(best, Math.hypot(x - (ax + t * dx), y - (ay + t * dy)));
  }
  return best;
}
// 点（0〜10000）が 画像の 中か（かたむきも 見る）
function noteImgHit(it, x, y) {
  const b = noteImgBox(it), px = x / 10000 * NOTEINK.W - b.cx, py = y / 10000 * NOTEINK.Hpx - b.cy, a = -(it.a || 0) * Math.PI / 180;
  const lx = px * Math.cos(a) - py * Math.sin(a), ly = px * Math.sin(a) + py * Math.cos(a);
  return Math.abs(lx) <= b.w / 2 && Math.abs(ly) <= b.h / 2;
}
function noteInkPush(key, items, kind) {   // 1回の 操作で 足した もの（戻る で まとめて もどる）
  const list = (NOTEINK.pages[key] = NOTEINK.pages[key] || []);
  for (const it of items) list.push(it);
  (NOTEINK.undo[key] = NOTEINK.undo[key] || []).push({ t: 'add', items });
  if (typeof sampleHide === 'function' && !(items.length === 1 && items[0].p && items[0].p.length <= 4)) sampleHide();   // ★nv0.2.139 見本は「ほんとうの 線が 1本 できた とき」に 消える。ちょん（点）は ダブルタップの 1回目なので 消さない
  noteInkDirty(key); noteInkRender();
}
// ===== アイコン（同じ g の 線）・画像の あつかい =====
const noteGid = () => 'g' + Date.now().toString(36).slice(-6) + Math.random().toString(36).slice(2, 6);
// その 場所（紙の px）に ある いちばん 上の もの：{img}か{g}。画像は かたむきも 見る。アイコンは 四角の 中なら つかめる
function noteObjectAt(key, x, y) {
  const items = (key && NOTEINK.pages[key]) || [], px = x / 10000 * NOTEINK.W, py = y / 10000 * NOTEINK.Hpx, seen = new Set();
  for (let i = items.length - 1; i >= 0; i--) {
    const it = items[i];
    if (it.o === 'img') { if (noteImgHit(it, x, y)) return { img: it }; }
    else if (it.g && !seen.has(it.g)) { seen.add(it.g); const b = noteGroupBox(items, it.g); if (b && px >= b.x0 && px <= b.x1 && py >= b.y0 && py <= b.y1) return { g: it.g }; }
  }
  return null;
}
const noteGroupItems = (key, g) => ((key && NOTEINK.pages[key]) || []).filter(it => it.g === g);
function noteObjCenter(key, o) {   // 紙の 0〜10000
  if (o.img) return [o.img.x, o.img.y];
  const b = noteGroupBox(NOTEINK.pages[key] || [], o.g); return b ? [((b.x0 + b.x1) / 2) / NOTEINK.W * 10000, ((b.y0 + b.y1) / 2) / NOTEINK.Hpx * 10000] : [5000, 5000];
}
function noteObjSnap(key, o) {   // 大きさを かえる 前の すがた（そこから くらべて 変える）
  if (o.img) return { w: o.img.w };
  const c = noteObjCenter(key, o); return { c, items: noteGroupItems(key, o.g).map(it => ({ it, p: it.p.slice(), s: it.s })) };
}
function noteObjScale(key, o, snap, k) {
  if (o.img) { o.img.w = Math.max(300, Math.min(10000, Math.round(snap.w * k))); return; }
  const cl = v => Math.max(0, Math.min(10000, Math.round(v)));
  for (const q of snap.items) { const p = q.p, out = q.it.p; for (let i = 0; i + 1 < p.length; i += 2) { out[i] = cl(snap.c[0] + (p[i] - snap.c[0]) * k); out[i + 1] = cl(snap.c[1] + (p[i + 1] - snap.c[1]) * k); } q.it.s = Math.max(2, Math.min(40, Math.round(q.s * k))); }
}
function noteObjMove(key, o, dx, dy) {   // 0〜10000 の ぶん うごかす
  const cl = v => Math.max(0, Math.min(10000, Math.round(v)));
  if (o.img) { o.img.x = cl(o.img.x + dx); o.img.y = cl(o.img.y + dy); return; }
  for (const it of noteGroupItems(key, o.g)) for (let i = 0; i + 1 < it.p.length; i += 2) { it.p[i] = cl(it.p[i] + dx); it.p[i + 1] = cl(it.p[i + 1] + dy); }
}
function noteSelect(o) { NOTEINK.sel = o && o.img || null; NOTEINK.selG = o && o.g || null; NOTEINK.rev++; }
// ===== ダブルクリック（ダブルタップ）3段階：通常 → 大きく → 小さく → 通常（みなとさん 2026-10-15）=====
const NOTE_ZOOM_BIG = 3.5, NOTE_ZOOM_SMALL = 0.75;
const noteInkOrigin = () => { const r = book.parentElement.getBoundingClientRect(); return { x: r.left + book.offsetLeft, y: r.top + book.offsetTop }; };
function noteInkStepZoom(cx, cy) {
  if (typeof zoom === 'undefined' || typeof zoomAt !== 'function') return;
  const o = noteInkOrigin(), px = cx - o.x, py = cy - o.y;
  if (zoom.s > 1.05) zoomAt(NOTE_ZOOM_SMALL, px, py);            // 大きく → 小さく
  else if (zoom.s < 0.95) { zoom.s = 1; zoom.tx = zoom.ty = 0; applyZoom(); }   // 小さく → 通常
  else zoomAt(NOTE_ZOOM_BIG, px, py);                                // 通常 → 大きく（ダブルタップした ところが 中心）
}
// ★2026-10-16 スクロール：トップページでは この 紙は 枠（iframe）の 中。スクロールするのは 外側（ページ か .main）
function noteScrollTarget() {
  try {
    const fe = window.frameElement; if (!fe) return window;
    const pw = fe.ownerDocument.defaultView; let el = fe.parentElement;
    while (el && el !== fe.ownerDocument.documentElement) {
      const o = pw.getComputedStyle(el).overflowY;
      if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return pw;
  } catch (e) { return window; }
}
function noteFrameTop() { try { const fe = window.frameElement; return fe ? fe.getBoundingClientRect().top : 0; } catch (e) { return 0; } }   // 枠（iframe）の 上が 外の ページの 画面で どこか
// ★2026-10-16 みなとさん「2本指だと 画面が チカチカ」＝外の ページは html{scroll-behavior:smooth}。指の 動きごとに スクロールを 命令すると
//   なめらかに 動こうと 追いかけて ちらつく → ①ジェスチャーの あいだだけ auto に ②1フレームに 1回だけ まとめて 動かす
const NOTE_SCR = { t: null, pend: 0, raf: 0, saved: [] };
function noteScrollBegin(t) {
  noteScrollEnd(); NOTE_SCR.t = t;
  try {
    const d = t.document || t.ownerDocument, els = [d.documentElement]; if (t.nodeType === 1) els.push(t);
    NOTE_SCR.saved = els.map(e => [e, e.style.getPropertyValue('scroll-behavior'), e.style.getPropertyPriority('scroll-behavior')]);
    els.forEach(e => e.style.setProperty('scroll-behavior', 'auto', 'important'));
  } catch (e) { NOTE_SCR.saved = []; }
}
function noteScrollApply() {
  const t = NOTE_SCR.t, v = NOTE_SCR.pend; NOTE_SCR.pend = 0; if (!t || !v) return;
  try { if (t.nodeType === 1) t.scrollTop += v; else t.scrollTo(t.scrollX, t.scrollY + v); } catch (e) {}
}
function noteScrollBy(t, dy) {
  if (NOTE_SCR.t !== t) noteScrollBegin(t);
  NOTE_SCR.pend += dy; if (NOTE_SCR.raf) return;
  NOTE_SCR.raf = requestAnimationFrame(() => { NOTE_SCR.raf = 0; noteScrollApply(); });
}
function noteScrollEnd() {
  if (NOTE_SCR.raf) { cancelAnimationFrame(NOTE_SCR.raf); NOTE_SCR.raf = 0; }
  noteScrollApply();
  for (const [e, v, pr] of NOTE_SCR.saved) { try { if (v) e.style.setProperty('scroll-behavior', v, pr); else e.style.removeProperty('scroll-behavior'); } catch (er) {} }
  NOTE_SCR.saved = []; NOTE_SCR.t = null;
}
function noteInkApplyScroll() { const cv = NOTEINK.cv; if (!cv) return; cv.style.touchAction = NOTEINK.scroll ? 'pan-y' : ''; cv.style.cursor = NOTEINK.scroll ? 'default' : ''; }
let noteRenderRaf = 0;
function noteInkRenderSoon() { if (noteRenderRaf) return; noteRenderRaf = requestAnimationFrame(() => { noteRenderRaf = 0; noteInkRender(); }); }
function noteInkBind(cv) {
  let tapT = 0, tapX = 0, tapY = 0, tapItem = null, tapTimer = 0, paperPinch = null;
  let pts = null, spd = null, down = false, t0 = 0, drag = null, pinch = null, skipUp = false, shoLive = null, shoLast = null, shoSpeed = 0;
  let scTap = null, scLastTap = 0, scLastX = 0, scLastY = 0;   // ★スクロール中の ダブルタップ（紙の 大きさ）
  const ptrs = new Map(), scrY = new Map(), palm = new Set();   // palm＝Apple Pencil で 書いて いる あいだに ふれた 手のひら（touch）の id
  let penId = null, penUpAt = 0;   // scrY：画面ぜんたいの たて位置（スクロールしても ずれない）
  const pos = e => { const r = cv.getBoundingClientRect(); return [Math.min(10000, Math.max(0, Math.round((e.clientX - r.left) / r.width * 10000))), Math.min(10000, Math.max(0, Math.round((e.clientY - r.top) / r.height * 10000)))]; };
  const clearLive = () => { const lc = NOTEINK.live.getContext('2d'); lc.setTransform(1, 0, 0, 1, 0, 0); lc.clearRect(0, 0, NOTEINK.live.width, NOTEINK.live.height); };
  const eraseAt = (x, y) => {
    const key = noteInkKey(), list = key && NOTEINK.pages[key]; if (!list || !list.length) return;
    const yy = y * NOTEINK.H / 10000;
    for (let i = list.length - 1; i >= 0; i--) {
      const it = list[i], hit = it.o === 'img' ? noteImgHit(it, x, y) : noteInkNear(it.p, x, yy) < 160;
      if (hit) {
        const gone = it.g ? list.filter(q => q.g === it.g) : [it];   // アイコンは まとめて 消える
        for (const q of gone) { const k = list.indexOf(q); if (k >= 0) list.splice(k, 1); }
        if (NOTEINK.sel === it) NOTEINK.sel = null; if (it.g && NOTEINK.selG === it.g) NOTEINK.selG = null;
        (NOTEINK.undo[key] = NOTEINK.undo[key] || []).push({ t: 'del', i: Math.min(i, list.length), items: gone }); noteInkDirty(key); noteInkRender(); return;
      }
    }
  };
  const drawLive = () => {
    const lc = NOTEINK.live.getContext('2d'); lc.setTransform(NOTEINK.dpr, 0, 0, NOTEINK.dpr, 0, 0); lc.clearRect(0, 0, NOTEINK.W, NOTEINK.Hpx);
    if (NOTEINK.mode === 'cut') { lc.strokeStyle = 'rgba(229,57,53,.45)'; lc.lineCap = lc.lineJoin = 'round'; lc.lineWidth = 24 * notePxUnit(); lc.beginPath(); for (let i = 0; i + 1 < pts.length; i += 2) { const x = pts[i] / 10000 * NOTEINK.W, y = pts[i + 1] / 10000 * NOTEINK.Hpx; if (i === 0) { lc.moveTo(x, y); lc.lineTo(x + .01, y); } else lc.lineTo(x, y); } lc.stroke(); return; }
    if (NOTEINK.tool === 'sho' && shoLive) { noteShoDraw(lc, shoLive, NOTEINK.color); return; }
    noteDrawStroke(lc, { c: NOTEINK.color, t: NOTEINK.tool, s: noteInkDrawSize(NOTEINK.tool), p: pts }, noteLivePressure(pts));
  };
  const placeIcon = (x, y) => {
    const d = NOTE_STAMPS.find(s => s.id === NOTEINK.iconId), key = noteInkKey(); if (!d || !key) return;
    const px = NOTEINK.W * NOTE_ICON_BASE * d.size / 0.44, s = Math.max(2, Math.min(40, Math.round(px * NOTE_LINE_RATIO / notePxUnit())));
    const cx = x / 10000 * NOTEINK.W, cy = y / 10000 * NOTEINK.Hpx, items = [], g = noteGid();
    for (const line of d.lines) {
      if (line.length < 2) continue;
      const p = []; for (const [ux, uy] of line) { p.push(Math.max(0, Math.min(10000, Math.round((cx - px / 2 + ux * px) / NOTEINK.W * 10000)))); p.push(Math.max(0, Math.min(10000, Math.round((cy - px / 2 + uy * px) / NOTEINK.Hpx * 10000)))); }
      if (p.length <= NOTE_POINTS_MAX * 2) items.push({ c: NOTEINK.color, t: 'pen', s, p, r: 1, g });
    }
    if (items.length) { noteInkPush(key, items); NOTEINK.sel = null; NOTEINK.selG = g; NOTEINK.iconId = null; noteInkBarSync(); noteInkRender(); noteInkMsg('おきました。つぎも おく ときは「アイコン」から もう一度 えらんで ください（おいた ものは ドラッグで うごかせます）', 3600); }   // ★2026-10-15 みなとさん「スタンプは 1回 おしたら もう一度 えらばないと おせない」
  };
  const shoStart = (x, y) => { // 書：描きはじめ
    const k = noteVirtW() / 10000, vh = k * (NOTEINK.Hpx / NOTEINK.W) * 10000;
    shoLive = { core: [], pool: [], hair: [], brush: NOTE_FUDE.create(Object.assign({}, NOTE_FUDE.DEFAULTS)), k, vh };
    NOTE_FUDE.begin(shoLive.brush, x * k, y / 10000 * vh); shoLast = { x: x * k, y: y / 10000 * vh, t: Date.now() }; shoSpeed = 0;
  };
  const shoMove = (x, y) => { // 書：なぞっている あいだ（時間で はかった 本当の 速さ）
    const L = shoLast, X = x * shoLive.k, Y = y / 10000 * shoLive.vh, dx = X - L.x, dy = Y - L.y, dist = Math.sqrt(dx * dx + dy * dy), now = Date.now();
    const screenDist = Math.hypot((x - shoLive.px) * NOTEINK.W / 10000, (y - shoLive.py) * NOTEINK.Hpx / 10000);   // 画面の px の 動き
    const dt = Math.max(4, Math.min(64, now - L.t)); shoSpeed += (screenDist / dt * 16 - shoSpeed) * 0.5;
    const press = noteShoPress(shoSpeed), steps = Math.max(1, Math.min(24, Math.ceil(dist / 2)));
    for (let i = 1; i <= steps; i++) noteShoStore(shoLive, NOTE_FUDE.step(shoLive.brush, L.x + dx * (i / steps), L.y + dy * (i / steps), press, shoSpeed));
    shoLast = { x: X, y: Y, t: now }; shoLive.px = x; shoLive.py = y;
  };
  cv.addEventListener('pointerdown', e => {
    /* ★2026-10-16 みなとさん「Apple Pencil で 書いて いると かすれます」＝ペンで 書いて いる あいだに 手のひらが ふれると、2本指の しるし（ピンチ・スクロール）と まちがえて 書いて いる 線を **やめて** いた（線が とぎれる・きえる）。
       → ペンが ついて いる あいだと 離した 直後（0.5びょう）の touch は 手のひらと みなして ぜんぶ むしする */
    if (e.pointerType === 'pen') {   // ペンが つく まえから 手のひらが ふれて いた とき：その 指は ぜんぶ 手のひら あつかいに して、ペンの 線を あたらしく はじめる
      for (const id of ptrs.keys()) palm.add(id);
      ptrs.clear(); scrY.clear(); pts = null; spd = null; shoLive = null; drag = null; pinch = null; paperPinch = null; down = false; skipUp = false; clearLive();
      penId = e.pointerId;
    }
    else if (e.pointerType === 'touch' && (penId !== null || Date.now() - penUpAt < 500)) { palm.add(e.pointerId); e.preventDefault(); return; }
    if (NOTEINK.scroll) {   // ★スクロール中は 書かない・止めない（1本指は ブラウザが 上下に スクロール）。★みなとさん「スクロールでも ズームできるように」＝2本指の ピンチで 紙を ズーム・ダブルタップで 紙の 大きさ
      if (e.pointerType !== 'touch' || typeof zoom === 'undefined') return;
      ptrs.set(e.pointerId, [e.clientX, e.clientY]); scrY.set(e.pointerId, e.clientY + noteFrameTop());
      if (ptrs.size === 2) {
        pts = null; spd = null; down = false; scTap = null; clearLive();
        const v = [...ptrs.values()], mx = (v[0][0] + v[1][0]) / 2, my = (v[0][1] + v[1][1]) / 2, og = noteInkOrigin(), m = { x: mx - og.x, y: my - og.y };
        paperPinch = { d0: Math.max(10, Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1])), s0: zoom.s, c: { x: (m.x - zoom.tx) / zoom.s, y: (m.y - zoom.ty) / zoom.s } };
      } else if (ptrs.size === 1) scTap = { x: e.clientX, y: e.clientY, t: Date.now(), moved: false };
      return;
    }
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    e.preventDefault(); e.stopPropagation();
    if (NOTEINK.sq && NOTEINK.mode !== 'photo') { NOTEINK.sq = null; noteInkBarSync(); }
    try { cv.setPointerCapture(e.pointerId); } catch (er) {}
    ptrs.set(e.pointerId, [e.clientX, e.clientY]); scrY.set(e.pointerId, e.clientY + noteFrameTop());
    const md = NOTEINK.mode, key = noteInkKey(); if (!key) return;
    if (ptrs.size === 2) {   // 2本指：えにっきと 同じに、画像・アイコンを つまんで 大きさを かえる（どの 道具の ときも）
      pts = null; spd = null; shoLive = null; drag = null; down = false; skipUp = true; clearLive();
      const v = [...ptrs.values()], r = cv.getBoundingClientRect(), mx = (v[0][0] + v[1][0]) / 2, my = (v[0][1] + v[1][1]) / 2;
      const x = (mx - r.left) / r.width * 10000, y = (my - r.top) / r.height * 10000;
      const o = noteObjectAt(key, x, y) || noteObjectAt(key, (v[0][0] - r.left) / r.width * 10000, (v[0][1] - r.top) / r.height * 10000) || noteObjectAt(key, (v[1][0] - r.left) / r.width * 10000, (v[1][1] - r.top) / r.height * 10000);
      pinch = o ? { o, d0: Math.max(10, Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1])), snap: noteObjSnap(key, o), c0: [mx, my] } : null;
      if (o) { noteSelect(o); noteInkRender(); }
      else if (typeof zoom !== 'undefined') {   // ものが ない：紙ぜんたいを つまんで 大きさ・ずらし（拡大中は 2本指で うごかす）
        const og = noteInkOrigin(), m = { x: mx - og.x, y: my - og.y };
        paperPinch = { d0: Math.max(10, Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1])), s0: zoom.s, c: { x: (m.x - zoom.tx) / zoom.s, y: (m.y - zoom.ty) / zoom.s } };
        // ★2026-10-16 みなとさん「2本指で スクロール」：拡大して いない ときは、指の まん中が たてに 動けば ページを スクロール／指が ひらく・とじる なら 今までの ズーム
        if (zoom.s <= 1.02) paperPinch.scr = { mode: '', y0: ([...scrY.values()].reduce((a, b) => a + b, 0)) / Math.max(1, scrY.size), y: 0, target: noteScrollTarget() };
      }
      return;
    }
    if (ptrs.size > 2) return;
    down = true; skipUp = false; t0 = Date.now();
    const [x, y] = pos(e);
    if (md === 'erase') { eraseAt(x, y); return; }
    if (md === 'icon' || md === 'stamp' || md === 'photo') {
      const o = noteObjectAt(key, x, y);
      if (o) { noteSelect(o); const c = noteObjCenter(key, o); drag = { o, lx: x, ly: y, moved: false }; noteInkRender(); return; }
      if (md === 'icon') { if (NOTEINK.iconId) placeIcon(x, y); else noteInkMsg('おく アイコンを えらんで ください（「アイコン」ボタン）', 2200); down = false; return; }
      if (md === 'stamp') {
        if (NOTEINK.stampUrl) { const it = { o: 'img', u: NOTEINK.stampUrl, x, y, w: 2200, a: 0 }; noteSelect({ img: it }); NOTEINK.stampUrl = null; noteInkPush(key, [it]); noteInkBarSync(); noteInkMsg('おきました。つぎも おく ときは「スタンプ」から もう一度 えらんで ください（おいた 絵は ドラッグで うごかせます）', 3600); }
        else noteInkMsg('おく スタンプを えらんで ください（「スタンプ」ボタン）', 2200);
        down = false; return;
      }
      noteSelect(null); noteInkRender(); down = false; return;
    }
    if ((NOTEINK.pages[key] || []).length >= NOTE_STROKES_MAX) { down = false; noteInkMsg('このページは いっぱいです'); return; }
    pts = [x, y]; spd = [0];
    if (NOTE_DBG) { noteDbg.n++; noteDbg.ev = 0; noteDbg.kept = 1; noteDbg.skip = 0; noteDbg.cap = 0; noteDbg.gap = 0; noteDbg.coal = 0; noteDbg.last = performance.now(); noteDbg.t0 = noteDbg.last; noteDbg.type = e.pointerType; noteDbgShow(); }
    if (md === 'pen' && NOTEINK.tool === 'sho') { shoStart(x, y); shoLive.px = x; shoLive.py = y; }
    drawLive();
  });
  cv.addEventListener('pointermove', e => {
    if (palm.has(e.pointerId)) { e.preventDefault(); return; }
    if (ptrs.has(e.pointerId)) { ptrs.set(e.pointerId, [e.clientX, e.clientY]); scrY.set(e.pointerId, e.clientY + noteFrameTop()); }
    if (scTap && Math.hypot(e.clientX - scTap.x, e.clientY - scTap.y) > 10) scTap.moved = true;
    const key = noteInkKey();
    if (paperPinch && paperPinch.scr && paperPinch.scr.mode !== 'zoom' && ptrs.size >= 2) {
      e.preventDefault(); const v = [...ptrs.values()], d = Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1]), sy = [...scrY.values()], cy = (sy[0] + sy[1]) / 2, S = paperPinch.scr;
      if (!S.mode) { const dd = Math.abs(d - paperPinch.d0), dy = Math.abs(cy - S.y0); if (Math.max(dd, dy) > 12) { S.mode = dy > dd * 0.7 ? 'scroll' : 'zoom'; if (S.mode === 'scroll') S.y = cy; } }   // ★2本指の たての 動き ＞ ひらき・とじ なら スクロール
      if (S.mode === 'scroll') { noteScrollBy(S.target, S.y - cy); S.y = cy; return; }
      if (!S.mode) return;   // まだ どちらか きまらない
    }
    if (paperPinch && ptrs.size >= 2 && typeof zoom !== 'undefined') {
      e.preventDefault(); const v = [...ptrs.values()], d = Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1]), og = noteInkOrigin(), mx = (v[0][0] + v[1][0]) / 2 - og.x, my = (v[0][1] + v[1][1]) / 2 - og.y;
      zoom.s = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, paperPinch.s0 * d / paperPinch.d0)); zoom.tx = mx - zoom.s * paperPinch.c.x; zoom.ty = my - zoom.s * paperPinch.c.y; applyZoom(); return;
    }
    if (pinch && ptrs.size >= 2) {
      e.preventDefault(); const v = [...ptrs.values()], d = Math.hypot(v[0][0] - v[1][0], v[0][1] - v[1][1]), r = cv.getBoundingClientRect();
      noteObjScale(key, pinch.o, pinch.snap, d / pinch.d0);
      const mx = (v[0][0] + v[1][0]) / 2, my = (v[0][1] + v[1][1]) / 2;   // 2本指の まん中が うごいたら その ぶん うごかす
      if (pinch.o.g) { noteObjMove(key, pinch.o, (mx - pinch.c0[0]) / r.width * 10000, (my - pinch.c0[1]) / r.height * 10000); pinch.snap = noteObjSnap(key, pinch.o); pinch.d0 = d; pinch.c0 = [mx, my]; }
      else { noteObjMove(key, pinch.o, (mx - pinch.c0[0]) / r.width * 10000, (my - pinch.c0[1]) / r.height * 10000); pinch.c0 = [mx, my]; }
      NOTEINK.rev++; noteInkRender(); return;
    }
    if (!down) return;
    e.preventDefault(); e.stopPropagation();
    const [x, y] = pos(e);
    if (drag) { noteObjMove(key, drag.o, x - drag.lx, y - drag.ly); drag.lx = x; drag.ly = y; drag.moved = true; NOTEINK.rev++; noteInkRender(); return; }
    if (NOTEINK.mode === 'erase') { eraseAt(x, y); return; }
    if (!pts) return;
    /* ★2026-10-16 ペンは 1回の イベントに 複数の 点が まとまって くる ことが ある（getCoalescedEvents）。ぜんぶ 使うと 線が なめらかで とぎれない。対応して いない ブラウザは これまで どおり 1点 */
    let evs = null; try { if (!shoLive && typeof e.getCoalescedEvents === 'function') { const c = e.getCoalescedEvents(); if (c && c.length > 1) evs = c; } } catch (er) {}
    if (NOTE_DBG) { const nw = performance.now(); noteDbg.ev++; noteDbg.gap = Math.max(noteDbg.gap, nw - noteDbg.last); noteDbg.last = nw; if (evs) noteDbg.coal += evs.length - 1; }
    let added = false;
    for (const ev of (evs || [e])) {
      const [px, py] = ev === e ? [x, y] : pos(ev);
      const lx = pts[pts.length - 2], ly = pts[pts.length - 1], u = NOTEINK.W / 10000;
      if (pts.length >= NOTE_POINTS_MAX * 2) { if (NOTE_DBG) noteDbg.cap++; continue; }
      if (Math.hypot((px - lx) * u, (py - ly) * u) < 1.2) { if (NOTE_DBG) noteDbg.skip++; continue; }
      pts.push(px, py);
      if (shoLive) { shoMove(px, py); spd.push(Math.max(0, Math.min(999, Math.round(shoSpeed * 10)))); } else spd.push(0);
      added = true; if (NOTE_DBG) noteDbg.kept++;
    }
    if (added) drawLive();
    if (NOTE_DBG) noteDbgShow();
  });
  const end = e => {
    if (NOTE_DBG && e.type === 'pointercancel') { noteDbg.cancel++; noteDbgShow(); }
    if (palm.has(e.pointerId)) { palm.delete(e.pointerId); return; }
    if (NOTEINK.scroll && e.pointerType === 'touch' && ptrs.has(e.pointerId)) {   // ★スクロール中：ピンチを おわる／ダブルタップで 紙の 大きさ（実寸→3/4→0.55。ずれて いたら 実寸に もどす）
      const only = ptrs.size === 1; ptrs.delete(e.pointerId); scrY.delete(e.pointerId);
      if (ptrs.size < 2) paperPinch = null;
      if (e.type === 'pointerup' && only && scTap && !scTap.moved && Date.now() - scTap.t < 300 && typeof zoom !== 'undefined') {
        const nowT = Date.now(), og = noteInkOrigin();
        if (nowT - scLastTap < 350 && Math.abs(e.clientX - scLastX) < 30 && Math.abs(e.clientY - scLastY) < 30) {
          scLastTap = 0;
          if (zoom.s !== 1 || zoom.tx || zoom.ty) { zoom.s = 1; zoom.tx = 0; zoom.ty = 0; setZoom(false); applyZoom(); } else stepZoom(e.clientX - og.x, e.clientY - og.y);
        } else { scLastTap = nowT; scLastX = e.clientX; scLastY = e.clientY; }
      }
      scTap = null; return;
    }
    if (e.pointerType === 'pen' && e.pointerId === penId) { penId = null; penUpAt = Date.now(); }
    const had = ptrs.has(e.pointerId); ptrs.delete(e.pointerId); scrY.delete(e.pointerId);
    if (ptrs.size < 2) { if (paperPinch && paperPinch.scr && paperPinch.scr.mode === 'scroll') noteScrollEnd(); paperPinch = null; }
    if (ptrs.size < 2 && pinch) { pinch = null; const k = noteInkKey(); if (k) noteInkDirty(k); }
    if (!had) return;
    if (skipUp) { if (!ptrs.size) skipUp = false; return; }
    if (!down) return;
    down = false; e.stopPropagation();
    const key = noteInkKey();
    if (drag) { if (drag.moved && key) noteInkDirty(key); drag = null; return; }
    if (NOTEINK.mode === 'erase' || !pts) { pts = null; return; }
    const p = pts, sp = spd; pts = null; spd = null;
    // ちょん（動かさない・みじかい）：2回 つづけて ＝ 3段階の ズーム／1回 ＝ 手帳は 日づけを おす（予定）・ノートは 点を うつ
    if (p.length <= 4 && Date.now() - t0 < 450 && (NOTEINK.mode === 'pen' || NOTEINK.mode === 'erase')) {
      const now = Date.now(), dbl = now - tapT < 350 && Math.hypot(e.clientX - tapX, e.clientY - tapY) < 30;
      if (dbl) {
        clearTimeout(tapTimer); clearLive(); shoLive = null; tapT = 0;
        if (tapItem) { const list = NOTEINK.pages[key] || [], i = list.lastIndexOf(tapItem); if (i >= 0) { list.splice(i, 1); const u = NOTEINK.undo[key]; if (u && u.length && u[u.length - 1].items && u[u.length - 1].items[0] === tapItem) u.pop(); noteInkDirty(key); } tapItem = null; }
        noteInkStepZoom(e.clientX, e.clientY); return;
      }
      tapT = now; tapX = e.clientX; tapY = e.clientY; tapItem = null;
      if (typeof noteInkTapThrough === 'function' && NOTEINK.mode === 'pen') {   // 手帳：2回目が 来ないか 少し まって から 予定の 窓
        clearLive(); shoLive = null; const cx = e.clientX, cy = e.clientY;
        tapTimer = setTimeout(() => { tapT = 0; noteInkTapThrough(cx, cy); }, 330);
        return;
      }
    }
    if (NOTEINK.mode === 'cut') { clearLive(); noteInkPush(key, [{ o: 'cut', s: 24, p }]); return; }
    const st = { c: NOTEINK.color, t: NOTEINK.tool, s: noteInkDrawSize(NOTEINK.tool), p };
    if (NOTEINK.tool === 'sho') {
      if (shoLive) { noteShoStore(shoLive, NOTE_FUDE.end(shoLive.brush)); for (const d of shoLive.hair) d.k = Math.round(d.w * 4) * 64 + Math.round(d.a * 24); shoLive.hair.sort((a, b) => a.k - b.k); NOTE_SHO_CACHE.set(st, { core: shoLive.core, pool: shoLive.pool, hair: shoLive.hair }); }   // ★描画用の 大きな データは 線に つけない（保存に まざって 巨大に なる）
      st.v = sp.slice(0, p.length / 2); while (st.v.length < p.length / 2) st.v.push(0);
      shoLive = null;
    } else st.q = noteLivePressure(p).map(v => Math.round(v * 100));
    noteInkPush(key, [st]);
    if (tapT && NOTEINK.mode === 'pen' && p.length <= 4) tapItem = st;   // 点（ちょん）を おぼえて おく（2回目の ちょんで 消す）
  };
  cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
  // ★2026-10-16 iPad Safari：Apple Pencil の 線が 途中で きえる ことが ある（Scribble や スクロールの 既定の 動きが イベントを うばう）→ 書く 層の touchmove の 既定を とめる（スクロール モード中は 除く）
  cv.addEventListener('touchmove', ev => { if ((!NOTEINK.scroll || ev.touches.length >= 2) && ev.cancelable) ev.preventDefault(); }, { passive: false });   // ★スクロール中も 2本指の あいだは ブラウザの スクロール・ズームを 止める（紙の ピンチ用）
  cv.addEventListener('wheel', e => {   // パソコン：ホイール／トラックパッドの ピンチで、えらんだ（またはポインタの 下の）画像・アイコンの 大きさ
    const key = noteInkKey(); if (!key) return;
    let o = null;
    if (NOTEINK.mode === 'stamp' || NOTEINK.mode === 'photo' || NOTEINK.mode === 'icon') o = NOTEINK.sel ? { img: NOTEINK.sel } : NOTEINK.selG ? { g: NOTEINK.selG } : null;
    if (!o && e.ctrlKey) { const [x, y] = pos(e); o = noteObjectAt(key, x, y); }
    if (!o) return;
    e.preventDefault(); noteObjScale(key, o, noteObjSnap(key, o), e.deltaY < 0 ? 1.08 : 1 / 1.08); noteInkDirty(key); noteInkRender();
  }, { passive: false });
  NOTEINK.scaleSel = k => { const key = noteInkKey(), o = NOTEINK.sel ? { img: NOTEINK.sel } : NOTEINK.selG ? { g: NOTEINK.selG } : null; if (!key || !o) return; noteObjScale(key, o, noteObjSnap(key, o), k); noteInkDirty(key); noteInkRender(); };
}
function noteLivePressure(p) {
  const cfg = noteCfg(NOTEINK.tool), pts = [];
  for (let i = 0; i + 1 < p.length; i += 2) pts.push({ sx: p[i] / 10000 * NOTEINK.W, sy: p[i + 1] / 10000 * NOTEINK.Hpx });
  if (pts.length < 2) return pts.map(() => 1);
  return notePressures(noteStreamline(pts, cfg.streamline), noteInkDrawSize(NOTEINK.tool), cfg.thinning);
}
function noteInkUndo() {
  const key = noteInkKey(), u = key && NOTEINK.undo[key]; if (!u || !u.length) return;
  const a = u.pop(), list = NOTEINK.pages[key] = NOTEINK.pages[key] || [];
  if (a.t === 'add') { for (const it of a.items) { const i = list.lastIndexOf(it); if (i >= 0) list.splice(i, 1); if (NOTEINK.sel === it) NOTEINK.sel = null; } }
  else list.splice(Math.min(a.i, list.length), 0, ...a.items);
  noteInkDirty(key); noteInkRender();
}
// ===== 🎲 まわす キューブ（えにっきの sd-cube.js と 同じ）：なぞると 回る・紐を 持つと 動く・ダブルタップで 正面 =====
const NOTE_CUBE = {
  SIZE: 68, R: 22, HANDLE_R: 10, STRING_LEN: 40, SWAY: 1.6,
  FACES: [{ n: [0, 0, -1], label: '前' }, { n: [0, 0, 1], label: '後' }, { n: [0, -1, 0], label: '上' }, { n: [0, 1, 0], label: '下' }, { n: [1, 0, 0], label: '右' }, { n: [-1, 0, 0], label: '左' }],
  CORNERS: [[-1, -1, -1], [1, -1, -1], [1, 1, -1], [-1, 1, -1], [-1, -1, 1], [1, -1, 1], [1, 1, 1], [-1, 1, 1]],
  EDGES: [[0, 1], [1, 2], [2, 3], [3, 0], [4, 5], [5, 6], [6, 7], [7, 4], [0, 4], [1, 5], [2, 6], [3, 7]],
  _rot(x, y, z, rotX, rotY) { const rx = x * Math.cos(rotY) - z * Math.sin(rotY), rz = x * Math.sin(rotY) + z * Math.cos(rotY); return { x: rx, y: y * Math.cos(rotX) - rz * Math.sin(rotX), z: y * Math.sin(rotX) + rz * Math.cos(rotX) }; },
  draw(ctx, rotX, rotY) {
    const S = this.SIZE, R = this.R, cx = S / 2, cy = S / 2; ctx.clearRect(-30, 0, 130, 170);
    const pts = this.CORNERS.map(([x, y, z]) => { const p = this._rot(x * R, y * R, z * R, rotX, rotY), d = 240 / (240 + p.z); return { x: cx + p.x * d, y: cy + p.y * d, z: p.z }; });
    const edges = this.EDGES.map(([a, b]) => ({ a, b, z: (pts[a].z + pts[b].z) / 2 })).sort((p, q) => q.z - p.z);
    ctx.lineCap = 'round';
    for (const e of edges) { const near = e.z < 0; ctx.strokeStyle = near ? 'rgba(200,230,255,0.95)' : 'rgba(140,180,230,0.35)'; ctx.lineWidth = near ? 1.8 : 1.1; ctx.beginPath(); ctx.moveTo(pts[e.a].x, pts[e.a].y); ctx.lineTo(pts[e.b].x, pts[e.b].y); ctx.stroke(); }
    let best = null, bestZ = Infinity;
    for (const f of this.FACES) { const p = this._rot(f.n[0] * R, f.n[1] * R, f.n[2] * R, rotX, rotY); if (p.z < bestZ) { bestZ = p.z; best = { f, p }; } }
    if (best) { const d = 240 / (240 + best.p.z); ctx.fillStyle = 'rgba(255,255,255,0.92)'; ctx.font = '700 13px -apple-system, "Hiragino Sans", sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(best.f.label, cx + best.p.x * d * 0.55, cy + best.p.y * d * 0.55); }
  },
  _joints: null, _t: 0,
  stepString(bx, by) {
    const N = 5, seg = this.STRING_LEN / N;
    if (!this._joints) { this._joints = []; for (let i = 0; i <= N; i++) this._joints.push({ x: bx, y: by + seg * i }); }
    const j = this._joints; j[0].x = bx; j[0].y = by + this.SIZE; this._t += 0.06;
    for (let i = 1; i <= N; i++) {
      const prev = j[i - 1];
      j[i].x += (prev.x - j[i].x) * 0.22; j[i].y += (prev.y + seg - j[i].y) * 0.30;
      j[i].x += Math.sin(this._t + i * 0.7) * 0.18 * this.SWAY * i; j[i].y += 0.6;
      const dx = j[i].x - prev.x, dy = j[i].y - prev.y, len = Math.sqrt(dx * dx + dy * dy) || 1;
      j[i].x = prev.x + dx / len * seg; j[i].y = prev.y + dy / len * seg;
    }
    return j;
  },
  drawString(ctx, bx, by) {
    const j = this.stepString(bx, by), col = 'rgba(170,215,255,0.65)';
    ctx.save(); ctx.strokeStyle = col; ctx.lineWidth = 1.5; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(j[0].x, j[0].y);
    for (let i = 1; i < j.length; i++) { const a = j[i - 1], b = j[i]; ctx.quadraticCurveTo(a.x, a.y, (a.x + b.x) / 2, (a.y + b.y) / 2); }
    ctx.lineTo(j[j.length - 1].x, j[j.length - 1].y); ctx.stroke();
    const h = j[j.length - 1]; ctx.fillStyle = 'rgba(30,50,90,0.9)'; ctx.beginPath(); ctx.arc(h.x, h.y, this.HANDLE_R, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = col; ctx.beginPath(); ctx.arc(h.x, h.y, 2.2, 0, Math.PI * 2); ctx.fill(); ctx.restore();
  },
  hitHandle(sx, sy) { const j = this._joints; if (!j) return false; const h = j[j.length - 1], dx = sx - h.x, dy = sy - h.y, r = this.HANDLE_R + 12; return dx * dx + dy * dy < r * r; },
};
const NOTE_CUBE_SPEED = 0.012, NOTE_CUBE_FRONT = { x: 0.2, y: 0 };
function noteCubeTilt() {   // キューブの むき → 紙の かたむき
  const d = 180 / Math.PI, r = NOTEINK.rot;
  NOTEINK.tilt = { a: Math.max(-70, Math.min(70, r.y * d)), b: Math.max(-70, Math.min(70, -(r.x - NOTE_CUBE_FRONT.x) * d)) };
  noteInkApplyTilt(false);
}
function noteInkShowBall(on) {
  const area = document.querySelector('.paper-area'), B = NOTEINK.ball;
  if (!on) { if (B.raf) cancelAnimationFrame(B.raf); B.raf = 0; if (B.el) B.el.remove(); B.el = B.cv = null; return; }
  if (!area || B.el) return;
  // ★ボールは 紙（かたむく ほう）の 外に おく：紙の 親（stage）の 上に 重ねる
  const host = area.parentElement; if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
  const el = document.createElement('div'); el.className = 'note-cube';
  const place = () => { el.style.left = (area.offsetLeft + B.x) + 'px'; el.style.top = (area.offsetTop + B.y) + 'px'; };
  place();
  const cv = document.createElement('canvas'); cv.className = 'note-cube-cv'; cv.width = 120; cv.height = 170; el.append(cv); host.append(el); B.el = el; B.cv = cv;
  const ctx = cv.getContext('2d'); NOTE_CUBE._joints = null;
  const loop = () => { if (!B.el) return; ctx.clearRect(0, 0, 120, 170); ctx.save(); ctx.translate(26, 0); NOTE_CUBE.draw(ctx, NOTEINK.rot.x, NOTEINK.rot.y); ctx.restore(); NOTE_CUBE.drawString(ctx, 26 + 34, 0); B.raf = requestAnimationFrame(loop); };
  B.raf = requestAnimationFrame(loop);
  let down = false, moving = false, onString = false, sx = 0, sy = 0, lx = 0, ly = 0, lastTap = 0;
  cv.addEventListener('pointerdown', e => {
    down = true; moving = false; sx = lx = e.clientX; sy = ly = e.clientY;
    const r = cv.getBoundingClientRect(); onString = NOTE_CUBE.hitHandle(e.clientX - r.left, e.clientY - r.top);
    try { cv.setPointerCapture(e.pointerId); } catch (er) {}
    e.stopPropagation(); if (e.cancelable) e.preventDefault();
  });
  cv.addEventListener('pointermove', e => {
    if (!down) return;
    const dx = e.clientX - lx, dy = e.clientY - ly;
    if (!moving && (Math.abs(e.clientX - sx) > 4 || Math.abs(e.clientY - sy) > 4)) moving = true;
    if (moving) {
      if (onString) { const aw = area.offsetWidth, ah = area.offsetHeight; B.x = Math.max(-20, Math.min(aw - 50, B.x + dx)); B.y = Math.max(0, Math.min(ah - 60, B.y + dy)); place(); }   // ✋ 紐を ひっぱって ボールを うごかす
      else { NOTEINK.rot.y += dx * NOTE_CUBE_SPEED; NOTEINK.rot.x += dy * NOTE_CUBE_SPEED; noteCubeTilt(); }                                                                            // 🎲 なぞって 回す
    }
    lx = e.clientX; ly = e.clientY; e.stopPropagation();
  });
  const end = e => {
    if (!down) return; down = false; e.stopPropagation();
    if (!moving) {   // ダブルタップで 正面
      const now = Date.now();
      if (now - lastTap < 320) { lastTap = 0; NOTEINK.rot = { x: NOTE_CUBE_FRONT.x, y: 0 }; NOTEINK.tilt = { a: 0, b: 0 }; noteInkApplyTilt(true); }
      else { lastTap = now; noteInkMsg('🎲 なぞると 回る／🎈 紐を 持つと 動かせる／ダブルタップで 正面', 2600); }
    } else noteInkRender();
    onString = false; moving = false;
  };
  cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
}
// まわす：紙ぜんたいを 立体で かたむける（キューブを なぞる）
function noteInkApplyTilt(smooth) {
  // ★2026-10-15 みなとさん「まわすは 書いた 文字だけ（えにっきと おなじ）」：紙（.paper-area）は うごかさず、書いた ものの 層（canvas）だけを かたむける
  const area = document.querySelector('.paper-area'); if (area) { area.style.transition = 'none'; area.style.transform = ''; }
  const { a, b } = NOTEINK.tilt;
  const tf = (a || b) ? 'perspective(1100px) rotateY(' + a.toFixed(1) + 'deg) rotateX(' + b.toFixed(1) + 'deg)' : '';
  for (const c of [NOTEINK.cv, NOTEINK.live]) if (c) { c.style.transition = smooth ? 'transform .35s ease' : 'none'; c.style.transform = tf; }
}
// 写真：えらんだ 画像を 小さくして（白ぬき オプション）お店の ファイルに 保存 → 紙に おく
async function noteInkPhoto(file) {
  if (!file || NOTEINK.busy) return;
  if (!SHOP_LOGGED_IN) { noteInkMsg('ログインすると 写真を おけます'); return; }
  const key = noteInkKey(); if (!key) return;
  NOTEINK.busy = true; noteInkMsg('写真を よみこんで います…', 20000);
  try {
    const bmp = await createImageBitmap(file);
    const k = Math.min(1, 1400 / Math.max(bmp.width, bmp.height)), w = Math.max(1, Math.round(bmp.width * k)), h = Math.max(1, Math.round(bmp.height * k));
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const ctx = c.getContext('2d'); ctx.drawImage(bmp, 0, 0, w, h);
    let mime = 'image/jpeg';
    if (NOTEINK.whiteout) {   // 白に ちかい いろを 透明に（ふちは やわらかく）
      const im = ctx.getImageData(0, 0, w, h), d = im.data;
      for (let i = 0; i < d.length; i += 4) { const m = Math.min(d[i], d[i + 1], d[i + 2]); if (m >= 250) d[i + 3] = 0; else if (m > 225) d[i + 3] = Math.round(d[i + 3] * (250 - m) / 25); }
      ctx.putImageData(im, 0, 0); mime = 'image/png';
    }
    const dataUrl = c.toDataURL(mime, 0.86);
    noteInkMsg('保存して います…', 20000);
    const res = await fetch('/apps/techou/note-photo', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ photo: dataUrl }) });
    const j = await res.json().catch(() => null);
    if (!res.ok || !j || !j.ok || !NOTE_IMG_RE.test(j.url || '')) { noteInkMsg((j && typeof j.error === 'string' && /[぀-ヿ一-鿿]/.test(j.error)) ? j.error : '写真を 保存できませんでした', 3500); return; }
    const it = { o: 'img', u: j.url, x: 5000, y: 3500, w: 3600, a: 0 };
    NOTEINK.mode = 'photo'; NOTEINK.sel = it; noteInkPush(key, [it]); noteInkMsg('おきました（ドラッグで 動かす・ホイール／2本指で 大きさ）', 3500);
  } catch (e) { noteInkMsg('写真を よみこめませんでした', 3000); }
  finally { NOTEINK.busy = false; }
}
function noteInkInit() {
  const area = document.querySelector('.paper-area'), stage = document.querySelector('.stage');
  if (!area || !stage || NOTEINK.cv) return;
  /* ★2026-10-15 みなとさん「拡大縮小を すると ぜんぶ 崩れます。位置は 固定」：ブラウザの 「ページぜんたいの 拡大」（ダブルタップ・ピンチ）を とめる。拡大は 紙だけ */
  try { document.documentElement.style.touchAction = 'manipulation'; document.body.style.touchAction = 'manipulation'; } catch (e) {}
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(t => document.addEventListener(t, e => e.preventDefault(), { passive: false }));
  document.addEventListener('dblclick', e => e.preventDefault());
  // ★2026-10-15 長押し・右クリックの「画像を保存」メニューを 出さない／画像を 引っぱって ドラッグも させない（トップページの 手帳・ノートだけ）
  document.addEventListener('contextmenu', e => { if (document.body.classList.contains('tk-home')) e.preventDefault(); });
  document.addEventListener('dragstart', e => { if (document.body.classList.contains('tk-home')) e.preventDefault(); });
  // ★2026-10-16 みなとさん「線を たくさん 書いて いると コピー・Google で 検索 などが 出る。消しゴムの 消しが 選択される」＝文字の 選択を とめる（入力欄は 除く）
  document.addEventListener('selectstart', e => { if (!document.body.classList.contains('tk-home')) return; const el = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement); if (el && el.closest && el.closest('input,textarea')) return; e.preventDefault(); });
  const mkCv = cls => { const c = document.createElement('canvas'); c.className = cls; c.style.visibility = 'hidden'; area.append(c); return c; };
  NOTEINK.cv = mkCv('note-ink'); NOTEINK.live = mkCv('note-ink note-ink-live'); NOTEINK.live.style.pointerEvents = 'none';
  try { NOTEINK.live.getContext('2d', { desynchronized: true }); } catch (e) {}   // ★書いて いる 途中の 層を 低い おくれで（Safari は 無視する）
  noteInkBind(NOTEINK.cv);
  const wrap = document.createElement('div'); wrap.className = 'note-bar-wrap';
  const sqEl = document.createElement('div'); sqEl.className = 'note-sq'; NOTEINK.sqEl = sqEl;
  const bar = document.createElement('div'); bar.id = 'note-colors'; bar.className = 'note-colors'; NOTEINK.bar = bar;
  const sw = (which, ico, label) => '<button type="button" class="sd-ball-sw" data-sw="' + which + '">' + noteIco(ico, 18) + '<span class="sd-ico-label">' + label + '</span></button>';
  bar.innerHTML = sw('edit', 'eraser', '消しゴム') + sw('pen', 'pen', 'ペン') + sw('stamp', 'stampTool', 'スタンプ') + sw('photo', 'photo', '写真') + sw('scroll', 'scroll', 'スクロール')   // ★2026-10-16 みなとさん「ペンの ままだと 下に スクロールできない」＝［スクロール］を おすと 指で 上下に スクロール（はじめは ペン）／★2026-10-15 みなとさん「トップページの まわす・アイコンは 廃止」（しくみは のこす＝ボタンだけ 出さない）
    + '<div class="sd-col-sep"></div><input type="color" id="note-col-now" class="sd-col-now" value="' + NOTEINK.color + '" aria-label="色">'
    + '<span class="note-pg"></span>';
  const msg = document.createElement('div'); msg.className = 'note-msg'; NOTEINK.msg = msg;
  const file = document.createElement('input'); file.type = 'file'; file.accept = 'image/*'; file.hidden = true; NOTEINK.fileEl = file;
  file.addEventListener('change', () => { const f = file.files && file.files[0]; file.value = ''; noteInkPhoto(f); });
  wrap.append(sqEl, bar, msg, file); stage.insertBefore(wrap, area.nextSibling);
  const setMode = (m) => { if (NOTEINK.mode === 'rotate' && m !== 'rotate') { NOTEINK.tilt = { a: 0, b: 0 }; NOTEINK.rot = { x: NOTE_CUBE_FRONT.x, y: 0 }; noteInkApplyTilt(true); noteInkShowBall(false); setTimeout(noteInkRender, 380); } NOTEINK.mode = m; };
  bar.addEventListener('click', async e => {
    const b = e.target.closest('.sd-ball-sw'); if (!b) return;
    const w = b.dataset.sw, was = NOTEINK.sq;
    if (w === 'scroll') { NOTEINK.scroll = !NOTEINK.scroll; NOTEINK.sq = null; noteInkApplyScroll(); noteInkBarSync(); noteInkMsg(NOTEINK.scroll ? '指で 上下に スクロールできます（もう一度 おすと 書けます）' : '書けます', 2200); return; }
    if (NOTEINK.scroll) { NOTEINK.scroll = false; noteInkApplyScroll(); }   // ほかの 道具を えらんだら 書く ほうへ もどす
    if (w === 'pen') { setMode('pen'); NOTEINK.sq = was === 'pen' ? null : 'pen'; }
    else if (w === 'edit') { if (NOTEINK.mode === 'erase' && was === 'edit') { setMode('pen'); NOTEINK.sq = null; } else { setMode('erase'); NOTEINK.sq = 'edit'; } }
    else if (w === 'cube') { if (NOTEINK.mode === 'rotate') { setMode('pen'); } else { setMode('rotate'); noteInkShowBall(true); noteInkMsg('🎲 ボールを なぞると 紙が 回ります（このあいだは 書けません）／もう一度 まわす で もどります', 3600); } NOTEINK.sq = null; }
    else if (w === 'tpl') { setMode('icon'); NOTEINK.sq = was === 'tpl' ? null : 'tpl'; NOTEINK.iconId = null; }   // えらぶ まで おけない
    else if (w === 'stamp') {
      setMode('stamp'); NOTEINK.sq = was === 'stamp' ? null : 'stamp';
      NOTEINK.stampUrl = null;   // えらぶ まで おけない
      if (NOTEINK.sq && !NOTEINK.stampList) { NOTEINK.stampList = []; noteInkBarSync(); try { NOTEINK.stampList = (typeof stampList === 'function' ? await stampList() : []) || []; } catch (er) { NOTEINK.stampList = []; } }
    }
    else if (w === 'photo') { setMode('photo'); NOTEINK.sq = was === 'photo' ? null : 'photo'; }
    noteInkBarSync(); noteInkRender();
  });
  bar.querySelector('#note-col-now').addEventListener('input', e => { if (NOTEINK.scroll) { NOTEINK.scroll = false; noteInkApplyScroll(); } NOTEINK.color = e.target.value.toLowerCase(); NOTEINK.colorTouched = true; if (NOTEINK.mode === 'erase' || NOTEINK.mode === 'rotate') setMode('pen'); noteInkBarSync(); });
  sqEl.addEventListener('click', e => {
    const b = e.target.closest('.sd-sq'); if (!b || b.disabled) return;
    if (b.classList.contains('sd-sq-make')) return;   // ★2026-10-17 スタンプを作成する＝リンクの まま（えにっきの トップへ）
    const k = b.dataset.kind, q = b.dataset.sq;
    if (q === 'pen') { NOTEINK.tool = k; NOTEINK.mode = 'pen'; NOTEINK.sq = null; }
    else if (q === 'edit') {
      if (k === 'undo') { noteInkUndo(); return; }
      if (k === 'clear') { const key = noteInkKey(); if (key && (NOTEINK.pages[key] || []).length && confirm(tr('このページの 書きこみを ぜんぶ 消しますか？'))) { const items = NOTEINK.pages[key].slice(); (NOTEINK.undo[key] = NOTEINK.undo[key] || []).push({ t: 'del', i: 0, items }); NOTEINK.pages[key] = []; NOTEINK.sel = null; noteInkDirty(key); noteInkRender(); } return; }
      if (k === 'erase') { NOTEINK.mode = NOTEINK.mode === 'erase' ? 'pen' : 'erase'; if (NOTEINK.mode !== 'erase') NOTEINK.sq = null; }
      if (k === 'cut') { NOTEINK.mode = NOTEINK.mode === 'cut' ? 'pen' : 'cut'; if (NOTEINK.mode === 'cut') noteInkMsg('写真・絵の 消したい ところを なぞると 透明に なります（線は そのまま）', 3000); else NOTEINK.sq = null; }
    }
    else if (q === 'tpl') { NOTEINK.iconId = k; NOTEINK.mode = 'icon'; NOTEINK.sq = null; noteInkMsg('紙を タップすると おけます', 1800); }
    else if (q === 'stamp') { NOTEINK.stampUrl = k; NOTEINK.mode = 'stamp'; noteInkMsg('紙を タップすると おけます（おいた 絵は ドラッグで 動かせます）', 2600); }
    else if (q === 'photo') {
      if (k === 'pick') { NOTEINK.fileEl.click(); return; }
      if (k === 'cut') { NOTEINK.whiteout = !NOTEINK.whiteout; noteInkMsg(NOTEINK.whiteout ? '白ぬき：つぎに えらぶ 写真の 白い ところが 透明に なります' : '白ぬき：なし', 2400); }
      else if (k === 'big') { if (NOTEINK.scaleSel) NOTEINK.scaleSel(1.15); }
      else if (k === 'small') { if (NOTEINK.scaleSel) NOTEINK.scaleSel(1 / 1.15); }
      else if (k === 'del') { const key = noteInkKey(), it = NOTEINK.sel, list = key && NOTEINK.pages[key]; if (it && list) { const i = list.indexOf(it); if (i >= 0) { list.splice(i, 1); (NOTEINK.undo[key] = NOTEINK.undo[key] || []).push({ t: 'del', i, items: [it] }); NOTEINK.sel = null; noteInkDirty(key); } } }
    }
    noteInkBarSync(); noteInkRender();
  });
  if (window.ResizeObserver) { let t = 0; new ResizeObserver(() => { clearTimeout(t); t = setTimeout(noteInkRender, 60); }).observe(stage); }
  addEventListener('resize', () => noteInkRender());
  if (!TK_HOME) {   // ★nv0.2.146 トップは［保存］を おした ときだけ（出る ときは 外側が「保存して いません」と きく）
    addEventListener('pagehide', () => { noteInkFlush({ keepalive: true }); });
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') noteInkFlush({ keepalive: true }); });
  }
  if (TK_HOME) { NOTEINK.scroll = true; noteInkApplyScroll(); }   // ★nv0.2.154 みなとさん「印刷ボタンを 押した（トップを ひらいた）時の デフォルトは スクロール」＝さいしょは 指で 上下に スクロール。書く ときは［ペン］を おす
  noteInkFitArea();
  noteInkBarSync(); noteInkRender(); noteInkLoad(); noteInkLoadSettings();
}
/* INK-END */
/* ★nv0.2.57 みなとさん「穴の 色を 白では なく 背景の 色と 同じに」：紙の うしろの 色を はかって 穴に ぬる */
function syncHoleColor() {
  try {
    let el = document.querySelector('.paper-area'), c = '';
    while (el) { const bg = getComputedStyle(el).backgroundColor; if (bg && bg !== 'transparent' && !/^rgba\(\s*0,\s*0,\s*0,\s*0\s*\)$/.test(bg)) { c = bg; break; } el = el.parentElement; }
    if (c) document.documentElement.style.setProperty('--hole-fill', c);
  } catch (e) { /* 色が はかれなくても 紙は 出る */ }
}
function makeSheet(cls) {
  const s = document.createElement('div');
  s.className = 'sheet ' + cls;
  s.dataset.kind = 'note';
  s.innerHTML = `<img alt="">${holesSvg()}<div class="cover"></div><div class="info"></div><div class="shade"></div>`;
  return s;
}
const base = makeSheet('base');
const leaf = makeSheet('leaf');
$('book').append(base, leaf);

// ☆・右上の3行・名前は、手帳の紙の絵の中にある（本店の柄と同じ場所）。かえたら少し待って絵を作りなおす
let decoTimer = 0;
function refreshDeco() {
  clearTimeout(decoTimer);
  decoTimer = setTimeout(() => {
    repaint().then(() => clearTinted([base.querySelector(':scope > img').src]));
  }, 250);
}
function paintSheet(sheet, url, note) {
  sheet.dataset.kind = 'note';
  const img = sheet.querySelector(':scope > img');
  img.src = url;
  img.alt = note ? note.name : '';
}
function copySheet(from, to) {
  to.dataset.kind = from.dataset.kind;
  to.replaceChildren(...[...from.childNodes].map(n => n.cloneNode(true)));
}
const mk = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
function paintCover(sheet) {
  sheet.dataset.kind = 'cover';
  const b = BINDERS.find(x => x.id === state.binder);
  const cv = sheet.querySelector('.cover');
  cv.className = 'cover ' + state.binder;
  cv.replaceChildren(mk('div', 'cv-t', TEXTS.coverTitle), mk('div', 'cv-s', b.name));
}

/* ★2026-10-15 内容の確認：はじめから 変えた ところの 一覧（ご注文内容の 前の ページ）。spot＝紙の どこを 丸で かこむか */
function changesList() {
  const out = [], add = (label, value, spot, before) => out.push({ label: tr(label), value, spot, before });
  const n = state.notes[state.idx];
  if (state.country !== 'jp') add('国', nkValue('country'), 'paper', TEXTS.nkCountries[0]);
  if (n && n.name !== '原稿用紙') add('柄', n.name, 'paper', '原稿用紙');
  try { if (n && n.fmt.custom) add('形を変える', typeof customCode === 'function' ? customCode() : tr('変えている'), 'paper'); } catch (e) {}
  if (state.color !== START_COLOR) add(TEXTS.inkNames[0] + 'の色', state.color, 'paper', START_COLOR);
  INK_KEYS.slice(1).forEach((k, i) => { if (state.inks[k]) add(TEXTS.inkNames[i + 1] + 'の色', state.inks[k], 'paper', state.color); });
  if (state.name !== DEFAULT_NAME) add('名入れ', state.name || tr('なし'), 'name', DEFAULT_NAME);
  if (state.stars !== 5) add('星', state.stars + TEXTS.starsUnit, 'stars', 5 + TEXTS.starsUnit);
  const dt = ['□たいせつ', '□みかえす', '□おしまい'];   // ★2026-11-03
  if ((state.todo || []).some((v, i) => v !== dt[i])) add('チェック', (state.todo || []).filter(Boolean).join('・') || tr('なし'), 'todo');
  if (state.paper !== 'book') add('紙', tr((PAPERS.find(p => p.id === state.paper) || {}).name || ''), 'none', tr(PAPERS[0].name));
  if (state.binder !== 'none') add('バインダー', tr((BINDERS.find(b => b.id === state.binder) || {}).name || ''), 'none', tr(BINDERS[0].name));
  if (state.option && state.option !== 'normal') add('大容量', tr((OPTIONS.find(o => o.id === state.option) || {}).name || ''), 'none', tr(OPTIONS[0].name));
  if (SHOP === 'shopify' && state.enikki.mode === 0) add('えにっき', TEXTS.nkEnikkiModes[1], 'none', TEXTS.nkEnikkiModes[0]);
  return out;
}
function changesOl(list, ol = mk('ol', 'chg-list')) {
  ol.replaceChildren();
  const isHex = v => /^#[0-9a-f]{6}$/i.test(v || '');
  const val = (v, cls) => { const e = mk('i', cls); if (isHex(v)) { const d = mk('u'); d.style.background = v; e.append(d, ' ' + v.toUpperCase()); } else e.textContent = v; return e; };
  list.forEach(c => { const li = mk('li'); li.append(mk('b', '', c.label)); const sp = mk('span'); if (c.before) sp.append(val(c.before, 'bf'), ' → '); sp.append(val(c.value, 'af')); li.append(sp); ol.append(li); });
  return ol;
}
function syncCheck() {
  const ol = $('checkList'); if (!ol) return;
  const list = changesList();
  changesOl(list, ol);
  if (!list.length) ol.append(mk('li', '', tr('はじめの ままです')));
}
function changesOverlay(list) {
  const sx = PSEL.w / 182, sy = PSEL.h / 257;
  const spots = {
    name: `<ellipse cx="${149 * sx}" cy="${249.5 * sy}" rx="${30 * sx}" ry="${5.5 * sy}"/>`,
    stars: `<rect x="${5 * sx}" y="${5 * sy}" width="${32 * sx}" height="${10 * sy}" rx="3"/>`,
    todo: `<rect x="${138 * sx}" y="${5 * sy}" width="${38 * sx}" height="${17 * sy}" rx="3"/>`,
    paper: `<rect x="2" y="2" width="${PSEL.w - 4}" height="${PSEL.h - 4}" rx="4" stroke-dasharray="3 2"/>`,
  };
  const tagPos = { name: [120, 240], stars: [6, 17], todo: [130, 23], paper: [100, 30] };
  const seen = new Set(); let o = '';
  list.forEach(c => { if (spots[c.spot] && !seen.has(c.spot)) { seen.add(c.spot); o += spots[c.spot]; } });
  const cnt = {};
  list.forEach((c, i) => { const p = tagPos[c.spot]; if (!p) return; const k = (cnt[c.spot] = (cnt[c.spot] || 0) + 1); const x = (p[0] + (k - 1) * 8) * sx, y = p[1] * sy;
    o += `<circle cx="${x + 3.5 * sx}" cy="${y + 3.2 * sy}" r="${3.4 * Math.min(sx, sy)}" fill="#e0472f" stroke="none"/><text x="${x + 3.5 * sx}" y="${y + 4.6 * sy}" font-size="${4 * Math.min(sx, sy)}" text-anchor="middle" fill="#fff" stroke="none" font-weight="800">${i + 1}</text>`; });
  return `<svg class="chg-ov" viewBox="0 0 ${PSEL.w} ${PSEL.h}" preserveAspectRatio="none" aria-hidden="true" fill="none" stroke="#e0472f" stroke-width="1.1" vector-effect="non-scaling-stroke">${o}</svg>`;
}
function paintInfo(sheet, page, noteUrl) {
  const box = sheet.querySelector('.info');
  const card = mk('div', 'card' + (page.steps ? ' howto' : '') + (page.changes ? ' chg' : ''));
  if (page.changes) {   // ★2026-10-15 変えた ところ（紙の 上は 丸で かこむ だけ・一覧は 下の 欄に）
    const list = changesList();
    const ov = document.createElement('div'); ov.className = 'chg-wrap'; ov.innerHTML = changesOverlay(list);
    box.replaceChildren(ov);
    sheet.dataset.kind = 'oneside'; sheet.querySelector(':scope > img').src = noteUrl;
    return;
  }
  if (page.steps) {
    // ご注文の方法：左の丸と同じ絵をならべて、ひとこと
    card.append(mk('h3', '', tr(page.title)));
    const ol = mk('ol', 'howto-list');
    if (page.start) ol.style.counterReset = 'hw ' + page.start;   // ★v0.2.150 2ページめは 7 から
    page.steps.forEach(st => {
      const li = mk('li');
      const icons = mk('span', 'howto-ic');
      st.pi.forEach(k => { const c = mk('i', 'ball'); c.innerHTML = picto(k); icons.append(c); });
      const tx = mk('span', 'howto-tx', tr(st.text));
      if (st.sub) tx.append(mk('small', '', tr(st.sub)));
      li.append(icons, tx);
      ol.append(li);
    });
    card.append(ol);
    box.replaceChildren(card);
    sheet.dataset.kind = 'info';
    return;
  }
  const n = INFO_PAGES.filter(pg => !pg.steps).indexOf(page) + 1;
  card.append(mk('div', 'no', `POINT ${n}`), mk('h3', '', tr(page.title)), mk('p', '', tr(page.text)));
  if (page.tags) {
    const ul = mk('ul');
    ul.append(...page.tags.map(t => mk('li', '', tr(t))));
    card.append(ul, mk('p', '', tr(page.tagsNote)));
  }
  if (page.price) card.append(mk('div', 'yen', page.price() + (PRICE_IS_KARI ? `（${TEXTS.priceKari}）` : '')));
  const parts = [];
  if (page.photo && PHOTO[page.photo]) {
    const img = mk('img', 'ph'); img.alt = page.title;
    const kari = mk('span', 'kari-ph', TEXTS.photoKari);
    img.onerror = () => {   // 写真が まだ置いてないとき：こわれた画像のかわりに 絵
      const ic = mk('i', 'big-pi'); ic.innerHTML = picto(page.photo === 'pen' ? 'name' : page.photo === 'paper' ? 'paper' : 'binder');
      img.replaceWith(ic); kari.remove();
    };
    img.src = PHOTO[page.photo];
    parts.push(img, kari);
  } else if (page.photo) {
    const ic = mk('i', 'big-pi'); ic.innerHTML = picto(page.photo === 'pen' ? 'name' : page.photo === 'paper' ? 'paper' : 'binder');
    parts.push(ic);
  } else if (page.icon) {
    const ic = mk('i', 'big-pi'); ic.innerHTML = picto(page.icon);
    parts.push(ic);
  }
  box.replaceChildren(...parts, card);
  if (page.kind === 'oneside') {
    // 片面印刷：今の柄の紙の上に説明をうかせる
    sheet.dataset.kind = 'oneside';
    sheet.querySelector(':scope > img').src = noteUrl;
  } else {
    sheet.dataset.kind = 'info';
  }
}

// ===== ページをめくる =====
//   紙を横にスワイプ（← → キー）＝ページ：［表紙（バインダーをえらんだとき）］→ 手帳の紙 → 説明のページ → ご注文内容
//   手帳の形をかえる＝上のタイル
//   ★手帳の紙は1冊ぶんぜんぶ（月間式＝24まい）。ページの名前は s0, s1, …（sheet＝何まいめ、0から）
let turning = Promise.resolve();
function visible() {
  /* ★nv0.2.16 オーダーメイドは **どの なかまでも いちばん左**（古い ノート v0.1.54 と 同じ） */
  const cm = state.notes.filter(n => n.fmt.custom);
  const rest = state.cat === 'all' ? state.notes.filter(n => !n.fmt.custom)
                                   : state.notes.filter(n => !n.fmt.custom && n.fmt.cat === state.cat);
  return [...cm, ...rest];
}
function pageList() {
  const list = [];
  if (state.binder !== 'none') list.push({ id: 'cover', label: tr('表紙') });
  // 年間の紙（2まい）は 手帳の紙の 前（v0.2.74）
  const yn = yNote();
  if (yn) for (let i = 0; i < sheetCount(yn); i++) list.push({ id: 'y' + i, ysheet: i, label: sheetLabel(yn, i) });
  const note = state.notes[state.idx];
  for (let i = 0; i < sheetCount(note); i++) list.push({ id: 's' + i, sheet: i, label: sheetLabel(note, i) });
  if (window.TK_LOC && /[?&]tkhome=1(&|$)/.test(window.TK_LOC.search || '')) return list.filter(p => p.sheet != null);   // ★nv0.2.57 トップは 紙（柄）だけ。表紙・説明・ご注文内容には 入らない
  // ★ご注文内容は、いちばん最後のページ（2026-09-17 ご要望）
  return list.concat(PRINT_ONLY ? INFO_PAGES.filter(p => !['paper', 'bb', 'leather'].includes(p.id)) : INFO_PAGES, PRINT_ONLY ? [] : [{ id: 'order', label: TEXTS.summaryTitle }]);   // ★nv0.2.163 印刷専用には ご注文を 出さない
}
const sheetPage = () => 's' + state.sheet;   // いま（さいごに）見ている手帳の紙のページ
const curPage = () => pageList().find(p => p.id === state.page) || pageList().find(p => p.id === sheetPage());

// 1まいの中身を用意して、紙にぬる関数を返す（写真は先に読みこむ）
async function painterFor(page) {
  const note = state.notes[state.idx];
  const preload = async src => { const im = new Image(); im.src = src; try { await im.decode(); } catch (e) {} };
  if (page.id === 'cover') return sh => paintCover(sh);
  if (page.id === 'order') return sh => paintOrder(sh);
  if (page.ysheet != null) {   // 年間の紙
    state.ySheet = page.ysheet;
    const yurl = await tintedUrl(yNote());
    await preload(yurl);
    return sh => paintSheet(sh, yurl, yNote());
  }
  if (page.sheet != null) setSheet(page.sheet);   // めくった先の紙を「いまの紙」にする
  /* ★nv0.2.20 めくっても **柄は かえない**（みなとさんの ご指示） */
  const note2 = state.notes[state.idx];
  const url = await tintedUrl(note2);
  if (page.sheet != null) { await preload(url); return sh => paintSheet(sh, url, note2); }
  if (page.photo && PHOTO[page.photo]) await preload(PHOTO[page.photo]);
  return sh => paintInfo(sh, page, url);
}
async function flip(paint, dir) {
  if (dir && zoom.on) setZoom(false);
  const first = !base.dataset.painted;
  base.dataset.painted = '1';
  if (TK_HOME && dir) noteInkHide();
  if (TK_HOME && typeof sampleHide === 'function') sampleHide();   // ★2026-10-19 見本は ページを めくったら 消える   // ★nv0.2.58 めくる あいだは 書きこみを かくす
  if (first || !dir || reduceMotion) {
    if (!first && dir && reduceMotion) await base.animate([{ opacity: .3 }, { opacity: 1 }], 220).finished;
    paint(base);
    if (TK_HOME) noteInkRender();
    return;
  }
  const opts = { duration: 560, easing: 'cubic-bezier(.45,.05,.35,1)' };
  leaf.style.display = 'block';
  if (dir > 0) {
    // 今の紙が左へめくれて、下から次が出てくる
    copySheet(base, leaf);
    paint(base);
    leaf.querySelector('.shade').animate([{ opacity: 0 }, { opacity: 1 }], opts);
    await leaf.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-180deg)' }], opts).finished;
  } else {
    // 左から前の紙がもどってきて、上にかぶさる
    paint(leaf);
    leaf.querySelector('.shade').animate([{ opacity: 1 }, { opacity: 0 }], opts);
    await leaf.animate([{ transform: 'rotateY(-180deg)' }, { transform: 'rotateY(0deg)' }], opts).finished;
    paint(base);
  }
  leaf.style.display = 'none';
  if (TK_HOME) noteInkRender();   // ★nv0.2.58
  if (TK_HOME) { try { if (window.parent && window.parent !== window && typeof window.parent.tkSampleCheck === 'function') window.parent.tkSampleCheck(); } catch (e) {} }   // ★2026-10-20 紙が かわったら「見本」ボタンを 出すか 見なおす
}
function queue(fn) {
  turning = turning.then(fn).catch(e => console.error(e));
  return turning;
}
// 手帳の形をかえる（手帳の紙のページで見せる）
function go(idx, dir) {
  return queue(async () => {
    const was = curPage().id;
    const keep = curDate();
    state.idx = idx;
    /* ★nv0.2.6 みなとさん「何も かわって いない」（2026-10-03）
       ------------------------------------------------------------
       ★わたしの 入れまちがいでした。見本（タイル）を 押すと state.idx は かわるのに、
         **紙の 番号（state.sheet）が ついてこなかった**。
         そのあと painterFor が「紙の 番号 → その 柄」を 見るので、
         **もとの 柄に もどされて いた**（だから 何も かわらない）。
       → ノートの ときは「その 柄が いまの なかまの 何まいめか」を 紙の 番号に する。
         こうすると 見本・矢じるし・下の バーの 3つが いつも そろいます。 */
    if (unitOf(state.notes[idx]) === 'note') {
      setSheet(0);   // ★nv0.2.20 ノートの 紙は いつも 1まいめ
    } else {
      setSheet(sheetNear(state.notes[idx], keep));   // 形をかえても、同じ日のあたりの紙
    }
    if (!(dir === 0 && /^y\d+$/.test(state.page))) state.page = sheetPage();   // ★ひらいた ときに QR が 年間の紙を さしていたら そのまま
    const paint = await painterFor(curPage());
    updateUi();
    const list = pageList();
    const d = was === state.page ? dir : Math.sign(list.findIndex(p => p.id === state.page) - list.findIndex(p => p.id === was)) || dir;
    await flip(paint, d);
    if (TK_HOME) { try { if (window.parent && window.parent !== window && typeof window.parent.tkSampleCheck === 'function') window.parent.tkSampleCheck(); } catch (e) {} }   // ★2026-10-20 柄を えらんだ ときも「見本」ボタンを 見なおす
  });
}
// ページを動かす
function turnPage(id) {
  // ★nv0.2.146 ページを めくる ときの 自動保存は やめた（トップの［保存］ボタンに うつした）
  return queue(async () => {
    const list = pageList();
    const from = list.findIndex(p => p.id === curPage().id);
    const to = list.findIndex(p => p.id === id);
    if (to < 0 || to === from) return;
    state.page = id;
    const paint = await painterFor(list[to]);
    updateUi();
    await flip(paint, to > from ? 1 : -1);
  });
}
function step(d) {
  const list = pageList();
  const i = list.findIndex(p => p.id === curPage().id) + d;
  if (i >= 0 && i < list.length) turnPage(list[i].id);
}
// 今のページをぬり直す（色やバインダーをかえたとき）
function repaint() {
  return queue(async () => { const paint = await painterFor(curPage()); paint(base); });
}
// 紙の下（1段・v0.2.67）：左の きりかえ［手帳｜注文］＋ その中身
//   ・手帳：［すべらせる目もり］［いまの紙の名前］
//   ・注文：ページの点（手帳の紙ぜんぶで1つ・説明・ご注文内容）
//   ★2段だと 紙が ノートより 低くなるので 1段に した（みなとさん）。「今日」ボタンは なくした（紙の 今日の しるしは そのまま）
//   ★目もりは、指をはなしたときにその紙へめくる（動かしているあいだは名前だけかわる）
//   ★ページの しゅるい（手帳の紙／説明・注文）が かわったら、きりかえも それに あわせる。押せば いつでも かえられる
//   ★v0.2.74：きりかえは 3つ［年間トップ｜手帳トップ｜注文方法］（みなとさん）。年間トップ＝年間の 1まいめ
let navMode = 'sheet', navKind = 'sheet';
const NAV_GO = { year: 'y0', sheet: 's0', info: 'howto' };
// いま 見ている ページの しゅるい：year（年間）／sheet（手帳の 紙）／info（説明・注文）
function pageKind() { const now = curPage(); return now.ysheet != null ? 'year' : now.sheet == null ? 'info' : 'sheet'; }
// きりかえの 3つ（年間が ない 形なら 2つ）
function navItems() { return [['year', TEXTS.navYear], ['sheet', TEXTS.navSheet], ['info', TEXTS.navInfo]].filter(([m]) => m !== 'year' || yNote()); }
// ★v0.2.73 みなとさん：押したら とぶ。年間トップ＝年間の 1まいめ／手帳トップ＝手帳の 1まいめ／注文方法＝「ご注文の方法」の ページ
function navJump(m) {
  navMode = m;
  // ★v0.2.79：年間トップなら 上の なかまも「年間」、手帳トップなら 手帳の形の なかまに（「すべて」が なくなったので）
  const cat = m === 'year' ? 'year' : m === 'sheet' ? state.notes[state.idx].fmt.cat : null;
  if (cat && cat !== state.cat) { state.cat = cat; buildCats(); buildTiles(); $('tiles').scrollLeft = 0; }
  syncPages();
  turnPage(NAV_GO[m]);
}
function syncPages() {
  const now = curPage();
  const kind = pageKind();
  if (kind !== navKind) { navKind = kind; navMode = kind; }
  const sw = mk('div', 'navsw');
  sw.setAttribute('role', 'group');
  for (const [m, label] of navItems()) {
    const b = mk('button', '', label);
    b.type = 'button';
    b.setAttribute('aria-pressed', String(navMode === m));
    b.onclick = () => navJump(m);
    sw.append(b);
  }
  // 目もり：年間なら 年間の紙（2まい）、手帳なら 手帳の紙
  const yr = navMode === 'year' && yNote();
  const note = yr ? yNote() : state.notes[state.idx];
  const cur = yr ? state.ySheet : state.sheet, pre = yr ? 'y' : 's';
  const n = sheetCount(note);
  const nav = mk('div', 'sheetnav' + (kind !== navMode ? ' away' : ''));
  const rg = mk('input');
  rg.type = 'range'; rg.min = 0; rg.max = n - 1; rg.step = 1; rg.value = cur;
  rg.setAttribute('aria-label', TEXTS.sheetRange);
  rg.hidden = n <= 1;   // 1まいだけ のときは、すべらせる目もりはいらない
  const lbl = mk('span', 'lbl');
  const showLbl = i => lbl.replaceChildren(mk('b', '', (yr ? TEXTS.navYearShort : '') + sheetLabel(note, i)), mk('small', '', TEXTS.sheetOf(i + 1, n)));
  showLbl(cur);
  rg.oninput = () => showLbl(+rg.value);
  rg.onchange = () => turnPage(pre + rg.value);
  nav.append(rg, lbl);
  // 点：表紙・年間の紙（まとめて1つ）・手帳の紙（まとめて1つ）・説明・ご注文内容
  const dots = mk('div', 'dots');
  dots.setAttribute('role', 'tablist');
  dots.setAttribute('aria-label', 'ページ');
  pageList().filter(p => (p.sheet == null || p.sheet === state.sheet) && (p.ysheet == null || p.ysheet === state.ySheet)).forEach(p => {
    const b = mk('button', 'pdot');
    b.type = 'button';
    b.setAttribute('role', 'tab');
    const label = p.sheet != null ? TEXTS.sheetLabel : p.ysheet != null ? TEXTS.navYear : p.label;
    b.setAttribute('aria-label', label);
    b.title = label;
    b.setAttribute('aria-current', String(p.sheet != null ? now.sheet != null : p.ysheet != null ? now.ysheet != null : p.id === now.id));
    b.onclick = () => turnPage(p.id);
    dots.append(b);
  });
  $('pages').replaceChildren(sw, navMode === 'info' ? dots : nav);
}

// 本店の柄と同じ、上のまん中の丸いマーク（本店の柄のパスをそのまま使う。単位は pt → mm にちぢめる）
/* ★v0.2.129 紙の 余白を 1か所に（サイズ対応の 準備）
   前は 形ごとに「左 16・右 174・上 30」と 書いてあった（19〜20か所）。
   ここに まとめた。B5 の 絵は 1文字も 変わらない（版の 前後で ハッシュを くらべた）。
   これから：紙の サイズ（TK_PAPER）で この 3つと 紙の 大きさ・穴を 切りかえる。 */
const PG = { X1: 16, X2: 174, TOP: 30 };
// ★v0.2.115 えにっきの 絵は マスの 80%（みなとさん）。1.0 に すると マスいっぱい
/* ★v0.2.122 みなとさん：えにっきの 絵は **正方形**に なりました。
   マスの はば いっぱい・下の線に ぴったり つけます。
   正方形なので 上に すきまが のこり、そこに 日付と 暦が 出ます。 */
const ENIKKI_FIT = 1;     // マスの はば の 何わり つかうか（1＝いっぱい）
const ENIKKI_GAP = 0;     // 下の 線との すきま（mm。0＝ぴったり）
const MARK_TOP = 22;   // マークの下から線を始める（mm）
function markSvg(C) {
  const pt = 25.4 / 72;
  const ring = 'M0 0C0-10.176-8.249-18.425-18.425-18.425-28.601-18.425-36.85-10.176-36.85 0-36.85 10.176-28.601 18.425-18.425 18.425-8.249 18.425 0 10.176 0 0Z';
  return `<g transform="scale(${pt.toFixed(6)})">`
    + `<path class="line" fill="${C}" transform="matrix(1,0,0,-1,236.4444,39.595399)" d="M0 0V-.408L-4.911-2.267V-1.859Z"/>`
    + `<path class="line" fill="${C}" transform="matrix(1,0,0,-1,236.4444,25.242798)" d="M0 0V-.402L-4.911 1.499V1.913Z"/>`
    + `<circle class="paper" fill="#ffffff" cx="257.953" cy="35.433" r="18.425"/>`
    + `<path transform="matrix(1,0,0,-1,276.378,35.433107)" stroke-width="1" fill="none" stroke="${C}" d="${ring}"/>`
    + `<path class="line" fill="${C}" transform="matrix(1,0,0,-1,263.5667,36.001405)" d="M0 0-4.546-4.546-10.229 1.137-5.683 5.683C-5.369 5.997-4.86 5.997-4.546 5.683L0 1.137C.314 .823 .314 .314 0 0M-3.41 10.229C-4.351 11.171-5.878 11.171-6.82 10.229L-13.071 3.978-14.337 5.245C-15.128 6.035-16.48 5.475-16.48 4.357V1.775C-16.48 1.002-16.174 .261-15.627-.285L-6.82-9.093C-5.878-10.034-4.351-10.034-3.41-9.093L4.546-1.137C5.488-.195 5.488 1.332 4.546 2.273Z"/>`
    + `<path class="line" fill="${C}" transform="matrix(1,0,0,-1,257.9528,53.708559)" d="M0 0C-10.077 0-18.275 8.198-18.275 18.275-18.275 28.353-10.077 36.551 0 36.551 10.077 36.551 18.275 28.353 18.275 18.275 18.275 8.198 10.077 0 0 0M0 36.851C-10.243 36.851-18.575 28.518-18.575 18.275-18.575 8.033-10.243-.3 0-.3 10.243-.3 18.575 8.033 18.575 18.275 18.575 28.518 10.243 36.851 0 36.851"/>`
    + `<path class="line" fill="${C}" transform="matrix(1,0,0,-1,257.9528,52.291017)" d="M0 0C-9.295 0-16.858 7.562-16.858 16.858-16.858 26.153-9.295 33.716 0 33.716 9.295 33.716 16.858 26.153 16.858 16.858 16.858 7.562 9.295 0 0 0M0 34.016C-9.461 34.016-17.158 26.319-17.158 16.858-17.158 7.397-9.461-.3 0-.3 9.461-.3 17.158 7.397 17.158 16.858 17.158 26.319 9.461 34.016 0 34.016"/>`
    + `</g>`;
}
// ===== 手帳の形（ここに1行足すと、形がふえる）=====
//   id   ＝注文コードに入る記号（M＝月間のなかま、W＝週間のなかま。計画書 3.5 のカタログと同じ）
//   unit ＝1まいに入る長さ（month／week／biweek）
//   mini ＝紙の下の小さなカレンダー（prev＝前の月、cur＝その月、next＝次の月）
//   draw ＝その形の線を描く関数。まだないときは null（タイルは「準備中」）
// ★どの形も、ページをまたがず B5 1ページにおさめる（この手帳の特徴）
// 形の一覧（ならび＝「すべて」のタブのならび。id は注文コードに入るので かえない）
const FORMATS = [
  { id: 'C1', name: 'オーダーメイド', cat: 'year', unit: 'year', mini: [], custom: true, draw: drawCustomYear },
  { id: 'Y1', name: '年間カレンダー', cat: 'year', unit: 'year', mini: [], draw: drawYearCalendar, tune: 'C1', tp: 0 },
  { id: 'M6', name: '年間スケジュール', cat: 'year', unit: 'year', mini: [], draw: drawYearly, tune: 'C1', tp: 1 },
  { id: 'Y2', name: '年間チャートよこ型', cat: 'year', unit: 'year', mini: [], draw: drawYearChart, tune: 'C1', tp: 2 },
  { id: 'Y3', name: '年間の目標', cat: 'year', unit: 'year', mini: [], draw: drawYearGoals, tune: 'C1', tp: 3 },
  // ★v0.2.95 お手本（NOLTY/Bindex・高橋）に ある 年間の 形
  { id: 'Y4', name: '年間計画表', cat: 'year', unit: 'year', mini: [], draw: drawYearPlan, tune: 'C1', tp: 4 },
  { id: 'Y5', name: '年間プロジェクト', cat: 'year', unit: 'year', mini: [], draw: drawYearProject, tune: 'C1', tp: 5 },
  { id: 'Y6', name: '月ごとの目標', cat: 'year', unit: 'year', mini: [], draw: drawYearReview },
  { id: 'Y7', name: '記念日リスト', cat: 'year', unit: 'year', mini: [], draw: drawAnniversary },
  { id: 'Y8', name: '2年カレンダー', cat: 'year', unit: 'year', mini: [], draw: (at, fmt, opt, cfg = {}) => drawYearsCalendar(at, fmt, opt, { ...cfg, years: 2 }) },
  { id: 'Y9', name: '3年カレンダー', cat: 'year', unit: 'year', mini: [], draw: (at, fmt, opt, cfg = {}) => drawYearsCalendar(at, fmt, opt, { ...cfg, years: 3 }) },
  { id: 'C2', name: 'オーダーメイド', cat: 'month', unit: 'month', mini: ['prev', 'next'], custom: true, draw: drawCustomMonth },
  { id: 'M1', name: '月間式', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthly, tune: 'C2', tp: 0 },
  { id: 'M2', name: '月間式インデックス', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthlyIndex, tune: 'C2', tp: 1 },
  { id: 'M3', name: '月間式レフト', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthlyLeft, tune: 'C2', tp: 2 },
  { id: 'M4', name: '月間式たて型', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthlyList, tune: 'C2', tp: 3 },
  { id: 'M5', name: 'ガントチャート', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawGantt, tune: 'C2', tp: 4 },
  // ★v0.2.87 お手本（NOLTY）に ある 形を 足した
  { id: 'M21', name: '月間タスク', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthTask, tune: 'C2', tp: 5 },
  { id: 'M22', name: 'アイダにメモ', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthBand, tune: 'C2', tp: 6 },
  { id: 'M23', name: 'デュアルマンスリー', cat: 'month', unit: 'month', mini: [], draw: drawDualMonth, tune: 'C2', tp: 7 },
  // ★v0.2.88 本の カタログ（能率手帳ウィック）から
  { id: 'M24', name: '土日ハーフ', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthWeekendHalf, tune: 'C2', tp: 8 },
  { id: 'M25', name: '月間＋時間めもり', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthTime, tune: 'C2', tp: 9 },
  // ★v0.2.91
  { id: 'M26', name: '前半・後半', cat: 'month', unit: 'month', mini: ['prev', 'next'], draw: drawMonthHalves, tune: 'C2', tp: 10 },
  { id: 'M27', name: '2か月の たてリスト', cat: 'month', unit: 'month', mini: [], draw: drawTwoMonthList, tune: 'C2', tp: 11 },
  { id: 'M28', name: 'ガント 2か月', cat: 'month', unit: 'month', mini: [], draw: drawGanttTwo, tune: 'C2', tp: 12 },
  { id: 'C3', name: 'オーダーメイド', cat: 'vert', unit: 'week', mini: ['cur'], custom: true, draw: drawCustomVert },
  { id: 'W11', name: '週間バーティカル式', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawWeeklyVerticalFull, tune: 'C3', tp: 0 },
  { id: 'W2', name: '24時間バーティカル', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawWeekly24, tune: 'C3', tp: 1 },
  { id: 'W3', name: '3分割バーティカル', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawWeeklySplit3, tune: 'C3', tp: 2 },
  // ★v0.2.101 できあいの バーティカル（形を変えずに そのまま つかえる）
  { id: 'W30', name: 'バーティカル 30分', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVert30, tune: 'C3', tp: 4 },
  { id: 'W31', name: '予定と 実際', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertPlanDo, tune: 'C3', tp: 5 },
  { id: 'W32', name: '上下メモつき', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertTopBot, tune: 'C3', tp: 6 },
  { id: 'W33', name: 'やること □つき', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertCheck, tune: 'C3', tp: 7 },
  { id: 'W34', name: '5ブロック', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertBlocks, tune: 'C3', tp: 8 },
  { id: 'W35', name: '方眼バーティカル', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertGrid, tune: 'C3', tp: 9 },
  { id: 'W36', name: '平日 重視', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertWeekday, tune: 'C3', tp: 10 },
  { id: 'W37', name: '朝がた（6時から）', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawVertMorning, tune: 'C3', tp: 11 },
  { id: 'W9', name: 'ライフログ', cat: 'vert', unit: 'week', mini: ['cur'], draw: drawLifeLog, tune: 'C3', tp: 3 },
  { id: 'C4', name: 'オーダーメイド', cat: 'left', unit: 'week', mini: ['cur'], custom: true, draw: drawCustomLeft },
  { id: 'W4', name: '週間レフト式', cat: 'left', unit: 'week', mini: ['cur'], draw: drawWeeklyLeft, tune: 'C4', tp: 0 },
  { id: 'W8', name: 'タスクログ', cat: 'left', unit: 'week', mini: ['cur'], draw: drawTaskLog, tune: 'C4', tp: 1 },
  { id: 'W10', name: 'ホリゾンタルタイム', cat: 'left', unit: 'week', mini: ['cur'], draw: drawHorizontalTime, tune: 'C4', tp: 2 },
  // ★v0.2.99 できあいの レフト式（お手本の 手帳に よく ある 形）
  { id: 'W12', name: 'レフト 平日重視', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftWeekday, tune: 'C4', tp: 3 },
  { id: 'W13', name: 'レフト＋時間の点', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftDots, tune: 'C4', tp: 4 },
  { id: 'W14', name: 'レフト 午前・午後', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftHalf, tune: 'C4', tp: 5 },
  { id: 'W15', name: 'レフト 3分割', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftThird, tune: 'C4', tp: 6 },
  { id: 'W16', name: '変則レフト（日曜 右下）', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftSunRight, tune: 'C4', tp: 7 },
  { id: 'W17', name: 'レフト＋右7段', cat: 'left', unit: 'week', mini: ['cur'], draw: drawLeftRows7, tune: 'C4', tp: 8 },
  { id: 'C5', name: 'オーダーメイド', cat: 'sep', unit: 'week', mini: ['cur'], custom: true, draw: drawCustomSep },
  { id: 'W5', name: '週間セパレート式', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawWeeklySeparate, tune: 'C5', tp: 0 },
  { id: 'W6', name: '週間ブロック式', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawWeeklyBlock, tune: 'C5', tp: 1 },
  // ★v0.2.103 できあいの セパレート
  { id: 'W40', name: 'セパレート＋十字', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSepCross, tune: 'C5', tp: 2 },
  { id: 'W41', name: 'セパレート＋時間めもり', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSepTime, tune: 'C5', tp: 3 },
  { id: 'W42', name: 'セパレート＋右2列', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSepCols, tune: 'C5', tp: 4 },
  { id: 'W43', name: 'セパレート 下メモ', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSepBottom, tune: 'C5', tp: 5 },
  { id: 'W44', name: '方眼セパレート', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSepGrid, tune: 'C5', tp: 6 },
  { id: 'W45', name: 'セパレート 3日＋4日', cat: 'sep', unit: 'week', mini: ['cur'], draw: drawSep34, tune: 'C5', tp: 7 },
  { id: 'C6', name: 'オーダーメイド', cat: 'vleft', unit: 'week', mini: ['cur'], custom: true, draw: drawCustomVleft },
  { id: 'W1', name: '週間バーチカルレフト', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawWeeklyVertical, tune: 'C6', tp: 0 },
  // ★v0.2.107 できあいの バーチカルレフト（お手本：ラコニック「仕事計画」DIARY Pre.9 A5 バーチカルレフト）
  { id: 'W50', name: 'バーチカルレフト トピック', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawVleftTopic, tune: 'C6', tp: 1 },
  { id: 'W51', name: 'バーチカルレフト 方眼メモ', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawVleftGrid, tune: 'C6', tp: 2 },
  { id: 'W52', name: 'バーチカルレフト 予定と実際', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawVleftPlanAct, tune: 'C6', tp: 3 },
  { id: 'W53', name: 'バーチカルレフト やること□', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawVleftCheck, tune: 'C6', tp: 4 },
  { id: 'W54', name: 'バーチカルレフト 朝がた', cat: 'vleft', unit: 'week', mini: ['cur'], draw: drawVleftMorning, tune: 'C6', tp: 5 },
  { id: 'W55', name: 'バーチカルレフト 3か月', cat: 'vleft', unit: 'week', mini: ['cur', 'next', 'next2'], draw: drawVleft3m, tune: 'C6', tp: 6 },
  { id: 'C7', name: 'オーダーメイド', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], custom: true, draw: drawCustomBiweek },
  { id: 'W7', name: '2週間式', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekly, tune: 'C7', tp: 0 },
  // ★v0.2.107 できあいの 2週間式（手帳カタログ本の 写真 10まい）
  { id: 'W60', name: '2週間 時間めもり', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekTime, tune: 'C7', tp: 1 },
  { id: 'W61', name: '2週間 上下に時間', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekTimeEnds, tune: 'C7', tp: 2 },
  { id: 'W62', name: '2週間 時間の点', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekDots, tune: 'C7', tp: 3 },
  { id: 'W63', name: '2週間 まん中に線', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekMid, tune: 'C7', tp: 4 },
  { id: 'W64', name: '2週間 今週の目標', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekGoal, tune: 'C7', tp: 5 },
  { id: 'W65', name: '2週間 シンプル', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekPlain, tune: 'C7', tp: 6 },
  { id: 'W66', name: '2週間 下にメモ', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekBottom, tune: 'C7', tp: 7 },
  { id: 'W67', name: '2週間 日づけが外', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekMirror, tune: 'C7', tp: 8 },
  { id: 'W68', name: '2週間 右にメモ', cat: 'bi', unit: 'biweek', mini: ['cur', 'next'], draw: drawBiweekMemo, tune: 'C7', tp: 9 },
];
// マス目の えらび（段の数・メモ・曜日の 帯…）が つかえない「もとの形」（たて型・ガントチャート・デュアルマンスリー）
const TEXTS_MONTH_UNIT = '月';
const TEXTS_YR_GOAL = '目標';        // Y6 の 見出し（アメリカでは L() で GOALS・v0.2.160）
const TEXTS_YR_REVIEW = 'ふりかえり';   // 月間プランの 表の 見出し（月）
const NO_GRID_BASE = [3, 4, 7, 9, 10, 11, 12];   // マス目の えらびが つかえない もとの形（たて型・ガント・デュアル・時間めもり）
const MEMO_TYPES = ['無地', '横罫', '方眼', 'ドット', '十字', '5本罫', 'チェック', 'マス目', '英語罫'];
const MEMO_SPACES = Array.from({ length: 27 }, (_, i) => 2 + i * .5);   // 2〜15mm（0.5mm ずつ）
const MEMO_WEIGHTS = ['ほそい', 'ふつう', 'ふとい'];
const MEMO_STYLES = ['実線', '点線', '破線'];
const MEMO_EMPHS = ['なし', '5本ごと', '10本ごと'];
const MEMO_DEF = { type: 2, sp: 6, wt: 0, st: 0, em: 0 };   // 方眼・5mm・ほそい・実線・強調なし（いままでと同じ見た目）
const memoSpec = (v, frame) => ({ type: v[0], sp: v[1], wt: v[2], st: v[3], em: v[4], frame: !!frame });
// ===== オーダーメイド（なかまごとに1つ。id は C1〜C7）=====
//   items の ならび と えらんだ番号が、楽天の「オーダー」の欄の記号になる（例 C1-0101）。★ならびは かえない（足すときは うしろに）
const CUSTOM = {
  //   items[0] が「もとの形」のときは presets も書く（もとの形を押すと、下のえらびが その形の中身になる）
  C1: { presets: [[0, 0, 0, 2, 6, 0, 0, 0], [0, 0, 0, 2, 6, 0, 0, 0], [0, 1, 0, 2, 6, 0, 0, 0], [0, 0, 0, 2, 6, 0, 0, 0], [0, 0, 0, 2, 6, 0, 0, 0], [0, 0, 0, 2, 6, 0, 0, 0]], items: [
    { label: 'もとの形', opts: ['年間カレンダー', '年間スケジュール（たて）', '年間チャートよこ型', '年間の目標', '年間計画表', '年間プロジェクト'], kind: 'pic', icons: [{ grid: [3, 4] }, { cols: 12 }, { rows: 12 }, { goal: 1, grid: [3, 4] }, { rows: 12, cols: 5 }, { bars: 1, rows: 12 }] },
    { label: '月のわけ方', opts: ['12か月で1まい', '6か月で1まい'], kind: 'pic', icons: [{ rows: 12 }, { rows: 6 }] },
    { label: '日の欄の線', opts: ['なし', '点線'], kind: 'pic', icons: [{}, { cell: 1 }], off: v => v[0] === 0 || v[0] === 3 },   // カレンダー・目標では つかわない
    { label: '下のメモ', opts: ['なし', 'あり'], kind: 'pic', icons: [{}, { band: 'b' }] },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
  ] },
  C2: { presets: [[1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 1, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 1, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 1, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0], [1, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0]], items: [
    { label: 'もとの形', opts: ['月間式', '月間式インデックス', '月間式レフト', '月間式たて型', 'ガントチャート', '月間タスク', 'アイダにメモ', 'デュアルマンスリー', '土日ハーフ', '月間＋時間めもり', '前半・後半', '2か月の たてリスト', 'ガント 2か月'], kind: 'pic', icons: [{ grid: [7, 5] }, { idx: 1, grid: [7, 5] }, { band: 'r', f: 1 / 3, grid: [7, 5] }, { rows: 11 }, { bars: 1, rows: 8 }, { grid: [7, 5], cell: 1 }, { grid: [7, 6] }, { grid: [7, 6], gap: 1 }, { grid: [6, 6] }, { rows: 11, cols: 4 }, { rows: 11, cols: 2 }, { rows: 11, cols: 2, gap: 1 }, { bars: 1, rows: 8, gap: 1 }] },
    { label: '段の数', opts: ['5段', '6段'], kind: 'pic', icons: [{ grid: [7, 5] }, { grid: [7, 6] }], def: 1, off: v => NO_GRID_BASE.includes(v[0]) },
    { label: 'よこのメモ', opts: ['なし', '右 1/3', '右 1/2', '左 1/3', '左 1/2'], kind: 'pic', icons: [{ grid: [7, 5] }, { band: 'r', f: 1 / 3, grid: [5, 5] }, { band: 'r', f: 1 / 2, grid: [4, 5] }, { band: 'l', f: 1 / 3, grid: [5, 5] }, { band: 'l', f: 1 / 2, grid: [4, 5] }], off: v => v[0] === 4 },
    { label: 'たてのメモ', opts: ['なし', '下', '上'], kind: 'pic', icons: [{ grid: [7, 5] }, { band: 'b', grid: [7, 4] }, { band: 't', grid: [7, 4] }], off: v => v[0] === 3 },
    { label: 'インデックス', opts: ['なし', 'あり'], kind: 'pic', icons: [{ grid: [7, 5] }, { idx: 1, grid: [7, 5] }], off: v => NO_GRID_BASE.includes(v[0]) },
    // ★v0.2.107 みなとさん：「マスの中の線」と「線の 種類」を 1つに まとめた（点線の 本数 か、メモと 同じ 線）
    { label: 'マスの中の線', opts: ['なし', '1本', '2本', '3本', '4本', '5本', ...MEMO_TYPES.slice(1)], kind: 'pic', icons: [{}, { cell: 1 }, { cell: 2 }, { cell: 3 }, { cell: 4 }, { cell: 5 }, ...MEMO_TYPES.slice(1).map((_, k) => ({ memo: k + 1 }))], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2, off: v => v[0] === 3 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.86 細かい えらび（マス目の 形。たて型・ガントチャートには ない）
    { label: '表の 上', opts: ['ふつう', 'すこし上', '上', 'すこし下'], kind: 'pic', icons: [{ grid: [7, 6] }, { grid: [7, 6] }, { grid: [7, 6] }, { grid: [7, 6] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '表の 下', opts: ['ふつう', 'すこし短く', '短く'], kind: 'pic', icons: [{ grid: [7, 6] }, { grid: [7, 5] }, { grid: [7, 4] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '表の はば', opts: ['ふつう', 'ひろい', 'せまい'], kind: 'pic', icons: [{ grid: [7, 6] }, { grid: [7, 6] }, { grid: [7, 6] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '曜日の 帯', opts: ['ふつう 6mm', 'ひくい 4mm', '高い 8mm', 'なし'], kind: 'pic', icons: [{ grid: [7, 6] }, { grid: [7, 6] }, { grid: [7, 6] }, { grid: [7, 6] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '曜日の 名前', opts: ['英語 MON', '日本語 月', 'なし'], off: v => [3, 4].includes(v[0]) || v[14] === 3 },   // 帯が「なし」のときは えらべない（デュアルでも えらべる）
    { label: '日付の 丸', opts: ['ふつう', '小さい', '大きい'], kind: 'pic', icons: [{}, {}, {}], off: v => [3, 4].includes(v[0]) },   // デュアルでも えらべる
    // ★v0.2.89 本の 手帳に よく ある 部品
    { label: '週の 番号', opts: ['なし', 'つける'], kind: 'pic', icons: [{ grid: [7, 6] }, { band: 'l', f: .12, grid: [6, 6] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '左の 列', opts: ['なし', 'メモ', 'やること □', '1〜31'], kind: 'pic', icons: [{ grid: [7, 6] }, { band: 'l', f: .22, grid: [6, 6] }, { band: 'l', f: .22, grid: [6, 6] }, { band: 'l', f: .22, rows: 11 }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '右の 列（NOTES）', opts: ['なし', 'つける'], kind: 'pic', icons: [{ grid: [7, 6] }, { band: 'r', f: .22, grid: [6, 6] }], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '日付の となりの 数字', opts: ['なし', 'その年の 何日め'], off: v => NO_GRID_BASE.includes(v[0]) },
    // ★v0.2.90
    { label: '列の はば', opts: ['均等', '週末を 大きく', '平日を 大きく'], kind: 'pic', icons: [{ grid: [7, 6] }, { grid: [5, 6] }, { grid: [7, 6] }], off: v => NO_GRID_BASE.includes(v[0]) || v[0] === 8 },
    { label: '日付', opts: ['入れる', '入れない（フリー）'], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: 'マスの 上の メモ線', opts: ['なし', 'つける'], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: 'マスの すみの □', opts: ['なし', '2つ'], off: v => NO_GRID_BASE.includes(v[0]) },
    { label: '土日の マスの 色', opts: ['なし', 'うすく ぬる'], off: v => NO_GRID_BASE.includes(v[0]) || v[0] === 8 },
    // ★v0.2.92
    { label: '下の 月間プランの 表', opts: ['なし', 'つける'], off: v => [3, 4, 7, 9, 10, 11].includes(v[0]) },
    { label: '潮の らん', opts: ['なし', 'つける'], off: v => ![10, 11].includes(v[0]) },   // たてリストだけ
    // ★v0.2.93 マスの中も メモと 同じ 線に できる／カレンダーの 場所
    { label: 'マスの中の 線の 間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 4, off: v => NO_GRID_BASE.includes(v[0]) || v[0] === 8 || v[4] <= 5 },
    { label: 'カレンダーの 場所', opts: ['右下', '左下', '右上', '下のまんなか'], kind: 'pic', icons: [{ band: 'b' }, { band: 'b' }, { band: 't' }, { band: 'b' }] },
    { label: 'メモの わく', opts: ['なし', 'つける'], off: v => v[2] === 0 && v[3] === 0 && v[17] === 0 && !v[18] },   // ★v0.2.103 はじめは なし
    // ★v0.2.107 マスの中の 時計（ねた時間などを ぬる。お手本：ルーズリーフの アレンジ本「マンスリー×体調管理」）
    // ★v0.2.109 みなとさん：時計は「表示」の パネルに うつした（えらびは ここに のこす＝注文コードも そのまま）
    { label: 'マスの中の 時計', opts: ['なし', 'つける'], hide: true, off: v => NO_GRID_BASE.includes(v[0]) },
  ] },
  C3: { presets: [[0, 7, 6, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 6, 0, 0, 0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 7, 6, 0, 2, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 7, 6, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 8, 4, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], [0, 8, 4, 0, 1, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 8, 3, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0], [0, 8, 3, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0], [0, 7, 6, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0], [0, 8, 4, 0, 0, 1, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0], [0, 8, 4, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], [0, 6, 2, 0, 0, 0, 1, 0, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0]], items: [
    { label: 'もとの形', opts: ['週間バーティカル式', '24時間バーティカル', '3分割バーティカル', 'ライフログ', 'バーティカル 30分', '予定と 実際', '上下メモつき', 'やること □つき', '5ブロック', '方眼バーティカル', '平日 重視', '朝がた'], kind: 'pic', icons: [{ cols: 7, rows: 8 }, { cols: 7, rows: 12 }, { cols: 7, rows: 3 }, { cols: 7, rows: 8, night: 1 }, { cols: 7, rows: 10 }, { cols: 7, rows: 8 }, { cols: 7, rows: 8 }, { cols: 7, rows: 8 }, { cols: 7, rows: 5 }, { cols: 7, rows: 8 }, { cols: 5, rows: 8 }, { cols: 7, rows: 9 }] },
    { label: '目もり', opts: ['時刻', '校時'], kind: 'pic', icons: [{ cols: 7, rows: 10 }, { cols: 7, rows: 6 }], off: v => v[0] === 3 },
    { label: 'はじめの時間', opts: ['0時', '1時', '2時', '3時', '4時', '5時', '6時', '7時', '8時', '9時'], def: 7, off: v => v[0] === 3 || v[1] === 1 },
    { label: 'おわりの時間', opts: ['18時', '19時', '20時', '21時', '22時', '23時', '24時'], def: 6, off: v => v[0] === 3 || v[1] === 1 },
    { label: '日数', opts: ['7日', '月〜金'], kind: 'pic', icons: [{ cols: 7 }, { cols: 5 }] },
    { label: '1日の分割', opts: ['1', '2', '3', '4'], kind: 'pic', icons: [{ cols: 1 }, { cols: 2 }, { cols: 3 }, { cols: 4 }], off: v => v[0] === 3 },
    { label: '30分の点線', opts: ['あり', 'なし'], kind: 'pic', icons: [{ rows: 4, halfDash: 1 }, { rows: 4 }], off: v => v[0] === 3 || v[1] === 1 },
    { label: '夜をうすく', opts: ['あり', 'なし'], kind: 'pic', icons: [{ cols: 7, night: 1 }, { cols: 7 }], def: 1, off: v => v[0] === 3 || v[1] === 1 },
    { label: '下のメモ', opts: ['なし', 'あり', '子どもの記録'], kind: 'pic', icons: [{ cols: 7 }, { band: 'b', cols: 7 }, { band: 'b', f: .35, bandCols: 4, cols: 7 }], off: v => v[0] === 3 },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.104 できあいの バーティカルの 中身（形を変える で さわれる）
    { label: 'お昼の 帯', opts: ['なし', 'つける'], off: v => v[0] === 3 || v[18] === 1 },
    { label: '12時・18時の 線', opts: ['ふつう', '太く'], off: v => v[0] === 3 || v[18] === 1 },
    { label: '上の メモ欄', opts: ['なし', 'つける'], off: v => v[0] === 3 },
    { label: '下の メモ欄', opts: ['なし', 'つける'], off: v => v[0] === 3 },
    { label: 'チェックの □', opts: ['なし', '2つ', '4つ'], off: v => v[0] === 3 },
    { label: '時間の 分け方', opts: ['1時間ごと', '5ブロック'], off: v => v[0] === 3 },
    { label: '方眼を しく', opts: ['なし', '4mm'], off: v => v[0] === 3 },
    { label: '土日の 大きさ', opts: ['平日と 同じ', '小さく'], off: v => v[0] === 3 },
  ] },
  C4: { presets: [[1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 1, 0, 3, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [3, 2, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1], [1, 0, 0, 3, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], [1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], [1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0], [1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0], [1, 0, 0, 3, 2, 6, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0]], items: [
    { label: 'もとの形', opts: ['週間レフト式', 'タスクログ', 'ホリゾンタルタイム', 'レフト 平日重視', 'レフト＋時間の点', 'レフト 午前・午後', 'レフト 3分割', '変則レフト（日曜 右下）', 'レフト＋右7段'], kind: 'pic', icons: [{ rows: 7, v: .5 }, { rows: 7, v: .6, band: 'r', f: .4, bandCols: 2 }, { rows: 7, v: .5, band: 'r', f: .5, bandCols: 5 }, { rows: 7, v: .6, bandCols: 5 }, { rows: 7, v: .6 }, { rows: 7, v: .6, lines: 1 }, { rows: 7, v: .6, cols: 3 }, { rows: 7, v: .6, band: 'r', f: .4 }, { rows: 7, v: .6, band: 'r', f: .4, rows2: 7 }] },
    { label: '左右のわりあい', opts: ['4:6', '5:5', '6:4', '右なし（7日いっぱい）'], kind: 'pic', icons: [{ rows: 7, v: .4 }, { rows: 7, v: .5 }, { rows: 7, v: .6 }, { rows: 7 }], def: 2 },
    { label: 'もうひとつの欄', opts: ['メモ', 'TO DO', '横の時間'], kind: 'pic', icons: [{ band: 'r', f: .5, rows: 7 }, { band: 'r', f: .5, bandCols: 2, rows: 7 }, { band: 'r', f: .5, bandCols: 5, rows: 7 }] },
    { label: 'その欄の場所', opts: ['右', '左'], kind: 'pic', icons: [{ band: 'r', f: .5, rows: 7 }, { band: 'l', f: .5, rows: 7 }], off: v => v[1] === 3 },
    { label: '行の線', opts: ['0本', '1本', '2本', '3本', '4本'], kind: 'pic', icons: [{}, { lines: 1 }, { lines: 2 }, { lines: 3 }, { lines: 4 }], def: 3 },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.97 レフト式の 中の しかけ
    { label: '時間の 目やすの 点', opts: ['なし', '9・12・3・6', '1時間ごと'], off: v => v[2] === 2 },
    { label: '行の 分け方', opts: ['なし', '上下2段', '左右3分割', '逆N字（3本）'], kind: 'pic', icons: [{ rows: 7 }, { rows: 7, lines: 1 }, { rows: 7, cols: 3 }, { rows: 7, lines: 3 }], off: v => v[2] === 2 },
    { label: 'もうひとつの欄を 7段に', opts: ['なし', '7段に 分ける'], off: v => v[1] === 3 },
    { label: '右はしに 当月の 日づけ', opts: ['なし', 'つける'], off: v => v[1] === 3 },
    // ★v0.2.98
    { label: '日曜の 場所', opts: ['左に ならべる', '右がわの 下（変則レフト）'], off: v => v[1] === 3 },
    { label: '土日の 大きさ', opts: ['平日と 同じ', '小さく（平日 重視）'] },
    { label: '曜日の 書き方', opts: ['英語だけ', '英語＋漢字'] },
    { label: '土日・祝日の 色', opts: ['なし', 'うすく ぬる'] },
  ] },
  C5: { presets: [[0, 0, 4, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 4, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0], [0, 0, 3, 2, 6, 0, 0, 0, 0, 1, 0, 0, 0], [0, 0, 4, 2, 6, 0, 0, 0, 0, 0, 1, 0, 0], [0, 1, 3, 2, 6, 0, 0, 0, 0, 0, 0, 1, 0], [0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 1], [1, 0, 4, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0]], items: [
    { label: 'もとの形', opts: ['週間セパレート式', '週間ブロック式', 'セパレート＋十字', 'セパレート＋時間めもり', 'セパレート＋右2列', 'セパレート 下メモ', '方眼セパレート', 'セパレート 3日＋4日'], kind: 'pic', icons: [{ h: .57, rows: 4 }, { grid: [2, 4] }, { h: .57, rows: 7, cols: 2 }, { h: .57, rows: 7 }, { h: .57, rows: 7, band: 'r', f: .18 }, { h: .43, rows: 6, band: 'b', f: .3 }, { h: .57, rows: 7 }, { h: .43, rows: 7 }] },
    { label: 'わけ方', opts: ['4日＋3日', '3日＋4日'], kind: 'pic', icons: [{ h: .57, rows: 7 }, { h: .43, rows: 7 }], off: v => v[0] === 1 },
    { label: 'メモ欄', opts: ['おわり（下）', 'なし', 'はじめ（上）'], kind: 'pic', icons: [{ band: 'b', f: .25, rows: 6 }, { rows: 8 }, { band: 't', f: .25, rows: 6 }] },
    { label: '行の線', opts: ['0本', '1本', '2本', '3本', '4本', '5本'], kind: 'pic', icons: [{}, { lines: 1 }, { lines: 2 }, { lines: 3 }, { lines: 4 }, { lines: 5 }], def: 4 },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.104 できあいの セパレートの 中身
    { label: '日付の となりの 十字', opts: ['なし', 'つける'], off: v => v[0] === 1 },
    { label: '横の 時間めもり', opts: ['なし', '8〜22時'], off: v => v[0] === 1 },
    { label: '右はしの たてメモ', opts: ['なし', '2列'], off: v => v[0] === 1 },
    { label: '下の メモ', opts: ['なし', 'つける'], off: v => v[0] === 1 },
    { label: '方眼を しく', opts: ['なし', '4mm'], off: v => v[0] === 1 },
  ] },
  C6: { presets: [
    [7, 6, 1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [7, 6, 1, 0, 0, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [7, 6, 2, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [7, 6, 1, 0, 1, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [7, 6, 1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 1, 0, 0, 0],
    [5, 3, 1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 1, 0, 0],
    [7, 6, 1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 2],
  ], items: [
    { label: 'もとの形', opts: ['週間バーチカルレフト', 'トピックつき', '方眼メモ 大', '予定と実際', 'やること□', '朝がた', '3か月カレンダー'], kind: 'pic', icons: [{ band: 'r', f: 1 / 3, cols: 5 }, { band: 'r', f: 1 / 3, cols: 5, h: .12 }, { band: 'r', f: .5, grid: [4, 6] }, { band: 'r', f: 1 / 3, cols: 10 }, { band: 'r', f: 1 / 3, cols: 5, dash: 1 }, { band: 'r', f: 1 / 3, cols: 5, h: .45 }, { band: 'r', f: 1 / 3, cols: 5, rows: 3 }] },
    { label: 'はじめの時間', opts: ['0時', '1時', '2時', '3時', '4時', '5時', '6時', '7時', '8時', '9時'], def: 7 },
    { label: 'おわりの時間', opts: ['18時', '19時', '20時', '21時', '22時', '23時', '24時'], def: 6 },
    { label: 'メモの場所', opts: ['右 1/4', '右 1/3', '右 1/2', '左 1/4', '左 1/3', '左 1/2'], kind: 'pic', icons: [{ band: 'r', f: .25, cols: 7 }, { band: 'r', f: 1 / 3, cols: 6 }, { band: 'r', f: .5, cols: 5 }, { band: 'l', f: .25, cols: 7 }, { band: 'l', f: 1 / 3, cols: 6 }, { band: 'l', f: .5, cols: 5 }], def: 1 },
    { label: 'インデックス', opts: ['あり', 'なし'], kind: 'pic', icons: [{ idx: 1, cols: 7 }, { cols: 7 }] },
    { label: '1日の分割', opts: ['1', '2', '3', '4'], kind: 'pic', icons: [{ cols: 1 }, { cols: 2 }, { cols: 3 }, { cols: 4 }] },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.107 できあいの バーチカルレフトの 中身（お手本：ラコニック 仕事計画 Pre.9）
    { label: 'その日の トピック', opts: ['なし', '上に 入れる'] },
    { label: 'やったことの らん', opts: ['なし', '下に 入れる'] },
    { label: 'やることの □', opts: ['なし', '5つ'] },
    { label: 'お昼の 帯', opts: ['なし', 'つける'] },
    { label: '方眼を しく', opts: ['なし', '4mm'] },
    { label: 'カレンダーの 数', opts: ['当月だけ', '当月＋翌月', '3か月'] },
  ] },
  C7: { presets: [
    [1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 2, 6, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    [1, 0, 0, 2, 6, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0],
    [1, 0, 0, 2, 6, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0],
    [2, 0, 0, 2, 6, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [3, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0],
    [1, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 0, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
    [1, 1, 0, 2, 6, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
  ], items: [
    { label: 'もとの形', opts: ['2週間式', '時間めもり', '上下に時間', '時間の点', 'まん中に線', '今週の目標', 'シンプル', '下にメモ', '日づけが外', '右にメモ'], kind: 'pic', icons: [{ rows: 7, gap: 1 }, { rows: 7, gap: 1, lines: 1 }, { rows: 7, gap: 1, halfDash: 1 }, { rows: 7, gap: 1, dash: 1 }, { rows: 7, gap: 1, v: .55 }, { rows: 6, gap: 1, band: 't', f: .12 }, { rows: 7, gap: 1 }, { rows: 6, gap: 1, band: 'b', f: .2 }, { rows: 7, gap: 1 }, { rows: 7, gap: 1, band: 'r', f: .25 }] },
    { label: '行の線', opts: ['0本', '1本', '2本', '3本'], kind: 'pic', icons: [{}, { lines: 1 }, { lines: 2 }, { lines: 3 }], def: 1 },
    { label: 'メモの列', opts: ['なし', '右', '左'], kind: 'pic', icons: [{ rows: 7, gap: 1 }, { band: 'r', f: .25, rows: 7, gap: 1 }, { band: 'l', f: .25, rows: 7, gap: 1 }] },
    { label: '上下のあいだ', opts: ['あり', 'なし'], kind: 'pic', icons: [{ gap: 1, rows: 8 }, { h: .5, rows: 8 }] },
    { label: 'メモの線', opts: MEMO_TYPES, kind: 'icon', def: 2 },
    { label: 'メモの間隔', opts: MEMO_SPACES.map(v => v + 'mm'), kind: 'step', def: 6 },
    { label: 'メモの線の太さ', opts: MEMO_WEIGHTS },
    { label: 'メモの線の引き方', opts: MEMO_STYLES },
    { label: 'メモの強調', opts: MEMO_EMPHS },
    // ★v0.2.107 できあいの 2週間式の 中身（手帳カタログ本の 写真から）
    { label: '横の 時間', opts: ['なし', 'ぜんぶの行（8〜20時）', '上と下の行（9〜18時）'] },
    { label: '時間の 目やすの 点', opts: ['なし', 'つける'] },
    { label: 'まん中の たて線', opts: ['なし', 'つける'] },
    { label: '今週の目標の らん', opts: ['なし', 'つける'] },
    { label: '下の メモ', opts: ['なし', 'つける'] },
    { label: '曜日の 書き方', opts: ['英語だけ', '英語＋漢字'] },
    { label: '暦（六曜など）', opts: ['入れる', '日付と曜日だけ'] },
    { label: '2週めの 日づけ', opts: ['左に そろえる', '右はしに（外がわ）'], off: v => v[3] === 1 },
  ] },
};
// 「この形を 変える」＝ 基本の形（M1〜M5）を オーダーメイドの えらびで 描く（v0.2.85）
//   ・state.tune[形のID]＝えらびの 数の ならび。ない＝基本の形の まま
//   ・中身は その なかまの オーダーメイド（CUSTOM[fmt.tune]）と 同じ。はじめの 値は その形の「もとの形」（presets[fmt.tp]）
//   ・だから 変えた ばかりの 絵は、基本の形と まったく 同じ（テストで たしかめる）
state.tune = {};
// オーダーメイドの 描き方（基本の形を 変えるときに つかう）
const CUSTOM_DRAW = { C1: drawCustomYear, C2: drawCustomMonth, C3: drawCustomVert, C4: drawCustomLeft, C5: drawCustomSep, C6: drawCustomVleft, C7: drawCustomBiweek };
const tuneStart = fmt => {
  const spec = CUSTOM[fmt.tune];
  // 「もとの形」が ある なかまは その ひな形、ない なかま（C6・C7）は はじめの えらび
  return spec.presets ? [fmt.tp, ...spec.presets[fmt.tp]] : spec.items.map(it => it.def || 0);
};
const tuneOf = note => (note && note.fmt.tune && state.tune[note.id]) || null;
const tuneCode = note => cmCode(note.fmt.tune, state.tune[note.id]);
// パネルで さわる 相手（オーダーメイドの形 or 変えている 基本の形）
// ----- マスの中の 時計（v0.2.109）-----
//   「表示」の パネルから つけ外しする。中身は 形を変える（C2）の いちばん うしろの えらび
const clockIdx = () => CUSTOM.C2.items.length - 1;
const clockBase = note => (state.tune[note.id] ? state.tune[note.id][0] : note.fmt.tp);
const canClock = (note = state.notes[state.idx]) => !!(CUSTOM_ON && note && note.fmt.tune === 'C2' && !NO_GRID_BASE.includes(clockBase(note)));
const clockOn = (note = state.notes[state.idx]) => !!(note && state.tune[note.id] && state.tune[note.id][clockIdx()]);
function setClock(note, on) {
  const v = (state.tune[note.id] || tuneStart(note.fmt)).slice();
  v[clockIdx()] = on ? 1 : 0;
  // もとの形と まったく 同じに なったら 「変えていない」に もどす（注文コードも もとどおり）
  if (String(v) === String(tuneStart(note.fmt))) delete state.tune[note.id];
  else state.tune[note.id] = v;
}
function cmTarget(note = state.notes[state.idx]) {
  if (!note) return null;
  /* ★nv0.2.19 ノートの オーダーメイドは **手帳の 表（CUSTOM）を つかいません**。
     その場で 線を 描く 作り（CM・customCode）なので、ここは ノート用の 答えを かえします。
     手帳の まま だと CUSTOM[note.id] が 無くて エラーに なります。 */
  if (note.fmt.custom) return { note, id: note.id, spec: null, v: state.custom, code: customCode() };
  const v = tuneOf(note);
  return v ? { note, id: note.id, spec: CUSTOM[note.fmt.tune], v, code: tuneCode(note) } : null;
}
state.custom = Object.fromEntries(Object.entries(CUSTOM).map(([id, c]) => [id, c.presets ? [0, ...c.presets[0]] : c.items.map(it => it.def || 0)]));
const cmCode = (id, v = state.custom[id]) => `${id}-${v.map(n => n.toString(36)).join('')}`;
// オーダーの記号を読む（読めないときは null）
function readCmCode(code) {
  const m = /^(C\d)-([0-9a-z]+)$/.exec(code || '');
  if (!m || !Object.hasOwn(CUSTOM, m[1])) return null;
  const items = CUSTOM[m[1]].items, v = [...m[2]].map(ch => parseInt(ch, 36));
  if (v.length !== items.length || v.some((n, i) => n >= items[i].opts.length)) return null;
  return { id: m[1], v };
}
// 年間の1まいに入る月の数（年間のオーダーメイドで 6か月 をえらんだときは 6）
const yearPer = note => (note && note.fmt.id === 'C1' && state.custom.C1[1] ? 6 : 12);
// えらべる はじまりの年（10年分）と月。どの形も、はじまり月の1日から2年分（24か月）
const YEAR_MIN = 2026, YEAR_MAX = 2035;
const TODAY = new Date();
const startYear = () => Math.min(YEAR_MAX, Math.max(YEAR_MIN, TODAY.getFullYear()));
const startMonth = () => (startYear() === TODAY.getFullYear() ? TODAY.getMonth() + 1 : 1);   // 今年なら今月から
state.month = 1;       // はじまり月（1〜12）
state.weekStart = 1;   // 週のはじまり（1＝月曜、0＝日曜）
state.holidays = true; // 祝日を入れるか
state.rokuyo = true;   // 六曜を入れるか
state.moon = true;     // 月齢（新月・満月のしるし）を入れるか
state.sekki = true;    // 二十四節気を入れるか
state.kyureki = false; // 旧暦を入れるか（はじめは入れない）
state.miniCal = true;  // 右下の小さなカレンダーを出すか
state.events = 0;      // ぎょうじ（1＝日本の行事・2＝先生行事・4＝保育園行事）
// 日付の丸（土曜＝ふちの丸・日曜＝ぬった丸・祝日＝ぬった丸）。false にすると 丸はやめて 色のちがう数字だけ
state.marks = { sat: true, sun: true, hol: true };
// 背景：柄（0＝無地 1＝ドット 2＝方眼 3＝罫線 4＝十字）・間隔（mm）・こさ（BG_DENS の何番め）
const BG_GAPS = [2, 3, 4, 5, 6, 7, 8, 9, 10];
const BG_DENS = [.1, .2, 1 / 3, .5, 1];
state.bg = { type: 0, gap: 5, dens: 2 };
// サイズ：文字の大きさ（%）・位置（mm。＋は右・下）
const SIZE_KS = [80, 90, 100, 110, 120];
const SIZE_DS = [-1, -.5, 0, .5, 1];
state.size = { k: 100, dx: 0, dy: 0 };
// ★v0.2.139 「表示」で えらべる ものを 1つの 文字列に（メニューで「変えている」を 出す ため）。はじめの 値は ここで おぼえる
function viewCode() { return JSON.stringify([state.weekStart, state.holidays, state.rokuyo, state.moon, state.sekki, state.kyureki, state.miniCal, state.events, state.marks, state.size]); }
const VIEW_DEFAULT = viewCode();
// 1冊の紙の数と、i まいめ（0から）の場所 at＝{ y, m, d }（その紙のはじめの日）
//   1冊＝はじまり月の1日から、24か月めの さいごの日まで
//   月間式：はじまり月から24まい
//   週の手帳：はじめの日が入る週から、おわりの日が入る週まで（約105まい。前後の日も入る）
//   2週間式：同じ週を2週ずつ（約53まい。さいごの紙は、次の週で14日にする）
//   年間スケジュール：はじまり月から12か月で1まい、2まい
// 日の数の差（夏時間のある国で見ても1日ずれないよう、UTC でくらべる）
const dayDiff = (a, b) => Math.round((Date.UTC(b.getFullYear(), b.getMonth(), b.getDate()) - Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())) / 864e5);
// 1冊のはじめの日・おわりの日
const bookFrom = (y = state.year, m = state.month) => new Date(y, m - 1, 1);
// 1冊の 長さ（か月）：週の手帳（週・2週）は 1年分、月間式・年間は 2年分（v0.2.74 みなとさん）
const monthsOf = note => (['week', 'biweek'].includes(unitOf(note)) ? 12 : 24);
const bookTo = (y = state.year, m = state.month, note = state.notes[state.idx]) => new Date(y, m - 1 + monthsOf(note), 0);
// y年m月1日が入る週の、はじめの日
function weekBase(year, month, ws) {
  const d = new Date(year, month - 1, 1);
  return new Date(year, month - 1, 1 - (d.getDay() - ws + 7) % 7);
}
const weekIndex = (year, month, ws, date) => Math.floor(dayDiff(weekBase(year, month, ws), date) / 7);
// 見出しの WEEK の数：その年の1月1日が入る週を1とする（年をまたぐ週は、次の年の1）
const weekNo = (ws, days) => weekIndex(days[6].getFullYear(), 1, ws, days[0]) + 1;
const unitOf = note => (note && note.fmt ? note.fmt.unit : 'month');   // ★fmt が ないとき（テストの 仮の 紙）は 月間
const weeksPer = note => (unitOf(note) === 'biweek' ? 2 : 1);   // 1まいに入る週の数
function sheetCount(note, year = state.year, month = state.month, ws = state.weekStart) {
  /* ★nv0.2.20 みなとさん「ページを めくると 種類が 変更されます。変更されないように して」（2026-10-03）
     ------------------------------------------------------------
     ★nv0.2.1 で わたしが「めくる＝となりの 柄に かわる」に して いました。これが まちがい。
       柄を かえるのは **上の 見本を 押した とき だけ**に します。
       めくる（‹ ›）は **ページ**（紙 → 説明 → ご注文内容）を 行き来する だけ。
     → ノートの 紙は 1まい。 */
  if (unitOf(note) === 'note') return TK_HOME ? noteHomeCount() : 1;   // ★nv0.2.58 トップの ノートは めくれる（書いた ページの つぎに 1まい）
  if (unitOf(note) === 'month') return 24;
  if (unitOf(note) === 'year') return 24 / yearPer(note);
  return Math.ceil((weekIndex(year, month, ws, bookTo(year, month, note)) + 1) / weeksPer(note));
}
function sheetAt(note, i, year = state.year, month = state.month, ws = state.weekStart) {
  if (unitOf(note) === 'note') return { y: year, m: month, d: 1 };   // ★ノートは 日付を つかわない
  if (unitOf(note) === 'month') return { ...addMonth(year, month, i), d: 1 };
  if (unitOf(note) === 'year') return { ...addMonth(year, month, yearPer(note) * i), d: 1 };
  const b = weekBase(year, month, ws);
  const d = new Date(b.getFullYear(), b.getMonth(), b.getDate() + 7 * i * weeksPer(note));
  return { y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate() };
}
const atDate = at => new Date(at.y, at.m - 1, at.d || 1);
function sheetLabel(note, i) {
  if (unitOf(note) === 'note') return note.name || '';   // ★nv0.2.20 いま えらんで いる 柄の 名前
  const a = sheetAt(note, i);
  if (uiLang() !== 'ja') { const mo = MONTH_EN[a.m - 1].slice(0, 3); return { month: `${mo} ${a.y}`, year: a.m === 1 ? `${a.y}` : `${mo} ${a.y}–` }[unitOf(note)] || `${mo} ${a.d}, ${a.y}–`; }   // ★v0.2.164
  return { month: `${a.y}年${a.m}月`, year: a.m === 1 ? `${a.y}年` : `${a.y}年${a.m}月〜` }[unitOf(note)] || `${a.y}年${a.m}/${a.d}〜`;
}
// その日が入る紙（1冊の外なら -1）
function sheetOfDate(note, date) {
  const u = unitOf(note);
  const mi = (date.getFullYear() - state.year) * 12 + date.getMonth() + 1 - state.month;   // はじまり月から何か月め
  const i = u === 'month' ? mi
    : u === 'year' ? Math.floor(mi / yearPer(note))
    : Math.floor(weekIndex(state.year, state.month, state.weekStart, date) / weeksPer(note));
  return i >= 0 && i < sheetCount(note) ? i : -1;
}
// 今日が入っている紙（入っていなければ -1）
const todaySheet = (note = state.notes[state.idx]) => sheetOfDate(note, TODAY);
// いまの紙の「日」：今日が入っていれば今日、ちがえば紙のはじめの日（形・週のはじまりをかえても、この日の紙をひらく）
const curDate = () => (todaySheet() === state.sheet ? TODAY : atDate(state.at));
function sheetNear(note, date) {
  const i = sheetOfDate(note, date);
  if (i >= 0) return i;
  return date < bookFrom() ? 0 : sheetCount(note) - 1;
}
function setSheet(i) {
  state.sheet = i;
  state.at = sheetAt(state.notes[state.idx], i);
}
// はじまり月をきめる。紙は、今日がこの1冊に入っていれば今日の紙、ちがえば1まいめ
function setStart(y, m) {
  state.year = y;
  state.month = m;
  setSheet(Math.max(0, todaySheet()));
  if (state.page && /^s\d+$/.test(state.page)) state.page = sheetPage();
}
// いま紙に出している場所（絵の作りおきの名前・印刷の記録に使う）
const koyoBits = () => (state.rokuyo ? 1 : 0) | (state.moon ? 2 : 0) | (state.sekki ? 4 : 0) | (state.kyureki ? 8 : 0)
  | (state.marks.sat ? 16 : 0) | (state.marks.sun ? 32 : 0) | (state.marks.hol ? 64 : 0);   // 暦と 日付の丸のえらび（?d= にも入る）
const plannerKey = () => `${state.country}-${state.year}-${state.month}-${state.at.y}-${state.at.m}-${state.at.d}-${state.weekStart}-${state.holidays ? 1 : 0}-${koyoBits()}-${state.miniCal ? 1 : 0}-${bgCode()}-${sizeCode()}-${state.events}`;
// 描くときのえらびかた（ws＝週のはじまり、hol＝祝日、ro＝六曜、mo＝月齢、se＝二十四節気、ky＝旧暦、cal＝小さなカレンダー、marks＝日付の丸、bg＝背景、size＝文字の大きさ・位置、ev＝ぎょうじ、from・to＝1冊のはじめとおわりの日）
const drawOpt = (note = state.notes[state.idx]) => ({ country: state.country, ws: state.weekStart, hol: state.holidays, ro: state.rokuyo, mo: state.moon, se: state.sekki, ky: state.kyureki, cal: state.miniCal, marks: { ...state.marks }, bg: { ...state.bg }, size: { ...state.size }, ev: state.events, from: bookFrom(), to: bookTo(state.year, state.month, note) });
// この1冊に入らない日（週の紙の、はじまり月より前・24か月めより後の日）はうすくする
const outBook = (d, opt) => !!opt.from && (d < opt.from || d > opt.to);
// ===== 注文コード =====
//   B5T<年間><形>-<年月><設定><背景><サイズ><ぎょうじ>   例 B5T0M1-2609000522c0（読み方は フォルダの「注文コードの読み方.md」）
//   ・年間：0〜3（YEAR_FMTS）。年間なしの 古い コードは「-」
//   ・形：FORMATS の id　・年月：はじまり月を YYMM の4けた（2026年9月→2609）
//   ・設定：36進数2文字（00〜3j）。ビットが立つと「ふつうとちがう」
//       1＝日曜はじまり　2＝祝日を入れない　4＝六曜を入れない　8＝月齢を入れない　16＝二十四節気を入れない
//       32＝旧暦を入れる　64＝小さなカレンダーを出さない
//       128＝土曜の丸をつけない　256＝日曜の丸をつけない　512＝祝日の丸をつけない（ぜんぶで 1023＝36進数 sr の2文字）
//   ・背景：3文字＝柄（0〜4）・間隔（2〜9、10mm は a）・こさ（0〜4＝1/10・1/5・1/3・1/2・同じ）
//   ・ぎょうじと紙：1文字（36進数。ぎょうじ 0〜7＝日本の行事1＋先生行事2＋保育園行事4　＋　紙 0〜2 を 8ばいして足す。0〜23＝0〜n）
//   ・サイズ：2文字＝大きさ（0〜4＝80〜120%）・位置（左右×5＋上下 を36進数。0〜4＝−1〜＋1mm。そのままは c）
//   ★半角の英数字と「-」だけ（楽天の EUC-JP でこわれない）・20文字まで
const PAPER_IDS = ['book', 'fp', 'mp'];   // 紙の種類（注文コードでは 0・1・2）
const PAPER_I = Object.fromEntries(PAPER_IDS.map((k, i) => [k, i]));
const CODE_FLAGS = ['sun', 'noHol', 'noRokuyo', 'noMoon', 'noSekki', 'kyureki', 'noCal', 'noSatMark', 'noSunMark', 'noHolMark'];
const bgCode = (b = state.bg) => `${b.type}${b.gap.toString(36)}${b.dens}`;
const sizeCode = (z = state.size) => `${SIZE_KS.indexOf(z.k)}${(SIZE_DS.indexOf(z.dx) * 5 + SIZE_DS.indexOf(z.dy)).toString(36)}`;
// ★年間の紙（v0.2.74）：B5T の すぐ うしろの 1文字（0＝年間カレンダー 1＝年間スケジュール 2＝年間チャート 3＝年間の目標）
//   年間が ない 古い コードは「-」（B5T-M1-…）。文字の数は かわらない（いちばん長くて 20文字の まま）
const YEAR_FMTS = ['Y1', 'M6', 'Y2', 'Y3'];
function planCode(p) {
  const bits = CODE_FLAGS.reduce((b, k, i) => b | (p[k] ? 1 << i : 0), 0);
  const yk = YEAR_FMTS.indexOf(p.yfmt);
  return `B5T${yk < 0 ? '-' : yk}${p.fmt}-${String(p.year % 100).padStart(2, '0')}${String(p.month).padStart(2, '0')}${bits.toString(36).padStart(2, '0')}${bgCode(p.bg)}${sizeCode(p.size)}${((p.events || 0) + (PAPER_I[p.paper] || 0) * 8).toString(36)}${countryOf(p.country).code}`;
}
// 注文コードを読む（お店で中身をたしかめる・テスト用）。読めないときは null
function readPlanCode(code) {
  const my = /^B5T([-0-3])/.exec(code || '');
  const m = /^B5T[-0-3]([A-Z][0-9]{1,2})-(\d{2})(0[1-9]|1[0-2])([0-9a-z]{2})([0-4])([2-9a])([0-4])([0-4])([0-9a-o])([0-9a-n])([UCKE])?$/.exec(code || '');   // ★v0.2.159 さいごの 1文字＝国（COUNTRIES の code。無ければ 日本）
  if (!m || !FORMATS.some(f => f.id === m[1])) return null;
  const bits = parseInt(m[4], 36);
  if (bits >= 1 << CODE_FLAGS.length) return null;
  // ★年間が ない（「-」の）ときは yfmt を つけない（前の版の コードと 同じ 中身に なるように）
  const p = { fmt: m[1], ...(my[1] === '-' ? {} : { yfmt: YEAR_FMTS[+my[1]] }), year: 2000 + +m[2], month: +m[3], bg: { type: +m[5], gap: parseInt(m[6], 36), dens: +m[7] } };
  const pos = parseInt(m[9], 36);
  p.size = { k: SIZE_KS[+m[8]], dx: SIZE_DS[Math.floor(pos / 5)], dy: SIZE_DS[pos % 5] };
  const ep = parseInt(m[10], 36);
  if (ep >= PAPER_IDS.length * 8) return null;
  p.events = ep % 8;
  p.paper = PAPER_IDS[Math.floor(ep / 8)];
  CODE_FLAGS.forEach((k, i) => { p[k] = !!(bits & 1 << i); });
  if (m[11]) p.country = (COUNTRIES.find(c => c.code === m[11]) || {}).id;
  return p;
}

// ご注文内容の「期間」
function termText(note) {
  const a = bookFrom(), b = bookTo(state.year, state.month, note);
  if (uiLang() !== 'ja') return `${MONTH_EN[a.getMonth()].slice(0, 3)} ${a.getFullYear()} – ${MONTH_EN[b.getMonth()].slice(0, 3)} ${b.getFullYear()} (${monthsOf(note) / 12} years, ${sheetCount(note)} sheets)`;   // ★v0.2.164
  return `${a.getFullYear()}年${a.getMonth() + 1}月〜${b.getFullYear()}年${b.getMonth() + 1}月（${monthsOf(note) / 12}年分・${sheetCount(note)}まい）`;
}

// ----- 描くときの道具（単位は mm。B5＝182×257）-----
const INK_C = START_COLOR;   // 描くときの色。tintedUrl() でえらんだ色にかえる
const FONT = 'Hiragino Maru Gothic ProN, M PLUS Rounded 1c, Hiragino Sans, sans-serif';
const WD_JA = ['日', '月', '火', '水', '木', '金', '土'];
const WD_EN = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const MONTH_EN = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
const nf = n => +n.toFixed(2);
const svgLine = (x1, y1, x2, y2, w, extra = '') => `<line x1="${nf(x1)}" y1="${nf(y1)}" x2="${nf(x2)}" y2="${nf(y2)}" stroke="${INK_C}" stroke-width="${w}"${extra}/>`;
// 文字（ここに入るのは、このページで作った数字・決まった文字だけ）
// 日曜（祝日の名前も）は class="ink sun"、土曜は "ink sat"（色のパネルの 日曜日の色・土曜日の色になる）
const inkCls = extra => (/data-holiday|data-dow="0"/.test(extra) ? 'ink sun' : /data-dow="6"/.test(extra) ? 'ink sat' : 'ink');
const dowAttr = dow => (dow === 0 || dow === 6 ? ` data-dow="${dow}"` : '');
const svgText = (x, y, size, body, extra = '') => `<text class="${inkCls(extra)}" fill="${INK_C}" x="${nf(x)}" y="${nf(y)}" font-size="${size}"${extra}>${body}</text>`;
// 月曜はじまりなら ['月', …, '日'] の順
const weekOrder = ws => [0, 1, 2, 3, 4, 5, 6].map(i => (i + ws) % 7);
// その月のカレンダーのマス（6週×7日＝42日）。前後の月の日もふくむ
function monthDays(y, m, ws) {
  const off = (new Date(y, m - 1, 1).getDay() - ws + 7) % 7;
  return Array.from({ length: 42 }, (_, i) => new Date(y, m - 1, 1 - off + i));
}
// ===== 日本の祝日（年ごとに計算する）=====
//   「国民の祝日に関する法律」のきまりどおりに計算する
//   ・春分の日・秋分の日は計算式（1980〜2099年に使える式）。正式には前の年の2月に国立天文台の発表できまる
//   ・振替休日：祝日が日曜なら、そのあとの「祝日でない日」が休み
//   ・国民の休日：前の日と次の日が祝日の日は休み（例 2026年9月22日）
//   ★法律がかわったら（オリンピックの年のように）ここを直して版を上げる
// ★v0.2.159 国：描いている あいだの 国（plannerSvg が opt.country から 入れる。opt に 無ければ jp＝今まで どおり）
// ★v0.2.167 画面の 言葉（LANG）は この 範囲の 外で 決まる。ここでは uiLang() で 見る（テストでは 無いので 'ja'）
const uiLang = () => (typeof LANG === 'string' ? LANG : 'ja');
const COUNTRIES = [
  { id: 'jp', lang: 'ja', ws: 1, code: '',  ready: true },   // 日本（もと）
  { id: 'us', lang: 'en', ws: 0, code: 'U', ready: true },   // アメリカ（v0.2.159〜）
  { id: 'cn', lang: 'zh', ws: 1, code: 'C', ready: false },  // 中国（これから）
  { id: 'kr', lang: 'ko', ws: 0, code: 'K', ready: false },  // 韓国（これから）
  { id: 'eu', lang: 'en', ws: 1, code: 'E', ready: false },  // ヨーロッパ（英・独・仏は これから）
];
const countryOf = id => COUNTRIES.find(c => c.id === id) || COUNTRIES[0];
const I18N = {};          // 言葉 → 辞書。紙の ぶん（koyo/wd/ro2/paper）は plannerSvg の 前で、画面の ぶん（ui/fn/fmt/cat）は いちばん下で 登録（テストは 紙の ぶんだけ 見る）
let CTRY = 'jp', PLANG = 'ja';   // ★v0.2.165 PLANG＝紙の 言葉（COUNTRIES の lang）
const WD_US = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const WDL = () => (PLANG === 'ja' ? WD_JA : (I18N[PLANG].wd || WD_US));   // 曜日の 短い 字（日本＝漢字 1字・英語＝2字）
const L = (ja, en) => (PLANG === 'ja' ? ja : ((I18N[PLANG].paper || {})[ja] ?? en));   // 紙の 決まった 文字（辞書に 無ければ 英語）
// アメリカの 祝日（連邦の 祝日 11）。ふりかえの 休み（observed）は 出さない
const nthDow = (y, m, dow, n) => 1 + (dow - new Date(y, m - 1, 1).getDay() + 7) % 7 + (n - 1) * 7;
const lastDow = (y, m, dow) => { const last = new Date(y, m, 0).getDate(); return last - (new Date(y, m - 1, last).getDay() - dow + 7) % 7; };
function holidaysUS(y) {
  const h = new Map(); const add = (m, d, name) => h.set(`${m}-${d}`, name);
  add(1, 1, "New Year's Day"); add(1, nthDow(y, 1, 1, 3), 'MLK Day'); add(2, nthDow(y, 2, 1, 3), "Presidents' Day");
  add(5, lastDow(y, 5, 1), 'Memorial Day'); add(6, 19, 'Juneteenth'); add(7, 4, 'Independence Day');
  add(9, nthDow(y, 9, 1, 1), 'Labor Day'); add(10, nthDow(y, 10, 1, 2), 'Columbus Day'); add(11, 11, 'Veterans Day');
  add(11, nthDow(y, 11, 4, 4), 'Thanksgiving'); add(12, 25, 'Christmas');
  return h;
}
// ★v0.2.161 みなとさん：アメリカでも 六曜・月齢・二十四節気・旧暦・ぎょうじを（英語で）出す。日本語 → 英語の 辞書。無い ものは そのまま
const KOYO_EN = {
  '大安': 'Taian', '赤口': 'Shakko', '先勝': 'Sensho', '友引': 'Tomobiki', '先負': 'Senbu', '仏滅': 'Butsumetsu',
  '春分': 'Spring Equinox', '清明': 'Qingming', '穀雨': 'Grain Rain', '立夏': 'Start of Summer', '小満': 'Grain Buds', '芒種': 'Grain in Ear', '夏至': 'Summer Solstice', '小暑': 'Minor Heat', '大暑': 'Major Heat', '立秋': 'Start of Autumn', '処暑': 'End of Heat', '白露': 'White Dew',
  '秋分': 'Autumn Equinox', '寒露': 'Cold Dew', '霜降': 'Frost Descent', '立冬': 'Start of Winter', '小雪': 'Minor Snow', '大雪': 'Major Snow', '冬至': 'Winter Solstice', '小寒': 'Minor Cold', '大寒': 'Major Cold', '立春': 'Start of Spring', '雨水': 'Rain Water', '啓蟄': 'Insects Awaken',
  '節分': 'Setsubun', '彼岸入り': 'Higan', '八十八夜': '88th Night', '二百十日': '210th Day', '土用の入り': 'Doyo', '入梅': 'Rainy Season', '半夏生': 'Hangesho',
  '七草': 'Nanakusa', '鏡開き': 'Kagami-biraki', '小正月': 'Koshogatsu', 'バレンタイン': "Valentine's Day", 'ひなまつり': 'Hinamatsuri', 'ホワイトデー': 'White Day', '花まつり': 'Hanamatsuri', '端午の節句': 'Tango no Sekku', '七夕': 'Tanabata', 'お盆入り': 'Obon begins', 'お盆明け': 'Obon ends', '重陽': 'Choyo',
  'ハロウィン': 'Halloween', '七五三': 'Shichi-go-san', 'クリスマスイブ': 'Christmas Eve', 'クリスマス': 'Christmas', '大晦日': "New Year's Eve", '母の日': "Mother's Day", '父の日': "Father's Day", '十五夜': 'Harvest Moon', '十三夜': 'Jusanya',
  '学校': 'School', '園': 'Preschool',
  '始業式': 'Opening ceremony', '書き初め': 'Calligraphy', '避難訓練': 'Fire drill', '学校公開': 'Open school', 'なわとび大会': 'Jump-rope meet', '入学説明会': 'Entrance briefing', '6年生を送る会': 'Farewell party', '卒業式': 'Graduation', '修了式': 'Closing ceremony', '入学式': 'Entrance ceremony', '身体測定': 'Health check', '家庭訪問': 'Home visits',
  '遠足': 'Field trip', '運動会': 'Sports day', '健康診断': 'Physical exam', 'プール開き': 'Pool opens', '歯科検診': 'Dental check', '個人面談': 'Parent meeting', '終業式': 'Term-end ceremony', '夏休み': 'Summer break', '登校日': 'School day', '就学時健診': 'Pre-entry exam', '音楽会': 'Concert', '学習発表会': 'Presentation day', '社会科見学': 'Study tour', '持久走大会': 'Endurance run', '大掃除': 'Big cleanup',
  '誕生会': 'Birthday party', 'お正月あそび': 'New Year games', '豆まき': 'Bean throwing', '保育参観': "Parents' day", 'ひなまつり会': 'Hinamatsuri party', 'お別れ会': 'Farewell party', '卒園式': 'Graduation', '入園式': 'Entrance ceremony', '進級': 'Moving up', '保護者会': "Parents' meeting", 'こどもの日の会': "Children's Day party", '親子遠足': 'Family outing',
  '七夕まつり': 'Tanabata festival', '夏まつり': 'Summer festival', '水あそび': 'Water play', 'すいか割り': 'Watermelon split', '敬老の会': "Seniors' day", 'お月見会': 'Moon viewing', 'いも掘り': 'Potato digging', '作品展': 'Art show', '生活発表会': 'Recital', 'クリスマス会': 'Christmas party', 'もちつき': 'Mochi pounding',
};
const RO_SHORT = { Taian: 'TA', Shakko: 'SK', Sensho: 'SS', Tomobiki: 'TB', Senbu: 'SB', Butsumetsu: 'BM' };   // 六曜を たてに 2文字で 置く 形（M5）むけ
const TX = str => (PLANG !== 'ja' && str ? ((I18N[PLANG].koyo || {})[str] || str) : str);   // こよみ・行事の 文字（T だと テストの 道具と かぶる）
const HOLIDAYS = { us: holidaysUS };   // 国 → 祝日を 作る 関数（日本は 下の holidaysOf の 中）
const holidayCache = new Map();   // 鍵は 国＋年（v0.2.159）
// その月の第n月曜の日にち
const nthMonday = (y, m, n) => 1 + (8 - new Date(y, m - 1, 1).getDay()) % 7 + (n - 1) * 7;
function holidaysOf(y) {
  const ck = CTRY + y;
  if (holidayCache.has(ck)) return holidayCache.get(ck);
  if (HOLIDAYS[CTRY]) { const hc = HOLIDAYS[CTRY](y); holidayCache.set(ck, hc); return hc; }   // 日本 いがいの 祝日は 国ごとの 関数
  const h = new Map();
  const key = d => `${d.getMonth() + 1}-${d.getDate()}`;
  const add = (m, d, name) => h.set(`${m}-${d}`, name);
  const t = y - 1980;
  add(1, 1, '元日');
  add(1, nthMonday(y, 1, 2), '成人の日');
  add(2, 11, '建国記念の日');
  add(2, 23, '天皇誕生日');
  add(3, Math.floor(20.8431 + 0.242194 * t - Math.floor(t / 4)), '春分の日');
  add(4, 29, '昭和の日');
  add(5, 3, '憲法記念日');
  add(5, 4, 'みどりの日');
  add(5, 5, 'こどもの日');
  add(7, nthMonday(y, 7, 3), '海の日');
  add(8, 11, '山の日');
  add(9, nthMonday(y, 9, 3), '敬老の日');
  add(9, Math.floor(23.2488 + 0.242194 * t - Math.floor(t / 4)), '秋分の日');
  add(10, nthMonday(y, 10, 2), 'スポーツの日');
  add(11, 3, '文化の日');
  add(11, 23, '勤労感謝の日');
  const base = [...h.keys()].map(k => { const [m, d] = k.split('-').map(Number); return new Date(y, m - 1, d); });
  for (const d of base) {
    // 国民の休日：d と2日あとが祝日で、そのあいだの日が祝日でない
    const mid = new Date(y, d.getMonth(), d.getDate() + 1), after = new Date(y, d.getMonth(), d.getDate() + 2);
    if (after.getFullYear() === y && h.has(key(after)) && !h.has(key(mid))) h.set(key(mid), '国民の休日');
  }
  for (const d of base) {
    if (d.getDay() !== 0) continue;
    const n = new Date(d);
    do n.setDate(n.getDate() + 1); while (h.has(key(n)));
    if (n.getFullYear() === y) h.set(key(n), '振替休日');
  }
  holidayCache.set(ck, h);
  return h;
}
// その日の祝日の名前（なければ ''）
const holidayName = d => holidaysOf(d.getFullYear()).get(`${d.getMonth() + 1}-${d.getDate()}`) || '';
// ===== 暦（二十四節気・新月と満月・旧暦・六曜）=====
//   このページの中だけで計算する（外から読まない）
//   ・太陽の位置：Bretagnon & Simon の式（Reingold & Dershowitz『Calendrical Calculations』の形）＋章動・光行差
//   ・新月・満月：Meeus『Astronomical Algorithms』49章
//   ・時刻の差 ΔT：Espenak & Meeus の式（2005〜2050年）
//   ・旧暦：天保暦のきまり（新月の日が1日、冬至をふくむ月が11月、中気のない月が閏月。13か月ある年だけ）
//   ・六曜：（旧暦の月＋日）÷6 のあまり
//   ★テスト：国立天文台 暦計算室の 2009〜2027年の表（二十四節気・朔・望）と、日付がすべて同じ
//   ★2033年は「旧暦2033年問題」。上のきまりで 閏11月（日本カレンダー暦文化振興協会の案と同じ）
const KOYO = (() => {
  const RAD = Math.PI / 180;
  const sinD = d => Math.sin(d * RAD), cosD = d => Math.cos(d * RAD);
  const mod360 = d => ((d % 360) + 360) % 360;
  const J2000 = 2451545.0;
  // ΔT（秒）＝ 力学時 − 世界時
  const deltaT = y => { const t = y - 2000; return 62.92 + 0.32217 * t + 0.005589 * t * t; };
  const jdToYear = jd => 2000 + (jd - J2000) / 365.25;
  // ----- 太陽の視黄経（度）。jde＝力学時のユリウス日 -----
  const SX = [403406, 195207, 119433, 112392, 3891, 2819, 1721, 660, 350, 334, 314, 268, 242, 234, 158, 132, 129, 114, 99, 93, 86, 78, 72, 68, 64, 46, 38, 37, 32, 29, 28, 27, 27, 25, 24, 21, 21, 20, 18, 17, 14, 13, 13, 13, 12, 10, 10, 10, 10];
  const SY = [270.54861, 340.19128, 63.91854, 331.2622, 317.843, 86.631, 240.052, 310.26, 247.23, 260.87, 297.82, 343.14, 166.79, 81.53, 3.5, 132.75, 182.95, 162.03, 29.8, 266.4, 249.2, 157.6, 257.8, 185.1, 69.9, 8, 197.1, 250.4, 65.3, 162.7, 341.5, 291.6, 98.5, 146.7, 110, 5.2, 342.6, 230.9, 256.1, 45.3, 242.9, 115.2, 151.8, 285.3, 53.3, 126.6, 205.7, 85.9, 146.1];
  const SZ = [0.9287892, 35999.1376958, 35999.4089666, 35998.7287385, 71998.20261, 71998.4403, 36000.35726, 71997.4812, 32964.4678, -19.441, 445267.1117, 45036.884, 3.1008, 22518.4434, -19.9739, 65928.9345, 9038.0293, 3034.7684, 33718.148, 3034.448, -2280.773, 29929.992, 31556.493, 149.588, 9037.75, 107997.405, -4444.176, 151.771, 67555.316, 31556.08, -4561.54, 107996.706, 1221.655, 62894.167, 31437.369, 14578.298, -31931.757, 34777.243, 1221.999, 62894.511, -4442.039, 107997.909, 119.066, 16859.071, -4.578, 26895.292, -39.127, 12297.536, 90073.778];
  function sunLong(jde) {
    const c = (jde - J2000) / 36525;
    let s = 0;
    for (let i = 0; i < SX.length; i++) s += SX[i] * sinD(SY[i] + SZ[i] * c);
    const lam = 282.7771834 + 36000.76953744 * c + 0.000005729577951308232 * s;
    const aberration = 0.0000974 * cosD(177.63 + 35999.01848 * c) - 0.005575;
    const A = 124.90 - 1934.134 * c + 0.002063 * c * c, B = 201.11 + 72001.5377 * c + 0.00057 * c * c;
    const nutation = -0.004778 * sinD(A) - 0.0003667 * sinD(B);
    return mod360(lam + aberration + nutation);
  }
  // 太陽の黄経が target 度になるとき（世界時のユリウス日）。jd0 の近くをさがす
  function sunAt(target, jd0) {
    let jd = jd0;
    for (let i = 0; i < 20; i++) {
      const jde = jd + deltaT(jdToYear(jd)) / 86400;
      let diff = mod360(target - sunLong(jde));
      if (diff > 180) diff -= 360;
      jd += diff * 365.242189 / 360;
      if (Math.abs(diff) < 1e-7) break;
    }
    return jd;
  }
  // ----- 新月（phase 0）・満月（phase 0.5）。k は 2000年1月からの数 -----
  function moonPhase(k, phase) {
    k += phase;
    const T = k / 1236.85, T2 = T * T, T3 = T2 * T, T4 = T3 * T;
    let jde = 2451550.09766 + 29.530588861 * k + 0.00015437 * T2 - 0.00000015 * T3 + 0.00000000073 * T4;
    const E = 1 - 0.002516 * T - 0.0000074 * T2;
    const M = 2.5534 + 29.1053567 * k - 0.0000014 * T2 - 0.00000011 * T3;
    const Mp = 201.5643 + 385.81693528 * k + 0.0107582 * T2 + 0.00001238 * T3 - 0.000000058 * T4;
    const F = 160.7108 + 390.67050284 * k - 0.0016118 * T2 - 0.00000227 * T3 + 0.000000011 * T4;
    const Om = 124.7746 - 1.56375588 * k + 0.0020672 * T2 + 0.00000215 * T3;
    const full = phase === 0.5;
    const t = full
      ? [-0.40614, Mp, 0.17302 * E, M, 0.01614, 2 * Mp, 0.01043, 2 * F, 0.00734 * E, Mp - M, -0.00515 * E, Mp + M, 0.00209 * E * E, 2 * M]
      : [-0.4072, Mp, 0.17241 * E, M, 0.01608, 2 * Mp, 0.01039, 2 * F, 0.00739 * E, Mp - M, -0.00514 * E, Mp + M, 0.00208 * E * E, 2 * M];
    t.push(-0.00111, Mp - 2 * F, -0.00057, Mp + 2 * F, 0.00056 * E, 2 * Mp + M, -0.00042, 3 * Mp, 0.00042 * E, M + 2 * F,
      0.00038 * E, M - 2 * F, -0.00024 * E, 2 * Mp - M, -0.00017, Om, -0.00007, Mp + 2 * M, 0.00004, 2 * Mp - 2 * F,
      0.00004, 3 * M, 0.00003, Mp + M - 2 * F, 0.00003, 2 * Mp + 2 * F, -0.00003, Mp + M + 2 * F, 0.00003, Mp - M + 2 * F,
      -0.00002, Mp - M - 2 * F, -0.00002, 3 * Mp + M, 0.00002, 4 * Mp);
    for (let i = 0; i < t.length; i += 2) jde += t[i] * sinD(t[i + 1]);
    const A = [299.77 + 0.107408 * k - 0.009173 * T2, 251.88 + 0.016321 * k, 251.83 + 26.651886 * k, 349.42 + 36.412478 * k,
      84.66 + 18.206239 * k, 141.74 + 53.303771 * k, 207.14 + 2.453732 * k, 154.84 + 7.30686 * k, 34.52 + 27.261239 * k,
      207.19 + 0.121824 * k, 291.34 + 1.844379 * k, 161.72 + 24.198154 * k, 239.56 + 25.513099 * k, 331.55 + 3.592518 * k];
    const AC = [0.000325, 0.000165, 0.000164, 0.000126, 0.00011, 0.000062, 0.00006, 0.000056, 0.000047, 0.000042, 0.00004, 0.000037, 0.000035, 0.000023];
    for (let i = 0; i < 14; i++) jde += AC[i] * sinD(A[i]);
    return jde - deltaT(jdToYear(jde)) / 86400;   // 世界時
  }
  // ----- 日本時間の日付 -----
  // 世界時のユリウス日 → 日本時間の { y, m, d, hh, mm }（分は切りすて）
  function jdToJst(jd) {
    const ms = Math.floor(((jd - 2440587.5) * 86400 + 9 * 3600) * 1000 / 60000) * 60000;
    const t = new Date(ms);
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate(), hh: t.getUTCHours(), mm: t.getUTCMinutes() };
  }
  const dayNo = (y, m, d) => Math.round(Date.UTC(y, m - 1, d) / 864e5);   // 1970-01-01 からの日の数
  const jstDay = jd => { const j = jdToJst(jd); return dayNo(j.y, j.m, j.d); };
  const jdOfDay = n => n + 2440587.5 - 9 / 24;   // 日本時間でその日の0時（世界時のユリウス日）

  const SEKKI = ['春分', '清明', '穀雨', '立夏', '小満', '芒種', '夏至', '小暑', '大暑', '立秋', '処暑', '白露',
    '秋分', '寒露', '霜降', '立冬', '小雪', '大雪', '冬至', '小寒', '大寒', '立春', '雨水', '啓蟄'];   // 黄経 0°, 15°, …
  const ROKUYO = ['大安', '赤口', '先勝', '友引', '先負', '仏滅'];

  // その年の二十四節気（日本時間の日の数 → 名前）と、時刻つきの一覧
  const sekkiCache = new Map();
  function sekkiOf(y) {
    if (sekkiCache.has(y)) return sekkiCache.get(y);
    const list = [];
    const jan1 = jdOfDay(dayNo(y, 1, 1));
    for (let i = 0; i < 24; i++) {
      const lon = (285 + 15 * i) % 360;                   // 小寒（1月はじめ）から
      const guess = jan1 + 5 + i * 365.2422 / 24;
      const jd = sunAt(lon, guess);
      list.push({ jd, day: jstDay(jd), lon, name: SEKKI[lon / 15] });
    }
    const map = new Map(list.map(e => [e.day, e.name]));
    const r = { list, map };
    sekkiCache.set(y, r);
    return r;
  }
  // その年の新月・満月（日本時間の日の数 → '朔' / '望'）と一覧
  const moonCache = new Map();
  function moonOf(y) {
    if (moonCache.has(y)) return moonCache.get(y);
    const list = [];
    const k0 = Math.floor((y - 2000) * 12.3685) - 2;
    for (let k = k0; k < k0 + 16; k++) {
      for (const ph of [0, 0.5]) {
        const jd = moonPhase(k, ph);
        const j = jdToJst(jd);
        if (j.y === y) list.push({ jd, day: jstDay(jd), kind: ph ? '望' : '朔' });
      }
    }
    list.sort((a, b) => a.jd - b.jd);
    const r = { list, map: new Map(list.map(e => [e.day, e.kind])) };
    moonCache.set(y, r);
    return r;
  }
  // ----- 旧暦 -----
  // 冬至をふくむ月（11月）から、次の冬至をふくむ月の前までを1まとまり（歳）として、月に名前をつける
  const newMoonsFrom = (day0, n) => {
    // day0 以前でいちばん近い新月の日から n 個
    let k = Math.floor((day0 / 365.2425 + 1970 - 2000) * 12.3685) + 1;
    while (jstDay(moonPhase(k, 0)) > day0) k--;
    return Array.from({ length: n }, (_, i) => jstDay(moonPhase(k + i, 0)));
  };
  const suiCache = new Map();
  // y年の冬至をふくむ月から、y＋1年の冬至をふくむ月までの月（はじめの日と名前）
  function sui(y) {
    if (suiCache.has(y)) return suiCache.get(y);
    const ws1 = sekkiOf(y).list.find(e => e.lon === 270).day;
    const ws2 = sekkiOf(y + 1).list.find(e => e.lon === 270).day;
    const starts = newMoonsFrom(ws1, 16);
    const i2 = starts.findIndex((s, i) => s <= ws2 && starts[i + 1] > ws2);
    const months = starts.slice(0, i2 + 1).map((s, i) => ({ start: s, end: starts[i + 1] }));   // 11月〜次の11月
    // 中気（黄経 30°ごと）の日
    const chuki = [...sekkiOf(y).list, ...sekkiOf(y + 1).list].filter(e => e.lon % 30 === 0).map(e => e.day);
    const hasChuki = mo => chuki.some(c => c >= mo.start && c < mo.end);
    const leap = months.length === 14;   // 11月から次の11月まで13か月（＋次の11月）＝閏月がある
    let num = 11, leapUsed = false;
    months.forEach((mo, i) => {
      if (i > 0) {
        if (leap && !leapUsed && !hasChuki(mo)) { mo.leap = true; leapUsed = true; }
        else num = num % 12 + 1;
      }
      mo.month = num;
    });
    suiCache.set(y, months);
    return months;
  }
  // 日本時間の日 → { month, day, leap }
  function lunar(y, m, d) {
    const n = dayNo(y, m, d);
    for (const yy of [y - 1, y]) {
      const mo = sui(yy).find(x => n >= x.start && n < x.end);
      if (mo) return { month: mo.month, day: n - mo.start + 1, leap: !!mo.leap };
    }
    return null;
  }
  // ----- 雑節（国立天文台の「雑節」と同じ決め方）-----
  //   節分＝立春の前の日、彼岸入り＝春分・秋分の3日前、八十八夜・二百十日＝立春から数えて88日め・210日め
  //   入梅＝太陽黄経80°、半夏生＝100°、土用の入り＝297°・27°・117°・207° になる日
  const zasCache = new Map();
  function zassetsuOf(y) {
    if (zasCache.has(y)) return zasCache.get(y);
    const sk = sekkiOf(y).list, dayOf = lon => sk.find(e => e.lon === lon).day;
    const risshun = dayOf(315), jan1 = jdOfDay(dayNo(y, 1, 1));
    const list = [
      { day: risshun - 1, name: '節分' },
      { day: dayOf(0) - 3, name: '彼岸入り' },
      { day: risshun + 87, name: '八十八夜' },
      { day: risshun + 209, name: '二百十日' },
      { day: dayOf(180) - 3, name: '彼岸入り' },
    ];
    [[297, '土用の入り', 17], [27, '土用の入り', 107], [80, '入梅', 161], [100, '半夏生', 182], [117, '土用の入り', 200], [207, '土用の入り', 293]].forEach(([lon, name, doy]) => {
      const jd = sunAt(lon, jan1 + doy);
      list.push({ day: jstDay(jd), name, jd, lon });
    });
    list.sort((a, b) => a.day - b.day);
    const map = new Map();
    list.forEach(e => map.set(e.day, [...(map.get(e.day) || []), e.name]));
    const r = { list, map };
    zasCache.set(y, r);
    return r;
  }
  return {
    sunLong, sunAt, moonPhase, jdToJst, sekkiOf, moonOf, sui, lunar, dayNo, zassetsuOf,
    // その日の雑節（なければ []）
    zassetsu: d => zassetsuOf(d.getFullYear()).map.get(dayNo(d.getFullYear(), d.getMonth() + 1, d.getDate())) || [],
    // その日の二十四節気（なければ ''）
    sekki: d => sekkiOf(d.getFullYear()).map.get(dayNo(d.getFullYear(), d.getMonth() + 1, d.getDate())) || '',
    // その日が新月・満月か（'朔' / '望' / ''）
    moon: d => moonOf(d.getFullYear()).map.get(dayNo(d.getFullYear(), d.getMonth() + 1, d.getDate())) || '',
    // その日の旧暦（'8/15'、閏月は '閏11/3'）
    kyureki: d => { const l = lunar(d.getFullYear(), d.getMonth() + 1, d.getDate()); return l ? `${l.leap ? '閏' : ''}${l.month}/${l.day}` : ''; },
    // その日の六曜
    rokuyo: d => { const l = lunar(d.getFullYear(), d.getMonth() + 1, d.getDate()); return l ? ROKUYO[(l.month + l.day) % 6] : ''; },
  };
})();

const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
const addMonth = (y, m, d) => { const t = new Date(y, m - 1 + d, 1); return { y: t.getFullYear(), m: t.getMonth() + 1 }; };

// 日付の数字。日曜・祝日はぬった丸に紙の色の数字、土曜はふちの丸（1色で見分ける）
//   opt.marks で 丸を つけない ことも できる（丸がなくても、色で 土曜・日曜が わかる）
function dayNum(cx, cy, r, size, d, faded, opt) {
  const isHol = !!(opt.hol && holidayName(d));
  const dow = isHol ? 0 : d.getDay();
  const mk = opt.marks || { sat: true, sun: true, hol: true };
  const ring = dow === 0 ? (isHol ? mk.hol : mk.sun) : dow === 6 ? mk.sat : false;
  const op = faded ? ' opacity=".35"' : '';
  let o = '';
  let cls = 'ink', fill = INK_C;
  if (dow === 0) {
    if (ring) { o += `<circle class="ink sun" fill="${INK_C}" cx="${nf(cx)}" cy="${nf(cy)}" r="${r}"${op}/>`; cls = 'paper'; fill = '#ffffff'; }
    else cls = 'ink sun';
  } else if (dow === 6) {
    if (mk.sat) o += `<circle class="sat" fill="none" stroke="${INK_C}" stroke-width=".25" cx="${nf(cx)}" cy="${nf(cy)}" r="${r}"${op}/>`;
    cls = 'ink sat';
  }
  o += `<text class="${cls}" fill="${fill}" x="${nf(cx)}" y="${nf(cy + size * .36)}" font-size="${size}" text-anchor="middle" font-weight="700"${op}>${d.getDate()}</text>`;
  return o;
}

// その日の暦（入れないもの・うすくする日は ''）
function koyoOf(d, opt, faded) {
  if (faded) return { ro: '', se: '', mo: '', kyu: '', ev: '' };
  const ev = opt.ev & 1 ? eventOf(d, opt.hol) : '';
  // ★v0.2.161 アメリカでは 英語（六曜＝ローマ字・節気＝英語・旧暦の 閏＝L・行事＝英語を / で つなぐ）
  return { ro: TX(opt.ro ? KOYO.rokuyo(d) : ''), se: TX(opt.se ? KOYO.sekki(d) : ''), mo: opt.mo ? KOYO.moon(d) : '', kyu: (opt.ky ? KOYO.kyureki(d) : '').replace('閏', PLANG === 'ja' ? '閏' : 'L'), ev: PLANG !== 'ja' && ev ? ev.split('・').map(TX).join(' / ') : ev };
}
// 新月＝ぬった丸、満月＝ふちの丸
function moonMark(cx, cy, r, kind) {
  if (!kind) return '';
  return kind === '朔'
    ? `<circle class="ink" fill="${INK_C}" cx="${nf(cx)}" cy="${nf(cy)}" r="${r}" data-moon="new"/>`
    : `<circle fill="none" stroke="${INK_C}" stroke-width=".25" cx="${nf(cx)}" cy="${nf(cy)}" r="${r}" data-moon="full"/>`;
}

// ===== 日本の行事（日にちが決まるものだけ）=====
const EVENTS_FIXED = new Map([
  ['1-7', '七草'], ['1-11', '鏡開き'], ['1-15', '小正月'], ['2-14', 'バレンタイン'], ['3-3', 'ひなまつり'], ['3-14', 'ホワイトデー'],
  ['4-8', '花まつり'], ['5-5', '端午の節句'], ['7-7', '七夕'], ['8-13', 'お盆入り'], ['8-16', 'お盆明け'], ['9-9', '重陽'],
  ['10-31', 'ハロウィン'], ['11-15', '七五三'], ['12-24', 'クリスマスイブ'], ['12-25', 'クリスマス'], ['12-31', '大晦日'],
]);
// 先生行事・保育園行事：月ごとの「おもな行事」（日は学校・園ごとにちがうので、一覧と ( / ) の欄だけ）
//   ★ベネッセ教育情報・自治体の年間行事予定表・ほいくis・保育士バンク などの 年間行事のまとめを参考に、ふつうにあるものだけ（みなとさんに見てもらう）
//   ★保育園の 誕生会・避難訓練 は毎月ある
const PLAN_SCHOOL = [
  ['始業式', '書き初め', '避難訓練'],                         // 1月
  ['学校公開', 'なわとび大会', '入学説明会'],                  // 2月
  ['6年生を送る会', '卒業式', '修了式'],                       // 3月
  ['始業式', '入学式', '身体測定', '家庭訪問', '避難訓練'],     // 4月
  ['遠足', '運動会', '健康診断'],                              // 5月
  ['プール開き', '歯科検診', '学校公開'],                      // 6月
  ['個人面談', '終業式'],                                      // 7月
  ['夏休み', '登校日'],                                        // 8月
  ['始業式', '避難訓練', '運動会'],                            // 9月
  ['遠足', '就学時健診', '音楽会'],                            // 10月
  ['学習発表会', '社会科見学', '持久走大会'],                  // 11月
  ['個人面談', '大掃除', '終業式'],                            // 12月
];
const PLAN_NURSERY_EVERY = ['誕生会', '避難訓練'];
const PLAN_NURSERY = [
  ['お正月あそび', '鏡開き'],                                  // 1月
  ['豆まき', '保育参観'],                                      // 2月
  ['ひなまつり会', 'お別れ会', '卒園式'],                      // 3月
  ['入園式', '進級', '健康診断', '保護者会'],                  // 4月
  ['こどもの日の会', '親子遠足'],                              // 5月
  ['歯科検診', '保育参観'],                                    // 6月
  ['七夕まつり', 'プール開き', '夏まつり'],                    // 7月
  ['水あそび', 'すいか割り'],                                  // 8月
  ['敬老の会', 'お月見会'],                                    // 9月
  ['運動会', 'いも掘り', 'ハロウィン'],                        // 10月
  ['作品展', '健康診断', '七五三'],                            // 11月
  ['生活発表会', 'クリスマス会', 'もちつき'],                  // 12月
];
// その月の一覧：[['学校', [...]], ['園', [...]]]（えらんだものだけ）
const planLists = (m, ev) => [
  ev & 2 && ['学校', PLAN_SCHOOL[m - 1], 'school'],
  ev & 4 && ['園', [...PLAN_NURSERY[m - 1], ...PLAN_NURSERY_EVERY], 'nursery'],
].filter(Boolean);
// 一覧を描く：［学校］始業式 ( / )　入学式 ( / ) …（はばが足りなければ次の行。行が足りなければ入れない）
//   ★ならべた一覧なので「サイズ」で大きさはかえない（data-noscale）
function planList(m, ev, x0, x1, y0, lh, lines) {
  const S = 1.8, P = 7.2;   // P＝( / ) のはば（日にちを書く）
  let o = '', x = x0, line = 0;
  const put = w => {
    if (x + w > x1 && x > x0) { x = x0; line++; }
    return line < lines;
  };
  planLists(m, ev).forEach(([tag, items, kind]) => {
    const label = PLANG === 'ja' ? `［${tag}］` : `[${TX(tag)}]`, tw = [...label].length * S;   // 日本語 いがいは 半角の かっこ   // 全角のかっこ（「サイズ」でずらしても くずれないように、四角ではなく文字）
    if (x > x0) x += 1.5;
    if (!put(tw + [...items[0]].length * S + P)) return;
    o += svgText(x, y0 + lh * line, S, label, ` font-weight="800" data-plan-tag="${kind}" data-noscale="1"`);
    x += tw + .4;
    items.forEach(it0 => {
      const it = TX(it0);   // ★v0.2.161
      const w = [...it].length * S + P;
      if (!put(w)) return;
      const yy = y0 + lh * line;
      o += svgText(x, yy, S, it, ` data-plan="${kind}" data-noscale="1"`);
      const px = x + [...it].length * S + .6;
      o += svgText(px, yy, S, '(', ' data-noscale="1"') + svgText(px + 2.9, yy, S, '/', ' data-noscale="1"') + svgText(px + 5.8, yy, S, ')', ' data-noscale="1"');
      x += w + 1.2;
    });
  });
  return o;
}
// 月間式の表の下はし（一覧を入れるときは 12mm 上げる）
const monthBot = opt => (opt.ev & 6 ? 208 : 220);
// 下にメモを入れるときの、マス目の下はし（M2 と オーダーメイドで 同じ）
const monthGB = (TOP, BOT) => Math.round(TOP + (BOT - TOP) * .64);

// その日の行事（いくつかあるときは「・」でつなぐ）。hol＝祝日を入れるとき（こどもの日と同じ日の 端午の節句 は入れない）
function eventOf(d, hol) {
  const m = d.getMonth() + 1, dd = d.getDate(), sun = d.getDay() === 0;
  const list = [];
  const f = EVENTS_FIXED.get(`${m}-${dd}`);
  if (f && !(hol && f === '端午の節句')) list.push(f);
  if (sun && m === 5 && dd >= 8 && dd <= 14) list.push('母の日');     // 5月の第2日曜
  if (sun && m === 6 && dd >= 15 && dd <= 21) list.push('父の日');    // 6月の第3日曜
  list.push(...KOYO.zassetsu(d));
  const l = KOYO.lunar(d.getFullYear(), m, dd);
  if (l && !l.leap && l.month === 8 && l.day === 15) list.push('十五夜');
  if (l && !l.leap && l.month === 9 && l.day === 13) list.push('十三夜');
  return list.join('・');
}
// 二十四節気と行事（同じ日なら ならべる）。行事がないときは これまでと同じ1つの文字
//   ★どちらも全角の文字だけなので、はば＝文字の数×大きさ で よせる
//   ★maxW（入る場所のはば）をこえるとき（行事が2つ重なった日など）は、textLength で はばをちぢめる
function seEv(x, y, size, se, ev, anchor = 'start', maxW = Infinity) {
  if (!ev) return se ? svgText(x, y, size, se, `${anchor === 'start' ? '' : ` text-anchor="${anchor}"`} data-sekki="1"`) : '';
  let w1 = se ? [...se].length * size : 0, w2 = [...ev].length * size, gap = se ? size * .5 : 0;
  const f = Math.min(1, maxW / (w1 + gap + w2));
  w1 *= f; w2 *= f; gap *= f;
  const x0 = anchor === 'middle' ? x - (w1 + gap + w2) / 2 : anchor === 'end' ? x - (w1 + gap + w2) : x;
  const fit = w => (f < 1 ? ` textLength="${nf(w)}" lengthAdjust="spacingAndGlyphs"` : '');
  return (se ? svgText(x0, y, size, se, `${fit(w1)} data-sekki="1"`) : '') + svgText(x0 + w1 + gap, y, size, ev, `${fit(w2)} data-event="1"`);
}

// 旧暦の文字（x・y・大きさ・よせ方は形ごと）
const kyuText = (x, y, size, kyu, anchor = 'end') => (kyu ? svgText(x, y, size, kyu, ` text-anchor="${anchor}" data-kyureki="1"`) : '');

// 小さなカレンダー（紙の下の帯に入れる。はば 34mm）
function miniCal(at, x, top, opt) {
  const ws = opt.ws;
  const w = 34, cw = w / 7, rh = 2.7;
  let o = svgText(x, top + 2.4, 2.6, `${at.y}.${at.m}`, ' font-weight="800"');
  weekOrder(ws).forEach((dw, c) => { o += svgText(x + cw * (c + .5), top + 5.4, 1.7, WDL()[dw], ' text-anchor="middle"' + dowAttr(dw)); });
  o += svgLine(x, top + 6.3, x + w, top + 6.3, .15);
  monthDays(at.y, at.m, ws).forEach((d, i) => {
    if (d.getMonth() !== at.m - 1) return;
    const c = i % 7, r = Math.floor(i / 7);
    const red = d.getDay() === 0 || (opt.hol && holidayName(d));   // 日曜・祝日は太字
    o += svgText(x + cw * (c + .5), top + 8.6 + r * rh, 1.9, d.getDate(), ` text-anchor="middle"${red ? ' font-weight="800"' : ''}${dowAttr(red ? 0 : d.getDay())}`);
  });
  return o;
}
// 紙の下の帯（左は印刷のQRカード、右下は名入れが入るので、そのあいだ）
const MINI_TOP = 224;
function miniRow(fmt, at, opt) {
  const plan = opt.ev & 6;
  let o = '';
  if (plan && fmt.unit === 'month') o += planList(at.m, opt.ev, 16, 174, 212.4, 4, 2);   // 月間式：表の下
  if (plan && fmt.unit !== 'month') o += planList(at.m, opt.ev, 76, 134, 226.4, 3.8, 5);   // 週の形：右下のカレンダーの左
  if (opt.cal === false) return o;   // 表示パネルで「出さない」
  // カレンダーの 場所（v0.2.93）：0 右下（ふつう）・1 左下・2 右上・3 下のまんなか
  const POS = opt.calPos || 0;
  // 週の形で一覧を入れるときは、カレンダーは いまの月の1つだけ
  const keys = plan && fmt.unit !== 'month' ? fmt.mini.slice(0, 1) : fmt.mini;
  const list = keys.map(k => addMonth(at.y, at.m, k === 'prev' ? -1 : k === 'next' ? 1 : k === 'next2' ? 2 : 0));
  // ★v0.2.107 3か月（当月から 翌々月まで）も ならべられる
  const XS = {
    0: [[138], [100, 138], [62, 100, 138]][list.length - 1],
    1: [[16], [16, 54], [16, 54, 92]][list.length - 1],
    2: [[138], [100, 138], [62, 100, 138]][list.length - 1],
    3: [[74], [56, 94], [38, 74, 110]][list.length - 1],
  }[POS];
  const TOPY = POS === 2 ? 2 : MINI_TOP;
  return o + list.map((a, i) => miniCal(a, XS[i], TOPY, opt)).join('');
}

// ----- 月のマス目（7列×6段）。M1・M2 でつかう -----
//   cfg（オーダーメイド）：rows＝段の数（5のときは6段めの日を5段めのマスの右下に入れる）、lines＝マスの中の点線の数
//   ★マスのはばが 14mm より細いとき（右にメモを入れたときなど）は、月のしるし・旧暦・祝日を1段ずつ下げる
function monthGrid(at, opt, X1, X2, TOP, BOT, cfg = {}) {
  //   cfg.headH＝曜日の 帯の 高さ（0＝帯なし）、cfg.dow＝曜日の 名前（0 英語・1 日本語・2 なし）、cfg.dateR＝日付の 丸の 大きさ
  //   cfg.band＝週の 行の 下に つける メモの 帯の 高さ（mm・アイダにメモ）、cfg.task＝マスを 予定／やること に 分ける（月間タスク）
  //   v0.2.89：cfg.weekNo＝左はしに 週の番号／cfg.leftCol＝左はしの 列（1 メモ・2 やること□・3 1〜31）／cfg.rightCol＝右はしの NOTES 列／cfg.dayNo＝日付の となりに「その年の 何日め」
  //   v0.2.90：cfg.wide＝はばの かえ方（0 均等・1 週末を 大きく・2 平日を 大きく）／cfg.noDate＝日付を 入れない（フリー）
  //            cfg.topMemo＝マスの 上に うすい メモ線／cfg.checks＝マスの すみに チェックの □／cfg.wkTint＝土日の マスに うすい 色の 帯
  //   cfg.wkHalf＝土日を 1つの 列に まとめて、上下 半分ずつに する（平日が 広くなる）
  // 左右に つける 列（週の番号・メモ・NOTES）の ぶんだけ マス目を せまくする（v0.2.89）
  const WKW = cfg.weekNo ? 9 : 0, LCW = cfg.leftCol ? 24 : 0, RCW = cfg.rightCol ? 24 : 0;
  const GX1 = X1 + WKW + LCW, GX2 = X2 - RCW;
  const OX1 = X1, OX2 = X2;   // もとの はば（左右の 列を 描くのに つかう）
  X1 = GX1; X2 = GX2;
  const ws = opt.ws, HEAD = cfg.headH == null ? 6 : cfg.headH, rows = cfg.wkHalf ? 6 : (cfg.rows || 6);
  const WH = !!cfg.wkHalf, cols = WH ? 6 : 7;
  // 列の はば：均等／週末を 大きく／平日を 大きく（v0.2.90）
  const wide = WH ? 0 : (cfg.wide || 0);
  const wOf = dw => (wide === 1 ? (dw === 0 || dw === 6 ? 1.45 : .82) : wide === 2 ? (dw === 0 || dw === 6 ? .7 : 1.12) : 1);
  const order0 = [0, 1, 2, 3, 4, 5, 6].map(i => (i + (opt.ws)) % 7);
  const wSum = order0.reduce((a, dw) => a + wOf(dw), 0);
  const cwUnit = (X2 - X1) / (wide ? wSum : cols);
  const colX = [];   // 列の 左はしの 場所（はばが ちがうとき）
  { let acc = X1; order0.forEach(dw => { colX.push(acc); acc += cwUnit * (wide ? wOf(dw) : 1); }); colX.push(X2); }
  const cwAt = k => (wide ? colX[k + 1] - colX[k] : (X2 - X1) / cols);
  const cw = (X2 - X1) / cols, rh = (BOT - TOP - HEAD) / rows, narrow = cw < 14;
  const wkCol = ws === 1 ? 5 : 0;   // 土日の 列（月曜はじまりは 右はし・日曜はじまりは 左はし）
  // その日が どの マスに 入るか（土日ハーフのとき）
  const cellAt = (dw, k, r) => {
    const y0 = TOP + HEAD + rh * r;
    if (!WH) return { x: wide ? colX[k] : X1 + cw * k, y: y0, w: cwAt(k), h: rh };
    const half = ws === 1 ? (dw === 6 ? 0 : dw === 0 ? 1 : -1) : (dw === 0 ? 0 : dw === 6 ? 1 : -1);
    if (half < 0) return { x: X1 + cw * (ws === 1 ? k : k), y: y0, w: cw, h: rh };
    return { x: X1 + cw * wkCol, y: y0 + rh / 2 * half, w: cw, h: rh / 2 };
  };
  const band = cfg.band || 0, dh = rh - band;   // dh＝日を 書く ところの 高さ（帯を のぞく）
  let o = '';
  // 曜日の行（cfg.dow＝2 なら 名前を 書かない・HEAD＝0 なら 帯じたい なし）
  if (HEAD > 0 && cfg.dow !== 2) weekOrder(ws).forEach((dw, c) => {
    const ja = cfg.dow === 1;
    const name = ja ? WDL()[dw] : WD_EN[dw];
    if (WH && (dw === 0 || dw === 6)) {
      // 土日ハーフ：1つの 列に 2つの 名前を 上下に
      const top = ws === 1 ? dw === 6 : dw === 0;
      o += svgText(X1 + cw * (wkCol + .5), TOP + (top ? HEAD / 2 - .4 : HEAD - .8), 1.8, name, ' text-anchor="middle" font-weight="700"' + dowAttr(dw));
      return;
    }
    o += svgText((wide ? colX[c] + cwAt(c) / 2 : X1 + cw * (c + .5)), TOP + Math.min(HEAD - 1.4, 4.1), ja ? 2.2 : 2.5, name, ' text-anchor="middle" font-weight="700" letter-spacing=".3"' + dowAttr(dw));
  });
  // わく・線（土日も平日と同じはば）
  o += `<rect x="${X1}" y="${TOP}" width="${nf(X2 - X1)}" height="${nf(BOT - TOP)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  if (HEAD > 0) o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  // 土日の マスに うすい 色の 帯（v0.2.90。印刷にも 出る うすい ぬり）
  if (cfg.wkTint && !WH) order0.forEach((dw, k) => {
    if (dw !== 0 && dw !== 6) return;
    o += `<rect class="line" x="${nf(wide ? colX[k] : X1 + cw * k)}" y="${nf(TOP + HEAD)}" width="${nf(cwAt(k))}" height="${nf(BOT - TOP - HEAD)}" fill="${INK_C}" opacity=".07" data-wktint="1"/>`;
  });
  // たての線：メモの帯（アイダにメモ）が あるときは、帯の 手前で 止める
  for (let c = 1; c < cols; c++) {
    const lx = wide ? colX[c] : X1 + cw * c;
    if (!band) o += svgLine(lx, TOP, lx, BOT, .2);
    else {
      o += svgLine(lx, TOP, lx, TOP + HEAD, .2);
      for (let r = 0; r < rows; r++) o += svgLine(lx, TOP + HEAD + rh * r, lx, TOP + HEAD + rh * r + dh, .2);
    }
  }
  for (let r = 1; r < rows; r++) o += svgLine(X1, TOP + HEAD + rh * r, X2, TOP + HEAD + rh * r, .2);
  // メモの帯（アイダにメモ）：日の ところと 帯の あいだに うすい線
  if (band) for (let r = 0; r < rows; r++) o += svgLine(X1, TOP + HEAD + rh * r + dh, X2, TOP + HEAD + rh * r + dh, .15, ' data-band="1"');
  // 土日ハーフ：土日の 列だけ 段の まん中に 線（曜日の 帯の 中にも）
  if (WH) {
    const wx = X1 + cw * wkCol;
    if (HEAD > 0) o += svgLine(wx, TOP + HEAD / 2, wx + cw, TOP + HEAD / 2, .12, ' data-half="1"');
    for (let r = 0; r < rows; r++) o += svgLine(wx, TOP + HEAD + rh * r + rh / 2, wx + cw, TOP + HEAD + rh * r + rh / 2, .2, ' data-half="1"');
  }
  // マスの中の書く線（点線。マスごと。5段で右下に日を入れたマスは、その日の手前でとめる）
  const top0 = narrow ? 15 : 14;
  const days = monthDays(at.y, at.m, ws);
  // マスの中を メモと 同じ 線（方眼・ドットなど）に する（v0.2.93）
  if (cfg.cellMemo && cfg.cellMemo.type && !WH) {
    const days1 = days;
    for (let r = 0; r < rows; r++) for (let c = 0; c < 7; c++) {
      const x = (wide ? colX[c] : X1 + cw * c), y = TOP + HEAD + rh * r, w2 = cwAt(c);
      const merged = rows < 6 && r === rows - 1 && days1[35 + c].getMonth() === at.m - 1;
      const hh = dh - top0 - .6 - (merged ? 8 : 0);
      // ★マスの中の線は、メモ欄と 見分けが つくように 目じるしを かえる
      if (hh > 2) o += memoBox(x + .6, y + top0, w2 - 1.2, hh, cfg.cellMemo).replace(/data-memo-type=/g, 'data-cellmemo-type=');
    }
  }
  // ★土日ハーフのときは マスの 高さが 2とおり あるので、中の線は 引かない（はみ出さないように）
  if (cfg.lines && !WH && dh - top0 > 3) {
    for (let r = 0; r < rows; r++) for (let c = 0; c < 7; c++) {
      const x = X1 + cw * c, y = TOP + HEAD + rh * r;
      const merged = rows < 6 && r === rows - 1 && days[35 + c].getMonth() === at.m - 1;
      for (let j = 0; j < cfg.lines; j++) {
        const yy = y + top0 + (dh - top0 - 1.5) * j / Math.max(1, cfg.lines - 1);
        o += svgLine(x + .8, yy, x + cw - (merged && yy > y + rh - 9.5 ? 10 : .8), yy, .12, ' stroke-dasharray=".4 .8" data-cell-line="1"');
      }
    }
  }
  // 月間タスク：マスの 下半分を「やること」に（点線＋□）
  if (cfg.task && !WH) for (let r = 0; r < rows; r++) for (let c = 0; c < 7; c++) {
    const x = X1 + cw * c, y = TOP + HEAD + rh * r, ty = y + dh * .55;
    o += svgLine(x + .8, ty, x + cw - .8, ty, .12, ' stroke-dasharray=".6 .8" data-task="1"');
    for (let k = 0; k < 2; k++) {
      const by = ty + 2 + k * 3.4;
      if (by + 2.4 > y + dh - .6) break;
      o += `<rect x="${nf(x + 1.4)}" y="${nf(by)}" width="2.2" height="2.2" rx=".3" fill="none" stroke="${INK_C}" stroke-width=".15" data-todo="1"/>`;
      o += svgLine(x + 4.2, by + 2.2, x + cw - 1.2, by + 2.2, .12, ' stroke-dasharray=".4 .8" data-task="1"');
    }
  }
  // 週の番号・左の列・右の列（v0.2.89）
  if (WKW) {
    const days0 = monthDays(at.y, at.m, ws);
    for (let r = 0; r < rows; r++) {
      const d0 = days0[r * 7];
      const wk = isoWeek(d0);
      o += svgText(OX1 + WKW / 2, TOP + HEAD + rh * r + 3.4, 1.5, 'W' + wk, ' text-anchor="middle" data-weekno="1"');
    }
    o += svgLine(OX1 + WKW, TOP, OX1 + WKW, BOT, .15);
  }
  if (LCW) {
    const lx = OX1 + WKW;
    o += sideCol(lx, TOP, LCW, BOT - TOP, HEAD, cfg.leftCol, cfg.memo, at, null, opt);
    o += svgLine(lx + LCW, TOP, lx + LCW, BOT, .2);
  }
  if (RCW) {
    o += sideCol(GX2, TOP, RCW, BOT - TOP, HEAD, 1, cfg.memo, at, 'NOTES', opt);
    o += svgLine(GX2, TOP, GX2, BOT, .2);
  }
  // マスの 中身（日付・暦・祝日）。はばと 高さを もらう（土日ハーフでも つかう・v0.2.88）
  const cellBody = (d, x, y, w, h, faded) => {
    let t = '';
    /* ★v0.2.120 えにっきの 絵は いちばん 下（＝日付も 暦も 線も 絵の 上に 出る）
       ★v0.2.122 **正方形**。マスの はば いっぱい・下の線に ぴったり。
          正方形なので 上が あき、そこに 日付・六曜・祝日が 出ます。
          マスが 横長の ときは（高さの ほうが みじかい ので）高さに あわせます。 */
    if (cfg.enikki && !faded && !cfg.noDate) {
      const side = Math.min(w * ENIKKI_FIT, h - ENIKKI_GAP);   // 正方形の 1辺
      const ex = x + (w - side) / 2;                            // よこは まん中（はばいっぱいなら 左はし）
      const ey = y + h - side - ENIKKI_GAP;                     // たては 下づけ
      if (side > 2) t += `<rect data-enikki="${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}" x="${nf(ex)}" y="${nf(ey)}" width="${nf(side)}" height="${nf(side)}" fill="none" stroke="none"/>`;
    }
    // マスの 上の うすい メモ線（予定欄の 上に 1本・v0.2.90）
    if (cfg.topMemo) t += svgLine(x + .8, y + 3.2, x + w - .8, y + 3.2, .1, ' stroke-dasharray=".5 1" data-topmemo="1"');
    // マスの すみの チェックの □（2つ・v0.2.90）
    if (cfg.checks && !faded) for (let k = 0; k < 2; k++) {
      t += `<rect x="${nf(x + w - 3.2 - k * 3)}" y="${nf(y + h - 3.2)}" width="2.2" height="2.2" rx=".3" fill="none" stroke="${INK_C}" stroke-width=".15" data-daycheck="1"/>`;
    }
    // ★v0.2.107 マスの中の 時計（12時間の 文字ばん。ねた時間・はたらいた時間を 色で ぬる）
    if (cfg.clock && !faded && w > 13 && h > 13) t += clockFace(x + w - 4.4 - (cfg.checks ? 6.4 : 0), y + h - 4.6, 3.4);
    if (cfg.noDate) return t;   // 日付なし（フリー）
    const DR = cfg.dateR || 2.4;
    t += dayNum(x + 1.2 + DR, y + 1.2 + DR, DR, nf(3.2 * DR / 2.4), d, faded, opt);
    // 日付の となりに「その年の 何日め－のこり」（クオバディスの 作り・v0.2.89）
    if (cfg.dayNo && !faded && w > 16) {
      const n = Math.round((d - new Date(d.getFullYear(), 0, 1)) / 86400000) + 1;
      const left = (new Date(d.getFullYear(), 11, 31) - d) / 86400000;
      t += svgText(x + w - 1, y + 3.4, 1.4, `${n}-${Math.round(left)}`, ' text-anchor="end" data-dayno="1"');
    }
    const ky = koyoOf(d, opt, faded);
    const hn = opt.hol && !faded && holidayName(d);
    if (w < 14) {
      t += moonMark(x + 1.8, y + 7.4, .8, ky.mo);
      if (ky.ro) t += svgText(x + w - 1, y + 4.2, 1.5, ky.ro, ' text-anchor="end" data-rokuyo="1"');
      t += kyuText(x + w - 1, y + 7.9, 1.4, ky.kyu);
      if (hn) t += svgText(x + 1, y + 10.6, 1.7, hn, ` data-holiday="1"${[...hn].length * 1.7 > w - 2 ? ` textLength="${nf(w - 2)}" lengthAdjust="spacingAndGlyphs"` : ''}`);
      t += seEv(x + 1, y + (hn ? 13.2 : 10.6), 1.6, ky.se, ky.ev, 'start', w - 2);
      return t;
    }
    t += moonMark(x + 7.4, y + 3.6, 1, ky.mo);
    if (ky.ro) t += svgText(x + w - 1.2, y + 4.2, 1.7, ky.ro, ' text-anchor="end" data-rokuyo="1"');
    t += kyuText(x + w - 1.2, y + 6.5, 1.5, ky.kyu);
    if (hn) t += svgText(x + 1.4, y + 9, 2, hn, ' data-holiday="1"');
    t += seEv(x + 1.4, y + (hn ? 11.8 : 9), 1.8, ky.se, ky.ev, 'start', w - 2.4);
    return t;
  };
  // 日付（前後の月の日はうすく）
  days.forEach((d, i) => {
    const c = i % 7, r = Math.floor(i / 7);
    const faded = d.getMonth() !== at.m - 1;
    if (r >= rows) {
      // 5段のとき：6段めの（その月の）日は、5段めのマスの右下に ななめ線で分けて入れる
      if (faded) return;
      const x = X1 + cw * c, y = TOP + HEAD + rh * (rows - 1);
      o += svgLine(x + cw - 9, y + rh - .3, x + cw - .3, y + rh - 9, .15, ' data-merge="1"');
      if (opt.today && sameDay(d, TODAY)) o += todayRect(x + cw - 6.2, y + rh - 6.2, 5.6, 5.6);
      o += dayNum(x + cw - 3.4, y + rh - 3.4, 2.2, 3.2, d, false, opt);
      return;
    }
    const cell = cellAt(d.getDay(), c, r);
    if (opt.today && !faded && sameDay(d, TODAY)) o += todayRect(cell.x + .8, cell.y + .8, cell.w - 1.6, cell.h - 1.6);
    o += cellBody(d, cell.x, cell.y, cell.w, WH ? cell.h : dh, faded);
  });
  return o;
}

// 週の番号（ISO 8601：木曜が 入る 週の 番号）
function isoWeek(d) {
  const t = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7));
  const first = new Date(t.getFullYear(), 0, 4);
  return 1 + Math.round(((t - first) / 86400000 - 3 + ((first.getDay() + 6) % 7)) / 7);
}
// 左や 右に つける 細い列（1 メモ・2 やること□・3 1〜31）。見出しの 帯の 下から 書く
function sideCol(x, y, w, h, head, kind, memo, at, title, opt = {}) {
  let o = '';
  const name = title || ['', 'MEMO', 'TO DO', ''][kind] || '';
  if (head > 0 && name) o += svgText(x + w / 2, y + Math.min(head - 1.4, 4.1), 1.9, name, ' text-anchor="middle" font-weight="700" letter-spacing=".3" data-sidecol="1"');
  const top = y + head, bh = h - head;
  if (kind === 3) {
    // 1〜31 の たてリスト（その月の 日だけ）。曜日も 入れて、土曜・日曜・祝日は 色を かえる（v0.2.93）
    const last = new Date(at.y, at.m, 0).getDate();
    const rh2 = bh / 31;
    for (let i = 0; i < last; i++) {
      const yy = top + rh2 * i, d = new Date(at.y, at.m - 1, i + 1);
      const hol = opt.hol && holidayName(d);
      const mark = hol ? ' data-dow="0"' : dowAttr(d.getDay());   // 祝日は 色だけ（日曜と 同じ）
      // ★v0.2.109 みなとさん：土日・祝日が ひと目で わかるように、うすい 帯＋太字
      const rest = d.getDay() === 0 || d.getDay() === 6 || !!hol;
      if (rest) o += `<rect class="line" x="${nf(x)}" y="${nf(yy)}" width="${nf(w)}" height="${nf(rh2)}" fill="${INK_C}" opacity=".08" data-sidetint="1"/>`;
      const bold = rest ? ' font-weight="800"' : '';
      o += svgText(x + 1.2, yy + rh2 - .8, 1.5, i + 1, ' data-sideday="1"' + bold + mark);
      o += svgText(x + 5.4, yy + rh2 - .8, 1.3, WDL()[d.getDay()], ' data-sidedow="1"' + bold + mark);
      o += svgLine(x + 8, yy + rh2 - .5, x + w - 1, yy + rh2 - .5, .1);
    }
    return o;
  }
  if (kind === 2) {
    // やること：□つきの 行
    const n = Math.max(1, Math.floor(bh / 5.2));
    for (let i = 0; i < n; i++) {
      const yy = top + 3 + 5.2 * i;
      if (yy + 2.4 > y + h) break;
      o += `<rect x="${nf(x + 1.4)}" y="${nf(yy)}" width="2.2" height="2.2" rx=".3" fill="none" stroke="${INK_C}" stroke-width=".15" data-todo="1"/>`;
      o += svgLine(x + 4.4, yy + 2.2, x + w - 1, yy + 2.2, .1);
    }
    return o;
  }
  // メモ：えらんだ 線（方眼・ドットなど）
  return o + memoBox(x + .8, top + 1, w - 1.6, bh - 2, memo || MEMO_DEF);
}

// ----- M1 月間式（月間ブロック・7列×6段）-----
function drawMonthly(at, fmt, opt) {
  return monthHead(at) + monthGrid(at, opt, 16, 174, 30, monthBot(opt), { enikki: opt.enikki }) + miniRow(fmt, at, opt);
}

// 1か月（または 半月）ぶんの たてリスト。x・y・はば・高さを もらって 書く（v0.2.91）
//   from〜to の 日だけ（前半・後半に 分けるときに つかう）。cfg.tide＝右はしに 潮の らん
function dayListBlock(at, opt, x, y, w, h, from, to, cfg = {}) {
  const n = to - from + 1, rh = h / n, LW = cfg.dateW || 15, TW = cfg.tide ? 8 : 0;
  let o = `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(x + LW, y, x + LW, y + h, .25);
  if (TW) o += svgLine(x + w - TW, y, x + w - TW, y + h, .25);
  for (let i = 0; i < n; i++) {
    const d = new Date(at.y, at.m - 1, from + i), yy = y + rh * i, cy = yy + rh / 2;
    if (i > 0) o += svgLine(x, yy, x + w, yy, d.getDay() === opt.ws ? .25 : .1);
    o += dayNum(x + 3.2, cy, 2, 2.6, d, false, opt);
    o += svgText(x + 7.4, cy + .8, 1.9, WDL()[d.getDay()], ' font-weight="700"' + dowAttr(d.getDay()));
    const ky = koyoOf(d, opt, false);
    if (ky.ro) o += svgText(x + LW - 1, cy + .6, 1.4, ky.ro, ' text-anchor="end" data-rokuyo="1"');
    o += moonMark(x + 11.4, cy, .8, ky.mo);
    const hn = opt.hol && holidayName(d);
    if (hn) o += svgText(x + LW + 1.2, cy + .6, 1.6, hn, ' data-holiday="1"');
    o += seEv(x + LW + 1.2, cy + (hn ? 2.6 : .6), 1.5, ky.se, ky.ev, 'start', w - LW - TW - 2);
    if (cfg.lines) for (let k = 1; k <= cfg.lines; k++) o += svgLine(x + LW + .8, yy + rh * k / (cfg.lines + 1), x + w - TW - .8, yy + rh * k / (cfg.lines + 1), .08, ' stroke-dasharray=".4 .8" data-cell-line="1"');
  }
  return o;
}
// 下に つける「月間プラン」の 表（1〜31 の 列・行は 6本。お手本：サジェス）
function planTable(at, opt, x, y, w, h, rows = 5) {
  const last = new Date(at.y, at.m, 0).getDate(), LW = 16, cw = (w - LW) / last;
  let o = `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgText(x + 1.2, y + 4, 1.8, at.m + TEXTS_MONTH_UNIT, ' font-weight="700" data-plantable="1"');
  o += svgLine(x + LW, y, x + LW, y + h, .25);
  o += svgLine(x, y + 5.4, x + w, y + 5.4, .25);
  for (let i = 0; i < last; i++) {
    const d = new Date(at.y, at.m - 1, i + 1), cx = x + LW + cw * i;
    if (i > 0) o += svgLine(cx, y, cx, y + h, .1);
    o += svgText(cx + cw / 2, y + 2.6, 1.5, i + 1, ' text-anchor="middle" data-ptday="1"' + dowAttr(d.getDay()));
    o += svgText(cx + cw / 2, y + 4.8, 1.2, WDL()[d.getDay()], ' text-anchor="middle"' + dowAttr(d.getDay()));
  }
  const rh = (h - 5.4) / rows;
  for (let r = 1; r < rows; r++) o += svgLine(x, y + 5.4 + rh * r, x + w, y + 5.4 + rh * r, .1);
  return o;
}

// ----- v0.2.103 できあいの 週間セパレート（本の 手帳に よく ある 形）-----
function sepPreset(at, fmt, opt, cfg, extra) { return drawWeeklySeparate(at, fmt, opt, { ...extra, ...cfg }); }
function drawSepCross(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { cross: true, lines: 4 }); }        // 日付の となりに 十字（仕事／私／午前／午後）
function drawSepTime(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { time: [8, 22], lines: 3 }); }       // 上に 横の 時間めもり
function drawSepCols(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { memoCols: true, lines: 4 }); }      // 右はしに たてメモ 2列
function drawSepBottom(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { bottomMemo: 46, memo: false, lines: 3 }); }   // 下 1/3 が メモ
function drawSepGrid(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { gridBase: 4, lines: 0 }); }         // 方眼ベース
function drawSep34(at, fmt, opt, cfg = {}) { return sepPreset(at, fmt, opt, cfg, { top: 3, lines: 4 }); }                // 3日＋4日（上下の 分け方ちがい）

// ----- v0.2.101 できあいの 週間バーティカル（本の 手帳に よく ある 形。形を変えなくても そのまま つかえる）-----
//   ★もとは「週間バーティカル式（はばいっぱい）」と 同じ 作り。ちがう ところだけ 足している
function vertPreset(at, fmt, opt, cfg, extra) {
  return verticalWeek(at, fmt, opt, { hours: [7, 24], memo: 0, night: [], ...extra, ...cfg });
}
function drawVert30(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 22], noon: true }); }            // 30分の点線＋お昼の帯
function drawVertPlanDo(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 22], split: 2 }); }          // 予定と 実際
function drawVertTopBot(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 21], dayTop: 8, dayBottom: 16 }); }   // 上に 今日のいちばん・下に やったこと
function drawVertCheck(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 21], checks: 4 }); }          // やること □つき
function drawVertBlocks(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { blocks: [8, 12, 15, 18, 21] }); }       // 5ブロック
function drawVertGrid(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 22], gridBase: 4, half: false }); }   // 方眼ベース
function drawVertWeekday(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [8, 22], smallWeekend: true, bold: [12, 18] }); }   // 平日 重視＋12/18時を太く
function drawVertMorning(at, fmt, opt, cfg = {}) { return vertPreset(at, fmt, opt, cfg, { hours: [6, 20], noon: true }); }        // 朝がた

// ----- v0.2.99 できあいの 週間レフト式（お手本の 手帳に よく ある 形。形を変えなくても そのまま えらべる）-----
//   W12 時間めもり（1時間ごと）／W13 時間の 点（9・12・3・6）／W14 上下2段（午前・午後）
//   W15 左右3分割／W16 変則レフト（日曜だけ 右下）／W17 右がわ 7段
//   ★FORMATS より 先に よばれるので function で 書く（const だと まだ ない と 言われる）
// ★わりあいは ひな形（もとの形）と 同じ 5:5
function leftPreset(at, fmt, opt, cfg, extra) { return leftWeek(at, fmt, opt, { ratio: .5, right: MEMO_DEF, lines: 3, ...extra, ...cfg }); }
//   ★写真の 手帳から、よく ある 組み合わせを そのまま 入れた（形を 変えなくても つかえるように・v0.2.102）
function drawLeftWeekday(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { small: true, tint: true }); }            // 平日 重視（土日 小さく＋土日祝に 色）
function drawLeftDots(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { dots: [9, 12, 15, 18], dowBoth: true }); } // 時間の 目やすの 点＋曜日 英漢
function drawLeftHalf(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { split: 1, tint: true }); }                 // 午前・午後の 2段＋土日祝に 色
function drawLeftThird(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { split: 2 }); }                            // 左右 3分割
function drawLeftSunRight(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { sunRight: true, dateCol: true }); }    // 日曜だけ 右下＋右はしに 当月の 日づけ
function drawLeftRows7(at, fmt, opt, cfg = {}) { return leftPreset(at, fmt, opt, cfg, { rightRows: true, dowBoth: true }); }      // 右を 7段に（曜日ごとの 記録）

// ----- Y6 月ごとの 目標と ふりかえり（12か月 × 目標／ふりかえり）。お手本：Bindex 目標管理表・高橋 -----
function drawYearReview(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12;
  const { X1, X2, TOP } = PG, BOT = cfg.memo ? 190 : 222, LW = 22, MID = X1 + LW + (X2 - X1 - LW) / 2;
  let o = yearHead(at, 'GOAL / REVIEW', n);   // ★SVG では & は つかえない
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  const HEAD = 6.5, rh = (BOT - TOP - HEAD) / n;
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  o += svgLine(X1 + LW, TOP, X1 + LW, BOT, .3);
  o += svgLine(MID, TOP, MID, BOT, .25);
  o += svgText((X1 + LW + MID) / 2, TOP + 4.4, 2.2, L(TEXTS_YR_GOAL, 'GOALS'), ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  o += svgText((MID + X2) / 2, TOP + 4.4, 2.2, L(TEXTS_YR_REVIEW, 'REVIEW'), ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  for (let i = 0; i < n; i++) {
    const a = addMonth(at.y, at.m, i), y = TOP + HEAD + rh * i;
    if (i > 0) o += svgLine(X1, y, X2, y, a.m === 1 ? .3 : .15);
    o += boxMonthHead(X1 + 2.4, y + rh / 2 + 1.6, i, a, 'data-yreview="1"');
  }
  if (cfg.memo) { o += svgText(X1, BOT + 6.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"'); o += memoBox(X1, BOT + 8.4, X2 - X1, 222 - BOT - 8.4, cfg.memoSpec); }
  return o;
}
// ----- Y7 記念日・誕生日リスト（12か月の 箱）。お手本：高橋・能率の おつきあい帳 -----
function drawAnniversary(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, rows = n / 3;
  const BOT = cfg.memo ? 176 : 222;
  let o = yearHead(at, 'ANNIVERSARY', n);
  for (let k = 0; k < n; k++) {
    const a = addMonth(at.y, at.m, k);
    const { x, y, w, h } = yearBox(k, 30, BOT, 4, rows);
    o += `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    o += boxMonthHead(x + 2.5, y + 6.6, k, a, 'data-yanni="1"');
    o += svgLine(x + 2.5, y + 8.2, x + w - 2.5, y + 8.2, .2);
    const lines = Math.max(1, Math.floor((h - 11) / 5));
    for (let i = 0; i < lines; i++) {
      const ly = y + 13.2 + i * 5;
      if (ly > y + h - 1.5) break;
      o += svgText(x + 3, ly - .6, 1.6, '/', ' data-annidate="1"');
      o += svgLine(x + 8.5, ly, x + w - 2.5, ly, .1, ' stroke-dasharray=".4 .8"');
    }
  }
  if (cfg.memo) { o += svgText(16, BOT + 6.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"'); o += memoBox(16, BOT + 8.4, 158, 222 - BOT - 8.4, cfg.memoSpec); }
  return o;
}
// ----- Y8・Y9 2年／3年の カレンダー（12×2＝24か月・12×3＝36か月を 1まいに）。お手本：Bindex 067・061 -----
function drawYearsCalendar(at, fmt, opt, cfg = {}) {
  const years = cfg.years || 2, n = 12 * years, cols = years === 3 ? 6 : 4, rows = n / cols;
  const { TOP } = PG, BOT = 222, G = 2.4;
  const w = (158 - G * (cols - 1)) / cols, h = (BOT - TOP - G * (rows - 1)) / rows;
  let o = yearHead(at, years === 3 ? '3 YEARS' : '2 YEARS', n);
  for (let k = 0; k < n; k++) {
    const a = addMonth(at.y, at.m, k);
    const x = 16 + (k % cols) * (w + G), y = TOP + Math.floor(k / cols) * (h + G);
    o += `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;   // ★背景の 柄を しくために .35（わく）
    // ★月の 数字の はばを そろえて 年と かさならないように（v0.2.100）
    const mw2 = String(a.m).length === 2 ? 5.6 : 2.8;
    o += svgText(x + 1.6, y + 4.2, 2.8, a.m, ` font-weight="800" textLength="${mw2}" lengthAdjust="spacingAndGlyphs" data-ymulti="1" data-noscale="1"`);
    o += svgText(x + 1.6 + mw2 + 1.4, y + 4.2, 1.6, a.y, ' letter-spacing=".2" data-noscale="1"');
    const cw = (w - 3) / 7, top = y + 6.4, rh2 = (h - 7.6) / 6;
    weekOrder(opt.ws).forEach((dw, c) => { o += svgText(x + 1.5 + cw * (c + .5), top - .6, 1.2, WD_EN[dw].slice(0, 1), ' text-anchor="middle"' + dowAttr(dw)); });
    const off = (new Date(a.y, a.m - 1, 1).getDay() - opt.ws + 7) % 7;
    const last = new Date(a.y, a.m, 0).getDate();
    for (let d = 1; d <= last; d++) {
      const i = off + d - 1, c = i % 7, r = Math.floor(i / 7);
      const day = new Date(a.y, a.m - 1, d);
      const red = day.getDay() === 0 || (opt.hol && holidayName(day));
      o += svgText(x + 1.5 + cw * (c + .5), top + rh2 * (r + .8), 1.6, d, ` text-anchor="middle"${red ? ' font-weight="800"' : ''}${dowAttr(red ? 0 : day.getDay())} data-ymd="1"`);
    }
  }
  return o;
}

// ----- Y4 年間計画表（YEARLY PLAN）：12か月 × こうもく。お手本：Bindex 333・高橋 年間計画表 -----
//   cfg.cols＝こうもくの 数（4〜8）、cfg.memo＝下に メモ
function drawYearPlan(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, cols = cfg.cols || 5;
  const { X1, X2, TOP } = PG, BOT = cfg.memo ? 190 : 222, LW = 22;
  let o = yearHead(at, 'YEARLY PLAN', n);
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  const rh = (BOT - TOP) / n, cw = (X2 - X1 - LW) / cols;
  for (let c = 1; c <= cols; c++) o += svgLine(X1 + LW + cw * (c - 1), TOP, X1 + LW + cw * (c - 1), BOT, c === 1 ? .3 : .15);
  for (let i = 0; i < n; i++) {
    const a = addMonth(at.y, at.m, i), y = TOP + rh * i;
    if (i > 0) o += svgLine(X1, y, X2, y, a.m === 1 ? .3 : .15);
    o += boxMonthHead(X1 + 2.4, y + rh / 2 + 1.6, i, a, 'data-yplan="1"');
  }
  if (cfg.memo) { o += svgText(X1, BOT + 6.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"'); o += memoBox(X1, BOT + 8.4, X2 - X1, 222 - BOT - 8.4, cfg.memoSpec); }
  return o;
}
// ----- Y5 年間プロジェクト（ガント）：やること × 12か月。お手本：Bindex プロジェクトチェックリスト -----
function drawYearProject(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, rows = cfg.rows || 16;
  const { X1, X2, TOP } = PG, BOT = cfg.memo ? 190 : 222, LW = 36, HEAD = 7;
  let o = yearHead(at, 'YEARLY PROJECT', n);
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgText(X1 + LW / 2, TOP + 4.8, 2.3, 'PROJECT', ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  o += svgLine(X1 + LW, TOP, X1 + LW, BOT, .3);
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  const cw = (X2 - X1 - LW) / n, rh = (BOT - TOP - HEAD) / rows;
  for (let i = 0; i < n; i++) {
    const a = addMonth(at.y, at.m, i), x = X1 + LW + cw * i;
    if (i > 0) o += svgLine(x, TOP, x, BOT, a.m === 1 ? .3 : .12);
    o += svgText(x + cw / 2, TOP + 4.8, 2.1, a.m, ' text-anchor="middle" font-weight="700" data-yproj="1"');
  }
  for (let r = 1; r < rows; r++) o += svgLine(X1, TOP + HEAD + rh * r, X2, TOP + HEAD + rh * r, .12);
  if (cfg.memo) { o += svgText(X1, BOT + 6.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"'); o += memoBox(X1, BOT + 8.4, X2 - X1, 222 - BOT - 8.4, cfg.memoSpec); }
  return o;
}

// ----- M28 ガントチャート 2か月（たてに 2つ・v0.2.94）-----
function drawGanttTwo(at, fmt, opt, cfg = {}) {
  const nx = addMonth(at.y, at.m, 1);
  const rows = cfg.rows || 6;   // ★「マスの中の線」で 6〜10行に できる（v0.2.94）
  // ぎょうじの 一覧を 入れるときは 表を 上げる（ほかの 月間と 同じ）
  const plan = opt.ev & 6;
  const G1 = plan ? 112 : 118, T2 = plan ? 130 : 138, G2 = plan ? 206 : 222;
  let o = monthHead(at, null, null, 0, true);
  o += drawGantt(at, fmt, opt, { ...cfg, top: 34, gb: G1, rows, noHead: true, memo: false, noMini: true });
  o += drawGantt({ y: nx.y, m: nx.m, d: 1 }, fmt, opt, { ...cfg, top: T2, gb: G2, rows, noHead: true, miniHead: true, memo: false, noMini: true });
  return o + (plan ? planList(at.m, opt.ev, 16, 174, 212.4, 4, 2) : '');
}

// ----- M26 前半・後半（1〜15／16〜末を 左右に ならべる。お手本：能率エクセル5・ベーシックE1001）-----
function drawMonthHalves(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, BOT = monthBot(opt), GAP = 4;
  const last = new Date(at.y, at.m, 0).getDate(), w = (X2 - X1 - GAP) / 2;
  let o = monthHead(at);
  o += dayListBlock(at, opt, X1, TOP, w, BOT - TOP, 1, 15, cfg);
  o += dayListBlock(at, opt, X1 + w + GAP, TOP, w, BOT - TOP, 16, last, cfg);
  return o + miniRow(fmt, at, opt);
}
// ----- M27 2か月の たてリスト（この月と つぎの月。お手本：ゴルフ手帳・ニューダイアリー）-----
function drawTwoMonthList(at, fmt, opt, cfg = {}) {
  const nx = addMonth(at.y, at.m, 1);
  const { X1, X2, TOP } = PG, BOT = opt.ev & 6 ? 208 : 226, GAP = 4;
  const w = (X2 - X1 - GAP) / 2;
  // 2か月ならぶので 英語の 月の名前は 入れない（となりの 月の 数字に かからないように）
  let o = monthHead(at, null, null, 0, true);
  o += monthHead({ y: nx.y, m: nx.m }, null, X1 + w + GAP, 0, true);   // 2つめの 月も 同じ 大きさ（v0.2.93）
  o += dayListBlock(at, opt, X1, TOP, w, BOT - TOP, 1, new Date(at.y, at.m, 0).getDate(), cfg);
  o += dayListBlock({ y: nx.y, m: nx.m, d: 1 }, opt, X1 + w + GAP, TOP, w, BOT - TOP, 1, new Date(nx.y, nx.m, 0).getDate(), cfg);
  return o + (opt.ev & 6 ? planList(at.m, opt.ev, 16, 174, 212.4, 4, 2) : '');
}

// ----- M24 土日ハーフ（お手本：能率手帳ウィック5）：土日を 1列に まとめて 上下 半分ずつ -----
function drawMonthWeekendHalf(at, fmt, opt, cfg = {}) {
  return monthHead(at) + monthGrid(at, opt, 16, 174, 30, monthBot(opt), { wkHalf: true, enikki: opt.enikki, ...cfg }) + miniRow(fmt, at, opt);
}
// ----- M25 月間＋時間めもり（お手本：能率手帳ウィック4）：日が たてに ならび、予定の 列に 時間の めもり -----
function drawMonthTime(at, fmt, opt, cfg = {}) {
  return drawMonthlyList(at, fmt, opt, { memo: 0, time: [8, 21], ...cfg });
}

// ----- M21 月間タスク（NOLTY「月間タスク」）：マスの 中を 予定／やること に 日割り -----
function drawMonthTask(at, fmt, opt, cfg = {}) {
  return monthHead(at) + monthGrid(at, opt, 16, 174, 30, monthBot(opt), { task: true, enikki: opt.enikki, ...cfg }) + miniRow(fmt, at, opt);
}
// ----- M22 アイダにメモ（NOLTY の 定番）：週の 行の 下に 細い メモの 帯 -----
function drawMonthBand(at, fmt, opt, cfg = {}) {
  return monthHead(at) + monthGrid(at, opt, 16, 174, 30, monthBot(opt), { band: 7, enikki: opt.enikki, ...cfg }) + miniRow(fmt, at, opt);
}
// ----- M23 デュアルマンスリー（NOLTY）：1まいに 2か月（上＝この月・下＝つぎの月）-----
//   ★1まいに 入れるので 小さなカレンダーは 出さない
function drawDualMonth(at, fmt, opt, cfg = {}) {
  const nx = addMonth(at.y, at.m, 1);
  // ぎょうじ（先生・保育園）の 一覧を 入れるときは 表を 上げる（ほかの 月間の形と 同じ）
  const { TOP } = PG, BOT = opt.ev & 6 ? 208 : 226, MID = Math.round((TOP + BOT) / 2 + 3);
  let o = monthHead(at);
  // ★2つめの 月の 見出し（13mm）が 上の 表に かからないように 16mm あける（v0.2.95）
  o += monthGrid(at, opt, 16, 174, TOP, MID - 16, { rows: 6, headH: 4, enikki: opt.enikki, ...cfg });
  o += monthHead(nx, null, 16, MID - 27.5);   // 2つめの 月も 同じ 大きさ（v0.2.93）
  o += monthGrid(nx, opt, 16, 174, MID, BOT, { rows: 6, headH: 4, ...cfg });
  // 小さなカレンダーは 出さない（1まいに 2か月 入っているため）。ぎょうじの 一覧だけ 出す
  return o + (opt.ev & 6 ? planList(at.m, opt.ev, 16, 174, 212.4, 4, 2) : '');
}

// ----- M3 月間式レフト（左 2/3＝月のマス目、右 1/3＝方眼メモ）-----
//   お手本：ラコニック A5レフトマンスリー（片面1ヶ月マンスリー＋メモ）を1まいに
//   ★マスのはば 15mm：いちばん長い祝日（6文字＝12mm）もおさまる
function drawMonthlyLeft(at, fmt, opt) {
  const { X1, X2, TOP } = PG, BOT = monthBot(opt);
  const XM = X1 + (X2 - X1) * 2 / 3;
  return monthHead(at) + monthGrid(at, opt, X1, XM, TOP, BOT, { enikki: opt.enikki }) + gridMemo(XM + 3, TOP, X2 - XM - 3, BOT - TOP) + miniRow(fmt, at, opt);
}

// ----- M4 月間式たて型（1日1行・31行。左＝日付、まん中＝予定、右＝メモ）-----
//   お手本：高橋書店 月間横ケイ式・本の「月間式（縦型）」・アシュフォード 月間バーティカル式
//   ★31日ない月は、のこりの行を空ける。週のさかいめの線は少し太く
//   cfg（オーダーメイド）：memo＝右のメモの列のはば（0＝なし・1/3・1/2）
//   cfg.time＝[はじめの時間, おわりの時間]（予定の 列に 1時間ごとの うすい線と 見出しの 数字・v0.2.88）
function drawMonthlyList(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, HEAD = 6, BOT = monthBot(opt), LW = 24;
  const MW = (X2 - X1) * (cfg.memo == null ? 1 / 3 : cfg.memo);   // 2026-09-18 44mm → 1/3（オーダーメイドの「右のメモ」と同じに）
  const XS = X1 + LW, XR = X2 - MW;           // 予定の列のはじめ、メモの列のはじめ
  const rh = (BOT - TOP - HEAD) / 31;
  const last = new Date(at.y, at.m, 0).getDate();
  let o = monthHead(at);
  o += svgText(X1 + LW / 2, TOP + 4.1, 2.3, 'DATE', ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  // ★時間の めもりを 入れる ときは 見出し「SCHEDULE」は 書かない（数字と かさなるため・v0.2.100）
  if (!cfg.time) o += svgText((XS + XR) / 2, TOP + 4.1, 2.3, 'SCHEDULE', ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  if (MW) o += svgText((XR + X2) / 2, TOP + 4.1, 2.3, 'MEMO', ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  o += svgLine(XS, TOP, XS, BOT, .25);
  o += svgLine(XR, TOP, XR, BOT, .25);
  // 時間の めもり：予定の 列に 1時間ごとの たて線＋見出しに 数字（ドットのように 見える 細い線）
  if (cfg.time) {
    const [H0, H1] = cfg.time, tw = (XR - XS) / (H1 - H0);
    for (let h = H0; h <= H1; h++) {
      const x = XS + tw * (h - H0);
      if (h > H0) o += svgLine(x, TOP + HEAD, x, BOT, .1, ' stroke-dasharray=".5 1.2" data-htime="1"');
      if (h < H1) o += svgText(x + tw / 2, TOP + 4.1, 1.6, h, ' text-anchor="middle" data-htime-n="1"');
    }
  }
  for (let r = 0; r < 31; r++) {
    const y = TOP + HEAD + rh * r;
    const d = new Date(at.y, at.m - 1, r + 1);
    const has = r < last;
    // 週のさかいめ（次の日が週のはじまり）は太く
    if (r > 0) o += svgLine(X1, y, X2, y, has && d.getDay() === opt.ws ? .3 : .12);
    if (!has) continue;
    if (opt.today && sameDay(d, TODAY)) o += todayRect(X1 + .5, y + .3, X2 - X1 - 1, rh - .6);
    const cy = y + rh / 2;
    o += dayNum(X1 + 3.6, cy, 2.2, 2.8, d, false, opt);
    o += svgText(X1 + 8.6, cy + .8, 2.1, WDL()[d.getDay()], ' font-weight="700"' + dowAttr(d.getDay()));
    const ky = koyoOf(d, opt, false);
    o += moonMark(X1 + 12.6, cy, .8, ky.mo);
    if (ky.ro) o += svgText(XS - 1.2, cy + .6, 1.6, ky.ro, ' text-anchor="end" data-rokuyo="1"');
    o += kyuText(XS - 5.2, cy + .5, 1.3, ky.kyu);
    const hn = opt.hol && holidayName(d);
    if (hn) o += svgText(XS + 1.4, cy + .7, 1.8, hn, ' data-holiday="1"');
    o += seEv(XS + 1.4 + (hn ? [...hn].length * 1.8 + 1.8 : 0), cy + .7, 1.8, ky.se, ky.ev, 'start', XR - XS - 2.4 - (hn ? [...hn].length * 1.8 + 1.8 : 0));
  }
  return o + miniRow(fmt, at, opt);
}

// ----- M5 ガントチャート（上＝TASK の列と31日の列、下＝方眼メモ）-----
//   お手本：ラコニック A4／A5ガントチャートマンスリー（曜日をまたいで書ける・ページの下半分はグリッド）
//   ★1日の列は約4mm。祝日・二十四節気の名前は列に入らないので、表の下に1行でならべる
//   cfg（オーダーメイド）：memo＝下のメモ（false でなし）、memoKind＝メモの線
function drawGantt(at, fmt, opt, cfg = {}) {
  //   cfg.top/cfg.gb＝表の 上と 下（2か月ならべる ときに つかう・v0.2.94）、cfg.rows＝行の数、cfg.noHead＝月の 見出しを 書かない
  const { X1, X2 } = PG, TOP = cfg.top || PG.TOP, BOT = monthBot(opt), LW = 26, GB = cfg.gb || 132, ROWS = cfg.rows || 14;
  const GX = X1 + LW, cw = (X2 - GX) / 31;
  const R1 = 5, R2 = 8.6, R3 = 13.2, HEAD = 15.6;   // 日付・曜日・六曜・月のしるしの行のさかい
  const rh = (GB - TOP - HEAD) / ROWS;
  const last = new Date(at.y, at.m, 0).getDate();
  let o = cfg.noHead ? '' : monthHead(at);
  if (cfg.miniHead) o += monthHead(at, null, 16, TOP - 27.5, true) + svgText(X1, TOP - 1.6, .01, '', ' data-gantt2="1"');
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${GB - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgText(X1 + LW / 2, TOP + 9.4, 2.3, 'TASK', ' text-anchor="middle" font-weight="700" letter-spacing=".3"');
  o += svgLine(GX, TOP, GX, GB, .3);
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  [R1, R2, R3].forEach(r => { o += svgLine(GX, TOP + r, X2, TOP + r, .12); });
  for (let k = 1; k < ROWS; k++) o += svgLine(X1, TOP + HEAD + rh * k, X2, TOP + HEAD + rh * k, .15);
  const notes = [];   // 表の下にならべる祝日・二十四節気
  for (let i = 0; i < 31; i++) {
    const x = GX + cw * i, cx = x + cw / 2;
    const d = new Date(at.y, at.m - 1, i + 1);
    const has = i < last;
    // 週のさかいめは太く
    if (i > 0) o += svgLine(x, TOP, x, GB, has && d.getDay() === opt.ws ? .3 : .12);
    if (!has) continue;
    if (opt.today && sameDay(d, TODAY)) o += todayRect(x + .3, TOP + .3, cw - .6, GB - TOP - .6);
    o += dayNum(cx, TOP + R1 / 2, 1.8, 2.1, d, false, opt);
    o += svgText(cx, TOP + R2 - .9, 1.6, WDL()[d.getDay()], ' text-anchor="middle"' + dowAttr(d.getDay()));
    const ky = koyoOf(d, opt, false);
    if (ky.ro) o += `<text class="ink" fill="${INK_C}" font-size="1.4" text-anchor="middle" data-rokuyo="1">${[...(PLANG === 'ja' ? ky.ro : ((I18N[PLANG].ro2 || {})[ky.ro] || ky.ro))].map((ch, j) => `<tspan x="${nf(cx)}" y="${nf(TOP + R2 + 1.9 + j * 1.7)}">${ch}</tspan>`).join('')}</text>`;   // 2文字をたてに
    o += moonMark(cx, TOP + (R3 + HEAD) / 2, .7, ky.mo);
    const hn = opt.hol && holidayName(d);
    if (hn || ky.se) notes.push({ day: i + 1, hn, se: ky.se });
  }
  // 祝日・二十四節気の一覧（例：21 敬老の日　23 秋分の日 秋分）
  let nx = X1;
  const ny = GB + 4.2;
  notes.forEach(n => {
    const dw = nf(String(n.day).length * 1.9 * .62);
    o += svgText(nx, ny, 1.9, n.day, ` font-weight="800" textLength="${dw}" lengthAdjust="spacingAndGlyphs" data-noscale="1"`);
    nx += dw + 1;
    if (n.hn) { o += svgText(nx, ny, 1.8, n.hn, ' data-holiday="1" data-noscale="1"'); nx += [...n.hn].length * 1.8 + .8; }
    if (n.se) { o += svgText(nx, ny, 1.8, n.se, ' data-sekki="1" data-noscale="1"'); nx += [...n.se].length * 1.8 + .8; }
    nx += 2.4;
  });
  if (cfg.memo !== false) {
    o += svgText(X1, GB + 10.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
    o += memoBox(X1, GB + 12.4, X2 - X1, BOT - GB - 12.4, cfg.memoSpec);
  }
  // ★2か月ならべる ときは、小さなカレンダーと ぎょうじの 一覧は 外で 1回だけ 出す（v0.2.94）
  return o + (cfg.noMini ? '' : miniRow(fmt, at, opt));
}

// ----- M6 年間スケジュール（1〜31日×12か月の表。祝日・二十四節気は表の下にならべる）-----
//   お手本：アシュフォード 年間スケジュール（12か月をたてにならべる）
//   ★1年が1まいで見えるので、小さなカレンダーは入れない。その月にない日は ななめの線
const MONTH_EN3 = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
// 年間の見出し：大きな年（1月はじまりでないときは、英語の右に「2026.4 — 2027.3」。上のまん中の丸マークをよける）
function yearHead(at, label, n = 12) {
  const last = addMonth(at.y, at.m, n - 1);
  let o = svgText(26, 25.5, 11, at.y, ' font-weight="800" letter-spacing=".4"');
  o += svgText(62, 24.6, 2.8, label, ' letter-spacing=".6"');
  if (at.m !== 1 || n !== 12) o += svgText(102, 24.6, 2.4, `${at.y}.${at.m} — ${last.y}.${last.m}`, ' font-weight="700" letter-spacing=".3" data-span="1"');
  return o;
}
// 年間の12のわく（3列×4段）の場所。k＝0〜11
const yearBox = (k, top, bot, G = 4, rows = 4) => {
  const w = (158 - G * 2) / 3, h = (bot - top - G * (rows - 1)) / rows;
  return { x: 16 + (k % 3) * (w + G), y: top + Math.floor(k / 3) * (h + G), w, h };
};
// わくの中の月の見出し：大きな月（5mm。はばは textLength でそろえる）・英語3文字（年のはじめの月と1月には小さな年）
//   ★月の数字は 5mm 以上なので「サイズ」で大きさがかわらない（右の英語にかさならない）
function boxMonthHead(x, y, k, a, attr, sub = 2) {
  const size = 5, mw = String(a.m).length === 2 ? 6 : 2.9;
  let o = svgText(x, y, size, a.m, ` font-weight="800" textLength="${mw}" lengthAdjust="spacingAndGlyphs" ${attr}`);
  o += svgText(x + mw + 1, y, sub, MONTH_EN3[a.m - 1], ' letter-spacing=".2"');
  if (k === 0 || a.m === 1) o += svgText(x + mw + 1, y - sub * 1.35, sub, a.y, ' font-weight="700" data-newyear="1"');
  return o;
}

// ----- Y1 年間カレンダー（12か月の小さなカレンダーを 3列×4段）-----
//   お手本：NOLTY・高橋書店・博文館 の 手帳のはじめの年間カレンダー
//   ★小さいので六曜・月齢は入れない。日曜・祝日は太字（日曜日の色）、土曜は土曜日の色
//   cfg（オーダーメイド）：months＝1まいの月の数、memo＝下のメモ
function drawYearCalendar(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, memo = !!cfg.memo, rows = n / 3;
  const BOT = memo ? 176 : 222;
  let o = yearHead(at, 'YEARLY CALENDAR', n);
  for (let k = 0; k < n; k++) {
    const a = addMonth(at.y, at.m, k);
    const { x, y, w, h } = yearBox(k, 30, BOT, 4, rows);
    o += `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    o += boxMonthHead(x + 2.5, y + 6.6, k, a, 'data-ycal="1"');
    const cw = (w - 5) / 7, top = y + 11.6, rh = (h - 11.6 - 1.5) / 6;
    weekOrder(opt.ws).forEach((dw, c) => { o += svgText(x + 2.5 + cw * (c + .5), y + 10.4, 1.7, WD_EN[dw].slice(0, 2), ' text-anchor="middle" font-weight="700"' + dowAttr(dw)); });
    o += svgLine(x + 2.5, top, x + w - 2.5, top, .15);
    const off = (new Date(a.y, a.m - 1, 1).getDay() - opt.ws + 7) % 7;
    const last = new Date(a.y, a.m, 0).getDate();
    for (let d = 1; d <= last; d++) {
      const i = off + d - 1, c = i % 7, r = Math.floor(i / 7);
      const day = new Date(a.y, a.m - 1, d);
      const red = day.getDay() === 0 || (opt.hol && holidayName(day));
      const cx = x + 2.5 + cw * (c + .5), cy = top + rh * (r + .5);
      if (opt.today && sameDay(day, TODAY)) o += todayRect(cx - cw / 2 + .2, cy - rh / 2 + .2, cw - .4, rh - .4);
      o += svgText(cx, cy + .9, 2.5, d, ` text-anchor="middle" data-yd="${k}" data-c="${c}" data-r="${r}"${red ? ' font-weight="800"' : ''}${dowAttr(red ? 0 : day.getDay())}`);
    }
  }
  if (memo) o += memoArea(16, BOT + 5, 158, 222 - BOT - 5, cfg.memoSpec);
  return o;
}

// ----- Y2 年間チャート よこ型（12行＝月 × 31列＝日）-----
//   お手本：ガントチャートの1年版（月をまたぐ予定を 横に線で書ける）
//   cfg（オーダーメイド）：months＝1まいの月の数、dots＝書く点線、memo＝下のメモ
function drawYearChart(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, dots = cfg.dots !== false, memo = !!cfg.memo;
  const { X1, X2, TOP } = PG, HEAD = 6, BOT = memo ? 160 : 214, MW = 12;
  const cw = (X2 - X1 - MW) / 31, rh = (BOT - TOP - HEAD) / n, GX = X1 + MW;
  let o = yearHead(at, 'YEARLY CHART', n);
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  o += svgLine(GX, TOP, GX, BOT, .3);
  for (let i = 0; i < 31; i++) {
    const x = GX + cw * i;
    if (i) o += svgLine(x, TOP, x, BOT, (i % 5) ? .1 : .2);   // 5日ごとに少し太く
    o += svgText(x + cw / 2, TOP + 4.1, 2, i + 1, ' text-anchor="middle" font-weight="700" data-dcol="1"');
  }
  for (let k = 0; k < n; k++) {
    const a = addMonth(at.y, at.m, k);
    const y = TOP + HEAD + rh * k;
    if (k) o += svgLine(X1, y, X2, y, a.m === 1 ? .45 : .25);   // 年がかわる月は太く
    o += boxMonthHead(X1 + 1.2, y + rh / 2 + 1.8, k, a, 'data-ymon="1"', 1.5);
    // 書く線（点線2本）
    if (dots) [.5, .78].forEach(p => { o += svgLine(GX + .5, y + rh * p, X2 - .5, y + rh * p, .12, ' stroke-dasharray=".4 .8" data-dots="1"'); });
    const last = new Date(a.y, a.m, 0).getDate();
    for (let i = 0; i < 31; i++) {
      const x = GX + cw * i;
      if (i >= last) { o += svgLine(x + .5, y + rh - .5, x + cw - .5, y + .5, .1, ' data-none="1"'); continue; }   // その月にない日
      const day = new Date(a.y, a.m - 1, i + 1);
      const red = day.getDay() === 0 || (opt.hol && holidayName(day));
      if (opt.today && sameDay(day, TODAY)) o += todayRect(x + .2, y + .2, cw - .4, rh - .4);
      o += svgText(x + cw / 2, y + 2.6, 1.5, WDL()[day.getDay()], ` text-anchor="middle" data-yw="${k}"${red ? ' font-weight="800"' : ''}${dowAttr(red ? 0 : day.getDay())}`);
    }
  }
  if (memo) o += memoArea(X1, BOT + 5, X2 - X1, 222 - BOT - 5, cfg.memoSpec);
  return o;
}
// ===== メモの線（ルーズリーフのオーダーメイドと同じ。gold_v0166 の areaSvg をうつしたもの）=====
//   spec＝{ type, sp, wt, st, em }：種類・間隔・太さ・引き方・強調（数はえらんだ番号）
// メモのわく（外のわくは .3。中は えらんだ線）
function memoBox(x, y, w, h, spec = MEMO_DEF, iconMode = false) {
  const sp = MEMO_SPACES[spec.sp] ?? 5, sw = [.1, .2, .35][spec.wt] ?? .1;
  const dash = ['', ` stroke-dasharray="0.05 ${nf(Math.max(.7, sw * 3))}" stroke-linecap="round"`, ` stroke-dasharray="${nf(sp * .28)} ${nf(sp * .16)}"`][spec.st] || '';
  const every = [0, 5, 10][spec.em] || 0;
  const lw = k => (every && k % every === 0 ? nf(sw * 2.2) : sw);
  const L = (x1, y1, x2, y2, width, d = dash) => svgLine(x1, y1, x2, y2, width, d);
  const X2 = x + w, Y2 = y + h;
  // ★v0.2.107 spec.org＝線を そろえる もとの点 [x, y]。となりの メモと ぴったり 同じ線の上に なる
  const snap = (v, o0, step) => (spec.org == null ? v + step : v + ((((o0 - v) % step) + step) % step || step));
  const ORGX = spec.org ? spec.org[0] : 0, ORGY = spec.org ? spec.org[1] : 0;
  //   ★わくの太さの字は これまでと同じ「.3」にする（形がまったく同じ絵になるように）
  // ★v0.2.103 メモの わくは はじめ「なし」。spec.frame が true の ときだけ 線を 引く（形と 目じるしは のこす）
  const frame = (fx, fy, fw, fh, width = '.3') => `<rect x="${nf(fx)}" y="${nf(fy)}" width="${nf(fw)}" height="${nf(fh)}" fill="none" stroke="${spec.frame ? INK_C : 'none'}" stroke-width="${width}" data-memo-type="${spec.type}"/>`;
  let o = '';
  const hlines = step => { let k = 1; for (let yy = snap(y, ORGY, step); yy < Y2 - .01; yy += step, k++) o += L(x, yy, X2, yy, lw(k)); };
  switch (spec.type) {
    case 0: o = frame(x, y, w, h); break;                                   // 無地
    case 1: o = frame(x, y, w, h); hlines(sp); break;                        // 横罫
    case 2: case 7: {                                                        // 方眼・マス目（まん中にそろえる）
      const m = spec.type === 7 ? Math.max(sp, 5) : sp;
      let x0, y0, cols, rows;
      if (spec.org) { x0 = snap(x, ORGX, m) - m; y0 = snap(y, ORGY, m) - m; if (x0 < x - .001) x0 += m; if (y0 < y - .001) y0 += m; cols = Math.floor((X2 - x0) / m + .001); rows = Math.floor((Y2 - y0) / m + .001); }
      else { cols = Math.floor(w / m); rows = Math.floor(h / m); x0 = x + (w - cols * m) / 2; y0 = y + (h - rows * m) / 2; }
      o = frame(x0, y0, cols * m, rows * m, spec.type === 7 ? nf(Math.max(.3, sw * 1.8)) : '.3');
      for (let i = 1; i < cols; i++) o += L(x0 + i * m, y0, x0 + i * m, y0 + rows * m, lw(i));
      for (let j = 1; j < rows; j++) o += L(x0, y0 + j * m, x0 + cols * m, y0 + j * m, lw(j));
      break; }
    case 3: {                                                                // ドット
      o = frame(x, y, w, h);
      for (let yy = snap(y, ORGY, sp); yy < Y2 - .01; yy += sp) for (let xx = snap(x, ORGX, sp); xx < X2 - .01; xx += sp) o += `<circle class="line" cx="${nf(xx)}" cy="${nf(yy)}" r="${nf(sw * 1.6)}" fill="${INK_C}"/>`;
      break; }
    case 4: {                                                                // 十字
      o = frame(x, y, w, h);
      const t = Math.min(sp * .2, 1.2);
      for (let yy = snap(y, ORGY, sp); yy < Y2 - .01; yy += sp) for (let xx = snap(x, ORGX, sp); xx < X2 - .01; xx += sp) o += L(xx - t, yy, xx + t, yy, sw, '') + L(xx, yy - t, xx, yy + t, sw, '');
      break; }
    case 5: {                                                                // 5本罫
      o = frame(x, y, w, h);
      for (let yy = y + sp; yy + sp * 4 < Y2; yy += sp * 6.5) for (let k = 0; k < 5; k++) o += L(x, yy + k * sp, X2, yy + k * sp, k === 0 || k === 4 ? nf(sw * 1.8) : sw);
      break; }
    case 6: {                                                                // チェック（□と線）
      o = frame(x, y, w, h);
      const step = Math.max(sp, 5), bx = Math.min(step * .55, 4);
      for (let yy = y + step; yy < Y2 - .01; yy += step) {
        o += `<rect x="${nf(x + 1)}" y="${nf(yy - bx)}" width="${nf(bx)}" height="${nf(bx)}" rx=".4" fill="none" stroke="${INK_C}" stroke-width="${nf(sw * 1.6)}" data-memo-check="1"/>`;
        o += L(x + bx + 2, yy, X2 - 1, yy, sw);
      }
      break; }
    case 8: {                                                                // 英語罫（4本ずつ）
      o = frame(x, y, w, h);
      for (let yy = y + sp * .6; yy + sp < Y2; yy += sp * 1.6) [0, 1, 2, 3].forEach(k => { o += L(x, yy + k * sp / 3, X2, yy + k * sp / 3, k === 3 ? nf(sw * 1.5) : sw, k === 1 || k === 2 ? ' stroke-dasharray="1 1"' : ''); });
      break; }
    default: o = frame(x, y, w, h);
  }
  return o;
}
// パネルのボタンの 小さな見本
// ----- オーダーメイドの えらびを 絵にする（B5の紙を 上から見た形。よこ20・たて26）-----
//   s の中身： band＝メモの場所（r 右・l 左・t 上・b 下）と f＝はば（0〜1）
//             grid＝[よこのマス, たてのマス]、rows／cols＝線の数、cell＝マスの中の線の数
//             idx＝右はしのインデックス、v＝たての区切りの場所（0〜1）、h＝よこの区切りの場所
//             dash＝点線、bars＝ガントの棒、goal＝上に大きな欄
function cmIcon(s = {}) {
  const W = 20, H = 26, m = 2.2;
  const x0 = m, y0 = m, x1 = W - m, y1 = H - m, w = x1 - x0, h = y1 - y0;
  const P = (d, sw = .55, extra = '') => `<path d="${d}" fill="none" stroke="currentColor" stroke-width="${sw}"${extra}/>`;
  const R = (x, y, ww, hh, op = '.3') => `<rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${ww.toFixed(2)}" height="${hh.toFixed(2)}" rx=".5" fill="currentColor" opacity="${op}"/>`;
  let o = `<rect x="${x0}" y="${y0}" width="${w}" height="${h}" rx="1.3" fill="none" stroke="currentColor" stroke-width=".9"/>`;
  // 使えるところ（メモをのぞいた ところ）
  let ax = x0, ay = y0, aw = w, ah = h;
  if (s.idx) { aw -= 2.4; o += R(x1 - 2.2, y0 + 2, 2, 3.4, '.5') + R(x1 - 2.2, y0 + 6.4, 2, 3.4, '.35') + R(x1 - 2.2, y0 + 10.8, 2, 3.4, '.2'); }
  if (s.band) {
    const f = s.f || (s.band === 'b' || s.band === 't' ? 0.3 : 1 / 3);
    if (s.band === 'r') { const bw = aw * f; o += R(ax + aw - bw, ay, bw, ah); aw -= bw; }
    if (s.band === 'l') { const bw = aw * f; o += R(ax, ay, bw, ah); ax += bw; aw -= bw; }
    if (s.band === 'b') { const bh = ah * f; o += R(ax, ay + ah - bh, aw, bh); ah -= bh; }
    if (s.band === 't') { const bh = ah * f; o += R(ax, ay, aw, bh); ay += bh; ah -= bh; }
    if (s.bandCols) {   // メモの中の たての線（子どもの記録・TO DO など）
      const bx = s.band === 'l' ? x0 + .2 : ax + aw, bw2 = (s.band === 'r' || s.band === 'l') ? (w - aw) : aw;
      const by = s.band === 't' ? y0 : ay + ah, bh2 = (s.band === 't' || s.band === 'b') ? (h - ah) : ah;
      let d = '';
      for (let i = 1; i < s.bandCols; i++) d += `M${(bx + bw2 * i / s.bandCols).toFixed(2)} ${by.toFixed(2)}V${(by + bh2).toFixed(2)}`;
      o += P(d, .35);
    }
  }
  if (s.goal) { o += R(ax, ay, aw, ah * .3); ay += ah * .3 + .8; ah = ah * .7 - .8; }
  if (s.grid) {
    const [gc, gr] = s.grid;
    let d = '';
    for (let i = 1; i < gc; i++) d += `M${(ax + aw * i / gc).toFixed(2)} ${ay.toFixed(2)}V${(ay + ah).toFixed(2)}`;
    for (let i = 1; i < gr; i++) d += `M${ax.toFixed(2)} ${(ay + ah * i / gr).toFixed(2)}H${(ax + aw).toFixed(2)}`;
    o += P(d, .4);
  }
  if (s.rows) { let d = ''; for (let i = 1; i < s.rows; i++) d += `M${ax.toFixed(2)} ${(ay + ah * i / s.rows).toFixed(2)}H${(ax + aw).toFixed(2)}`; o += P(d, .4); }
  if (s.cols) { let d = ''; for (let i = 1; i < s.cols; i++) d += `M${(ax + aw * i / s.cols).toFixed(2)} ${ay.toFixed(2)}V${(ay + ah).toFixed(2)}`; o += P(d, .4); }
  if (s.bars) { let g = ''; for (let i = 0; i < 4; i++) g += R(ax + 1 + i * 1.4, ay + 1.6 + i * 4.2, aw * (.35 + i * .13), 2.2, '.35'); o += g; }
  if (s.lines) { let d = ''; for (let i = 1; i <= s.lines; i++) d += `M${(ax + 1).toFixed(2)} ${(ay + ah * i / (s.lines + 1)).toFixed(2)}H${(ax + aw - 1).toFixed(2)}`; o += P(d, .5); }
  if (s.halfDash && s.rows) { let d = ''; for (let i = 0; i < s.rows; i++) d += `M${(ax + 1).toFixed(2)} ${(ay + ah * (i + .5) / s.rows).toFixed(2)}H${(ax + aw - 1).toFixed(2)}`; o += P(d, .35, ' stroke-dasharray="1 1"'); }
  if (s.cell) { let d = ''; for (let i = 1; i <= s.cell; i++) d += `M${(ax + 1).toFixed(2)} ${(ay + ah * i / (s.cell + 1)).toFixed(2)}H${(ax + aw - 1).toFixed(2)}`; o += P(d, .35, ' stroke-dasharray="1 1"'); }
  if (s.v) o += P(`M${(ax + aw * s.v).toFixed(2)} ${ay.toFixed(2)}V${(ay + ah).toFixed(2)}`, .8);
  if (s.h) o += P(`M${ax.toFixed(2)} ${(ay + ah * s.h).toFixed(2)}H${(ax + aw).toFixed(2)}`, .8);
  if (s.gap) o += P(`M${ax.toFixed(2)} ${(ay + ah * .5).toFixed(2)}H${(ax + aw).toFixed(2)}`, .8, ' stroke-dasharray="1.4 1.2"');
  if (s.dash) { let d = ''; for (let i = 1; i < 4; i++) d += `M${(ax + 1.5).toFixed(2)} ${(ay + ah * i / 4).toFixed(2)}H${(ax + aw - 1.5).toFixed(2)}`; o += P(d, .35, ' stroke-dasharray="1 1"'); }
  if (s.night) o += R(ax, ay + ah * .72, aw, ah * .28, '.18');
  if (s.x) o += P(`M${(x0 + 4).toFixed(2)} ${(y0 + 4).toFixed(2)}L${(x1 - 4).toFixed(2)} ${(y1 - 4).toFixed(2)}M${(x1 - 4).toFixed(2)} ${(y0 + 4).toFixed(2)}L${(x0 + 4).toFixed(2)} ${(y1 - 4).toFixed(2)}`, .8);
  return `<svg viewBox="0 0 20 26" aria-hidden="true">${o}</svg>`;
}
function memoIcon(type) {
  return `<svg viewBox="0 0 26 26" aria-hidden="true">${memoBox(3, 3, 20, 20, { type, sp: type === 7 || type === 8 ? 8 : 4, wt: 1, st: 0, em: 0 })}</svg>`;
}
// 下のメモ（MEMO の文字＋えらんだ線）
function memoArea(x, y, w, h, spec) {
  return svgText(x, y + 1, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"') + memoBox(x, y + 3, w, h - 3, spec);
}

// ----- C7 2週間式のオーダーメイド -----
function drawCustomBiweek(at, fmt, opt) {
  const v = opt.cm || state.custom[fmt.id];   // v[0]＝もとの形
  return drawBiweekly(at, fmt, opt, {
    lines: v[1], memo: v[2] > 0, memoSide: v[2] === 2 ? 'l' : 'r', gap: v[3] === 0, memoSpec: memoSpec(v.slice(4, 9)),
    time: v[9] === 1 ? [8, 20] : null, timeEnds: v[9] === 2 ? [9, 18] : null,
    dots: !!v[10], mid: !!v[11], goal: !!v[12], bottomMemo: !!v[13],
    dowBoth: !!v[14], plain: !!v[15], mirror: !!v[16],
  });
}

// ----- C6 週間バーチカルレフトのオーダーメイド -----
function drawCustomVleft(at, fmt, opt) {
  const v = opt.cm || state.custom[fmt.id];   // v[0]＝もとの形
  return vleftWeek(at, fmt, opt, {
    hours: [v[1], v[2] + 18],
    memo: [1 / 4, 1 / 3, 1 / 2][v[3] % 3],
    memoSide: v[3] >= 3 ? 'l' : 'r',
    memoSpec: memoSpec(v.slice(6, 11)),
    index: v[4] === 0,
    split: v[5] + 1,
    // ★v0.2.107 できあいの バーチカルレフトの 中身
    dayTop: v[11] ? 9 : 0,
    dayBottom: v[12] ? 12 : 0,
    checks: v[13] ? 5 : 0,
    noon: !!v[14],
    gridBase: v[15] ? 4 : 0,
    mini: [['cur'], ['cur', 'next'], ['cur', 'next', 'next2']][v[16]],
  });
}

// ----- C5 週間セパレートのオーダーメイド -----
function drawCustomSep(at, fmt, opt) {
  const w = opt.cm || state.custom[fmt.id], v = w.slice(1);   // w[0]＝もとの形
  const memo = memoSpec(v.slice(3, 8));
  if (w[0] === 1) return drawWeeklyBlock(at, fmt, opt, { memo: v[1] !== 1, memoTop: v[1] === 2, lines: v[2], memoSpec: memo });   // 週間ブロック式
  // ★v0.2.104 v[8]＝十字・v[9]＝横の時間めもり・v[10]＝右はしのたてメモ・v[11]＝下のメモ・v[12]＝方眼
  return drawWeeklySeparate(at, fmt, opt, { top: v[0] === 1 ? 3 : 4, memo: v[1] !== 1, memoTop: v[1] === 2, lines: v[2],
    cross: !!v[8], time: v[9] ? [8, 22] : null, memoCols: !!v[10], bottomMemo: v[11] ? 46 : 0, gridBase: v[12] ? 4 : 0 });
}

// ----- C4 週間レフト式のオーダーメイド -----
function drawCustomLeft(at, fmt, opt) {
  const v = (opt.cm || state.custom[fmt.id]).slice(1);   // v[0]＝もとの形
  const full = v[0] === 3;   // 右なし（7日いっぱい）
  const right = v[1], memo = memoSpec(v.slice(4));
  // v[9]＝時間の 目やすの 点・v[10]＝行の 分け方・v[11]＝もうひとつの欄を 7段に・v[12]＝右はしの 日づけ（v0.2.97）
  const DOTS = [null, [9, 12, 15, 18], [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]][v[9] || 0];
  return leftWeek(at, fmt, opt, {
    ratio: full ? 1 : [.4, .5, .6][v[0]],
    right: full ? 'none' : right === 1 ? 'todo' : memo,   // 0＝メモ 1＝TO DO 2＝横の時間（右はメモ）
    side: v[2] === 1 ? 'l' : 'r',                          // もうひとつの欄を 左にもおける
    time: right === 2 ? [8, 22] : null,
    lines: v[3],
    dots: DOTS, split: v[10] || 0, rightRows: !full && !!v[11], dateCol: !full && !!v[12],
    // v0.2.98：v[13]＝日曜の場所・v[14]＝土日の大きさ・v[15]＝曜日の書き方・v[16]＝土日祝の色
    sunRight: !full && !!v[13], small: !!v[14], dowBoth: !!v[15], tint: !!v[16],
  });
}

// ----- C3 週間バーティカルのオーダーメイド -----
function drawCustomVert(at, fmt, opt) {
  const w = opt.cm || state.custom[fmt.id], v = w.slice(1);   // w[0]＝もとの形
  if (w[0] === 3) return drawLifeLog(at, fmt, opt, { days5: v[3] === 1 });   // ライフログ
  return verticalWeek(at, fmt, opt, {
    kou: v[0] === 1,
    hours: [v[1], v[2] + 18],
    days5: v[3] === 1,
    split: v[4] + 1,
    half: v[5] === 0,
    night: v[6] === 0 ? [[0, 6], [22, 24]] : [],
    bottom: v[7],
    memo: 0,
    memoSpec: memoSpec(v.slice(8, 13)),
    // ★v0.2.104 v[13]〜v[20]：お昼の帯・12/18時を太く・上下のメモ欄・チェック□・5ブロック・方眼・土日を小さく
    noon: !!v[13], bold: v[14] ? [12, 18] : null, dayTop: v[15] ? 8 : 0, dayBottom: v[16] ? 16 : 0,
    checks: [0, 2, 4][v[17] || 0], blocks: v[18] ? [8, 12, 15, 18, 21] : null, gridBase: v[19] ? 4 : 0, smallWeekend: !!v[20],
  });
}

// ----- C2 月間式のオーダーメイド -----
function drawCustomMonth(at, fmt, opt) {
  const w = opt.cm || state.custom[fmt.id], base = w[0], v = w.slice(1);   // w[0]＝もとの形
  //   v[1]＝よこのメモ（0 なし・1 右1/3・2 右1/2・3 左1/3・4 左1/2）、v[2]＝たてのメモ（0 なし・1 下・2 上）
  const SIDE = [null, ['r', 1 / 3], ['r', 1 / 2], ['l', 1 / 3], ['l', 1 / 2]][v[1]];
  // ★v0.2.107 v[4]＝マスの中の線（0〜5＝点線の 本数、6〜13＝メモと 同じ 線の 種類）
  const CELLN = v[4] || 0, lines = CELLN <= 5 ? CELLN : 0;
  const rows = v[0] ? 6 : 5, side = SIDE, updown = v[2], index = !!v[3], memo = memoSpec(v.slice(5, 10), v[29]);
  // 細かい えらび（v0.2.86）：v[10]＝表の 上・v[11]＝表の 下・v[12]＝はば・v[13]＝曜日の 帯の 高さ・v[14]＝曜日の 名前・v[15]＝日付の 丸
  const TOP_S = [30, 28, 26, 32][v[10] || 0], BOT_S = [0, -6, -12][v[11] || 0], SIDE_S = [[16, 174], [12, 178], [20, 170]][v[12] || 0];
  const HEAD_S = [6, 4, 8, 0][v[13] || 0], DOW_S = v[14] || 0, DATE_S = [2.4, 2, 2.8][v[15] || 0];
  // v0.2.89：v[16]＝週の番号・v[17]＝左の列・v[18]＝右の列・v[19]＝日付のとなりの数字
  const WK_S = !!v[16], LC_S = v[17] || 0, RC_S = !!v[18], DN_S = !!v[19];
  // v0.2.90：v[20]＝列のはば・v[21]＝日付なし・v[22]＝上のメモ線・v[23]＝すみの□・v[24]＝土日の色
  const WIDE_S = v[20] || 0, NODATE_S = !!v[21], TOPM_S = !!v[22], CHK_S = !!v[23], TINT_S = !!v[24];
  // v0.2.92：v[25]＝下の 月間プランの 表・v[26]＝潮の らん
  const PT_S = !!v[25], TIDE_S = !!v[26];
  // v0.2.93／v0.2.107：v[27]＝マスの中の 線の 間隔・v[28]＝カレンダーの 場所・v[29]＝メモの わく・v[30]＝マスの中の 時計
  const CELLM_S = { type: CELLN > 5 ? CELLN - 5 : 0, sp: v[27] == null ? 4 : v[27], wt: memo.wt, st: memo.st, em: 0 };
  const CALPOS_S = v[28] || 0, CLOCK_S = !!v[30];
  if (base === 3) return drawMonthlyList(at, fmt, opt, { memo: side ? side[1] : 0 });   // 月間式たて型
  if (base === 4) return drawGantt(at, fmt, opt, { memo: updown === 1, memoSpec: memo });   // ガントチャート
  if (base === 7) return drawDualMonth(at, fmt, opt, { lines, dow: DOW_S, dateR: DATE_S });   // デュアルマンスリー（v0.2.87。曜日の 名前と 日付の 丸は かえられる）
  if (base === 9) return drawMonthTime(at, fmt, opt, { memo: side ? side[1] : 0 });           // 月間＋時間めもり（v0.2.88）
  if (base === 10) return drawMonthHalves(at, fmt, opt, { lines, tide: TIDE_S });              // 前半・後半（v0.2.91）
  if (base === 11) return drawTwoMonthList(at, fmt, opt, { lines, tide: TIDE_S });             // 2か月の たてリスト（v0.2.91）
  // ガント 2か月（v0.2.94）：行の数は「マスの中の線」で かえられる（2〜10行）
  if (base === 12) return drawGanttTwo(at, fmt, opt, { rows: 6 + lines * 2 });
  const X1 = SIDE_S[0], X2 = SIDE_S[1], TOP = TOP_S, BOT = monthBot(opt) + BOT_S, IW = 8;
  const XE = index ? X2 - IW - 2 : X2;                 // インデックスの手前
  // よこのメモ：マス目とメモのさかい（右か左）
  let GX1 = X1, GX2 = XE, mx = 0, mw = 0;
  if (side) {
    const bw = (XE - X1) * side[1];
    if (side[0] === 'r') { GX2 = XE - bw; mx = GX2 + 3; mw = XE - GX2 - 3; }
    else { GX1 = X1 + bw; mx = X1; mw = bw - 3; }
  }
  // たてのメモ：マス目の上か下（高さは どちらも同じ）
  const BH = BOT - monthGB(TOP, BOT);                  // メモの高さ
  const GT = updown === 2 ? TOP + BH : TOP;
  let GB = updown === 1 ? BOT - BH : BOT;
  // 月間タスク（5）・アイダにメモ（6）は マス目の 中身が ちがうだけ（v0.2.87）
  const PTH = PT_S ? 26 : 0;   // 下の 月間プランの 表の 高さ
  if (PTH) GB -= PTH + 3;
  let o = monthHead(at) + monthGrid(at, opt, GX1, GX2, GT, GB, { rows, lines, headH: HEAD_S, dow: DOW_S, dateR: DATE_S, task: base === 5, band: base === 6 ? 7 : 0, wkHalf: base === 8, weekNo: WK_S, leftCol: LC_S, rightCol: RC_S, dayNo: DN_S, memo, wide: WIDE_S, noDate: NODATE_S, topMemo: TOPM_S, checks: CHK_S, wkTint: TINT_S, cellMemo: CELLM_S, clock: CLOCK_S, enikki: opt.enikki });
  if (PTH) o += planTable(at, opt, X1, GB + 3, XE - X1, PTH);
  // ★v0.2.107 よこの メモと たての メモが 両方ある ときは、線を ぴったり そろえる（同じ もとの点から 引く）
  const morg = side && updown ? [X1, TOP] : null;
  if (side) o += memoBox(mx, GT, mw, GB - GT, morg ? { ...memo, org: morg } : memo);
  if (index) o += monthIndex(X2 - IW, IW, TOP, BOT, at.m);   // ★ならびは 月間式インデックス（M2）と同じにする（もとの形が 同じ紙になるように）
  if (updown) {
    const my = updown === 1 ? GB : TOP;                // 下のメモは マス目の下、上のメモは いちばん上
    o += svgText(X1, my + 5, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
    o += memoBox(X1, my + 7, XE - X1, BH - 7, morg ? { ...memo, org: morg } : memo);
  }
  return o + miniRow(fmt, at, { ...opt, calPos: CALPOS_S });
}

// ----- C1 年間のオーダーメイド（たて＝年間スケジュール、よこ＝年間チャート をもとに）-----
function drawCustomYear(at, fmt, opt) {
  const v = opt.cm || state.custom[fmt.id], cfg = { months: v[1] ? 6 : 12, dots: !!v[2], memo: !!v[3], memoSpec: memoSpec(v.slice(4)) };
  //   v[0]＝もとの形（0 カレンダー／1 スケジュール たて／2 チャート よこ／3 目標）
  return [drawYearCalendar, drawYearly, drawYearChart, drawYearGoals, drawYearPlan, drawYearProject][v[0]](at, fmt, opt, cfg);
}

// ----- Y3 年間の目標（上＝この1年の目標・テーマ、下＝12か月の目標 3列×4段）-----
//   お手本：高橋書店 2027年版「目標・テーマ・やりたいことを 年別・月別に 書き残せるページ」
//   cfg（オーダーメイド）：months＝1まいの月の数、memo＝下のメモ
function drawYearGoals(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, memo = !!cfg.memo, rows = n / 3;
  const { X1, X2, TOP } = PG, YB = 84, BOT = memo ? 186 : 222;
  let o = yearHead(at, 'YEARLY GOALS', n);
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${YB - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgText(X1 + 3, TOP + 6, 2.8, L('この1年の目標・テーマ', 'GOALS & THEMES FOR THE YEAR'), ' font-weight="800" data-goal="year"');
  for (let yy = TOP + 14; yy < YB - 3; yy += 8) o += svgLine(X1 + 3, yy, X2 - 3, yy, .12, ' stroke-dasharray=".4 .8"');
  for (let k = 0; k < n; k++) {
    const a = addMonth(at.y, at.m, k);
    const { x, y, w, h } = yearBox(k, YB + 6, BOT, 4, rows);
    o += `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    o += boxMonthHead(x + 2.5, y + 6.4, k, a, 'data-gmonth="1"');
    for (let yy = y + 12; yy < y + h - 2; yy += 6) o += svgLine(x + 2.5, yy, x + w - 2.5, yy, .12, ' stroke-dasharray=".4 .8"');
  }
  if (memo) o += memoArea(X1, BOT + 5, X2 - X1, 222 - BOT - 5, cfg.memoSpec);
  return o;
}

function drawYearly(at, fmt, opt, cfg = {}) {
  const n = cfg.months || 12, memo = !!cfg.memo;
  const { X1, X2, TOP } = PG, HEAD = 7, BOT = memo ? 150 : 203, DW = 7;
  const cw = (X2 - X1 - DW) / n, rh = (BOT - TOP - HEAD) / 31;
  let o = yearHead(at, 'YEARLY SCHEDULE', n);
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  o += svgLine(X1 + DW, TOP, X1 + DW, BOT, .3);
  for (let r = 1; r < 31; r++) o += svgLine(X1, TOP + HEAD + rh * r, X2, TOP + HEAD + rh * r, r % 5 ? .1 : .2);   // 5日ごとに少し太く
  for (let r = 0; r < 31; r++) o += svgText(X1 + DW / 2, TOP + HEAD + rh * (r + .5) + .7, 2, r + 1, ' text-anchor="middle" font-weight="700" data-dayrow="1"');
  // 日の欄の点線（オーダーメイド）：1日を上下2つに
  if (cfg.dots) for (let r = 0; r < 31; r++) o += svgLine(X1 + DW + .5, TOP + HEAD + rh * (r + .5), X2 - .5, TOP + HEAD + rh * (r + .5), .1, ' stroke-dasharray=".4 .8" data-dots="1"');
  const notes = [];
  for (let k = 0; k < n; k++) {
    const { y: yy, m } = addMonth(at.y, at.m, k);
    const x = X1 + DW + cw * k;
    // 年がかわる月：太い線と、わくの上に小さな年
    if (k) o += svgLine(x, TOP, x, BOT, m === 1 ? .45 : .25);
    if (k && m === 1) o += svgText(x + .4, TOP - 1, 1.8, yy, ' font-weight="800" data-newyear="1"');
    o += svgText(x + cw / 2, TOP + 3.6, 3, m, ' text-anchor="middle" font-weight="800" data-month="1"');
    o += svgText(x + cw / 2, TOP + 6.1, 1.4, MONTH_EN3[m - 1], ' text-anchor="middle" letter-spacing=".2"');
    const days = new Date(yy, m, 0).getDate();
    for (let r = 0; r < 31; r++) {
      const y = TOP + HEAD + rh * r, cy = y + rh / 2;
      if (r >= days) { o += svgLine(x + .6, y + rh - .6, x + cw - .6, y + .6, .1); continue; }   // その月にない日
      const d = new Date(yy, m - 1, r + 1);
      if (opt.today && sameDay(d, TODAY)) o += todayRect(x + .3, y + .2, cw - .6, rh - .4);
      // 曜日：日曜・祝日＝ぬった丸、土曜＝ふちの丸
      const hn = opt.hol && holidayName(d);
      const dow = hn ? 0 : d.getDay();
      const mk = opt.marks || { sat: true, sun: true, hol: true };
      const ring = dow === 0 ? (hn ? mk.hol : mk.sun) : dow === 6 ? mk.sat : false;
      if (dow === 0 && ring) o += `<circle class="ink sun" fill="${INK_C}" cx="${nf(x + 1.9)}" cy="${nf(cy)}" r="1.2" data-wdmark="1"/>`;
      else if (dow === 6 && ring) o += `<circle class="sat" fill="none" stroke="${INK_C}" stroke-width=".2" cx="${nf(x + 1.9)}" cy="${nf(cy)}" r="1.2"/>`;
      o += `<text class="${dow === 0 ? (ring ? 'paper' : 'ink sun') : dow === 6 ? 'ink sat' : 'ink'}" fill="${dow === 0 && ring ? '#ffffff' : INK_C}" x="${nf(x + 1.9)}" y="${nf(cy + .5)}" font-size="1.45" text-anchor="middle" font-weight="700" data-wd="1">${WDL()[d.getDay()]}</text>`;
      const ky = koyoOf(d, opt, false);
      o += moonMark(x + 3.9, cy - 1, .45, ky.mo);
      if (ky.ro) o += svgText(x + cw - .5, cy + .45, 1.2, ky.ro, ' text-anchor="end" data-rokuyo="1"');
      if (hn || ky.se) notes.push({ m, d: r + 1, hn, se: ky.se });
    }
  }
  // 祝日・二十四節気の一覧（表の下、はばに合わせて行をかえる）
  const LS = 1.6, LH = 4;
  let nx = X1, ny = BOT + 4;
  const put = (w, fn) => { if (nx + w > X2) { nx = X1; ny += LH; } o += fn(nx); nx += w; };
  notes.forEach(n => {
    const md = `${n.m}/${n.d}`;
    const mw = nf(md.length * LS * .62);   // 日付のはば（textLength でそろえる。2026-09-18 10/12 などが祝日にかさなった）
    const w = mw + .6 + (n.hn ? [...n.hn].length * LS + .5 : 0) + (n.se ? [...n.se].length * LS + .5 : 0) + 2;
    put(w, x0 => {
      let t = svgText(x0, ny, LS, md, ` font-weight="800" textLength="${mw}" lengthAdjust="spacingAndGlyphs" data-note-date="1" data-noscale="1"`);
      let xx = x0 + mw + .6;
      if (n.hn) { t += svgText(xx, ny, LS, n.hn, ' data-holiday="1" data-noscale="1"'); xx += [...n.hn].length * LS + .5; }
      if (n.se) t += svgText(xx, ny, LS, n.se, ' data-sekki="1" data-noscale="1"');
      return t;
    });
  });
  if (memo) o += memoArea(X1, ny + 4, X2 - X1, 222 - ny - 4, cfg.memoSpec);
  return o;
}

// ----- M2 月間式インデックス（上 2/3＝月のマス目、右はし＝1〜12月のインデックス、下＝方眼メモ）-----
//   お手本：ラコニック A5プレミアムマンスリー（インデックス付き・月ごとのグリッドメモ）・アシュフォード index&メモプラス
function drawMonthlyIndex(at, fmt, opt) {
  const { X1, X2, TOP } = PG, BOT = monthBot(opt), IW = 8, GB = monthGB(TOP, BOT);   // IW＝インデックスのはば、GB＝マス目の下
  let o = monthHead(at) + monthGrid(at, opt, X1, X2 - IW - 2, TOP, GB, { enikki: opt.enikki });
  o += monthIndex(X2 - IW, IW, TOP, BOT, at.m);
  // メモ（方眼）
  o += svgText(X1, GB + 5, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
  o += gridMemo(X1, GB + 7, X2 - IW - 2 - X1, BOT - GB - 7);
  return o + miniRow(fmt, at, opt);
}

// 右はしの 1〜12月のインデックス（いまの月だけぬる）。M2・W1 でつかう
function monthIndex(ix, IW, TOP, BOT, cur) {
  const th = (BOT - TOP) / 12;
  let o = '';
  for (let m = 1; m <= 12; m++) {
    const y = TOP + th * (m - 1), on = m === cur;
    o += `<rect${on ? ' class="ink"' : ''} x="${ix}" y="${nf(y + .4)}" width="${IW}" height="${nf(th - .8)}" rx="1.2" fill="${on ? INK_C : 'none'}" stroke="${INK_C}" stroke-width=".25"${on ? ' data-index-on="1"' : ''}/>`;
    o += `<text class="${on ? 'paper' : 'ink'}" fill="${on ? '#ffffff' : INK_C}" x="${nf(ix + IW / 2)}" y="${nf(y + th / 2 + 1.2)}" font-size="3.2" font-weight="800" text-anchor="middle" data-index="1">${m}</text>`;
  }
  return o;
}

// ----- 月・年の見出し（月間式・週の手帳でおなじ）-----
// 月の 見出し（数字・年・英語）。x を もらえば その場所に 書ける（2つめの 月も 同じ 大きさに・v0.2.93）
function monthHead(at, sub, HX0, DY = 0, noEn = false) {
  const HX = HX0 == null ? 26 : HX0;   // 左の丸ボタンにかくれないよう、少し右から
  // ★月の数字のはばは、字の形（見る人の文字）でかわるので、textLength で決まった長さにそろえる
  //   （2026-09-17：丸ゴシックだと「12」が右の「2026」にかさなった）
  const MW = String(at.m).length === 2 ? 15.6 : 7.6;
  let o = svgText(HX, 25.5 + DY, 13, at.m, ` font-weight="800" textLength="${MW}" lengthAdjust="spacingAndGlyphs"`);
  const nx = HX + MW + 6;   // 月の数字と年のあいだは 6mm（2026-09-17 みなとさん）
  o += svgText(nx, 19 + DY, 3.2, at.y, ' font-weight="700" letter-spacing=".3"');
  if (!noEn) o += svgText(nx, 24.6 + DY, 2.8, MONTH_EN[at.m - 1] + (sub ? '  ' + sub : ''), ' letter-spacing=".6"');
  return o;
}
// 週の7日（はじめの日から。n＝日の数）
const weekDates = (at, n = 7) => Array.from({ length: n }, (_, i) => new Date(at.y, at.m - 1, at.d + i));
// 方眼（メモ欄）。w×h の中に 5mm のマスを、まん中にそろえて引く
// 方眼のメモ（もとからある形でつかう）。メモの線の部品（memoBox）にまとめた
function gridMemo(x, y, w, h, step = 5) {
  const sp = MEMO_SPACES.indexOf(step);
  return memoBox(x, y, w, h, { type: 2, sp: sp < 0 ? 6 : sp, wt: 0, st: 0, em: 0 });
}

// マスの中の 時計（12の 目もりの 文字ばん。まん中に 小さな 点。v0.2.107）
//   お手本：ルーズリーフの アレンジ本「マンスリー×体調管理」（時計の スタンプを 押して ねた時間を ぬる）
function clockFace(cx, cy, r) {
  let o = `<circle cx="${nf(cx)}" cy="${nf(cy)}" r="${nf(r)}" fill="none" stroke="${INK_C}" stroke-width=".18" data-clock="1"/>`;
  for (let k = 0; k < 12; k++) {
    const a = Math.PI * k / 6, sx = Math.sin(a), sy = -Math.cos(a);
    const t = k % 3 === 0 ? r * .3 : r * .17;
    o += svgLine(cx + sx * (r - t), cy + sy * (r - t), cx + sx * r, cy + sy * r, k % 3 === 0 ? .16 : .1);
  }
  o += `<circle class="line" cx="${nf(cx)}" cy="${nf(cy)}" r=".22" fill="${INK_C}"/>`;
  return o;
}

// 1日の列の見出し（高さ17mm：曜日・六曜・月のしるし・日付の丸・祝日・二十四節気）。バーティカル・ライフログでつかう
function dayColumnHead(x, cw, TOP, d, opt) {
  const cx = x + cw / 2;
  const faded = outBook(d, opt);   // この1冊に入らない日
  const op = faded ? ' opacity=".35"' : '';
  const ky = koyoOf(d, opt, faded);
  const hn = opt.hol && !faded && holidayName(d);
  const fit = (t, size) => ([...t].length * size > cw - 1 ? ` textLength="${nf(cw - 1)}" lengthAdjust="spacingAndGlyphs"` : '');
  if (cw < 13) {
    // 細い列（メモを 1/2 にしたときなど）：六曜は いちばん下の行に
    let o = svgText(cx, TOP + 3.2, 1.8, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700"${op}${dowAttr(d.getDay())}`);
    o += moonMark(x + 1.4, TOP + 5, .7, ky.mo);
    o += kyuText(x + cw - .6, TOP + 5.6, 1.2, ky.kyu);
    o += dayNum(cx, TOP + 8.6, 2.4, 3.2, d, faded, opt);
    if (hn) o += svgText(cx, TOP + 12.6, 1.4, hn, ` text-anchor="middle" data-holiday="1"${fit(hn, 1.4)}`);
    o += seEv(cx, TOP + 14.6, 1.3, ky.se, ky.ev, 'middle', cw - 1);
    if (ky.ro) o += svgText(cx, TOP + 16.5, 1.3, ky.ro, ' text-anchor="middle" data-rokuyo="1"');
    return o;
  }
  let o = svgText(cx, TOP + 3.4, 2, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700" letter-spacing=".2"${op}${dowAttr(d.getDay())}`);
  o += moonMark(x + 1.6, TOP + 2.8, .8, ky.mo);
  // ★v0.2.105 六曜は 文字を 大きくしても そのまま（曜日と かさならないように）
  if (ky.ro) o += svgText(x + cw - .8, TOP + 3.4, 1.5, ky.ro, ' text-anchor="end" data-noscale="1" data-rokuyo="1"');
  o += kyuText(x + cw - .8, TOP + 5.1, 1.3, ky.kyu);   // 日付の丸（上はし TOP+5.4）にかからない高さ
  o += dayNum(cx, TOP + 8, 2.6, 3.4, d, faded, opt);
  if (hn) o += svgText(cx, TOP + 12.8, 1.6, hn, ` text-anchor="middle" data-holiday="1"`);   // 6文字でも 9.6mm＝列（14mm）におさまる
  o += seEv(cx, TOP + 15.4, 1.6, ky.se, ky.ev, 'middle', cw - 1);
  return o;
}

// ----- 週のバーティカル（W1・W2・W3・W11 でつかう）-----
//   cfg.hours＝[はじめ, おわり]、cfg.memo＝右の方眼メモのはばの割合（0＝メモなし）
//   cfg.split＝1日の列をたてにいくつに分けるか（点線）
//   cfg.index＝右はしに 1〜12月のインデックス（メモとのあいだに）
//   cfg.night＝線をうすくして 30分の点線を引かない時間（メモとしても書ける）
//   cfg.days5＝月〜金の5日だけ、cfg.kou＝校時（朝・1〜6時間目・放課後）、cfg.half＝30分の点線
//   cfg.bottom＝下のはしの欄（0＝なし 1＝メモ 2＝子どもの記録）
function verticalWeek(at, fmt, opt, cfg) {
  const { X1, X2, TOP } = PG, HEAD = 17, BOT = cfg.bottom ? 182 : 220;
  const TW = 7;                                       // 時間の列のはば
  const IW0 = 8;                                      // インデックスのはば
  const ML = cfg.memo && cfg.memoSide === 'l';        // メモを左におく（オーダーメイド）
  const MW = cfg.memo ? (X2 - X1) * cfg.memo : 0;     // メモのはば
  // A1〜A2＝日の欄（メモが左のときは 右へずらす）、XM＝そのみぎはし（これまでの名前のまま）
  const A1 = ML ? X1 + MW : X1;
  const XM = ML ? X2 - (cfg.index ? IW0 + 2 : 0) : X2 - MW;
  const week = weekDates(at);
  const days = cfg.days5 ? week.filter(d => d.getDay() >= 1 && d.getDay() <= 5) : week;   // 月〜金だけにもできる
  const nd = days.length;
  //   v0.2.101：cfg.noon＝お昼（12〜13時）に うすい帯／cfg.bold＝太くする 時間／cfg.dayTop＝1日の 上の メモ欄（mm）
  //             cfg.dayBottom＝1日の 下の メモ欄（mm）／cfg.checks＝下の チェック□の数／cfg.blocks＝時間を ブロックで 分ける
  //             cfg.gridBase＝方眼を しく（mm）／cfg.smallWeekend＝土日を 小さく
  const gx = A1 + TW;
  const wOf = d => (cfg.smallWeekend && (d.getDay() === 0 || d.getDay() === 6) ? .6 : 1);
  const wSum = days.reduce((a, d) => a + wOf(d), 0);
  const cwUnit = (XM - gx) / wSum;
  const colX = [];
  { let acc = gx; days.forEach(d => { colX.push(acc); acc += cwUnit * wOf(d); }); colX.push(XM); }
  const cwAt = c => colX[c + 1] - colX[c];
  const cx0 = c => colX[c];
  const cw = (XM - gx) / nd;   // 均等のときの はば（いままでと 同じ）
  const KOU = [L('朝', 'AM'), '1', '2', '3', '4', '5', '6', L('放課後', 'After')];   // 校時（学校の1日）
  const h0 = cfg.hours[0], h1 = Math.max(cfg.hours[0] + 1, cfg.hours[1]);
  const TOPM = cfg.dayTop || 0, BOTM = cfg.dayBottom || 0;   // 上下の メモ欄の ぶん（時間は そのあいだに）
  const TY = TOP + HEAD + TOPM, BY2 = BOT - BOTM;
  const n = cfg.kou ? KOU.length : cfg.blocks ? cfg.blocks.length : h1 - h0;
  const hh = (BY2 - TY) / n;
  const isNight = h => (cfg.night || []).some(([a, b]) => h >= a && h < b);
  let o = weekHead(at, opt, week);
  // 今日の列（画面だけ）
  days.forEach((d, c) => {
    if (opt.today && sameDay(d, TODAY)) o += todayRect(cx0(c) + .5, TOP + .5, cwAt(c) - 1, BOT - TOP - 1);
  });
  // 方眼を しく（4mm など。線の 下に うすく）
  if (cfg.gridBase) o += memoBox(A1, TOP + HEAD, XM - A1, BOT - TOP - HEAD, { type: 2, sp: MEMO_SPACES.indexOf(cfg.gridBase) < 0 ? 4 : MEMO_SPACES.indexOf(cfg.gridBase), wt: 0, st: 0, em: 0, nf: true }).replace(/data-memo-type=/g, 'data-gridbase=');
  // わく・曜日の列
  o += `<rect x="${nf(A1)}" y="${TOP}" width="${nf(XM - A1)}" height="${nf(BOT - TOP)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(A1, TOP + HEAD, XM, TOP + HEAD, .3);
  o += svgLine(gx, TOP, gx, BOT, .25);
  for (let c = 1; c < nd; c++) o += svgLine(cx0(c), TOP, cx0(c), BOT, .2);
  for (let c = 0; c < nd && cfg.split > 1; c++) {
    for (let j = 1; j < cfg.split; j++) o += svgLine(cx0(c) + cwAt(c) * j / cfg.split, TOP + HEAD, cx0(c) + cwAt(c) * j / cfg.split, BOT, .12, ' stroke-dasharray=".4 .8" data-split="1"');
  }
  days.forEach((d, c) => { o += dayColumnHead(cx0(c), cwAt(c), TOP, d, opt); });
  // 1日の 上の メモ欄（今日の いちばん・Dominant）
  if (cfg.dayTop) {
    const y = TOP + HEAD + cfg.dayTop;
    o += svgLine(A1, y, XM, y, .25, ' data-daytop="1"');
  }
  // 1日の 下の メモ欄（やったこと）
  if (cfg.dayBottom) {
    const y = BOT - cfg.dayBottom;
    o += svgLine(A1, y, XM, y, .25, ' data-daybottom="1"');
  }
  if (cfg.kou) {
    // 校時：朝・1〜6時間目・放課後（時刻のかわりに行の名前）
    for (let k = 0; k < n; k++) {
      const y = TY + hh * k;
      if (k) o += svgLine(gx, y, XM, y, .2);
      o += svgText(A1 + TW - 1, y + hh / 2 + .8, KOU[k].length > 1 ? 1.7 : 2.4, KOU[k], ' text-anchor="end" font-weight="700" data-kou="1"');
    }
  } else {
  // 時間の目もり（1時間ごとに線、30分は点線。夜の時間は うすい線だけ）
  const small = hh < 8;   // 目もりがつまるときは数字を小さく
  // お昼（12〜13時）に うすい帯（ごはんの 目じるし）
  if (cfg.noon && !cfg.blocks && h0 <= 12 && h1 > 12) {
    const y = TY + hh * (12 - h0);
    o += `<rect class="line" x="${nf(gx)}" y="${nf(y)}" width="${nf(XM - gx)}" height="${nf(hh)}" fill="${INK_C}" opacity=".08" data-noon="1"/>`;
  }
  // ブロックで 分ける（8・12・15・18・21時 など。こまかくしない人むけ）
  if (cfg.blocks) {
    cfg.blocks.forEach((h, k) => {
      const y = TY + hh * k;
      if (k) o += svgLine(gx, y, XM, y, .25);
      o += svgText(A1 + TW - 1, y + 3, 2.2, h, ' text-anchor="end" font-weight="700" data-hour="1"');
    });
  } else
  for (let k = 0; k <= n; k++) {
    const y = TY + hh * k, h = h0 + k;
    const night = isNight(h) || (k > 0 && isNight(h - 1) && k === n);
    // 12時・18時などは 線を 太く（午前／午後／夜の 区切り）
    const boldH = (cfg.bold || []).includes(h);
    if (k > 0 && k < n) o += svgLine(gx, y, XM, y, isNight(h - 1) && isNight(h) ? .12 : boldH ? .35 : .2);
    o += svgText(A1 + TW - 1, y + (small ? (k === 0 ? 2.2 : k === n ? -.6 : .7) : (k === 0 ? 2.6 : k === n ? -.8 : .9)), small ? 1.9 : 2.2, h, ` text-anchor="end" font-weight="700" data-hour="1"${night ? ' opacity=".6"' : ''}`);
    if (k < n && !isNight(h) && cfg.half !== false) o += svgLine(gx, y + hh / 2, XM, y + hh / 2, .12, ' stroke-dasharray=".4 .8" data-half="1"');
  }
  }
  // 1日ごとの チェックの □（下のはしに）
  if (cfg.checks) days.forEach((d, c) => {
    for (let k = 0; k < cfg.checks; k++) {
      const bx = cx0(c) + 1.2, by = BY2 - 3.2 - k * 3.4;
      if (by < TY) break;
      o += `<rect x="${nf(bx)}" y="${nf(by)}" width="2.2" height="2.2" rx=".3" fill="none" stroke="${INK_C}" stroke-width=".15" data-daycheck="1"/>`;
    }
  });
  // 下のはしの欄（メモ・子どもの記録）
  if (cfg.bottom) {
    const BY = BOT + 6, BH = 220 - BY;
    o += svgText(A1, BY - 1.5, 2.2, cfg.bottom === 2 ? L('子どもの記録', 'KIDS') : 'MEMO', ` font-weight="700" letter-spacing=".3" data-memo="1"`);
    if (cfg.bottom === 2) {
      // 子どもの記録：日ごとの列をそのままのばして、書く点線を3本
      o += `<rect x="${nf(A1)}" y="${nf(BY)}" width="${nf(XM - A1)}" height="${nf(BH)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
      o += svgLine(gx, BY, gx, BY + BH, .25);
      for (let c = 1; c < nd; c++) o += svgLine(gx + cw * c, BY, gx + cw * c, BY + BH, .2);
      for (let j = 1; j <= 3; j++) o += svgLine(gx + 1, BY + BH * j / 4, XM - 1, BY + BH * j / 4, .12, ' stroke-dasharray=".4 .8" data-kidline="1"');
    } else o += memoBox(A1, BY, XM - A1, BH, cfg.memoSpec);
  }
  // メモ（方眼）とインデックス
  const IW = IW0;
  if (cfg.memo) o += (ML ? memoBox(X1, TOP, MW - 3, BOT - TOP, cfg.memoSpec)
    : memoBox(XM + 3, TOP, X2 - XM - 3 - (cfg.index ? IW + 2 : 0), BOT - TOP, cfg.memoSpec));
  if (cfg.index) o += monthIndex(X2 - IW, IW, TOP, BOT, at.m);
  return o + miniRow(cfg.mini ? { ...fmt, mini: cfg.mini } : fmt, at, opt);
}

// ----- 週間バーチカルレフト（★v0.2.107 形を なおした）-----
//   お手本：ラコニック「仕事計画」DIARY Pre.9 A5 バーチカルレフト
//   **上の段に 3日・下の段に 4日**。上の段の いちばん左は メモの 箱。右に 大きな メモ、右はしに 月の インデックス
//   cfg：hours＝[はじめ, おわり]／memo＝右の メモの はばの わりあい／memoSide＝'l' で 左／index＝月の インデックス
//       split＝1日を たてに 分ける／dayTop＝その日の トピックの らん（mm）／dayBottom＝やったことの らん（mm）
//       checks＝やることの □ の 数／noon＝お昼に うすい 帯／gridBase＝方眼を しく（mm）／mini＝下の カレンダーの 数
function vleftWeek(at, fmt, opt, cfg) {
  const { X1, X2, TOP } = PG, BOT = 220, IW = 8;
  const MW = (X2 - X1) * (cfg.memo || 0);
  const ML = cfg.memoSide === 'l';
  const IX = cfg.index ? IW + 2 : 0;                    // インデックスの ぶん
  const XA = ML ? X1 + MW : X1;                          // 日の ところの 左はし
  const XM = ML ? X2 - IX : X2 - MW - IX;                // 日の ところの 右はし
  const GY = 3, th = (BOT - TOP - GY) / 2;               // 上下の あいだ・1段の 高さ
  const cw = (XM - XA) / 4;                              // 列の はば（下の段が 4つ）
  const HEAD = 17, TW = 4.4;                             // 日の 見出し・時間の めもりの はば
  const h0 = cfg.hours[0], h1 = Math.max(h0 + 1, cfg.hours[1]);
  const week = weekDates(at);
  let o = weekHead(at, opt, week);
  const tierY = t => TOP + t * (th + GY);
  for (let t = 0; t < 2; t++) {
    if (cfg.gridBase) o += memoBox(XA, tierY(t) + HEAD, XM - XA, th - HEAD, { type: 2, sp: MEMO_SPACES.indexOf(cfg.gridBase) < 0 ? 4 : MEMO_SPACES.indexOf(cfg.gridBase), wt: 0, st: 0, em: 0 }).replace(/data-memo-type=/g, 'data-gridbase=');
    o += `<rect x="${nf(XA)}" y="${nf(tierY(t))}" width="${nf(XM - XA)}" height="${nf(th)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  }
  // 上の段の いちばん左＝自由に つかう 箱（今週の メモ）
  o += svgText(XA + 2, tierY(0) + 4.4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
  o += memoBox(XA + 1.4, tierY(0) + 6, cw - 2.8, th - 7.4, cfg.memoSpec);
  week.forEach((d, i) => {
    const t = i < 3 ? 0 : 1, c = i < 3 ? i + 1 : i - 3;
    const x = XA + cw * c, y = tierY(t);
    if (c) o += svgLine(x, y, x, y + th, .2);
    if (opt.today && sameDay(d, TODAY)) o += todayRect(x + .5, y + .5, cw - 1, th - 1);
    o += dayColumnHead(x, cw, y, d, opt);
    o += svgLine(x, y + HEAD, x + cw, y + HEAD, .3);
    const gy = y + HEAD + (cfg.dayTop || 0), by = y + th - (cfg.dayBottom || 0);
    if (cfg.dayTop) o += svgLine(x, gy, x + cw, gy, .25, ' data-daytop="1"');
    if (cfg.dayBottom) o += svgLine(x, by, x + cw, by, .25, ' data-daybottom="1"');
    const n = h1 - h0, hh = (by - gy) / n;
    o += svgLine(x + TW, gy, x + TW, by, .18);
    if (cfg.noon && h0 <= 12 && h1 > 12) o += `<rect class="line" x="${nf(x + TW)}" y="${nf(gy + hh * (12 - h0))}" width="${nf(cw - TW)}" height="${nf(hh)}" fill="${INK_C}" opacity=".08" data-noon="1"/>`;
    for (let k = 0; k <= n; k++) {
      const yy = gy + hh * k, h = h0 + k;
      if (k > 0 && k < n) o += svgLine(x + TW, yy, x + cw, yy, .15);
      o += svgText(x + TW - .7, yy + (k === 0 ? 1.8 : k === n ? -.5 : .6), 1.5, h, ' text-anchor="end" font-weight="700" data-hour="1"');
      if (k < n) o += svgLine(x + TW, yy + hh / 2, x + cw, yy + hh / 2, .1, ' stroke-dasharray=".4 .8" data-half="1"');
    }
    for (let j = 1; j < (cfg.split || 1); j++) o += svgLine(x + TW + (cw - TW) * j / cfg.split, gy, x + TW + (cw - TW) * j / cfg.split, by, .12, ' stroke-dasharray=".4 .8" data-split="1"');
    for (let k = 0; k < (cfg.checks || 0); k++) {
      const bx = x + TW + 1, bY = by - 3.2 - k * 3.4;
      if (bY < gy) break;
      o += `<rect x="${nf(bx)}" y="${nf(bY)}" width="2.2" height="2.2" rx=".3" fill="none" stroke="${INK_C}" stroke-width=".15" data-daycheck="1"/>`;
    }
  });
  if (MW) o += memoBox(ML ? X1 : XM + 3, TOP, MW - 3, BOT - TOP, cfg.memoSpec);
  if (cfg.index) o += monthIndex(X2 - IW, IW, TOP, BOT, at.m);
  return o + miniRow(cfg.mini ? { ...fmt, mini: cfg.mini } : fmt, at, opt);
}
function drawWeeklyVertical(at, fmt, opt) {
  return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 3, index: true });
}
// できあいの バーチカルレフト（v0.2.107。お手本：ラコニック「仕事計画」DIARY Pre.9 A5 バーチカルレフト）
//   トピック＝その日に いちばん したいこと／方眼メモ 大＝図も 書ける／予定と実際＝1日を 2つに
//   やること□＝日ごとに 5つ／朝がた＝5〜21時＋お昼の帯／3か月＝当月から 翌々月まで
function drawVleftTopic(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 3, index: true, dayTop: 9 }); }
function drawVleftGrid(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 2, index: true }); }
function drawVleftPlanAct(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 3, index: true, split: 2 }); }
function drawVleftCheck(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 3, index: true, checks: 5 }); }
function drawVleftMorning(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [5, 21], memo: 1 / 3, index: true, noon: true }); }
function drawVleft3m(at, fmt, opt) { return vleftWeek(at, fmt, opt, { hours: [7, 24], memo: 1 / 3, index: true }); }

// ----- W11 週間バーティカル式（紙のはばいっぱいに 7日×7:00〜24:00）-----
//   お手本：高橋書店・NOLTY の 週間バーティカル（見開きの7日を1まいに）
function drawWeeklyVerticalFull(at, fmt, opt) {
  return verticalWeek(at, fmt, opt, { hours: [7, 24], memo: 0 });
}

// ----- W3 3分割バーティカル（紙のはばいっぱいに 7日×7:00〜24:00、1日の列を3つに分ける）-----
//   お手本：マークス 3分割週間バーチカル（1日を仕事・家・自分などに分けて書ける）
function drawWeeklySplit3(at, fmt, opt) {
  return verticalWeek(at, fmt, opt, { hours: [7, 24], memo: 0, split: 3 });
}

// ----- W2 24時間バーティカル（紙のはばいっぱいに 7日×0:00〜24:00）-----
//   お手本：ラコニック A5ワーク（24時間対応の見開き1週間バーチカル。深夜の時間帯はフリースペースと兼用）
//   ★夜（0〜6時・22〜24時）は、線をうすくして 30分の点線を引かない＝メモとしても書ける
function drawWeekly24(at, fmt, opt) {
  return verticalWeek(at, fmt, opt, { hours: [0, 24], memo: 0, night: [[0, 6], [22, 24]] });
}

// 週の手帳の見出し（月・年・WEEK）と、今日のしるし・うすくする日の見分け
const weekHead = (at, opt, days) => monthHead(at, `WEEK ${weekNo(opt.ws, days)}`);
const todayRect = (x, y, w, h) => `<rect class="today" data-today="1" x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" rx="1.2" fill="none" stroke="#c14a30" stroke-width=".5"/>`;

// ----- 左に7日の行（W4・W8・W10 でつかう）-----
//   cfg.ratio＝7日の行のはばの割合、cfg.right＝右がわ（'grid'＝方眼メモ、'todo'＝TO DO リスト、'none'＝なし）
//   cfg.time＝[はじめ, おわり]：行の上に横向きの時間の目もり（ないときは書く点線3本）
function leftWeek(at, fmt, opt, cfg) {
  const { X1, X2, TOP } = PG, BOT = 220;
  const SW = cfg.side === 'l';             // 右がわの欄を 左にする（オーダーメイド）
  const DW = (X2 - X1) * cfg.ratio;        // 7日のはば
  const A1 = SW ? X2 - DW : X1;            // 7日のひだりはし
  const XM = A1 + DW;                      // 7日と もうひとつの欄の さかい
  const LW = 14;                            // 曜日・日付の列のはば
  //   v0.2.98：cfg.sunRight＝日曜だけ 右がわの 下に（変則レフト）／cfg.small＝土日を 小さく／cfg.dowBoth＝曜日を 英語＋漢字／cfg.tint＝土日祝に うすい色
  const days = weekDates(at);
  const nDay = cfg.sunRight ? 6 : 7;
  const wOf = d => (cfg.small ? ((d.getDay() === 0 || d.getDay() === 6) ? .68 : 1.128) : 1);
  const wSum = days.slice(0, nDay).reduce((a, d) => a + wOf(d), 0);
  let o = weekHead(at, opt, days);
  o += `<rect x="${A1}" y="${TOP}" width="${nf(XM - A1)}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(A1 + LW, TOP, A1 + LW, BOT, .25);
  let acc = TOP;
  days.forEach((d, k) => {
    if (k >= nDay) return;
    const rh = (BOT - TOP) * wOf(d) / wSum;
    const y = acc, cx = A1 + LW / 2;
    acc += rh;
    if (cfg.tint && (d.getDay() === 0 || d.getDay() === 6 || (opt.hol && holidayName(d)))) o += `<rect class="line" x="${nf(A1)}" y="${nf(y)}" width="${nf(XM - A1)}" height="${nf(rh)}" fill="${INK_C}" opacity=".07" data-wktint="1"/>`;
    if (k) o += svgLine(A1, y, XM, y, .25);
    if (cfg.time) o += timeRuler(A1 + LW + 3, XM - 3, y, rh, cfg.time);
    else { const nl = cfg.lines == null ? 3 : cfg.lines; for (let j = 1; j <= nl; j++) o += svgLine(A1 + LW + 2, y + rh * j / (nl + 1), XM - 2, y + rh * j / (nl + 1), .12, ' stroke-dasharray=".4 .8" data-rowline="1"'); }   // 書く線（点線）
    // ★v0.2.97 レフト式の 中の しかけ（お手本：能率・高橋・博文館・ラコニックなど）
    const wx1 = A1 + LW + 2, wx2 = XM - 2;
    if (cfg.dots) {
      // 時間の 目やすの 点（9・12・3・6 の ところ。数字は 書かない）
      const [d0, d1] = cfg.dotRange || [9, 21];
      for (const h of cfg.dots) {
        if (h < d0 || h > d1) continue;
        const x = wx1 + (wx2 - wx1) * (h - d0) / (d1 - d0);
        o += `<circle class="line" cx="${nf(x)}" cy="${nf(y + 2.6)}" r=".28" fill="${INK_C}" data-tdot="1"/>`;
      }
    }
    if (cfg.split === 1) o += svgLine(wx1, y + rh / 2, wx2, y + rh / 2, .12, ' stroke-dasharray=".5 1" data-split2="1"');   // 上下2段（午前／午後）
    if (cfg.split === 2) for (let j = 1; j <= 2; j++) o += svgLine(wx1 + (wx2 - wx1) * j / 3, y + 1.2, wx1 + (wx2 - wx1) * j / 3, y + rh - 1.2, .12, ' stroke-dasharray=".5 1" data-split3="1"');   // 左右3分割
    if (cfg.split === 3) {
      // 逆N字の 時間軸（1日を 3本に 分ける。お手本：博文館 サジェス）
      const hrs = [[8, 12], [1, 5], [6, 10]];
      hrs.forEach(([a, b], j) => {
        const ly = y + rh * (j + 1) / 4;
        o += svgLine(wx1, ly, wx2, ly, .1, ' data-n3="1"');
        for (let h = a; h <= b; h++) {
          const x = wx1 + (wx2 - wx1) * (h - a) / (b - a);
          o += svgText(x, ly - .8, 1.2, h, ' text-anchor="middle" data-n3h="1"');
        }
      });
    }
    const faded = outBook(d, opt);
    const op = faded ? ' opacity=".35"' : '';
    if (opt.today && sameDay(d, TODAY)) o += todayRect(A1 + .5, y + .5, XM - A1 - 1, rh - 1);
    o += svgText(cx, y + 4, 2, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700" letter-spacing=".2"${op}${dowAttr(d.getDay())}`);
    if (cfg.dowBoth) o += svgText(cx, y + 6.2, 1.6, WDL()[d.getDay()], ` text-anchor="middle"${op}${dowAttr(d.getDay())} data-dowja="1"`);
    const dy = cfg.dowBoth ? 10.8 : 8.6;
    o += dayNum(cx, y + dy, 2.6, 3.4, d, faded, opt);
    const ky = koyoOf(d, opt, faded);
    o += moonMark(cx + 4.2, y + dy, .8, ky.mo);
    const hn = opt.hol && !faded && holidayName(d);
    // 高さが 足りない ときは 字を 小さく して ぜんぶ 入れる（土日を 小さく したとき・v0.2.102）
    const tight = dy + 14.8 >= rh;
    const fs = tight ? 1.2 : 1.5, st = tight ? 2.1 : 2.8, y0 = dy + (tight ? 3.4 : 4.8);
    if (hn) o += svgText(cx, y + y0, fs, hn, ` text-anchor="middle" data-holiday="1"${[...hn].length * fs > LW - 1 ? ` textLength="${nf(LW - 1)}" lengthAdjust="spacingAndGlyphs"` : ''}`);
    o += seEv(cx, y + y0 + st, fs, ky.se, ky.ev, 'middle', LW - 1);
    if (ky.ro) o += svgText(cx, y + y0 + st * 2, fs, ky.ro, ' text-anchor="middle" data-rokuyo="1"');
    o += kyuText(cx, y + y0 + st * 3, fs, ky.kyu, 'middle');
  });
  let rx = SW ? 16 : XM + 3, rw = SW ? A1 - 16 - 3 : X2 - XM - 3;   // もうひとつの欄の ばしょ
  // 右はしに 当月の 日づけを たてに（お手本：キョクトウ PBF54K・コーテッド CDA01）
  let rw2 = rw, rx2 = rx;
  if (cfg.dateCol) {
    const dw = 9, dx = SW ? rx : rx + rw - dw;
    rw2 = rw - dw - 2; if (!SW) rx2 = rx; else rx2 = rx + dw + 2;
    const last = new Date(at.y, at.m, 0).getDate(), dh = (BOT - TOP) / last;
    for (let i = 0; i < last; i++) {
      const d = new Date(at.y, at.m - 1, i + 1), yy = TOP + dh * i;
      // ★祝日は 色だけ かえる（日曜と 同じ）。data-holiday は 紙の 祝日名の しるしなので つけない
      const hol = opt.hol && holidayName(d);
      const mk2 = hol ? ' data-dow="0"' : dowAttr(d.getDay());
      o += svgText(dx + 1, yy + dh - .6, 1.5, WD_EN[d.getDay()][0], ' data-dcolw="1"' + mk2);
      o += svgText(dx + dw - 1, yy + dh - .6, 1.5, i + 1, ' text-anchor="end" data-dcol="1"' + mk2);
    }
  }
  const rx0 = rx, rw0 = rw;
  rx = rx2; rw = rw2;
  // 右がわを 7段に 分ける（曜日ごとの 記録にも つかえる。お手本：デザインフィル PRD-2）
  if (cfg.rightRows) {
    const rh2 = (BOT - TOP) / 7;
    for (let k = 1; k < 7; k++) o += svgLine(rx, TOP + rh2 * k, rx + rw, TOP + rh2 * k, .2, ' data-rrow="1"');
  }
  // 日曜だけ 右がわの 下に（変則レフト。お手本：ナカバヤシ スタンダード・ジュビックPD-1007）
  let rBot = BOT;
  if (cfg.sunRight) {
    const d = days[6], sh = 30, sy = BOT - sh;
    rBot = sy - 3;
    o += `<rect x="${nf(rx)}" y="${nf(sy)}" width="${nf(rw)}" height="${sh}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    o += svgLine(rx + LW, sy, rx + LW, sy + sh, .25);
    o += svgText(rx + LW / 2, sy + 4.4, 2, WD_EN[0], ' text-anchor="middle" font-weight="700" letter-spacing=".2"' + dowAttr(0));
    o += dayNum(rx + LW / 2, sy + 9.4, 2.6, 3.4, d, outBook(d, opt), opt);
    const ky = koyoOf(d, opt, outBook(d, opt));
    const hn = opt.hol && !outBook(d, opt) && holidayName(d);   // 1冊に 入らない 日は 書かない
    o += moonMark(rx + LW / 2 + 4.2, sy + 9.4, .8, ky.mo);
    if (hn) o += svgText(rx + LW / 2, sy + 14.2, 1.5, hn, ' text-anchor="middle" data-holiday="1"');
    o += seEv(rx + LW / 2, sy + 17, 1.5, ky.se, ky.ev, 'middle', LW - 1);
    if (ky.ro) o += svgText(rx + LW / 2, sy + 19.8, 1.5, ky.ro, ' text-anchor="middle" data-rokuyo="1"');
    o += kyuText(rx + LW / 2, sy + 22.4, 1.5, ky.kyu, 'middle');
    // 横の時間を つかう形では 日曜も 同じ 時間の めもりに（点線は 引かない）
    if (cfg.time) o += timeRuler(rx + LW + 3, rx + rw - 3, sy, sh, cfg.time);
    else { const nl = cfg.lines == null ? 3 : cfg.lines; for (let j = 1; j <= nl; j++) o += svgLine(rx + LW + 2, sy + sh * j / (nl + 1), rx + rw - 2, sy + sh * j / (nl + 1), .12, ' stroke-dasharray=".4 .8" data-rowline="1"'); }
  }
  if (cfg.right === 'todo') o += todoBox(rx, TOP, rw, rBot - TOP);
  else if (cfg.right === 'grid') o += gridMemo(rx, TOP, rw, rBot - TOP);
  else if (cfg.right && typeof cfg.right === 'object') o += memoBox(rx, TOP, rw, rBot - TOP, cfg.right);   // オーダーメイドの メモの線
  o += miniRow(fmt, at, opt);
  return o;
}
// 横向きの時間の目もり（行の上に数字と目もり、1時間ごとに うすい点線をたてに。行のまん中に書く点線）
function timeRuler(xa, xb, y, h, [h0, h1]) {
  const step = (xb - xa) / (h1 - h0);
  let o = svgLine(xa, y + 4.6, xb, y + 4.6, .2);
  for (let k = 0; k <= h1 - h0; k++) {
    const x = xa + step * k;
    o += svgText(x, y + 3.2, 1.7, h0 + k, ' text-anchor="middle" font-weight="700" data-htime="1"');
    o += svgLine(x, y + 4.6, x, y + 5.8, .2);
    if (k > 0 && k < h1 - h0) o += svgLine(x, y + 5.8, x, y + h - 1.2, .1, ' stroke-dasharray=".3 .9"');
    if (k < h1 - h0) o += svgLine(x + step / 2, y + 4.6, x + step / 2, y + 5.3, .12);   // 30分
  }
  o += svgLine(xa, y + (h + 5.8) / 2, xb, y + (h + 5.8) / 2, .12, ' stroke-dasharray=".4 .8"');
  return o;
}
// TO DO リスト（□と書く線。行の高さ 7mm）
function todoBox(x, y, w, h) {
  const HH = 8, RH = 7, n = Math.floor((h - HH) / RH);
  let o = `<rect x="${nf(x)}" y="${nf(y)}" width="${nf(w)}" height="${nf(h)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgText(x + 2.4, y + 5.4, 2.4, 'TO DO', ' font-weight="800" letter-spacing=".4" data-todo-head="1"');
  o += svgLine(x, y + HH, x + w, y + HH, .3);
  for (let i = 0; i < n; i++) {
    const cy = y + HH + RH * (i + .5);
    o += `<rect x="${nf(x + 2.4)}" y="${nf(cy - 1.5)}" width="3" height="3" rx=".5" fill="none" stroke="${INK_C}" stroke-width=".25" data-todo="1"/>`;
    o += svgLine(x + 7, y + HH + RH * (i + 1) - 1.2, x + w - 2, y + HH + RH * (i + 1) - 1.2, .12, ' stroke-dasharray=".4 .8"');
  }
  return o;
}

// ----- W9 ライフログ（紙のはばいっぱいに7日×記録の行＋日記）-----
//   お手本：ラコニック B6ライフログ（天気・体温・食事メニュー・ヘルスケアなど、毎日の変化を記録）
//   行：［名前, 高さmm, かたち］。のこりの高さは日記（点線）
const LIFE_ROWS = [
  ['天気', 8, 'weather'], ['体温', 6, 'unit:℃'], ['起床', 6, 'unit::'], ['就寝', 6, 'unit::'],
  ['朝ごはん', 11, 'lines'], ['昼ごはん', 11, 'lines'], ['夜ごはん', 11, 'lines'],
  ['体調', 7, 'dots'], ['歩数', 6, 'unit:歩'],

];
// ★v0.2.159 アメリカの ときの 名前（無い ものは そのまま）
const LIFE_EN = { '天気': 'Weather', '体温': 'Temp', '起床': 'Wake', '就寝': 'Sleep', '朝ごはん': 'Breakfast', '昼ごはん': 'Lunch', '夜ごはん': 'Dinner', '体調': 'Health', '歩数': 'Steps', '日記': 'Diary', '℃': '°F', '歩': 'steps' };
// 天気の小さな絵（線だけ）：晴れ・くもり・雨
function weatherIcons(cx, cy) {
  const L = (d) => `<path d="${d}" fill="none" stroke="${INK_C}" stroke-width=".22" stroke-linecap="round" stroke-linejoin="round"/>`;
  const sx = cx - 4.4, rx = cx + 4.2;   // 晴れの光とくもがくっつかないように
  const rays = [0, 45, 90, 135, 180, 225, 270, 315].map(a => { const r = Math.PI * a / 180; return `M${nf(sx + Math.cos(r) * 1.25)} ${nf(cy + Math.sin(r) * 1.25)}L${nf(sx + Math.cos(r) * 1.7)} ${nf(cy + Math.sin(r) * 1.7)}`; }).join('');
  return `<g data-weather="1"><circle cx="${nf(sx)}" cy="${nf(cy)}" r=".8" fill="none" stroke="${INK_C}" stroke-width=".22"/>${L(rays)}`
    + L(`M${nf(cx - 1.4)} ${nf(cy + .7)}h2.8a.8 .8 0 0 0 0-1.6a1.1 1.1 0 0 0-2.1-.3a.8 .8 0 0 0-.7 1.9z`)
    + L(`M${nf(rx - 1.5)} ${nf(cy - .1)}a1.5 1.5 0 0 1 3 0z M${nf(rx)} ${nf(cy - .1)}v1.3a.5 .5 0 0 1-1 0`) + '</g>';
}
//   cfg（オーダーメイド）：days5＝月〜金の5日だけ
function drawLifeLog(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, HEAD = 17, BOT = 220, LW = 14;
  const week = weekDates(at);
  const days = cfg.days5 ? week.filter(d => d.getDay() >= 1 && d.getDay() <= 5) : week;
  const nd = days.length;
  const gx = X1 + LW, cw = (X2 - gx) / nd;
  let o = weekHead(at, opt, week);
  days.forEach((d, c) => {
    if (opt.today && sameDay(d, TODAY)) o += todayRect(gx + cw * c + .5, TOP + .5, cw - 1, BOT - TOP - 1);
  });
  o += `<rect x="${X1}" y="${TOP}" width="${X2 - X1}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
  o += svgLine(X1, TOP + HEAD, X2, TOP + HEAD, .3);
  o += svgLine(gx, TOP, gx, BOT, .25);
  for (let c = 1; c < nd; c++) o += svgLine(gx + cw * c, TOP, gx + cw * c, BOT, .2);
  days.forEach((d, c) => { o += dayColumnHead(gx + cw * c, cw, TOP, d, opt); });
  // 記録の行
  let y = TOP + HEAD;
  const rows = [...LIFE_ROWS, ['日記', BOT - TOP - HEAD - LIFE_ROWS.reduce((a, r) => a + r[1], 0), 'diary']];
  rows.forEach(([name0, h, kind], k) => {
    const name = L(name0, LIFE_EN[name0] || name0);   // 国で 名前を 切りかえ（辞書は I18N.<言葉>.life でも 上書きできる）
    if (k) o += svgLine(X1, y, X2, y, .2);
    const small = [...name].length > 2;
    o += svgText(X1 + LW / 2, kind === 'diary' ? y + 5 : y + h / 2 + .7, small ? 1.8 : 2.1, name, ' text-anchor="middle" font-weight="700" data-life="1"');
    for (let c = 0; c < nd; c++) {
      const x = gx + cw * c, cx = x + cw / 2, cy = y + h / 2;
      if (kind === 'weather') o += weatherIcons(cx, cy);
      else if (kind.startsWith('unit:')) o += svgText(x + cw - 1.4, cy + .7, 1.7, L(kind.slice(5), LIFE_EN[kind.slice(5)] || kind.slice(5)), ' text-anchor="end"');
      else if (kind === 'lines') for (let j = 1; j <= 2; j++) o += svgLine(x + 1.2, y + h * j / 3, x + cw - 1.2, y + h * j / 3, .1, ' stroke-dasharray=".4 .8"');
      else if (kind === 'dots') for (let j = 0; j < 5; j++) o += `<circle cx="${nf(cx + (j - 2) * 2.3)}" cy="${nf(cy)}" r=".75" fill="none" stroke="${INK_C}" stroke-width=".2"/>`;
      else if (kind === 'diary') for (let yy = y + 8; yy < y + h - 1; yy += 6) o += svgLine(x + 1.2, yy, x + cw - 1.2, yy, .1, ' stroke-dasharray=".4 .8"');
    }
    y += h;
  });
  return o + miniRow(fmt, at, opt);
}

// ----- W4 週間レフト式（左半分＝7日の横長の行、右半分＝方眼メモ。7行はどれも同じ高さ）-----
//   お手本：高橋書店 レフト式・マークス 週間レフト・アシュフォード レフト式（左ページに7日、右ページにメモ）を1まいに
function drawWeeklyLeft(at, fmt, opt) {
  return leftWeek(at, fmt, opt, { ratio: 1 / 2, right: 'grid' });
}

// ----- W10 ホリゾンタルタイム（紙のはばいっぱいに7日の横長の行。行の上に 8〜22時の横向きの目もり）-----
//   お手本：アシュフォード 週間ダイアリー（ホリゾンタルタイム式）
function drawHorizontalTime(at, fmt, opt) {
  return leftWeek(at, fmt, opt, { ratio: 1, right: 'none', time: [8, 22] });
}

// ----- W8 タスクログ（左 約6割＝7日の行、右 約4割＝その週の TO DO リスト）-----
//   お手本：ラコニック B6／B6Cタスクログ（曜日にしばられず、その週にすることを書ける TO DO リスト）
function drawTaskLog(at, fmt, opt) {
  return leftWeek(at, fmt, opt, { ratio: .6, right: 'todo' });   // 2026-09-18 .58 → .6（オーダーメイドの「6:4」と同じに）
}

// ----- W5 週間セパレート式（上に4日、下に3日＋メモ。8つの横長の欄はどれも同じ高さ）-----
//   お手本：高橋書店 セパレート式・本の「週間セパレート式」（左ページ4日・右ページ3日＋メモ）を1まいに
//   cfg（オーダーメイド）：top＝上のかたまりに入れる日の数（4／3）、memo＝メモ欄、lines＝書く点線の数
function drawWeeklySeparate(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, BOT = 220, GAP = 4;   // GAP＝上と下のあいだ（本の見開きの「のど」）
  const LW = 16;                                           // 左の曜日・日付の列のはば
  //   v0.2.103：cfg.cross＝日付の となりに 十字の 小さな 欄（リンクアップ式）／cfg.time＝[はじめ, おわり] 横の 時間めもり
  //             cfg.memoCols＝右はしに たての メモ欄（2つ）／cfg.bottomMemo＝下に メモ（mm）／cfg.gridBase＝方眼を しく（mm）
  const topDays = cfg.top || 4, memo = cfg.memo !== false, nl = cfg.lines == null ? 4 : cfg.lines;
  const CW = cfg.cross ? 30 : 0, MC = cfg.memoCols ? 26 : 0;
  const days = weekDates(at);
  // ならべる欄：上のかたまり → 下のかたまり（メモはあれば 3日＋3日のときは上、ほかは下のおわり）
  const slots = [...days.map((d, i) => ({ d, i })), ...(memo ? [{ memo: true }] : [])];
  const list = memo && cfg.memoTop ? [{ memo: true }, ...days.map((d, i) => ({ d, i }))]
    : memo && topDays === 3 ? [...days.slice(0, 3).map((d, i) => ({ d, i })), { memo: true }, ...days.slice(3).map((d, i) => ({ d, i: i + 3 }))] : slots;
  const n1 = topDays + (memo && (cfg.memoTop || topDays === 3) ? 1 : 0), n2 = list.length - n1;
  const BOT2 = BOT - (cfg.bottomMemo || 0);
  const rh = (BOT2 - TOP - GAP) / list.length;
  let o = weekHead(at, opt, days);
  const rowY = k => TOP + rh * k + (k >= n1 ? GAP : 0);
  // 2つのかたまりのわく
  [[0, n1], [n1, n2]].forEach(([k, n]) => {
    o += `<rect x="${X1}" y="${nf(rowY(k))}" width="${X2 - X1}" height="${nf(rh * n)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    if (cfg.gridBase) o += memoBox(X1 + LW, rowY(k), X2 - X1 - LW, rh * n, { type: 2, sp: MEMO_SPACES.indexOf(cfg.gridBase) < 0 ? 4 : MEMO_SPACES.indexOf(cfg.gridBase), wt: 0, st: 0, em: 0, nf: true }).replace(/data-memo-type=/g, 'data-gridbase=');
    o += svgLine(X1 + LW, rowY(k), X1 + LW, rowY(k) + rh * n, .25);
    // 十字の 小さな 欄（お手本：高橋書店の リンクアップ式）
    if (CW) { o += svgLine(X1 + LW + CW, rowY(k), X1 + LW + CW, rowY(k) + rh * n, .25); }
    // 右はしの たてメモ 2列（お手本：博文館 デスクプランナー「市況・収支など」）
    if (MC) { o += svgLine(X2 - MC, rowY(k), X2 - MC, rowY(k) + rh * n, .25); o += svgLine(X2 - MC / 2, rowY(k), X2 - MC / 2, rowY(k) + rh * n, .15); }
  });
  for (let k = 0; k < list.length; k++) {
    const y = rowY(k);
    if (k !== 0 && k !== n1) o += svgLine(X1, y, X2, y, .25);
    // 書く線（点線）
    const wx1 = X1 + LW + CW + 2, wx2 = X2 - MC - 2;
    for (let j = 1; j <= nl; j++) o += svgLine(wx1, y + rh * j / (nl + 1), wx2, y + rh * j / (nl + 1), .12, ' stroke-dasharray=".4 .8" data-rowline="1"');
    // 十字（まん中に たてと よこの 線）
    if (CW && !list[k].memo) { o += svgLine(X1 + LW, y + rh / 2, X1 + LW + CW, y + rh / 2, .12, ' data-cross="1"'); o += svgLine(X1 + LW + CW / 2, y, X1 + LW + CW / 2, y + rh, .12, ' data-cross="1"'); }
    // 横の 時間めもり（お手本：高橋 リシェル2・ダイアモンドダイアリー）
    if (cfg.time && !list[k].memo) {
      const [t0, t1] = cfg.time, tw = (wx2 - wx1) / (t1 - t0);
      for (let h = t0; h <= t1; h++) {
        const x = wx1 + tw * (h - t0);
        o += svgText(x, y + 2.6, 1.3, h, ' text-anchor="middle" data-septime="1"');
        if (h < t1) o += svgLine(x + tw / 2, y + 1.6, x + tw / 2, y + 2.6, .1);
      }
      o += svgLine(wx1, y + 3.4, wx2, y + 3.4, .15);
    }
    if (list[k].memo) {
      o += svgText(X1 + LW / 2, y + 5, 2.2, 'MEMO', ' text-anchor="middle" font-weight="700" letter-spacing=".3" data-memo="1"');
      continue;
    }
    const d = list[k].d, cx = X1 + LW / 2;
    const faded = outBook(d, opt);
    const op = faded ? ' opacity=".35"' : '';
    if (opt.today && sameDay(d, TODAY)) o += todayRect(X1 + .5, y + .5, X2 - X1 - 1, rh - 1);
    // ★v0.2.105 行が 低いときは 字を 小さく して、列から はみ出さない ようにする
    const tight = rh < 20;   // ★下メモを つけて 行が 低いときだけ 小さくする（ふつうは 23.25mm）
    const fs = tight ? 1.2 : 1.6, st = tight ? 2.2 : 2.9;
    const dy0 = tight ? 3.2 : 4, dy1 = tight ? 6.8 : 8.6, y0 = tight ? 9.6 : 14;
    o += svgText(cx, y + dy0, tight ? 1.6 : 2, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700" letter-spacing=".2"${op}${dowAttr(d.getDay())}`);
    o += dayNum(cx, y + dy1, tight ? 2.1 : 2.6, tight ? 2.8 : 3.4, d, faded, opt);
    const ky = koyoOf(d, opt, faded);
    o += moonMark(cx + (tight ? 3.8 : 4.6), y + dy1, tight ? .75 : .9, ky.mo);
    const hn = opt.hol && !faded && holidayName(d);
    const fit = t => ([...t].length * fs > LW - 1 ? ` textLength="${nf(LW - 1)}" lengthAdjust="spacingAndGlyphs"` : '');
    if (hn) o += svgText(cx, y + y0, fs, hn, ` text-anchor="middle" data-holiday="1"${fit(hn)}`);
    o += seEv(cx, y + y0 + st, fs, ky.se, ky.ev, 'middle', LW - 1);
    if (ky.ro) o += svgText(cx, y + y0 + st * 2, fs, ky.ro, ' text-anchor="middle" data-rokuyo="1"');
    o += kyuText(cx, y + y0 + st * 3, fs, ky.kyu, 'middle');
  }
  o += miniRow(fmt, at, opt);
  return o;
}

// ----- W6 週間ブロック式（2列×4段の8マス。左の列に月〜木、右の列に金・土・日とメモ）-----
//   お手本：高橋書店 週間ブロック式・マークス 週間ブロック・ラコニック B6ブロック（見開き1週間ブロック＋方眼メモ）を1まいに
//   cfg（オーダーメイド）：memo＝メモのマス（false で 8つめも使わない）、lines＝マスの中の書く点線の数
function drawWeeklyBlock(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, BOT = 220, GAP = 4, HH = 8.4;   // HH＝マスの上の見出しの高さ
  const memo = cfg.memo !== false, nl = cfg.lines == null ? 0 : cfg.lines;
  const w = (X2 - X1 - GAP) / 2, rh = (BOT - TOP) / 4;
  const days = weekDates(at);
  let o = weekHead(at, opt, days);
  [X1, X1 + w + GAP].forEach(x => {
    o += `<rect x="${nf(x)}" y="${TOP}" width="${nf(w)}" height="${BOT - TOP}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    for (let r = 1; r < 4; r++) o += svgLine(x, TOP + rh * r, x + w, TOP + rh * r, .25);
  });
  const mk = cfg.memoTop ? 0 : 7;          // メモのマスの ばしょ（0＝左上・7＝右下）
  for (let k = 0; k < 8; k++) {
    const x = k < 4 ? X1 : X1 + w + GAP, y = TOP + rh * (k % 4);
    o += svgLine(x + 1.5, y + HH, x + w - 1.5, y + HH, .12, ' stroke-dasharray=".4 .8"');
    for (let j = 1; j <= nl; j++) o += svgLine(x + 1.5, y + HH + (rh - HH) * j / (nl + 1), x + w - 1.5, y + HH + (rh - HH) * j / (nl + 1), .12, ' stroke-dasharray=".4 .8" data-rowline="1"');
    if (memo ? k === mk : k === 7) {
      if (memo) {
        o += svgText(x + 2, y + 5.6, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
        o += memoBox(x + 1, y + HH + 1, w - 2, rh - HH - 2, cfg.memoSpec);
      }
      continue;
    }
    const d = days[memo && cfg.memoTop ? k - 1 : k];
    const faded = outBook(d, opt);
    const op = faded ? ' opacity=".35"' : '';
    if (opt.today && sameDay(d, TODAY)) o += todayRect(x + .5, y + .5, w - 1, rh - 1);
    // 見出し：日付の丸・曜日・祝日・二十四節気 …（右はし）月のしるし・六曜
    o += dayNum(x + 4.2, y + 4.2, 2.6, 3.4, d, faded, opt);
    o += svgText(x + 8.2, y + 5.1, 2, WD_EN[d.getDay()], ` font-weight="700" letter-spacing=".2"${op}${dowAttr(d.getDay())}`);
    const ky = koyoOf(d, opt, faded);
    const hn = opt.hol && !faded && holidayName(d);
    if (hn) o += svgText(x + 16, y + 5, 1.8, hn, ' data-holiday="1"');
    o += seEv(x + 16 + (hn ? [...hn].length * 1.8 + 1.8 : 0), y + 5, 1.8, ky.se, ky.ev, 'start', w - 31 - (hn ? [...hn].length * 1.8 + 1.8 : 0));   // 右はしの 月のしるし・旧暦・六曜 の手前まで
    o += moonMark(x + w - 6.4, y + 4.4, .8, ky.mo);
    o += kyuText(x + w - 8.2, y + 5, 1.6, ky.kyu);
    if (ky.ro) o += svgText(x + w - 1.6, y + 5, 1.7, ky.ro, ' text-anchor="end" data-rokuyo="1"');
  }
  o += miniRow(fmt, at, opt);
  return o;
}

// ----- 2週間式（14日の横長の行。1週間ずつ2つのかたまり）-----
//   お手本：ライフ 1A／7A・マルマン 583-9・ミドリ PRH-2・無印 スリム手帳・Letts 73SX・
//           ナカバヤシ スリムツーウイーク・能率手帳エクセル 1381（手帳カタログ本の 写真 10まい・v0.2.107）
//   cfg（オーダーメイド）：lines＝書く点線の数、memo＝右にメモの列、gap＝上下のあいだ
//   v0.2.107：time＝ぜんぶの行に 時間の めもり（ライフ 1A）／timeEnds＝かたまりの はじめと おわりの行だけ（能率 1381）
//             dots＝時間の 目やすの 点 2つ（マルマン 583-9）／mid＝まん中に たて線（ミドリ PRH-2）
//             goal＝上に「今週の目標」の 帯（ライフ 7A）／bottomMemo＝下に メモ（ミドリ PRH-2）
//             plain＝日付と 曜日と 祝日だけ（無印）／dowBoth＝曜日に 漢字も（マルマン・ナカバヤシ）
//             mirror＝2週めの 日づけを 右はしに（Letts 73SX の 見開きの 外がわ）
function drawBiweekly(at, fmt, opt, cfg = {}) {
  const { X1, X2, TOP } = PG, BOT0 = 220, GAP = cfg.gap === false ? 0 : 4;
  const LW = 16, MW = 42;
  const BM = cfg.bottomMemo ? 40 : 0;                       // 下の メモの 高さ
  const BOT = BOT0 - (BM ? BM + 3 : 0);
  const ML = cfg.memo && cfg.memoSide === 'l';   // メモの列を左におく（オーダーメイド）
  const AL = ML ? X1 + MW : X1;         // 日の行の左はし
  const XR = ML ? X2 : (cfg.memo ? X2 - MW : X2);   // 日の行の右はし（メモの列を入れるとせまくなる）
  const nl = cfg.lines == null ? 1 : cfg.lines;
  const GH = cfg.goal ? 8 : 0;                              // 「今週の目標」の 帯の 高さ
  const nb = GAP ? 2 : 1, per = 14 / nb;                    // かたまりの数・1かたまりの日の数
  const bh = (BOT - TOP - (nb - 1) * GAP) / nb;             // かたまりの 高さ
  const rh = (bh - GH) / per;
  const days = weekDates(at, 14);
  const koyoBottom = !!(cfg.time || cfg.timeEnds);          // 時間の めもりが あるときは 暦を 行の 下に
  let o = weekHead(at, opt, days);
  const bTop = b => TOP + b * (bh + GAP);
  const rowY = k => bTop(Math.floor(k / per)) + GH + rh * (k % per);
  const isRight = b => !!(cfg.mirror && b === 1);           // そのかたまりの 日づけを 右はしに
  for (let b = 0; b < nb; b++) {
    const y0 = bTop(b), right = isRight(b);
    o += `<rect x="${nf(AL)}" y="${nf(y0)}" width="${nf(XR - AL)}" height="${nf(bh)}" fill="none" stroke="${INK_C}" stroke-width=".35"/>`;
    if (GH) {
      o += svgText(AL + 2, y0 + 5.4, 2.2, L('今週の目標', 'WEEKLY GOALS'), ' font-weight="700" letter-spacing=".2" data-goal="1"');
      o += svgLine(AL, y0 + GH, XR, y0 + GH, .3);
    }
    const dx = right ? XR - LW : AL + LW;
    o += svgLine(dx, y0 + GH, dx, y0 + bh, .25);
    if (cfg.mid) {                                          // まん中に たて線（仕事と 私用を 書き分ける）
      const wa = right ? AL : AL + LW, wb = right ? XR - LW : XR;
      o += svgLine((wa + wb) / 2, y0 + GH, (wa + wb) / 2, y0 + bh, .15, ' data-mid="1"');
    }
  }
  if (cfg.memo) {
    const mx = ML ? 16 : XR + 3;                 // メモの列の 左はし（左のときは 紙のはしから）
    const mw = ML ? MW - 3 : X2 - XR - 3;
    o += svgText(mx, TOP + 4, 2.2, 'MEMO', ' font-weight="700" letter-spacing=".3" data-memo="1"');
    o += memoBox(mx, TOP + 5.5, mw, BOT - TOP - 5.5, cfg.memoSpec);
  }
  if (BM) o += memoBox(AL, BOT + 3, XR - AL, BM, cfg.memoSpec);   // 下の メモ（ミドリ PRH-2）
  days.forEach((d, k) => {
    const b = Math.floor(k / per), i = k % per, y = rowY(k), right = isRight(b);
    const dx0 = right ? XR - LW : AL;                       // 日づけの 列の 左はし
    const wx1 = (right ? AL : AL + LW) + 2, wx2 = (right ? XR - LW : XR) - 2;   // 書く欄
    if (i) o += svgLine(AL, y, XR, y, !GAP && k === 7 ? .3 : .2);
    if (cfg.time) o += timeRuler(wx1 + 1, wx2 - 1, y, rh, cfg.time);
    else {
      if (cfg.timeEnds && (i === 0 || i === per - 1)) o += timeHint(wx1 + 1, wx2 - 1, y, cfg.timeEnds);
      for (let j = 1; j <= nl; j++) o += svgLine(wx1, y + rh * j / (nl + 1), wx2, y + rh * j / (nl + 1), .12, ' stroke-dasharray=".4 .8" data-rowline="1"');   // 書く線（点線）
    }
    // 時間の 目やすの 点（左はしと まん中。お手本：マルマン 583-9）
    if (cfg.dots) for (const f of [0, .5]) o += `<circle class="line" cx="${nf(wx1 + (wx2 - wx1) * f)}" cy="${nf(y + rh / 2)}" r=".3" fill="${INK_C}" data-tdot="1"/>`;
    const faded = outBook(d, opt);
    const op = faded ? ' opacity=".35"' : '';
    if (opt.today && sameDay(d, TODAY)) o += todayRect(AL + .5, y + .5, XR - AL - 1, rh - 1);
    // 左（Letts の形では 右）：曜日と日付の丸を横にならべる
    if (cfg.dowBoth) {
      o += svgText(dx0 + 4.6, y + rh / 2 - .8, 1.8, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700" letter-spacing=".1"${op}${dowAttr(d.getDay())}`);
      o += svgText(dx0 + 4.6, y + rh / 2 + 2.6, 1.7, WDL()[d.getDay()], ` text-anchor="middle"${op}${dowAttr(d.getDay())} data-dowja="1"`);
    } else o += svgText(dx0 + 4.6, y + rh / 2 + .7, 1.9, WD_EN[d.getDay()], ` text-anchor="middle" font-weight="700" letter-spacing=".1"${op}${dowAttr(d.getDay())}`);
    o += dayNum(dx0 + 11.6, y + rh / 2, 2.6, 3.4, d, faded, opt);
    // 書く欄の上（時間の めもりが あるときは 下）：（左）祝日・二十四節気　（右）月のしるし・六曜
    const ty = koyoBottom ? y + rh - 1.2 : y + 2.8;
    const hn = opt.hol && !faded && holidayName(d);
    if (hn) o += svgText(wx1 - .4, ty, 1.8, hn, ' data-holiday="1"');
    if (cfg.plain) return;                                  // 日付と 曜日と 祝日だけ（無印 スリム手帳）
    const ky = koyoOf(d, opt, faded);
    o += seEv(wx1 - .4 + (hn ? [...hn].length * 1.8 + 1.8 : 0), ty, 1.8, ky.se, ky.ev, 'start', wx2 - wx1 - 16 - (hn ? [...hn].length * 1.8 + 1.8 : 0));
    o += moonMark(wx2 - 4.4, ty - .6, .8, ky.mo);
    o += kyuText(wx2 - 6.2, ty, 1.6, ky.kyu);
    if (ky.ro) o += svgText(wx2 + .4, ty, 1.8, ky.ro, ' text-anchor="end" data-rokuyo="1"');
  });
  o += miniRow(fmt, at, opt);
  return o;
}
// 時間の 目やす（数字と 小さな たて線だけ。行の 上に。お手本：能率手帳エクセル 1381）
function timeHint(xa, xb, y, [h0, h1]) {
  const step = (xb - xa) / (h1 - h0);
  let o = '';
  for (let k = 0; k <= h1 - h0; k++) {
    const x = xa + step * k;
    o += svgText(x, y + 2.4, 1.5, h0 + k, ' text-anchor="middle" data-hhint="1"');
    o += svgLine(x, y + 2.9, x, y + 3.9, .15);
  }
  return o;
}
// できあいの 2週間式（v0.2.107）。どれも「形を変える」（C7）で 直せる
function drawBiweekTime(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { time: [8, 20], lines: 0 }); }
function drawBiweekTimeEnds(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { timeEnds: [9, 18], lines: 1 }); }
function drawBiweekDots(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { dots: true, lines: 1, dowBoth: true }); }
function drawBiweekMid(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { mid: true, lines: 2 }); }
function drawBiweekGoal(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { goal: true, lines: 3 }); }
function drawBiweekPlain(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { plain: true, lines: 0 }); }
function drawBiweekBottom(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { bottomMemo: true, lines: 1 }); }
function drawBiweekMirror(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { mirror: true, lines: 0 }); }
function drawBiweekMemo(at, fmt, opt) { return drawBiweekly(at, fmt, opt, { memo: true, memoSide: 'r', lines: 1, dowBoth: true, memoSpec: memoSpec([2, 6, 0, 0, 0]) }); }

// 名前の場所（本店の柄の SVG と同じ。pt → mm）
//   名前：右はし 173.5mm・下の線 250.73mm・3.18mm（本店は左 150.24mm から BirthBookNote が入る）
//   ★☆と右上の3行は 2026-09-18 になくした
function decoSvg() {
  const t = (k, x, y, size, extra = '') => `<text class="ink" fill="${INK_C}" data-bbn="${k}" x="${x}" y="${y}" font-size="${size}"${extra}></text>`;
  return t('name', 173.5, 250.73, 3.18, ' text-anchor="end" letter-spacing=".1"');
}
// 手帳の紙1まい（SVGの文字）。上のまん中に、本店の柄と同じ丸マーク
// 英語の 紙の 辞書（こよみ・行事・曜日・六曜の 2文字・決まった 文字）。画面の ぶんは いちばん下で 足す
I18N.en = { koyo: KOYO_EN, wd: WD_US, ro2: RO_SHORT, paper: {} };
function plannerSvg(note, at = state.at, opt = drawOpt(note)) {
  CTRY = opt.country || 'jp'; PLANG = countryOf(CTRY).lang; if (PLANG !== 'ja' && !I18N[PLANG]) PLANG = 'ja';   // ★v0.2.159 祝日の 国・紙の 言葉
  const f = note.fmt;
  if (f.custom && !opt.cm) opt = { ...opt, cm: state.custom[f.id] };   // オーダーメイドの えらび
  // 基本の形を 変えているときは、その なかまの オーダーメイドの 描き方で 描く（v0.2.85）
  const tv = !f.custom && f.tune ? (opt.cm || state.tune[f.id]) : null;
  const body = sizeBody(tv ? CUSTOM_DRAW[f.tune](at, f, { ...opt, cm: tv }) : f.draw(at, f, opt), opt.size);
  const P = psizeOf(opt.psize || PSIZE);
  if (P.id === 'b5') return `<svg xmlns="http://www.w3.org/2000/svg" width="182mm" height="257mm" viewBox="0 0 182 257"><title>${f.name}</title>`
    + `<rect width="182" height="257" fill="#ffffff"/>${markSvg(INK_C)}${bgSvg(body, opt.bg)}`
    + `<g font-family="${FONT}">${body}${decoSvg()}</g></svg>`;
  // ★v0.2.168 A5・A4：B5 の 絵を scale で 紙に ぴったり（群は 紙の ぜんぶを うめるので、スタンプの わりあい座標も そのまま 合う）
  const fx = P.w / 182, fy = P.h / 257;
  // ★v0.2.175 割合の ちがう 紙（L判・レター）は 引きのばすと ゆがむ → 等倍で まん中に（あまりは 余白）
  const tf = Math.abs(fx - fy) / fy <= 0.02
    ? `scale(${fx.toFixed(5)},${fy.toFixed(5)})`
    : (() => { const k = Math.min(fx, fy); return `translate(${((P.w - 182 * k) / 2).toFixed(2)},${((P.h - 257 * k) / 2).toFixed(2)}) scale(${k.toFixed(5)})`; })();
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${P.w}mm" height="${P.h}mm" viewBox="0 0 ${P.w} ${P.h}"><title>${f.name}</title>`
    + `<rect width="${P.w}" height="${P.h}" fill="#ffffff"/>`
    + `<g transform="${tf}">${markSvg(INK_C)}${bgSvg(body, opt.bg)}<g font-family="${FONT}">${body}${decoSvg()}</g></g></svg>`;
}
// サイズ：手帳の中の文字（<text> と <tspan>）と、文字についた丸（日付の丸・月のしるし）の大きさ・位置をかえる
//   ・位置（x・y）は ぜんぶの文字・丸を同じだけずらす（数字が丸からはみ出さないように）
//   ・大きさは、見出しの帯（y＜29.5）と大きな文字（5mm 以上）、data-noscale の文字（ならべた一覧）はかえない（となりにかさならないように）
//   ・文字の場所は「よせる点」なので、大きくしても よせ方（左・まん中・右）はそのまま
function sizeBody(body, z) {
  if (!z || (z.k === 100 && !z.dx && !z.dy)) return body;
  const k = z.k / 100;
  return body.replace(/<(text|tspan|circle)\b([^>]*)>/g, (all, tag, attrs) => {
    if (tag === 'circle') {
      const cy = /\bcy="(-?[\d.]+)"/.exec(attrs);
      const big = cy && +cy[1] >= 29.5;
      return `<circle${attrs
        .replace(/\bcx="(-?[\d.]+)"/, (_, v) => `cx="${nf(+v + z.dx)}"`)
        .replace(/\bcy="(-?[\d.]+)"/, (_, v) => `cy="${nf(+v + z.dy)}"`)
        .replace(/\br="([\d.]+)"/, (_, v) => `r="${big ? nf(v * k) : v}"`)}>`;
    }
    const fs = /font-size="([\d.]+)"/.exec(attrs), y = /\by="(-?[\d.]+)"/.exec(attrs);
    const scale = tag === 'text' && fs && +fs[1] < 5 && (!y || +y[1] >= 29.5) && !attrs.includes('data-noscale');
    const a = attrs
      .replace(/\bx="(-?[\d.]+)"/, (_, v) => `x="${nf(+v + z.dx)}"`)
      .replace(/\by="(-?[\d.]+)"/, (_, v) => `y="${nf(+v + z.dy)}"`)
      .replace(/font-size="([\d.]+)"/, (_, v) => `font-size="${scale ? nf(v * k) : v}"`);
    return `<${tag}${a}>`;
  });
}
function sizeText(z = state.size) {
  const pos = [[z.dy, TEXTS.posY], [z.dx, TEXTS.posX]].filter(([d]) => d).map(([d, t]) => t[SIZE_DS.indexOf(d)] + 'mm');
  if (uiLang() !== 'ja') return `Text ${z.k}%` + (pos.length ? ' · ' + pos.join(' · ') : ' · position unchanged');   // ★v0.2.164
  return `文字 ${z.k}%・` + (pos.length ? pos.join('・') : '位置 そのまま');
}
// 背景：手帳のわく（太さ .35 の四角）の中にだけ、線の下にしく柄
//   ・柄は わくの左上から はじめる（わくの線と柄の線がそろう）
//   ・こさは まとめて opacity でうすくする（色は線の色のまま。印刷にも出る）
//   ・data-bg は見本（タイル）で取りのぞく目印
function bgSvg(body, bg) {
  if (!bg || !bg.type) return '';
  const g = bg.gap, S = `fill="none" stroke="${INK_C}" stroke-width=".12"`;
  const corners = [[0, 0], [g, 0], [0, g], [g, g]];   // 柄の1マスのはしは切れるので、4すみに置いて つなげる
  const tile = {
    1: corners.map(([x, y]) => `<circle class="line" fill="${INK_C}" cx="${x}" cy="${y}" r=".22"/>`).join(''),
    2: `<path d="M0 0H${g}M0 ${g}H${g}M0 0V${g}M${g} 0V${g}" ${S}/>`,
    3: `<path d="M0 0H${g}M0 ${g}H${g}" ${S}/>`,
    4: `<path d="${corners.map(([x, y]) => `M${x - .7} ${y}H${x + .7}M${x} ${y - .7}V${y + .7}`).join('')}" ${S}/>`,
  }[bg.type];
  if (!tile) return '';
  const frames = [...body.matchAll(/<rect x="([\d.]+)" y="([\d.]+)" width="([\d.]+)" height="([\d.]+)" fill="none" stroke="[^"]+" stroke-width="\.35"\/>/g)];
  let defs = '', rects = '';
  frames.forEach(([, x, y, w, h], i) => {
    defs += `<pattern id="bgp${i}" patternUnits="userSpaceOnUse" x="${x}" y="${y}" width="${g}" height="${g}">${tile}</pattern>`;
    rects += `<rect x="${x}" y="${y}" width="${w}" height="${h}" fill="url(#bgp${i})" data-bgarea="1"/>`;
  });
  return `<g data-bg="1"><defs>${defs}</defs><g opacity="${nf(BG_DENS[bg.dens])}">${rects}</g></g>`;
}

// ===== 年・週のはじまり・祝日のパネル =====
function seg(el, labels, now, pick) {
  el.replaceChildren(...labels.map((lb, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = lb;
    b.setAttribute('aria-pressed', String(i === now));
    b.onclick = () => pick(i);
    return b;
  }));
}
function syncYear() {
  $('yearChoices').replaceChildren(...Array.from({ length: YEAR_MAX - YEAR_MIN + 1 }, (_, i) => {
    const y = YEAR_MIN + i;
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = y;
    if (y === TODAY.getFullYear()) b.className = 'now';   // 今年のしるし（下の線）
    b.setAttribute('aria-pressed', String(y === state.year));
    b.onclick = () => changePlanner(() => setStart(y, state.month));
    return b;
  }));
  $('monthChoices').replaceChildren(...Array.from({ length: 12 }, (_, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = (i + 1) + TEXTS.monthUnit;
    if (i === TODAY.getMonth() && state.year === TODAY.getFullYear()) b.className = 'now';   // 今月のしるし
    b.setAttribute('aria-pressed', String(i + 1 === state.month));
    b.onclick = () => changePlanner(() => setStart(state.year, i + 1));
    return b;
  }));
  $('yearNote').textContent = TEXTS.yearNote;
  seg($('weekStartSeg'), TEXTS.weekStarts, state.weekStart === 1 ? 0 : 1, i => changePlanner(() => { state.weekStart = i === 0 ? 1 : 0; }));
  seg($('holidaySeg'), TEXTS.holidayOpts, state.holidays ? 0 : 1, i => changePlanner(() => { state.holidays = i === 0; }));
  seg($('rokuyoSeg'), TEXTS.holidayOpts, state.rokuyo ? 0 : 1, i => changePlanner(() => { state.rokuyo = i === 0; }));
  seg($('moonSeg'), TEXTS.holidayOpts, state.moon ? 0 : 1, i => changePlanner(() => { state.moon = i === 0; }));
  seg($('sekkiSeg'), TEXTS.holidayOpts, state.sekki ? 0 : 1, i => changePlanner(() => { state.sekki = i === 0; }));
  seg($('kyurekiSeg'), TEXTS.holidayOpts, state.kyureki ? 0 : 1, i => changePlanner(() => { state.kyureki = i === 0; }));
  seg($('evJpSeg'), TEXTS.holidayOpts, state.events & 1 ? 0 : 1, i => changePlanner(() => { state.events = (state.events & ~1) | (i === 0 ? 1 : 0); }));
  [['evSchoolSeg', 2], ['evNurserySeg', 4]].forEach(([id, bit]) => seg($(id), TEXTS.holidayOpts, state.events & bit ? 0 : 1, i => changePlanner(() => { state.events = (state.events & ~bit) | (i === 0 ? bit : 0); })));
  [['markSatSeg', 'sat'], ['markSunSeg', 'sun'], ['markHolSeg', 'hol']].forEach(([id, k]) => seg($(id), TEXTS.markOpts, state.marks[k] ? 0 : 1, i => changePlanner(() => { state.marks[k] = i === 0; })));
  seg($('calSeg'), TEXTS.calOpts, state.miniCal ? 0 : 1, i => changePlanner(() => { state.miniCal = i === 0; }));
  // マスの中の 時計（月間式のときだけ・v0.2.109）
  const cn = state.notes[state.idx], okClock = canClock(cn);
  $('clockRow').hidden = !okClock;
  $('clockNote').hidden = !okClock;
  if (okClock) seg($('clockSeg'), TEXTS.markOpts, clockOn(cn) ? 0 : 1, i => { changeCustom(() => setClock(cn, i === 0)); syncYear(); });
}
// サイズのパネル
function syncSize() {
  const grid = (el, labels, now, pick) => el.replaceChildren(...labels.map((lb, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = lb;
    b.setAttribute('aria-pressed', String(i === now));
    b.onclick = () => changePlanner(() => pick(i));
    return b;
  }));
  const z = state.size;
  grid($('sizeChoices'), SIZE_KS.map(k => k + '%'), SIZE_KS.indexOf(z.k), i => { z.k = SIZE_KS[i]; });
  grid($('posYChoices'), TEXTS.posY, SIZE_DS.indexOf(z.dy), i => { z.dy = SIZE_DS[i]; });
  grid($('posXChoices'), TEXTS.posX, SIZE_DS.indexOf(z.dx), i => { z.dx = SIZE_DS[i]; });
}
// 背景のパネル
function syncBg() {
  const grid = (el, labels, now, pick, off, pi) => el.replaceChildren(...labels.map((lb, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = lb;
    if (pi) {   // 柄は 絵＋文字（絵はこのページで決めたものだけ）
      const ic = document.createElement('i'); ic.className = 'pi'; ic.innerHTML = picto(pi + i);
      b.prepend(ic);
    }
    b.setAttribute('aria-pressed', String(i === now));
    if (off) b.setAttribute('aria-disabled', 'true');   // 無地のときは うすく（おしてもよい）
    b.onclick = () => changePlanner(() => pick(i));
    return b;
  }));
  const bg = state.bg;
  grid($('bgTypeChoices'), TEXTS.bgTypes, bg.type, i => { bg.type = i; }, false, 'bg');
  grid($('bgGapChoices'), BG_GAPS.map(g => g + 'mm'), BG_GAPS.indexOf(bg.gap), i => { bg.gap = BG_GAPS[i]; }, !bg.type);
  grid($('bgDensChoices'), TEXTS.bgDensNames, bg.dens, i => { bg.dens = i; }, !bg.type);
}
// はじまり月などをかえたら、いまの紙をぬり直す（めくる動きはしない）
function changePlanner(fn) {
  const keep = curDate(), y0 = state.year, m0 = state.month;
  fn();
  if (state.year === y0 && state.month === m0) setSheet(sheetNear(state.notes[state.idx], keep));   // 週のはじまりなど：同じ日の紙
  if (/^s\d+$/.test(state.page)) state.page = sheetPage();
  if (ENIKKI.on && ENIKKI.status !== 'off') { const rg = enikkiRange(); if (ENIKKI.range !== rg.from + '/' + rg.to) enikkiLoad(); }
  syncYear();
  syncBg();
  syncSize();
  const my = ++colorTurn;
  repaint().then(() => { if (my === colorTurn) clearTinted([base.querySelector(':scope > img').src]); });
  updateUi();
}

// ===== 上のバー =====
// なかま（上の切りかえ）。FORMATS の cat と同じ名前。「日」「連用」などをふやすときは、ここに1行足す
// ★v0.2.163 アメリカの ときの 形の 名前（69）と なかまの 名前（7）。無い id は 日本語の まま
const FMT_EN = {
  Y1: 'Yearly Calendar', M6: 'Yearly Schedule', Y2: 'Yearly Chart (landscape)', Y3: 'Yearly Goals', Y4: 'Yearly Plan', Y5: 'Yearly Projects', Y6: 'Monthly Goals', Y7: 'Anniversary List', Y8: '2-Year Calendar', Y9: '3-Year Calendar',
  M1: 'Monthly', M2: 'Monthly + Index', M3: 'Monthly Left', M4: 'Monthly Vertical', M5: 'Gantt Chart', M21: 'Monthly Tasks', M22: 'Monthly + Memo Rows', M23: 'Dual Monthly', M24: 'Weekend Half', M25: 'Monthly + Time Scale', M26: 'Two Halves', M27: '2-Month List', M28: '2-Month Gantt',
  W11: 'Weekly Vertical', W2: '24-Hour Vertical', W3: '3-Split Vertical', W30: 'Vertical 30-min', W31: 'Plan & Actual', W32: 'Vertical + Memo', W33: 'Vertical + To-Do', W34: '5 Blocks', W35: 'Grid Vertical', W36: 'Weekday Focus', W37: 'Early Bird (from 6)', W9: 'Life Log',
  W4: 'Weekly Left', W8: 'Task Log', W10: 'Horizontal Time', W12: 'Left Weekday Focus', W13: 'Left + Time Dots', W14: 'Left AM / PM', W15: 'Left 3-Split', W16: 'Left (Sun. bottom-right)', W17: 'Left + 7 Rows',
  W5: 'Weekly Separate', W6: 'Weekly Blocks', W40: 'Separate + Cross', W41: 'Separate + Time Scale', W42: 'Separate + 2 Columns', W43: 'Separate + Bottom Memo', W44: 'Grid Separate', W45: 'Separate 3 + 4 Days',
  W1: 'Vertical Left', W50: 'Vertical Left Topics', W51: 'Vertical Left Grid Memo', W52: 'Vertical Left Plan & Actual', W53: 'Vertical Left To-Do', W54: 'Vertical Left Early Bird', W55: 'Vertical Left 3 Months',
  W7: '2-Week', W60: '2-Week Time Scale', W61: '2-Week Time Top / Bottom', W62: '2-Week Time Dots', W63: '2-Week Center Line', W64: '2-Week Weekly Goals', W65: '2-Week Simple', W66: '2-Week Bottom Memo', W67: '2-Week Dates Outside', W68: '2-Week Right Memo',
};
const CAT_EN = { year: 'Yearly', month: 'Monthly', vert: 'Weekly Vertical', left: 'Weekly Left', sep: 'Weekly Separate', vleft: 'Vertical Left', bi: '2-Week' };
UI_EN['柄'] = 'Design';   // ★nv0.2.145 用語集：柄＝design（ノートの ご注文内容の 行）。手帳の「背景の 柄」は 別の ことば（背景（線の下にしく柄））
Object.assign(CAT_EN, {"lines": "Lined", "grid": "Grid & dot", "plan": "Planner & schedule", "diary": "Diary & records", "money": "Budget & money", "study": "Study", "music": "Music", "hobby": "Hobbies"});   // ★nv0.2.145 ノートの なかま（notes.json の id）
Object.assign(FMT_EN, {   // ★nv0.2.145 ノートの 柄の 英語の 名前（キー＝柄の id。見本の 英語 title_en）。ない 柄は 日本語の まま
  "3237101083833": "PDCA Notebook",   // PDCAノート
  "3237101083998": "To-Do List",   // ToDoリスト
  "3237101037009": "Task List",   // やることリスト
  "3237101056515": "Study Planner",   // スタディープランナーデイリー　タイムスケジュールつき
  "3237101087082": "Meeting Notebook",   // ミーティングノート
  "3237101022058": "Yearly Schedule Notebook",   // 年間予定表
  "3237101081450": "Undated Daily Page with Checklist",   // 日フリー1日1ページ　チェックリストつき
  "3237101096832": "Undated Daily Page Planner",   // 日フリー1日1ページ手帳
  "3237101098878": "Goal Mandala Notebook",   // 目標達成マンダラノート
  "3237101080790": "One-Page Diary",   // 1ページ日記
  "3237101002018": "Allowance Notebook",   // おこづかいちょう
  "3237101088557": "Weekly Budget Notebook",   // ウィークリー家計簿
  "3237101088733": "Monthly Budget Notebook",   // マンスリー家計簿
  "3237101008375": "Fan Merch Trade Notebook",   // 推し活お取引ノート
  "3237101040514": "Gifts Received Record",   // 贈答記録(いただいたもの)
  "3237101039766": "Gifts Given Record",   // 贈答記録(さしあげたもの)
  "3237101001444": "Cash Ledger",   // 金銭出納帳
  "3237101048533": "Haiku Notebook",   // 俳句ノート
  "3237101022803": "Manuscript Paper (Genko Yoshi)",   // 原稿用紙
  "3237101016134": "English Writing Notebook",   // 英作文ノート
  "3237101063125": "English Practice Notebook",   // 英習罫8段
  "3237101048471": "Karaoke Notebook",   // カラオケノート
  "3237101088832": "Set List Notebook",   // セトリノート
  "3237101087038": "Playlist Notebook",   // プレイリストノート
  "3237101060553": "Ink Log",   // インクログ
  "3237101086730": "Café Notebook",   // カフェノート
  "3237101090041": "Curry Notebook",   // カレーノート
  "3237101052442": "Camping Notebook",   // キャンプノート
  "3237101050220": "Cosmetics Log",   // コスメログノート
  "3237101090580": "Coffee Log",   // コーヒーログノート
  "3237101088831": "Golf Notebook",   // ゴルフノート
  "3237101088237": "Shopping Notebook",   // ショッピングノート
  "3237101052068": "Sticker Log",   // シールログノート
  "3237101001721": "Stamp Notebook",   // スタンプ帳
  "3237101087852": "Stage Log",   // ステージログノート
  "3237101085850": "Soft Tennis Notebook",   // ソフトテニスノート
  "3237101052893": "Travel Notebook",   // トラベルノート
  "3237101061235": "Nail Design Notebook",   // ネイルデザインノート
  "3237101079785": "Basketball Notebook",   // バスケットボールノート
  "3237101064051": "Bread Notebook",   // パンノート
  "3237101087940": "Pet Notebook",   // ペットノート
  "3237101051628": "Running Notebook",   // ランニングノート
  "3237101054290": "Ramen Notebook",   // ラーメンノート
  "3237101088270": "Recipe Notebook",   // レシピノート
  "3237101045939": "Table Tennis Notebook 02",   // 卓球ノート02
  "3237101074418": "Go Game Notebook",   // 囲碁ノート
  "3237101000234": "Shogi Notebook",   // 将棋ノート
  "3237101050280": "Fan Merch Stock Notebook (Boxes & Packs)",   // 押し活グッズストックノート
  "3237101052876": "Fan Merch Stock Notebook",   // 推し活グッズストックノート
  "3237101010466": "Fan Event Ticket Notebook",   // 推し活チケットノート
  "3237101090452": "Travel Packing List",   // 旅行持ち物リスト
  "3237101098728": "Movie Notebook",   // 映画ノート
  "3237101020848": "Horse Racing Notebook",   // 競馬ノート
  "3237101080000": "Art Museum Notebook",   // 美術館ノート
  "3237101000437": "Reading Notebook",   // 読書ノート
  "3237101025593": "Baseball Game Log",   // 野球観戦ノート
  "3237101014195": "Fishing Notebook",   // 釣りノート
  "3237101084223": "Mahjong Notebook",   // 麻雀ノート
});
const fmtName = f => (LANG === 'ja' ? f.name : ((I18N[LANG].fmt || {})[f.id] || f.name));
FORMATS.forEach(f => { if (FMT_EN[f.id]) UI_EN[f.name] = FMT_EN[f.id]; });   // 「もとの形」の えらびにも 英語の 名前
const catName = c => (LANG === 'ja' ? c.name : ((I18N[LANG].cat || {})[c.id] || c.name));
/* ★バースブックノート v0.2.0（2026-10-03）
   ------------------------------------------------------------
   手帳の 画面を そのまま つかい、**紙だけ ノートの 柄**に 入れかえます。
   なかま（CATS）と 形（FORMATS）は notes.json から 作るので、
   ここでは 空の 入れものに して おきます（はじめの ところで 入れます）。 */
const CATS = [];
function buildCats() {
  // ★v0.2.79 みなとさん：「すべて」は なくした。押しても紙はめくらない（タイルのならびだけかわる）
  //   えらばれている 形（年間・手帳）が 入っている なかまは 緑の 枠（chosen）
  const all = CATS.map(c => ({ ...c, count: state.notes.filter(n => n.fmt.cat === c.id).length }));
  const chosen = [state.notes[state.idx], yNote()].filter(Boolean).map(n => n.fmt.cat);
  $('cats').replaceChildren(...all.filter(c => c.count).map(c => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'cat' + (chosen.includes(c.id) ? ' chosen' : ''); b.dataset.cat = c.id;
    b.textContent = `${catName(c)} ${c.count}`;   // ★v0.2.163 アメリカは 英語
    b.setAttribute('aria-pressed', String(c.id === state.cat));
    b.onclick = () => {
      state.cat = c.id;
      buildCats(); buildTiles();
      $('tiles').scrollLeft = 0;
      updateUi();
    };
    return b;
  }));
}
// ★v0.2.169 紙の サイズの ボタン（B5・A5・A4）。みなとさん「サイズの ボタンを 作成して。実際は ファイル名で 変更する」
//   ・いまは 同じ ファイルを ?paper= つきで 開きなおす（?d= も つけるので、えらんだ 内容は そのまま）
//   ・本番は サイズごとに 別の ファイル（商品の URL）に する → 下の SIZE_URLS に ファイル名を 入れると、そこへ 飛ぶように なる
//     （例：SIZE_URLS.a5 = 'a5.html'。ファイルが きまれば ?paper= は いらない）
//   ・お店では head.liquid が window.TK_SIZE_URLS で 商品の URL を わたせる（わたさなければ ?paper=）
const SIZE_URLS = Object.assign({ b5: '', a5: '', b6: '', a4: '', l: '', ly: '', letter: '', 'letter-yoko': '' }, (typeof window !== 'undefined' && window.TK_SIZE_URLS) || {});
function sizeHref(id) {
  const url = SIZE_URLS[id];
  if (url) return url + (url.includes('?') ? '&' : '?') + 'd=' + shareCode();
  const base = /^https?:$/.test(location.protocol) ? location.pathname : '';
  const keep = /(^|[?&])shop=shopify(&|$)/.test(location.search) ? 'shop=shopify&' : '';   // 手元の ためし用
  return base + '?' + keep + (id !== 'b5' ? 'paper=' + id + '&' : '') + 'd=' + shareCode();
}
function buildSizes() {
  const box = $('sizes'); if (!box) return;
  const row = mk('div', 'row');
  /* ★v0.2.219 みなとさん「1ページめの サイズも 横スクロールに して、この アイコンに」（バースブックの ページと 同じ 絵）
     どの 紙も 同じ ものさし（220×300mm・下ぞろえ）で 描くので、見くらべる だけで 大小が わかる */
  row.append(...Object.values(SIZES).filter(S => !S.hidden && (!(typeof window !== 'undefined' && window.TK_SIZE_URLS) || SIZE_URLS[S.id] || S.id === PSIZE)).map(S => {   // ★v0.2.179 hidden は 出さない／★nv0.2.148 お店では 商品の ない サイズは 出さない（柄の 一覧が ちがう 商品で ?paper= を ひらくと 紙が くずれる）
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'size-btn';
    const x = ((220 - S.w) / 2).toFixed(1), y = (300 - S.h).toFixed(1);
    b.innerHTML = `<svg viewBox="0 0 220 300" aria-hidden="true"><line x1="0" y1="300" x2="220" y2="300" stroke="#e0e0e0" stroke-width="3"/><rect x="${x}" y="${y}" width="${S.w}" height="${S.h}" rx="4" fill="#FDF8D8" stroke="#1a1a1a" stroke-width="5"${S.printOnly ? ' stroke-dasharray="14 8"' : ''}/></svg>`;
    b.append(mk('span', 'sz-nm', tr(S.name)), mk('span', 'sz-mm', S.w + '×' + S.h + 'mm'), mk('span', 'sz-mm', S.holes ? S.holes + tr('穴') : tr('穴なし')));   // ★v0.2.216 穴なし
    b.title = S.w + '×' + S.h + 'mm';
    if (S.printOnly) b.classList.add('po-size');   // ★v0.2.214 印刷専用
    b.setAttribute('aria-pressed', String(S.id === PSIZE));
    if (S.id !== PSIZE) b.onclick = () => { location.href = sizeHref(S.id); };
    return b;
  }));
  /* ★v0.2.219 横に すべらせた とき 勝手に ページが 移らない ように（バースブックの ページと 同じ 見はり）
     指（マウス）が 8px より 動いた とき・横スクロールが 止まって 0.35秒 たつまでは おしても 移らない */
  guardRow(row);   // ★v0.2.229 部品に（表示の 手順と 共通）
  box.replaceChildren(row);   // ★v0.2.214 → ★v0.2.236 みなとさん「サイズの 文字は なくして えらぶ だけ」（見出し・ひとこと なし）
}
// ===== 上のタイルの見本：線を黒く・太くした絵を作る =====
//   ★見本は紙のまん中を約3.5倍にして見せるが、元の線は細すぎて（0.3pt ほど）見えない。
//     そこで見本用に、線の色を黒にして、太さを「画面の上で 1.2px」にそろえる
//     （vector-effect:non-scaling-stroke ＝ 大きさを変えても線の太さはそのまま）
//   ★塗りでできた細い線（日付の丸など）は、同じ色のふちどりをつけて太らせる
//   ★白い地は紙の色にする（そのままだと見本がまっ白になる）
const thumbs = new Map();
async function thumbUrl(note) {
  if (thumbs.has(note.id)) return thumbs.get(note.id);
  const doc = new DOMParser().parseFromString(await getSvg(note), 'image/svg+xml');
  const svg = doc.documentElement;
  if (svg.nodeName !== 'svg') throw new Error('not svg');
  svg.querySelectorAll('script,foreignObject,image,[data-bg]').forEach(n => n.remove());   // マークの画像・背景は見本にいらない
  const INK = '#1a1a1a';
  svg.querySelectorAll('[fill],[stroke]').forEach(el => {
    const f = (el.getAttribute('fill') || '').toLowerCase();
    const s = (el.getAttribute('stroke') || '').toLowerCase();
    if (f === '#ffffff' || f === '#fff' || f === 'white') { el.setAttribute('fill', SHEET_COLOR); return; }
    if (s && s !== 'none') el.setAttribute('stroke', INK);
    if (f && f !== 'none') {
      el.setAttribute('fill', INK);
      if (!s || s === 'none') { el.setAttribute('stroke', INK); el.setAttribute('stroke-width', '0'); el.setAttribute('data-fat', '1'); }
    }
  });
  const st = doc.createElementNS('http://www.w3.org/2000/svg', 'style');
  st.textContent = `[stroke]:not([stroke="none"]){stroke:${INK}!important;stroke-width:1.2px!important;vector-effect:non-scaling-stroke}`
    + `[stroke][data-fat]{stroke-width:.8px!important}.ink{fill:${INK}!important}text,tspan{stroke:none!important}`
    + `rect[fill="#ffffff"],rect[fill="#fff"],rect[fill="white"],.paper{fill:${SHEET_COLOR}!important}`;
  svg.appendChild(st);
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(doc)], { type: 'image/svg+xml' }));
  thumbs.set(note.id, url);
  return url;
}
// 見えてきた見本から1つずつ作る
/* ⚡ ★nv0.2.26 みなとさん「柄で えらぶの 表示スピードが 遅いです。早く する ことが できますか？
   SVG から ファイルを 作るので 劣化は しないで ほしい」（2026-10-03）
   ------------------------------------------------------------
   ★本物の お店で はかりました：
       方眼・ドット 37まい … **16.4秒**（10.0MB）
       学習        63まい … **23.9秒**（2.7MB）
     中を 見ると、かかって いたのは ほぼ ぜんぶ「**読む**」ところ。
     ★大事：24KB の 小さい 柄でも **664ms**かかって いました。
       大きさの せいでは なく、**1まい 読み終わるまで つぎを 待って いた**のが 原因。
       1まい 0.5秒 × 63まい ＝ 25秒。
   → **いっぺんに 読む**（6本ずつ）。ブラウザは もともと 何本も 同時に 読めます。
     ★絵は 1ドットも さわりません（劣化なし）。読む じゅんばんを かえる だけです。 */
const thumbQueue = [];
let thumbRunning = 0;
const THUMB_PARALLEL = 6;   // いっぺんに 読む 本数（ブラウザの ふつうの かぎりと 同じ）

async function thumbOne(img) {
  const note = state.notes.find(n => n.id === img.dataset.id);
  if (!note || !img.isConnected) return;
  try { img.src = await thumbUrl(note); } catch (e) { console.error(e); }
}

function runThumbs() {
  while (thumbRunning < THUMB_PARALLEL && thumbQueue.length) {
    const img = thumbQueue.shift();
    thumbRunning++;
    thumbOne(img).finally(() => { thumbRunning--; runThumbs(); });
  }
}
const thumbObserver = new IntersectionObserver(entries => {
  for (const en of entries) {
    if (!en.isIntersecting) continue;
    thumbObserver.unobserve(en.target);
    const img = en.target.querySelector('img');
    if (img) thumbQueue.push(img);
  }
  runThumbs();
}, { root: $('tiles'), rootMargin: '0px 200px' });
function buildTiles() {
  /* ★nv0.2.99 みなとさん「いちばん 左の オーダーメイドは 廃止」＝柄の 一覧から オーダーメイドの タイルを 出さない（形を変える の 手順の ほうで 同じことが できる） */
  $('tiles').replaceChildren(...visible().filter(n => !n.fmt.custom).map(n => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'tile' + (n.ready ? '' : ' wait') + (n.fmt.custom ? ' custom' : ''); b.dataset.index = n.index;
    const zoom = document.createElement('span'); zoom.className = 'zoom';
    if (n.fmt.custom) {
      const ic = document.createElement('i'); ic.className = 'pi'; ic.innerHTML = picto('custom');
      zoom.append(ic);
    } else if (!n.ready) {
      // ★まだ作っていない形：押せない。「準備中」の札
      b.disabled = true;
      const ic = document.createElement('i'); ic.className = 'pi'; ic.innerHTML = picto('sheets');
      zoom.append(ic, Object.assign(document.createElement('span'), { className: 'soon', textContent: TEXTS.soon }));
    } else {
      // ★見本は、スクロールして見えてきたときに thumbUrl() で「黒い太い線」の絵を作って入れる
      const img = document.createElement('img'); img.alt = ''; img.dataset.id = n.id;
      zoom.append(img);
      thumbObserver.observe(zoom);   // ★img はまだ高さ0なので、枠のほうを見はる
    }
    const cap = document.createElement('span'); cap.textContent = fmtName(n.fmt);   // ★v0.2.163 アメリカは 英語
    b.append(zoom, cap);
    b.onclick = () => {
      if (!n.ready) return;
      // ★年間の タイル＝年間の紙の 形を えらぶ（手帳の形は そのまま）。年間の 1まいめを 見せる（v0.2.74）
      if (isYearNote(n)) {
        const same = n.index === state.yIdx;
        state.yIdx = n.index;
        updateUi();
        if (curPage().ysheet != null && !same) repaint();
        else if (curPage().ysheet == null) turnPage('y0');
        return;
      }
      if (n.index !== state.idx) go(n.index, n.index > state.idx ? 1 : -1);
      else if (curPage().sheet == null) turnPage(sheetPage());   // 説明のページを見ていたら、手帳の紙にもどす
      if (n.fmt.custom && ($('pop').hidden || $('pop').dataset.key !== 'custom')) openPop('custom');
    };
    return b;
  }));
  updateUi();
}

// ===== 下のカード =====
function hslToHex(h, s, l) {
  s /= 100; l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = n => { const k = (n + h / 30) % 12; return l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)); };
  return '#' + [f(0), f(8), f(4)].map(x => Math.round(x * 255).toString(16).padStart(2, '0')).join('');
}
function hexToHsl(hex) {
  const n = parseInt(hex.slice(1), 16), r = (n >> 16 & 255) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2;
  let h = 0, s = 0;
  if (mx !== mn) {
    const d = mx - mn;
    s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn);
    h = mx === r ? ((g - b) / d + (g < b ? 6 : 0)) : mx === g ? ((b - r) / d + 2) : ((r - g) / d + 4);
    h *= 60;
  }
  return [Math.round(h), Math.round(s * 100), Math.round(l * 100)];
}
function buildPalette() {
  const p = $('palPanel');
  if (p.dataset.built) return;
  const sec = t => { const d = document.createElement('div'); d.className = 'pal-sec'; d.textContent = t; return d; };
  const baseGrid = () => {
    const g = document.createElement('div'); g.className = 'pal-grid base';
    g.append(...PAL_BASE.map(({ c, name, yomi }) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'pal-named'; b.dataset.c = c; b.title = `${name}（${yomi}）${c}`;
      b.setAttribute('aria-label', `${name}（${yomi}）`);
      const sw = document.createElement('span'); sw.className = 'pal-sw'; sw.dataset.c = c; sw.style.background = c;
      const nm = document.createElement('span'); nm.className = 'pal-nm'; nm.textContent = name;
      b.append(sw, nm);
      return b;
    }));
    return g;
  };
  const grid = (colors, more) => {
    const g = document.createElement('div'); g.className = 'pal-grid' + (more ? ' more' : '');
    g.append(...colors.map(c => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'pal-sw'; b.dataset.c = c; b.style.background = c; b.title = c;
      b.setAttribute('aria-label', '色 ' + c);
      return b;
    }));
    return g;
  };
  const slider = (id, label, max) => {
    const l = document.createElement('label'); l.className = 'pal-sl';
    const i = document.createElement('input'); i.type = 'range'; i.id = id; i.min = 0; i.max = max;
    const v = document.createElement('span'); v.id = id + 'v';
    l.append(label, i, v);
    return l;
  };
  const btn = (id, t) => { const b = document.createElement('button'); b.type = 'button'; b.id = id; b.textContent = t; return b; };
  const foot = document.createElement('div'); foot.className = 'pal-foot';
  foot.append(btn('palNative', TEXTS.palNative), btn('palClose', TEXTS.palClose));
  const more = PAL_TONES.flatMap(([s, l]) => PAL_HUES.map(h => hslToHex(h, s, l)));
  p.append(
    sec(TEXTS.palBase), baseGrid(),
    sec(TEXTS.palMore), grid([...more, ...PAL_GRAYS], true),
    sec(TEXTS.palFine), slider('palH', TEXTS.palHue, 359), slider('palS', TEXTS.palSat, 100), slider('palL', TEXTS.palLight, 100),
    foot,
  );
  p.addEventListener('click', e => { const b = e.target.closest('.pal-sw, .pal-named'); if (b) setColor(b.dataset.c); });
  ['palH', 'palS', 'palL'].forEach(id => $(id).addEventListener('input', () => {
    setColor(hslToHex(+$('palH').value, +$('palS').value, +$('palL').value), true);   // true＝スライダーは動かしなおさない（指の下でずれないように）
  }));
  $('palClose').onclick = () => closePop();
  $('palNative').onclick = () => $('colorNative').click();
  p.dataset.built = '1';
}
// 色のパネルの上：どの色をかえるか（線・文字・土曜日・日曜日）
function syncInkTabs() {
  $('inkTabs').replaceChildren(...INK_KEYS.map((k, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'tab');
    b.setAttribute('aria-selected', String(k === state.inkTarget));
    const sw = document.createElement('i'); sw.style.background = inkOf(k);
    b.append(sw, TEXTS.inkNames[i]);
    b.onclick = () => { state.inkTarget = k; syncColor(); };
    return b;
  }));
  const same = $('inkSame');
  same.hidden = state.inkTarget === 'line';
  same.setAttribute('aria-pressed', String(state.inkTarget !== 'line' && !state.inks[state.inkTarget]));
  try { if (!syncInkTabs.busy) { syncInkTabs.busy = 1; syncColorPix(); } } catch (e) {} finally { syncInkTabs.busy = 0; }   // ★絵の パネルも いっしょに 更新
}
$('inkSame').onclick = () => {
  if (state.inkTarget === 'line') return;
  state.inks[state.inkTarget] = null;
  paintColor();
};
// パレットの見た目を、いまの色に合わせる（えらんだ丸に枠・スライダーの位置）
function syncColor(fromSlider) {
  syncInkTabs();
  const c = inkOf(state.inkTarget);
  $('colorPrev').style.background = c;
  if (document.activeElement !== $('colorHex')) $('colorHex').value = c.toUpperCase();
  const cn = colorName(c);
  $('colorName').replaceChildren(...(cn ? [tr(cn.name), Object.assign(document.createElement('small'), { textContent: tr(cn.yomi) })] : []));
  $('colorNative').value = c;
  const p = $('palPanel');
  if (!p.dataset.built) return;
  p.querySelectorAll('.pal-sw').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.c === c)));
  if (!fromSlider) { const [h, s, l] = hexToHsl(c); $('palH').value = h; $('palS').value = s; $('palL').value = l; }
  ['palH', 'palS', 'palL'].forEach(id => { $(id + 'v').textContent = $(id).value; });
}
function showPalette() {
  buildPalette();
  $('palPanel').hidden = false;
  syncColor();
}
let colorTurn = 0;
function setColor(c, fromSlider) {
  c = c.toLowerCase();
  if (state.inkTarget === 'line') state.color = c;
  else state.inks[state.inkTarget] = c;
  return paintColor(fromSlider);
}
// 色をかえたあと：パネルと紙をぬり直す
async function paintColor(fromSlider) {
  syncColor(fromSlider);
  const my = ++colorTurn;   // スライダーを速く動かしたとき、最後の色だけを紙に出す
  const note = state.notes[state.idx];
  if (!note) return;
  const url = await tintedUrl(note);
  if (my !== colorTurn) return;
  await repaint();
  clearTinted([url]);
  updateUi();
}
$('colorNative').addEventListener('input', e => setColor(e.target.value));
$('colorHex').addEventListener('input', e => { if (/^#[0-9a-fA-F]{6}$/.test(e.target.value)) setColor(e.target.value); });
$('colorHex').addEventListener('blur', () => syncColor());

// オーダーメイドから外れたら（ほかの形・なかま・説明のページなど）、線をつくるパネルはとじる
function closeCustomIfLeft() {
  if ($('pop').hidden || $('pop').dataset.key !== 'custom') return;
  const note = state.notes[state.idx];
  // ★v0.2.99：上の「なかま」の えらびが ちがっても 閉じない（形を変える が すぐ 閉じる 不具合）
  if (!(cmTarget(note) && curPage().sheet != null)) closePop();
  else nbSyncCustom();   // ★nv0.2.14 タイルを 押した ときも 中身を 作りなおす（cmBox は ノートには ない）
}
// 線をつくるパネル：CUSTOM の表から ボタンを作る（4つまでは つながったボタン、それより多いときは ならべたボタン）
function syncCustom() {
  const t = cmTarget();
  if (!t) return;
  const note = t.note, spec = t.spec, v = t.v;
  $('cmBox').dataset.id = note.id;
  // 「もとの形に もどす」＝この ページの いちばん上の ボタン（v0.2.108 みなとさん：いつも 見えるように）
  //   まだ 何も かえていない ときは 押せない（グレー）
  const tunedNow = !!(note.fmt.tune && state.tune[note.id] && String(state.tune[note.id]) !== String(tuneStart(note.fmt)));
  $('cmBack').hidden = !note.fmt.tune;
  $('cmBack').disabled = !tunedNow;
  $('cmBack').onclick = () => changeCustom(() => { delete state.tune[note.id]; });
  // ★v0.2.103 できあいの 形を えらんだ ときは「もとの形」は 出さない（いま えらんでいる 形を 直す）
  const skip0 = !!spec.presets;   // ★v0.2.105 どの 形でも「もとの形」は 出さない（できあいを えらんで 直す）
  $('cmBox').replaceChildren(...spec.items.map((it, i) => ((skip0 && i === 0) || it.hide ? null : (() => {
    const line = document.createElement('div'); line.className = 'cm-line';
    const sec = document.createElement('div'); sec.className = 'cm-sec'; sec.textContent = tr(it.label);   // ★v0.2.164
    const off = !!(it.off && it.off(v));   // その「もとの形」では つかわない えらび
    const pick = j => changeCustom(() => {
      v[i] = j;
      if (i === 0 && spec.presets) spec.presets[j].forEach((n, k) => { v[k + 1] = n; });   // もとの形：下のえらびを その形の中身に
    });
    const box = document.createElement('div');
    if (it.kind === 'step') {
      // ＋−で数を決める（つきやシステムの せってい と同じ作り）
      box.className = 'cm-step2';
      const mk = (t, d) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'stp'; b.textContent = t;
        b.disabled = off || v[i] + d < 0 || v[i] + d >= it.opts.length;
        b.onclick = () => pick(v[i] + d);
        return b;
      };
      const val = document.createElement('b'); val.textContent = tr(it.opts[v[i]]);
      box.append(mk('−', -1), val, mk('＋', 1));
    } else {
      box.className = it.kind === 'icon' ? 'year-grid memo-types' : it.kind === 'pic' ? 'year-grid memo-types pic-grid' : (it.opts.length > 3 || it.opts.some(o => [...o].length > 5)) ? 'year-grid' : 'cm-seg';   // 長い名前は たてにならべる（字が切れないように）
      box.replaceChildren(...it.opts.map((lb, j) => {
        const b = document.createElement('button');
        b.type = 'button'; b.textContent = tr(lb);
        if (it.kind === 'icon' || it.kind === 'pic') {
          const ic = document.createElement('i'); ic.className = 'pi';
          ic.innerHTML = it.kind === 'icon' ? memoIcon(j) : (it.icons[j] && it.icons[j].memo != null ? memoIcon(it.icons[j].memo) : cmIcon(it.icons[j]));
          b.prepend(ic);
        }
        b.disabled = off;
        b.setAttribute('aria-pressed', String(j === v[i] && !off));
        b.onclick = () => pick(j);
        return b;
      }));
    }
    line.append(sec, box);
    if (off) line.style.opacity = '.45';
    return line;
  })())).filter(Boolean));
  $('cmCode').textContent = t.code;
}
function changeCustom(fn) {
  const keep = curDate();
  fn();
  setSheet(sheetNear(state.notes[state.idx], keep));   // 紙の数がかわることがある（年間の 6か月×2 など）
  if (/^s\d+$/.test(state.page)) state.page = sheetPage();
  nbSyncCustom();   // ★nv0.2.14
  const my = ++colorTurn;
  repaint().then(() => { if (my === colorTurn) clearTinted([base.querySelector(':scope > img').src]); });
  updateUi();
}
// 左のボタンで、押した項目のパネルだけ開く（もう一度押す・✕・外を押すと閉じる）
const POP_TITLES = { custom: 'cardCustom', year: 'cardYear', view: 'cardView', print: 'cardPrint', paper: 'cardPaper', binder: 'cardBinder', color: 'cardColor', name: 'cardName' };
function openPop(key) {
  const pop = $('pop');
  const same = !pop.hidden && pop.dataset.key === key;
  pop.hidden = same;
  pop.dataset.key = same ? '' : key;
  document.querySelectorAll('.tool[data-pop]').forEach(b => b.setAttribute('aria-expanded', String(!same && b.dataset.pop === key)));
  document.body.classList.toggle('cm-open', !same && key === 'custom');
  if (same) return;
  const icon = document.createElement('i');
  icon.className = 'pi';
  icon.innerHTML = picto(key);
  $('popTitle').replaceChildren(icon, TEXTS[POP_TITLES[key]]);
  pop.querySelectorAll('.pop-card').forEach(c => { c.hidden = c.dataset.card !== key; });
  if (key === 'color') showPalette();
  if (key === 'year' || key === 'view') syncYear();   // 表示の中に こよみ（もとの「表記」）が ある
  if (key === 'year') syncBg();                        // はじまり月の中に 背景が ある（v0.2.64）
  if (key === 'view') syncSize();
  if (key === 'custom') { try { nbCustomFromNow(); } catch (e) {} nbSyncCustom(); }   // ★nv0.2.21 いまの 柄から
  if (key === 'print') {
    syncPrintApp();
    { const po = $('prOnlyNote'); if (po) po.hidden = !PRINT_ONLY; } try { prChoose('home'); prRefreshQuota(); prCooldownSync(); } catch (e) {}
  }
  pop.scrollTop = 0;
}
function closePop() { if (!$('pop').hidden) openPop($('pop').dataset.key); }
document.querySelectorAll('.tool[data-pop]').forEach(b => { b.onclick = () => openPop(b.dataset.pop); });
$('popClose').onclick = closePop;
// 「形を変える」：えらんでいる 基本の形を、その なかまの オーダーメイドの えらびで 変えられるようにする（v0.2.85）
//   ★はじめの えらびは その形 そのもの → 押しただけでは 絵は かわらない
$('toolTune').onclick = () => {
  const note = state.notes[state.idx];
  if (!note || !note.fmt.tune) return;
  if (!state.tune[note.id]) state.tune[note.id] = tuneStart(note.fmt);
  updateUi();   // ★先に 画面を そろえてから ひらく（ひらいた あとに 閉じられないように）
  if ($('pop').hidden || $('pop').dataset.key !== 'custom') openPop('custom'); else closePop();
};
document.addEventListener('pointerdown', e => {
  if (NK.on) return;   // ★v0.2.131 お店の 画面では パネルは いつも 出ている（外を 押しても とじない）
  if ($('pop').hidden || e.target.closest('#pop, .tool, .tile')) return;
  if ($('pop').dataset.key === 'custom' && e.target.closest('.paper-area')) return;   // 線をつくりながら、紙をズームして見られるように
  closePop();
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') closePop(); });

/* ★nv0.2.35 ノートの 注文コードを 作りなおした（みなとさん 2026-10-03）
   ------------------------------------------------------------
   ★前は 手帳の planCode を そのまま 借りて いたので、こう なって いました：
       B5T-3237101009611-2610000522c0   ← 30文字
     ・楽天の 1つの 欄は **20文字まで** → はみ出す（12の 柄で しらべて 11が こえた）
     ・「B5T」＝手帳・はじまり月・六曜… **ノートに 無い もの**が 入って いた
     ・読みもどせなかった（readPlanCode が null）
   ★新しい 形（9〜10文字）：
       B5N  2f8  5  0  0  [J]
       └┬┘ └┬┘ └┬┘└┬┘└┬┘ └┬┘
        │    │   │  │  │   国（日本は つけない。U/C/K/E）
        │    │   │  │  大容量（0 ふつう／1 大容量）
        │    │   │  紙（0 書籍／1 万年筆／2 シャープペン）
        │    │   星の数（0〜5）
        │    柄の 番号（36進数 3文字。notes_no.json の「ずっと 変わらない 番号」）
        B5の ノート
     ・**000 ＝ オーダーメイド**（形は「オーダー」の 欄に ある）
     ・形を変える は いままで どおり オーダー／オーダー2 の 欄
     ・チェックの 3行は 文字なので コードに 入らない → **「チェック」の 欄**（下） */
const noteNoOf = note => (note && note.fmt && Number.isInteger(note.fmt.no) ? note.fmt.no : 0);
const NOTE_OPTS = ['normal', 'big'];
/* ★nv0.2.50 みなとさん「楽天GOLD で ノートで L判を 作成して ください。よこ です」（2026-10-03）
   ------------------------------------------------------------
   ★それまで 注文コードは **いつも「B5N」**で はじまって いたので、
     L判よこの 注文も B5 の 注文と **見分けが つきません**でした。
   → はじめの 2文字を **紙の 大きさ**に します。日本の B5 は いままで どおり「B5」なので、
     **これまでの 注文コードは そのまま 読めます**。
       B5 → B5N…／L判よこ → LYN…／L判たて → LTN…／A5 → A5N…／B6 → B6N…／A4 → A4N… */
const NOTE_SIZE_CODE = { b5: 'B5', ly: 'LY', l: 'LT', a5: 'A5', b6: 'B6', a4: 'A4' };
const noteSizeOf = head => (Object.keys(NOTE_SIZE_CODE).find(k => NOTE_SIZE_CODE[k] === head) || 'b5');
/* ★nv0.2.36 オーダーメイドの ときも「下じきに した 柄」の 番号を 入れる。
   ------------------------------------------------------------
   ★「形を変える」の 線の 種類に **「いまの柄」**が あり、その 区画には
     えらんで いた 柄が そのまま 入ります（state.cmBaseFmt）。
     000 に して しまうと **どの 柄から 作ったか わからなく なり、刷れません**。
   ★見分けかた：
     ・オーダーの 欄が **ある** → オーダーメイド（下じき＝その 番号の 柄）
     ・オーダーの 欄が **ない** → その 番号の 柄 そのもの */
const noteBaseNo = note => (note && note.fmt.custom
  ? (state.cmBaseFmt && Number.isInteger(state.cmBaseFmt.no) ? state.cmBaseFmt.no : 0)
  : noteNoOf(note));
function orderCode() {
  const note = state.notes[state.idx];
  const no = noteBaseNo(note);
  const stars = Math.max(0, Math.min(5, state.stars | 0));
  const paper = Math.max(0, PAPER_IDS.indexOf(state.paper));
  const opt = Math.max(0, NOTE_OPTS.indexOf(state.option));
  return (NOTE_SIZE_CODE[PSIZE] || 'B5') + 'N' + no.toString(36).padStart(3, '0') + stars + paper + opt + countryOf(state.country).code;
}
// 注文コードを 読む（お店で 中身を たしかめる・テスト用）。読めない ときは null
function readNoteCode(code) {
  const m = /^(B5|LY|LT|A5|B6|A4)N([0-9a-z]{3})([0-5])([0-2])([01])([UCKE])?$/.exec(code || '');
  if (!m) return null;
  const size = noteSizeOf(m[1]);   // ★nv0.2.50 はじめの 2文字＝紙の 大きさ
  const no = parseInt(m[2], 36);
  // ★nv0.2.36 no＝柄の 番号（オーダーメイドの ときは 下じきの 柄）。
  //   オーダーメイドか どうかは「オーダーの 欄が あるか」で 決める（ここでは 決めない）
  const p = { size, no, stars: +m[3], paper: PAPER_IDS[+m[4]], option: NOTE_OPTS[+m[5]] };
  if (m[6]) p.country = (COUNTRIES.find(c => c.code === m[6]) || {}).id;
  return p;
}
// チェックの 3行（□こみで 1行6文字まで → 6+1+6+1+6 ＝ ちょうど 20文字）
const todoChoice = () => (state.todo || []).map(t => String(t || '').slice(0, 6)).join('/');
function orderChoices() {
  const c = [RAKUTEN.opt.code + ':' + orderCode(), RAKUTEN.opt.color + ':' + state.color.toUpperCase()];
  inkChoice().forEach(([label, hex]) => c.push(label + ':' + hex));
  const note = state.notes[state.idx];
  const t = cmTarget(note);
  // オーダーの 記号は 1つの 欄に 20文字まで → こえたら「オーダー2」に つづきを 入れる（v0.2.89）
  if (t) {
    c.push(RAKUTEN.opt.order + ':' + t.code.slice(0, RAKUTEN.MAX));
    if (t.code.length > RAKUTEN.MAX) c.push(RAKUTEN.opt.order2 + ':' + t.code.slice(RAKUTEN.MAX));
  }
  if (state.name) c.push(RAKUTEN.opt.name + ':' + state.name);
  // ★nv0.2.35 チェックの 3行（□こみで 1行6文字まで → ちょうど 20文字に おさまる）
  const td = todoChoice();
  if (td.replace(/\//g, '')) c.push(RAKUTEN.opt.todo + ':' + td);
  /* ★nv0.2.43 みなとさん「えにっきは 値段の 変更は ない ので、項目選択肢では なく
     **あるか ないか だけ**に して」（2026-10-03）
     → **楽天には 送りません**。お店の ご注文内容の 1行だけに のこします（orderRows）。 */
  return c;
}
// 下の ボタンの 小さな文字：「年間カレンダー2年：月間式2年：書籍用紙：レザーバインダー」（v0.2.78）
function orderSummary() {
  const note = state.notes[state.idx], yn = yNote();
  if (LANG !== 'ja') return [yn ? tr(yn.name) : '', note ? tr(note.name) : '', tr(TEXTS.paperShort[state.paper] || ''), tr(TEXTS.binderShort[state.binder] || '')].filter(Boolean).join(' · ');   // ★nv0.2.145 英語：ノートは 年が ないので「2年」は 出さない
  return [yn ? `${yn.name}${monthsOf(yn) / 12}年` : '', note ? `${note.name}${monthsOf(note) / 12}年` : '',
    TEXTS.paperShort[state.paper] || '', TEXTS.binderShort[state.binder] || ''].filter(Boolean).join('：');
}
// 楽天の色の欄：線とちがう色にしたものだけ（[[項目の名前, 色]] を返す）
function inkChoice() {
  return [['text', RAKUTEN.opt.inkText], ['sat', RAKUTEN.opt.inkSat], ['sun', RAKUTEN.opt.inkSun]]
    .filter(([k]) => state.inks[k]).map(([k, label]) => [label, state.inks[k].toUpperCase()]);
}
// ご注文内容の行（[名前, 中身, 色の丸]）。ページのカードと、ボタンの「…」の説明で使う
function orderRows() {
  /* ★nv0.2.12 みなとさん「ご注文内容も ノート版に 変更です」（2026-10-03）
     ------------------------------------------------------------
     手帳の ご注文内容には 暦の 行が ずらりと ありました
     （期間・週のはじまり・祝日・暦・カレンダー・日付の丸・ぎょうじ・背景…）。
     ノートに 暦は ない ので ぜんぶ 外し、ノートの ものに 入れかえます。
       柄 → 形を変える → 色 → 名入れ → 星 → チェック → 紙 → バインダー → 大容量 → 注文コード */
  const note = state.notes[state.idx];
  const binder = BINDERS.find(b => b.id === state.binder);
  const opt = (typeof OPTIONS !== 'undefined') ? OPTIONS.find(o => o.id === state.option) : null;
  const todo = (state.todo || []).filter(t => String(t).trim());
  return [
    ...(SHOP === 'shopify' ? [[TEXTS.countryRow, TEXTS.nkCountries[state.country === 'us' ? 1 : 0]]] : []),
    [TEXTS.fmtRow, note ? fmtName(note.fmt) : '—'],
    ...(note && note.fmt.cat && CATS.find(c => c.id === note.fmt.cat)
        ? [[tr('なかま'), catName(CATS.find(c => c.id === note.fmt.cat))]] : []),
    /* ★nv0.2.49 みなとさん「最後の 注文の 確認と、楽天で 飛んで くる 注文を 同じ 形式に して おいて」（2026-10-03）
       → 楽天に とどくのは「オーダー」（長い ときは「オーダー2」に つづき）。
         ここも **まったく 同じ 名前・同じ 分け方**で 出します。 */
    ...(note && note.fmt.custom && typeof customCode === 'function'
        ? (c => [[RAKUTEN.opt.order, c.slice(0, RAKUTEN.MAX), null, 'code'],
            ...(c.length > RAKUTEN.MAX ? [[RAKUTEN.opt.order2, c.slice(RAKUTEN.MAX), null, 'code']] : [])])(customCode()) : []),
    [TEXTS.inkRows ? TEXTS.inkRows[0] : tr('線の色'), String(state.color).toUpperCase(), state.color],
    // ★nv0.2.49 文字の色は 線と ちがう ときだけ 楽天に 行く。ご注文内容も それに そろえる
    ...(state.inks && state.inks.text ? [[RAKUTEN.opt.inkText, String(state.inks.text).toUpperCase(), state.inks.text]] : []),
    [tr('名入れ'), state.name || TEXTS.none],
    [tr('星'), state.stars ? '☆'.repeat(state.stars) + '（' + state.stars + TEXTS.starsUnit + '）' : TEXTS.none],
    // ★nv0.2.49 楽天に 行くのと 同じ つなぎ（/）に する
    [RAKUTEN.opt.todo, todo.length ? todoChoice() : TEXTS.none],
    [TEXTS.paperRow, tr(paperOf().name)],
    [tr('バインダー'), tr(binder.name)],
    ...(opt ? [[tr('大容量'), tr(opt.name) + (state.option === 'big' ? '（＋' + yen(BIG_PLUS) + '）' : '')]] : []),
    [tr('えにっき'), TEXTS.enikkiOrder[state.enikki.mode > 0 ? 0 : 1]],   // ★nv0.2.35 あるか・ないか だけ
    [tr('注文コード'), orderCode(), null, 'code'],
  ];
}
// ご注文内容のページ（紙1枚ぶん）
function paintOrder(sheet) {
  sheet.dataset.kind = 'info';
  const card = mk('div', 'card order');
  card.append(mk('h3', '', TEXTS.summaryTitle));
  const rows = orderRows();
  const list = mk('div', 'order-list' + (rows.length > 10 ? ' two' : ''));   // 行が多いときは2列
  for (const [k, v, sw, cls, rowCls] of rows) {
    const r = mk('div', 'or' + (rowCls ? ' ' + rowCls : ''));
    const val = mk('span', 'v' + (cls ? ' ' + cls : ''));
    if (sw) { const s = mk('i', 'sw'); s.style.background = sw; val.append(s); }
    val.append(v);
    r.append(mk('span', 'k', k), val);
    list.append(r);
  }
  const price = mk('div', 'order-price');
  const lbl = mk('span', '', tr('お値段')); lbl.append(mk('small', '', tr('税込')));
  price.append(lbl, mk('b', '', yen(priceOf())));
  // 送料無料・B5・26穴｜レビューで ペン（v0.2.67 に カゴの 下から うつした）
  // ★v0.2.78 みなとさん：「いちばん最後のページです」の ところに カゴに入れる ボタン（押すと addToCart。下の ボタンは ここへ くるだけ）
  //   めくる 動きで 紙が 写される（copySheet）ので、押したときの しごとは document で まとめて うける（下の addEventListener）
  const ready = cartReady();
  const cb = mk('button', 'cart order-cart' + (ready ? '' : ' wait'));
  cb.type = 'button';
  const ic = mk('i', 'pi'); ic.innerHTML = picto('cart');   // 決まった絵だけ
  cb.append(ic, mk('span', 't', ready ? TEXTS.cart : TEXTS.cartWait), mk('span', 'yen', yen(priceOf())));
  card.append(list, price, cb);   // ★2026-11-03 みなとさん 送料無料・ペンの おまけは 書かない
  sheet.querySelector('.info').replaceChildren(card);
  fitOrder(card);
}
// ご注文内容が カードに入りきらないときは、文字を少しずつ小さくする（2026-09-18 行がふえて かさなったため）
function fitOrder(card) {
  const list = card.querySelector('.order-list');
  let k = 1;
  card.style.setProperty('--os', k);
  //   ★v0.2.79 みなとさん「文字を 表示パネル ぐらいに」：ちぢめるのは 少しだけ（.9 まで）。入りきらない ぶんは 上下に スクロール
  while (k > .9 && list.scrollHeight > list.clientHeight + 1) {
    k = Math.round((k - .05) * 100) / 100;
    card.style.setProperty('--os', k);
  }
}
function updateUi() {
  syncPages();
  syncFlip();
  closeCustomIfLeft();
  const note = state.notes[state.idx];
  $('toolTune').hidden = !(CUSTOM_ON && note && note.fmt.tune && curPage().sheet != null);
  $('toolTune').setAttribute('aria-expanded', String(!$('pop').hidden && $('pop').dataset.key === 'custom' && !!tuneOf(note)));
  document.querySelectorAll('.tile').forEach(b => b.setAttribute('aria-current', String(+b.dataset.index === state.idx || +b.dataset.index === state.yIdx)));   // 年間と 手帳の 2つに しるし
  const chosenCats = [note, yNote()].filter(Boolean).map(n => n.fmt.cat);   // えらばれている なかまも 緑の 枠（v0.2.79）
  document.querySelectorAll('.cat').forEach(b => b.classList.toggle('chosen', chosenCats.includes(b.dataset.cat)));
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  const price = el('span', '', yen(priceOf()));
  if (PRICE_IS_KARI) price.append(el('span', 'kari', TEXTS.priceKari));
  // 下の ボタン（v0.2.78 みなとさん）：押すと ご注文内容の ページへ。カゴに入れるのは ご注文内容の いちばん下の ボタン
  //   小さな文字＝「年間カレンダー2年：月間式2年：書籍用紙：レザーバインダー」／大きな文字＝「B5ルーズリーフ 内容確定に進む」
  $('cartBtn').classList.remove('wait');
  $('cartIcon').innerHTML = picto('sheets');
  $('cartLabel').replaceChildren(el('small', '', note ? orderSummary() : TEXTS.cartWaitName), el('b', '', TEXTS.goConfirm));
  $('cartPrice').replaceChildren(price);
  // ★ご注文内容はページの1枚。いま見ているときだけ、その場で書きかえる（めくる動きはしない）
  if (curPage().id === 'order' && base.dataset.kind === 'info') paintOrder(base);
  $('checkBtn').setAttribute('aria-pressed', String(curPage().id === 'order'));
}

// 名入れ・チェック（紙にもすぐ出す）
const INPUT_BAD = /[<>\u0000-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069]/g;
$('nameInput').addEventListener('input', e => {
  const v = e.target.value.replace(INPUT_BAD, '');
  if (v !== e.target.value) e.target.value = v;
  state.name = e.target.value.trim();
  refreshDeco();
  updateUi();
});
// バインダー（えらぶと値段がかわる）
function choiceButton(item, pressed, price, disabled, onPick) {
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'choice';
  b.setAttribute('aria-pressed', String(pressed));
  b.disabled = disabled;
  const icon = document.createElement('i'); icon.className = 'pi'; icon.innerHTML = picto(item.pi);
  const t = document.createElement('span'); t.className = 't';
  const nm = document.createElement('b'); nm.textContent = tr(item.name);   // ★v0.2.164
  const sub = document.createElement('small'); sub.textContent = tr(item.sub);
  t.append(nm, sub);
  const y = document.createElement('span'); y.className = 'yen'; y.textContent = price;
  b.append(icon, t, y);
  b.onclick = onPick;
  return b;
}
function syncChoices() {
  $('paperChoices').replaceChildren(...PAPERS.map(it => choiceButton(
    it, it.id === state.paper, PAPER_OUT[it.id] ? tr('品切れ') : yen(priceOf(state.binder, it.id)), !!PAPER_OUT[it.id],   // その紙に したときの 値段・品切れは 押せない
    () => { state.paper = it.id; syncChoices(); updateUi(); })));
  $('binderChoices').replaceChildren(...BINDER_LIST.map(it => choiceButton(
    it, it.id === state.binder, yen(priceOf(it.id)), false,
    () => {
      const before = state.binder;
      state.binder = it.id;
      syncChoices();
      updateUi();
      if (it.id !== 'none' && before !== it.id) {
        if (curPage().id === 'cover') repaint(); else turnPage('cover');
      } else if (it.id === 'none' && state.page === 'cover') { state.page = sheetPage(); repaint(); updateUi(); }
    })));
  /* ★nv0.2.5 大容量（ノートだけ）。右には「たすと いくら」を 出す（紙・バインダーで かわらない） */
  if ($('optionChoices')) {
    $('optionChoices').replaceChildren(...OPTIONS.map(it => choiceButton(
      it, it.id === state.option, it.id === 'big' ? '+' + yen(BIG_PLUS) : '—', false,
      () => { state.option = it.id; syncChoices(); updateUi(); })));
  }
  try { syncChoicePix(); } catch (e) {}   // ★絵の パネルも
}
syncChoices();


// めくる操作：紙のスワイプ・矢印キー（上のタイルでもえらべる）
// ズーム（2026-09-17 2本指に対応）
//   ・2本指で広げる／すぼめる＝大きく（8倍まで。v0.2.315）／小さく（半分まで）
//   ・ダブルタップ（ダブルクリック）＝もとの大きさにもどす（★大きくはしない。ご要望）
//   ・大きいとき、1本指でずらして見る。もとの大きさ・小さいときは、横にスワイプでめくる
//   ・小さいときは、紙をまん中に置く
//   ★紙の左上を「0,0」として、translate(tx,ty) scale(s) で動かす
//     （紙の中の点 p は、画面では tx + s×p に出る）
const ZOOM_MAX = 8, ZOOM_MIN = 0.5;   // ★v0.2.113 小さくは 半分まで（もっと 小さく できるように）／★v0.2.315 みなとさん「拡大を さらに。えにっきの 大きさまで」＝大きくは 4倍 → 8倍（月間式の 1日の マスが 画面の はばに なる ところまで）。スクロール中の ピンチ・ペンの 2本指も 同じ
const zoom = { on: false, s: 1, tx: 0, ty: 0 };   // on ＝ もとより大きい（1本指でずらすとき）
function clampZoom() {
  const book = $('book');
  const w = book.offsetWidth, hh = book.offsetHeight;
  zoom.s = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, zoom.s));
  if (Math.abs(zoom.s - 1) < 0.01) { zoom.s = 1; zoom.tx = zoom.ty = 0; }
  // ★v0.2.114 みなとさん：小さいときは 左右だけ まん中、**上（頭）は そろえる**
  else if (zoom.s < 1) { zoom.tx = (w - w * zoom.s) / 2; zoom.ty = (typeof TK_HOME !== 'undefined' && TK_HOME) ? (hh - hh * zoom.s) / 2 : 0; }   // ★2026-10-15 みなとさん「縮小したら 中心に」：トップページでは 上下も まん中（お店の 商品ページは これまで どおり 頭そろえ）
  else {
    zoom.tx = Math.min(0, Math.max(w - w * zoom.s, zoom.tx));   // 紙のはしが枠の内側に入りこまないところまで
    zoom.ty = Math.min(0, Math.max(hh - hh * zoom.s, zoom.ty));
  }
  zoom.on = zoom.s > 1;
}
function applyZoom() {
  const book = $('book');
  clampZoom();
  book.classList.toggle('zoomed', zoom.on);
  const moved = zoom.s !== 1;
  book.style.transformOrigin = moved ? '0 0' : '';
  book.style.transform = moved ? `translate(${zoom.tx}px, ${zoom.ty}px) scale(${zoom.s})` : '';
  $('zoomHint').hidden = !moved;
  if (typeof TK_HOME !== 'undefined' && TK_HOME) { if (typeof noteInkPlaceFlips === 'function') noteInkPlaceFlips(); if (typeof noteInkRenderSoon === 'function') noteInkRenderSoon(); if (typeof homeRefreshOverlaySoon === 'function') homeRefreshOverlaySoon(); }   // ★2026-10-15 ホーム：拡大・縮小の たびに 書きこみ・日づけの 位置を 引きなおす
  // ★v0.2.148 みなとさん「縮小した ときは 紙と 下の 間を つめて」：お店では 紙の 枠と 窓の 高さを 縮小後の 大きさに
  if (NK.on) {
    const pa = book.parentElement, win = $('nkWin');
    pa.style.setProperty('--pa-h', zoom.s < 1 ? Math.round(book.offsetHeight * zoom.s) + 'px' : 'auto');
    if (win) {
      win.classList.toggle('nk-small', zoom.s < 1);   // ★v0.2.156 小さい ときは 下の すき間も つめる（下の 欄が もっと 見える）
      if (zoom.s < 1) { const st = pa.parentElement; win.style.setProperty('--nkv', (st.offsetHeight + 4) + 'px'); } else win.style.removeProperty('--nkv');
    }
  }
}
// もとの大きさにもどす
function setZoom(on) {
  zoom.s = 1; zoom.tx = zoom.ty = 0;
  applyZoom();
}
// ★v0.2.113 みなとさん：ダブルクリック（ダブルタップ）で 大きさを 3段階に かえる
//   **実寸（もとの大きさ）が いちばん 大きい**。おすたびに 小さく なって、3つめの つぎは 実寸に もどる
//   もとの大きさ → 3/4 → 1/2 → もとの大きさ …
const ZOOM_STEPS = [1, 0.75, 0.55];
//   紙の 場所 (px, py)＝book の 左上から はかった 画面の ところ を そのままに して 大きさを かえる
function zoomAt(s, px, py) {
  const p = { x: (px - zoom.tx) / zoom.s, y: (py - zoom.ty) / zoom.s };   // いま そこに ある 紙の中の 点
  zoom.s = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, s));
  zoom.tx = px - zoom.s * p.x;
  zoom.ty = py - zoom.s * p.y;
  applyZoom();
}
function stepZoom(px, py) {
  const i = ZOOM_STEPS.findIndex(v => Math.abs(zoom.s - v) < 0.06);
  zoomAt(ZOOM_STEPS[(i < 0 ? 0 : i + 1) % ZOOM_STEPS.length], px, py);
}
(() => {
  const book = $('book');
  const pts = new Map();   // いま紙にふれている指（pointerId → 場所）
  let x0 = null, y0 = 0, tx0 = 0, ty0 = 0, moved = false, lastTap = 0, lastX = 0, lastY = 0;
  let pinch = null, afterPinch = false;        // 2本指のとき：{ d0: はじめの指の間, s0, c: 指のまん中の下にある紙の場所 }
  // 紙の「動かす前」の左上（画面上の場所）。★getBoundingClientRect は拡大後の大きさになるので使わない
  const origin = () => { const r = book.parentElement.getBoundingClientRect(); return { x: r.left + book.offsetLeft, y: r.top + book.offsetTop }; };
  const mid = () => { const [a, b] = [...pts.values()]; const o = origin(); return { x: (a.x + b.x) / 2 - o.x, y: (a.y + b.y) / 2 - o.y, d: Math.hypot(a.x - b.x, a.y - b.y) }; };
  const startPinch = () => {
    const m = mid();
    pinch = { d0: Math.max(m.d, 1), s0: zoom.s, c: { x: (m.x - zoom.tx) / zoom.s, y: (m.y - zoom.ty) / zoom.s } };
    x0 = null;   // 1本指の動き（めくる・ずらす）はやめる
  };
  book.addEventListener('pointerdown', e => {
    // ★紙の上の ボタン（ご注文内容の カゴに入れる）は ふつうに 押せるように、めくる・ずらす は しない（v0.2.78）
    //   setPointerCapture を すると click が 紙に とられて ボタンが 動かなく なる
    if (e.target.closest('button, a, input')) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    try { book.setPointerCapture(e.pointerId); } catch (err) { /* とれなくても動く */ }
    if (pts.size === 2) { startPinch(); return; }
    if (pts.size > 2) return;
    x0 = e.clientX; y0 = e.clientY; tx0 = zoom.tx; ty0 = zoom.ty; moved = false; afterPinch = false;
  });
  book.addEventListener('pointermove', e => {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinch && pts.size >= 2) {
      const m = mid();
      zoom.s = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, pinch.s0 * m.d / pinch.d0));
      zoom.tx = m.x - zoom.s * pinch.c.x;   // 指のまん中の下の紙が、指についてくるように
      zoom.ty = m.y - zoom.s * pinch.c.y;
      applyZoom();
      return;
    }
    if (x0 === null || !zoom.on) return;
    const dx = e.clientX - x0, dy = e.clientY - y0;
    if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
    zoom.tx = tx0 + dx; zoom.ty = ty0 + dy;
    applyZoom();
  });
  const end = e => {
    pts.delete(e.pointerId);
    if (pinch) {
      if (pts.size < 2) pinch = null;
      if (pts.size === 1) { const [p] = [...pts.values()]; x0 = p.x; y0 = p.y; tx0 = zoom.tx; ty0 = zoom.ty; moved = true; afterPinch = true; }   // のこった1本でそのままずらせる
      return;
    }
    if (x0 === null || e.type === 'pointercancel') { x0 = null; return; }
    const dx = e.clientX - x0, dy = e.clientY - y0;
    x0 = null;
    const isTap = !moved && Math.abs(dx) < 10 && Math.abs(dy) < 10;
    if (isTap) {
      const now = Date.now();
      if (now - lastTap < 350 && Math.abs(e.clientX - lastX) < 30 && Math.abs(e.clientY - lastY) < 30) {
        lastTap = 0;
        const o2 = origin();
        // ★v0.2.132 みなとさん「紙が 動く。ダブルクリックで まん中に」：ずれて いたら まず 実寸の まん中に もどす
        if (zoom.s !== 1 || zoom.tx || zoom.ty) { zoom.s = 1; zoom.tx = 0; zoom.ty = 0; setZoom(false); applyZoom(); }
        else stepZoom(e.clientX - o2.x, e.clientY - o2.y);   // ★ダブルタップで 3段階（v0.2.112）
        return;
      }
      lastTap = now; lastX = e.clientX; lastY = e.clientY;
      // えにっきの 絵：マスを おすと つぎの 絵（ダブルタップと まちがえないように 少し まつ・v0.2.84）
      const tx = e.clientX, ty = e.clientY;
      // ★v0.2.124 スタンプ（貼る・大きく・消す）が 先。なにも しなければ えにっきの 絵の 切りかえ
      if (ENIKKI.on && (ENIKKI.pick || Object.keys(ENIKKI.stamps).length)) setTimeout(() => { if (lastTap === now && !stampTap(tx, ty) && ENIKKI.status === 'ok') enikkiTap(tx, ty); }, 360);
      else if (ENIKKI.status === 'ok') setTimeout(() => { if (lastTap === now) enikkiTap(tx, ty); }, 360);
      return;
    }
    // ★2本指のあとに残った指では、めくらない（ズームをやめた直後に勝手にめくれないように）
    if (!zoom.on && !afterPinch && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
  };
  book.addEventListener('pointerup', end);
  book.addEventListener('pointercancel', end);
  book.addEventListener('dblclick', e => e.preventDefault());
  // ★v0.2.112 パソコンの トラックパッド：2本指の ピンチ（ctrl＋ホイールで くる）／Ctrl＋ホイール
  book.addEventListener('wheel', e => {
    if (!e.ctrlKey) return;   // ふつうの スクロールは そのまま（ページが うごく）
    e.preventDefault();
    const o2 = origin();
    zoomAt(zoom.s * Math.exp(-e.deltaY / 180), e.clientX - o2.x, e.clientY - o2.y);
  }, { passive: false });
  book.addEventListener('dragstart', e => e.preventDefault());   // ★パソコン：画像の ドラッグを 止める（止めないと pointercancel に なって めくれない）
  // ★iPhone：2本指で「ページぜんたい」が大きくなるのを止める（紙だけを大きくする）
  ['gesturestart', 'gesturechange'].forEach(t => book.addEventListener(t, e => e.preventDefault(), { passive: false }));
})();
// 紙の 左右の「‹ ›」（パソコンだけ 見える）
const FLIP_ARROW = { l: 'M15 5l-7 7 7 7', r: 'M9 5l7 7-7 7' };
[['flipPrev', 'l', -1], ['flipNext', 'r', 1]].forEach(([id, side, d]) => {
  $(id).innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${FLIP_ARROW[side]}"/></svg>`;   // 決まった絵だけ
  $(id).onclick = () => { if (zoom.s !== 1) setZoom(false); step(d); };
});
function syncFlip() {
  const list = pageList(), i = list.findIndex(p => p.id === curPage().id);
  $('flipPrev').disabled = i <= 0;
  $('flipNext').disabled = i < 0 || i >= list.length - 1;
}
document.addEventListener('keydown', e => {
  if (e.target.closest?.('input,textarea')) return;
  if (e.key === 'ArrowRight') step(1);
  if (e.key === 'ArrowLeft') step(-1);
});

// ===== QRコードを作る（バイトモード・誤り訂正M・1〜20型）=====
//   外の道具を使わず、このページだけで作る。作りは規格どおり（Nayuki の作り方を参考）
const makeQr = (() => {
  // 型ごとの［1ブロックの誤り訂正の数, [[ブロック数, 1ブロックのデータ数], ...]］（誤り訂正M）
  const BLOCKS_M = [null,
    [10, [[1, 16]]], [16, [[1, 28]]], [26, [[1, 44]]], [18, [[2, 32]]], [24, [[2, 43]]],
    [16, [[4, 27]]], [18, [[4, 31]]], [22, [[2, 38], [2, 39]]], [22, [[3, 36], [2, 37]]], [26, [[4, 43], [1, 44]]],
    [30, [[1, 50], [4, 51]]], [22, [[6, 36], [2, 37]]], [22, [[8, 37], [1, 38]]], [24, [[4, 40], [5, 41]]], [24, [[5, 41], [5, 42]]],
    [28, [[7, 45], [3, 46]]], [28, [[10, 46], [1, 47]]], [26, [[9, 43], [4, 44]]], [26, [[3, 44], [11, 45]]], [26, [[3, 41], [13, 42]]],
  ];
  const ALIGN = [null, [], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50],
    [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82],
    [6, 30, 58, 86], [6, 34, 62, 90]];
  const MASKS = [
    (x, y) => (x + y) % 2 === 0, (x, y) => y % 2 === 0, (x, y) => x % 3 === 0, (x, y) => (x + y) % 3 === 0,
    (x, y) => (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0, (x, y) => x * y % 2 + x * y % 3 === 0,
    (x, y) => (x * y % 2 + x * y % 3) % 2 === 0, (x, y) => ((x + y) % 2 + x * y % 3) % 2 === 0,
  ];
  const bit = (v, i) => ((v >>> i) & 1) !== 0;
  const gfMul = (x, y) => { let z = 0; for (let i = 7; i >= 0; i--) { z = (z << 1) ^ ((z >>> 7) * 0x11D); z ^= ((y >>> i) & 1) * x; } return z; };
  const rsDivisor = deg => {
    const r = new Array(deg).fill(0); r[deg - 1] = 1;
    let root = 1;
    for (let i = 0; i < deg; i++) {
      for (let j = 0; j < deg; j++) { r[j] = gfMul(r[j], root); if (j + 1 < deg) r[j] ^= r[j + 1]; }
      root = gfMul(root, 2);
    }
    return r;
  };
  const rsRemainder = (data, div) => {
    const r = new Array(div.length).fill(0);
    for (const b of data) {
      const f = b ^ r.shift(); r.push(0);
      div.forEach((d, i) => { r[i] ^= gfMul(d, f); });
    }
    return r;
  };
  const dataCap = v => BLOCKS_M[v][1].reduce((a, [n, k]) => a + n * k, 0);

  return function makeQr(text, opt = {}) {
    const bytes = [...new TextEncoder().encode(text)];
    let ver = opt.version;
    if (!ver) {
      for (ver = 1; ver <= 20; ver++) if (4 + (ver < 10 ? 8 : 16) + bytes.length * 8 <= dataCap(ver) * 8) break;
      if (ver > 20) throw new Error('QRに入りきりません');
    }
    const size = ver * 4 + 17;
    // --- データのビット列 ---
    const bb = [];
    const put = (v, len) => { for (let i = len - 1; i >= 0; i--) bb.push((v >>> i) & 1); };
    put(4, 4); put(bytes.length, ver < 10 ? 8 : 16); bytes.forEach(b => put(b, 8));
    const cap = dataCap(ver) * 8;
    put(0, Math.min(4, cap - bb.length));
    put(0, (8 - bb.length % 8) % 8);
    for (let pad = 0xEC; bb.length < cap; pad ^= 0xEC ^ 0x11) put(pad, 8);
    const data = [];
    for (let i = 0; i < bb.length; i += 8) data.push(parseInt(bb.slice(i, i + 8).join(''), 2));
    // --- 誤り訂正をつけて、交互にならべる ---
    const [ecLen, groups] = BLOCKS_M[ver];
    const div = rsDivisor(ecLen);
    const dBlocks = [], eBlocks = [];
    let k = 0;
    for (const [n, len] of groups) for (let b = 0; b < n; b++) { const d = data.slice(k, k + len); k += len; dBlocks.push(d); eBlocks.push(rsRemainder(d, div)); }
    const cw = [];
    const maxLen = Math.max(...dBlocks.map(d => d.length));
    for (let i = 0; i < maxLen; i++) dBlocks.forEach(d => { if (i < d.length) cw.push(d[i]); });
    for (let i = 0; i < ecLen; i++) eBlocks.forEach(e => cw.push(e[i]));
    // --- 決まった模様 ---
    const mod = Array.from({ length: size }, () => new Array(size).fill(false));
    const fn = Array.from({ length: size }, () => new Array(size).fill(false));
    const set = (x, y, v) => { mod[y][x] = v; fn[y][x] = true; };
    for (let i = 0; i < size; i++) { set(6, i, i % 2 === 0); set(i, 6, i % 2 === 0); }
    const finder = (cx, cy) => {
      for (let dy = -4; dy <= 4; dy++) for (let dx = -4; dx <= 4; dx++) {
        const x = cx + dx, y = cy + dy;
        if (x < 0 || y < 0 || x >= size || y >= size) continue;
        const d = Math.max(Math.abs(dx), Math.abs(dy));
        set(x, y, d !== 2 && d !== 4);
      }
    };
    finder(3, 3); finder(size - 4, 3); finder(3, size - 4);
    const al = ALIGN[ver], last = al.length - 1;
    al.forEach((ay, i) => al.forEach((ax, j) => {
      if ((i === 0 && j === 0) || (i === 0 && j === last) || (i === last && j === 0)) return;
      for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) set(ax + dx, ay + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
    }));
    const drawFormat = mask => {
      const d = (0 << 3) | mask;   // 誤り訂正M＝0
      let rem = d;
      for (let i = 0; i < 10; i++) rem = (rem << 1) ^ ((rem >>> 9) * 0x537);
      const bits = ((d << 10) | rem) ^ 0x5412;
      for (let i = 0; i <= 5; i++) set(8, i, bit(bits, i));
      set(8, 7, bit(bits, 6)); set(8, 8, bit(bits, 7)); set(7, 8, bit(bits, 8));
      for (let i = 9; i < 15; i++) set(14 - i, 8, bit(bits, i));
      for (let i = 0; i < 8; i++) set(size - 1 - i, 8, bit(bits, i));
      for (let i = 8; i < 15; i++) set(8, size - 15 + i, bit(bits, i));
      set(8, size - 8, true);
    };
    drawFormat(0);
    if (ver >= 7) {
      let rem = ver;
      for (let i = 0; i < 12; i++) rem = (rem << 1) ^ ((rem >>> 11) * 0x1F25);
      const bits = (ver << 12) | rem;
      for (let i = 0; i < 18; i++) { const a = size - 11 + i % 3, b = Math.floor(i / 3); set(a, b, bit(bits, i)); set(b, a, bit(bits, i)); }
    }
    // --- データをジグザグに置く ---
    let n = 0;
    for (let right = size - 1; right >= 1; right -= 2) {
      if (right === 6) right = 5;
      for (let v = 0; v < size; v++) for (let j = 0; j < 2; j++) {
        const x = right - j, up = ((right + 1) & 2) === 0, y = up ? size - 1 - v : v;
        if (!fn[y][x] && n < cw.length * 8) { mod[y][x] = bit(cw[n >>> 3], 7 - (n & 7)); n++; }
      }
    }
    // --- マスク（えらぶ：点のかたよりがいちばん少ないもの）---
    const applyMask = m => { for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) if (!fn[y][x] && MASKS[m](x, y)) mod[y][x] = !mod[y][x]; };
    const penalty = () => {
      let p = 0;
      const lines = [];
      for (let y = 0; y < size; y++) lines.push(mod[y]);
      for (let x = 0; x < size; x++) lines.push(mod.map(r => r[x]));
      for (const line of lines) {
        let run = 1;
        for (let i = 1; i <= size; i++) {
          if (i < size && line[i] === line[i - 1]) run++;
          else { if (run >= 5) p += run - 2; run = 1; }
        }
        const s = line.map(v => (v ? 1 : 0)).join('');
        for (const pat of ['10111010000', '00001011101']) for (let i = s.indexOf(pat); i >= 0; i = s.indexOf(pat, i + 1)) p += 40;
      }
      for (let y = 0; y < size - 1; y++) for (let x = 0; x < size - 1; x++) {
        const c = mod[y][x];
        if (c === mod[y][x + 1] && c === mod[y + 1][x] && c === mod[y + 1][x + 1]) p += 3;
      }
      const dark = mod.reduce((a, r) => a + r.filter(Boolean).length, 0);
      p += Math.floor(Math.abs(dark * 20 - size * size * 10) / (size * size)) * 10;
      return p;
    };
    let mask = opt.mask;
    if (mask == null) {
      let best = Infinity;
      for (let m = 0; m < 8; m++) {
        applyMask(m); drawFormat(m);
        const pt = penalty();
        if (pt < best) { best = pt; mask = m; }
        applyMask(m);
      }
    }
    applyMask(mask); drawFormat(mask);
    return { size, version: ver, mask, rows: mod.map(r => r.map(v => (v ? '1' : '0')).join('')) };
  };
})();

// ===== いま入れている内容を、みじかい文字にする（QRとURL用）=====
//   ?d=… の中身（v0.2.74 から しるし 13。さいごに [年間の形のID, 見ている年間の紙（-1＝見ていない）] を 足した）：[12, 手帳の形のID, 年, はじまり月, 週のはじまり(1/0), 祝日(1/0), 暦と丸(0〜127＝六曜1＋月齢2＋二十四節気4＋旧暦8＋土曜の丸16＋日曜の丸32＋祝日の丸64), カレンダー(1/0), 背景(3文字), サイズ(2文字), ぎょうじ(0〜7), オーダーメイド（C1-0101 など。ちがう形は ''）, 何まいめ(0から), 線の色(6けた), [文字, 土曜, 日曜の色（6けた。線と同じは '')], バインダー, 紙, 名入れ] を JSON → UTF-8 → base64url
//   ★印刷した紙のQRを読むと、その紙がひらく
//   ★先頭の 12 は「手帳（はじまり月・表示・背景・色4つ・サイズ・ぎょうじ・オーダーメイド・日付の丸・紙）」のしるし（ルーズリーフは 1。手帳の古いしるし 2〜11 は読まない）
// ファイルで開いたときの QR の行き先（内容はもどらない）。楽天の規約で 楽天の外は入れない
//   ・楽天：楽天のお店のトップ　・Shopify：テーマの部品が わたす アドレス（window.TK_SHARE_URL）
const SHARE_FALLBACK = SHOP === 'shopify' && typeof window.TK_SHARE_URL === 'string' && /^https:\/\/[a-z0-9.-]+\//.test(window.TK_SHARE_URL)
  ? window.TK_SHARE_URL : 'https://www.rakuten.co.jp/timekeeper/';
function shareCode(noName) {   // ★2026-10-15 noName＝人に 見せる 共有アドレス用。名入れの 名前は 入れない
  const note = state.notes[state.idx];
  // ★v0.2.74：しるし 13。さいごに 年間の形（Y1 など）と「年間の紙を 見ているか（何まいめ。見ていなければ -1）」を 足した
  const arr = [13, note ? note.id : '', state.year, state.month, state.weekStart, state.holidays ? 1 : 0, koyoBits(), state.miniCal ? 1 : 0, bgCode(), sizeCode(), state.events, cmTarget(note) ? cmTarget(note).code : '', state.sheet, state.color.slice(1),
    ['text', 'sat', 'sun'].map(k => (state.inks[k] || '').slice(1)), state.binder, state.paper, noName ? '' : state.name, yNote() ? yNote().id : '', curPage().ysheet != null ? state.ySheet : -1, state.country];   // ★v0.2.159 さいごに 国
  const bin = String.fromCharCode(...new TextEncoder().encode(JSON.stringify(arr)));
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function shareUrl(noName) {
  const base = /^https?:$/.test(location.protocol) ? location.origin + location.pathname : SHARE_FALLBACK;
  return base + '?' + (PSIZE !== 'b5' ? 'paper=' + PSIZE + '&' : '') + 'd=' + shareCode(noName);   // ★v0.2.168 紙の サイズも のこす
}
// URL の ?d= を読んで、内容をもどす（外から来た文字なので、1つずつ形をたしかめる）
function readShare() {
  const d = new URLSearchParams(TK_LOC.search).get('d');
  if (!d || d.length > 1200) return;
  let arr;
  try {
    const bin = atob(d.replace(/-/g, '+').replace(/_/g, '/'));
    arr = JSON.parse(new TextDecoder().decode(Uint8Array.from(bin, ch => ch.charCodeAt(0))));
  } catch (e) { return; }
  if (!Array.isArray(arr) || (arr[0] !== 12 && arr[0] !== 13)) return;   // 12＝年間の まえの 版（年間は はじめの まま）  ★テストが この形を 見ている
  const [, id, year, month, ws, hol, kb, cal, bgc, szc, evb, cmc, sheet, color, ik, binder, paper, name, yid, ys] = arr;
  if (SHOP === 'shopify' && COUNTRIES.some(c => c.id === arr[20] && c.ready)) state.country = arr[20];   // ★v0.2.159 国（お店だけ。週の はじまり・こよみは この あとの 値で 入る。言葉は nkInit で）
  const str = v => (typeof v === 'string' ? v : '');
  // 形は一覧にあって、作ってあるものだけ。年間の形なら 年間の紙に（前の版の QR で 年間の形が 手帳の形に 入っていたとき）
  const note = state.notes.find(n => n.id === id && n.ready);
  if (note && isYearNote(note)) state.yIdx = note.index;
  else if (note) state.idx = note.index;
  const yn = state.notes.find(n => n.id === yid && n.ready && isYearNote(n));
  if (yn) state.yIdx = yn.index;
  if (ws === 0 || ws === 1) state.weekStart = ws;
  if (Number.isInteger(year) && year >= YEAR_MIN && year <= YEAR_MAX && Number.isInteger(month) && month >= 1 && month <= 12) setStart(year, month);
  if (hol === 0 || hol === 1) state.holidays = hol === 1;
  if (Number.isInteger(kb) && kb >= 0 && kb <= 127) {
    state.rokuyo = !!(kb & 1); state.moon = !!(kb & 2); state.sekki = !!(kb & 4); state.kyureki = !!(kb & 8);
    state.marks = { sat: !!(kb & 16), sun: !!(kb & 32), hol: !!(kb & 64) };
  }
  if (cal === 0 || cal === 1) state.miniCal = cal === 1;
  if (Number.isInteger(evb) && evb >= 0 && evb <= 7) state.events = evb;
  const cm = readCmCode(str(cmc));
  if (cm && note && cm.id === note.id) state.custom[cm.id] = cm.v;   // 紙の数がかわるので、はじまり月・紙の場所より前に
  else if (cm && note && cm.id === note.fmt.tune) state.tune[note.id] = cm.v;   // 変えた 基本の形（v0.2.85）
  const bm = /^([0-4])([2-9a])([0-4])$/.exec(str(bgc));
  if (bm) state.bg = { type: +bm[1], gap: parseInt(bm[2], 36), dens: +bm[3] };
  const zm = /^([0-4])([0-9a-o])$/.exec(str(szc));
  if (zm) { const pos = parseInt(zm[2], 36); state.size = { k: SIZE_KS[+zm[1]], dx: SIZE_DS[Math.floor(pos / 5)], dy: SIZE_DS[pos % 5] }; }
  // 紙の場所：その1冊の中の数だけ
  if (Number.isInteger(sheet) && sheet >= 0 && sheet < sheetCount(state.notes[state.idx])) { setSheet(sheet); state.page = sheetPage(); }
  // 年間の紙を 見ていた QR なら、その 年間の紙を ひらく（v0.2.74）
  if (yNote() && Number.isInteger(ys) && ys >= 0 && ys < sheetCount(yNote())) { state.ySheet = ys; state.page = 'y' + ys; }
  if (/^[0-9a-f]{6}$/i.test(str(color))) state.color = '#' + color.toLowerCase();
  if (Array.isArray(ik) && ik.length === 3) ['text', 'sat', 'sun'].forEach((k, i) => { if (/^[0-9a-f]{6}$/i.test(str(ik[i]))) state.inks[k] = '#' + ik[i].toLowerCase(); });
  // バインダーは、決めた名前の一覧にあるものだけ（__proto__ などの特別なことばを通さない）
  //   ★BINDER_LIST（いまの お店の 一覧）で しらべる。楽天で マルマンの QR を 読んでも マルマンには ならない
  if (BINDER_LIST.some(b => b.id === binder)) state.binder = binder;
  if (PAPERS.some(x => x.id === paper) && !PAPER_OUT[paper]) state.paper = paper;   // 品切れの 紙は えらばない   // 紙も 決めた名前の一覧にあるものだけ
  // 名前：絵文字・< > ・見えない文字（制御文字）は取りのぞく
  const noEmoji = new RegExp(NO_EMOJI.source, 'gu');
  const clean = (v, max) => [...str(v).replace(noEmoji, '').replace(/[<>\u0000-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069]/g, '')].slice(0, max).join('').trim();
  state.name = clean(name, 20);
  $('nameInput').value = state.name;
  syncChoices();
}

// ===== 印刷した紙の左下に入れるQRコード =====
//   読みとると、このページが同じ内容でひらく。名札のような白いカードに、丸い点のQRとお店の名前をのせる（単位は mm）
function printMarkSvg() {   // ★手帳 v0.2.240 と おなじ（22×9mm）
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 9" width="22mm" height="9mm" data-print-mark="1" fill="none" stroke="#111" stroke-width=".5" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 3.2V1h6v2.2"/><rect x="1.5" y="3.2" width="10" height="4" rx=".8"/><rect x="3.5" y="5.6" width="6" height="2.6"/><circle cx="10" cy="4.6" r=".35" fill="#111" stroke="none"/><text x="13" y="6.4" font-size="3.6" font-family="Helvetica,Arial,sans-serif" font-weight="700" fill="#111" stroke="none" letter-spacing=".3">PRINT</text></svg>';
}
function qrCardSvg(color) {
  // ★v0.2.116 みなとさん「印刷した QR が よめない」を なおした
  //   ① 点を 四角に（丸は インクが 少なくて 読みにくい）
  //   ② いつも こい色で 描く（えらんだ色が うすいと カメラが 読めない）
  //   ③ QR を 26mm → 31mm に（1マス 0.40mm → 0.49mm）
  //   ★カードの わくと 文字は、えらんだ色の まま
  const QR_INK = '#111111';                           // QR は かならず こい色
  const qr = makeQr(shareUrl());
  const n = qr.size, box = 31, q = 2;                 // QRの大きさ 31mm、まわりの白 2mm
  const m = (box - q * 2) / n;                        // 1マスの大きさ
  const isFinder = (r, c) => (r < 7 && c < 7) || (r < 7 && c >= n - 7) || (r >= n - 7 && c < 7);
  let dots = '';
  qr.rows.forEach((row, r) => {
    for (let c = 0; c < n; c++) {
      if (row[c] === '1' && !isFinder(r, c)) dots += `<rect x="${c}" y="${r}" width="1" height="1" rx=".18"/>`;
    }
  });
  const finder = (x, y) => `<rect x="${x + .5}" y="${y + .5}" width="6" height="6" rx="1.4" fill="none" stroke="${QR_INK}" stroke-width="1"/>`
    + `<rect x="${x + 2}" y="${y + 2}" width="3" height="3" rx=".7"/>`;
  const finders = finder(0, 0) + finder(n - 7, 0) + finder(0, n - 7);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 34" width="70mm" height="34mm" data-qr-version="${qr.version}" data-qr-mm="${nf(m)}">
    <rect x=".15" y=".15" width="69.7" height="33.7" rx="3.2" fill="#fff" stroke="${color}" stroke-width=".3"/>
    <rect x="1.5" y="1.5" width="31" height="31" fill="#fff"/>
    <g transform="translate(${1.5 + q} ${1.5 + q}) scale(${m.toFixed(4)})" fill="${QR_INK}">${dots}${finders}</g>
    <g fill="${color}" font-family="Hiragino Maru Gothic ProN, M PLUS Rounded 1c, sans-serif">
      <text x="35.5" y="10" font-size="4.6" font-weight="800" textLength="31" lengthAdjust="spacingAndGlyphs">BirthBookNote</text>
      <text x="35.5" y="14.8" font-size="3" font-weight="700" textLength="31" lengthAdjust="spacingAndGlyphs">バースブック手帳B5</text>
      <line x1="35.5" y1="17.6" x2="66.5" y2="17.6" stroke="${color}" stroke-width=".2"/>
      <text x="35.5" y="21.6" font-size="2.5">読みとると、この紙の</text>
      <text x="35.5" y="25" font-size="2.5">デザインがひらきます</text>
      <text x="35.5" y="29.6" font-size="2.5" font-weight="700">手帳のタイムキーパー</text>
    </g>
  </svg>`;
}

// ===== 印刷した記録（ログ）を送る =====
//   ★送り先（PRINT_LOG_URL）が空のあいだは、どこにも送らない
//   ★名前・右上の3行の「中の文字」は送らない（あるか・ないかだけ）。IPなどもページからは送らない
//   ★sendBeacon で text/plain の JSON を送る（ページを閉じても届きやすい・楽天GOLDからでも送れる形）
const PRINT_LOG_URL = '';
function printLogData() {
  const note = state.notes[state.idx] || {};
  return {
    v: 1,
    at: new Date().toISOString(),
    app: APP_VERSION,
    code: orderCode(),
    format: note.id || '',
    formatName: note.name || '',
    yearFormat: yNote() ? yNote().id : '',
    year: state.year,
    month: state.month,
    weekStart: state.weekStart,
    holidays: state.holidays,
    koyomi: koyoBits(),
    marks: `${state.marks.sat ? 1 : 0}${state.marks.sun ? 1 : 0}${state.marks.hol ? 1 : 0}`,
    miniCal: state.miniCal,
    bg: bgCode(),
    size: sizeCode(),
    events: state.events,
    custom: state.notes[state.idx] && state.notes[state.idx].fmt.custom ? cmCode(state.notes[state.idx].id) : '',
    sheet: plannerKey(),
    color: state.color.toUpperCase(),
    inks: inkChoice().map(a => a.join(' ')).join(' / '),
    paper: state.paper,
    binder: state.binder,
    hasName: !!state.name,
    device: matchMedia('(pointer: coarse)').matches ? 'touch' : 'mouse',
    page: location.origin + location.pathname,
  };
}
function sendPrintLog() {
  if (!PRINT_LOG_URL) return;
  try {
    const body = new Blob([JSON.stringify(printLogData())], { type: 'text/plain' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(PRINT_LOG_URL, body))) {
      fetch(PRINT_LOG_URL, { method: 'POST', body, keepalive: true, mode: 'no-cors' }).catch(() => {});
    }
  } catch (e) { /* 記録が送れなくても、印刷はそのまま */ }
}

// ===== 印刷して確認 =====
//   いま見ている手帳の紙（線の色・☆・右上の3行・名前入り）を、B5（182×257mm）原寸で1枚だけ印刷する
//   ★楽天アプリの中では印刷画面が出ないことがある（そのときはブラウザで開いてもらう）
/* ============================================================
 * 📄 v0.2.180 PDF ダウンロード（会員）— ぜんぶの 紙を 1つの PDF に
 * ------------------------------------------------------------
 *  みなとさん 2026-10-02「ショピファイの 購入で ダウンロードを 追加します。
 *  サブスクモデルで 1ヶ月 480円。PDF で ダウンロードできるように」
 *  計画＝tkdeko_pdf_subsc_plan.md
 *
 *  ★なぜ ブラウザで 作るか：紙は もともと **SVG**なので、
 *    そのまま **ベクターの PDF**に できる（拡大しても きれい・ミリ単位で ぴったり）。
 *    サーバーは いらない＝お金も かからない。
 *  ★部品（jsPDF・svg2pdf）は **押した ときだけ** 読みこむ。
 *    ありかは window.TK_PDF_LIBS（お店の テーマが わたす）。
 *    → **楽天 GOLD では この 2行が 無い ので、PDF の ボタンも 出ない**
 *      （きまり：楽天の HTML に Shopify の アドレスを 書かない）
 * ============================================================ */

/* 部品を 1回だけ 読みこむ */
let pdfLibs = null;
function loadPdfLibs() {
  if (pdfLibs) return pdfLibs;
  const urls = window.TK_PDF_LIBS;
  if (!Array.isArray(urls) || urls.length < 2) return Promise.reject(new Error('no-libs'));
  const one = src => new Promise((ok, ng) => {
    const t = document.createElement('script');
    t.src = src; t.onload = ok; t.onerror = () => ng(new Error('load ' + src));
    document.head.appendChild(t);
  });
  // ★svg2pdf は jsPDF の あとで ないと つながらない ので 順番に
  //   ★3つめ＝日本語の 字（tk-font.js）。無い 古い head.liquid でも 2つで 動く（字は 入らない）
  pdfLibs = urls.reduce((p, u) => p.then(() => one(u)), Promise.resolve());
  return pdfLibs;
}

/* ★色を 直に 塗る
   画面では <style> の !important で 色を かえて いるが、
   PDF を 作る 道具は その CSS を 読まない ので、**1つずつ 属性に 書く**。
   （これを しないと PDF が ぜんぶ 黒い 線に なる） */
function flattenInk(svg, sheet) {
  const c = inks();
  const B = NOTE_INK_BASE.toLowerCase();
  const TXT = new Set(['text', 'tspan', 'use']);
  svg.querySelectorAll('style').forEach(el => el.remove());
  const all = svg.querySelectorAll('*');
  for (const el of all) {
    const cl = el.getAttribute('class') || '';
    const st = el.getAttribute('stroke');
    if (st && st !== 'none') el.setAttribute('stroke', c.line);
    if (cl.includes('ink')) el.setAttribute('fill', c.text);
    else if (cl.includes('line')) el.setAttribute('fill', c.line);
    /* ★nv0.2.44 みなとさん 2026-10-03「印刷に 進みます」で 見つけた。
       ------------------------------------------------------------
       ★画面は nv0.2.34 で 直したが、**PDF の 道は 直って いなかった**。
         画面は CSS（[fill="#c1e4e9"]）で そめるが、PDF の 道具は CSS を 読まない ので
         ここで 1つずつ 書く ひつようが ある。
         直す 前は 柄の 文字が **本店の うすい 水色（#c1e4e9）の まま**だった（45か所）。
       ・文字（text・tspan・use）… 文字の 色
       ・そのほか（path・丸・四角 など）… 線の 色 */
    const f0 = (el.getAttribute('fill') || '').toLowerCase();
    if (f0 === B) el.setAttribute('fill', TXT.has(el.tagName.toLowerCase()) ? c.text : c.line);
    const f = (el.getAttribute('fill') || '').toLowerCase();
    if (f === '#ffffff' || f === '#fff' || f === 'white' || cl.includes('paper')) el.setAttribute('fill', sheet);
    /* ★手帳 v0.2.193〜197 と おなじ：字を 1つずつ 属性に 書き（Zen Maru Gothic）、太さを bold/normal に。1文字の textLength は 外す */
    if (el.nodeName === 'text' || el.nodeName === 'tspan') {
      if (window.TK_FONT) el.setAttribute('font-family', window.TK_FONT.family);
      const w = String(el.getAttribute('font-weight') || '');
      if (w && w !== 'normal' && w !== 'bold') el.setAttribute('font-weight', (w === 'bolder' || parseInt(w, 10) >= 600) ? 'bold' : 'normal');
      /* ★v0.2.197 みなとさん「年間 2年なのに 3か月しか 出ない」「プレビューが から」
         ＝PDF の 道具（svg2pdf）は textLength を「字と 字の あいだ」で そろえる ので、
           **1文字**（年間の 月の 数字 1〜9）だと 0 で 割って「-Infinity Tc」が PDF に 入り、
           Acrobat は そこで その ページを 描くのを やめて いた（Poppler でも 同じ・Chrome は 無視して 描く）。
         → 1文字の textLength は 外す（1文字なら はばを そろえる 意味も ない） */
      if (el.hasAttribute('textLength') && [...(el.textContent || '').trim()].length <= 1) { el.removeAttribute('textLength'); el.removeAttribute('lengthAdjust'); }
    }
  }
  return svg;
}

/* ★v0.2.199 みなとさん「日付の 数字が 土日の 丸の まん中に 来ない」の 本当の 原因
   ＝PDF の 道具（svg2pdf）は 字の はば（text-anchor="middle" の まん中あわせ・textLength）を
     **ブラウザーに はからせる**。ブラウザーは「TKMaru」という 字を 知らない ので 別の 字（代わりの 字）で はかり、
     PDF に 入る 字より 1.5倍ほど 広く 出て、数字が 左に ずれて いた。
   → 同じ 字を ブラウザーにも 入れて（FontFace）から 作る。はかる 字 ＝ PDF の 字 に なる */
let tkBrowserFontP = null;
function tkBrowserFont() {
  const F = window.TK_FONT;
  if (!F || !F.regular || typeof FontFace === 'undefined') return Promise.resolve(false);
  if (tkBrowserFontP) return tkBrowserFontP;
  const one = (b64, weight) => { const f = new FontFace(F.family, 'url(data:font/ttf;base64,' + b64 + ')', { weight }); document.fonts.add(f); return f.load(); };
  tkBrowserFontP = Promise.all([one(F.regular, '400'), one(F.bold || F.regular, '700')])
    .then(() => { try { if (typeof window.TK_LOG === 'function') window.TK_LOG('字: ブラウザーにも 入れた ' + F.family); } catch (e) {} return true; })
    .catch(e => { console.warn('[pdf] browser font', e); try { if (typeof window.TK_LOG === 'function') window.TK_LOG('⚠️ 字を ブラウザーに 入れられない: ' + (e && e.message || e)); } catch (e2) {} return false; });
  return tkBrowserFontP;
}

/* ★v0.2.193 jsPDF に 日本語の 字を 入れる（tk-font.js が 読めて いる ときだけ。無ければ いままで どおり） */
function tkPdfFonts(doc) {
  const F = window.TK_FONT;
  const log = m => { try { if (typeof window.TK_LOG === 'function') window.TK_LOG('字: ' + m); } catch (e) {} };   // ★v0.2.195 お店用ページの ログ
  if (!F || !F.regular) { log('TK_FONT が ない（tk-font.js が 読めて いない）'); return false; }
  try {
    if (!doc.getFontList()[F.family]) {
      doc.addFileToVFS('tk-maru-regular.ttf', F.regular);
      doc.addFont('tk-maru-regular.ttf', F.family, 'normal');
      doc.addFileToVFS('tk-maru-bold.ttf', F.bold || F.regular);
      doc.addFont('tk-maru-bold.ttf', F.family, 'bold');
    }
    doc.setFont(F.family, 'normal');
    /* ★v0.2.198 みなとさん「日付の 数字が 土日の 丸の まん中に 来ない」
       ＝textLength（字の はばを そろえる）で jsPDF の 中に「字の あいだ（charSpace）」が のこり、
         つぎの 字の はばを はかる とき（text-anchor="middle" の まん中あわせ）に それが まざって ずれて いた。
       → 字を 1つ 描く たびに charSpace を 0 に もどす（PDF の 中は q/Q で もどって いる。JS の 中だけ のこって いた） */
    if (!doc.__tkTextGuard) {
      const orig = doc.text;
      doc.text = function () { try { return orig.apply(this, arguments); } finally { try { this.setCharSpace(0); } catch (e) {} } };
      doc.__tkTextGuard = true;
    }
    log('入れた ' + F.family + '（regular ' + Math.round(F.regular.length / 1024) + 'KB・bold ' + Math.round((F.bold || '').length / 1024) + 'KB）・いま ' + doc.getFont().fontName);
    return true;
  } catch (e) { console.warn('[pdf] font', e); log('⚠️ 入れられない: ' + (e && e.message || e)); return false; }
}

/* 1まいぶんの SVG（絵の もと）を 作る。tintedUrl と 同じ 中身だが **要素の まま** 返す */
async function sheetSvgEl(note, sheet) {
  const doc = new DOMParser().parseFromString(await getSvg(note, false), 'image/svg+xml');
  const svg = doc.documentElement;
  if (svg.nodeName !== 'svg') throw new Error('not svg');
  fillDeco(svg);
  fillEnikki(svg);
  fillStamps(svg, note);
  return flattenInk(svg, sheet);
}

/* ぜんぶの 紙を 1つの PDF に して ダウンロード */
let pdfBusy = false;
async function makePdf() {
  if (pdfBusy) return;
  pdfBusy = true;
  const btn = $('pdfGo');
  const say = t => { const e = $('pdfMsg'); if (e) e.textContent = t; };
  if (btn) btn.disabled = true;
  /* いまの 場所を おぼえて おく（作りおわったら もどす） */
  const keep = { page: state.page, sheet: state.sheet, ySheet: state.ySheet };
  const hide = document.createElement('div');
  hide.style.cssText = 'position:fixed;left:-99999px;top:0;width:1px;height:1px;overflow:hidden';
  document.body.appendChild(hide);
  try {
    say(TEXTS.pdfLoading);
    await loadPdfLibs();
    const JP = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
    /* ★svg2pdf は 読みこむと **jsPDF の 中に `doc.svg()` として 入る**。
       window.svg2pdf は かたまり（{svg2pdf}）で 関数では ない ので そこを 見ない。
       （手元で ためして わかった：window.svg2pdf → object・JP.API.svg → あり） */
    if (!JP || typeof JP.API.svg !== 'function') throw new Error('libs');
    const ps = psizeOf(PSIZE);
    const pages = pageList().filter(p => p.ysheet != null || p.sheet != null);
    if (!pages.length) throw new Error('no-pages');
    const sm = prSheetPlan();   // ★nv0.2.171 A4・レターの まん中に 原寸で（かどに 切る 印）
    const PW = sm ? sm.sw : ps.w, PH = sm ? sm.sh : ps.h, OX = sm ? sm.ox : 0, OY = sm ? sm.oy : 0;
    const marks = () => { if (!sm || !sm.marks) return; doc.setDrawColor(102); doc.setLineWidth(0.25); const x0 = OX, y0 = OY, x1 = OX + ps.w, y1 = OY + ps.h; for (const [x, sx] of [[x0, -1], [x1, 1]]) for (const [y, sy] of [[y0, -1], [y1, 1]]) { doc.line(x + sx, y, x + sx * 4.5, y); doc.line(x, y + sy, x, y + sy * 4.5); } };
    const doc = new JP({ unit: 'mm', format: [PW, PH], orientation: PW > PH ? 'landscape' : 'portrait', compress: true });
    tkPdfFonts(doc);   // ★日本語の 字
    await tkBrowserFont();   // ★ブラウザーにも 同じ 字（はばを はかる ため）
    for (let i = 0; i < pages.length; i++) {
      const p = pages[i];
      say(TEXTS.pdfMaking.replace('{n}', i + 1).replace('{all}', pages.length));
      let el;
      if (p.ysheet != null) { state.ySheet = p.ysheet; el = await sheetSvgEl(yNote(), '#ffffff'); }
      else { setSheet(p.sheet); el = await sheetSvgEl(state.notes[state.idx], '#ffffff'); }
      hide.replaceChildren(el);                       // 道具が 大きさを はかれる ように 画面に 入れる
      if (i) doc.addPage([PW, PH], PW > PH ? 'landscape' : 'portrait');
      await doc.svg(el, { x: OX, y: OY, width: ps.w, height: ps.h });
      marks();
      await new Promise(r => setTimeout(r, 0));       // 画面が 止まらない ように ひと休み
    }
    doc.save(pdfName(pages.length));
    say(TEXTS.pdfDone);
  } catch (e) {
    console.error(e);
    say(TEXTS.pdfError);
  } finally {
    hide.remove();
    state.ySheet = keep.ySheet; setSheet(keep.sheet); state.page = keep.page;
    pdfBusy = false;
    if (btn) btn.disabled = false;
  }
}
function pdfName(n) {
  const ps = psizeOf(PSIZE);
  return 'birthbook-' + PSIZE + '-' + state.year + String(state.month).padStart(2, '0') + '-' + n + 'p.pdf';
}

/* ★2026-10-19 プラス会員：選んだ ページ（ノートごと）を まとめて 印刷。1まい ずつ 紙の 絵＋そのページの 書きこみ。ふつうの 人は 使えない（トップの 画面が とめる） */
function noteInkPrintCanvasFor(key, pxW) {
  const items = NOTEINK.pages[key] || []; if (!items.length) return null;
  const ps = typeof PSEL !== 'undefined' ? PSEL : { w: 182, h: 257 };
  const W = Math.max(600, pxW || 1800), H = Math.round(W * ps.h / ps.w);
  const keep = { W: NOTEINK.W, Hpx: NOTEINK.Hpx, H: NOTEINK.H, dpr: NOTEINK.dpr, sel: NOTEINK.sel, selG: NOTEINK.selG };
  const c = document.createElement('canvas'); c.width = W; c.height = H;
  try {
    NOTEINK.W = W; NOTEINK.Hpx = H; NOTEINK.H = 10000 * H / W; NOTEINK.dpr = 1; NOTEINK.sel = null; NOTEINK.selG = null;
    const ctx = c.getContext('2d'); ctx.setTransform(1, 0, 0, 1, 0, 0);
    noteDrawItems(ctx, items);
  } finally { Object.assign(NOTEINK, keep); }
  return c;
}
const noteListFromOpt = opt => {   // {from,to} → [ページ番号…]（上限は ふつう 2・会員 52）。opt が なければ null＝いまの 1ページ
  if (!opt || !(+opt.from >= 1)) return null;
  const max = noteWriteMax(); const a = Math.max(1, Math.min(max, Math.floor(+opt.from))); const b = Math.max(a, Math.min(max, Math.floor(+opt.to || a)));
  const out = []; for (let i = a; i <= b; i++) out.push(i); return out;
};
async function printNotePages(list, opt) {
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
  if (!note || !list || !list.length) return;
  const sheet = $('printSheet');
  const url = await tintedUrl(note, '#ffffff');   // 紙は 白（どの ページも おなじ 柄）
  sheet.classList.add('multi'); sheet.replaceChildren();
  const pre = noteInkPrefix();
  for (const pg of list) {
    const page = document.createElement('div'); page.className = 'p-page';
    const img = document.createElement('img'); img.alt = ''; img.src = url; page.appendChild(img);
    try { const ic = noteInkPrintCanvasFor(pre + pg, 1800); if (ic) { ic.className = 'p-ink'; page.appendChild(ic); } } catch (e) { console.error(e); }
    const q = document.createElement('div'); q.className = 'p-qr'; q.innerHTML = window.TK_PLUS ? '' : printMarkSvg(); page.appendChild(q);   // プラス会員は 印刷マークなし
    sheet.appendChild(page);
  }
  await Promise.all([...sheet.querySelectorAll('img')].map(i => (i.decode ? i.decode() : Promise.resolve()).catch(() => {})));
  prApplySheet(sheet);   // ★nv0.2.171
  sendPrintLog();
  if (!(opt && opt.prepare)) window.print();
}
/* ★nv0.2.171 刷る紙：このサイズ／A4／レター。小さい 紙は A4・レターの まん中に 原寸で 置いて かどに 切る 印を つける。
   ・ノートが 紙より 大きい とき（レターを A4 に 等）は えらべない（縮めない＝原寸が きまり）
   ・はじめは B5・A4 は「このサイズ」、ほかは 言語の 地域で A4 か レター（北米） */
const PR_SHEETS = { a4: [210, 297, 'A4'], letter: [215.9, 279.4, 'レター'] };
function prSheetFits(id) { const s = PR_SHEETS[id], ps = psizeOf(PSIZE); return !!s && ps.w <= s[0] + 0.01 && ps.h <= s[1] + 0.01 && (s[0] - ps.w > 0.5 || s[1] - ps.h > 0.5); }
function prSheetPick() {
  let v = ''; try { v = localStorage.getItem('tk_pr_sheet') || ''; } catch (e) {}
  if (v === 'own' || (PR_SHEETS[v] && prSheetFits(v))) return v;
  if (PSIZE === 'b5' || PSIZE === 'a4') return 'own';
  const loc = String((typeof navigator !== 'undefined' && navigator.language) || '').toLowerCase();
  const us = /^en-(us|ca|ph)|^es-(mx|us)|^fr-ca/.test(loc) ? 'letter' : 'a4';
  return prSheetFits(us) ? us : (prSheetFits(us === 'a4' ? 'letter' : 'a4') ? (us === 'a4' ? 'letter' : 'a4') : 'own');
}
function prSheetPlan() {
  const id = prSheetPick(); if (id === 'own' || !prSheetFits(id)) return null;
  const s = PR_SHEETS[id], ps = psizeOf(PSIZE), ox = (s[0] - ps.w) / 2, oy = (s[1] - ps.h) / 2;
  return { id, sw: s[0], sh: s[1], pw: ps.w, ph: ps.h, ox, oy, name: s[2], marks: ox >= 5 && oy >= 5 };
}
function prMarksSvg(m) {   // 4つの かどに「切る 印」（ノートの わくの 外がわ 1mm から 3.5mm）
  const L = 3.5, g = 1, x0 = m.ox, y0 = m.oy, x1 = m.ox + m.pw, y1 = m.oy + m.ph; let d = '';
  for (const [x, sx] of [[x0, -1], [x1, 1]]) for (const [y, sy] of [[y0, -1], [y1, 1]]) d += `M${(x + sx * g).toFixed(2)} ${y.toFixed(2)}h${(sx * L).toFixed(2)}M${x.toFixed(2)} ${(y + sy * g).toFixed(2)}v${(sy * L).toFixed(2)}`;
  return `<svg class="p-marks" viewBox="0 0 ${m.sw} ${m.sh}" preserveAspectRatio="none" aria-hidden="true"><path d="${d}" fill="none" stroke="#666" stroke-width=".25"/></svg>`;
}
function prApplySheet(sheet) {   // 印刷の 直前に よぶ：@page の 大きさ・置き場所・印
  sheet.querySelectorAll('.p-marks').forEach(e => e.remove());
  let st = document.getElementById('tkSheetPage'); const m = prSheetPlan();
  if (!m) { delete sheet.dataset.sheet; ['--sw', '--sh', '--ox', '--oy'].forEach(k => sheet.style.removeProperty(k)); if (st) st.remove(); return; }
  sheet.dataset.sheet = m.id; sheet.style.setProperty('--sw', m.sw); sheet.style.setProperty('--sh', m.sh); sheet.style.setProperty('--ox', m.ox.toFixed(3)); sheet.style.setProperty('--oy', m.oy.toFixed(3));
  if (!st) { st = document.createElement('style'); st.id = 'tkSheetPage'; }
  st.textContent = `@page{size:${m.sw}mm ${m.sh}mm;margin:0}`; document.body.appendChild(st);   // いちばん あとに 置く（ほかの @page より 勝つ）
  if (m.marks) (sheet.classList.contains('multi') ? [...sheet.querySelectorAll('.p-page')] : [sheet]).forEach(c => c.insertAdjacentHTML('beforeend', prMarksSvg(m)));
}
function prSheetUi() {
  const box = $('prSheet'); if (!box) return;
  const cur = prSheetPick();
  box.querySelectorAll('button').forEach(b => { const id = b.dataset.sheet; b.disabled = id !== 'own' && !prSheetFits(id); b.setAttribute('aria-pressed', String(id === cur)); });
  const h = $('prSheetHint'), m = prSheetPlan();
  if (h) { h.hidden = !m; if (m) h.textContent = TEXTS.prSheetHint.replace('{p}', m.name); }
}
(function () {
  const box = $('prSheet'); if (!box) return;
  box.querySelectorAll('button').forEach(b => b.onclick = () => { try { localStorage.setItem('tk_pr_sheet', b.dataset.sheet); } catch (e) {} prSheetUi(); });
  prSheetUi();
})();
async function printNote(opt) {
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];   // 年間の紙を 見ているときは 年間の紙を 印刷（v0.2.74）
  if (!note) return;
  { const sh = $('printSheet'); if (sh && sh.classList.contains('multi')) { sh.classList.remove('multi'); sh.innerHTML = '<img alt=""><div class="p-qr"></div>'; } }   // ★2026-10-19 まとめ印刷の あとは 1まいの 形に もどす
  const btn = $('printGo');
  btn.disabled = true;
  try {
    const sheet = $('printSheet');
    const img = sheet.querySelector('img');
    img.src = await tintedUrl(note, '#ffffff');   // 印刷は白い紙のまま
    await img.decode();   // ☆・3行・名前は絵の中に入っている
    sheet.querySelectorAll('.p-ink').forEach(e => e.remove());   // ★2026-10-15 書いた ものも 刷る（前の 印刷の 分は けす）
    try { const ic = typeof noteInkPrintCanvas === 'function' ? noteInkPrintCanvas(1800) : null; if (ic) { ic.className = 'p-ink'; sheet.appendChild(ic); } } catch (e) { console.error(e); }
    sheet.querySelector('.p-qr').innerHTML = printMarkSvg();   // ★QR → 印刷と わかる 小さな マーク（手帳 v0.2.240 と おなじ）
    if (window.TK_PLUS) sheet.querySelector('.p-qr').innerHTML = '';   // ★プラス会員は 印刷マークを 消す
    prApplySheet(sheet);   // ★nv0.2.171 A4・レターの まん中へ
    sendPrintLog();
    if (!(opt && opt.prepare)) window.print();   // ★2026-10-16 opt.prepare＝iPhone：外側の ページが 印刷の 窓を ひらく（PDF を 出さない）
  } catch (e) {
    console.error(e);
    alert(TEXTS.printError);
  } finally {
    btn.disabled = false;
  }
}
/* ★v0.2.203 家で印刷：お店では 先に Worker で 1回 数えて（1日 3回・会員 100回）、OK なら 印刷の 窓。楽天・ためしは いままで どおり */
/* ★v0.2.241 みなとさん「楽天は 1時間に 1回。ボタンを 押せなく」
   楽天には サーバーが ない ので ブラウザに 時刻を おぼえる（本店は Worker が 数える ので 対象外）。
   ブラウザの 記録を 消す・べつの ブラウザで 開く と 抜けられる（かんたんな 見はり） */
const PR_LIMIT_KEY = 'tk_print_at', PR_LIMIT_MS = 60 * 60 * 1000;
const prLimited = () => !prCounted();   // 数えて いない ところ＝楽天・ためし
function prCooldownLeft() { if (!prLimited()) return 0; try { const t = +localStorage.getItem(PR_LIMIT_KEY) || 0; return Math.max(0, t + PR_LIMIT_MS - Date.now()); } catch (e) { return 0; } }
function prCooldownSync() {
  const b = $('printGo'); if (!b) return;
  const left = prCooldownLeft(), span = b.querySelector('span');
  if (!span) return;
  if (!b.dataset.orig) b.dataset.orig = span.textContent;
  if (left > 0) { b.disabled = true; b.classList.add('pr-cool'); span.textContent = TEXTS.prCool.replace('{m}', Math.ceil(left / 60000)); }
  else if (b.classList.contains('pr-cool')) { b.disabled = false; b.classList.remove('pr-cool'); span.textContent = b.dataset.orig; }
}
setInterval(prCooldownSync, 20000);
/* ★2026-10-15 みなとさん「印刷は 今の ページだけ・1日 3回」：トップページの［印刷］から。お店の 数え（/apps/techou/print-ok・1日 3回・サブスク会員は 100回）に とおってから 今の 1まいを 印刷する */

/* ★2026-10-19〜20 みなとさん「見本ボタンを おすと、見本の 文字が あらわれる（ハリー・ポッターの 日記のように）」「原稿用紙なら 原稿用紙に 書きこむ。原稿用紙の 使い方のように」
   「罫線なら 罫線の プロの 使い方」「中学生の 使い方で OK」「ふせんは 廃止。ノートを ひとつずつ 調べて 作る」「文章の 内容は メタオブジェクトに 入れて 変えられる ように」
   ------------------------------------------------------------
   ・文は Shopify の メタオブジェクト「見本（ノート）note_sample」から（お店の head.liquid が window.TK_SAMPLES に わたす）。管理画面で 直せば そのまま かわる
       title＝見本の 名前／papers＝つかう 紙（番号を , や 改行で ならべる。cat:lines＝罫線 ぜんぶ）／kind＝genko（原稿用紙）か ruled（罫線・横書き）
       heading＝題名（原稿用紙）／author＝名前（原稿用紙）／body＝本文（原稿用紙＝1行が 1段落／罫線＝1行が ノートの 1行。行の はじめの 印：#＝題（太字・赤い 下線）!＝赤 ?＝緑 =＝マーカー >＝字下げ。空の 行＝1行 あける）
   ・字は PDF と 同じ Zen Maru Gothic（tk-font.js・OFL）を ブラウザーに 入れて 描く（おした ときだけ 読む）
   ・原稿用紙（B5「原稿用紙」3237101022803）＝縦書き 20マス×10行に 1字ずつ／罫線・方眼＝紙の 横線を 絵から 見つけて その 上に 横書き／見本の ない 紙＝ボタンを 出さない
   ・保存しない・印刷にも 入らない・書きはじめたり ページを めくると 消える */
let tkSampleEl = null, tkSampleBusy = false;
const GENKO_NOTE_ID = '3237101022803';   // 原稿用紙（B5）
const GENKO_GEO = { xs: [409.5, 371.5, 333.8, 295.8, 257.8, 219.8, 182, 144, 106, 68], cw: 28, y0: 112, ch: 25.8, W: 515.906, H: 728.504 };   // 右の 行から。マスの 左はし／はば／上／高さ（pt）
const SM_COL = { ink: '#1d4fa8', red: '#d33', green: '#1f8a4c', pencil: '#2b3047' };
function sampleHide() {
  if (!tkSampleEl) return;
  tkSampleEl.remove(); tkSampleEl = null;
  try { if (window.parent && window.parent !== window && typeof window.parent.tkSampleOff === 'function') window.parent.tkSampleOff(); } catch (e) {}
}
function sampleLayout() {
  if (!tkSampleEl || !NOTEINK.cv) return;
  const st = NOTEINK.cv.style;
  tkSampleEl.style.left = st.left; tkSampleEl.style.top = st.top; tkSampleEl.style.width = st.width; tkSampleEl.style.height = st.height;
}
function sampleCss() {
  if (document.getElementById('tkSampleCss')) return;
  const css = document.createElement('style'); css.id = 'tkSampleCss';
  css.textContent = '#tkSample{position:absolute;pointer-events:none;z-index:6;overflow:hidden}'
    + '#tkSample .sl{position:absolute;overflow:visible}#tkSample .sl svg{display:block;width:100%;height:auto;overflow:visible;letter-spacing:0}'   // ★nv0.2.135 お店の CSS の 字間（letter-spacing）を 受けつがない（はかった はばと ずれる）
    + '#tkSample .sl.h{clip-path:inset(-20% 100% -20% 0);opacity:.3;filter:blur(2px);animation:tkSmH 1.1s cubic-bezier(.3,.6,.2,1) forwards;animation-delay:calc(var(--i)*.75s + .2s)}'
    + '#tkSample .sl.v{clip-path:inset(0 -10% 100% -10%);opacity:.3;filter:blur(2px);animation:tkSmV 1.3s cubic-bezier(.3,.6,.2,1) forwards;animation-delay:calc(var(--i)*.7s + .2s)}'
    + '@keyframes tkSmH{0%{clip-path:inset(-20% 100% -20% 0);opacity:.3;filter:blur(2px)}60%{opacity:1;filter:blur(1px)}100%{clip-path:inset(-20% -5% -20% 0);opacity:1;filter:blur(0)}}'
    + '@keyframes tkSmV{0%{clip-path:inset(0 -10% 100% -10%);opacity:.3;filter:blur(2px)}60%{opacity:1;filter:blur(1px)}100%{clip-path:inset(-3% -10% -3% -10%);opacity:1;filter:blur(0)}}'
    + '@media (prefers-reduced-motion:reduce){#tkSample .sl.h,#tkSample .sl.v{animation:none;clip-path:none;opacity:1;filter:none}}';
  document.head.appendChild(css);
}
/* 字（tk-font.js）を おした ときだけ 読んで、ブラウザーに 入れる */
let sampleFontP = null;
function sampleFont() {
  if (sampleFontP) return sampleFontP;
  sampleFontP = (async () => {
    if (!window.TK_FONT) {
      const libs = Array.isArray(window.TK_PDF_LIBS) ? window.TK_PDF_LIBS : [];
      const src = libs.find(u => /tk-font\.js/.test(String(u))) || libs[2];
      if (!src) return false;
      await new Promise((ok, ng) => { const t = document.createElement('script'); t.src = src; t.onload = ok; t.onerror = () => ng(new Error('load font')); document.head.appendChild(t); });
    }
    return await tkBrowserFont();
  })().catch(e => { console.warn('sample font', e); return false; });
  return sampleFontP;
}
const sampleFamily = () => (window.TK_FONT && window.TK_FONT.family ? '"' + window.TK_FONT.family + '",' : '') + '"Hiragino Maru Gothic ProN","Zen Maru Gothic",sans-serif';
const sampleEsc = t => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
let sampleCtx = null;
function sampleWidth(text, E) {   // 字の はば（pt）を はかる
  if (!sampleCtx) sampleCtx = document.createElement('canvas').getContext('2d');
  sampleCtx.font = E + 'px ' + sampleFamily();
  return sampleCtx.measureText(text).width;
}
/* いまの 紙に 合う 見本を メタオブジェクトから さがす（番号 ＞ cat:〜 ＞ all の 順） */
function sampleFor(note) {
  const list = Array.isArray(window.TK_SAMPLES) ? window.TK_SAMPLES : [];
  if (!note || !list.length) return null;
  const id = String(note.id || ''), cat = 'cat:' + String(note.fmt && note.fmt.cat || '');
  const idB5 = id.replace(/^(32371)0\d/, (m, a) => a + '01');   // ★nv0.2.159 サイズ別：B6・A5・A4・L判の 番号は B5 の 番号に そろえて 見本を さがす
  const toks = s => String(s.papers || '').split(/[\s,、，]+/).map(x => x.trim()).filter(Boolean);
  let best = null, score = 0;
  for (const s of list) {
    const t = toks(s), kind = String(s.kind || '').trim().toLowerCase();
    let sc = (t.includes(id) || t.includes(idB5)) ? 3 : t.includes(cat) ? 2 : t.includes('all') ? 1 : 0;
    if (!sc) continue;
    if (kind === 'genko' && !(idB5 === GENKO_NOTE_ID && Math.abs(PSEL.w - 182) < 1)) continue;   // 原稿用紙の 見本は 原稿用紙にだけ
    if (sc > score) { best = s; score = sc; }
  }
  return best;
}
/* 縦書き 1マス：flag p＝、。／q＝「／r＝」／l＝ー／s＝小さい かな／x＝！／h＝行頭に 来る 句読点（マスの 外） */
/* ★nv0.2.140 みなとさん「使い方の 表示を ノートにも」：body の `|` で はじまる 行＝使い方（トップの 下に カードで 出る）。紙に 書く お手本の 行からは 外す */
const sampleBodyUse = smp => String(smp && smp.body || '').split(/\r?\n/).filter(l => l[0] === '|').map(l => l.slice(1).trim()).filter(Boolean);
const sampleBodyPaper = smp => String(smp && smp.body || '').split(/\r?\n/).filter(l => l[0] !== '|').join('\n');
window.tkHomeSampleInfo = function () {
  try {
    const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
    const smp = sampleFor(note); if (!smp) return null;
    const lines = sampleBodyUse(smp); if (!lines.length) return null;
    const nm = String(note && note.name || '').replace(/\s+/g, ' ').trim();
    // ★nv0.2.144 英語の ページでは メタオブジェクトの 英語の 名前（Translate & Adapt で 入れた title）を つかう（紙の 名前は 日本語しか ない ため）
    if (shopLang() !== 'ja') { const en = String(smp.title || '').trim(); return { title: ('How to use: ' + (en || nm)).slice(0, 60), lines, name: en || nm, nodemo: Math.abs(PSEL.w - 182) > 1 }; }
    return { title: (nm ? nm + ' の つかい方' : 'つかい方').slice(0, 30), lines, name: nm, nodemo: Math.abs(PSEL.w - 182) > 1 };
  } catch (e) { return null; }
};
function sampleCell(ch, flag, cx, cy, E, color) {
  let tx = cx, ty = cy, rot = '';
  if (flag === 'p' || flag === 'h') { tx = cx + E * 0.36; ty = cy - E * 0.30; }
  else if (flag === 'q') { rot = 90; tx = cx + E * 0.25; ty = cy - E * 0.22; }
  else if (flag === 'r') { rot = 90; tx = cx - E * 0.25; ty = cy + E * 0.22; }
  else if (flag === 'l') { rot = 90; }
  else if (flag === 's') { tx = cx + E * 0.14; ty = cy - E * 0.14; }
  return '<text x="0" y="0" transform="translate(' + tx.toFixed(2) + ',' + ty.toFixed(2) + ')' + (rot ? ' rotate(' + rot + ')' : '') + '" font-size="' + E + '" text-anchor="middle" dominant-baseline="central" fill="' + color + '">' + sampleEsc(ch) + '</text>';
}
function sampleGenkoCells(smp) {   // 題名（1行目・上から 4マス目）・名前（2行目・下を 1マス あける）・本文（3行目から・段落の はじめは 1マス あける）
  const cells = [], CLOSE = '、。」!?！？', SMALL = 'ぁぃぅぇぉっゃゅょゎァィゥェォッャュョ';
  const flag = ch => ch === '、' || ch === '。' ? 'p' : ch === '「' ? 'q' : ch === '」' ? 'r' : ch === 'ー' ? 'l' : SMALL.includes(ch) ? 's' : '';
  const title = String(smp.heading || '').trim(), name = String(smp.author || '').trim();
  [...title].slice(0, 16).forEach((ch, i) => cells.push([0, 3 + i, ch, flag(ch)]));
  const nm = [...name].slice(0, 8); nm.forEach((ch, i) => { if (ch !== ' ' && ch !== '　') cells.push([1, 19 - nm.length + i, ch, flag(ch)]); });
  let col = 2, row = 0;
  for (const p of sampleBodyPaper(smp).split(/\r?\n/).map(x => x.trim()).filter(Boolean)) {
    if (row !== 0) col++;
    row = 1;
    for (const ch of p) {
      if (col > 9) return cells;   // 10行を こえたら そこまで
      if (row >= 20) { col++; row = 0; if (CLOSE.includes(ch)) { cells.push([col - 1, 20, ch, 'h']); continue; } if (col > 9) return cells; }
      cells.push([col, row, ch, flag(ch)]); row++;
    }
  }
  return cells;
}
function sampleGenkoHtml(smp) {
  const G = GENKO_GEO, E = 21, cols = {};
  for (const [c, r, ch, fl] of sampleGenkoCells(smp)) {
    const cx = G.xs[c] + G.cw / 2, cy = G.y0 + G.ch * r + G.ch / 2;
    (cols[c] = cols[c] || []).push(sampleCell(ch, fl, cx, cy, E, SM_COL.pencil));
  }
  let h = '', i = 0;
  for (const c of Object.keys(cols).map(Number).sort((a, b) => a - b)) {
    const vx = G.xs[c] - 3, vw = G.cw + 6, vy = G.y0 - 4, vh = G.ch * 21 + 8;
    h += '<div class="sl v" style="--i:' + i + ';left:' + (vx / G.W * 100).toFixed(3) + '%;top:' + (vy / G.H * 100).toFixed(3) + '%;width:' + (vw / G.W * 100).toFixed(3) + '%"><svg viewBox="' + vx + ' ' + vy + ' ' + vw + ' ' + vh + '" font-family=\'' + sampleFamily() + '\' aria-hidden="true">' + cols[c].join('') + '</svg></div>';
    i++;
  }
  return h || null;
}
/* 罫線（横の 線）を 紙の 絵から 見つける。見つからない・でこぼこ なら null */
/* ★nv0.2.135 紙の 絵を 小さく（半分）描いて 画素を かえす（横線・たて線を さがす 土台） */
async function sampleRaster(note, S0) {
  const el = await sheetSvgEl(note, '#ffffff');
  const vb = el.viewBox && el.viewBox.baseVal; const Wp = (vb && vb.width) || 515.906, Hp = (vb && vb.height) || 728.504;
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(el)], { type: 'image/svg+xml' }));
  try {
    const img = new Image(); await new Promise((ok, ng) => { img.onload = ok; img.onerror = ng; img.src = url; });
    const S = S0 || 0.5, W = Math.round(Wp * S), H = Math.round(Hp * S);
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const g = c.getContext('2d', { willReadFrequently: true }); g.fillStyle = '#fff'; g.fillRect(0, 0, W, H); g.drawImage(img, 0, 0, W, H);
    return { d: g.getImageData(0, 0, W, H).data, W, H, S, Wp, Hp };
  } finally { URL.revokeObjectURL(url); }
}
/* ★nv0.2.135 紙の 横線と たて線（マス目）を ぜんぶ さがす → { hs:[{y,x0,x1}], vs:[{x,y0,y1}] }（pt）。字を マスの 中に おさめる ため */
async function sampleFindGrid(note) {
  const R = await sampleRaster(note, 1), { d, W, H, S } = R, dark = (x, y) => { const i = (y * W + x) * 4; return d[i] + d[i + 1] + d[i + 2] < 720; };   // 原寸で 読む（半分だと 細い 線が 消える）
  const MIN = 12 * S;   // 12pt より みじかい 線は 見ない（文字の 一部）
  const hs = [], vs = [];
  for (let y = 0; y < H; y++) { let run = -1; for (let x = 0; x <= W; x++) { const on = x < W && dark(x, y); if (on && run < 0) run = x; else if (!on && run >= 0) { if (x - run >= MIN) hs.push({ y: y / S, x0: run / S, x1: x / S }); run = -1; } } }
  for (let x = 0; x < W; x++) { let run = -1; for (let y = 0; y <= H; y++) { const on = y < H && dark(x, y); if (on && run < 0) run = y; else if (!on && run >= 0) { if (y - run >= MIN) vs.push({ x: x / S, y0: run / S, y1: y / S }); run = -1; } } }
  // となりあう 画素の 行（線の 太さ）は 1本に まとめる
  const merge = (arr, k, a0, a1) => { arr.sort((p, q) => p[k] - q[k] || p[a0] - q[a0]); const out = []; for (const s of arr) { const t = out[out.length - 1]; if (t && Math.abs(s[k] - t[k]) <= 1.6 && Math.abs(s[a0] - t[a0]) < 3 && Math.abs(s[a1] - t[a1]) < 3) { t[k] = (t[k] + s[k]) / 2; } else out.push({ ...s }); } return out; };
  return { hs: merge(hs, 'y', 'x0', 'x1'), vs: merge(vs, 'x', 'y0', 'y1'), Wp: R.Wp, Hp: R.Hp };
}
/* 点（x,y）を かこむ マス → { top, bottom, left, right }（ない 辺は null） */
function sampleCellAt(G, x, y) {
  let top = null, bottom = null, left = null, right = null;
  for (const h of G.hs) { if (h.x0 - 2 > x || h.x1 + 2 < x) continue; if (h.y <= y && (top == null || h.y > top)) top = h.y; if (h.y > y && (bottom == null || h.y < bottom)) bottom = h.y; }
  for (const v of G.vs) { if (v.y0 - 2 > y || v.y1 + 2 < y) continue; if (v.x <= x && (left == null || v.x > left)) left = v.x; if (v.x > x + 8 && (right == null || v.x < right)) right = v.x; }   // 右の 線は 8pt より 先の もの（1けたごとの 細い 線は とばす）
  return { top, bottom, left, right };
}
async function sampleFindRules(note) {
  const R = await sampleRaster(note); const { Wp, Hp } = R;
  {
    const { d, W, H, S } = R, x1 = Math.round(W * 0.22), x2 = Math.round(W * 0.78);
    const ys = []; let run = null;
    for (let y = Math.round(H * 0.08); y < Math.round(H * 0.94); y++) {
      let n = 0; for (let x = x1; x < x2; x++) { const i = (y * W + x) * 4; if (d[i] + d[i + 1] + d[i + 2] < 735) n++; }
      const on = n / (x2 - x1) > 0.7;
      if (on) { if (!run) run = [y, y]; else run[1] = y; } else if (run) { ys.push((run[0] + run[1]) / 2 / S); run = null; }
    }
    if (run) ys.push((run[0] + run[1]) / 2 / S);
    if (ys.length < 12) return null;
    const diffs = ys.slice(1).map((v, i) => v - ys[i]).sort((a, b) => a - b), sp = diffs[Math.floor(diffs.length / 2)];
    if (sp < 12 || sp > 40) return null;
    const near = (a, b) => Math.abs(b - a - sp) < sp * 0.18;
    const got = ys.filter((y, i) => (i > 0 && near(ys[i - 1], y)) || (i < ys.length - 1 && near(y, ys[i + 1])));
    if (got.length < 12) return null;
    const best = [];   // ★2026-10-20 見つけそこねた 線（2〜4本 とび）は 間を うめる（方眼で 抜けていた）
    for (let i = 0; i < got.length; i++) {
      if (i > 0) { const k = Math.round((got[i] - got[i - 1]) / sp); if (k >= 2 && k <= 4 && Math.abs(got[i] - got[i - 1] - k * sp) < sp * 0.18) for (let j = 1; j < k; j++) best.push(got[i - 1] + (got[i] - got[i - 1]) * j / k); }
      best.push(got[i]);
    }
    let left = W; for (const yy of best) { const y = Math.round(yy * S); for (let x = 0; x < W; x++) { const i = (y * W + x) * 4; if (d[i] + d[i + 1] + d[i + 2] < 735) { if (x < left) left = x; break; } } }
    return { lines: best, sp, Wp, Hp, left: left / S };
  }
}
/* body の 1行 → { ind, text, col, fl }。印：#＝題（太字・赤い 下線）!＝赤 ?＝緑 =＝マーカー >＝字下げ（印は いくつ 重ねても よい） */
function sampleRuledLines(smp) {
  return sampleBodyPaper(smp).split(/\r?\n/).map(raw => {
    let t = raw.replace(/^\s+/, ''), ind = 0, col = 'ink', fl = '', at = null;
    const m = /^@\s*(-?[\d.]+)\s*[,、，]\s*(-?[\d.]+)(?:\s*[,、，]\s*(\d{1,2}(?:\.\d+)?))?(?:\s+|(?=[^\d.\s])|$)/.exec(t);   // ★2026-10-20 @x,y[,size]＝紙の はば・高さの %（左上が 0,0）に 置く。size は 2けたまで・文が 数字で はじまる ときは 空白を はさむ
    if (m) { at = { x: +m[1], y: +m[2], size: m[3] ? +m[3] : 0 }; t = t.slice(m[0].length); }
    else {   // ★nv0.2.135 紙に 印刷されている 文字を 目じるしに 置く：@前:年 2026（年の 左に）／@後:場所 駅前（場所の 右に）／@中:◎ ◯（◎の まん中に）。同じ 文字が 2つ あるときは 年#2
      const tb = /^@\s*表\s*[:：]\s*([^,、，#]+?)(?:#(\d+))?\s*[,、，]\s*(\d{1,2})(?:\s*[,、，]\s*(\d{1,2}(?:\.\d+)?))?(?:[ \t]+|$)/.exec(t);   // ★型「表」：@表:内容,1 おこづかい ＝ 見出し「内容」の 列の 1行目の マスに
      if (tb) { at = { anchor: '表', label: tb[1], nth: tb[2] ? +tb[2] : 1, row: +tb[3], size: tb[4] ? +tb[4] : 0 }; t = t.slice(tb[0].length); }
      const a = tb ? null : /^@\s*(前|後|中|間)\s*[:：]\s*([^,、，#]+?)(?:#(\d+))?(?:\s*[,、，]\s*(\d{1,2}(?:\.\d+)?))?(?:[ \t]+|$)/.exec(t);   // 目じるしに 全角の 空白が あっても よい（（　　　）など）。文との 区切りは 半角の 空白。間:年|月＝年と 月の あいだの まん中
      if (a) { at = { anchor: a[1], label: a[2], nth: a[3] ? +a[3] : 1, size: a[4] ? +a[4] : 0 }; t = t.slice(a[0].length); }
      else {   // ★型「日付」：@日付,12 2026 10 19 月 → 年・月・日・曜日（または（　））を 紙から さがして 入れる。2つめの 日付は @日付#2
        const d = /^@\s*日付(?:#(\d+))?(?:\s*[,、，]\s*(\d{1,2}(?:\.\d+)?))?(?:[ \t]+|$)/.exec(t);
        if (d) { at = { anchor: '日付', nth: d[1] ? +d[1] : 1, size: d[2] ? +d[2] : 0 }; t = t.slice(d[0].length); }
        else {   // ★型「月日」：@月日:x,y,size 10 1 → 斜めの 線が 印刷してある マスに、月を 左上・日を 右下に 分けて 書く（/ は 書かない）
          const g = /^@\s*月日\s*[:：]\s*(-?[\d.]+)\s*[,、，]\s*(-?[\d.]+)(?:\s*[,、，]\s*(\d{1,2}(?:\.\d+)?))?(?:[ \t]+|$)/.exec(t);
          if (g) { at = { anchor: '月日', x: +g[1], y: +g[2], size: g[3] ? +g[3] : 0 }; t = t.slice(g[0].length); }
        }
      }
    }
    for (;;) {
      if (t.startsWith('>')) { ind++; t = t.slice(1); }
      else if (t.startsWith('#')) { fl = 'b'; t = t.slice(1); }
      else if (t.startsWith('!')) { col = 'red'; t = t.slice(1); }
      else if (t.startsWith('?')) { col = 'green'; t = t.slice(1); }
      else if (t.startsWith('=')) { fl = 'hl'; t = t.slice(1); }
      else break;
      t = t.replace(/^\s+/, '');
    }
    return { ind, text: t.trim(), col, fl, at };
  });
}
function sampleRuledHtml(R, smp) {
  const E0 = Math.min(20, R.sp * 0.78), x0 = R.left + R.sp * 0.4, maxW = R.Wp - x0 - R.left * 0.6;
  const start = R.lines.findIndex(y => y > R.Hp * 0.13);
  if (start < 0) return null;
  let h = '', i = 0, idx = 0;
  for (const L of sampleRuledLines(smp)) {
    const y = R.lines[start + idx]; idx++;
    if (y == null) break;
    if (!L.text) continue;
    let e = E0, w = sampleWidth(L.text, e);
    const avail = maxW - L.ind * E0 * 1.2; if (w > avail) { e = Math.max(8, e * avail / w); w = sampleWidth(L.text, e); }
    const lx = x0 + L.ind * E0 * 1.2, top = y - e * 0.88 - R.sp * 0.1, vw = w + 6, vh = e * 1.2;
    const hl = L.fl === 'hl' ? '<rect x="-3" y="' + (e * 0.52) + '" width="' + (w + 6) + '" height="' + (e * 0.4) + '" fill="#ffd54f" opacity=".85"/>' : '';
    const ul = L.fl === 'b' ? '<line x1="0" y1="' + (e * 1.02) + '" x2="' + w + '" y2="' + (e * 1.02) + '" stroke="#d33" stroke-width="1.2"/>' : '';
    h += '<div class="sl h" style="--i:' + i + ';left:' + (lx / R.Wp * 100).toFixed(3) + '%;top:' + (top / R.Hp * 100).toFixed(3) + '%;width:' + (vw / R.Wp * 100).toFixed(3) + '%"><svg viewBox="-3 0 ' + vw + ' ' + vh + '" font-family=\'' + sampleFamily() + '\' aria-hidden="true">' + hl
      + '<text x="0" y="' + (e * 0.88) + '" font-size="' + e + '"' + (L.fl === 'b' ? ' font-weight="700"' : '') + ' fill="' + (SM_COL[L.col] || SM_COL.ink) + '">' + sampleEsc(L.text) + '</text>' + ul + '</svg></div>';
    i++;
  }
  return h || null;
}
/* ★2026-10-20 kind=free：紙の 絵を 見ず、body の @x,y[,size] の 場所に 横書き（日記・家計簿・ノートの 表など、線の ない／でこぼこな 紙）。size＝字の 大きさ（pt・なければ 14） */
/* ★nv0.2.135 紙に 印刷されている 文字（年・月・DATE …）を 1字ずつ 読む → [{ch, x0, x1, y, fs}]（pt・左上が 0,0）
   柄の SVG は Illustrator の 書き出し：<text transform="matrix(1 0 0 1 0 728.504)"><tspan x="98.3 107.3 …" y="-637.9">年　月…</tspan> */
async function sampleLabels(note) {
  const el = await sheetSvgEl(note, '#ffffff'), out = [];
  el.querySelectorAll('text').forEach(t => {
    const fs = parseFloat(t.getAttribute('font-size')) || 8;
    let ty = 0; const tr = /matrix\(([^)]*)\)/.exec(t.getAttribute('transform') || ''); if (tr) { const v = tr[1].trim().split(/[\s,]+/).map(Number); if (v.length === 6) ty = v[5]; }
    t.querySelectorAll('tspan').forEach(s => {
      const str = s.textContent; if (!str) return;
      if (/^(No\.\d{6,}|#[0-9A-Fa-f]{6}|BBN-protect|BirthBookNote|Color|code #)/.test(str.trim())) return;   // 紙の 番号・色の 印・まもりの 文字は 目じるしに しない
      const xs = (s.getAttribute('x') || '').trim().split(/[\s,]+/).map(Number).filter(n => !isNaN(n)); if (!xs.length) return;
      const y = (parseFloat((s.getAttribute('y') || '0').split(/[\s,]+/)[0]) || 0) + ty;
      const chars = [...str]; let x = xs[0];
      for (let i = 0; i < chars.length; i++) {
        const ch = chars[i]; const x0 = i < xs.length ? xs[i] : x;
        const adv = /[\x20-\x7e]/.test(ch) ? fs * 0.6 : fs;   // 半角は 6割の はば
        const x1 = i + 1 < xs.length ? xs[i + 1] : x0 + adv; x = x1;
        out.push({ ch, x0, x1, y, fs, sp: /\s/.test(ch) });
      }
    });
  });
  return out;
}
/* 目じるしの 文字（ならび）を さがす → { x0, x1, y, fs }。nth＝何番目 */
function sampleLabelBox(labels, label, nth, from) {
  const want = [...label].filter(c => !/\s/.test(c)); let seen = 0;   // 空白は 見ない（「収 入」も「収入」で 見つかる）
  if (!want.length) return null;
  for (let i = from || 0; i < labels.length; i++) {
    if (labels[i].sp || labels[i].ch !== want[0]) continue;
    let j = 1, k = i + 1, last = i;
    while (j < want.length && k < labels.length) { if (labels[k].sp) { k++; continue; } if (labels[k].ch !== want[j]) break; last = k; j++; k++; }
    if (j < want.length) continue;
    if (++seen < (nth || 1)) continue;
    const a = labels[i], b = labels[last];
    return { x0: a.x0, x1: b.x1, y: a.y, fs: a.fs, i, end: last + 1 };
  }
  return null;
}
/* 間:年|月 ＝ 年（nth番目）と、その あとに 出てくる 月の あいだ → { x0: 年の 右, x1: 月の 左, y, fs } */
function sampleGapBox(labels, label, nth) {
  const p = label.split(/[|｜]/); if (p.length !== 2) return null;
  const A = sampleLabelBox(labels, p[0].trim(), nth); if (!A) return null;
  const B = sampleLabelBox(labels, p[1].trim(), 1, A.end); if (!B) return null;
  return { x0: A.x1, x1: B.x0, y: A.y, fs: A.fs };
}
async function sampleFreeHtml(smp, note) {
  const Wp = (typeof PSEL !== 'undefined' && PSEL.w) ? PSEL.w / 25.4 * 72 : 515.906, Hp = (typeof PSEL !== 'undefined' && PSEL.h) ? PSEL.h / 25.4 * 72 : 728.504;
  const lines0 = sampleRuledLines(smp);
  const labels = lines0.some(L => L.at && L.at.anchor) ? await sampleLabels(note) : [];
  let G = null; try { G = await sampleFindGrid(note); } catch (err) { console.warn('見本：線が 読めない', err); }   // ★紙の マス目（字を 線の 中に おさめる ため）
  const lines = [];
  for (const L of lines0) {   // 型「日付」を 年・月・日・曜日の 4つに ひらく／型「月日」を 左上・右下の 2つに
    if (L.at && L.at.anchor === '月日') {
      const v = L.text.split(/[\s\/／]+/).filter(Boolean), px = Wp * L.at.x / 100, py = Hp * L.at.y / 100, C = G ? sampleCellAt(G, px, py) : {};
      if (C.top != null && C.bottom != null && C.bottom - C.top <= 60) {   // x＝斜めの 線の まん中。上下の 線だけ あれば よい（たての 線は なくても よい）
        const rh = C.bottom - C.top, e = Math.min(L.at.size || 10, rh * 0.42);
        if (v[0]) lines.push({ ind: 0, col: L.col, fl: L.fl, text: v[0], at: { abs: true, lx: px + rh * 0.02 - sampleWidth(v[0], e), base: C.top + rh * 0.40, size: e } });   // 月＝左上（斜め線より 上・左）
        if (v[1]) lines.push({ ind: 0, col: L.col, fl: L.fl, text: v[1], at: { abs: true, lx: px + rh * 0.12, base: C.bottom - rh * 0.06, size: e } });   // 日＝右下（斜め線より 下・右）
      } else {   // 線が ない 紙：斜め線の 左に 月・右に 日（同じ 高さ）
        const e = L.at.size || 10;
        if (v[0]) lines.push({ ind: 0, col: L.col, fl: L.fl, text: v[0], at: { abs: true, lx: px - 4 - sampleWidth(v[0], e), base: py + e * 0.1, size: e } });
        if (v[1]) lines.push({ ind: 0, col: L.col, fl: L.fl, text: v[1], at: { abs: true, lx: px + 4, base: py + e * 0.5, size: e } });
      }
      continue;
    }
    if (!(L.at && L.at.anchor === '日付')) { lines.push(L); continue; }
    const v = L.text.split(/[\s\/／]+/).filter(Boolean).map(x => /^[-－ー]$/.test(x) ? '' : x), mk = (anchor, label, text, nth) => ({ ind: 0, col: L.col, fl: L.fl, text, at: { anchor, label, nth: nth || 1, size: L.at.size } });   // 「-」＝その 欄は 書かない（例：年を 書く 場所が ない 紙）
    const Y = sampleLabelBox(labels, '年', L.at.nth); if (!Y) { console.warn('見本：年が 紙に ない'); continue; }
    if (v[0]) { const prev = labels.slice(0, Y.i).filter(l => !l.sp && Math.abs(l.y - Y.y) < 3).map(l => l.x1).sort((p, q) => q - p)[0]; if (prev == null || Y.x0 - prev > 18) lines.push(mk('前', '年', v[0], L.at.nth)); }   // 年の 左に 場所が ない 紙（訪問日時年…）は 年を 書かない
    if (v[1]) lines.push(mk('間', '年|月', v[1], L.at.nth));
    const M = sampleLabelBox(labels, '月', 1, Y.end), D = M && sampleLabelBox(labels, '日', 1, M.end);
    if (v[2] && M) lines.push(mk('間', '月|日', v[2], 1 + labels.slice(0, M.i).filter(l => l.ch === '月').length));
    if (v[3] && D) {   // 曜日：「曜日」が あれば その 左／「（　）」が あれば その まん中／なければ 日の 右
      const W = sampleLabelBox(labels, '曜日', 1, D.end), P = sampleLabelBox(labels, '（', 1, D.end), Q = P && sampleLabelBox(labels, '）', 1, P.end);
      if (W && W.i - D.end < 12) lines.push(mk('前', '曜日', v[3], 1 + labels.slice(0, W.i).filter((l, k) => l.ch === '曜' && labels[k + 1] && labels[k + 1].ch === '日').length));
      else if (P && Q && P.i - D.end < 12) lines.push(mk('間', '（|）', v[3], 1 + labels.slice(0, P.i).filter(l => l.ch === '（').length));
      else lines.push(mk('後', '日', v[3], 1 + labels.slice(0, D.i).filter(l => l.ch === '日').length));
    }
  }
  let h = '', i = 0;
  for (const L of lines) {
    if (!L.at || !L.text) continue;
    let e = L.at.size || 14, w = sampleWidth(L.text, e);
    let lx, base;
    const mark = /^[◯○◎✓✔★☆●]+$/.test(L.text);   // 印（丸で かこむ・チェック・星）は マスに 合わせない
    if (L.at.abs) { lx = L.at.lx; base = L.at.base; }
    else if (L.at.anchor === '表') {   // 見出しの 列の n 行目：見出しの 下に ある 横線を 数えて、その マスの まん中
      const B = sampleLabelBox(labels, L.at.label, L.at.nth); if (!B || !G) { console.warn('見本：表の 見出しが ない', L.at.label); continue; }
      const cx = (B.x0 + B.x1) / 2, rows = G.hs.filter(hh => hh.x0 - 2 <= cx && hh.x1 + 2 >= cx && hh.y > B.y - 2).map(hh => hh.y).sort((p, q) => p - q);
      if (rows.length <= L.at.row) { console.warn('見本：表の 行が たりない', L.at.label, L.at.row); continue; }
      const yc = (rows[L.at.row - 1] + rows[L.at.row]) / 2, C = sampleCellAt(G, cx, yc);
      const prevH = labels.filter(l => !l.sp && Math.abs(l.y - B.y) < 3 && l.x1 <= B.x0 + 0.5).map(l => l.x1).sort((p, q) => q - p)[0];   // 見出しの 行の 前の 文字（たて線の ない 表の 列の 左）
      lx = Math.max(C.left != null ? C.left + 3 : 0, prevH != null ? prevH + 4 : 0, 0) || (B.x0 - 2); base = yc + e * 0.36;
      const rowH = rows[L.at.row] - rows[L.at.row - 1], inCell = labels.filter(l => !l.sp && l.ch !== '／' && Math.abs(l.y - yc) < rowH / 2 && l.x0 >= lx - 2 && l.x0 < cx + 30).map(l => l.x1).sort((p, q) => q - p)[0];   // マスの 中の ￥ や 番号
      if (inCell != null) lx = Math.max(lx, inCell + 3);
    }
    else if (L.at.anchor) {
      const B = L.at.anchor === '間' ? sampleGapBox(labels, L.at.label, L.at.nth) : sampleLabelBox(labels, L.at.label, L.at.nth);
      if (!B) { console.warn('見本：目じるしが 紙に ない', L.at.label); continue; }
      if (L.at.anchor === '前') {
        lx = B.x0 - 3 - w; base = B.y;
        const prev = labels.filter(l => !l.sp && Math.abs(l.y - B.y) < 3 && l.x1 <= B.x0 + 0.5).map(l => l.x1).sort((p, q) => q - p)[0];   // 同じ 行の 前の 文字
        if (prev != null && lx < prev + 3) { const avail = B.x0 - 3 - (prev + 3); if (avail > 6) { e = Math.max(6, e * avail / w); w = sampleWidth(L.text, e); lx = B.x0 - 3 - w; } }
      }
      else if (L.at.anchor === '後') {
        lx = B.x1 + 3; base = B.y;
        const next = labels.filter(l => !l.sp && Math.abs(l.y - B.y) < 3 && l.x0 >= B.x1 - 0.5).map(l => l.x0).sort((p, q) => p - q)[0];   // 同じ 行の つぎの 文字
        if (next != null && lx + w > next - 3) { const avail = next - 3 - lx; if (avail > 6) { e = Math.max(6, e * avail / w); w = sampleWidth(L.text, e); } }
      }
      else if (L.at.anchor === '間') { lx = (B.x0 + B.x1) / 2 - w / 2; base = B.y; }   // 間＝2つの 文字の あいだの まん中・同じ 下ばし
      else { lx = (B.x0 + B.x1) / 2 - w / 2; base = B.y - B.fs * 0.36 + e * 0.36; }   // 中＝目じるしの まん中に
    } else { lx = Wp * L.at.x / 100; base = Hp * L.at.y / 100 - e * 0.07; }
    lx += L.ind * e * 1.2;
    if (G && !mark && !L.at.abs) {   // ★マスの 中に おさめる：上下の 線の 7割までの 大きさ・上下は まん中・左右の 線から はみ出さない
      const C = sampleCellAt(G, lx + 2, base - e * 0.35), rowH = (C.top != null && C.bottom != null) ? C.bottom - C.top : 0;
      if (rowH >= 10 && rowH <= 60 && rowH >= e * 0.75) {   // 字より ずっと せまい 行（英習罫の 4本線・細かい 方眼 など）は マスと 見ない
        if (e > rowH * 0.72) { e = Math.max(6, rowH * 0.72); w = sampleWidth(L.text, e); }
        if (!L.at.anchor) base = (C.top + C.bottom) / 2 + e * 0.36;
      }
      if (C.left != null && lx < C.left + 3) { if (L.at.anchor === '前' || L.at.anchor === '間' || L.at.anchor === '中') { const avail = lx + w - (C.left + 3); if (avail > 6) { e = Math.max(6, e * avail / w); const w2 = sampleWidth(L.text, e); lx = lx + w - w2; w = w2; } } else lx = C.left + 3; }
      const crossing = G.vs.filter(v => v.x > lx + 2 && v.x < lx + w - 2 && v.y0 - 2 <= base && v.y1 + 2 >= base - e * 0.7).length;   // 字の 中を 通る たて線（方眼なら たくさん）
      const rl = (crossing >= 2 ? Wp - 14 : (C.right != null ? C.right : Wp - 14)) - 3;
      if (lx + w > rl) { e = Math.max(6, e * (rl - lx) / w); w = sampleWidth(L.text, e); }
    }
    const top = base - e * 0.88, vw = w + 6, vh = e * 1.25;
    const hl = L.fl === 'hl' ? '<rect x="-3" y="' + (e * 0.52) + '" width="' + (w + 6) + '" height="' + (e * 0.4) + '" fill="#ffd54f" opacity=".85"/>' : '';
    const ul = L.fl === 'b' ? '<line x1="0" y1="' + (e * 1.02) + '" x2="' + w + '" y2="' + (e * 1.02) + '" stroke="#d33" stroke-width="1.2"/>' : '';
    h += '<div class="sl h" data-a="' + (L.at.anchor || '') + '" data-w="' + w.toFixed(2) + '" style="--i:' + i + ';left:' + (lx / Wp * 100).toFixed(3) + '%;top:' + (top / Hp * 100).toFixed(3) + '%;width:' + (vw / Wp * 100).toFixed(3) + '%"><svg viewBox="-3 0 ' + vw + ' ' + vh + '" font-family=\'' + sampleFamily() + '\' aria-hidden="true">' + hl
      + '<text x="0" y="' + (e * 0.88) + '" font-size="' + e + '"' + (L.fl === 'b' ? ' font-weight="700"' : '') + ' fill="' + (SM_COL[L.col] || SM_COL.ink) + '">' + sampleEsc(L.text) + '</text>' + ul + '</svg></div>';
    i++;
  }
  return h || null;
}
window.tkHomeSample = async function (force) {
  const want = typeof force === 'boolean' ? force : !tkSampleEl;
  if (!want) { sampleHide(); return false; }
  if (tkSampleEl) return true;
  if (Math.abs(PSEL.w - 182) > 1) { try { return !!sampleFor(curPage().ysheet != null ? yNote() : state.notes[state.idx]); } catch (e) { return false; } }   // ★nv0.2.160 B5 以外：紙には お手本を 書かない（使い方カードだけ。外の ページが 出す）。ほかの じゅんびを まつ 前に 返す
  if (tkSampleBusy || !NOTEINK.cv || !NOTEINK.cv.parentNode) return false;
  tkSampleBusy = true;
  try {
    const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
    const smp = sampleFor(note); if (!smp) return false;
    sampleCss(); await sampleFont();
    let html = null;
    const kind = String(smp.kind || '').trim().toLowerCase();
    if (kind === 'genko') html = sampleGenkoHtml(smp);
    else if (kind === 'free') html = await sampleFreeHtml(smp, note);
    else { try { const R = await sampleFindRules(note); if (R) html = sampleRuledHtml(R, smp); } catch (e) { console.warn('sample rules', e); } }
    if (!html || tkSampleEl) return !!tkSampleEl;
    const box = document.createElement('div'); box.id = 'tkSample'; box.setAttribute('aria-hidden', 'true'); box.innerHTML = html;
    NOTEINK.cv.parentNode.appendChild(box); tkSampleEl = box; sampleLayout(); sampleFitBoxes(box);
    return true;
  } catch (e) { console.warn('sample', e); return false; }
  finally { tkSampleBusy = false; }
};
/* ★nv0.2.135 描いた あとに 本当の 字の はばを はかって、箱が せまければ 広げる（はかった はばより 字が 広いと 右が 切れていた） */
function sampleFitBoxes(box) {
  const Wp = (typeof PSEL !== 'undefined' && PSEL.w) ? PSEL.w / 25.4 * 72 : 515.906;
  box.querySelectorAll('.sl').forEach(d => {
    const svg = d.querySelector('svg'), t = d.querySelector('text'); if (!svg || !t) return;
    try {
      const r = t.getBBox(), vb = svg.viewBox.baseVal, need = r.x + r.width + 4;
      const a = d.getAttribute('data-a'), w0 = parseFloat(d.getAttribute('data-w'));   // 目じるしの 左（前）・まん中（中）は 本当の はばで 置きなおす
      if ((a === '前' || a === '中' || a === '間') && w0 > 0 && Math.abs(r.width - w0) > 0.3) d.style.left = (parseFloat(d.style.left) - (r.width - w0) * (a === '前' ? 1 : 0.5) / Wp * 100) + '%';
      if (need <= vb.x + vb.width) return;
      const k = (need - vb.x) / vb.width;
      svg.setAttribute('viewBox', vb.x + ' ' + vb.y + ' ' + (need - vb.x) + ' ' + vb.height);
      d.style.width = (parseFloat(d.style.width) * k) + '%';
      const rc = svg.querySelector('rect'); if (rc) rc.setAttribute('width', need - vb.x);
      const ln = svg.querySelector('line'); if (ln) ln.setAttribute('x2', r.x + r.width);
    } catch (e) {}
  });
}
/* ★nv0.2.135 検査：見本の 字が 紙の 印刷文字と かさなっていないか（紙の pt で くらべる）。かさなりの 一覧を かえす（空なら OK） */
window.tkHomeSampleOverlaps = async function () {
  const box = tkSampleEl; if (!box) return null;
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
  const Wp = (typeof PSEL !== 'undefined' && PSEL.w) ? PSEL.w / 25.4 * 72 : 515.906, Hp = (typeof PSEL !== 'undefined' && PSEL.h) ? PSEL.h / 25.4 * 72 : 728.504;
  const labels = (await sampleLabels(note)).filter(l => !l.sp && l.ch !== '／' && l.ch !== '/');   // 斜め線は 月日で わざと その 左上・右下に 書く ので 見ない
  const out = [];
  box.querySelectorAll('.sl').forEach(d => {
    const svg = d.querySelector('svg'), t = d.querySelector('text'); if (!svg || !t) return;
    const r = t.getBBox(), vb = svg.viewBox.baseVal;
    if (/^[◯○◎✓✔★☆●]+$/.test(t.textContent.trim())) return;   // 印（丸で かこむ・チェック・星）は 紙の 文字に かさねる もの なので 見ない
    const x0 = Wp * parseFloat(d.style.left) / 100 + (r.x - vb.x) + 1, y0 = Hp * parseFloat(d.style.top) / 100 + r.y + r.height * 0.2, x1 = x0 + r.width - 2, y1 = y0 + r.height * 0.6;
    const hit = labels.filter(l => l.x0 < x1 && l.x1 > x0 && l.y - l.fs * 0.8 < y1 && l.y > y0).map(l => l.ch);
    if (hit.length) out.push({ text: t.textContent, hit: hit.join(''), box: [x0, y0, x1, y1].map(v => Math.round(v)) });
  });
  return out;
};
/* この 紙に 見本が あるか（なければ「見本」ボタンを 出さない） */
window.tkHomeSampleOk = async function () {
  for (let i = 0; i < 40 && !(typeof NK_BOOTED !== 'undefined' && NK_BOOTED && state.notes && state.notes[state.idx]); i++) await new Promise(r => setTimeout(r, 100));
  try {
    const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
    const smp = sampleFor(note); if (!smp) return false;
    if (Math.abs(PSEL.w - 182) > 1) return true;   // ★nv0.2.159 B5 以外も 使い方カードは 出す
    const k = String(smp.kind || '').trim().toLowerCase();
    if (k === 'genko') return true;
    if (k === 'free') return sampleRuledLines(smp).some(L => L.at && L.text);
    const R = await sampleFindRules(note);
    return !!R;
  } catch (e) { return false; }
};
{ let _smT = 0; addEventListener('resize', () => { clearTimeout(_smT); _smT = setTimeout(sampleLayout, 60); setTimeout(sampleLayout, 300); }); }   // ★nv0.2.136 紙の 大きさが 決まった あとに 置きなおす（窓を 変えた ときに ずれていた）
window.tkHomePrint = async function (opt) {
  const selPages = noteListFromOpt(opt);   // ★2026-10-19 {from,to}＝ページを えらんで 印刷（1ページ だけでも 可）。なければ いまの 1ページ
  if (selPages && selPages.length > 1 && !window.TK_PLUS) return { ok: false, message: tr('まとめて 印刷は プラス会員（月380円）の 特典です') };
  if (selPages && !SHOP_LOGGED_IN) return { ok: false, needLogin: true, message: tr('ページを えらんで 印刷するには ログインが いります') };
  if (inAppView()) return { ok: false, message: tr('この アプリの 画面では 印刷できません。Safari か Chrome で ひらいて ください。') };
  /* ★2026-10-16 みなとさん「ログインしなくても 印刷できるように」：ログインして いない 人は 1日 3回まで（この ブラウザの 中だけで 数える＝お店の サーバーは つかわない） */
  let j = null;
  try {
    if (!SHOP_LOGGED_IN) {
      const day = new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10); let n = 0;
      try { const g = JSON.parse(localStorage.getItem('tk_guest_print') || 'null'); if (g && g.day === day) n = +g.n || 0; } catch (e) {}
      if (n >= 3) return { ok: false, needLogin: true, message: tr('きょうの ログインなしの 印刷は 3回まで です。ログインすると 1日 3回・保存・マイ手帳に のこせます。') };
      try { localStorage.setItem('tk_guest_print', JSON.stringify({ day, n: n + 1 })); } catch (e) {}
      j = { ok: true, home: { left: 2 - n }, guest: true };
    } else {
    const r = await fetch('/apps/techou/print-ok', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } });
    j = await r.json().catch(() => null);
    if (j && j.ok) window.TK_PLUS = !!j.member;   // ★プラス会員は 印刷マークを 消す
    if (j && j.ok && selPages && selPages.length > 1 && !j.member) return { ok: false, message: tr('まとめて 印刷は プラス会員（月380円）の 特典です') };
    if (!r.ok || !j || !j.ok) return { ok: false, message: (j && j.error === 'limit') ? (j.message || tr('きょうの 分は おわりました')) : ((j && j.message) || tr('印刷できませんでした')) };
    }
    /* ★2026-10-15 みなとさん「トップの ノートの 印刷ボタンが 反応しません」：iPhone（Safari・Chrome とも）は 画面から 直接 印刷（window.print）が できない／きかない。
       → 数えに とおった あと **PDF を 作って ひらく リンク**を わたす（ひらいて 共有 → プリント）。ほかの 端末は いままで どおり */
    const ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1)) {
      // ★2026-10-16 みなとさん「PDF を ひらかず すぐ 印刷」：紙を つくる だけして、外側の ページ（トップ）が 印刷の 窓を ひらく（PDF は 出さない）
      try { await (selPages ? printNotePages(selPages, { prepare: true }) : printNote({ prepare: true })); return { ok: true, left: j.home ? j.home.left : null, prepared: true, guest: !!j.guest }; }
      catch (e) { const { blob } = await npOnePdf({ ink: true }); return { ok: true, left: j.home ? j.home.left : null, pdfUrl: URL.createObjectURL(blob), guest: !!j.guest }; }   // だめなら これまでの PDF
    }
    await (selPages ? printNotePages(selPages) : printNote());
    return { ok: true, left: j.home ? j.home.left : null, guest: !!j.guest };
  } catch (e) { return { ok: false, message: tr('印刷できませんでした（つながりません）') }; }
};
$('printGo').onclick = async () => {
  if (inAppView()) { syncPrintApp(); return; }
  if (!prCounted()) {
    if (prCooldownLeft() > 0) { prCooldownSync(); return; }
    try { localStorage.setItem(PR_LIMIT_KEY, String(Date.now())); } catch (e) {}
    try { await printNote(); } finally { prCooldownSync(); }   // printNote の おわりで ボタンが 有効に もどる ので、そのあと もう一度 グレーに する
    return;
  }
  if (!SHOP_LOGGED_IN) { prToLogin(); return; }
  const btn = $('printGo'); btn.disabled = true;
  try {
    const r = await fetch('/apps/techou/print-ok', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || !j.ok) { $('prQuota').textContent = (j && j.error === 'limit') ? TEXTS.prQuotaOff : ((j && j.message) || TEXTS.printError); return; }
    prShowQuota(j);
    await printNote();
  } catch (e) { $('prQuota').textContent = TEXTS.printError; }
  finally { btn.disabled = false; }
};
/* ★v0.2.203 印刷の カードの 2種類（家／コンビニ）と きょうの のこり */
const prCounted = () => SHOP === 'shopify' && npAvailable();   // お店で 部品が ある とき＝Worker が 数える
function prToLogin() { $('prQuota').textContent = TEXTS.prLogin; try { const u = new URL(shareUrl()); location.href = '/account/login?return_to=' + encodeURIComponent(u.pathname + u.search); } catch (e) {} }
function prChoose(kind) {
  const k = $('prKind'); if (!k) return;
  if (SHOP !== 'shopify') { ['prNp', 'npBox', 'prNpNo'].forEach(id => { const x = $(id); if (x) x.hidden = true; }); }   // ★みなとさん 2026-11-03「コンビニ印刷は 楽天では 出さない」
  /* ★v0.2.233 みなとさん「印刷の ところに 保存を」＝3つめ「保存」（お店だけ・ログイン中は おきにいりに 入れる・ログイン前は 案内）
     ねっぷりが できない 紙や 部品が ない ときでも 保存は 出す（コンビニの ボタンだけ かくす） */
  const saveOk = false;   // ★みなとさん 2026-11-03「ここで 保存も 廃止。印刷に 登録で できています」
  const pcard = k.closest('.pop-card'); if (pcard) pcard.dataset.pk = (prCounted() || saveOk) ? '1' : '0';   // ★v0.2.240
  if (!prCounted() && !saveOk) { k.hidden = true; $('prHomeBox').hidden = false; return; }
  const npOk = prCounted() && npSupported();   // ★v0.2.210 ねっぷりは B5・A4 だけ。ほかの 紙では ボタンも 箱も 出さない
  if (!npOk && kind === 'np') kind = 'home';
  k.hidden = !npOk && !saveOk; $('prNp').hidden = !npOk; $('prNpNo').hidden = npOk || !prCounted(); $('prOne').hidden = false;
  $('prSave').hidden = !saveOk;
  $('prHome').setAttribute('aria-pressed', String(kind === 'home'));
  $('prNp').setAttribute('aria-pressed', String(kind === 'np'));
  $('prSave').setAttribute('aria-pressed', String(kind === 'save'));
  $('prHomeBox').hidden = kind !== 'home';
  $('npBox').hidden = kind !== 'np';
  $('prSaveBox').hidden = kind !== 'save';
  const loggedIn = SHOP_LOGGED_IN && typeof window.TK_KARTE === 'string';
  $('prSaveGo').hidden = !loggedIn; $('prSaveLoginBox').hidden = loggedIn;
}
{ const b = $('prSave'); if (b) b.onclick = () => { prChoose('save'); if (SHOP_LOGGED_IN && typeof window.TK_KARTE === 'string') favSaveOrder(b, $('prSaveMsg')); };   // ★v0.2.237 押すと すぐ 保存（ボタンの 文字が 保存しています…→完了しました）
  const g = $('prSaveGo'); if (g) g.onclick = () => favSaveOrder(g); const l = $('prSaveLoginGo'); if (l) l.onclick = prToLogin;
  // ★v0.2.237 コンビニの 箱と 保存の 箱は ボタンの すぐ下
  const k = $('prKind'); if (k) { const nb = $('npBox'), sb = $('prSaveBox'); if (nb && sb) k.after(nb, sb); } }
function prShowQuota(q) {
  window.TK_PLUS = !!q.member;   // ★プラス会員は 印刷マークを 消す
  const pb = $('pdfBox'); if (pb) pb.hidden = true;   // ★みなとさん 2026-11-03「PDFを 作るは ここでは 廃止。サイトの 方で 行います」
  $('prQuota').textContent = (npSupported() ? TEXTS.prQuota.replace('{n}', q.np.left) : TEXTS.prQuotaHome).replace('{h}', q.home.left).replace('{l}', q.limit) + (q.member ? '' : '／' + TEXTS.prQuotaMember) + '／' + TEXTS.prCounted;
}
async function prRefreshQuota() {
  if (!prCounted()) return;
  if (!SHOP_LOGGED_IN) { $('prQuota').textContent = TEXTS.prLogin; return; }
  try {
    const r = await fetch('/apps/techou/print-quota', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => null);
    if (r.ok && j && j.ok) prShowQuota(j);
  } catch (e) { /* のこりが 見えなくても 押せば Worker が 止める */ }
}
(function () {
  const h = $('prHome'), n = $('prNp'); if (!h || !n) return;
  h.onclick = () => { prChoose('home'); if (document.body.classList.contains('nike')) $('printGo').click(); };   // ★v0.2.237 みなとさん「家で印刷を 押すと 印刷」（下の ボタンは 出さない）
  n.onclick = () => prChoose('np');
})();

/* ★v0.2.180 PDF の ボタン。**お店で、部品の ありかが わたされた ときだけ** 出す
   （楽天 GOLD には TK_PDF_LIBS が 無い ので 出ない） */
(function () {
  const box = $('pdfBox'), go = $('pdfGo');
  if (!box || !go) return;
  box.hidden = true; return;   // ★みなとさん 2026-11-03 PDF は ここでは 廃止（サイトの 方で 行う）。下は つかわない
  go.onclick = async () => {
    /* 会員かどうかを 聞く。まだ しくみが 無い（入口が 404）あいだは 「じゅんび中」と 出す */
    let ok = false;
    try {
      const r = await fetch(window.TK_PDF_CHECK || '/apps/techou/pdf-ok', { headers: { Accept: 'application/json' } });
      if (r.ok) { const j = await r.json(); ok = !!(j && j.ok && j.member); }
    } catch (e) {}
    if (!ok) { const m = $('pdfMsg'); if (m) m.textContent = TEXTS.pdfMember; return; }
    makePdf();
  };
})();

/* ★v0.2.202 🏪 コンビニで 刷る（ねっぷり＝シャープ ネットワークプリント）
   ------------------------------------------------------------
   ・見ている 1まいを PDF に して、本店の 中の 道（/apps/techou/netprint）へ 送る
     → Worker v4.36.0 が ねっぷりに 登録（ゲストログイン → 文書登録 → QR）→ ユーザー番号と QR が かえる
   ・出るのは お店（Shopify）で PDF の 部品が ある ときだけ（楽天 GOLD には 出ない。ねっぷりの アドレスは この ファイルに 書かない）
   ・ログインして いなければ、押した ときに ログインの ページへ（もどって くると 同じ 形で ひらく）
   ・ねっぷりの 文書プリントで 刷れる 紙は A4・A3・B4・B5 だけ → B5・A4 は そのまま。
     ほかの 大きさ（A5・B6・L判）は **A4 の まん中に 原寸**で 置く（切って つかう）。印刷は 原寸（pdf_fit_to_page=false） */
// ★ねっぷりで 刷れる 紙（B5・A4 だけ）
const NP_PAPER = { b5: 'B5', a4: 'A4' };   // ねっぷりに そのまま 登録できる 紙
const npSupported = () => !!NP_PAPER[PSIZE];
function npPaperOf(ps) { return { np: NP_PAPER[ps.id] || 'B5', w: ps.w, h: ps.h, ox: 0, oy: 0, centered: false }; }

const NP = { last: null };
const npAvailable = () => SHOP === 'shopify' && Array.isArray(window.TK_PDF_LIBS) && window.TK_PDF_LIBS.length >= 2;
function npName() { return ('birthbooknote-' + PSIZE + '-' + (typeof noteInkPageNo === 'function' ? noteInkPageNo() : 1)).replace(/[^0-9A-Za-z_-]/g, '').slice(0, 26); }   // ★ノート用（ページ番号）
/* 見ている 1まいだけの PDF（makePdf と 同じ 道具・同じ 字） */
async function npOnePdf(opt) {   // ★2026-10-15 opt.ink＝書いた ものも PDF に 入れる（iPhone の PDF 印刷用）
  await loadPdfLibs();
  const JP = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
  if (!JP || typeof JP.API.svg !== 'function') throw new Error('libs');
  const ps = psizeOf(PSIZE), pg = npPaperOf(ps);
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
  if (!note) throw new Error('no-note');
  const hide = document.createElement('div');
  hide.style.cssText = 'position:fixed;left:-99999px;top:0;width:1px;height:1px;overflow:hidden';
  document.body.appendChild(hide);
  try {
    const doc = new JP({ unit: 'mm', format: [pg.w, pg.h], orientation: pg.w > pg.h ? 'landscape' : 'portrait', compress: true });
    tkPdfFonts(doc);
    await tkBrowserFont();
    const el = await sheetSvgEl(note, '#ffffff');
    hide.replaceChildren(el);
    await doc.svg(el, { x: pg.ox, y: pg.oy, width: ps.w, height: ps.h });
    if (opt && opt.ink && typeof noteInkPrintCanvas === 'function') {   // 書いた ものを うえに かさねる（写真など 外の 画像で canvas が 使えない ときは 紙だけ）
      try { const ic = noteInkPrintCanvas(1600); if (ic) doc.addImage(ic.toDataURL('image/png'), 'PNG', pg.ox, pg.oy, ps.w, ps.h); } catch (e) { console.warn('pdf ink', e); }
    }
    return { blob: doc.output('blob'), paper: pg.np, centered: pg.centered };
  } finally { hide.remove(); }
}
let npBusy = false;
async function npSend() {
  if (npBusy) return;
  npBusy = true;
  const go = $('npGo'), say = t => { $('npMsg').textContent = t; };
  go.disabled = true; $('npResult').hidden = true;
  try {
    say(TEXTS.pdfLoading);
    const { blob, paper, centered } = await npOnePdf();
    // ★v0.2.218 みなとさん「ねっぷりで 印刷した 画像に して」→ 送る PDF と **同じ 1まい** から すぐ 絵を 作って 取って おく
    //   （送り おわってから 作ると、その あいだに 紙を めくった とき ちがう ページの 絵に なる）
    let thumb = null; try { thumb = await npThumbBlob(); } catch (e) { thumb = null; }
    say(TEXTS.npSending);
    const q = new URLSearchParams({ paper, name: npName() });   // ★v0.2.203 日数は 30日 固定（Worker が きめる）
    const pw = $('npPw').value.trim(); if (pw) q.set('pw', pw);
    const r = await fetch('/apps/techou/netprint?' + q, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/pdf', Accept: 'application/json' }, body: blob });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || !j.ok) { say((j && j.message) || TEXTS.npError); return; }
    npShow(j, centered);
    npSaveThumb(j.fileId, thumb);   // ★v0.2.217 送った 紙の 小さな 絵（待たない・だめでも 番号は 出て いる）
    say('');
  } catch (e) {
    console.error(e);
    say(TEXTS.npError);
  } finally { npBusy = false; go.disabled = false; }
}
/* ★v0.2.217 みなとさん「QR と いっしょに 画像を 入れて、どれを ねっぷり したか わかりやすく」
   送った 紙を 240px の JPEG（60KB まで）に して、手帳の Worker（/apps/techou/netprint/thumb）に おぼえさせる。
   おきにいりの「ねっぷり」の 段で 番号・QR の となりに 出る。字体は 画面の ものに なる（見本なので）。 */
async function npThumbBlob() {
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
  if (!note) return null;
  const el = await sheetSvgEl(note, '#ffffff');
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(el)], { type: 'image/svg+xml' }));
  try {
    const img = new Image();
    await new Promise((ok, ng) => { img.onload = ok; img.onerror = ng; img.src = url; });
    const ps = psizeOf(PSIZE), W = 240, H = Math.round(W * ps.h / ps.w);
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const g = c.getContext('2d'); g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H); g.drawImage(img, 0, 0, W, H);
    for (const qv of [0.8, 0.6, 0.45]) { const b = await new Promise(r => c.toBlob(r, 'image/jpeg', qv)); if (b && b.size <= 60000) return b; }
    return null;
  } finally { URL.revokeObjectURL(url); }
}
async function npSaveThumb(fid, b) {   // b＝送る 前に 作った 絵（★v0.2.218）
  try {
    if (!/^[0-9]{1,20}$/.test(String(fid || '')) || !b) return;
    await fetch('/apps/techou/netprint/thumb?f=' + encodeURIComponent(fid), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'image/jpeg', Accept: 'application/json' }, body: b });
  } catch (e) { console.warn('np thumb', e); }
}
/* ★2026-10-19 トップの［印刷］から「ねっぷり印刷」：いまの 1ページ か、会員は えらんだ ページ（最大 52）を 1つの PDF に して 1個として 登録。
   ・書いた ものも 入れる／10MB を こえたら 送らず「ページを 分けて」と 返す／ふつうの 人は 1ページだけ（まとめては 会員の 特典） */
async function npPagesPdf(list, inkW, onProgress) {   // inkW＝書きこみの 絵の よこ幅（ページが おおい ほど 小さく して 10MB に おさめる）。onProgress(いま, ぜんぶ)
  await loadPdfLibs();
  const JP = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
  if (!JP || typeof JP.API.svg !== 'function') throw new Error('libs');
  const ps = psizeOf(PSIZE), pg = npPaperOf(ps);
  const note = curPage().ysheet != null ? yNote() : state.notes[state.idx];
  if (!note) throw new Error('no-note');
  const hide = document.createElement('div');
  hide.style.cssText = 'position:fixed;left:-99999px;top:0;width:1px;height:1px;overflow:hidden';
  document.body.appendChild(hide);
  let svgUrl = null;
  try {
    const doc = new JP({ unit: 'mm', format: [pg.w, pg.h], orientation: pg.w > pg.h ? 'landscape' : 'portrait', compress: true });
    tkPdfFonts(doc);
    await tkBrowserFont();
    const el = await sheetSvgEl(note, '#ffffff');
    hide.replaceChildren(el);
    const pre = noteInkPrefix();
    const W = inkW || 1400;
    let paperImg = null;   // 写真・スタンプの 絵が ある ページは「紙＋書きこみ」を 1まいの JPEG に まとめる（PNG だと 写真で 10MB を こえる）
    const needFlat = list.some(n => (NOTEINK.pages[pre + n] || []).some(it => it && it.o === 'img'));
    if (needFlat) {
      svgUrl = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(el)], { type: 'image/svg+xml' }));
      paperImg = new Image();
      await new Promise((ok, ng) => { paperImg.onload = ok; paperImg.onerror = ng; paperImg.src = svgUrl; });
    }
    for (let i = 0; i < list.length; i++) {
      if (i) doc.addPage([pg.w, pg.h], pg.w > pg.h ? 'landscape' : 'portrait');
      const items = NOTEINK.pages[pre + list[i]] || [];
      const flat = paperImg && items.some(it => it && it.o === 'img');
      if (flat) {
        try {
          const ic = noteInkPrintCanvasFor(pre + list[i], W);
          const c = document.createElement('canvas'); c.width = ic.width; c.height = ic.height;
          const g = c.getContext('2d'); g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(paperImg, 0, 0, c.width, c.height); g.drawImage(ic, 0, 0);
          doc.addImage(c.toDataURL('image/jpeg', 0.74), 'JPEG', pg.ox, pg.oy, ps.w, ps.h);
        } catch (e) {   // 外の 写真で canvas が 使えない とき：紙だけ（いままでの ねっぷりと おなじ）
          console.warn('np flat', e); await doc.svg(el, { x: pg.ox, y: pg.oy, width: ps.w, height: ps.h });
        }
      } else {
        await doc.svg(el, { x: pg.ox, y: pg.oy, width: ps.w, height: ps.h });
        try { const ic = noteInkPrintCanvasFor(pre + list[i], W); if (ic) doc.addImage(ic.toDataURL('image/png'), 'PNG', pg.ox, pg.oy, ps.w, ps.h); } catch (e) { console.warn('np ink', e); }
      }
      if (onProgress) { try { onProgress(i + 1, list.length); } catch (e) {} }
      await new Promise(r => setTimeout(r, 0));   // 画面が 止まらない ように ひと休み
    }
    return { blob: doc.output('blob'), paper: pg.np, centered: pg.centered };
  } finally { hide.remove(); if (svgUrl) URL.revokeObjectURL(svgUrl); }
}
window.tkHomeNetprint = async function (opt) {
  if (!SHOP_LOGGED_IN) return { ok: false, needLogin: true, message: tr('ねっぷり印刷は ログインが いります') };
  if (!npAvailable() || !npSupported()) return { ok: false, message: tr('この 紙は ねっぷりで 刷れません（B5・A4 だけ）') };
  const selP = noteListFromOpt(opt);
  const list = selP || [noteInkPageNo()];
  if (list.length > 1 && !window.TK_PLUS) return { ok: false, message: tr('まとめての ねっぷりは プラス会員（月380円）の 特典です') };
  try {
    let pdf;
    const prog = opt && typeof opt.onProgress === 'function' ? opt.onProgress : null;
    if (selP) {   // ページが おおい ほど 書きこみの 絵を 小さく（52ページでも 10MB に おさめる）。それでも こえたら 小さくして 1回だけ やりなおす
      const w0 = list.length <= 10 ? 1400 : list.length <= 30 ? 1100 : 900;
      pdf = await npPagesPdf(list, w0, prog);
      if (pdf.blob.size > 9.5 * 1024 * 1024) pdf = await npPagesPdf(list, 650, prog);
    } else pdf = await npOnePdf({ ink: true });
    const { blob, paper, centered } = pdf;
    if (blob.size > 9.5 * 1024 * 1024) return { ok: false, message: tr('ページが おおくて 大きすぎます（10MBまで）。ページの はんいを 分けて ください') };
    let thumb = null; if (!selP || list.length === 1) { try { thumb = await npThumbBlob(); } catch (e) { thumb = null; } }
    const nm = (selP ? 'birthbooknote-' + PSIZE + '-p' + list[0] + 'to' + list[list.length - 1] : npName()).replace(/[^0-9A-Za-z_-]/g, '').slice(0, 26);
    const q = new URLSearchParams({ paper, name: nm });
    const pw = opt && typeof opt.pw === 'string' ? opt.pw.trim() : ''; if (pw) q.set('pw', pw);
    const r = await fetch('/apps/techou/netprint?' + q, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/pdf', Accept: 'application/json' }, body: blob });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || !j.ok) return { ok: false, message: (j && j.message) || TEXTS.npError };
    NP.last = j.fileId;
    if (thumb) npSaveThumb(j.fileId, thumb);
    return { ...j, centered, pages: list.length };
  } catch (e) { console.error(e); return { ok: false, message: TEXTS.npError }; }
};
window.tkHomeNpOk = () => !!(SHOP_LOGGED_IN && npAvailable() && npSupported());
function npDate(sec) { const d = new Date(sec * 1000); return LANG === 'ja' ? (d.getMonth() + 1) + '月' + d.getDate() + '日' : MONTH_EN[d.getMonth()].slice(0, 3) + ' ' + d.getDate(); }
function npShow(j, centered) {
  NP.last = j.fileId;
  $('npCode').textContent = j.userCode;
  const img = $('npQr');
  if (j.qr && /^data:image\/jpeg;base64,/.test(j.qr)) { img.src = j.qr; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
  $('npInfo').textContent = TEXTS.npInfo.replace('{paper}', j.paper).replace('{days}', String(j.days || 3)).replace('{date}', npDate(j.expiresAt)) + (centered ? TEXTS.npCentered : '') + (j.pw ? (j.pwCode ? 'コンビニで 暗証番号（' + j.pwCode + '）も 入れます。' : TEXTS.npPwNote) : '') + (j.test ? TEXTS.npTest : '');
  $('npCheckMsg').textContent = '';
  $('npResult').hidden = false;
  prRefreshQuota();   // ★v0.2.203 のこり 回数を 出しなおす
}
async function npCheck() {
  if (!NP.last) return;
  const m = $('npCheckMsg'); m.textContent = TEXTS.npChecking;
  try {
    const r = await fetch('/apps/techou/netprint/status?f=' + encodeURIComponent(NP.last), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || !j.ok) { m.textContent = (j && j.message) || TEXTS.npError; return; }
    m.textContent = j.printable ? TEXTS.npReady : (j.failed ? TEXTS.npFailed : TEXTS.npNotYet.replace('{s}', j.status || ''));
  } catch (e) { m.textContent = TEXTS.npError; }
}
(function () {
  const box = $('npBox'); if (!box || !npAvailable()) return;
  /* ★v0.2.203 見せる／かくすは prChoose（家／コンビニの えらび）が する */
  if (!SHOP_LOGGED_IN) {
    /* ログインの ページへ（もどり先＝いまの 形の アドレス）。Shopify が 新しい ログインへ 送りなおして くれる */
    $('npGo').onclick = () => { $('npMsg').textContent = TEXTS.npLogin; try { const u = new URL(shareUrl()); location.href = '/account/login?return_to=' + encodeURIComponent(u.pathname + u.search); } catch (e) {} };
    return;
  }
  $('npGo').onclick = npSend;
  $('npCheck').onclick = npCheck;
})();

// ===== 楽天市場アプリなど「アプリの中の画面」では印刷できないので、ブラウザで開くよう案内する =====
//   ★アプリの中の画面は、印刷の命令（window.print）を出しても何も起きないことが多い
//   見分け方（userAgent＝ブラウザの名札）：
//     ・名札に Rakuten / Ichiba が入っている → 楽天市場アプリ
//     ・iPhone で「Safari/」の印がない → アプリの中の画面（Safari・Chrome には印がある）
//     ・Android で「; wv)」の印がある → アプリの中の画面
//   ★見分けがまちがっていたら、下の小さな版の数字（v0.1.xx）を押すと名札が出るので、それで確かめる
function inAppView() {
  const ua = navigator.userAgent || '';
  if (/Rakuten|Ichiba/i.test(ua)) return true;
  if (/iPhone|iPad|iPod/.test(ua) && !/Safari\//.test(ua)) return true;
  if (/Android/.test(ua) && /; wv\)/.test(ua)) return true;
  return false;
}
function syncPrintApp() {
  const app = inAppView();
  $('printAppNote').hidden = !app;
  $('printGo').hidden = app;
  if (app) { $('printUrl').value = shareUrl(); $('printCopyMsg').textContent = ''; }
}
$('printCopy').onclick = async () => {
  const url = shareUrl();
  $('printUrl').value = url;
  let ok = false;
  try { await navigator.clipboard.writeText(url); ok = true; } catch (e) { /* 次のやり方でためす */ }
  if (!ok) {
    // ★古いやり方：入れ物の文字をえらんでコピー（アプリの中ではこちらしか使えないことがある）
    const el = $('printUrl');
    el.focus(); el.select(); el.setSelectionRange(0, url.length);
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
  }
  $('printCopyMsg').textContent = ok ? TEXTS.printCopied : TEXTS.printCopyFail;
};
$('ver').onclick = () => alert(navigator.userAgent);   // 見分けの確認用（ふつうのお客さんは押さない小さな文字）

// ===== カゴへ =====
const itemKey = () => state.binder;
//   ・楽天：楽天の 商品番号が あるとき（いままでと 同じ）
//   ・Shopify：商品に その バインダーの バリアントが あって、売り切れで ないとき
const cartReady = () => CART_READY && (SHOP === 'shopify'
  ? !!(SHOPIFY_VARIANTS[itemKey()] && SHOPIFY_VARIANTS[itemKey()].available)
  : !!RAKUTEN.item && BINDER_LIST.some(b => b.id === itemKey()) && !PAPER_OUT[state.paper]);
// Shopify の カゴへ（同じ お店の 中の /cart/add.js に 送る）
//   ★本物の Shopify（テーマの部品の しるし TK_SHOP ＋ https ＋ 本店の アドレス が そろったとき）だけ 送る。
//     ためしの localhost（?shop=shopify）では 送る中身を 見せるだけ（楽天の【テスト】と 同じ）
//   ★項目（properties）は 楽天と 同じ 名前 ＋ 紙 ＋ ご注文内容（日本語）。Shopify は 20文字の しばりが ない
//   ★項目の 名前を「_」で はじめると カゴや 注文で かくれてしまう → つけない
//   ★英語などの ページ（/en/）でも 動くように、Shopify.routes.root（ことばの 入口）を つかう
async function addShopifyCart(choices) {
  const v = SHOPIFY_VARIANTS[itemKey()];
  const props = {};
  choices.forEach(s => { const i = s.indexOf(':'); props[s.slice(0, i)] = s.slice(i + 1); });
  props[TEXTS.paperRow] = paperOf().name;
  props[TEXTS.summaryRow] = orderRows().filter(r => r[3] !== 'code').map(r => r[0] + '：' + r[1]).join('／');
  const real = window.TK_SHOP === 'shopify' && location.protocol === 'https:' && shopOf(location.hostname, location.protocol, '') === 'shopify';
  if (!real) {
    alert('【テスト】Shopify の上ではないので送りません。\nバリアント：' + v.id + '\n送る中身：\n' + Object.entries(props).map(([k, x]) => k + '：' + x).join('\n'));
    return;
  }
  const r0 = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  const root = typeof r0 === 'string' && /^\/([a-z]{2}(-[a-z]{2,4})?\/?)?$/i.test(r0) ? r0.replace(/\/?$/, '/') : '/';
  const btn = document.querySelector('.order-cart') || $('cartBtn');   // v0.2.78：カゴに入れるのは ご注文内容の ボタン
  btn.disabled = true;
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }),
    });
    if (!res.ok) throw new Error('cart ' + res.status);
    goTop(root + 'cart');
  } catch (e) {
    alert(TEXTS.cartFail);
    btn.disabled = false;
  }
}
$('checkBtn').onclick = () => { if (zoom.s !== 1) setZoom(false); closePop(); turnPage('order'); };
// ★nv0.2.147 印刷カードの［購入］：お店の 窓（NIKE 風）なら ⑭ 注文確定の 手順へ／旧画面は［内容を 確認する］と 同じ
$('prBuy').onclick = () => { if (typeof NK !== 'undefined' && NK.on && typeof nkGo === 'function') nkGo(TEXTS.nkSteps.findIndex(st => st[0] === 'order')); else $('checkBtn').onclick(); };   // ★nv0.2.151 nkGo は 番号
// ★nv0.2.152 トップの［印刷］→［購入］から とんで きた とき：窓の 準備が できたら ⑭ 注文確定へ（紙も ご注文内容の ページに）
if (window.__tkGo) { let tries = 0; const tm = setInterval(() => { tries++; if ((typeof NK !== 'undefined' && NK.on && NK.ready) || tries > 60) { clearInterval(tm); try { if (NK.on) nkGo(TEXTS.nkSteps.findIndex(st => st[0] === 'order')); else $('checkBtn').onclick(); } catch (e) {} } }, 150); }
// ★v0.2.78：下の ボタンは「内容確定に進む」＝ご注文内容の ページへ（カゴには 入れない）
$('cartBtn').onclick = $('checkBtn').onclick;
document.addEventListener('click', e => { if (e.target.closest('#book .order-cart')) addToCart(); });
// カゴに入れる（ご注文内容の いちばん下の ボタンから よぶ）
function addToCart() {
  if (!cartReady()) { alert(TEXTS.cartNotReady); return; }
  const choices = orderChoices();
  for (const v of choices) {
    const [k, ...rest] = v.split(':');
    const val = rest.join(':');
    if ([...val].length > RAKUTEN.MAX) { alert('「' + k + '」が' + RAKUTEN.MAX + '文字をこえています。短くしてください。'); return; }
    if (NO_EMOJI.test(val)) { alert('「' + k + '」に絵文字が入っています。消してください。'); return; }
  }
  if (SHOP === 'shopify') { addShopifyCart(choices); return; }   // ここから下は 楽天だけ（いままでと 同じ）
  if (!/(^|\.)rakuten\.ne\.jp$/.test(location.hostname)) {
    alert('【テスト】楽天GOLDの上ではないので送りません。\nバリエーション：' + RAKUTEN.sku() + '（' + yen(priceOf()) + '）\n送る中身：\n' + choices.join('\n'));
    return;
  }
  const f = document.createElement('form');
  f.method = 'post'; f.action = RAKUTEN.basket; f.acceptCharset = 'EUC-JP'; f.target = '_top';
  const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.append(i); };
  choices.forEach(v => add('choice', v));
  add('shop_bid', RAKUTEN.shopId);
  add('item_id', RAKUTEN.item);
  add('variant_id', RAKUTEN.sku());   // どの バリエーション（紙×バインダー）か
  add('units', '1');
  add('inventory_flag', '1');
  add('__event', 'ES01_003_001');
  document.body.append(f);
  f.submit();
};

// ===== 上の 横の列（なかま・タイル）を パソコンでも 動かせるように（v0.2.64）=====
//   ★スクロールバーは かくしている（見た目のため）ので、マウスだと 横に 動かせなかった（みなとさんの 気づき）
//   ・左右の はしに「‹ ›」ボタン（CSS で パソコンだけ・動ける向きだけ 出す）
//   ・列の上で ホイールを 回すと 横に 動く（横に はみ出して いる ときだけ。はみ出して いなければ ふつうの ホイール）
//   ★自分で 押した・回した ときだけ 動く（勝手に 動かさない きまり）
const HS_ARROW = { l: 'M15 5l-7 7 7 7', r: 'M9 5l7 7-7 7' };
function hScroll(el) {
  const box = document.createElement('div');
  box.className = 'hs';
  el.before(box);
  box.append(el);
  const update = () => {
    box.classList.toggle('can-l', el.scrollLeft > 2);
    box.classList.toggle('can-r', el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  };
  for (const side of ['l', 'r']) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'hs-btn ' + side;
    b.setAttribute('aria-label', side === 'l' ? '左へ' : '右へ');
    b.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${HS_ARROW[side]}"/></svg>`;   // 決まった絵だけ
    b.onclick = () => el.scrollBy({ left: (side === 'l' ? -1 : 1) * Math.round(el.clientWidth * .7), behavior: 'smooth' });
    box.append(b);
  }
  el.addEventListener('scroll', update, { passive: true });
  el.addEventListener('wheel', e => {
    if (e.ctrlKey || Math.abs(e.deltaX) >= Math.abs(e.deltaY) || el.scrollWidth <= el.clientWidth) return;   // 横の ホイール・トラックパッドは そのまま
    e.preventDefault();
    el.scrollLeft += e.deltaY * (e.deltaMode === 1 ? 16 : 1);   // deltaMode 1＝行の数で くる ブラウザ（Firefox）
  }, { passive: false });
  new MutationObserver(update).observe(el, { childList: true });   // なかま・タイルを 作りなおしたとき
  window.addEventListener('resize', update);
  update();
  return update;
}

// ===== 言葉の 辞書を 登録（英語）。中国語・韓国語・独・仏は ここに I18N.zh = { ui: {...}, ... } を 足す =====
Object.assign(I18N.en, {
  ui: UI_EN,                                   // 画面（TEXTS・えらぶ 欄・説明・ご注文内容）
  fn: { cartWhat: (name, n) => `${name} B5 loose-leaf, ${n} sheets`, enikkiCount: n => `${n} days with pictures (shown on monthly sheets)`, sheetOf: (i, n) => `sheet ${i} of ${n}` },
  fmt: FMT_EN, cat: CAT_EN,                    // 形と なかまの 名前
});
/* ★バースブックノート v0.2.0：柄の 一覧を 読む
   ------------------------------------------------------------
   notes.json の 形：
     { size:'B5', categories:[ { id, name, notes:[ { id, name, file } ] } ] }
   これを 手帳の CATS（なかま）と FORMATS（形）に 入れかえます。
   ★FORMATS は const なので、入れものは そのままで **中身だけ** 入れかえます。 */
async function loadNoteData() {
  let data = null;
  // ① ファイルを ダブルクリックで ひらいた とき＝notes.js を 読む（fetch が きかない ため）
  if (location.protocol === 'file:') {
    try {
      await new Promise((ok, ng) => {
        const sc = document.createElement('script');
        sc.src = 'notes.js?v=' + APP_VERSION;
        sc.onload = ok; sc.onerror = ng;
        document.head.appendChild(sc);
      });
      data = window.NOTES_LOCAL || null;
    } catch (e) { data = null; }
  }
  // ② ふだん（GOLD・お店）＝notes.json を 読む
  if (!data) {
    try {
      const list = (typeof window !== 'undefined' && window.TK_NOTE_LIST) || ('notes.json?v=' + APP_VERSION);
      const r = await fetch(list, { cache: 'no-cache' });
      data = await r.json();
    } catch (e) { data = null; }
  }
  if (!data || !Array.isArray(data.categories)) { console.warn('[note] 柄の 一覧が 読めません'); return; }

  // なかま
  CATS.length = 0;
  data.categories.forEach(c => CATS.push({ id: c.id, name: c.name }));

  // 形＝柄 1まい＝1つ。unit:'note' に すると 紙は 1まいだけに なる
  FORMATS.length = 0;
  /* ✂️ ★nv0.2.16 みなとさん「オーダーメイドも 全て 入れて」（2026-10-03）
     ------------------------------------------------------------
     古い ノート v0.1.54 と 同じ：**オーダーメイドは どの なかまでも いちばん左**。
     柄の ファイルは なく、その場で 線を 描く（customSvg）。 */
  FORMATS.push({ id: 'CM', name: 'オーダーメイド', cat: (data.categories[0] || {}).id || 'lines',
                 unit: 'note', mini: [], note: true, custom: true });
  data.categories.forEach(c => (c.notes || []).forEach(n => {
    // ★nv0.2.35 no＝ずっと 変わらない 番号（注文コードに 入る。build.py が notes_no.json で ふりだす）
    FORMATS.push({ id: n.id, name: n.name || n.id, cat: c.id, unit: 'note', mini: [], note: true, file: n.file, no: n.no });
  }));
  FORMATS.forEach(f => { if (FMT_EN[f.id] && !(f.name in UI_EN)) UI_EN[f.name] = FMT_EN[f.id]; });   // ★nv0.2.145 柄の 日本語の 名前 → 英語の 名前（画面・ご注文内容の 文字を 置きかえる ため。ない 柄は 日本語の まま）
  console.info('[note] 柄 ' + FORMATS.length + 'まい／なかま ' + CATS.length + 'つ');
}

/* ✂️ ★nv0.2.10 みなとさん「形を変える ここは 残します。同じように 形を 変更できるように します」
   ------------------------------------------------------------
   古い ノート v0.1.71 の **オーダーメイド**を そのまま 持って きました。
   紙を 区画に 分けて、区画ごとに 線を えらべます（8通りの わけ方 × 9種類の 線）。
   注文コードは 36進数14文字（注文コードの読み方.md の とおり）。
   ★手帳にも 同じ 名前の ものが ある ので、ぶつからない ように
     seg → nbSeg／syncCustom → nbSyncCustom／changeCustom → nbChangeCustom／
     markSvg → nbMarkSvg／MARK_TOP → NB_MARK_TOP に 変えて あります。 */
const CM = {
  layouts: [
    { name: '1面', tabs: ['ぜんぶ'], ratio: false },
    { name: '上下', tabs: ['上', '下'], ratio: true },
    { name: '左右', tabs: ['左', '右'], ratio: true },
    { name: '上＋下2列', tabs: ['上', '左下', '右下'], ratio: true },
    { name: '上2列＋下', tabs: ['左上', '右上', '下'], ratio: true },
    { name: '3段', tabs: ['上', 'まん中', '下'], ratio: false },
    { name: '3列', tabs: ['左', 'まん中', '右'], ratio: false },
    { name: '左メモ＋右2段', tabs: ['左', '右上', '右下'], ratio: true },
  ],
  headers: ['なし', '日付', 'タイトル'],
  /* ★nv0.2.27 みなとさん「カスタムの 中に 今 選ばれて いる ノートを 入れて 欲しい」（2026-10-03）
     → 10こめの 線の 種類として「**いまの 柄**」を 足しました。
       その 区画には、えらんで いる 柄を **その ところだけ 切り取って**入れます。 */
  types: ['無地', '横罫', '方眼', 'ドット', '十字', '5本罫', 'チェック', 'マス目', '英語罫', 'いまの柄'],
  ORIG: 9,   // ★「いまの柄」の ばんごう
  spaces: Array.from({ length: 27 }, (_, i) => 2 + i * .5),     // 2〜15mm
  ratios: Array.from({ length: 13 }, (_, i) => 20 + i * 5),       // 20〜80%
  weights: ['ほそい', 'ふつう', 'ふとい'],
  // ★nv0.2.179 線の太さ スライダー：番号 wt → 太さ(mm)。0・1・2 は もとの まま（保存ずみの 紙を こわさない）／ならびは 細い→太い
  wtw: { 0: .12, 1: .2, 2: .35, 3: .15, 4: .25, 5: .3, 6: .45, 7: .6, 8: .08, 9: .1 },
  wtOrder: [8, 9, 0, 3, 1, 4, 5, 2, 6, 7],
  styles: ['実線', '点線', '破線'],
  emphs: ['なし', '5本', '10本'],
};
const B5 = { w: 182, h: 257, x1: 16, x2: 174, y1: 10, y2: 247 };
state.custom = {
  layout: 1, header: 0, ratio: 8,
  areas: [
    { type: 1, sp: 10, wt: 1, st: 0, em: 0 },   // 横罫 7mm
    { type: 2, sp: 6, wt: 0, st: 0, em: 1 },    // 方眼 5mm・5本ごと
    { type: 3, sp: 6, wt: 1, st: 0, em: 0 },    // ドット 5mm
  ],
};
state.cmTab = 0;
const b36 = n => n.toString(36);
function customCode(c = state.custom) {
  return b36(c.layout * 3 + c.header) + b36(c.ratio)
    + c.areas.map(a => b36(a.type) + b36(a.sp) + b36(a.wt) + b36(a.st * 3 + a.em)).join('');
}
function decodeCustom(code) {
  if (!/^[0-9a-z]{14}$/.test(code || '')) return null;
  const v = [...code].map(ch => parseInt(ch, 36));
  const lh = v[0];
  const c = { layout: Math.floor(lh / 3), header: 0, ratio: v[1], areas: [] };   // いちばん上の欄は2026-09-17にやめた（いつも「なし」）
  if (c.layout >= CM.layouts.length || c.ratio >= CM.ratios.length) return null;
  for (let i = 0; i < 3; i++) {
    const [t, sp, wt, se] = v.slice(2 + i * 4, 6 + i * 4);
    if (t >= CM.types.length || sp >= CM.spaces.length || wt > 9 || se > 8) return null;
    c.areas.push({ type: t, sp, wt, st: Math.floor(se / 3), em: se % 3 });
  }
  return c;
}
// 区画の四角（mm）
function customAreas(c, top) {
  const X1 = B5.x1, X2 = B5.x2, Y2 = B5.y2, g = 3;
  const W = X2 - X1, H = Y2 - top, r = CM.ratios[c.ratio] / 100;
  const box = (x, y, w, h) => ({ x, y, w, h });
  const rows = (y, h, parts) => { const out = []; let yy = y; parts.forEach(f => { const hh = (h - g * (parts.length - 1)) * f; out.push([yy, hh]); yy += hh + g; }); return out; };
  const cols = (x, w, parts) => { const out = []; let xx = x; parts.forEach(f => { const ww = (w - g * (parts.length - 1)) * f; out.push([xx, ww]); xx += ww + g; }); return out; };
  switch (c.layout) {
    case 0: return [box(X1, top, W, H)];
    case 1: return rows(top, H, [r, 1 - r]).map(([y, h]) => box(X1, y, W, h));
    case 2: return cols(X1, W, [r, 1 - r]).map(([x, w]) => box(x, top, w, H));
    case 3: { const [[ty, th], [by, bh]] = rows(top, H, [r, 1 - r]); return [box(X1, ty, W, th), ...cols(X1, W, [.5, .5]).map(([x, w]) => box(x, by, w, bh))]; }
    case 4: { const [[ty, th], [by, bh]] = rows(top, H, [r, 1 - r]); return [...cols(X1, W, [.5, .5]).map(([x, w]) => box(x, ty, w, th)), box(X1, by, W, bh)]; }
    case 5: return rows(top, H, [1 / 3, 1 / 3, 1 / 3]).map(([y, h]) => box(X1, y, W, h));
    case 6: return cols(X1, W, [1 / 3, 1 / 3, 1 / 3]).map(([x, w]) => box(x, top, w, H));
    default: { const [[lx, lw], [rx, rw]] = cols(X1, W, [r, 1 - r]); return [box(lx, top, lw, H), ...rows(top, H, [.5, .5]).map(([y, h]) => box(rx, y, rw, h))]; }
  }
}
// 1つの区画に線を引く（SVGの文字を返す）
function areaSvg(a, spec, C, spOverride) {
  const f0 = n => +n.toFixed(2);
  /* ★nv0.2.27「いまの 柄」の 区画は、ここでは **しるしだけ** 置きます。
     ほんとうの 柄は あとで getSvg が 中に 入れます（柄の ファイルを 読む ひつようが ある ため）。 */
  if (spec.type === CM.ORIG) {
    return `<g data-orig="1" data-x="${f0(a.x)}" data-y="${f0(a.y)}" data-w="${f0(a.w)}" data-h="${f0(a.h)}"></g>`;
  }
  const f = n => +n.toFixed(2);
  const sp = spOverride || CM.spaces[spec.sp];
  const sw = CM.wtw[spec.wt] ?? .2;
  const dash = ['', ` stroke-dasharray="0.05 ${f(Math.max(.7, sw * 3))}" stroke-linecap="round"`, ` stroke-dasharray="${f(sp * .28)} ${f(sp * .16)}"`][spec.st];
  const emEvery = [0, 5, 10][spec.em];
  const w = k => (emEvery && k % emEvery === 0 ? f(sw * 2.2) : sw);
  const L = (x1, y1, x2, y2, width, d = dash) => `<line x1="${f(x1)}" y1="${f(y1)}" x2="${f(x2)}" y2="${f(y2)}" stroke="${C}" stroke-width="${width}"${d}/>`;
  const X2 = a.x + a.w, Y2 = a.y + a.h;
  let o = '';
  const hlines = (step, width) => { let k = 1; for (let y = a.y + step; y < Y2 - .01; y += step, k++) o += L(a.x, y, X2, y, width(k)); };
  const vlines = (step, width) => { let k = 1; for (let x = a.x + step; x < X2 - .01; x += step, k++) o += L(x, a.y, x, Y2, width(k)); };
  const frame = width => { o += `<rect x="${f(a.x)}" y="${f(a.y)}" width="${f(a.w)}" height="${f(a.h)}" fill="none" stroke="${C}" stroke-width="${width}"/>`; };
  switch (spec.type) {
    case 1: hlines(sp, w); break;
    case 2: frame(sw); hlines(sp, w); vlines(sp, w); break;
    case 3: for (let y = a.y + sp; y < Y2 - .01; y += sp) for (let x = a.x + sp; x < X2 - .01; x += sp) o += `<circle class="ink" cx="${f(x)}" cy="${f(y)}" r="${f(sw * 1.6)}" fill="${C}"/>`; break;
    case 4: { const t = Math.min(sp * .2, 1.2); for (let y = a.y + sp; y < Y2 - .01; y += sp) for (let x = a.x + sp; x < X2 - .01; x += sp) o += L(x - t, y, x + t, y, sw, '') + L(x, y - t, x, y + t, sw, ''); break; }
    case 5: { for (let y = a.y + sp; y + sp * 4 < Y2; y += sp * 6.5) for (let k = 0; k < 5; k++) o += L(a.x, y + k * sp, X2, y + k * sp, k === 0 || k === 4 ? f(sw * 1.8) : sw); break; }
    case 6: { const step = Math.max(sp, 5), bx = Math.min(step * .55, 4); for (let y = a.y + step; y < Y2 - .01; y += step) { o += `<rect x="${f(a.x + 1)}" y="${f(y - bx - (step - bx) / 2 + bx / 2 - bx / 2)}" width="${f(bx)}" height="${f(bx)}" rx=".4" fill="none" stroke="${C}" stroke-width="${sw}"/>` + L(a.x, y, X2, y, sw); } break; }
    case 7: { const m = Math.max(sp, 5), cols = Math.floor(a.w / m), rws = Math.floor(a.h / m), x0 = a.x + (a.w - cols * m) / 2, y0 = a.y + (a.h - rws * m) / 2;
      o += `<rect x="${f(x0)}" y="${f(y0)}" width="${f(cols * m)}" height="${f(rws * m)}" fill="none" stroke="${C}" stroke-width="${f(sw * 1.8)}"/>`;
      for (let i = 1; i < cols; i++) o += L(x0 + i * m, y0, x0 + i * m, y0 + rws * m, w(i));
      for (let j = 1; j < rws; j++) o += L(x0, y0 + j * m, x0 + cols * m, y0 + j * m, w(j));
      break; }
    case 8: { for (let y = a.y + sp * .6; y + sp < Y2; y += sp * 1.6) [0, 1, 2, 3].forEach(k => { o += L(a.x, y + k * sp / 3, X2, y + k * sp / 3, k === 3 ? f(sw * 1.5) : sw, k === 1 || k === 2 ? ' stroke-dasharray="0.8 0.8"' : dash); }); break; }
    default: break;
  }
  return o;
}
// 本店の柄と同じ、上のまん中の丸いマーク（本店の柄のパスをそのまま使う。単位は pt → mm にちぢめる）
const NB_MARK_TOP = 22;   // マークの下から線を始める（mm）
function nbMarkSvg(C) {
  const pt = 25.4 / 72;
  const ring = 'M0 0C0-10.176-8.249-18.425-18.425-18.425-28.601-18.425-36.85-10.176-36.85 0-36.85 10.176-28.601 18.425-18.425 18.425-8.249 18.425 0 10.176 0 0Z';
  return `<g transform="scale(${pt.toFixed(6)})">`
    + `<path class="ink" fill="${C}" transform="matrix(1,0,0,-1,236.4444,39.595399)" d="M0 0V-.408L-4.911-2.267V-1.859Z"/>`
    + `<path class="ink" fill="${C}" transform="matrix(1,0,0,-1,236.4444,25.242798)" d="M0 0V-.402L-4.911 1.499V1.913Z"/>`
    + `<circle class="paper" fill="#ffffff" cx="257.953" cy="35.433" r="18.425"/>`
    + `<path transform="matrix(1,0,0,-1,276.378,35.433107)" stroke-width="1" fill="none" stroke="${C}" d="${ring}"/>`
    + `<path class="ink" fill="${C}" transform="matrix(1,0,0,-1,263.5667,36.001405)" d="M0 0-4.546-4.546-10.229 1.137-5.683 5.683C-5.369 5.997-4.86 5.997-4.546 5.683L0 1.137C.314 .823 .314 .314 0 0M-3.41 10.229C-4.351 11.171-5.878 11.171-6.82 10.229L-13.071 3.978-14.337 5.245C-15.128 6.035-16.48 5.475-16.48 4.357V1.775C-16.48 1.002-16.174 .261-15.627-.285L-6.82-9.093C-5.878-10.034-4.351-10.034-3.41-9.093L4.546-1.137C5.488-.195 5.488 1.332 4.546 2.273Z"/>`
    + `<path class="ink" fill="${C}" transform="matrix(1,0,0,-1,257.9528,53.708559)" d="M0 0C-10.077 0-18.275 8.198-18.275 18.275-18.275 28.353-10.077 36.551 0 36.551 10.077 36.551 18.275 28.353 18.275 18.275 18.275 8.198 10.077 0 0 0M0 36.851C-10.243 36.851-18.575 28.518-18.575 18.275-18.575 8.033-10.243-.3 0-.3 10.243-.3 18.575 8.033 18.575 18.275 18.575 28.518 10.243 36.851 0 36.851"/>`
    + `<path class="ink" fill="${C}" transform="matrix(1,0,0,-1,257.9528,52.291017)" d="M0 0C-9.295 0-16.858 7.562-16.858 16.858-16.858 26.153-9.295 33.716 0 33.716 9.295 33.716 16.858 26.153 16.858 16.858 16.858 7.562 9.295 0 0 0M0 34.016C-9.461 34.016-17.158 26.319-17.158 16.858-17.158 7.397-9.461-.3 0-.3 9.461-.3 17.158 7.397 17.158 16.858 17.158 26.319 9.461 34.016 0 34.016"/>`
    + `</g>`;
}
/* ★nv0.2.40 みなとさん「オーダーメイドの 紙にも 名前・星・チェックの 場所を 作る」（2026-10-03）
   ------------------------------------------------------------
   ★それまで オーダーメイドの 紙には 書きこむ 目じるし（data-bbn）が **1つも ありません**でした。
     お客さまが 名前を 入れても、星を えらんでも、**刷られません**でした。
   ★場所は **235まいの 柄と まったく 同じ ところ**に しました。
     本店の 柄 235まいを ぜんぶ しらべて、いちばん 多い 場所（220まい）を mm に なおした ものです。
       星     左上 （13.16, 8.08）字 2.47mm
       チェック 右上 （158.36, 8.18 / 11.36 / 14.53）字 2.47mm
       名入れ  右下 （150.25, 250.72）字 3.17mm ※fillDeco が 右そろえに する
       色コード 左下 （12.88, 250.93）字 2.47mm
   ★線を 引く ところ（NB_MARK_TOP＝22mm〜247mm）とは かさなりません。 */
const NB_DECO = `<g font-family="sans-serif" class="bbn-deco">`
  + `<text class="ink" data-bbn="stars" x="13.16" y="8.08" font-size="2.47"></text>`
  + `<text class="ink" data-bbn="todo0" x="158.36" y="8.18" font-size="2.47"></text>`
  + `<text class="ink" data-bbn="todo1" x="158.36" y="11.36" font-size="2.47"></text>`
  + `<text class="ink" data-bbn="todo2" x="158.36" y="14.53" font-size="2.47"></text>`
  + `<text class="ink" data-bbn="name" x="150.25" y="250.72" font-size="3.17"></text>`
  + `<text class="ink" data-bbn="color" x="12.88" y="250.93" font-size="2.47"></text>`
  + `</g>`;
function customSvg(c = state.custom, C = '#698aab') {
  let body = nbMarkSvg(C) + NB_DECO.replace(/class="ink"/g, `class="ink" fill="${C}"`);
  let top = NB_MARK_TOP;
  if (c.header === 1) {
    body += `<g fill="${C}" class="ink" font-family="sans-serif" font-size="3.2"><text x="${B5.x2 - 58}" y="${B5.y1 + 10}">Date</text></g>`
      + `<line x1="${B5.x2 - 48}" y1="${B5.y1 + 11}" x2="${B5.x2}" y2="${B5.y1 + 11}" stroke="${C}" stroke-width=".25"/>`
      + `<g fill="${C}" class="ink" font-family="sans-serif" font-size="3.4"><text x="${B5.x2 - 36}" y="${B5.y1 + 10}">/</text><text x="${B5.x2 - 24}" y="${B5.y1 + 10}">/</text><text x="${B5.x2 - 12}" y="${B5.y1 + 10}">(</text><text x="${B5.x2 - 2}" y="${B5.y1 + 10}">)</text></g>`;
    top = B5.y1 + 16;
  } else if (c.header === 2) {
    body += `<g fill="${C}" class="ink" font-family="sans-serif" font-size="2.8"><text x="${B5.x1}" y="${B5.y1 + 4}">TITLE</text></g>`
      + `<line x1="${B5.x1}" y1="${B5.y1 + 11}" x2="${B5.x2}" y2="${B5.y1 + 11}" stroke="${C}" stroke-width=".35"/>`;
    top = B5.y1 + 15;
  }
  const areas = customAreas(c, top);
  areas.forEach((a, i) => { body += areaSvg(a, c.areas[i], C); });
  /* ★nv0.2.39 みなとさん 2026-10-03 の しらべで 見つけた バグ
     ------------------------------------------------------------
     「いまの柄」の 区画には、えらんだ 柄の 中身を そのまま 入れます。
     本店の 柄 235まいの うち **おおくが `xlink:href` を つかって います**。
     ここの <svg> に `xmlns:xlink` が 無いと、入れた とたんに
     「Namespace prefix xlink for href is not defined」で **紙が 1まいも 出なく なります**。
     → `xmlns:xlink` を 足しました（お店用ページも 同じ ところを つかいます）。 */
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="182mm" height="257mm" viewBox="0 0 182 257"><title>${TEXTS.customName}</title><rect width="182" height="257" fill="#ffffff"/>${body}</svg>`;
}
// パネルの小さな絵
function layoutIcon(i, ratioIdx = 8) {   // ★nv0.2.182 ratioIdx＝分ける位置スライダーの 見本用
  const c = { ...state.custom, layout: i, header: 0, ratio: ratioIdx };
  const a = customAreas(c, B5.y1);
  const sx = 20 / 182, sy = 26 / 257;
  return `<svg viewBox="0 0 22 28" aria-hidden="true"><rect x="1" y="1" width="20" height="26" rx="1.5" fill="${SHEET_COLOR}" stroke="currentColor" stroke-width=".8"/>`
    + a.map(r => `<rect x="${(1 + r.x * sx).toFixed(2)}" y="${(1 + r.y * sy).toFixed(2)}" width="${(r.w * sx).toFixed(2)}" height="${(r.h * sy).toFixed(2)}" rx=".6" fill="currentColor" opacity=".28"/>`).join('') + '</svg>';
}
function typeIcon(t) {
  /* ★nv0.2.27「いまの柄」は しるしだけ なので 絵に ならない。
     かわりに「紙の 中に 小さな 紙」の 絵を 描いて、ひと目で わかる ように する。 */
  if (t === CM.ORIG) {
    return `<svg viewBox="0 0 26 26" aria-hidden="true">`
      + `<rect x=".5" y=".5" width="25" height="25" rx="3" fill="${SHEET_COLOR}" stroke="#d9d3c4"/>`
      + `<rect x="4.5" y="4" width="17" height="18" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.1"/>`
      + `<g stroke="currentColor" stroke-width=".7" opacity=".85">`
      + [7, 10, 13, 16, 19].map(y => `<line x1="6.5" y1="${y}" x2="19.5" y2="${y}"/>`).join('')
      + `</g></svg>`;
  }
  return `<svg viewBox="0 0 26 26" aria-hidden="true"><rect x=".5" y=".5" width="25" height="25" rx="3" fill="${SHEET_COLOR}" stroke="#d9d3c4"/>`
    + areaSvg({ x: 3, y: 3, w: 20, h: 20 }, { type: t, sp: 0, wt: 1, st: 0, em: 0 }, 'currentColor', t === 8 ? 6 : t === 7 ? 6.6 : t === 5 ? 2.6 : 4)
    + '</svg>';
}
function nbSeg(el, labels, now, pick) {
  el.replaceChildren(...labels.map((lb, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.textContent = lb;
    b.setAttribute('aria-pressed', String(i === now));
    b.onclick = () => pick(i);
    return b;
  }));
}
/* ✂️ ★nv0.2.21 みなとさん「形を変えるの 部分を **現在 選んで いる ものを** カスタム
   できるように 変更して」（2026-10-03）
   ------------------------------------------------------------
   ★235まいの 柄は **絵の ファイル**なので、線の 設定を 持って いません。
     そのままでは「この 柄を 直す」が できません。
   → **名前から 線を 読みとって**、それを 下じきに します。
     「A罫7mm」→ 横罫・7mm／「方眼5mm」→ 方眼・5mm／「無地」→ 無地。
     名前から わからない ものは 横罫7mm から 始めます（ふつうの ノート）。
   こうすると「えらんだ 柄に ちかい ところから 直せる」ように なります。 */
function nbGuessCustom(note) {
  const nm = String((note && note.name) || '');
  // 線の 種類（CM.types の ならび）
  const T = { 無地: 0, 横罫: 1, 方眼: 2, ドット: 3, 十字: 4, チェック: 6, マス: 7, 英語: 8 };
  let type = 1;                                   // わからない ときは 横罫
  if (/無地/.test(nm)) type = T.無地;
  else if (/方眼/.test(nm)) type = T.方眼;
  else if (/ドット/.test(nm)) type = T.ドット;
  else if (/十字/.test(nm)) type = T.十字;
  else if (/チェック/.test(nm)) type = T.チェック;
  else if (/マス/.test(nm)) type = T.マス;
  else if (/英語/.test(nm)) type = T.英語;
  else if (/罫/.test(nm)) type = T.横罫;
  // 間隔（名前の 中の 数字＋mm）。CM.spaces は 2mm から 0.5mm きざみ
  let sp = 10;                                    // 7mm（2 + 10×0.5）
  const m = nm.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:mm|ｍｍ)/);
  if (m) {
    const v = parseFloat(m[1]);
    const i = Math.round((v - 2) / 0.5);
    if (i >= 0 && i < CM.spaces.length) sp = i;
  }
  /* ★nv0.2.27 はじめは「1面ぜんぶ＝いまの 柄」。
     ここから わけ方を かえると、上は いまの 柄・下は 自分の 線、が すぐ できます。 */
  return {
    layout: 0,                                    // 1面（まるごと）から
    header: 0,
    ratio: 8,
    areas: [
      { type: CM.ORIG, sp, wt: 1, st: 0, em: 0 },   // ★はじめは えらんだ 柄 そのまま
      { type, sp, wt: 1, st: 0, em: 0 },
      { type, sp, wt: 1, st: 0, em: 0 },
    ],
  };
}

/* ★nv0.2.21「形を変える」を ひらく とき：
   いま えらんで いるのが ふつうの 柄なら、その 柄を 下じきに して
   オーダーメイドの 紙に 切りかえます（＝えらんだ ものを カスタムできる）。 */
function nbCustomFromNow() {
  const note = state.notes[state.idx];
  if (!note || note.fmt.custom) return false;     // もう オーダーメイドなら そのまま
  state.custom = nbGuessCustom(note);
  state.cmTab = 0;
  state.cmBase = note.name;                       // どの 柄から 作ったか おぼえる
  state.cmBaseFmt = note.fmt;                     // ★nv0.2.27 その 柄の ファイル（区画に 入れる ため）
  const cm = state.notes.find(n => n.fmt.custom);
  if (!cm) return false;
  state.idx = cm.index;
  setSheet(0);
  buildTiles();
  return true;
}


/* ★2026-10-15 みなとさん「紙の わけ方など 手帳と おなじ ピクトグラムの 横スクロールに」
   形を変える＝なかま（チップ）：紙の わけ方・分ける 位置・直す 面・線の 種類・間隔・太さ・形・太くする 線。中身は nbSyncCustom の ボタンと おなじ pick */
function cmSample(kind, j) {
  const box = '<rect x="3" y="4" width="18" height="16" rx="1.5" fill="#FDF8D8"/>';   // ★nv0.2.180 紙を 表す 絵は クリーム色
  const lines = attr => [9, 12.5, 16].map(y => `<path d="M6 ${y}h12" ${attr}/>`).join('');
  if (kind === 'wt') return box + lines(`stroke-width="${[.6, 1.3, 2.4][j] || 1.3}"`);
  if (kind === 'st') return box + lines(([ '', 'stroke-dasharray=".6 1.6"', 'stroke-dasharray="2.4 1.4"' ][j] || '') + ' stroke-width="1.1"');
  if (kind === 'em') return box + [9, 12.5, 16].map((y, k) => `<path d="M6 ${y}h12" stroke-width="${j === 0 ? .6 : (k === 1 ? 2.2 : .6)}"/>`).join('');
  return box;
}
/* ★nv0.2.98 線の 間隔：すべらせると 見本の 線の 間隔が その場で かわる（はなすと 紙に はんえい） */
function spaceSlider(a) {
  const wrap = mk('div', 'cm-slider');
  const max = CM.spaces.length - 1;
  const val = mk('b', 'cms-val'), prev = mk('div', 'cms-prev');
  const inp = document.createElement('input'); inp.type = 'range'; inp.min = 0; inp.max = max; inp.step = 1; inp.value = a.sp; inp.setAttribute('aria-label', tr('線の 間隔'));
  const draw = j => {
    const mm = CM.spaces[j], px = Math.max(5, Math.min(40, mm * 2.6));   // mm → 見本の 高さ
    val.textContent = mm.toFixed(1) + 'mm';
    let s = '<svg viewBox="0 0 240 64" preserveAspectRatio="none" aria-hidden="true"><rect x="0.5" y="0.5" width="239" height="63" rx="6" fill="#FDF8D8" stroke="#d9d3c4"/>';
    for (let y = 8 + px; y < 64; y += px) s += `<path d="M10 ${y.toFixed(1)}H230" stroke="#1f6fb2" stroke-width="1.2" opacity=".75"/>`;
    s += '</svg>'; prev.innerHTML = s;
  };
  draw(a.sp);
  inp.addEventListener('input', () => draw(+inp.value));
  inp.addEventListener('change', () => nbChangeCustom(() => { a.sp = +inp.value; }));
  const ends = mk('div', 'cms-ends'); ends.append(mk('span', '', CM.spaces[0].toFixed(0) + 'mm'), mk('span', '', tr('せまい') + ' ⇄ ' + tr('ひろい')), mk('span', '', CM.spaces[max].toFixed(0) + 'mm'));
  wrap.append(val, prev, inp, ends);
  return wrap;
}
/* ★nv0.2.179 線の 太さ：線の 間隔と おなじ スライダー（すべらせると 見本の 線の 太さが その場で かわる・はなすと 紙に はんえい） */
function weightSlider(a) {
  const wrap = mk('div', 'cm-slider');
  const ord = CM.wtOrder, max = ord.length - 1;
  const val = mk('b', 'cms-val'), prev = mk('div', 'cms-prev');
  const inp = document.createElement('input'); inp.type = 'range'; inp.min = 0; inp.max = max; inp.step = 1; inp.value = Math.max(0, ord.indexOf(a.wt)); inp.setAttribute('aria-label', tr('線の 太さ'));
  const draw = j => {
    const mm = CM.wtw[ord[j]], px = Math.max(.6, mm * 7);   // mm → 見本の 線の 太さ
    val.textContent = mm.toFixed(2) + 'mm';
    let s = '<svg viewBox="0 0 240 64" preserveAspectRatio="none" aria-hidden="true"><rect x="0.5" y="0.5" width="239" height="63" rx="6" fill="#FDF8D8" stroke="#d9d3c4"/>';
    for (let y = 16; y < 64; y += 16) s += `<path d="M10 ${y}H230" stroke="#1f6fb2" stroke-width="${px.toFixed(2)}" opacity=".85"/>`;
    s += '</svg>'; prev.innerHTML = s;
  };
  draw(+inp.value);
  inp.addEventListener('input', () => draw(+inp.value));
  inp.addEventListener('change', () => nbChangeCustom(() => { a.wt = ord[+inp.value]; }));
  const ends = mk('div', 'cms-ends'); ends.append(mk('span', '', CM.wtw[ord[0]].toFixed(2) + 'mm'), mk('span', '', tr('ほそい') + ' ⇄ ' + tr('ふとい')), mk('span', '', CM.wtw[ord[max]].toFixed(2) + 'mm'));
  wrap.append(val, prev, inp, ends);
  return wrap;
}
/* ★nv0.2.182 分ける位置：ボタン13こ → スライダー（線の間隔・太さと おなじ）。値（CM.ratios の 番号）と 面積の 計算は そのまま */
function ratioSlider(c) {
  const wrap = mk('div', 'cm-slider');
  const max = CM.ratios.length - 1;
  const val = mk('b', 'cms-val'), prev = mk('div', 'cms-prev cms-portrait');
  const inp = document.createElement('input'); inp.type = 'range'; inp.min = 0; inp.max = max; inp.step = 1; inp.value = c.ratio; inp.setAttribute('aria-label', tr('分ける 位置'));
  const draw = j => { const r = CM.ratios[j]; val.textContent = r + ':' + (100 - r); prev.innerHTML = layoutIcon(c.layout, j); };
  draw(c.ratio);
  inp.addEventListener('input', () => draw(+inp.value));
  inp.addEventListener('change', () => nbChangeCustom(() => { c.ratio = +inp.value; }));
  const e = j => CM.ratios[j] + ':' + (100 - CM.ratios[j]);
  const ends = mk('div', 'cms-ends'); ends.append(mk('span', '', e(0)), mk('span', '', ''), mk('span', '', e(max)));
  wrap.append(val, prev, inp, ends);
  return wrap;
}
function syncCmPix() {
  const box = $('cmPix'); if (!box || !document.body.classList.contains('nike')) return;
  const c = state.custom, L = CM.layouts[c.layout];
  if (state.cmTab >= L.tabs.length) state.cmTab = 0;
  const a = c.areas[state.cmTab];
  const raw = (svg, name, on, fn, wide) => pixCard(svg, name, '', on, fn, { cls: 'cm-raw' + (wide ? ' cm-wide' : '') });
  const groups = [];
  groups.push({ title: TEXTS.cmLayout, cards: CM.layouts.map((lay, i) => raw(layoutIcon(i), lay.name, i === c.layout, () => nbChangeCustom(() => { c.layout = i; }))) });
  if (L.ratio) groups.push({ title: TEXTS.cmRatio, cards: [], extra: ratioSlider(c) });   // ★nv0.2.182 みなとさん「ここも ボタンでは なく おなじ 表現に」＝スライダー
  if (L.tabs.length > 1) groups.push({ title: tr('直す 面'), cards: L.tabs.map((nm, i) => pixCard(VP.txt(String(i + 1)), nm, '', i === state.cmTab, () => { state.cmTab = i; nbSyncCustom(); })) });
  groups.push({ title: TEXTS.cmType, cards: CM.types.map((nm, i) => raw(typeIcon(i), nm, i === a.type, () => nbChangeCustom(() => { a.type = i; }), true)) });
  groups.push({ title: TEXTS.cmSpace, cards: [], extra: spaceSlider(a) });   // ★nv0.2.98 みなとさん「線の 間隔は ボタンでは なく わかりやすい 見せ方に」＝スライダー＋見本の 線
  groups.push({ title: TEXTS.cmWeight, cards: [], extra: weightSlider(a) });   // ★nv0.2.179 みなとさん「線の太さを 線の間隔と おなじ 操作に」＝スライダー
  groups.push({ title: TEXTS.cmStyle, cards: CM.styles.map((nm, j) => pixCard(cmSample('st', j), nm, '', j === a.st, () => nbChangeCustom(() => { a.st = j; }))) });
  const last = { title: TEXTS.cmEmph, cards: CM.emphs.map((nm, j) => pixCard(cmSample('em', j), nm, '', j === a.em, () => nbChangeCustom(() => { a.em = j; }))) };
  last.extra = mk('div', 'nk-cap3', `B5S${state.stars}X` + customCode());
  groups.push(last);
  pixPanel(box, groups, 'cm');
}
function nbSyncCustom() {
  const c = state.custom, L = CM.layouts[c.layout];
  if (state.cmTab >= L.tabs.length) state.cmTab = 0;
  const a = c.areas[state.cmTab];
  $('cmLayouts').replaceChildren(...CM.layouts.map((lay, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'cm-btn';
    b.setAttribute('aria-pressed', String(i === c.layout));
    b.innerHTML = layoutIcon(i);
    b.append(lay.name);
    b.onclick = () => nbChangeCustom(() => { c.layout = i; });
    return b;
  }));
  $('cmRatioBox').hidden = !L.ratio;
  $('cmRatio').textContent = CM.ratios[c.ratio] + ':' + (100 - CM.ratios[c.ratio]);
  nbSeg($('cmTabs'), L.tabs, state.cmTab, i => { state.cmTab = i; nbSyncCustom(); });
  $('cmTypes').replaceChildren(...CM.types.map((nm, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'cm-btn';
    b.setAttribute('aria-pressed', String(i === a.type));
    b.innerHTML = typeIcon(i);
    b.append(nm);
    b.onclick = () => nbChangeCustom(() => { a.type = i; });
    return b;
  }));
  $('cmSp').textContent = CM.spaces[a.sp].toFixed(1) + 'mm';
  nbSeg($('cmWeight'), CM.weights, a.wt, i => nbChangeCustom(() => { a.wt = i; }));
  nbSeg($('cmStyle'), CM.styles, a.st, i => nbChangeCustom(() => { a.st = i; }));
  nbSeg($('cmEmph'), CM.emphs, a.em, i => nbChangeCustom(() => { a.em = i; }));
  $('cmCode').textContent = `B5S${state.stars}X` + customCode();
  try { syncCmPix(); } catch (e) { console.warn('cmPix', e); }   // ★2026-10-15 絵の パネルも
}
function nbChangeCustom(fn) {
  fn();
  nbSyncCustom();
  const my = ++colorTurn;
  // いま紙に出している絵は片づけない（めくるときに写しを使うため）
  repaint().then(() => { if (my === colorTurn) clearTinted([base.querySelector(':scope > img').src]); });
  updateUi();
}
$('cmRatioMinus').onclick = () => nbChangeCustom(() => { state.custom.ratio = Math.max(0, state.custom.ratio - 1); });
$('cmRatioPlus').onclick = () => nbChangeCustom(() => { state.custom.ratio = Math.min(CM.ratios.length - 1, state.custom.ratio + 1); });
$('cmSpMinus').onclick = () => nbChangeCustom(() => { const a = state.custom.areas[state.cmTab]; a.sp = Math.max(0, a.sp - 1); });
$('cmSpPlus').onclick = () => nbChangeCustom(() => { const a = state.custom.areas[state.cmTab]; a.sp = Math.min(CM.spaces.length - 1, a.sp + 1); });


/* ★2026-10-15 絵の パネル（手帳 v0.2.229〜235 から。ノートの 制作画面を おなじ 見た目に） */
function guardRow(row) {
  let sx = 0, sy = 0, moved = false, last = 0;
  row.addEventListener('scroll', () => { last = Date.now(); }, { passive: true });
  row.addEventListener('wheel', e => { if (e.deltaX) last = Date.now(); }, { passive: true });
  row.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
  row.addEventListener('pointermove', e => { if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) moved = true; }, { passive: true });
  row.addEventListener('click', e => { if (moved || Date.now() - last < 350) { e.preventDefault(); e.stopPropagation(); } }, true);
}
const VP = (() => {
  const T = (t, y = 15, sz = 8) => `<text x="12" y="${y}" font-size="${sz}" text-anchor="middle">${t}</text>`;
  const grid = (first) => `<rect x="3" y="5" width="18" height="15" rx="1.5"/><path d="M3 10h18M9 10v10M15 10v10"/>${first === 'sun' ? '<rect class="fill" x="3" y="10.5" width="5.5" height="9" rx=".5" opacity=".35"/>' : '<rect class="fill" x="3" y="10.5" width="5.5" height="9" rx=".5" opacity=".35"/>'}${T(first === 'sun' ? '日' : '月', 8.8, 5.5)}`;
  const circ = (filled, label) => (filled ? `<circle class="fill" cx="12" cy="12" r="8"/><text x="12" y="15.5" font-size="9" text-anchor="middle" style="fill:#fff">${label}</text>` : `<circle cx="12" cy="12" r="8"/>${T(label, 15.5, 9)}`);
  return {
    mon: grid('mon'), sun: grid('sun'),
    sat: circ(false, '土'), sunC: circ(true, '日'), hol: circ(true, '祝'),
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/><path class="fill" d="M12 12L12 3.5A8.5 8.5 0 0 1 20.5 12z" opacity=".3"/>',
    holi: circ(true, '祝'), rokuyo: `<rect x="4" y="4" width="16" height="16" rx="2"/>${T('大安', 15, 7)}`, moon: '<circle cx="8" cy="12" r="4.5"/><circle class="fill" cx="17" cy="12" r="4.5"/>',
    sekki: `<path d="M4 18c3-6 6-9 8-13 2 4 5 7 8 13"/>${T('立春', 22, 5.5)}`, kyureki: `<rect x="4" y="4" width="16" height="16" rx="2"/>${T('8/15', 15, 7)}`,
    cal: '<rect x="4" y="5" width="16" height="15" rx="1.5"/><path d="M4 9.5h16M8 5V3M16 5V3"/><path d="M7 13h2M11 13h2M15 13h2M7 16.5h2M11 16.5h2" stroke-width="1.2"/>',
    evJp: '<path d="M6 21V3"/><path d="M6 4h11l-3 4 3 4H6"/><circle class="fill" cx="10" cy="8" r="1.2"/>',
    school: '<rect x="3.5" y="4" width="17" height="11" rx="1"/><path d="M8 19h8M12 15v4"/><path d="M7 8h7M7 11h4" stroke-width="1.2"/>',
    nursery: '<circle cx="12" cy="9" r="4"/><path d="M5 21c1-4 4-6 7-6s6 2 7 6"/><path d="M10.5 9.5a1.5 1 0 0 0 3 0" stroke-width="1.2"/>',
    size: k => `<text x="12" y="17" font-size="${(k / 100 * 13).toFixed(1)}" text-anchor="middle">あ</text>`,
    up: n => `<path d="M12 19V7"/><path d="M7 ${n > 1 ? 10 : 12}l5-5 5 5"/>${n > 1 ? '<path d="M7 14l5-5 5 5" opacity=".5"/>' : ''}`,
    down: n => `<path d="M12 5v12"/><path d="M7 ${n > 1 ? 14 : 12}l5 5 5-5"/>${n > 1 ? '<path d="M7 10l5 5 5-5" opacity=".5"/>' : ''}`,
    left: n => `<path d="M19 12H7"/><path d="M${n > 1 ? 10 : 12} 7l-5 5 5 5"/>${n > 1 ? '<path d="M14 7l-5 5 5 5" opacity=".5"/>' : ''}`,
    right: n => `<path d="M5 12h12"/><path d="M${n > 1 ? 14 : 12} 7l5 5-5 5"/>${n > 1 ? '<path d="M10 7l5 5-5 5" opacity=".5"/>' : ''}`,
    zero: '<circle class="fill" cx="12" cy="12" r="2.5"/><path d="M12 4v4M12 16v4M4 12h4M16 12h4" opacity=".5"/>',
  };
})();
/* ★v0.2.230 絵の パネル（共通）：groups＝[{ title, cards, note, off }]。なかまが 2つ 以上なら 上に チップ（横に すべる）、下に えらんだ なかまの カード（横に すべる） */
const PIX = { sel: {} };
function pixCard(ico, name, sub, on, fn, opt = {}) {
  const b = document.createElement('button'); b.type = 'button';
  b.className = 'size-btn' + (opt.tog ? ' vp-tog' : '') + (opt.cls ? ' ' + opt.cls : '');
  if (typeof ico === 'string') b.innerHTML = /^<svg/.test(ico) ? ico : `<svg viewBox="0 0 24 24" aria-hidden="true">${ico}</svg>`; else if (ico) b.append(ico);
  b.append(mk('span', 'sz-nm', name)); if (sub) b.append(mk('span', 'sz-mm', sub));
  b.setAttribute('aria-pressed', String(!!on)); if (opt.off) b.disabled = true; b.onclick = fn; return b;
}
function pixPanel(box, groups, key) {
  if (!box) return;
  groups = groups.filter(Boolean);
  if (!groups.length) { box.replaceChildren(); return; }
  let si = PIX.sel[key] || 0; if (si >= groups.length) si = 0;
  const kids = [];
  if (groups.length > 1) {
    const chips = mk('div', 'pix-chips');
    groups.forEach((g, i) => { const c = document.createElement('button'); c.type = 'button'; c.className = 'pix-chip'; c.textContent = g.title; c.setAttribute('aria-pressed', String(i === si)); if (g.off) c.setAttribute('aria-disabled', 'true'); c.onclick = () => { PIX.sel[key] = i; pixPanel(box, groups, key); }; chips.append(c); });
    guardRow(chips); kids.push(chips);
  } else kids.push(mk('div', 'nk-cap2', groups[0].title));
  const g = groups[si];
  if (g.cards && g.cards.length) { const row = mk('div', 'row'); row.append(...g.cards); guardRow(row); kids.push(row); }
  if (g.note) kids.push(mk('div', 'nk-cap3', g.note));
  if (g.extra) kids.push(g.extra);
  box.replaceChildren(...kids);
  if (groups.length > 1) { const c = box.querySelector('.pix-chip[aria-pressed="true"]'); if (c && c.scrollIntoView) try { c.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
}
const esc = t => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
VP.txt = t => { const n = [...String(t)].length; return `<text x="12" y="${n > 2 ? 15 : 16.5}" font-size="${n > 4 ? 5 : n > 2 ? 6.5 : 11}" text-anchor="middle">${esc([...String(t)].slice(0, 6).join(''))}</text>`; };
VP.yearIco = y => `<rect x="3.5" y="5" width="17" height="15" rx="1.5"/><path d="M3.5 9.5h17M8 5V3M16 5V3"/><text x="12" y="17.5" font-size="6" text-anchor="middle">${esc(String(y).slice(2))}</text>`;
VP.monthIco = m => `<rect x="3.5" y="5" width="17" height="15" rx="1.5"/><path d="M3.5 9.5h17M8 5V3M16 5V3"/><text x="12" y="17.8" font-size="7" text-anchor="middle">${m}</text>`;
VP.enikkiOn = '<rect x="3.5" y="3.5" width="17" height="17" rx="1.5"/><text x="6" y="8.5" font-size="4.5">12</text><circle cx="15" cy="9" r="2"/><path d="M6.5 18l3.5-4 2.5 2.5 2-2 3.5 3.5"/>';
VP.enikkiOff = '<rect x="3.5" y="3.5" width="17" height="17" rx="1.5"/><text x="6" y="8.5" font-size="4.5">12</text>';
VP.nameOn = '<rect x="3.5" y="3.5" width="17" height="17" rx="1.5"/><path d="M10 17.5h8" stroke-width="1.2"/><path d="M12.5 15.5l3-3" stroke-width="1.2"/>';
VP.nameOff = '<rect x="3.5" y="3.5" width="17" height="17" rx="1.5"/>';
VP.line = '<path d="M4 11.5c0-3.6 3.6-6.5 8-6.5s8 2.9 8 6.5-3.6 6.5-8 6.5c-.8 0-1.6-.1-2.3-.3L6 19.5l.8-3.1C5.1 15.2 4 13.5 4 11.5z"/>';
/* ★v0.2.235 みなとさん「色を 上に つめて、スマホでも 下が 切れない ように（表示と 同じ 作り）」
   チップ＝線・文字・土曜・日曜／カード＝定番の 色（名前つき）＋「線と同じ」／その 下に 小さな 丸＝いろいろな 色 */
function syncColorPix() {
  const box = $('colorPix'); if (!box || !document.body.classList.contains('nike')) return;
  const sw = c => `<circle cx="12" cy="12" r="9" fill="${c}" stroke="#b9b1a4" stroke-width=".6"/>`;
  const groups = INK_KEYS.map((k, i) => {
    const cur = inkOf(k), same = k !== 'line' && !state.inks[k];
    const pick = c => { state.inkTarget = k; setColor(c); };
    const cards = [];
    if (k !== 'line') cards.push(pixCard(VP.txt('＝'), tr('線と同じ'), '', same, () => { state.inkTarget = k; state.inks[k] = null; paintColor(); }));
    PAL_BASE.forEach(p => cards.push(pixCard(sw(p.c), p.name, '', !same && cur === p.c, () => pick(p.c))));
    return { title: TEXTS.inkNames[i], cards };
  });
  PIX.sel.color = INK_KEYS.indexOf(state.inkTarget);
  pixPanel(box, groups, 'color');
  // チップを 押したら その 色を 直す 相手に する
  box.querySelectorAll('.pix-chip').forEach((c, i) => { const f = c.onclick; c.onclick = e => { state.inkTarget = INK_KEYS[i]; f(e); syncColor(); }; });
}
/* ★v0.2.230 えにっき：いれる／いれない（押すと 下の seg を 押した ことに する）＋ LINE で 見る */
function syncEnikkiPix() {
  const box = $('enikkiPix'); if (!box || !document.body.classList.contains('nike')) return;
  const on = state.enikki.mode > 0;
  const press = i => { const b = document.querySelectorAll('#nkEnikkiSeg button')[i]; if (b) b.click(); setTimeout(syncEnikkiPix, 0); };
  const cards = [pixCard(VP.enikkiOn, TEXTS.nkEnikkiModes[0], '', on, () => press(0)), pixCard(VP.enikkiOff, TEXTS.nkEnikkiModes[1], '', !on, () => press(1))];
  if (ENIKKI.on && (ENIKKI.status === 'off' || (ENIKKI.via === 'shop' && !ENIKKI.linked))) cards.push(pixCard(VP.line, TEXTS.enikkiLogin, '', false, enikkiLogin, { cls: 'line-card' }));
  pixPanel(box, [{ title: TEXTS.nkEnikkiNote, cards }], 'enikki');
}

/* ★2026-10-15 ノートの 名入れ：入れる／入れない ＋ 文字の 箱（手帳 v0.2.230・236 と おなじ 見た目。紙の マークは ノートに ない） */
function syncNamePix() {
  const box = $('namePix'); if (!box || !document.body.classList.contains('nike')) return;
  const inp = $('nameInput'); if (!inp) return; const has = !!inp.value.trim();
  const fire = () => { inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true })); syncNamePix(); };
  const cards = [
    pixCard(VP.nameOn, TEXTS.nkEnikkiModes[0], has ? inp.value.slice(0, 16) : '', has, () => { if (!inp.value.trim()) { inp.value = 'BirthBookNote'; fire(); } inp.focus(); }),
    pixCard(VP.nameOff, TEXTS.nkEnikkiModes[1], '', !has, () => { inp.value = ''; fire(); }),
  ];
  const nb = inp.closest('label'); if (nb) { nb.classList.add('name-box'); cards.push(nb); }
  pixPanel(box, [{ title: TEXTS.nameLabel, cards, note: TEXTS.nameNote }], 'name');
  if (!inp.dataset.pix) { inp.dataset.pix = '1'; inp.addEventListener('input', () => { clearTimeout(syncNamePix.tm); syncNamePix.tm = setTimeout(syncNamePix, 400); }); }
}
/* ★紙・バインダー・大容量：絵＋名前＋値段の カード（中身は syncChoices の choiceButton と おなじ） */
function syncChoicePix() {
  const pb = $('paperPix'), bb = $('binderPix'), ob = $('optionPix'); if (!pb || !document.body.classList.contains('nike')) return;
  const paper = PAPERS.map(it => pixCard(picto(it.pi), tr(it.name), PAPER_OUT[it.id] ? tr('品切れ') : yen(priceOf(state.binder, it.id)), it.id === state.paper,
    () => { state.paper = it.id; syncChoices(); updateUi(); }, { off: !!PAPER_OUT[it.id] }));
  pixPanel(pb, [{ title: TEXTS.cardPaper, cards: paper, note: TEXTS.paperNote }], 'paper');
  const binder = BINDER_LIST.map(it => pixCard(picto(it.pi), tr(it.name), yen(priceOf(it.id)), it.id === state.binder, () => {
    const before = state.binder; state.binder = it.id; syncChoices(); updateUi();
    if (it.id !== 'none' && before !== it.id) { if (curPage().id === 'cover') repaint(); else turnPage('cover'); }
    else if (it.id === 'none' && state.page === 'cover') { state.page = sheetPage(); repaint(); updateUi(); }
  }));
  pixPanel(bb, [{ title: TEXTS.cardBinder, cards: binder, note: TEXTS.binderNote }], 'binder');
  if (ob) {
    const opt = OPTIONS.map(it => pixCard(picto(it.pi), tr(it.name), it.id === 'big' ? '+' + yen(BIG_PLUS) : '', it.id === state.option, () => { state.option = it.id; syncChoices(); updateUi(); }));
    pixPanel(ob, [{ title: tr('大容量'), cards: opt, note: TEXTS.optionNote }], 'option');
  }
}
/* ★星（0〜5こ）：数ごとの カード（紙の 左上に 入る） */
VP.starN = n => `<path d="M12 3.6l2.5 5.2 5.6.8-4.1 4 1 5.6L12 16.5 7 19.2l1-5.6-4.1-4 5.6-.8z"/><text x="12" y="14.2" font-size="7" text-anchor="middle">${n}</text>`;
function syncStarsPix() {
  const box = $('starsPix'); if (!box || !document.body.classList.contains('nike')) return;
  /* ★nv0.2.98 みなとさん「クリックで ぜんぶ 消すか 表示するか」＝星は［いれる（3こ）］［いれない］の 2つだけ */
  const lastN = state.stars > 0 ? state.stars : (syncStarsPix.last || 3); if (state.stars > 0) syncStarsPix.last = state.stars;
  const cards = [
    pixCard(VP.starN(lastN), tr('あり'), '', state.stars > 0, () => changeStars(lastN - state.stars)),
    pixCard(VP.starN(0), tr('なし'), '', state.stars === 0, () => changeStars(-state.stars)),
  ];
  pixPanel(box, [{ title: tr('星（左上）'), cards, note: TEXTS.starsNote }], 'stars');
  // ★みなとさん「星の ± を なしの 横に」：［− 5こ ＋］を カードの 行の 右はしへ（行を 作りなおすと 外れるので おぼえておく）
  const st = syncStarsPix.step || (syncStarsPix.step = document.querySelector('.stars-step')), row = box.querySelector('.row');
  if (st && row) { row.append(st); st.classList.add('in-row'); }
}
/* ★チェック（右上の 3行）：□の つけはずし（文字は 下の 箱で 直せる） */
VP.checkOn = '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 12.5l3 3 5-6.5"/>';
VP.checkOff = '<rect x="4" y="4" width="16" height="16" rx="2"/>';
function syncTodoPix() {
  const box = $('todoPix'); if (!box || !document.body.classList.contains('nike')) return;
  /* ★nv0.2.98 みなとさん「クリックで ぜんぶ 消すか 表示するか」＝チェックは［いれる（3行ぜんぶ）］［いれない］の 2つだけ */
  const lines = [...document.querySelectorAll('.checks .line')];
  const onN = lines.filter(ln => ln.querySelector('.todo').value.startsWith(BOX)).length;
  const setAll = want => { lines.forEach(ln => { const on = ln.querySelector('.todo').value.startsWith(BOX); if (on !== want) ln.querySelector('.box-btn').click(); }); };
  const cards = [];   // ★nv0.2.174 あり／なし の 札は やめた（□ なし・ことばだけ。下の 3行で 直す）
  void onN; void setAll;
  pixPanel(box, [{ title: tr('右上の ことば'), cards, note: TEXTS.todoNote }], 'todo');
}

/* ★nv0.2.2 星・右上の3行・大容量の うごき（古い ノート v0.1.71 と 同じ） */
const STAR_MAX = 5;
const todoShow = v => String(v || '').replace(/^□\s*/, '□  ');   // ★2026-11-03 柄の もとの 書き方（□＋半角2つ）
const BOX = '□';   // ★楽天の 文字（EUC-JP）に ある 四角。⬜︎ は 楽天で こわれる

function syncStars() {
  const v = $('starsView'), n = $('starsNum');
  if (!v) return;
  v.innerHTML = picto('stars').repeat(state.stars);
  v.setAttribute('aria-label', `星 ${state.stars}${TEXTS.starsUnit}`);
  if (n) n.textContent = state.stars + TEXTS.starsUnit;
  if ($('starMinus')) $('starMinus').disabled = state.stars <= 0;
  if ($('starPlus')) $('starPlus').disabled = state.stars >= STAR_MAX;
  try { syncStarsPix(); } catch (e) {}
}
function changeStars(d) {
  state.stars = Math.max(0, Math.min(STAR_MAX, state.stars + d));
  syncStars();
  noteSvgCache.clear(); tinted.clear();   // 紙を 作りなおす
  repaint(); updateUi();
}
function syncBoxBtns() {
  document.querySelectorAll('.checks .line').forEach(line => {
    line.querySelector('.box-btn').setAttribute('aria-pressed', String(line.querySelector('.todo').value.startsWith(BOX)));
  });
  try { syncTodoPix(); } catch (e) {}
}
function bindNoteTools() {
  if ($('starMinus')) $('starMinus').onclick = () => changeStars(-1);
  if ($('starPlus')) $('starPlus').onclick = () => changeStars(1);
  document.querySelectorAll('.checks .line').forEach(line => {
    const input = line.querySelector('.todo');
    line.querySelector('.box-btn').onclick = () => {
      const v = input.value;
      if (v.startsWith(BOX)) input.value = v.slice(1);
      else if ([...v].length >= 6) { alert(TEXTS.boxFull); return; }
      else input.value = BOX + v;
      input.dispatchEvent(new Event('input'));
    };
  });
  document.querySelectorAll('.todo').forEach((el, i) => el.addEventListener('input', () => {
    syncBoxBtns();
    state.todo[i] = el.value;
    tinted.clear();
    repaint(); updateUi();
  }));
  syncStars(); syncBoxBtns();
}

// ===== はじめ =====
(async () => {
  // 手帳の形の一覧（index はタイルの並び）
  //   楽天では オーダーメイド（C1〜C7）を 出さない（index は 出したものの中の じゅんばん）
  //   ★年間の オーダーメイド（C1）は 出さない（v0.2.74：年間は 決まった 形から 1つ えらぶ）
  // ★v0.2.106 オーダーメイドの タイルは なくした（できあいの 形＋「形を変える」で 同じことが できるため）
  //   CUSTOM の 表は そのまま つかう（形を変える の えらび・注文コードの 記号）
  /* ★バースブックノート：手帳の 形（FORMATS）を すてて、ノートの 柄 235まいを 入れる。
     notes.json は build.py が notes/ を しらべて 作る もの。
     ファイルを ダブルクリックで ひらいた ときは notes.js（window.NOTES_LOCAL）を つかう。 */
  LANG = langOf(); if (LANG !== 'ja') applyTexts();   // ★nv0.2.145 柄の 一覧を 読む あいだも 日本語が ちらつかない ように、先に 言葉を きめる
  await loadNoteData();
  /* ★nv0.2.16 オーダーメイドも ならべる（custom を 外さない）。
     ready＝おせるか。ファイルが ある 柄か、オーダーメイドなら おせる。 */
  FORMATS.forEach(f => state.notes.push({ id: f.id, name: f.name, fmt: f, ready: !!(f.file || f.custom), index: state.notes.length }));
  // ★nv0.2.57 みなとさん「ノートの デフォルトは 罫線」：はじめの 柄は 無地では なく「A罫7mm」（?d= が あれば そちらが かつ）
  // ★2026-10-15 みなとさん「ノートの デフォルトは 原稿用紙」
  state.idx = Math.max(0, state.notes.findIndex(n => n.name === '原稿用紙'));
  state.yIdx = -1;          // ★年間の 紙は ない（ノートには 暦が ない）
  setStart(startYear(), startMonth());
  state.page = sheetPage();
  readShare();
  LANG = langOf(); if (LANG !== 'ja') applyTexts();   // ★nv0.2.145 画面の 言葉は 最初の 描画の 前に きめる（前は nkInit まで 日本語の まま 描いていた）
  // はじめに 見せる なかま：年間の紙を ひらくなら「年間」、ちがえば 手帳の形の なかま（v0.2.79「すべて」を なくした）
  state.cat = (state.notes[state.idx] && state.notes[state.idx].fmt.cat) || (CATS[0] && CATS[0].id);
  buildCats(); syncColor(); buildTiles();
  bindNoteTools();   // ★nv0.2.2 星・右上の3行の ボタンを つなぐ
  const hsUpdates = [hScroll($('cats')), hScroll($('tiles'))];
  // QRから開いたときなど：えらばれている形のタイルが見える位置にしておく（開いた最初だけ・動きなし）
  const on = $('tiles').querySelector('.tile[aria-current="true"]');
  if (on && on.offsetLeft + on.offsetWidth > $('tiles').clientWidth) $('tiles').scrollLeft = on.offsetLeft - $('tiles').offsetLeft - 10;
  // ★なかまの列は 左はしの まま（v0.2.64）。前は「すべて」が 見えるように 右へ ずらしていて、年間・月間式が かくれていた
  hsUpdates.forEach(f => f());
  // 説明のページの写真を先に読みこんでおく（めくったときに待たないように）
  Object.values(PHOTO).filter(Boolean).forEach(src => { const im = new Image(); im.src = src; });
  // ★v0.2.168 A5・A4 の とき：画面の 縦横比（--pw/--ph）と 印刷の 紙（@page）を 合わせる
  if (PSIZE !== 'b5') { const st = document.documentElement.style; st.setProperty('--pw', PSEL.w); st.setProperty('--ph', PSEL.h); const pg = document.createElement('style'); pg.textContent = `@page{size:${PSEL.w}mm ${PSEL.h}mm}`; document.body.appendChild(pg); }
  go(state.idx, 0);
  NK_BOOTED = true;   // ★nv0.2.32 ここから さきは ほけんも 動いて よい
  if (TK_HOME) { document.body.classList.add('tk-home'); noteInkInit(); noteQuotaLoad(); syncHoleColor(); setTimeout(syncHoleColor, 400); addEventListener('load', syncHoleColor); addEventListener('resize', syncHoleColor); }
  try { nkInit(); } catch (e) { console.warn('nike', e); }   // ★v0.2.155 ここで 画面を 作る（load を 待つと 前の 画面が 一瞬 見えた）
  syncEnikki();
  enikkiLoad();   // 本店で LINE の しるしが あれば えにっきの 絵を 読む（楽天では 何もしない）
  try { trDomAll(); } catch (e) { console.warn('trdom', e); }   // ★nv0.2.145 さいごに もう一度（最初に 描いた 文字を 置きかえる）
})();
